// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%231F2937%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%234B5563%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%234d6689%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2310B981%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23E11D48%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23E11D48%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2817, 24, 39, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%234B5563%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23374151%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23111827%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%2817, 24, 39, 0.9%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml;utf8,<svg width=%276%27 height=%2710%27 viewBox=%270 0 6 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27><path fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z%27 fill=%27%231F2937%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&amp;display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8); /* Beyaz yarı saydam */
    backdrop-filter: blur(5px); /* Buzlu cam efekti */
    z-index: 1040; /* Modalın z-index'inden düşük olmalı */
}

.modal-open .container {
    pointer-events: none; /* Sayfanın geri kalanını tıklanamaz yapar */
}

.modal {
    z-index: 1050; /* Modal en üstte olmalı */
}


.rotate {


    /* Border is the new background */
    background: none;

    /* Rotate from top left corner (not default) */
    transform-origin: 0 0;
    transform: rotate(90deg);

}

.datepicker {
    display: none
}

.datepicker.active {
    display: block
}

input[type="range"]::-webkit-slider-thumb { /* Override default look */
    appearance: none;
    margin-top: -1px; /* Centers thumb on the track */
    background-color: #5cd5eb;
    height: 1rem;
    width: 1rem;
}

.leaflet-container {

    width: 100vw;
    height: 100vh;
}

.tab-selected {
    color: #32557f !important;
    font-weight: bold;
    text-decoration: none;
    border-bottom: 3px solid #32557f;
    padding-bottom: 3px;
}

.datepicker-dropdown {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 20;
    padding-top: 4px
}

.datepicker-dropdown.datepicker-orient-top {
    padding-top: 0;
    padding-bottom: 4px
}

.datepicker-picker {
    display: inline-block;
    border-radius: 4px;
    background-color: #fff
}

.datepicker-dropdown .datepicker-picker {
    box-shadow: 0 2px 3px rgba(17, 24, 39, .1), 0 0 0 1px rgba(17, 24, 39, .1)
}

.datepicker-picker span {
    display: block;
    flex: 1 1;
    border: 0;
    border-radius: 4px;
    cursor: default;
    text-align: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none
}

.datepicker-main {
    padding: 2px
}

.datepicker-footer {
    box-shadow: inset 0 1px 1px rgba(17, 24, 39, .1);
    background-color: #9ca3af
}

.datepicker-controls,
.datepicker-grid,
.datepicker-view,
.datepicker-view .days-of-week {
    display: flex
}

.datepicker-grid {
    flex-wrap: wrap
}

.datepicker-view .days .datepicker-cell,
.datepicker-view .dow {
    flex-basis: 14.28571%
}

.datepicker-view.datepicker-grid .datepicker-cell {
    flex-basis: 25%
}

.datepicker-cell,
.datepicker-view .week {
    height: 2.25rem;
    line-height: 2.25rem
}

.datepicker-title {
    box-shadow: inset 0 -1px 1px rgba(17, 24, 39, .1);
    background-color: #9ca3af;
    padding: .375rem .75rem;
    text-align: center;
    font-weight: 700
}

.datepicker-header .datepicker-controls {
    padding: 2px 2px 0
}

.datepicker-controls .button {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    margin: 0;
    border: 1px solid #808998;
    border-radius: 4px;
    box-shadow: none;
    background-color: #fff;
    cursor: pointer;
    padding: calc(.375em - 1px) .75em;
    height: 2.25em;
    vertical-align: top;
    text-align: center;
    line-height: 1.5;
    white-space: nowrap;
    color: #1f2937;
    font-size: 1rem
}

.datepicker-controls .button:active,
.datepicker-controls .button:focus {
    outline: 0
}

.datepicker-controls .button:hover {
    border-color: #5b6371;
    color: #1f2937
}

.datepicker-controls .button:focus {
    border-color: #3273dc;
    color: #1f2937
}

.datepicker-controls .button:focus:not(:active) {
    box-shadow: 0 0 0 .125em rgba(50, 115, 220, .25)
}

.datepicker-controls .button:active {
    border-color: #384f80;
    color: #1f2937
}

.datepicker-controls .button[disabled] {
    cursor: not-allowed
}

.datepicker-header .datepicker-controls .button {
    border-color: transparent;
    font-weight: 700
}

.datepicker-header .datepicker-controls .button:hover {
    background-color: #f9f9f9
}

.datepicker-header .datepicker-controls .button:focus:not(:active) {
    box-shadow: 0 0 0 .125em rgba(255, 255, 255, .25)
}

.datepicker-header .datepicker-controls .button:active {
    background-color: #f2f2f2
}

.datepicker-header .datepicker-controls .button[disabled] {
    box-shadow: none
}

.datepicker-footer .datepicker-controls .button {
    margin: calc(.375rem - 1px) .375rem;
    border-radius: 2px;
    width: 100%;
    font-size: .75rem
}

.datepicker-controls .view-switch {
    flex: auto
}

.datepicker-controls .next-btn,
.datepicker-controls .prev-btn {
    padding-right: .375rem;
    padding-left: .375rem;
    width: 2.25rem
}

.datepicker-controls .next-btn.disabled,
.datepicker-controls .prev-btn.disabled {
    visibility: hidden
}

.datepicker-view .dow {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: .875rem;
    font-weight: 700
}

.datepicker-view .week {
    width: 2.25rem;
    color: #5b6371;
    font-size: .75rem
}

@media (max-width: 22.5rem) {
    .datepicker-view .week {
        width: 1.96875rem
    }
}

.datepicker-grid {
    width: 15.75rem
}

@media (max-width: 22.5rem) {
    .calendar-weeks + .days .datepicker-grid {
        width: 13.78125rem
    }
}

.datepicker-cell:not(.disabled):hover {
    background-color: #f9f9f9;
    cursor: pointer
}

.datepicker-cell.focused:not(.selected) {
    background-color: #8e96a4
}

.datepicker-cell.selected,
.datepicker-cell.selected:hover {
    background-color: #3273dc;
    color: #fff;
    font-weight: 600
}

.datepicker-cell.disabled {
    color: #808998
}

.datepicker-cell.next:not(.disabled),
.datepicker-cell.prev:not(.disabled) {
    color: #7a7a7a
}

.datepicker-cell.next.selected,
.datepicker-cell.prev.selected {
    color: #e6e6e6
}

.datepicker-cell.highlighted:not(.selected):not(.range):not(.today) {
    border-radius: 0;
    background-color: #9ca3af
}

.datepicker-cell.highlighted:not(.selected):not(.range):not(.today):not(.disabled):hover {
    background-color: #959ca9
}

.datepicker-cell.highlighted:not(.selected):not(.range):not(.today).focused {
    background-color: #8e96a4
}

.datepicker-cell.today:not(.selected) {
    background-color: #00d1b2
}

.datepicker-cell.today:not(.selected):not(.disabled) {
    color: #fff
}

.datepicker-cell.today.focused:not(.selected) {
    background-color: #00c4a7
}

.datepicker-cell.range-end:not(.selected),
.datepicker-cell.range-start:not(.selected) {
    background-color: #5b6371;
    color: #fff
}

.datepicker-cell.range-end.focused:not(.selected),
.datepicker-cell.range-start.focused:not(.selected) {
    background-color: #555d69
}

.datepicker-cell.range-start {
    border-radius: 4px 0 0 4px
}

.datepicker-cell.range-end {
    border-radius: 0 4px 4px 0
}

.datepicker-cell.range {
    border-radius: 0;
    background-color: #808998
}

.datepicker-cell.range:not(.disabled):not(.focused):not(.today):hover {
    background-color: #798293
}

.datepicker-cell.range.disabled {
    color: #666f7f
}

.datepicker-cell.range.focused {
    background-color: #727c8d
}

.datepicker-view.datepicker-grid .datepicker-cell {
    height: 4.5rem;
    line-height: 4.5rem
}

.datepicker-input.in-edit {
    border-color: #2366d1
}

.datepicker-input.in-edit:active,
.datepicker-input.in-edit:focus {
    box-shadow: 0 0 .25em .25em rgba(35, 102, 209, .2)
}

:root {
    --bs-blue: #2361ce;
    --bs-indigo: #4F46E5;
    --bs-purple: #7C3AED;
    --bs-pink: #EF4683;
    --bs-red: #E11D48;
    --bs-orange: #FBA918;
    --bs-yellow: #f3c78e;
    --bs-green: #10B981;
    --bs-teal: #1E90FF;
    --bs-cyan: #63b1bd;
    --bs-white: #ffffff;
    --bs-gray: #4B5563;
    --bs-gray-dark: #1F2937;
    --bs-primary: #1F2937;
    --bs-secondary: #f0bc74;
    --bs-tertiary: #31316A;
    --bs-success: #10B981;
    --bs-info: #2361ce;
    --bs-warning: #FBA918;
    --bs-danger: #E11D48;
    --bs-white: #ffffff;
    --bs-indigo: #4F46E5;
    --bs-purple: #7C3AED;
    --bs-yellow-100: #ffeed6;
    --bs-yellow-200: #f5dbb8;
    --bs-gray-50: #F9FAFB;
    --bs-gray-100: #F2F4F6;
    --bs-gray-200: #E5E7EB;
    --bs-gray-300: #D1D5DB;
    --bs-gray-400: #9CA3AF;
    --bs-gray-500: #6B7280;
    --bs-gray-600: #4B5563;
    --bs-gray-700: #374151;
    --bs-gray-800: #1F2937;
    --bs-gray-900: #111827;
    --bs-font-sans-serif: "Inter", sans-serif;
    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0))
}

*,
::after,
::before {
    box-sizing: border-box
}

@media (prefers-reduced-motion: no-preference) {
    :root {
        scroll-behavior: smooth
    }
}

body {
    margin: 0;
    font-family: var(--bs-font-sans-serif);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #374151;
    background-color: #f2f4f6;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(17, 24, 39, 0)
}

hr {
    margin: 1rem 0;
    color: inherit;
    background-color: currentColor;
    border: 0;
    opacity: .25
}

hr:not([size]) {
    height: .0625rem
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: .5rem;
    font-weight: 500;
    line-height: 1.3;
    color: #111827
}

.h1,
h1 {
    font-size: calc(1.375rem + 1.5vw)
}

@media (min-width: 1200px) {

    .h1,
    h1 {
        font-size: 2.5rem
    }
}

.h2,
h2 {
    font-size: calc(1.325rem + .9vw)
}

@media (min-width: 1200px) {

    .h2,
    h2 {
        font-size: 2rem
    }
}

.h3,
h3 {
    font-size: calc(1.3rem + .6vw)
}

@media (min-width: 1200px) {

    .h3,
    h3 {
        font-size: 1.75rem
    }
}

.h4,
h4 {
    font-size: calc(1.275rem + .3vw)
}

@media (min-width: 1200px) {

    .h4,
    h4 {
        font-size: 1.5rem
    }
}

.h5,
h5 {
    font-size: 1.25rem
}

.h6,
h6 {
    font-size: 1rem
}

p {
    margin-top: 0;
    margin-bottom: 1rem
}

abbr[data-bs-original-title],
abbr[title] {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
    cursor: help;
    text-decoration-skip-ink: none
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit
}

ol,
ul {
    padding-left: 2rem
}

dl,
ol,
ul {
    margin-top: 0;
    margin-bottom: 1rem
}

ol ol,
ol ul,
ul ol,
ul ul {
    margin-bottom: 0
}

dt {
    font-weight: 500
}

dd {
    margin-bottom: .5rem;
    margin-left: 0
}

blockquote {
    margin: 0 0 1rem
}

b,
strong {
    font-weight: 600
}

.small,
small {
    font-size: .875em
}

.mark,
mark {
    padding: .2em;
    background-color: #fcf8e3
}

sub,
sup {
    position: relative;
    font-size: .75em;
    line-height: 0;
    vertical-align: baseline
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

a {
    color: #1f2937;
    text-decoration: none
}

a:hover {
    color: #000;
    text-decoration: none
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
    color: inherit;
    text-decoration: none
}

code,
kbd,
pre,
samp {
    font-family: var(--bs-font-monospace);
    font-size: 1em;
    direction: ltr;
    unicode-bidi: bidi-override
}

pre {
    display: block;
    margin-top: 0;
    margin-bottom: 1rem;
    overflow: auto;
    font-size: .875em
}

pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal
}

code {
    font-size: .875em;
    color: #ef4683;
    word-wrap: break-word
}

a > code {
    color: inherit
}

kbd {
    padding: .2rem .4rem;
    font-size: .875em;
    color: #fff;
    background-color: #111827;
    border-radius: .35rem
}

kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 500
}

figure {
    margin: 0 0 1rem
}

img,
svg {
    vertical-align: middle
}

table {
    caption-side: bottom;
    border-collapse: collapse
}

caption {
    padding-top: .75rem;
    padding-bottom: .75rem;
    color: #58677d;
    text-align: left
}

th {
    text-align: inherit;
    text-align: -webkit-match-parent
}

tbody,
td,
tfoot,
th,
thead,
tr {
    border-color: inherit;
    border-style: solid;
    border-width: 0
}

label {
    display: inline-block
}

button {
    border-radius: 0
}

button:focus:not(:focus-visible) {
    outline: 0
}

button,
input,
optgroup,
select,
textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit
}

button,
select {
    text-transform: none
}

[role=button] {
    cursor: pointer
}

select {
    word-wrap: normal
}

select:disabled {
    opacity: 1
}

[list]::-webkit-calendar-picker-indicator {
    display: none
}

[type=button],
[type=reset],
[type=submit],
button {
    -webkit-appearance: button
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer
}

::-moz-focus-inner {
    padding: 0;
    border-style: none
}

textarea {
    resize: vertical
}

fieldset {
    min-width: 0;
    padding: 0;
    margin: 0;
    border: 0
}

legend {
    float: left;
    width: 100%;
    padding: 0;
    margin-bottom: .5rem;
    font-size: calc(1.275rem + .3vw);
    line-height: inherit
}

@media (min-width: 1200px) {
    legend {
        font-size: 1.5rem
    }
}

legend + * {
    clear: left
}

::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-year-field {
    padding: 0
}

::-webkit-inner-spin-button {
    height: auto
}

[type=search] {
    outline-offset: -2px;
    -webkit-appearance: textfield
}

::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-color-swatch-wrapper {
    padding: 0
}

::file-selector-button {
    font: inherit
}

::-webkit-file-upload-button {
    font: inherit;
    -webkit-appearance: button
}

output {
    display: inline-block
}

iframe {
    border: 0
}

summary {
    display: list-item;
    cursor: pointer
}

progress {
    vertical-align: baseline
}

[hidden] {
    display: none !important
}

.lead {
    font-size: 1.25rem;
    font-weight: 300
}

.display-1 {
    font-size: calc(1.625rem + 4.5vw);
    font-weight: 500;
    line-height: 1.3
}

@media (min-width: 1200px) {
    .display-1 {
        font-size: 5rem
    }
}

.display-2 {
    font-size: calc(1.475rem + 2.7vw);
    font-weight: 500;
    line-height: 1.3
}

@media (min-width: 1200px) {
    .display-2 {
        font-size: 3.5rem
    }
}

.display-3 {
    font-size: calc(1.375rem + 1.5vw);
    font-weight: 500;
    line-height: 1.3
}

@media (min-width: 1200px) {
    .display-3 {
        font-size: 2.5rem
    }
}

.display-4 {
    font-size: calc(1.3125rem + .75vw);
    font-weight: 500;
    line-height: 1.3
}

@media (min-width: 1200px) {
    .display-4 {
        font-size: 1.875rem
    }
}

.display-5 {
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.3
}

.display-6 {
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.3
}

.list-unstyled {
    padding-left: 0;
    list-style: none
}

.list-inline {
    padding-left: 0;
    list-style: none
}

.list-inline-item {
    display: inline-block
}

.list-inline-item:not(:last-child) {
    margin-right: .5rem
}

.initialism {
    font-size: .875em;
    text-transform: uppercase
}

.blockquote {
    margin-bottom: 1rem;
    font-size: 1.25rem
}

.blockquote > :last-child {
    margin-bottom: 0
}

.blockquote-footer {
    margin-top: -1rem;
    margin-bottom: 1rem;
    font-size: .875em;
    color: #4b5563
}

.blockquote-footer::before {
    content: "\\2014\\00A0"
}

.img-fluid {
    max-width: 100%;
    height: auto
}

.img-thumbnail {
    padding: .25rem;
    background-color: #f2f4f6;
    border: .0625rem solid #d1d5db;
    border-radius: .5rem;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    max-width: 100%;
    height: auto
}

.figure {
    display: inline-block
}

.figure-img {
    margin-bottom: .5rem;
    line-height: 1
}

.figure-caption {
    font-size: .875em;
    color: #4b5563
}

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    width: 100%;
    padding-right: var(--bs-gutter-x, 1rem);
    padding-left: var(--bs-gutter-x, 1rem);
    margin-right: auto;
    margin-left: auto
}

@media (min-width: 576px) {

    .container,
    .container-sm {
        max-width: 540px
    }
}

@media (min-width: 768px) {

    .container,
    .container-md,
    .container-sm {
        max-width: 720px
    }
}

@media (min-width: 992px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm {
        max-width: 960px
    }
}

@media (min-width: 1200px) {

    .container,
    .container-lg,
    .container-md,
    .container-sm,
    .container-xl {
        max-width: 1140px
    }
}

.row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--bs-gutter-y) * -1);
    margin-right: calc(var(--bs-gutter-x) / -2);
    margin-left: calc(var(--bs-gutter-x) / -2)
}

.row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) / 2);
    padding-left: calc(var(--bs-gutter-x) / 2);
    margin-top: var(--bs-gutter-y)
}

.col {
    flex: 1 0
}

.row-cols-auto > * {
    flex: 0 0 auto;
    width: auto
}

.row-cols-1 > * {
    flex: 0 0 auto;
    width: 100%
}

.row-cols-2 > * {
    flex: 0 0 auto;
    width: 50%
}

.row-cols-3 > * {
    flex: 0 0 auto;
    width: 33.33333%
}

.row-cols-4 > * {
    flex: 0 0 auto;
    width: 25%
}

.row-cols-5 > * {
    flex: 0 0 auto;
    width: 20%
}

.row-cols-6 > * {
    flex: 0 0 auto;
    width: 16.66667%
}

.col-auto {
    flex: 0 0 auto;
    width: auto
}

.col-1 {
    flex: 0 0 auto;
    width: 8.33333%
}

.col-2 {
    flex: 0 0 auto;
    width: 16.66667%
}

.col-3 {
    flex: 0 0 auto;
    width: 25%
}

.col-4 {
    flex: 0 0 auto;
    width: 33.33333%
}

.col-5 {
    flex: 0 0 auto;
    width: 41.66667%
}

.col-6 {
    flex: 0 0 auto;
    width: 50%
}

.col-7 {
    flex: 0 0 auto;
    width: 58.33333%
}

.col-8 {
    flex: 0 0 auto;
    width: 66.66667%
}

.col-9 {
    flex: 0 0 auto;
    width: 75%
}

.col-10 {
    flex: 0 0 auto;
    width: 83.33333%
}

.col-11 {
    flex: 0 0 auto;
    width: 91.66667%
}

.col-12 {
    flex: 0 0 auto;
    width: 100%
}

.offset-1 {
    margin-left: 8.33333%
}

.offset-2 {
    margin-left: 16.66667%
}

.offset-3 {
    margin-left: 25%
}

.offset-4 {
    margin-left: 33.33333%
}

.offset-5 {
    margin-left: 41.66667%
}

.offset-6 {
    margin-left: 50%
}

.offset-7 {
    margin-left: 58.33333%
}

.offset-8 {
    margin-left: 66.66667%
}

.offset-9 {
    margin-left: 75%
}

.offset-10 {
    margin-left: 83.33333%
}

.offset-11 {
    margin-left: 91.66667%
}

.g-0,
.gx-0 {
    --bs-gutter-x: 0
}

.g-0,
.gy-0 {
    --bs-gutter-y: 0
}

.g-1,
.gx-1 {
    --bs-gutter-x: 0.25rem
}

.g-1,
.gy-1 {
    --bs-gutter-y: 0.25rem
}

.g-2,
.gx-2 {
    --bs-gutter-x: 0.5rem
}

.g-2,
.gy-2 {
    --bs-gutter-y: 0.5rem
}

.g-3,
.gx-3 {
    --bs-gutter-x: 1rem
}

.g-3,
.gy-3 {
    --bs-gutter-y: 1rem
}

.g-4,
.gx-4 {
    --bs-gutter-x: 1.5rem
}

.g-4,
.gy-4 {
    --bs-gutter-y: 1.5rem
}

.g-5,
.gx-5 {
    --bs-gutter-x: 3rem
}

.g-5,
.gy-5 {
    --bs-gutter-y: 3rem
}

.g-6,
.gx-6 {
    --bs-gutter-x: 5rem
}

.g-6,
.gy-6 {
    --bs-gutter-y: 5rem
}

.g-7,
.gx-7 {
    --bs-gutter-x: 8rem
}

.g-7,
.gy-7 {
    --bs-gutter-y: 8rem
}

.g-8,
.gx-8 {
    --bs-gutter-x: 10rem
}

.g-8,
.gy-8 {
    --bs-gutter-y: 10rem
}

.g-9,
.gx-9 {
    --bs-gutter-x: 11rem
}

.g-9,
.gy-9 {
    --bs-gutter-y: 11rem
}

.g-10,
.gx-10 {
    --bs-gutter-x: 14rem
}

.g-10,
.gy-10 {
    --bs-gutter-y: 14rem
}

.g-11,
.gx-11 {
    --bs-gutter-x: 16rem
}

.g-11,
.gy-11 {
    --bs-gutter-y: 16rem
}

.g-12,
.gx-12 {
    --bs-gutter-x: 20rem
}

.g-12,
.gy-12 {
    --bs-gutter-y: 20rem
}

.g-sm,
.gx-sm {
    --bs-gutter-x: 1rem
}

.g-sm,
.gy-sm {
    --bs-gutter-y: 1rem
}

.g-md,
.gx-md {
    --bs-gutter-x: 2rem
}

.g-md,
.gy-md {
    --bs-gutter-y: 2rem
}

.g-lg,
.gx-lg {
    --bs-gutter-x: 4rem
}

.g-lg,
.gy-lg {
    --bs-gutter-y: 4rem
}

.g-xl,
.gx-xl {
    --bs-gutter-x: 8rem
}

.g-xl,
.gy-xl {
    --bs-gutter-y: 8rem
}

@media (min-width: 576px) {
    .col-sm {
        flex: 1 0
    }

    .row-cols-sm-auto > * {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-sm-1 > * {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-sm-2 > * {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-sm-3 > * {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .row-cols-sm-4 > * {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-sm-5 > * {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-sm-6 > * {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-sm-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-sm-1 {
        flex: 0 0 auto;
        width: 8.33333%
    }

    .col-sm-2 {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-sm-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-sm-4 {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .col-sm-5 {
        flex: 0 0 auto;
        width: 41.66667%
    }

    .col-sm-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-sm-7 {
        flex: 0 0 auto;
        width: 58.33333%
    }

    .col-sm-8 {
        flex: 0 0 auto;
        width: 66.66667%
    }

    .col-sm-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-sm-10 {
        flex: 0 0 auto;
        width: 83.33333%
    }

    .col-sm-11 {
        flex: 0 0 auto;
        width: 91.66667%
    }

    .col-sm-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-sm-0 {
        margin-left: 0
    }

    .offset-sm-1 {
        margin-left: 8.33333%
    }

    .offset-sm-2 {
        margin-left: 16.66667%
    }

    .offset-sm-3 {
        margin-left: 25%
    }

    .offset-sm-4 {
        margin-left: 33.33333%
    }

    .offset-sm-5 {
        margin-left: 41.66667%
    }

    .offset-sm-6 {
        margin-left: 50%
    }

    .offset-sm-7 {
        margin-left: 58.33333%
    }

    .offset-sm-8 {
        margin-left: 66.66667%
    }

    .offset-sm-9 {
        margin-left: 75%
    }

    .offset-sm-10 {
        margin-left: 83.33333%
    }

    .offset-sm-11 {
        margin-left: 91.66667%
    }

    .g-sm-0,
    .gx-sm-0 {
        --bs-gutter-x: 0
    }

    .g-sm-0,
    .gy-sm-0 {
        --bs-gutter-y: 0
    }

    .g-sm-1,
    .gx-sm-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-sm-1,
    .gy-sm-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-sm-2,
    .gx-sm-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-sm-2,
    .gy-sm-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-sm-3,
    .gx-sm-3 {
        --bs-gutter-x: 1rem
    }

    .g-sm-3,
    .gy-sm-3 {
        --bs-gutter-y: 1rem
    }

    .g-sm-4,
    .gx-sm-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-sm-4,
    .gy-sm-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-sm-5,
    .gx-sm-5 {
        --bs-gutter-x: 3rem
    }

    .g-sm-5,
    .gy-sm-5 {
        --bs-gutter-y: 3rem
    }

    .g-sm-6,
    .gx-sm-6 {
        --bs-gutter-x: 5rem
    }

    .g-sm-6,
    .gy-sm-6 {
        --bs-gutter-y: 5rem
    }

    .g-sm-7,
    .gx-sm-7 {
        --bs-gutter-x: 8rem
    }

    .g-sm-7,
    .gy-sm-7 {
        --bs-gutter-y: 8rem
    }

    .g-sm-8,
    .gx-sm-8 {
        --bs-gutter-x: 10rem
    }

    .g-sm-8,
    .gy-sm-8 {
        --bs-gutter-y: 10rem
    }

    .g-sm-9,
    .gx-sm-9 {
        --bs-gutter-x: 11rem
    }

    .g-sm-9,
    .gy-sm-9 {
        --bs-gutter-y: 11rem
    }

    .g-sm-10,
    .gx-sm-10 {
        --bs-gutter-x: 14rem
    }

    .g-sm-10,
    .gy-sm-10 {
        --bs-gutter-y: 14rem
    }

    .g-sm-11,
    .gx-sm-11 {
        --bs-gutter-x: 16rem
    }

    .g-sm-11,
    .gy-sm-11 {
        --bs-gutter-y: 16rem
    }

    .g-sm-12,
    .gx-sm-12 {
        --bs-gutter-x: 20rem
    }

    .g-sm-12,
    .gy-sm-12 {
        --bs-gutter-y: 20rem
    }

    .g-sm-sm,
    .gx-sm-sm {
        --bs-gutter-x: 1rem
    }

    .g-sm-sm,
    .gy-sm-sm {
        --bs-gutter-y: 1rem
    }

    .g-sm-md,
    .gx-sm-md {
        --bs-gutter-x: 2rem
    }

    .g-sm-md,
    .gy-sm-md {
        --bs-gutter-y: 2rem
    }

    .g-sm-lg,
    .gx-sm-lg {
        --bs-gutter-x: 4rem
    }

    .g-sm-lg,
    .gy-sm-lg {
        --bs-gutter-y: 4rem
    }

    .g-sm-xl,
    .gx-sm-xl {
        --bs-gutter-x: 8rem
    }

    .g-sm-xl,
    .gy-sm-xl {
        --bs-gutter-y: 8rem
    }
}

@media (min-width: 768px) {
    .col-md {
        flex: 1 0
    }

    .row-cols-md-auto > * {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-md-1 > * {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-md-2 > * {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-md-3 > * {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .row-cols-md-4 > * {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-md-5 > * {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-md-6 > * {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-md-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-md-1 {
        flex: 0 0 auto;
        width: 8.33333%
    }

    .col-md-2 {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-md-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-md-4 {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .col-md-5 {
        flex: 0 0 auto;
        width: 41.66667%
    }

    .col-md-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-md-7 {
        flex: 0 0 auto;
        width: 58.33333%
    }

    .col-md-8 {
        flex: 0 0 auto;
        width: 66.66667%
    }

    .col-md-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-md-10 {
        flex: 0 0 auto;
        width: 83.33333%
    }

    .col-md-11 {
        flex: 0 0 auto;
        width: 91.66667%
    }

    .col-md-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-md-0 {
        margin-left: 0
    }

    .offset-md-1 {
        margin-left: 8.33333%
    }

    .offset-md-2 {
        margin-left: 16.66667%
    }

    .offset-md-3 {
        margin-left: 25%
    }

    .offset-md-4 {
        margin-left: 33.33333%
    }

    .offset-md-5 {
        margin-left: 41.66667%
    }

    .offset-md-6 {
        margin-left: 50%
    }

    .offset-md-7 {
        margin-left: 58.33333%
    }

    .offset-md-8 {
        margin-left: 66.66667%
    }

    .offset-md-9 {
        margin-left: 75%
    }

    .offset-md-10 {
        margin-left: 83.33333%
    }

    .offset-md-11 {
        margin-left: 91.66667%
    }

    .g-md-0,
    .gx-md-0 {
        --bs-gutter-x: 0
    }

    .g-md-0,
    .gy-md-0 {
        --bs-gutter-y: 0
    }

    .g-md-1,
    .gx-md-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-md-1,
    .gy-md-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-md-2,
    .gx-md-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-md-2,
    .gy-md-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-md-3,
    .gx-md-3 {
        --bs-gutter-x: 1rem
    }

    .g-md-3,
    .gy-md-3 {
        --bs-gutter-y: 1rem
    }

    .g-md-4,
    .gx-md-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-md-4,
    .gy-md-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-md-5,
    .gx-md-5 {
        --bs-gutter-x: 3rem
    }

    .g-md-5,
    .gy-md-5 {
        --bs-gutter-y: 3rem
    }

    .g-md-6,
    .gx-md-6 {
        --bs-gutter-x: 5rem
    }

    .g-md-6,
    .gy-md-6 {
        --bs-gutter-y: 5rem
    }

    .g-md-7,
    .gx-md-7 {
        --bs-gutter-x: 8rem
    }

    .g-md-7,
    .gy-md-7 {
        --bs-gutter-y: 8rem
    }

    .g-md-8,
    .gx-md-8 {
        --bs-gutter-x: 10rem
    }

    .g-md-8,
    .gy-md-8 {
        --bs-gutter-y: 10rem
    }

    .g-md-9,
    .gx-md-9 {
        --bs-gutter-x: 11rem
    }

    .g-md-9,
    .gy-md-9 {
        --bs-gutter-y: 11rem
    }

    .g-md-10,
    .gx-md-10 {
        --bs-gutter-x: 14rem
    }

    .g-md-10,
    .gy-md-10 {
        --bs-gutter-y: 14rem
    }

    .g-md-11,
    .gx-md-11 {
        --bs-gutter-x: 16rem
    }

    .g-md-11,
    .gy-md-11 {
        --bs-gutter-y: 16rem
    }

    .g-md-12,
    .gx-md-12 {
        --bs-gutter-x: 20rem
    }

    .g-md-12,
    .gy-md-12 {
        --bs-gutter-y: 20rem
    }

    .g-md-sm,
    .gx-md-sm {
        --bs-gutter-x: 1rem
    }

    .g-md-sm,
    .gy-md-sm {
        --bs-gutter-y: 1rem
    }

    .g-md-md,
    .gx-md-md {
        --bs-gutter-x: 2rem
    }

    .g-md-md,
    .gy-md-md {
        --bs-gutter-y: 2rem
    }

    .g-md-lg,
    .gx-md-lg {
        --bs-gutter-x: 4rem
    }

    .g-md-lg,
    .gy-md-lg {
        --bs-gutter-y: 4rem
    }

    .g-md-xl,
    .gx-md-xl {
        --bs-gutter-x: 8rem
    }

    .g-md-xl,
    .gy-md-xl {
        --bs-gutter-y: 8rem
    }
}

@media (min-width: 992px) {
    .col-lg {
        flex: 1 0
    }

    .row-cols-lg-auto > * {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-lg-1 > * {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-lg-2 > * {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-lg-3 > * {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .row-cols-lg-4 > * {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-lg-5 > * {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-lg-6 > * {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-lg-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-lg-1 {
        flex: 0 0 auto;
        width: 8.33333%
    }

    .col-lg-2 {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-lg-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-lg-4 {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .col-lg-5 {
        flex: 0 0 auto;
        width: 41.66667%
    }

    .col-lg-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-lg-7 {
        flex: 0 0 auto;
        width: 58.33333%
    }

    .col-lg-8 {
        flex: 0 0 auto;
        width: 66.66667%
    }

    .col-lg-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-lg-10 {
        flex: 0 0 auto;
        width: 83.33333%
    }

    .col-lg-11 {
        flex: 0 0 auto;
        width: 91.66667%
    }

    .col-lg-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-lg-0 {
        margin-left: 0
    }

    .offset-lg-1 {
        margin-left: 8.33333%
    }

    .offset-lg-2 {
        margin-left: 16.66667%
    }

    .offset-lg-3 {
        margin-left: 25%
    }

    .offset-lg-4 {
        margin-left: 33.33333%
    }

    .offset-lg-5 {
        margin-left: 41.66667%
    }

    .offset-lg-6 {
        margin-left: 50%
    }

    .offset-lg-7 {
        margin-left: 58.33333%
    }

    .offset-lg-8 {
        margin-left: 66.66667%
    }

    .offset-lg-9 {
        margin-left: 75%
    }

    .offset-lg-10 {
        margin-left: 83.33333%
    }

    .offset-lg-11 {
        margin-left: 91.66667%
    }

    .g-lg-0,
    .gx-lg-0 {
        --bs-gutter-x: 0
    }

    .g-lg-0,
    .gy-lg-0 {
        --bs-gutter-y: 0
    }

    .g-lg-1,
    .gx-lg-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-lg-1,
    .gy-lg-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-lg-2,
    .gx-lg-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-lg-2,
    .gy-lg-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-lg-3,
    .gx-lg-3 {
        --bs-gutter-x: 1rem
    }

    .g-lg-3,
    .gy-lg-3 {
        --bs-gutter-y: 1rem
    }

    .g-lg-4,
    .gx-lg-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-lg-4,
    .gy-lg-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-lg-5,
    .gx-lg-5 {
        --bs-gutter-x: 3rem
    }

    .g-lg-5,
    .gy-lg-5 {
        --bs-gutter-y: 3rem
    }

    .g-lg-6,
    .gx-lg-6 {
        --bs-gutter-x: 5rem
    }

    .g-lg-6,
    .gy-lg-6 {
        --bs-gutter-y: 5rem
    }

    .g-lg-7,
    .gx-lg-7 {
        --bs-gutter-x: 8rem
    }

    .g-lg-7,
    .gy-lg-7 {
        --bs-gutter-y: 8rem
    }

    .g-lg-8,
    .gx-lg-8 {
        --bs-gutter-x: 10rem
    }

    .g-lg-8,
    .gy-lg-8 {
        --bs-gutter-y: 10rem
    }

    .g-lg-9,
    .gx-lg-9 {
        --bs-gutter-x: 11rem
    }

    .g-lg-9,
    .gy-lg-9 {
        --bs-gutter-y: 11rem
    }

    .g-lg-10,
    .gx-lg-10 {
        --bs-gutter-x: 14rem
    }

    .g-lg-10,
    .gy-lg-10 {
        --bs-gutter-y: 14rem
    }

    .g-lg-11,
    .gx-lg-11 {
        --bs-gutter-x: 16rem
    }

    .g-lg-11,
    .gy-lg-11 {
        --bs-gutter-y: 16rem
    }

    .g-lg-12,
    .gx-lg-12 {
        --bs-gutter-x: 20rem
    }

    .g-lg-12,
    .gy-lg-12 {
        --bs-gutter-y: 20rem
    }

    .g-lg-sm,
    .gx-lg-sm {
        --bs-gutter-x: 1rem
    }

    .g-lg-sm,
    .gy-lg-sm {
        --bs-gutter-y: 1rem
    }

    .g-lg-md,
    .gx-lg-md {
        --bs-gutter-x: 2rem
    }

    .g-lg-md,
    .gy-lg-md {
        --bs-gutter-y: 2rem
    }

    .g-lg-lg,
    .gx-lg-lg {
        --bs-gutter-x: 4rem
    }

    .g-lg-lg,
    .gy-lg-lg {
        --bs-gutter-y: 4rem
    }

    .g-lg-xl,
    .gx-lg-xl {
        --bs-gutter-x: 8rem
    }

    .g-lg-xl,
    .gy-lg-xl {
        --bs-gutter-y: 8rem
    }
}

@media (min-width: 1200px) {
    .col-xl {
        flex: 1 0
    }

    .row-cols-xl-auto > * {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-xl-1 > * {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-xl-2 > * {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-xl-3 > * {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .row-cols-xl-4 > * {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-xl-5 > * {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-xl-6 > * {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-xl-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-xl-1 {
        flex: 0 0 auto;
        width: 8.33333%
    }

    .col-xl-2 {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-xl-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-xl-4 {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .col-xl-5 {
        flex: 0 0 auto;
        width: 41.66667%
    }

    .col-xl-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-xl-7 {
        flex: 0 0 auto;
        width: 58.33333%
    }

    .col-xl-8 {
        flex: 0 0 auto;
        width: 66.66667%
    }

    .col-xl-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-xl-10 {
        flex: 0 0 auto;
        width: 83.33333%
    }

    .col-xl-11 {
        flex: 0 0 auto;
        width: 91.66667%
    }

    .col-xl-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-xl-0 {
        margin-left: 0
    }

    .offset-xl-1 {
        margin-left: 8.33333%
    }

    .offset-xl-2 {
        margin-left: 16.66667%
    }

    .offset-xl-3 {
        margin-left: 25%
    }

    .offset-xl-4 {
        margin-left: 33.33333%
    }

    .offset-xl-5 {
        margin-left: 41.66667%
    }

    .offset-xl-6 {
        margin-left: 50%
    }

    .offset-xl-7 {
        margin-left: 58.33333%
    }

    .offset-xl-8 {
        margin-left: 66.66667%
    }

    .offset-xl-9 {
        margin-left: 75%
    }

    .offset-xl-10 {
        margin-left: 83.33333%
    }

    .offset-xl-11 {
        margin-left: 91.66667%
    }

    .g-xl-0,
    .gx-xl-0 {
        --bs-gutter-x: 0
    }

    .g-xl-0,
    .gy-xl-0 {
        --bs-gutter-y: 0
    }

    .g-xl-1,
    .gx-xl-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-xl-1,
    .gy-xl-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-xl-2,
    .gx-xl-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-xl-2,
    .gy-xl-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-xl-3,
    .gx-xl-3 {
        --bs-gutter-x: 1rem
    }

    .g-xl-3,
    .gy-xl-3 {
        --bs-gutter-y: 1rem
    }

    .g-xl-4,
    .gx-xl-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-xl-4,
    .gy-xl-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-xl-5,
    .gx-xl-5 {
        --bs-gutter-x: 3rem
    }

    .g-xl-5,
    .gy-xl-5 {
        --bs-gutter-y: 3rem
    }

    .g-xl-6,
    .gx-xl-6 {
        --bs-gutter-x: 5rem
    }

    .g-xl-6,
    .gy-xl-6 {
        --bs-gutter-y: 5rem
    }

    .g-xl-7,
    .gx-xl-7 {
        --bs-gutter-x: 8rem
    }

    .g-xl-7,
    .gy-xl-7 {
        --bs-gutter-y: 8rem
    }

    .g-xl-8,
    .gx-xl-8 {
        --bs-gutter-x: 10rem
    }

    .g-xl-8,
    .gy-xl-8 {
        --bs-gutter-y: 10rem
    }

    .g-xl-9,
    .gx-xl-9 {
        --bs-gutter-x: 11rem
    }

    .g-xl-9,
    .gy-xl-9 {
        --bs-gutter-y: 11rem
    }

    .g-xl-10,
    .gx-xl-10 {
        --bs-gutter-x: 14rem
    }

    .g-xl-10,
    .gy-xl-10 {
        --bs-gutter-y: 14rem
    }

    .g-xl-11,
    .gx-xl-11 {
        --bs-gutter-x: 16rem
    }

    .g-xl-11,
    .gy-xl-11 {
        --bs-gutter-y: 16rem
    }

    .g-xl-12,
    .gx-xl-12 {
        --bs-gutter-x: 20rem
    }

    .g-xl-12,
    .gy-xl-12 {
        --bs-gutter-y: 20rem
    }

    .g-xl-sm,
    .gx-xl-sm {
        --bs-gutter-x: 1rem
    }

    .g-xl-sm,
    .gy-xl-sm {
        --bs-gutter-y: 1rem
    }

    .g-xl-md,
    .gx-xl-md {
        --bs-gutter-x: 2rem
    }

    .g-xl-md,
    .gy-xl-md {
        --bs-gutter-y: 2rem
    }

    .g-xl-lg,
    .gx-xl-lg {
        --bs-gutter-x: 4rem
    }

    .g-xl-lg,
    .gy-xl-lg {
        --bs-gutter-y: 4rem
    }

    .g-xl-xl,
    .gx-xl-xl {
        --bs-gutter-x: 8rem
    }

    .g-xl-xl,
    .gy-xl-xl {
        --bs-gutter-y: 8rem
    }
}

@media (min-width: 1400px) {
    .col-xxl {
        flex: 1 0
    }

    .row-cols-xxl-auto > * {
        flex: 0 0 auto;
        width: auto
    }

    .row-cols-xxl-1 > * {
        flex: 0 0 auto;
        width: 100%
    }

    .row-cols-xxl-2 > * {
        flex: 0 0 auto;
        width: 50%
    }

    .row-cols-xxl-3 > * {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .row-cols-xxl-4 > * {
        flex: 0 0 auto;
        width: 25%
    }

    .row-cols-xxl-5 > * {
        flex: 0 0 auto;
        width: 20%
    }

    .row-cols-xxl-6 > * {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-xxl-auto {
        flex: 0 0 auto;
        width: auto
    }

    .col-xxl-1 {
        flex: 0 0 auto;
        width: 8.33333%
    }

    .col-xxl-2 {
        flex: 0 0 auto;
        width: 16.66667%
    }

    .col-xxl-3 {
        flex: 0 0 auto;
        width: 25%
    }

    .col-xxl-4 {
        flex: 0 0 auto;
        width: 33.33333%
    }

    .col-xxl-5 {
        flex: 0 0 auto;
        width: 41.66667%
    }

    .col-xxl-6 {
        flex: 0 0 auto;
        width: 50%
    }

    .col-xxl-7 {
        flex: 0 0 auto;
        width: 58.33333%
    }

    .col-xxl-8 {
        flex: 0 0 auto;
        width: 66.66667%
    }

    .col-xxl-9 {
        flex: 0 0 auto;
        width: 75%
    }

    .col-xxl-10 {
        flex: 0 0 auto;
        width: 83.33333%
    }

    .col-xxl-11 {
        flex: 0 0 auto;
        width: 91.66667%
    }

    .col-xxl-12 {
        flex: 0 0 auto;
        width: 100%
    }

    .offset-xxl-0 {
        margin-left: 0
    }

    .offset-xxl-1 {
        margin-left: 8.33333%
    }

    .offset-xxl-2 {
        margin-left: 16.66667%
    }

    .offset-xxl-3 {
        margin-left: 25%
    }

    .offset-xxl-4 {
        margin-left: 33.33333%
    }

    .offset-xxl-5 {
        margin-left: 41.66667%
    }

    .offset-xxl-6 {
        margin-left: 50%
    }

    .offset-xxl-7 {
        margin-left: 58.33333%
    }

    .offset-xxl-8 {
        margin-left: 66.66667%
    }

    .offset-xxl-9 {
        margin-left: 75%
    }

    .offset-xxl-10 {
        margin-left: 83.33333%
    }

    .offset-xxl-11 {
        margin-left: 91.66667%
    }

    .g-xxl-0,
    .gx-xxl-0 {
        --bs-gutter-x: 0
    }

    .g-xxl-0,
    .gy-xxl-0 {
        --bs-gutter-y: 0
    }

    .g-xxl-1,
    .gx-xxl-1 {
        --bs-gutter-x: 0.25rem
    }

    .g-xxl-1,
    .gy-xxl-1 {
        --bs-gutter-y: 0.25rem
    }

    .g-xxl-2,
    .gx-xxl-2 {
        --bs-gutter-x: 0.5rem
    }

    .g-xxl-2,
    .gy-xxl-2 {
        --bs-gutter-y: 0.5rem
    }

    .g-xxl-3,
    .gx-xxl-3 {
        --bs-gutter-x: 1rem
    }

    .g-xxl-3,
    .gy-xxl-3 {
        --bs-gutter-y: 1rem
    }

    .g-xxl-4,
    .gx-xxl-4 {
        --bs-gutter-x: 1.5rem
    }

    .g-xxl-4,
    .gy-xxl-4 {
        --bs-gutter-y: 1.5rem
    }

    .g-xxl-5,
    .gx-xxl-5 {
        --bs-gutter-x: 3rem
    }

    .g-xxl-5,
    .gy-xxl-5 {
        --bs-gutter-y: 3rem
    }

    .g-xxl-6,
    .gx-xxl-6 {
        --bs-gutter-x: 5rem
    }

    .g-xxl-6,
    .gy-xxl-6 {
        --bs-gutter-y: 5rem
    }

    .g-xxl-7,
    .gx-xxl-7 {
        --bs-gutter-x: 8rem
    }

    .g-xxl-7,
    .gy-xxl-7 {
        --bs-gutter-y: 8rem
    }

    .g-xxl-8,
    .gx-xxl-8 {
        --bs-gutter-x: 10rem
    }

    .g-xxl-8,
    .gy-xxl-8 {
        --bs-gutter-y: 10rem
    }

    .g-xxl-9,
    .gx-xxl-9 {
        --bs-gutter-x: 11rem
    }

    .g-xxl-9,
    .gy-xxl-9 {
        --bs-gutter-y: 11rem
    }

    .g-xxl-10,
    .gx-xxl-10 {
        --bs-gutter-x: 14rem
    }

    .g-xxl-10,
    .gy-xxl-10 {
        --bs-gutter-y: 14rem
    }

    .g-xxl-11,
    .gx-xxl-11 {
        --bs-gutter-x: 16rem
    }

    .g-xxl-11,
    .gy-xxl-11 {
        --bs-gutter-y: 16rem
    }

    .g-xxl-12,
    .gx-xxl-12 {
        --bs-gutter-x: 20rem
    }

    .g-xxl-12,
    .gy-xxl-12 {
        --bs-gutter-y: 20rem
    }

    .g-xxl-sm,
    .gx-xxl-sm {
        --bs-gutter-x: 1rem
    }

    .g-xxl-sm,
    .gy-xxl-sm {
        --bs-gutter-y: 1rem
    }

    .g-xxl-md,
    .gx-xxl-md {
        --bs-gutter-x: 2rem
    }

    .g-xxl-md,
    .gy-xxl-md {
        --bs-gutter-y: 2rem
    }

    .g-xxl-lg,
    .gx-xxl-lg {
        --bs-gutter-x: 4rem
    }

    .g-xxl-lg,
    .gy-xxl-lg {
        --bs-gutter-y: 4rem
    }

    .g-xxl-xl,
    .gx-xxl-xl {
        --bs-gutter-x: 8rem
    }

    .g-xxl-xl,
    .gy-xxl-xl {
        --bs-gutter-y: 8rem
    }
}

.table {
    --bs-table-bg: transparent;
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: #374151;
    --bs-table-striped-bg: rgba(17, 24, 39, 0.05);
    --bs-table-active-color: #374151;
    --bs-table-active-bg: rgba(17, 24, 39, 0.1);
    --bs-table-hover-color: #374151;
    --bs-table-hover-bg: rgba(17, 24, 39, 0.075);
    width: 100%;
    margin-bottom: 1rem;
    color: #374151;
    vertical-align: top;
    border-color: #e5e7eb
}

.table > :not(caption) > * > * {
    padding: .75rem .5rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: .0625rem;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg)
}

.table > tbody {
    vertical-align: inherit
}

.table > thead {
    vertical-align: bottom
}

.table > :not(:last-child) > :last-child > * {
    border-bottom-color: currentColor
}

.caption-top {
    caption-side: top
}

.table-sm > :not(caption) > * > * {
    padding: .25rem .25rem
}

.table-bordered > :not(caption) > * {
    border-width: .0625rem 0
}

.table-bordered > :not(caption) > * > * {
    border-width: 0 .0625rem
}

.table-borderless > :not(caption) > * > * {
    border-bottom-width: 0
}

.table-striped > tbody > tr:nth-of-type(odd) {
    --bs-table-accent-bg: var(--bs-table-striped-bg);
    color: var(--bs-table-striped-color)
}

.table-active {
    --bs-table-accent-bg: var(--bs-table-active-bg);
    color: var(--bs-table-active-color)
}

.table-hover > tbody > tr:hover {
    --bs-table-accent-bg: var(--bs-table-hover-bg);
    color: var(--bs-table-hover-color)
}

.table-primary {
    --bs-table-bg: #d2d4d7;
    --bs-table-striped-bg: #c9cbcf;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #c0c3c7;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #c5c7cb;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #c0c3c7
}

.table-secondary {
    --bs-table-bg: #fcf2e3;
    --bs-table-striped-bg: #f1e8da;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #e6ded2;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #ebe3d6;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #e6ded2
}

.table-success {
    --bs-table-bg: #cff1e6;
    --bs-table-striped-bg: #c6e7dd;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #bdddd5;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #c2e2d9;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #bdddd5
}

.table-info {
    --bs-table-bg: #d3dff5;
    --bs-table-striped-bg: #cad6ec;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #c1cde2;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #c6d1e7;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #c1cde2
}

.table-warning {
    --bs-table-bg: #feeed1;
    --bs-table-striped-bg: #f3e4c9;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #e8dac2;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #eddfc5;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #e8dac2
}

.table-danger {
    --bs-table-bg: #f9d2da;
    --bs-table-striped-bg: #eecad2;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #e3c1ca;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #e9c5ce;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #e3c1ca
}

.table-light {
    --bs-table-bg: #9CA3AF;
    --bs-table-striped-bg: #969da9;
    --bs-table-striped-color: #1F2937;
    --bs-table-active-bg: #9097a3;
    --bs-table-active-color: #1F2937;
    --bs-table-hover-bg: #939aa6;
    --bs-table-hover-color: #1F2937;
    color: #1f2937;
    border-color: #9097a3
}

.table-dark {
    --bs-table-bg: #1F2937;
    --bs-table-striped-bg: #2a3441;
    --bs-table-striped-color: #ffffff;
    --bs-table-active-bg: #353e4b;
    --bs-table-active-color: #ffffff;
    --bs-table-hover-bg: #303946;
    --bs-table-hover-color: #ffffff;
    color: #fff;
    border-color: #353e4b
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch
}

@media (max-width: 575.98px) {
    .table-responsive-sm {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media (max-width: 767.98px) {
    .table-responsive-md {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media (max-width: 991.98px) {
    .table-responsive-lg {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media (max-width: 1199.98px) {
    .table-responsive-xl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

@media (max-width: 1399.98px) {
    .table-responsive-xxl {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch
    }
}

.form-label {
    margin-bottom: .5rem
}

.col-form-label {
    padding-top: .5625rem;
    padding-bottom: .5625rem;
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5
}

.col-form-label-lg {
    padding-top: .5625rem;
    padding-bottom: .5625rem;
    font-size: 1.25rem
}

.col-form-label-sm {
    padding-top: .4375rem;
    padding-bottom: .4375rem;
    font-size: .875rem
}

.form-text {
    margin-top: .25rem;
    font-size: .875em;
    color: #58677d
}

.form-control {
    display: block;
    width: 100%;
    padding: .5rem 1rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6b7280;
    background-color: #fff;
    background-clip: padding-box;
    border: .0625rem solid #d1d5db;
    appearance: none;
    border-radius: .5rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-control {
        transition: none
    }
}

.form-control[type=file] {
    overflow: hidden
}

.form-control[type=file]:not(:disabled):not([readonly]) {
    cursor: pointer
}

.form-control:focus {
    color: #6b7280;
    background-color: #fff;
    border-color: #4d6689;
    outline: 0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07), 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.form-control::-webkit-date-and-time-value {
    height: 1.5em
}

.form-control::placeholder {
    color: #4b5563;
    opacity: 1
}

.form-control:disabled,
.form-control[readonly] {
    background-color: #e5e7eb;
    opacity: 1
}

.form-control::file-selector-button {
    padding: .5rem 1rem;
    margin: -.5rem -1rem;
    margin-inline-end: 1rem;
    color: #6b7280;
    background-color: #fff;
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: .0625rem;
    border-radius: 0;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-control::file-selector-button {
        transition: none
    }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: #f2f2f2
}

.form-control::-webkit-file-upload-button {
    padding: .5rem 1rem;
    margin: -.5rem -1rem;
    margin-inline-end: 1rem;
    color: #6b7280;
    background-color: #fff;
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: .0625rem;
    border-radius: 0;
    -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-control::-webkit-file-upload-button {
        -webkit-transition: none;
        transition: none
    }
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
    background-color: #f2f2f2
}

.form-control-plaintext {
    display: block;
    width: 100%;
    padding: .5rem 0;
    margin-bottom: 0;
    line-height: 1.5;
    color: #374151;
    background-color: transparent;
    border: solid transparent;
    border-width: .0625rem 0
}

.form-control-plaintext.form-control-lg,
.form-control-plaintext.form-control-sm {
    padding-right: 0;
    padding-left: 0
}

.form-control-sm {
    min-height: calc(1.5em + .875rem);
    padding: .375rem .625rem;
    font-size: .875rem;
    border-radius: .5rem
}

.form-control-sm::file-selector-button {
    padding: .375rem .625rem;
    margin: -.375rem -.625rem;
    margin-inline-end: .625rem
}

.form-control-sm::-webkit-file-upload-button {
    padding: .375rem .625rem;
    margin: -.375rem -.625rem;
    margin-inline-end: .625rem
}

.form-control-lg {
    min-height: calc(1.5em + 1.125rem);
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: .5rem
}

.form-control-lg::file-selector-button {
    padding: .5rem 1rem;
    margin: -.5rem -1rem;
    margin-inline-end: 1rem
}

.form-control-lg::-webkit-file-upload-button {
    padding: .5rem 1rem;
    margin: -.5rem -1rem;
    margin-inline-end: 1rem
}

textarea.form-control {
    min-height: calc(1.5em + 1.125rem)
}

textarea.form-control-sm {
    min-height: calc(1.5em + .875rem)
}

textarea.form-control-lg {
    min-height: calc(1.5em + 1.125rem)
}

.form-control-color {
    max-width: 3rem;
    height: auto;
    padding: .5rem
}

.form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer
}

.form-control-color::-moz-color-swatch {
    height: 1.5em;
    border-radius: .5rem
}

.form-control-color::-webkit-color-swatch {
    height: 1.5em;
    border-radius: .5rem
}

.form-select {
    display: block;
    width: 100%;
    padding: .5rem 1rem .5rem 1rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6b7280;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 16px 12px;
    border: .0625rem solid #d1d5db;
    border-radius: .5rem;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125);
    appearance: none
}

.form-select:focus {
    border-color: #4d6689;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125), 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
    padding-right: 1rem;
    background-image: none
}

.form-select:disabled {
    color: #4b5563;
    background-color: #e5e7eb
}

.form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #6b7280
}

.form-select-sm {
    padding-top: .375rem;
    padding-bottom: .375rem;
    padding-left: .625rem;
    font-size: .875rem
}

.form-select-lg {
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: 1rem;
    font-size: 1.25rem
}

.form-check {
    display: block;
    min-height: 1.5rem;
    padding-left: 1.625em;
    margin-bottom: .125rem
}

.form-check .form-check-input {
    float: left;
    margin-left: -1.625em
}

.form-check-input {
    width: 1.125em;
    height: 1.125em;
    margin-top: .1875em;
    vertical-align: top;
    background-color: #f2f4f6;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #d1d5db;
    appearance: none;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    transition: background-color .2s ease-in-out, background-position .2s ease-in-out, border-color .2s ease-in-out, box-shadow .2s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-check-input {
        transition: none
    }
}

.form-check-input[type=checkbox] {
    border-radius: .25em
}

.form-check-input[type=radio] {
    border-radius: 50%
}

.form-check-input:active {
    filter: brightness(90%)
}

.form-check-input:focus {
    border-color: #4d6689;
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.form-check-input:checked {
    background-color: #1f2937;
    border-color: #1f2937
}

.form-check-input:checked[type=checkbox] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
}

.form-check-input:checked[type=radio] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
}

.form-check-input[type=checkbox]:indeterminate {
    background-color: #1f2937;
    border-color: #1f2937;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
}

.form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: .5
}

.form-check-input:disabled ~ .form-check-label,
.form-check-input[disabled] ~ .form-check-label {
    opacity: .5
}

.form-switch {
    padding-left: 2.75em
}

.form-switch .form-check-input {
    width: 2.25em;
    margin-left: -2.75em;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-position: left center;
    border-radius: 2.25em;
    transition: background-position .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-switch .form-check-input {
        transition: none
    }
}

.form-switch .form-check-input:focus {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
}

.form-switch .form-check-input:checked {
    background-position: right center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
}

.form-check-inline {
    display: inline-block;
    margin-right: 1rem
}

.btn-check {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none
}

.btn-check:disabled + .btn,
.btn-check[disabled] + .btn {
    pointer-events: none;
    filter: none;
    opacity: .65
}

.form-range {
    width: 100%;
    height: 1.36rem;
    padding: 0;
    background-color: transparent;
    appearance: none
}

.form-range:focus {
    outline: 0
}

.form-range:focus::-webkit-slider-thumb {
    box-shadow: 0 0 0 1px #f2f4f6, 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.form-range:focus::-moz-range-thumb {
    box-shadow: 0 0 0 1px #f2f4f6, 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.form-range::-moz-focus-outer {
    border: 0
}

.form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -.25rem;
    background-color: #1f2937;
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 .1rem .25rem rgba(17, 24, 39, .1);
    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media (prefers-reduced-motion: reduce) {
    .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none
    }
}

.form-range::-webkit-slider-thumb:active {
    background-color: #627fa7
}

.form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: .5rem;
    color: transparent;
    cursor: pointer;
    background-color: #d1d5db;
    border-color: transparent;
    border-radius: 1rem;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)
}

.form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #1f2937;
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 .1rem .25rem rgba(17, 24, 39, .1);
    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    appearance: none
}

@media (prefers-reduced-motion: reduce) {
    .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none
    }
}

.form-range::-moz-range-thumb:active {
    background-color: #627fa7
}

.form-range::-moz-range-track {
    width: 100%;
    height: .5rem;
    color: transparent;
    cursor: pointer;
    background-color: #d1d5db;
    border-color: transparent;
    border-radius: 1rem;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)
}

.form-range:disabled {
    pointer-events: none
}

.form-range:disabled::-webkit-slider-thumb {
    background-color: #6b7280
}

.form-range:disabled::-moz-range-thumb {
    background-color: #6b7280
}

.form-floating {
    position: relative
}

.form-floating > .form-control,
.form-floating > .form-select {
    height: 3.625rem;
    padding: 1rem 1rem
}

.form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 1rem 1rem;
    pointer-events: none;
    border: .0625rem solid transparent;
    transform-origin: 0 0;
    transition: opacity .1s ease-in-out, transform .1s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .form-floating > label {
        transition: none
    }
}

.form-floating > .form-control::placeholder {
    color: transparent
}

.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating > .form-control:-webkit-autofill {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: .625rem
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
    opacity: .65;
    transform: scale(.85) translateY(-.5rem) translateX(.15rem)
}

.form-floating > .form-control:-webkit-autofill ~ label {
    opacity: .65;
    transform: scale(.85) translateY(-.5rem) translateX(.15rem)
}

.input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%
}

.input-group > .form-control,
.input-group > .form-select {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0
}

.input-group > .form-control:focus,
.input-group > .form-select:focus {
    z-index: 3
}

.input-group .btn {
    position: relative;
    z-index: 2
}

.input-group .btn:focus {
    z-index: 3
}

.input-group-text {
    display: flex;
    align-items: center;
    padding: .5rem .625rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #9ca3af;
    text-align: center;
    white-space: nowrap;
    background-color: #fff;
    border: .0625rem solid #d1d5db;
    border-radius: .5rem
}

.input-group-lg > .btn,
.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text {
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: .5rem
}

.input-group-sm > .btn,
.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text {
    padding: .375rem .625rem;
    font-size: .875rem;
    border-radius: .5rem
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
    padding-right: 2rem
}

.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: -.0625rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.valid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: .875em;
    color: #10b981
}

.valid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .375rem .55rem;
    margin-top: .1rem;
    font-size: .875rem;
    color: #1f2937;
    background-color: rgba(16, 185, 129, .99);
    border-radius: .5rem
}

.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip,
.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip {
    display: block
}

.form-control.is-valid,
.was-validated .form-control:valid {
    border-color: #10b981;
    padding-right: calc(1.5em + 1rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    background-position: right calc(.375em + .25rem) center;
    background-size: calc(.75em + .5rem) calc(.75em + .5rem)
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
    padding-right: calc(1.5em + 1rem);
    background-position: top calc(.375em + .25rem) right calc(.375em + .25rem)
}

.form-select.is-valid,
.was-validated .form-select:valid {
    border-color: #10b981
}

.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"],
.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"] {
    padding-right: 3.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-position: right 1rem center, center right 2rem;
    background-size: 16px 12px, calc(.75em + .5rem) calc(.75em + .5rem)
}

.form-select.is-valid:focus,
.was-validated .form-select:valid:focus {
    border-color: #10b981;
    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)
}

.form-check-input.is-valid,
.was-validated .form-check-input:valid {
    border-color: #10b981
}

.form-check-input.is-valid:checked,
.was-validated .form-check-input:valid:checked {
    background-color: #10b981
}

.form-check-input.is-valid:focus,
.was-validated .form-check-input:valid:focus {
    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)
}

.form-check-input.is-valid ~ .form-check-label,
.was-validated .form-check-input:valid ~ .form-check-label {
    color: #10b981
}

.form-check-inline .form-check-input ~ .valid-feedback {
    margin-left: .5em
}

.input-group .form-control.is-valid,
.input-group .form-select.is-valid,
.was-validated .input-group .form-control:valid,
.was-validated .input-group .form-select:valid {
    z-index: 1
}

.input-group .form-control.is-valid:focus,
.input-group .form-select.is-valid:focus,
.was-validated .input-group .form-control:valid:focus,
.was-validated .input-group .form-select:valid:focus {
    z-index: 3
}

.invalid-feedback {
    display: none;
    width: 100%;
    margin-top: .25rem;
    font-size: .875em;
    color: #e11d48
}

.invalid-tooltip {
    position: absolute;
    top: 100%;
    z-index: 5;
    display: none;
    max-width: 100%;
    padding: .375rem .55rem;
    margin-top: .1rem;
    font-size: .875rem;
    color: #fff;
    background-color: rgba(225, 29, 72, .99);
    border-radius: .5rem
}

.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip,
.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip {
    display: block
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
    border-color: #e11d48;
    padding-right: calc(1.5em + 1rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    background-position: right calc(.375em + .25rem) center;
    background-size: calc(.75em + .5rem) calc(.75em + .5rem)
}

.form-control.is-invalid:focus,
.was-validated .form-control:invalid:focus {
    border-color: #e11d48;
    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
    padding-right: calc(1.5em + 1rem);
    background-position: top calc(.375em + .25rem) right calc(.375em + .25rem)
}

.form-select.is-invalid,
.was-validated .form-select:invalid {
    border-color: #e11d48
}

.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"],
.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"] {
    padding-right: 3.5rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-position: right 1rem center, center right 2rem;
    background-size: 16px 12px, calc(.75em + .5rem) calc(.75em + .5rem)
}

.form-select.is-invalid:focus,
.was-validated .form-select:invalid:focus {
    border-color: #e11d48;
    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)
}

.form-check-input.is-invalid,
.was-validated .form-check-input:invalid {
    border-color: #e11d48
}

.form-check-input.is-invalid:checked,
.was-validated .form-check-input:invalid:checked {
    background-color: #e11d48
}

.form-check-input.is-invalid:focus,
.was-validated .form-check-input:invalid:focus {
    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)
}

.form-check-input.is-invalid ~ .form-check-label,
.was-validated .form-check-input:invalid ~ .form-check-label {
    color: #e11d48
}

.form-check-inline .form-check-input ~ .invalid-feedback {
    margin-left: .5em
}

.input-group .form-control.is-invalid,
.input-group .form-select.is-invalid,
.was-validated .input-group .form-control:invalid,
.was-validated .input-group .form-select:invalid {
    z-index: 2
}

.input-group .form-control.is-invalid:focus,
.input-group .form-select.is-invalid:focus,
.was-validated .input-group .form-control:invalid:focus,
.was-validated .input-group .form-select:invalid:focus {
    z-index: 3
}

.btn {
    display: inline-block;
    font-weight: 500;
    line-height: 1.5;
    color: #374151;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    background-color: transparent;
    border: .0625rem solid transparent;
    padding: .5rem 1rem;
    font-size: .875rem;
    border-radius: .5rem;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .btn {
        transition: none
    }
}

.btn:hover {
    color: #374151
}

.btn-check:focus + .btn,
.btn:focus {
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.btn-check:active + .btn,
.btn-check:checked + .btn,
.btn.active,
.btn:active {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125)
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn:active:focus {
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25), inset 0 3px 5px rgba(17, 24, 39, .125)
}

.btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
    pointer-events: none;
    opacity: .65;
    box-shadow: none
}

.btn-primary {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-primary:hover {
    color: #fff;
    background-color: #1a232f;
    border-color: #19212c
}

.btn-check:focus + .btn-primary,
.btn-primary:focus {
    color: #fff;
    background-color: #1a232f;
    border-color: #19212c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(65, 73, 85, .5)
}

.btn-check:active + .btn-primary,
.btn-check:checked + .btn-primary,
.btn-primary.active,
.btn-primary:active,
.show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #19212c;
    border-color: #171f29
}

.btn-check:active + .btn-primary:focus,
.btn-check:checked + .btn-primary:focus,
.btn-primary.active:focus,
.btn-primary:active:focus,
.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(65, 73, 85, .5)
}

.btn-primary.disabled,
.btn-primary:disabled {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-secondary {
    color: #1f2937;
    background-color: #f0bc74;
    border-color: #f0bc74;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-secondary:hover {
    color: #1f2937;
    background-color: #f2c689;
    border-color: #f2c382
}

.btn-check:focus + .btn-secondary,
.btn-secondary:focus {
    color: #1f2937;
    background-color: #f2c689;
    border-color: #f2c382;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(209, 166, 107, .5)
}

.btn-check:active + .btn-secondary,
.btn-check:checked + .btn-secondary,
.btn-secondary.active,
.btn-secondary:active,
.show > .btn-secondary.dropdown-toggle {
    color: #1f2937;
    background-color: #f3c990;
    border-color: #f2c382
}

.btn-check:active + .btn-secondary:focus,
.btn-check:checked + .btn-secondary:focus,
.btn-secondary.active:focus,
.btn-secondary:active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(209, 166, 107, .5)
}

.btn-secondary.disabled,
.btn-secondary:disabled {
    color: #1f2937;
    background-color: #f0bc74;
    border-color: #f0bc74
}

.btn-tertiary {
    color: #fff;
    background-color: #31316a;
    border-color: #31316a;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-tertiary:hover {
    color: #fff;
    background-color: #2a2a5a;
    border-color: #272755
}

.btn-check:focus + .btn-tertiary,
.btn-tertiary:focus {
    color: #fff;
    background-color: #2a2a5a;
    border-color: #272755;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(80, 80, 128, .5)
}

.btn-check:active + .btn-tertiary,
.btn-check:checked + .btn-tertiary,
.btn-tertiary.active,
.btn-tertiary:active,
.show > .btn-tertiary.dropdown-toggle {
    color: #fff;
    background-color: #272755;
    border-color: #252550
}

.btn-check:active + .btn-tertiary:focus,
.btn-check:checked + .btn-tertiary:focus,
.btn-tertiary.active:focus,
.btn-tertiary:active:focus,
.show > .btn-tertiary.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(80, 80, 128, .5)
}

.btn-tertiary.disabled,
.btn-tertiary:disabled {
    color: #fff;
    background-color: #31316a;
    border-color: #31316a
}

.btn-success {
    color: #1f2937;
    background-color: #10b981;
    border-color: #10b981;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-success:hover {
    color: #1f2937;
    background-color: #34c494;
    border-color: #28c08e
}

.btn-check:focus + .btn-success,
.btn-success:focus {
    color: #1f2937;
    background-color: #34c494;
    border-color: #28c08e;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(18, 163, 118, .5)
}

.btn-check:active + .btn-success,
.btn-check:checked + .btn-success,
.btn-success.active,
.btn-success:active,
.show > .btn-success.dropdown-toggle {
    color: #1f2937;
    background-color: #40c79a;
    border-color: #28c08e
}

.btn-check:active + .btn-success:focus,
.btn-check:checked + .btn-success:focus,
.btn-success.active:focus,
.btn-success:active:focus,
.show > .btn-success.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(18, 163, 118, .5)
}

.btn-success.disabled,
.btn-success:disabled {
    color: #1f2937;
    background-color: #10b981;
    border-color: #10b981
}

.btn-info {
    color: #fff;
    background-color: #2361ce;
    border-color: #2361ce;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-info:hover {
    color: #fff;
    background-color: #1e52af;
    border-color: #1c4ea5
}

.btn-check:focus + .btn-info,
.btn-info:focus {
    color: #fff;
    background-color: #1e52af;
    border-color: #1c4ea5;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(68, 121, 213, .5)
}

.btn-check:active + .btn-info,
.btn-check:checked + .btn-info,
.btn-info.active,
.btn-info:active,
.show > .btn-info.dropdown-toggle {
    color: #fff;
    background-color: #1c4ea5;
    border-color: #1a499b
}

.btn-check:active + .btn-info:focus,
.btn-check:checked + .btn-info:focus,
.btn-info.active:focus,
.btn-info:active:focus,
.show > .btn-info.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(68, 121, 213, .5)
}

.btn-info.disabled,
.btn-info:disabled {
    color: #fff;
    background-color: #2361ce;
    border-color: #2361ce
}

.btn-warning {
    color: #1f2937;
    background-color: #fba918;
    border-color: #fba918;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-warning:hover {
    color: #1f2937;
    background-color: #fcb63b;
    border-color: #fbb22f
}

.btn-check:focus + .btn-warning,
.btn-warning:focus {
    color: #1f2937;
    background-color: #fcb63b;
    border-color: #fbb22f;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(218, 150, 29, .5)
}

.btn-check:active + .btn-warning,
.btn-check:checked + .btn-warning,
.btn-warning.active,
.btn-warning:active,
.show > .btn-warning.dropdown-toggle {
    color: #1f2937;
    background-color: #fcba46;
    border-color: #fbb22f
}

.btn-check:active + .btn-warning:focus,
.btn-check:checked + .btn-warning:focus,
.btn-warning.active:focus,
.btn-warning:active:focus,
.show > .btn-warning.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(218, 150, 29, .5)
}

.btn-warning.disabled,
.btn-warning:disabled {
    color: #1f2937;
    background-color: #fba918;
    border-color: #fba918
}

.btn-danger {
    color: #fff;
    background-color: #e11d48;
    border-color: #e11d48;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-danger:hover {
    color: #fff;
    background-color: #bf193d;
    border-color: #b4173a
}

.btn-check:focus + .btn-danger,
.btn-danger:focus {
    color: #fff;
    background-color: #bf193d;
    border-color: #b4173a;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(230, 63, 99, .5)
}

.btn-check:active + .btn-danger,
.btn-check:checked + .btn-danger,
.btn-danger.active,
.btn-danger:active,
.show > .btn-danger.dropdown-toggle {
    color: #fff;
    background-color: #b4173a;
    border-color: #a91636
}

.btn-check:active + .btn-danger:focus,
.btn-check:checked + .btn-danger:focus,
.btn-danger.active:focus,
.btn-danger:active:focus,
.show > .btn-danger.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(230, 63, 99, .5)
}

.btn-danger.disabled,
.btn-danger:disabled {
    color: #fff;
    background-color: #e11d48;
    border-color: #e11d48
}

.btn-white {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-white:hover {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff
}

.btn-check:focus + .btn-white,
.btn-white:focus {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(221, 223, 225, .5)
}

.btn-check:active + .btn-white,
.btn-check:checked + .btn-white,
.btn-white.active,
.btn-white:active,
.show > .btn-white.dropdown-toggle {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff
}

.btn-check:active + .btn-white:focus,
.btn-check:checked + .btn-white:focus,
.btn-white.active:focus,
.btn-white:active:focus,
.show > .btn-white.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(221, 223, 225, .5)
}

.btn-white.disabled,
.btn-white:disabled {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff
}

.btn-indigo {
    color: #fff;
    background-color: #4f46e5;
    border-color: #4f46e5;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-indigo:hover {
    color: #fff;
    background-color: #433cc3;
    border-color: #3f38b7
}

.btn-check:focus + .btn-indigo,
.btn-indigo:focus {
    color: #fff;
    background-color: #433cc3;
    border-color: #3f38b7;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(105, 98, 233, .5)
}

.btn-check:active + .btn-indigo,
.btn-check:checked + .btn-indigo,
.btn-indigo.active,
.btn-indigo:active,
.show > .btn-indigo.dropdown-toggle {
    color: #fff;
    background-color: #3f38b7;
    border-color: #3b35ac
}

.btn-check:active + .btn-indigo:focus,
.btn-check:checked + .btn-indigo:focus,
.btn-indigo.active:focus,
.btn-indigo:active:focus,
.show > .btn-indigo.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(105, 98, 233, .5)
}

.btn-indigo.disabled,
.btn-indigo:disabled {
    color: #fff;
    background-color: #4f46e5;
    border-color: #4f46e5
}

.btn-purple {
    color: #fff;
    background-color: #7c3aed;
    border-color: #7c3aed;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-purple:hover {
    color: #fff;
    background-color: #6931c9;
    border-color: #632ebe
}

.btn-check:focus + .btn-purple,
.btn-purple:focus {
    color: #fff;
    background-color: #6931c9;
    border-color: #632ebe;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(144, 88, 240, .5)
}

.btn-check:active + .btn-purple,
.btn-check:checked + .btn-purple,
.btn-purple.active,
.btn-purple:active,
.show > .btn-purple.dropdown-toggle {
    color: #fff;
    background-color: #632ebe;
    border-color: #5d2cb2
}

.btn-check:active + .btn-purple:focus,
.btn-check:checked + .btn-purple:focus,
.btn-purple.active:focus,
.btn-purple:active:focus,
.show > .btn-purple.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(144, 88, 240, .5)
}

.btn-purple.disabled,
.btn-purple:disabled {
    color: #fff;
    background-color: #7c3aed;
    border-color: #7c3aed
}

.btn-yellow-100 {
    color: #1f2937;
    background-color: #ffeed6;
    border-color: #ffeed6;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-yellow-100:hover {
    color: #1f2937;
    background-color: #fff1dc;
    border-color: #fff0da
}

.btn-check:focus + .btn-yellow-100,
.btn-yellow-100:focus {
    color: #1f2937;
    background-color: #fff1dc;
    border-color: #fff0da;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(221, 208, 190, .5)
}

.btn-check:active + .btn-yellow-100,
.btn-check:checked + .btn-yellow-100,
.btn-yellow-100.active,
.btn-yellow-100:active,
.show > .btn-yellow-100.dropdown-toggle {
    color: #1f2937;
    background-color: #fff1de;
    border-color: #fff0da
}

.btn-check:active + .btn-yellow-100:focus,
.btn-check:checked + .btn-yellow-100:focus,
.btn-yellow-100.active:focus,
.btn-yellow-100:active:focus,
.show > .btn-yellow-100.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(221, 208, 190, .5)
}

.btn-yellow-100.disabled,
.btn-yellow-100:disabled {
    color: #1f2937;
    background-color: #ffeed6;
    border-color: #ffeed6
}

.btn-yellow-200 {
    color: #1f2937;
    background-color: #f5dbb8;
    border-color: #f5dbb8;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-yellow-200:hover {
    color: #1f2937;
    background-color: #f7e0c3;
    border-color: #f6dfbf
}

.btn-check:focus + .btn-yellow-200,
.btn-yellow-200:focus {
    color: #1f2937;
    background-color: #f7e0c3;
    border-color: #f6dfbf;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(213, 192, 165, .5)
}

.btn-check:active + .btn-yellow-200,
.btn-check:checked + .btn-yellow-200,
.btn-yellow-200.active,
.btn-yellow-200:active,
.show > .btn-yellow-200.dropdown-toggle {
    color: #1f2937;
    background-color: #f7e2c6;
    border-color: #f6dfbf
}

.btn-check:active + .btn-yellow-200:focus,
.btn-check:checked + .btn-yellow-200:focus,
.btn-yellow-200.active:focus,
.btn-yellow-200:active:focus,
.show > .btn-yellow-200.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(213, 192, 165, .5)
}

.btn-yellow-200.disabled,
.btn-yellow-200:disabled {
    color: #1f2937;
    background-color: #f5dbb8;
    border-color: #f5dbb8
}

.btn-gray-50 {
    color: #1f2937;
    background-color: #f9fafb;
    border-color: #f9fafb;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-50:hover {
    color: #1f2937;
    background-color: #fafbfc;
    border-color: #fafbfb
}

.btn-check:focus + .btn-gray-50,
.btn-gray-50:focus {
    color: #1f2937;
    background-color: #fafbfc;
    border-color: #fafbfb;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(216, 219, 222, .5)
}

.btn-check:active + .btn-gray-50,
.btn-check:checked + .btn-gray-50,
.btn-gray-50.active,
.btn-gray-50:active,
.show > .btn-gray-50.dropdown-toggle {
    color: #1f2937;
    background-color: #fafbfc;
    border-color: #fafbfb
}

.btn-check:active + .btn-gray-50:focus,
.btn-check:checked + .btn-gray-50:focus,
.btn-gray-50.active:focus,
.btn-gray-50:active:focus,
.show > .btn-gray-50.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(216, 219, 222, .5)
}

.btn-gray-50.disabled,
.btn-gray-50:disabled {
    color: #1f2937;
    background-color: #f9fafb;
    border-color: #f9fafb
}

.btn-gray-100 {
    color: #1f2937;
    background-color: #f2f4f6;
    border-color: #f2f4f6;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-100:hover {
    color: #1f2937;
    background-color: #f4f6f7;
    border-color: #f3f5f7
}

.btn-check:focus + .btn-gray-100,
.btn-gray-100:focus {
    color: #1f2937;
    background-color: #f4f6f7;
    border-color: #f3f5f7;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(210, 214, 217, .5)
}

.btn-check:active + .btn-gray-100,
.btn-check:checked + .btn-gray-100,
.btn-gray-100.active,
.btn-gray-100:active,
.show > .btn-gray-100.dropdown-toggle {
    color: #1f2937;
    background-color: #f5f6f8;
    border-color: #f3f5f7
}

.btn-check:active + .btn-gray-100:focus,
.btn-check:checked + .btn-gray-100:focus,
.btn-gray-100.active:focus,
.btn-gray-100:active:focus,
.show > .btn-gray-100.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(210, 214, 217, .5)
}

.btn-gray-100.disabled,
.btn-gray-100:disabled {
    color: #1f2937;
    background-color: #f2f4f6;
    border-color: #f2f4f6
}

.btn-gray-200 {
    color: #1f2937;
    background-color: #e5e7eb;
    border-color: #e5e7eb;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-200:hover {
    color: #1f2937;
    background-color: #e9ebee;
    border-color: #e8e9ed
}

.btn-check:focus + .btn-gray-200,
.btn-gray-200:focus {
    color: #1f2937;
    background-color: #e9ebee;
    border-color: #e8e9ed;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(199, 203, 208, .5)
}

.btn-check:active + .btn-gray-200,
.btn-check:checked + .btn-gray-200,
.btn-gray-200.active,
.btn-gray-200:active,
.show > .btn-gray-200.dropdown-toggle {
    color: #1f2937;
    background-color: #eaecef;
    border-color: #e8e9ed
}

.btn-check:active + .btn-gray-200:focus,
.btn-check:checked + .btn-gray-200:focus,
.btn-gray-200.active:focus,
.btn-gray-200:active:focus,
.show > .btn-gray-200.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(199, 203, 208, .5)
}

.btn-gray-200.disabled,
.btn-gray-200:disabled {
    color: #1f2937;
    background-color: #e5e7eb;
    border-color: #e5e7eb
}

.btn-gray-300 {
    color: #1f2937;
    background-color: #d1d5db;
    border-color: #d1d5db;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-300:hover {
    color: #1f2937;
    background-color: #d8dbe0;
    border-color: #d6d9df
}

.btn-check:focus + .btn-gray-300,
.btn-gray-300:focus {
    color: #1f2937;
    background-color: #d8dbe0;
    border-color: #d6d9df;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(182, 187, 194, .5)
}

.btn-check:active + .btn-gray-300,
.btn-check:checked + .btn-gray-300,
.btn-gray-300.active,
.btn-gray-300:active,
.show > .btn-gray-300.dropdown-toggle {
    color: #1f2937;
    background-color: #dadde2;
    border-color: #d6d9df
}

.btn-check:active + .btn-gray-300:focus,
.btn-check:checked + .btn-gray-300:focus,
.btn-gray-300.active:focus,
.btn-gray-300:active:focus,
.show > .btn-gray-300.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(182, 187, 194, .5)
}

.btn-gray-300.disabled,
.btn-gray-300:disabled {
    color: #1f2937;
    background-color: #d1d5db;
    border-color: #d1d5db
}

.btn-gray-400 {
    color: #1f2937;
    background-color: #9ca3af;
    border-color: #9ca3af;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-400:hover {
    color: #1f2937;
    background-color: #abb1bb;
    border-color: #a6acb7
}

.btn-check:focus + .btn-gray-400,
.btn-gray-400:focus {
    color: #1f2937;
    background-color: #abb1bb;
    border-color: #a6acb7;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(137, 145, 157, .5)
}

.btn-check:active + .btn-gray-400,
.btn-check:checked + .btn-gray-400,
.btn-gray-400.active,
.btn-gray-400:active,
.show > .btn-gray-400.dropdown-toggle {
    color: #1f2937;
    background-color: #b0b5bf;
    border-color: #a6acb7
}

.btn-check:active + .btn-gray-400:focus,
.btn-check:checked + .btn-gray-400:focus,
.btn-gray-400.active:focus,
.btn-gray-400:active:focus,
.show > .btn-gray-400.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(137, 145, 157, .5)
}

.btn-gray-400.disabled,
.btn-gray-400:disabled {
    color: #1f2937;
    background-color: #9ca3af;
    border-color: #9ca3af
}

.btn-gray-500 {
    color: #fff;
    background-color: #6b7280;
    border-color: #6b7280;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-500:hover {
    color: #fff;
    background-color: #5b616d;
    border-color: #565b66
}

.btn-check:focus + .btn-gray-500,
.btn-gray-500:focus {
    color: #fff;
    background-color: #5b616d;
    border-color: #565b66;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(129, 135, 147, .5)
}

.btn-check:active + .btn-gray-500,
.btn-check:checked + .btn-gray-500,
.btn-gray-500.active,
.btn-gray-500:active,
.show > .btn-gray-500.dropdown-toggle {
    color: #fff;
    background-color: #565b66;
    border-color: #505660
}

.btn-check:active + .btn-gray-500:focus,
.btn-check:checked + .btn-gray-500:focus,
.btn-gray-500.active:focus,
.btn-gray-500:active:focus,
.show > .btn-gray-500.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(129, 135, 147, .5)
}

.btn-gray-500.disabled,
.btn-gray-500:disabled {
    color: #fff;
    background-color: #6b7280;
    border-color: #6b7280
}

.btn-gray-600 {
    color: #fff;
    background-color: #4b5563;
    border-color: #4b5563;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-600:hover {
    color: #fff;
    background-color: #404854;
    border-color: #3c444f
}

.btn-check:focus + .btn-gray-600,
.btn-gray-600:focus {
    color: #fff;
    background-color: #404854;
    border-color: #3c444f;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(102, 111, 122, .5)
}

.btn-check:active + .btn-gray-600,
.btn-check:checked + .btn-gray-600,
.btn-gray-600.active,
.btn-gray-600:active,
.show > .btn-gray-600.dropdown-toggle {
    color: #fff;
    background-color: #3c444f;
    border-color: #38404a
}

.btn-check:active + .btn-gray-600:focus,
.btn-check:checked + .btn-gray-600:focus,
.btn-gray-600.active:focus,
.btn-gray-600:active:focus,
.show > .btn-gray-600.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(102, 111, 122, .5)
}

.btn-gray-600.disabled,
.btn-gray-600:disabled {
    color: #fff;
    background-color: #4b5563;
    border-color: #4b5563
}

.btn-gray-700 {
    color: #fff;
    background-color: #374151;
    border-color: #374151;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-700:hover {
    color: #fff;
    background-color: #2f3745;
    border-color: #2c3441
}

.btn-check:focus + .btn-gray-700,
.btn-gray-700:focus {
    color: #fff;
    background-color: #2f3745;
    border-color: #2c3441;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(85, 94, 107, .5)
}

.btn-check:active + .btn-gray-700,
.btn-check:checked + .btn-gray-700,
.btn-gray-700.active,
.btn-gray-700:active,
.show > .btn-gray-700.dropdown-toggle {
    color: #fff;
    background-color: #2c3441;
    border-color: #29313d
}

.btn-check:active + .btn-gray-700:focus,
.btn-check:checked + .btn-gray-700:focus,
.btn-gray-700.active:focus,
.btn-gray-700:active:focus,
.show > .btn-gray-700.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(85, 94, 107, .5)
}

.btn-gray-700.disabled,
.btn-gray-700:disabled {
    color: #fff;
    background-color: #374151;
    border-color: #374151
}

.btn-gray-800 {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-800:hover {
    color: #fff;
    background-color: #1a232f;
    border-color: #19212c
}

.btn-check:focus + .btn-gray-800,
.btn-gray-800:focus {
    color: #fff;
    background-color: #1a232f;
    border-color: #19212c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(65, 73, 85, .5)
}

.btn-check:active + .btn-gray-800,
.btn-check:checked + .btn-gray-800,
.btn-gray-800.active,
.btn-gray-800:active,
.show > .btn-gray-800.dropdown-toggle {
    color: #fff;
    background-color: #19212c;
    border-color: #171f29
}

.btn-check:active + .btn-gray-800:focus,
.btn-check:checked + .btn-gray-800:focus,
.btn-gray-800.active:focus,
.btn-gray-800:active:focus,
.show > .btn-gray-800.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(65, 73, 85, .5)
}

.btn-gray-800.disabled,
.btn-gray-800:disabled {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-gray-900 {
    color: #fff;
    background-color: #111827;
    border-color: #111827;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-gray-900:hover {
    color: #fff;
    background-color: #0e1421;
    border-color: #0e131f
}

.btn-check:focus + .btn-gray-900,
.btn-gray-900:focus {
    color: #fff;
    background-color: #0e1421;
    border-color: #0e131f;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(53, 59, 71, .5)
}

.btn-check:active + .btn-gray-900,
.btn-check:checked + .btn-gray-900,
.btn-gray-900.active,
.btn-gray-900:active,
.show > .btn-gray-900.dropdown-toggle {
    color: #fff;
    background-color: #0e131f;
    border-color: #0d121d
}

.btn-check:active + .btn-gray-900:focus,
.btn-check:checked + .btn-gray-900:focus,
.btn-gray-900.active:focus,
.btn-gray-900:active:focus,
.show > .btn-gray-900.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(53, 59, 71, .5)
}

.btn-gray-900.disabled,
.btn-gray-900:disabled {
    color: #fff;
    background-color: #111827;
    border-color: #111827
}

.btn-outline-primary {
    color: #1f2937;
    border-color: #1f2937
}

.btn-outline-primary:hover {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-check:focus + .btn-outline-primary,
.btn-outline-primary:focus {
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .5)
}

.btn-check:active + .btn-outline-primary,
.btn-check:checked + .btn-outline-primary,
.btn-outline-primary.active,
.btn-outline-primary.dropdown-toggle.show,
.btn-outline-primary:active {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-check:active + .btn-outline-primary:focus,
.btn-check:checked + .btn-outline-primary:focus,
.btn-outline-primary.active:focus,
.btn-outline-primary.dropdown-toggle.show:focus,
.btn-outline-primary:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(31, 41, 55, .5)
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
    color: #1f2937;
    background-color: transparent
}

.btn-outline-secondary {
    color: #f0bc74;
    border-color: #f0bc74
}

.btn-outline-secondary:hover {
    color: #1f2937;
    background-color: #f0bc74;
    border-color: #f0bc74
}

.btn-check:focus + .btn-outline-secondary,
.btn-outline-secondary:focus {
    box-shadow: 0 0 0 .18rem rgba(240, 188, 116, .5)
}

.btn-check:active + .btn-outline-secondary,
.btn-check:checked + .btn-outline-secondary,
.btn-outline-secondary.active,
.btn-outline-secondary.dropdown-toggle.show,
.btn-outline-secondary:active {
    color: #1f2937;
    background-color: #f0bc74;
    border-color: #f0bc74
}

.btn-check:active + .btn-outline-secondary:focus,
.btn-check:checked + .btn-outline-secondary:focus,
.btn-outline-secondary.active:focus,
.btn-outline-secondary.dropdown-toggle.show:focus,
.btn-outline-secondary:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(240, 188, 116, .5)
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
    color: #f0bc74;
    background-color: transparent
}

.btn-outline-tertiary {
    color: #31316a;
    border-color: #31316a
}

.btn-outline-tertiary:hover {
    color: #fff;
    background-color: #31316a;
    border-color: #31316a
}

.btn-check:focus + .btn-outline-tertiary,
.btn-outline-tertiary:focus {
    box-shadow: 0 0 0 .18rem rgba(49, 49, 106, .5)
}

.btn-check:active + .btn-outline-tertiary,
.btn-check:checked + .btn-outline-tertiary,
.btn-outline-tertiary.active,
.btn-outline-tertiary.dropdown-toggle.show,
.btn-outline-tertiary:active {
    color: #fff;
    background-color: #31316a;
    border-color: #31316a
}

.btn-check:active + .btn-outline-tertiary:focus,
.btn-check:checked + .btn-outline-tertiary:focus,
.btn-outline-tertiary.active:focus,
.btn-outline-tertiary.dropdown-toggle.show:focus,
.btn-outline-tertiary:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(49, 49, 106, .5)
}

.btn-outline-tertiary.disabled,
.btn-outline-tertiary:disabled {
    color: #31316a;
    background-color: transparent
}

.btn-outline-success {
    color: #10b981;
    border-color: #10b981
}

.btn-outline-success:hover {
    color: #1f2937;
    background-color: #10b981;
    border-color: #10b981
}

.btn-check:focus + .btn-outline-success,
.btn-outline-success:focus {
    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .5)
}

.btn-check:active + .btn-outline-success,
.btn-check:checked + .btn-outline-success,
.btn-outline-success.active,
.btn-outline-success.dropdown-toggle.show,
.btn-outline-success:active {
    color: #1f2937;
    background-color: #10b981;
    border-color: #10b981
}

.btn-check:active + .btn-outline-success:focus,
.btn-check:checked + .btn-outline-success:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus,
.btn-outline-success:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(16, 185, 129, .5)
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
    color: #10b981;
    background-color: transparent
}

.btn-outline-info {
    color: #2361ce;
    border-color: #2361ce
}

.btn-outline-info:hover {
    color: #fff;
    background-color: #2361ce;
    border-color: #2361ce
}

.btn-check:focus + .btn-outline-info,
.btn-outline-info:focus {
    box-shadow: 0 0 0 .18rem rgba(35, 97, 206, .5)
}

.btn-check:active + .btn-outline-info,
.btn-check:checked + .btn-outline-info,
.btn-outline-info.active,
.btn-outline-info.dropdown-toggle.show,
.btn-outline-info:active {
    color: #fff;
    background-color: #2361ce;
    border-color: #2361ce
}

.btn-check:active + .btn-outline-info:focus,
.btn-check:checked + .btn-outline-info:focus,
.btn-outline-info.active:focus,
.btn-outline-info.dropdown-toggle.show:focus,
.btn-outline-info:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(35, 97, 206, .5)
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
    color: #2361ce;
    background-color: transparent
}

.btn-outline-warning {
    color: #fba918;
    border-color: #fba918
}

.btn-outline-warning:hover {
    color: #1f2937;
    background-color: #fba918;
    border-color: #fba918
}

.btn-check:focus + .btn-outline-warning,
.btn-outline-warning:focus {
    box-shadow: 0 0 0 .18rem rgba(251, 169, 24, .5)
}

.btn-check:active + .btn-outline-warning,
.btn-check:checked + .btn-outline-warning,
.btn-outline-warning.active,
.btn-outline-warning.dropdown-toggle.show,
.btn-outline-warning:active {
    color: #1f2937;
    background-color: #fba918;
    border-color: #fba918
}

.btn-check:active + .btn-outline-warning:focus,
.btn-check:checked + .btn-outline-warning:focus,
.btn-outline-warning.active:focus,
.btn-outline-warning.dropdown-toggle.show:focus,
.btn-outline-warning:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(251, 169, 24, .5)
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
    color: #fba918;
    background-color: transparent
}

.btn-outline-danger {
    color: #e11d48;
    border-color: #e11d48
}

.btn-outline-danger:hover {
    color: #fff;
    background-color: #e11d48;
    border-color: #e11d48
}

.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .5)
}

.btn-check:active + .btn-outline-danger,
.btn-check:checked + .btn-outline-danger,
.btn-outline-danger.active,
.btn-outline-danger.dropdown-toggle.show,
.btn-outline-danger:active {
    color: #fff;
    background-color: #e11d48;
    border-color: #e11d48
}

.btn-check:active + .btn-outline-danger:focus,
.btn-check:checked + .btn-outline-danger:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus,
.btn-outline-danger:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(225, 29, 72, .5)
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
    color: #e11d48;
    background-color: transparent
}

.btn-outline-white {
    color: #fff;
    border-color: #fff
}

.btn-outline-white:hover {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff
}

.btn-check:focus + .btn-outline-white,
.btn-outline-white:focus {
    box-shadow: 0 0 0 .18rem rgba(255, 255, 255, .5)
}

.btn-check:active + .btn-outline-white,
.btn-check:checked + .btn-outline-white,
.btn-outline-white.active,
.btn-outline-white.dropdown-toggle.show,
.btn-outline-white:active {
    color: #1f2937;
    background-color: #fff;
    border-color: #fff
}

.btn-check:active + .btn-outline-white:focus,
.btn-check:checked + .btn-outline-white:focus,
.btn-outline-white.active:focus,
.btn-outline-white.dropdown-toggle.show:focus,
.btn-outline-white:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(255, 255, 255, .5)
}

.btn-outline-white.disabled,
.btn-outline-white:disabled {
    color: #fff;
    background-color: transparent
}

.btn-outline-indigo {
    color: #4f46e5;
    border-color: #4f46e5
}

.btn-outline-indigo:hover {
    color: #fff;
    background-color: #4f46e5;
    border-color: #4f46e5
}

.btn-check:focus + .btn-outline-indigo,
.btn-outline-indigo:focus {
    box-shadow: 0 0 0 .18rem rgba(79, 70, 229, .5)
}

.btn-check:active + .btn-outline-indigo,
.btn-check:checked + .btn-outline-indigo,
.btn-outline-indigo.active,
.btn-outline-indigo.dropdown-toggle.show,
.btn-outline-indigo:active {
    color: #fff;
    background-color: #4f46e5;
    border-color: #4f46e5
}

.btn-check:active + .btn-outline-indigo:focus,
.btn-check:checked + .btn-outline-indigo:focus,
.btn-outline-indigo.active:focus,
.btn-outline-indigo.dropdown-toggle.show:focus,
.btn-outline-indigo:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(79, 70, 229, .5)
}

.btn-outline-indigo.disabled,
.btn-outline-indigo:disabled {
    color: #4f46e5;
    background-color: transparent
}

.btn-outline-purple {
    color: #7c3aed;
    border-color: #7c3aed
}

.btn-outline-purple:hover {
    color: #fff;
    background-color: #7c3aed;
    border-color: #7c3aed
}

.btn-check:focus + .btn-outline-purple,
.btn-outline-purple:focus {
    box-shadow: 0 0 0 .18rem rgba(124, 58, 237, .5)
}

.btn-check:active + .btn-outline-purple,
.btn-check:checked + .btn-outline-purple,
.btn-outline-purple.active,
.btn-outline-purple.dropdown-toggle.show,
.btn-outline-purple:active {
    color: #fff;
    background-color: #7c3aed;
    border-color: #7c3aed
}

.btn-check:active + .btn-outline-purple:focus,
.btn-check:checked + .btn-outline-purple:focus,
.btn-outline-purple.active:focus,
.btn-outline-purple.dropdown-toggle.show:focus,
.btn-outline-purple:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(124, 58, 237, .5)
}

.btn-outline-purple.disabled,
.btn-outline-purple:disabled {
    color: #7c3aed;
    background-color: transparent
}

.btn-outline-yellow-100 {
    color: #ffeed6;
    border-color: #ffeed6
}

.btn-outline-yellow-100:hover {
    color: #1f2937;
    background-color: #ffeed6;
    border-color: #ffeed6
}

.btn-check:focus + .btn-outline-yellow-100,
.btn-outline-yellow-100:focus {
    box-shadow: 0 0 0 .18rem rgba(255, 238, 214, .5)
}

.btn-check:active + .btn-outline-yellow-100,
.btn-check:checked + .btn-outline-yellow-100,
.btn-outline-yellow-100.active,
.btn-outline-yellow-100.dropdown-toggle.show,
.btn-outline-yellow-100:active {
    color: #1f2937;
    background-color: #ffeed6;
    border-color: #ffeed6
}

.btn-check:active + .btn-outline-yellow-100:focus,
.btn-check:checked + .btn-outline-yellow-100:focus,
.btn-outline-yellow-100.active:focus,
.btn-outline-yellow-100.dropdown-toggle.show:focus,
.btn-outline-yellow-100:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(255, 238, 214, .5)
}

.btn-outline-yellow-100.disabled,
.btn-outline-yellow-100:disabled {
    color: #ffeed6;
    background-color: transparent
}

.btn-outline-yellow-200 {
    color: #f5dbb8;
    border-color: #f5dbb8
}

.btn-outline-yellow-200:hover {
    color: #1f2937;
    background-color: #f5dbb8;
    border-color: #f5dbb8
}

.btn-check:focus + .btn-outline-yellow-200,
.btn-outline-yellow-200:focus {
    box-shadow: 0 0 0 .18rem rgba(245, 219, 184, .5)
}

.btn-check:active + .btn-outline-yellow-200,
.btn-check:checked + .btn-outline-yellow-200,
.btn-outline-yellow-200.active,
.btn-outline-yellow-200.dropdown-toggle.show,
.btn-outline-yellow-200:active {
    color: #1f2937;
    background-color: #f5dbb8;
    border-color: #f5dbb8
}

.btn-check:active + .btn-outline-yellow-200:focus,
.btn-check:checked + .btn-outline-yellow-200:focus,
.btn-outline-yellow-200.active:focus,
.btn-outline-yellow-200.dropdown-toggle.show:focus,
.btn-outline-yellow-200:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(245, 219, 184, .5)
}

.btn-outline-yellow-200.disabled,
.btn-outline-yellow-200:disabled {
    color: #f5dbb8;
    background-color: transparent
}

.btn-outline-gray-50 {
    color: #f9fafb;
    border-color: #f9fafb
}

.btn-outline-gray-50:hover {
    color: #1f2937;
    background-color: #f9fafb;
    border-color: #f9fafb
}

.btn-check:focus + .btn-outline-gray-50,
.btn-outline-gray-50:focus {
    box-shadow: 0 0 0 .18rem rgba(249, 250, 251, .5)
}

.btn-check:active + .btn-outline-gray-50,
.btn-check:checked + .btn-outline-gray-50,
.btn-outline-gray-50.active,
.btn-outline-gray-50.dropdown-toggle.show,
.btn-outline-gray-50:active {
    color: #1f2937;
    background-color: #f9fafb;
    border-color: #f9fafb
}

.btn-check:active + .btn-outline-gray-50:focus,
.btn-check:checked + .btn-outline-gray-50:focus,
.btn-outline-gray-50.active:focus,
.btn-outline-gray-50.dropdown-toggle.show:focus,
.btn-outline-gray-50:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(249, 250, 251, .5)
}

.btn-outline-gray-50.disabled,
.btn-outline-gray-50:disabled {
    color: #f9fafb;
    background-color: transparent
}

.btn-outline-gray-100 {
    color: #f2f4f6;
    border-color: #f2f4f6
}

.btn-outline-gray-100:hover {
    color: #1f2937;
    background-color: #f2f4f6;
    border-color: #f2f4f6
}

.btn-check:focus + .btn-outline-gray-100,
.btn-outline-gray-100:focus {
    box-shadow: 0 0 0 .18rem rgba(242, 244, 246, .5)
}

.btn-check:active + .btn-outline-gray-100,
.btn-check:checked + .btn-outline-gray-100,
.btn-outline-gray-100.active,
.btn-outline-gray-100.dropdown-toggle.show,
.btn-outline-gray-100:active {
    color: #1f2937;
    background-color: #f2f4f6;
    border-color: #f2f4f6
}

.btn-check:active + .btn-outline-gray-100:focus,
.btn-check:checked + .btn-outline-gray-100:focus,
.btn-outline-gray-100.active:focus,
.btn-outline-gray-100.dropdown-toggle.show:focus,
.btn-outline-gray-100:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(242, 244, 246, .5)
}

.btn-outline-gray-100.disabled,
.btn-outline-gray-100:disabled {
    color: #f2f4f6;
    background-color: transparent
}

.btn-outline-gray-200 {
    color: #e5e7eb;
    border-color: #e5e7eb
}

.btn-outline-gray-200:hover {
    color: #1f2937;
    background-color: #e5e7eb;
    border-color: #e5e7eb
}

.btn-check:focus + .btn-outline-gray-200,
.btn-outline-gray-200:focus {
    box-shadow: 0 0 0 .18rem rgba(229, 231, 235, .5)
}

.btn-check:active + .btn-outline-gray-200,
.btn-check:checked + .btn-outline-gray-200,
.btn-outline-gray-200.active,
.btn-outline-gray-200.dropdown-toggle.show,
.btn-outline-gray-200:active {
    color: #1f2937;
    background-color: #e5e7eb;
    border-color: #e5e7eb
}

.btn-check:active + .btn-outline-gray-200:focus,
.btn-check:checked + .btn-outline-gray-200:focus,
.btn-outline-gray-200.active:focus,
.btn-outline-gray-200.dropdown-toggle.show:focus,
.btn-outline-gray-200:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(229, 231, 235, .5)
}

.btn-outline-gray-200.disabled,
.btn-outline-gray-200:disabled {
    color: #e5e7eb;
    background-color: transparent
}

.btn-outline-gray-300 {
    color: #d1d5db;
    border-color: #d1d5db
}

.btn-outline-gray-300:hover {
    color: #1f2937;
    background-color: #d1d5db;
    border-color: #d1d5db
}

.btn-check:focus + .btn-outline-gray-300,
.btn-outline-gray-300:focus {
    box-shadow: 0 0 0 .18rem rgba(209, 213, 219, .5)
}

.btn-check:active + .btn-outline-gray-300,
.btn-check:checked + .btn-outline-gray-300,
.btn-outline-gray-300.active,
.btn-outline-gray-300.dropdown-toggle.show,
.btn-outline-gray-300:active {
    color: #1f2937;
    background-color: #d1d5db;
    border-color: #d1d5db
}

.btn-check:active + .btn-outline-gray-300:focus,
.btn-check:checked + .btn-outline-gray-300:focus,
.btn-outline-gray-300.active:focus,
.btn-outline-gray-300.dropdown-toggle.show:focus,
.btn-outline-gray-300:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(209, 213, 219, .5)
}

.btn-outline-gray-300.disabled,
.btn-outline-gray-300:disabled {
    color: #d1d5db;
    background-color: transparent
}

.btn-outline-gray-400 {
    color: #9ca3af;
    border-color: #9ca3af
}

.btn-outline-gray-400:hover {
    color: #1f2937;
    background-color: #9ca3af;
    border-color: #9ca3af
}

.btn-check:focus + .btn-outline-gray-400,
.btn-outline-gray-400:focus {
    box-shadow: 0 0 0 .18rem rgba(156, 163, 175, .5)
}

.btn-check:active + .btn-outline-gray-400,
.btn-check:checked + .btn-outline-gray-400,
.btn-outline-gray-400.active,
.btn-outline-gray-400.dropdown-toggle.show,
.btn-outline-gray-400:active {
    color: #1f2937;
    background-color: #9ca3af;
    border-color: #9ca3af
}

.btn-check:active + .btn-outline-gray-400:focus,
.btn-check:checked + .btn-outline-gray-400:focus,
.btn-outline-gray-400.active:focus,
.btn-outline-gray-400.dropdown-toggle.show:focus,
.btn-outline-gray-400:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(156, 163, 175, .5)
}

.btn-outline-gray-400.disabled,
.btn-outline-gray-400:disabled {
    color: #9ca3af;
    background-color: transparent
}

.btn-outline-gray-500 {
    color: #6b7280;
    border-color: #6b7280
}

.btn-outline-gray-500:hover {
    color: #fff;
    background-color: #6b7280;
    border-color: #6b7280
}

.btn-check:focus + .btn-outline-gray-500,
.btn-outline-gray-500:focus {
    box-shadow: 0 0 0 .18rem rgba(107, 114, 128, .5)
}

.btn-check:active + .btn-outline-gray-500,
.btn-check:checked + .btn-outline-gray-500,
.btn-outline-gray-500.active,
.btn-outline-gray-500.dropdown-toggle.show,
.btn-outline-gray-500:active {
    color: #fff;
    background-color: #6b7280;
    border-color: #6b7280
}

.btn-check:active + .btn-outline-gray-500:focus,
.btn-check:checked + .btn-outline-gray-500:focus,
.btn-outline-gray-500.active:focus,
.btn-outline-gray-500.dropdown-toggle.show:focus,
.btn-outline-gray-500:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(107, 114, 128, .5)
}

.btn-outline-gray-500.disabled,
.btn-outline-gray-500:disabled {
    color: #6b7280;
    background-color: transparent
}

.btn-outline-gray-600 {
    color: #4b5563;
    border-color: #4b5563
}

.btn-outline-gray-600:hover {
    color: #fff;
    background-color: #4b5563;
    border-color: #4b5563
}

.btn-check:focus + .btn-outline-gray-600,
.btn-outline-gray-600:focus {
    box-shadow: 0 0 0 .18rem rgba(75, 85, 99, .5)
}

.btn-check:active + .btn-outline-gray-600,
.btn-check:checked + .btn-outline-gray-600,
.btn-outline-gray-600.active,
.btn-outline-gray-600.dropdown-toggle.show,
.btn-outline-gray-600:active {
    color: #fff;
    background-color: #4b5563;
    border-color: #4b5563
}

.btn-check:active + .btn-outline-gray-600:focus,
.btn-check:checked + .btn-outline-gray-600:focus,
.btn-outline-gray-600.active:focus,
.btn-outline-gray-600.dropdown-toggle.show:focus,
.btn-outline-gray-600:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(75, 85, 99, .5)
}

.btn-outline-gray-600.disabled,
.btn-outline-gray-600:disabled {
    color: #4b5563;
    background-color: transparent
}

.btn-outline-gray-700 {
    color: #374151;
    border-color: #374151
}

.btn-outline-gray-700:hover {
    color: #fff;
    background-color: #374151;
    border-color: #374151
}

.btn-check:focus + .btn-outline-gray-700,
.btn-outline-gray-700:focus {
    box-shadow: 0 0 0 .18rem rgba(55, 65, 81, .5)
}

.btn-check:active + .btn-outline-gray-700,
.btn-check:checked + .btn-outline-gray-700,
.btn-outline-gray-700.active,
.btn-outline-gray-700.dropdown-toggle.show,
.btn-outline-gray-700:active {
    color: #fff;
    background-color: #374151;
    border-color: #374151
}

.btn-check:active + .btn-outline-gray-700:focus,
.btn-check:checked + .btn-outline-gray-700:focus,
.btn-outline-gray-700.active:focus,
.btn-outline-gray-700.dropdown-toggle.show:focus,
.btn-outline-gray-700:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(55, 65, 81, .5)
}

.btn-outline-gray-700.disabled,
.btn-outline-gray-700:disabled {
    color: #374151;
    background-color: transparent
}

.btn-outline-gray-800 {
    color: #1f2937;
    border-color: #1f2937
}

.btn-outline-gray-800:hover {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-check:focus + .btn-outline-gray-800,
.btn-outline-gray-800:focus {
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .5)
}

.btn-check:active + .btn-outline-gray-800,
.btn-check:checked + .btn-outline-gray-800,
.btn-outline-gray-800.active,
.btn-outline-gray-800.dropdown-toggle.show,
.btn-outline-gray-800:active {
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.btn-check:active + .btn-outline-gray-800:focus,
.btn-check:checked + .btn-outline-gray-800:focus,
.btn-outline-gray-800.active:focus,
.btn-outline-gray-800.dropdown-toggle.show:focus,
.btn-outline-gray-800:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(31, 41, 55, .5)
}

.btn-outline-gray-800.disabled,
.btn-outline-gray-800:disabled {
    color: #1f2937;
    background-color: transparent
}

.btn-outline-gray-900 {
    color: #111827;
    border-color: #111827
}

.btn-outline-gray-900:hover {
    color: #fff;
    background-color: #111827;
    border-color: #111827
}

.btn-check:focus + .btn-outline-gray-900,
.btn-outline-gray-900:focus {
    box-shadow: 0 0 0 .18rem rgba(17, 24, 39, .5)
}

.btn-check:active + .btn-outline-gray-900,
.btn-check:checked + .btn-outline-gray-900,
.btn-outline-gray-900.active,
.btn-outline-gray-900.dropdown-toggle.show,
.btn-outline-gray-900:active {
    color: #fff;
    background-color: #111827;
    border-color: #111827
}

.btn-check:active + .btn-outline-gray-900:focus,
.btn-check:checked + .btn-outline-gray-900:focus,
.btn-outline-gray-900.active:focus,
.btn-outline-gray-900.dropdown-toggle.show:focus,
.btn-outline-gray-900:active:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(17, 24, 39, .5)
}

.btn-outline-gray-900.disabled,
.btn-outline-gray-900:disabled {
    color: #111827;
    background-color: transparent
}

.btn-link {
    font-weight: 400;
    color: #1f2937;
    text-decoration: none
}

.btn-link:hover {
    color: #000;
    text-decoration: none
}

.btn-link:focus {
    text-decoration: none
}

.btn-link.disabled,
.btn-link:disabled {
    color: #4b5563
}

.btn-group-lg > .btn,
.btn-lg {
    padding: .5rem 1rem;
    font-size: 1.25rem;
    border-radius: .5rem
}

.btn-group-sm > .btn,
.btn-sm {
    padding: .375rem .625rem;
    font-size: .875rem;
    border-radius: .5rem
}

.fade {
    transition: opacity .15s linear
}

@media (prefers-reduced-motion: reduce) {
    .fade {
        transition: none
    }
}

.fade:not(.show) {
    opacity: 0
}

.collapse:not(.show) {
    display: none
}

.collapsing {
    height: 0;
    overflow: hidden;
    transition: height .35s ease
}

@media (prefers-reduced-motion: reduce) {
    .collapsing {
        transition: none
    }
}

.dropdown,
.dropend,
.dropstart,
.dropup {
    position: relative
}

.dropdown-toggle {
    white-space: nowrap
}

.dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent
}

.dropdown-toggle:empty::after {
    margin-left: 0
}

.dropdown-menu {
    position: absolute;
    z-index: 1000;
    display: none;
    min-width: 12rem;
    padding: .5rem 0;
    margin: 0;
    font-size: .875rem;
    color: #374151;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: .0625rem solid #e5e7eb;
    border-radius: .35rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05)
}

.dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: .125rem
}

.dropdown-menu-start {
    --bs-position: start
}

.dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0
}

.dropdown-menu-end {
    --bs-position: end
}

.dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto
}

@media (min-width: 576px) {
    .dropdown-menu-sm-start {
        --bs-position: start
    }

    .dropdown-menu-sm-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-sm-end {
        --bs-position: end
    }

    .dropdown-menu-sm-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media (min-width: 768px) {
    .dropdown-menu-md-start {
        --bs-position: start
    }

    .dropdown-menu-md-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-md-end {
        --bs-position: end
    }

    .dropdown-menu-md-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media (min-width: 992px) {
    .dropdown-menu-lg-start {
        --bs-position: start
    }

    .dropdown-menu-lg-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-lg-end {
        --bs-position: end
    }

    .dropdown-menu-lg-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media (min-width: 1200px) {
    .dropdown-menu-xl-start {
        --bs-position: start
    }

    .dropdown-menu-xl-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-xl-end {
        --bs-position: end
    }

    .dropdown-menu-xl-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

@media (min-width: 1400px) {
    .dropdown-menu-xxl-start {
        --bs-position: start
    }

    .dropdown-menu-xxl-start[data-bs-popper] {
        right: auto;
        left: 0
    }

    .dropdown-menu-xxl-end {
        --bs-position: end
    }

    .dropdown-menu-xxl-end[data-bs-popper] {
        right: 0;
        left: auto
    }
}

.dropup .dropdown-menu[data-bs-popper] {
    top: auto;
    bottom: 100%;
    margin-top: 0;
    margin-bottom: .125rem
}

.dropup .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: 0;
    border-right: .3em solid transparent;
    border-bottom: .3em solid;
    border-left: .3em solid transparent
}

.dropup .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropend .dropdown-menu[data-bs-popper] {
    top: 0;
    right: auto;
    left: 100%;
    margin-top: 0;
    margin-left: .125rem
}

.dropend .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid transparent;
    border-right: 0;
    border-bottom: .3em solid transparent;
    border-left: .3em solid
}

.dropend .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropend .dropdown-toggle::after {
    vertical-align: 0
}

.dropstart .dropdown-menu[data-bs-popper] {
    top: 0;
    right: 100%;
    left: auto;
    margin-top: 0;
    margin-right: .125rem
}

.dropstart .dropdown-toggle::after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: ""
}

.dropstart .dropdown-toggle::after {
    display: none
}

.dropstart .dropdown-toggle::before {
    display: inline-block;
    margin-right: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid transparent;
    border-right: .3em solid;
    border-bottom: .3em solid transparent
}

.dropstart .dropdown-toggle:empty::after {
    margin-left: 0
}

.dropstart .dropdown-toggle::before {
    vertical-align: 0
}

.dropdown-divider {
    height: 0;
    margin: .5rem 0;
    overflow: hidden;
    border-top: 1px solid #e5e7eb
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: .25rem 1rem;
    clear: both;
    font-weight: 400;
    color: #111827;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0
}

.dropdown-item:focus,
.dropdown-item:hover {
    color: #090d15;
    background-color: #f2f4f6
}

.dropdown-item.active,
.dropdown-item:active {
    color: #111827;
    text-decoration: none;
    background-color: #e5e7eb
}

.dropdown-item.disabled,
.dropdown-item:disabled {
    color: #4b5563;
    pointer-events: none;
    background-color: transparent
}

.dropdown-menu.show {
    display: block
}

.dropdown-header {
    display: block;
    padding: .5rem 1rem;
    margin-bottom: 0;
    font-size: .875rem;
    color: #111827;
    white-space: nowrap
}

.dropdown-item-text {
    display: block;
    padding: .25rem 1rem;
    color: #111827
}

.dropdown-menu-dark {
    color: #d1d5db;
    background-color: #1f2937;
    border-color: #e5e7eb
}

.dropdown-menu-dark .dropdown-item {
    color: #d1d5db
}

.dropdown-menu-dark .dropdown-item:focus,
.dropdown-menu-dark .dropdown-item:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, .15)
}

.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
    color: #111827;
    background-color: #e5e7eb
}

.dropdown-menu-dark .dropdown-item.disabled,
.dropdown-menu-dark .dropdown-item:disabled {
    color: #6b7280
}

.dropdown-menu-dark .dropdown-divider {
    border-color: #e5e7eb
}

.dropdown-menu-dark .dropdown-item-text {
    color: #d1d5db
}

.dropdown-menu-dark .dropdown-header {
    color: #6b7280
}

.btn-group,
.btn-group-vertical {
    position: relative;
    display: inline-flex;
    vertical-align: middle
}

.btn-group-vertical > .btn,
.btn-group > .btn {
    position: relative;
    flex: 1 1 auto
}

.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn.active,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:hover,
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn.active,
.btn-group > .btn:active,
.btn-group > .btn:focus,
.btn-group > .btn:hover {
    z-index: 1
}

.btn-toolbar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start
}

.btn-toolbar .input-group {
    width: auto
}

.btn-group > .btn-group:not(:first-child),
.btn-group > .btn:not(:first-child) {
    margin-left: -.0625rem
}

.btn-group > .btn-group:not(:last-child) > .btn,
.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0
}

.btn-group > .btn-group:not(:first-child) > .btn,
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0
}

.dropdown-toggle-split {
    padding-right: .75rem;
    padding-left: .75rem
}

.dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after {
    margin-left: 0
}

.dropstart .dropdown-toggle-split::before {
    margin-right: 0
}

.btn-group-sm > .btn + .dropdown-toggle-split,
.btn-sm + .dropdown-toggle-split {
    padding-right: .46875rem;
    padding-left: .46875rem
}

.btn-group-lg > .btn + .dropdown-toggle-split,
.btn-lg + .dropdown-toggle-split {
    padding-right: .75rem;
    padding-left: .75rem
}

.btn-group.show .dropdown-toggle {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125)
}

.btn-group.show .dropdown-toggle.btn-link {
    box-shadow: none
}

.btn-group-vertical {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
    width: 100%
}

.btn-group-vertical > .btn-group:not(:first-child),
.btn-group-vertical > .btn:not(:first-child) {
    margin-top: -.0625rem
}

.btn-group-vertical > .btn-group:not(:last-child) > .btn,
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0
}

.btn-group-vertical > .btn-group:not(:first-child) > .btn,
.btn-group-vertical > .btn ~ .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav {
    display: flex;
    flex-wrap: wrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.nav-link {
    display: block;
    padding: .5rem 1rem;
    color: #1f2937;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .nav-link {
        transition: none
    }
}

.nav-link:focus,
.nav-link:hover {
    color: #1f2937
}

.nav-link.disabled {
    color: #4b5563;
    pointer-events: none;
    cursor: default
}

.nav-tabs {
    border-bottom: .0625rem solid #9ca3af
}

.nav-tabs .nav-link {
    margin-bottom: -.0625rem;
    background: 0 0;
    border: .0625rem solid transparent;
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
    border-color: #e5e7eb #e5e7eb #9ca3af;
    isolation: isolate
}

.nav-tabs .nav-link.disabled {
    color: #4b5563;
    background-color: transparent;
    border-color: transparent
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
    color: #374151;
    background-color: #9ca3af;
    border-color: #9ca3af
}

.nav-tabs .dropdown-menu {
    margin-top: -.0625rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0
}

.nav-pills .nav-link {
    background: 0 0;
    border: 0;
    border-radius: .5rem
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: #1f2937;
    background-color: #f8f8f8
}

.nav-fill .nav-item,
.nav-fill > .nav-link {
    flex: 1 1 auto;
    text-align: center
}

.nav-justified .nav-item,
.nav-justified > .nav-link {
    flex-basis: 0;
    flex-grow: 1;
    text-align: center
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
    width: 100%
}

.tab-content > .tab-pane {
    display: none
}

.tab-content > .active {
    display: block
}

.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding-top: 1rem;
    padding-bottom: 1rem
}

.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-lg,
.navbar > .container-md,
.navbar > .container-sm,
.navbar > .container-xl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between
}

.navbar-brand {
    padding-top: 0;
    padding-bottom: 0;
    margin-right: 1rem;
    font-size: 1.25rem;
    white-space: nowrap
}

.navbar-nav {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none
}

.navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0
}

.navbar-nav .dropdown-menu {
    position: static
}

.navbar-text {
    padding-top: .5rem;
    padding-bottom: .5rem
}

.navbar-collapse {
    flex-basis: 100%;
    flex-grow: 1;
    align-items: center
}

.navbar-toggler {
    padding: .4rem .6rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: .0625rem solid transparent;
    border-radius: .5rem;
    transition: box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
        transition: none
    }
}

.navbar-toggler:hover {
    text-decoration: none
}

.navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 .18rem
}

.navbar-toggler-icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%
}

.navbar-nav-scroll {
    max-height: var(--bs-scroll-height, 75vh);
    overflow-y: auto
}

@media (min-width: 576px) {
    .navbar-expand-sm {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-sm .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: .8rem;
        padding-left: .8rem
    }

    .navbar-expand-sm .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-sm .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-sm .navbar-toggler {
        display: none
    }
}

@media (min-width: 768px) {
    .navbar-expand-md {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-md .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-md .navbar-nav .nav-link {
        padding-right: .8rem;
        padding-left: .8rem
    }

    .navbar-expand-md .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-md .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-md .navbar-toggler {
        display: none
    }
}

@media (min-width: 992px) {
    .navbar-expand-lg {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-lg .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: .8rem;
        padding-left: .8rem
    }

    .navbar-expand-lg .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-lg .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-lg .navbar-toggler {
        display: none
    }
}

@media (min-width: 1200px) {
    .navbar-expand-xl {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-xl .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: .8rem;
        padding-left: .8rem
    }

    .navbar-expand-xl .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-xl .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-xl .navbar-toggler {
        display: none
    }
}

@media (min-width: 1400px) {
    .navbar-expand-xxl {
        flex-wrap: nowrap;
        justify-content: flex-start
    }

    .navbar-expand-xxl .navbar-nav {
        flex-direction: row
    }

    .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute
    }

    .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: .8rem;
        padding-left: .8rem
    }

    .navbar-expand-xxl .navbar-nav-scroll {
        overflow: visible
    }

    .navbar-expand-xxl .navbar-collapse {
        display: flex !important;
        flex-basis: auto
    }

    .navbar-expand-xxl .navbar-toggler {
        display: none
    }
}

.navbar-expand {
    flex-wrap: nowrap;
    justify-content: flex-start
}

.navbar-expand .navbar-nav {
    flex-direction: row
}

.navbar-expand .navbar-nav .dropdown-menu {
    position: absolute
}

.navbar-expand .navbar-nav .nav-link {
    padding-right: .8rem;
    padding-left: .8rem
}

.navbar-expand .navbar-nav-scroll {
    overflow: visible
}

.navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto
}

.navbar-expand .navbar-toggler {
    display: none
}

.navbar-light .navbar-brand {
    color: #111827
}

.navbar-light .navbar-brand:focus,
.navbar-light .navbar-brand:hover {
    color: #111827
}

.navbar-light .navbar-nav .nav-link {
    color: rgba(17, 24, 39, .9)
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
    color: #111827
}

.navbar-light .navbar-nav .nav-link.disabled {
    color: rgba(17, 24, 39, .9)
}

.navbar-light .navbar-nav .nav-link.active,
.navbar-light .navbar-nav .show > .nav-link {
    color: #111827
}

.navbar-light .navbar-toggler {
    color: rgba(17, 24, 39, .9);
    border-color: rgba(17, 24, 39, .1)
}

.navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
}

.navbar-light .navbar-text {
    color: rgba(17, 24, 39, .9)
}

.navbar-light .navbar-text a,
.navbar-light .navbar-text a:focus,
.navbar-light .navbar-text a:hover {
    color: #111827
}

.navbar-dark .navbar-brand {
    color: #fff
}

.navbar-dark .navbar-brand:focus,
.navbar-dark .navbar-brand:hover {
    color: #fff
}

.navbar-dark .navbar-nav .nav-link {
    color: rgba(255, 255, 255, .9)
}

.navbar-dark .navbar-nav .nav-link:focus,
.navbar-dark .navbar-nav .nav-link:hover {
    color: #fff
}

.navbar-dark .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, .9)
}

.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .show > .nav-link {
    color: #fff
}

.navbar-dark .navbar-toggler {
    color: rgba(255, 255, 255, .9);
    border-color: rgba(255, 255, 255, .1)
}

.navbar-dark .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
}

.navbar-dark .navbar-text {
    color: rgba(255, 255, 255, .9)
}

.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:focus,
.navbar-dark .navbar-text a:hover {
    color: #fff
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: .0625rem solid rgba(17, 24, 39, .125);
    border-radius: .5rem
}

.card > hr {
    margin-right: 0;
    margin-left: 0
}

.card > .list-group {
    border-top: inherit;
    border-bottom: inherit
}

.card > .list-group:first-child {
    border-top-width: 0;
    border-top-left-radius: .4375rem;
    border-top-right-radius: .4375rem
}

.card > .list-group:last-child {
    border-bottom-width: 0;
    border-bottom-right-radius: .4375rem;
    border-bottom-left-radius: .4375rem
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
    border-top: 0
}

.card-body {
    flex: 1 1 auto;
    padding: 1.25rem 1.5rem
}

.card-title {
    margin-bottom: .875rem
}

.card-subtitle {
    margin-top: -.4375rem;
    margin-bottom: 0
}

.card-text:last-child {
    margin-bottom: 0
}

.card-link:hover {
    text-decoration: none
}

.card-link + .card-link {
    margin-left: 1.5rem
}

.card-header {
    padding: 1.25rem 1.5rem;
    margin-bottom: 0;
    background-color: rgba(17, 24, 39, .03);
    border-bottom: .0625rem solid rgba(17, 24, 39, .125)
}

.card-header:first-child {
    border-radius: .4375rem .4375rem 0 0
}

.card-footer {
    padding: 1.25rem 1.5rem;
    background-color: rgba(17, 24, 39, .03);
    border-top: .0625rem solid rgba(17, 24, 39, .125)
}

.card-footer:last-child {
    border-radius: 0 0 .4375rem .4375rem
}

.card-header-tabs {
    margin-right: -.75rem;
    margin-bottom: -1.25rem;
    margin-left: -.75rem;
    border-bottom: 0
}

.card-header-tabs .nav-link.active {
    background-color: #fff;
    border-bottom-color: #fff
}

.card-header-pills {
    margin-right: -.75rem;
    margin-left: -.75rem
}

.card-img-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 1rem;
    border-radius: .4375rem
}

.card-img,
.card-img-bottom,
.card-img-top {
    width: 100%
}

.card-img,
.card-img-top {
    border-top-left-radius: .4375rem;
    border-top-right-radius: .4375rem
}

.card-img,
.card-img-bottom {
    border-bottom-right-radius: .4375rem;
    border-bottom-left-radius: .4375rem
}

.card-group > .card {
    margin-bottom: .75rem
}

@media (min-width: 576px) {
    .card-group {
        display: flex;
        flex-flow: row wrap
    }

    .card-group > .card {
        flex: 1 0;
        margin-bottom: 0
    }

    .card-group > .card + .card {
        margin-left: 0;
        border-left: 0
    }

    .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0
    }

    .card-group > .card:not(:last-child) .card-header,
    .card-group > .card:not(:last-child) .card-img-top {
        border-top-right-radius: 0
    }

    .card-group > .card:not(:last-child) .card-footer,
    .card-group > .card:not(:last-child) .card-img-bottom {
        border-bottom-right-radius: 0
    }

    .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0
    }

    .card-group > .card:not(:first-child) .card-header,
    .card-group > .card:not(:first-child) .card-img-top {
        border-top-left-radius: 0
    }

    .card-group > .card:not(:first-child) .card-footer,
    .card-group > .card:not(:first-child) .card-img-bottom {
        border-bottom-left-radius: 0
    }
}

.accordion-button {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 1rem 1.25rem;
    font-size: 1rem;
    color: #374151;
    text-align: left;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    overflow-anchor: none;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, border-radius .15s ease
}

@media (prefers-reduced-motion: reduce) {
    .accordion-button {
        transition: none
    }
}

.accordion-button:not(.collapsed) {
    color: #4b5563;
    background-color: #f2f4f6;
    box-shadow: inset 0 -.0625rem 0 #e5e7eb
}

.accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    transform: rotate(180deg)
}

.accordion-button::after {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-left: auto;
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform .2s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .accordion-button::after {
        transition: none
    }
}

.accordion-button:hover {
    z-index: 2
}

.accordion-button:focus {
    z-index: 3;
    border-color: #4d6689;
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.accordion-header {
    margin-bottom: 0
}

.accordion-item {
    background-color: transparent;
    border: .0625rem solid #e5e7eb
}

.accordion-item:first-of-type {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem
}

.accordion-item:first-of-type .accordion-button {
    border-top-left-radius: .4375rem;
    border-top-right-radius: .4375rem
}

.accordion-item:not(:first-of-type) {
    border-top: 0
}

.accordion-item:last-of-type {
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem
}

.accordion-item:last-of-type .accordion-button.collapsed {
    border-bottom-right-radius: .4375rem;
    border-bottom-left-radius: .4375rem
}

.accordion-item:last-of-type .accordion-collapse {
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem
}

.accordion-body {
    padding: 1rem 1.25rem
}

.accordion-flush .accordion-collapse {
    border-width: 0
}

.accordion-flush .accordion-item {
    border-right: 0;
    border-left: 0;
    border-radius: 0
}

.accordion-flush .accordion-item:first-child {
    border-top: 0
}

.accordion-flush .accordion-item:last-child {
    border-bottom: 0
}

.accordion-flush .accordion-item .accordion-button {
    border-radius: 0
}

.breadcrumb {
    display: flex;
    flex-wrap: wrap;
    padding: .5rem 1rem;
    margin-bottom: 1rem;
    list-style: none;
    background-color: #e5e7eb;
    border-radius: .5rem
}

.breadcrumb-item + .breadcrumb-item {
    padding-left: .5rem
}

.breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: .5rem;
    color: #4b5563;
    content: var(--bs-breadcrumb-divider, "/")
}

.breadcrumb-item.active {
    color: #4b5563
}

.pagination {
    display: flex;
    padding-left: 0;
    list-style: none
}

.page-link {
    position: relative;
    display: block;
    color: #1f2937;
    background-color: #fff;
    border: .0625rem solid #9ca3af;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .page-link {
        transition: none
    }
}

.page-link:hover {
    z-index: 2;
    color: #000;
    background-color: #e5e7eb;
    border-color: #d1d5db
}

.page-link:focus {
    z-index: 3;
    color: #000;
    background-color: #e5e7eb;
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.page-item:not(:first-child) .page-link {
    margin-left: -.0625rem
}

.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.page-item.disabled .page-link {
    color: #4b5563;
    pointer-events: none;
    background-color: #fff;
    border-color: #d1d5db
}

.page-link {
    padding: .375rem .75rem
}

.page-item:first-child .page-link {
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem
}

.page-item:last-child .page-link {
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem
}

.pagination-lg .page-link {
    padding: .75rem 1.5rem;
    font-size: 1.25rem
}

.pagination-lg .page-item:first-child .page-link {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem
}

.pagination-lg .page-item:last-child .page-link {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem
}

.pagination-sm .page-link {
    padding: .25rem .5rem;
    font-size: .875rem
}

.pagination-sm .page-item:first-child .page-link {
    border-top-left-radius: .35rem;
    border-bottom-left-radius: .35rem
}

.pagination-sm .page-item:last-child .page-link {
    border-top-right-radius: .35rem;
    border-bottom-right-radius: .35rem
}

.badge {
    display: inline-block;
    padding: .2rem .4rem;
    font-size: .75em;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .5rem
}

.badge:empty {
    display: none
}

.btn .badge {
    position: relative;
    top: -1px
}

.alert {
    position: relative;
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    border: .0625rem solid transparent;
    border-radius: .5rem
}

.alert-heading {
    color: inherit
}

.alert-link {
    font-weight: 500
}

.alert-dismissible {
    padding-right: 3rem
}

.alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1.25rem 1rem
}

.alert-primary {
    color: #131921;
    background-color: #d2d4d7;
    border-color: #bcbfc3
}

.alert-primary .alert-link {
    color: #0f141a
}

.alert-secondary {
    color: #907146;
    background-color: #fcf2e3;
    border-color: #fbebd5
}

.alert-secondary .alert-link {
    color: #735a38
}

.alert-tertiary {
    color: #1d1d40;
    background-color: #d6d6e1;
    border-color: #c1c1d2
}

.alert-tertiary .alert-link {
    color: #171733
}

.alert-success {
    color: #0a6f4d;
    background-color: #cff1e6;
    border-color: #b7ead9
}

.alert-success .alert-link {
    color: #08593e
}

.alert-info {
    color: #153a7c;
    background-color: #d3dff5;
    border-color: #bdd0f0
}

.alert-info .alert-link {
    color: #112e63
}

.alert-warning {
    color: #97650e;
    background-color: #feeed1;
    border-color: #fee5ba
}

.alert-warning .alert-link {
    color: #79510b
}

.alert-danger {
    color: #87112b;
    background-color: #f9d2da;
    border-color: #f6bbc8
}

.alert-danger .alert-link {
    color: #6c0e22
}

.alert-white {
    color: #797f87;
    background-color: #fff;
    border-color: #fff
}

.alert-white .alert-link {
    color: #61666c
}

.alert-indigo {
    color: #2f2a89;
    background-color: #dcdafa;
    border-color: #cac8f7
}

.alert-indigo .alert-link {
    color: #26226e
}

.alert-purple {
    color: #4a238e;
    background-color: #e5d8fb;
    border-color: #d8c4fa
}

.alert-purple .alert-link {
    color: #3b1c72
}

.alert-yellow-100 {
    color: #998f80;
    background-color: #fffcf7;
    border-color: #fffaf3
}

.alert-yellow-100 .alert-link {
    color: #7a7266
}

.alert-yellow-200 {
    color: #93836e;
    background-color: #fdf8f1;
    border-color: #fcf4ea
}

.alert-yellow-200 .alert-link {
    color: #766958
}

.alert-gray-50 {
    color: #767d85;
    background-color: #fefefe;
    border-color: #fdfefe
}

.alert-gray-50 .alert-link {
    color: #5e646a
}

.alert-gray-100 {
    color: #919294;
    background-color: #fcfdfd;
    border-color: #fbfcfc
}

.alert-gray-100 .alert-link {
    color: #747576
}

.alert-gray-200 {
    color: #898b8d;
    background-color: #fafafb;
    border-color: #f7f8f9
}

.alert-gray-200 .alert-link {
    color: #6e6f71
}

.alert-gray-300 {
    color: #7d8083;
    background-color: #f6f7f8;
    border-color: #f1f2f4
}

.alert-gray-300 .alert-link {
    color: #646669
}

.alert-gray-400 {
    color: #5e6269;
    background-color: #ebedef;
    border-color: #e1e3e7
}

.alert-gray-400 .alert-link {
    color: #4b4e54
}

.alert-gray-500 {
    color: #40444d;
    background-color: #e1e3e6;
    border-color: #d3d5d9
}

.alert-gray-500 .alert-link {
    color: #33363e
}

.alert-gray-600 {
    color: #2d333b;
    background-color: #dbdde0;
    border-color: #c9ccd0
}

.alert-gray-600 .alert-link {
    color: #24292f
}

.alert-gray-700 {
    color: #212731;
    background-color: #d7d9dc;
    border-color: #c3c6cb
}

.alert-gray-700 .alert-link {
    color: #1a1f27
}

.alert-gray-800 {
    color: #131921;
    background-color: #d2d4d7;
    border-color: #bcbfc3
}

.alert-gray-800 .alert-link {
    color: #0f141a
}

.alert-gray-900 {
    color: #0a0e17;
    background-color: #cfd1d4;
    border-color: #b8babe
}

.alert-gray-900 .alert-link {
    color: #080b12
}

@keyframes progress-bar-stripes {
    0% {
        background-position-x: 1rem
    }
}

.progress {
    display: flex;
    height: 1rem;
    overflow: hidden;
    font-size: .75rem;
    background-color: #e5e7eb;
    border-radius: .5rem;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)
}

.progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #1f2937;
    transition: width .6s ease
}

@media (prefers-reduced-motion: reduce) {
    .progress-bar {
        transition: none
    }
}

.progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem
}

.progress-bar-animated {
    animation: 1s linear infinite progress-bar-stripes
}

@media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
        animation: none
    }
}

.list-group {
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 0;
    border-radius: .5rem
}

.list-group-numbered {
    list-style-type: none;
    counter-reset: section
}

.list-group-numbered > li::before {
    content: counters(section, ".") ". ";
    counter-increment: section
}

.list-group-item-action {
    width: 100%;
    color: #374151;
    text-align: inherit
}

.list-group-item-action:focus,
.list-group-item-action:hover {
    z-index: 1;
    color: #374151;
    text-decoration: none;
    background-color: #f2f4f6
}

.list-group-item-action:active {
    color: #374151;
    background-color: #e5e7eb
}

.list-group-item {
    position: relative;
    display: block;
    padding: .5rem 1rem;
    color: #374151;
    background-color: #fff;
    border: .0625rem solid rgba(17, 24, 39, .125)
}

.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit
}

.list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit
}

.list-group-item.disabled,
.list-group-item:disabled {
    color: #4b5563;
    pointer-events: none;
    background-color: #fff
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.list-group-item + .list-group-item {
    border-top-width: 0
}

.list-group-item + .list-group-item.active {
    margin-top: -.0625rem;
    border-top-width: .0625rem
}

.list-group-horizontal {
    flex-direction: row
}

.list-group-horizontal > .list-group-item:first-child {
    border-bottom-left-radius: .5rem;
    border-top-right-radius: 0
}

.list-group-horizontal > .list-group-item:last-child {
    border-top-right-radius: .5rem;
    border-bottom-left-radius: 0
}

.list-group-horizontal > .list-group-item.active {
    margin-top: 0
}

.list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: .0625rem;
    border-left-width: 0
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
    margin-left: -.0625rem;
    border-left-width: .0625rem
}

@media (min-width: 576px) {
    .list-group-horizontal-sm {
        flex-direction: row
    }

    .list-group-horizontal-sm > .list-group-item:first-child {
        border-bottom-left-radius: .5rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-sm > .list-group-item:last-child {
        border-top-right-radius: .5rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-sm > .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-top-width: .0625rem;
        border-left-width: 0
    }

    .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: -.0625rem;
        border-left-width: .0625rem
    }
}

@media (min-width: 768px) {
    .list-group-horizontal-md {
        flex-direction: row
    }

    .list-group-horizontal-md > .list-group-item:first-child {
        border-bottom-left-radius: .5rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-md > .list-group-item:last-child {
        border-top-right-radius: .5rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-md > .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-top-width: .0625rem;
        border-left-width: 0
    }

    .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: -.0625rem;
        border-left-width: .0625rem
    }
}

@media (min-width: 992px) {
    .list-group-horizontal-lg {
        flex-direction: row
    }

    .list-group-horizontal-lg > .list-group-item:first-child {
        border-bottom-left-radius: .5rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-lg > .list-group-item:last-child {
        border-top-right-radius: .5rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-lg > .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-top-width: .0625rem;
        border-left-width: 0
    }

    .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: -.0625rem;
        border-left-width: .0625rem
    }
}

@media (min-width: 1200px) {
    .list-group-horizontal-xl {
        flex-direction: row
    }

    .list-group-horizontal-xl > .list-group-item:first-child {
        border-bottom-left-radius: .5rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-xl > .list-group-item:last-child {
        border-top-right-radius: .5rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xl > .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-top-width: .0625rem;
        border-left-width: 0
    }

    .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: -.0625rem;
        border-left-width: .0625rem
    }
}

@media (min-width: 1400px) {
    .list-group-horizontal-xxl {
        flex-direction: row
    }

    .list-group-horizontal-xxl > .list-group-item:first-child {
        border-bottom-left-radius: .5rem;
        border-top-right-radius: 0
    }

    .list-group-horizontal-xxl > .list-group-item:last-child {
        border-top-right-radius: .5rem;
        border-bottom-left-radius: 0
    }

    .list-group-horizontal-xxl > .list-group-item.active {
        margin-top: 0
    }

    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
        border-top-width: .0625rem;
        border-left-width: 0
    }

    .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: -.0625rem;
        border-left-width: .0625rem
    }
}

.list-group-flush {
    border-radius: 0
}

.list-group-flush > .list-group-item {
    border-width: 0 0 .0625rem
}

.list-group-flush > .list-group-item:last-child {
    border-bottom-width: 0
}

.list-group-item-primary {
    color: #131921;
    background-color: #d2d4d7
}

.list-group-item-primary.list-group-item-action:focus,
.list-group-item-primary.list-group-item-action:hover {
    color: #131921;
    background-color: #bdbfc2
}

.list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #131921;
    border-color: #131921
}

.list-group-item-secondary {
    color: #907146;
    background-color: #fcf2e3
}

.list-group-item-secondary.list-group-item-action:focus,
.list-group-item-secondary.list-group-item-action:hover {
    color: #907146;
    background-color: #e3dacc
}

.list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #907146;
    border-color: #907146
}

.list-group-item-tertiary {
    color: #1d1d40;
    background-color: #d6d6e1
}

.list-group-item-tertiary.list-group-item-action:focus,
.list-group-item-tertiary.list-group-item-action:hover {
    color: #1d1d40;
    background-color: #c1c1cb
}

.list-group-item-tertiary.list-group-item-action.active {
    color: #fff;
    background-color: #1d1d40;
    border-color: #1d1d40
}

.list-group-item-success {
    color: #0a6f4d;
    background-color: #cff1e6
}

.list-group-item-success.list-group-item-action:focus,
.list-group-item-success.list-group-item-action:hover {
    color: #0a6f4d;
    background-color: #bad9cf
}

.list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #0a6f4d;
    border-color: #0a6f4d
}

.list-group-item-info {
    color: #153a7c;
    background-color: #d3dff5
}

.list-group-item-info.list-group-item-action:focus,
.list-group-item-info.list-group-item-action:hover {
    color: #153a7c;
    background-color: #bec9dd
}

.list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #153a7c;
    border-color: #153a7c
}

.list-group-item-warning {
    color: #97650e;
    background-color: #feeed1
}

.list-group-item-warning.list-group-item-action:focus,
.list-group-item-warning.list-group-item-action:hover {
    color: #97650e;
    background-color: #e5d6bc
}

.list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #97650e;
    border-color: #97650e
}

.list-group-item-danger {
    color: #87112b;
    background-color: #f9d2da
}

.list-group-item-danger.list-group-item-action:focus,
.list-group-item-danger.list-group-item-action:hover {
    color: #87112b;
    background-color: #e0bdc4
}

.list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #87112b;
    border-color: #87112b
}

.list-group-item-white {
    color: #797f87;
    background-color: #fff
}

.list-group-item-white.list-group-item-action:focus,
.list-group-item-white.list-group-item-action:hover {
    color: #797f87;
    background-color: #e6e6e6
}

.list-group-item-white.list-group-item-action.active {
    color: #fff;
    background-color: #797f87;
    border-color: #797f87
}

.list-group-item-indigo {
    color: #2f2a89;
    background-color: #dcdafa
}

.list-group-item-indigo.list-group-item-action:focus,
.list-group-item-indigo.list-group-item-action:hover {
    color: #2f2a89;
    background-color: #c6c4e1
}

.list-group-item-indigo.list-group-item-action.active {
    color: #fff;
    background-color: #2f2a89;
    border-color: #2f2a89
}

.list-group-item-purple {
    color: #4a238e;
    background-color: #e5d8fb
}

.list-group-item-purple.list-group-item-action:focus,
.list-group-item-purple.list-group-item-action:hover {
    color: #4a238e;
    background-color: #cec2e2
}

.list-group-item-purple.list-group-item-action.active {
    color: #fff;
    background-color: #4a238e;
    border-color: #4a238e
}

.list-group-item-yellow-100 {
    color: #998f80;
    background-color: #fffcf7
}

.list-group-item-yellow-100.list-group-item-action:focus,
.list-group-item-yellow-100.list-group-item-action:hover {
    color: #998f80;
    background-color: #e6e3de
}

.list-group-item-yellow-100.list-group-item-action.active {
    color: #fff;
    background-color: #998f80;
    border-color: #998f80
}

.list-group-item-yellow-200 {
    color: #93836e;
    background-color: #fdf8f1
}

.list-group-item-yellow-200.list-group-item-action:focus,
.list-group-item-yellow-200.list-group-item-action:hover {
    color: #93836e;
    background-color: #e4dfd9
}

.list-group-item-yellow-200.list-group-item-action.active {
    color: #fff;
    background-color: #93836e;
    border-color: #93836e
}

.list-group-item-gray-50 {
    color: #767d85;
    background-color: #fefefe
}

.list-group-item-gray-50.list-group-item-action:focus,
.list-group-item-gray-50.list-group-item-action:hover {
    color: #767d85;
    background-color: #e5e5e5
}

.list-group-item-gray-50.list-group-item-action.active {
    color: #fff;
    background-color: #767d85;
    border-color: #767d85
}

.list-group-item-gray-100 {
    color: #919294;
    background-color: #fcfdfd
}

.list-group-item-gray-100.list-group-item-action:focus,
.list-group-item-gray-100.list-group-item-action:hover {
    color: #919294;
    background-color: #e3e4e4
}

.list-group-item-gray-100.list-group-item-action.active {
    color: #fff;
    background-color: #919294;
    border-color: #919294
}

.list-group-item-gray-200 {
    color: #898b8d;
    background-color: #fafafb
}

.list-group-item-gray-200.list-group-item-action:focus,
.list-group-item-gray-200.list-group-item-action:hover {
    color: #898b8d;
    background-color: #e1e1e2
}

.list-group-item-gray-200.list-group-item-action.active {
    color: #fff;
    background-color: #898b8d;
    border-color: #898b8d
}

.list-group-item-gray-300 {
    color: #7d8083;
    background-color: #f6f7f8
}

.list-group-item-gray-300.list-group-item-action:focus,
.list-group-item-gray-300.list-group-item-action:hover {
    color: #7d8083;
    background-color: #dddedf
}

.list-group-item-gray-300.list-group-item-action.active {
    color: #fff;
    background-color: #7d8083;
    border-color: #7d8083
}

.list-group-item-gray-400 {
    color: #5e6269;
    background-color: #ebedef
}

.list-group-item-gray-400.list-group-item-action:focus,
.list-group-item-gray-400.list-group-item-action:hover {
    color: #5e6269;
    background-color: #d4d5d7
}

.list-group-item-gray-400.list-group-item-action.active {
    color: #fff;
    background-color: #5e6269;
    border-color: #5e6269
}

.list-group-item-gray-500 {
    color: #40444d;
    background-color: #e1e3e6
}

.list-group-item-gray-500.list-group-item-action:focus,
.list-group-item-gray-500.list-group-item-action:hover {
    color: #40444d;
    background-color: #cbcccf
}

.list-group-item-gray-500.list-group-item-action.active {
    color: #fff;
    background-color: #40444d;
    border-color: #40444d
}

.list-group-item-gray-600 {
    color: #2d333b;
    background-color: #dbdde0
}

.list-group-item-gray-600.list-group-item-action:focus,
.list-group-item-gray-600.list-group-item-action:hover {
    color: #2d333b;
    background-color: #c5c7ca
}

.list-group-item-gray-600.list-group-item-action.active {
    color: #fff;
    background-color: #2d333b;
    border-color: #2d333b
}

.list-group-item-gray-700 {
    color: #212731;
    background-color: #d7d9dc
}

.list-group-item-gray-700.list-group-item-action:focus,
.list-group-item-gray-700.list-group-item-action:hover {
    color: #212731;
    background-color: #c2c3c6
}

.list-group-item-gray-700.list-group-item-action.active {
    color: #fff;
    background-color: #212731;
    border-color: #212731
}

.list-group-item-gray-800 {
    color: #131921;
    background-color: #d2d4d7
}

.list-group-item-gray-800.list-group-item-action:focus,
.list-group-item-gray-800.list-group-item-action:hover {
    color: #131921;
    background-color: #bdbfc2
}

.list-group-item-gray-800.list-group-item-action.active {
    color: #fff;
    background-color: #131921;
    border-color: #131921
}

.list-group-item-gray-900 {
    color: #0a0e17;
    background-color: #cfd1d4
}

.list-group-item-gray-900.list-group-item-action:focus,
.list-group-item-gray-900.list-group-item-action:hover {
    color: #0a0e17;
    background-color: #babcbf
}

.list-group-item-gray-900.list-group-item-action.active {
    color: #fff;
    background-color: #0a0e17;
    border-color: #0a0e17
}

.btn-close {
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: .25em .25em;
    color: #111827;
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
    border: 0;
    border-radius: .5rem;
    opacity: .5
}

.btn-close:hover {
    color: #111827;
    text-decoration: none;
    opacity: .75
}

.btn-close:focus {
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25);
    opacity: 1
}

.btn-close.disabled,
.btn-close:disabled {
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none;
    opacity: .25
}

.btn-close-white {
    filter: invert(1) grayscale(100%) brightness(200%)
}

.toast {
    width: 350px;
    max-width: 100%;
    font-size: .875rem;
    pointer-events: auto;
    background-color: rgba(255, 255, 255, .85);
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06);
    border-radius: .5rem
}

.toast:not(.showing):not(.show) {
    opacity: 0
}

.toast.hide {
    display: none
}

.toast-container {
    width: max-content;
    max-width: 100%;
    pointer-events: none
}

.toast-container > :not(:last-child) {
    margin-bottom: 1rem
}

.toast-header {
    display: flex;
    align-items: center;
    padding: .25rem .75rem;
    color: #4b5563;
    background-color: rgba(255, 255, 255, .85);
    background-clip: padding-box;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
    border-top-left-radius: calc(.5rem - 1px);
    border-top-right-radius: calc(.5rem - 1px)
}

.toast-header .btn-close {
    margin-right: -.375rem;
    margin-left: .75rem
}

.toast-body {
    padding: .75rem;
    word-wrap: break-word
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0
}

.modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none
}

.modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, -50px)
}

@media (prefers-reduced-motion: reduce) {
    .modal.fade .modal-dialog {
        transition: none
    }
}

.modal.show .modal-dialog {
    transform: none
}

.modal.modal-static .modal-dialog {
    transform: scale(1.02)
}

.modal-dialog-scrollable {
    height: calc(100% - 1rem)
}

.modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden
}

.modal-dialog-scrollable .modal-body {
    overflow-y: auto
}

.modal-dialog-centered {
    display: flex;
    align-items: center;
    min-height: calc(100% - 1rem)
}

.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: .0625rem solid rgba(17, 24, 39, .2);
    border-radius: .5rem;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    outline: 0
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: #111827
}

.modal-backdrop.fade {
    opacity: 0
}

.modal-backdrop.show {
    opacity: .5
}

.modal-header {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem;
    border-bottom: .0625rem solid #e5e7eb;
    border-top-left-radius: .4375rem;
    border-top-right-radius: .4375rem
}

.modal-header .btn-close {
    padding: .5rem .5rem;
    margin: -.5rem -.5rem -.5rem auto
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5
}

.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem
}

.modal-footer {
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: .75rem;
    border-top: .0625rem solid #e5e7eb;
    border-bottom-right-radius: .4375rem;
    border-bottom-left-radius: .4375rem
}

.modal-footer > * {
    margin: .25rem
}

@media (min-width: 576px) {
    .modal-dialog {
        max-width: 500px;
        margin: 1.75rem auto
    }

    .modal-dialog-scrollable {
        height: calc(100% - 3.5rem)
    }

    .modal-dialog-centered {
        min-height: calc(100% - 3.5rem)
    }

    .modal-content {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
    }

    .modal-sm {
        max-width: 300px
    }
}

@media (min-width: 992px) {

    .modal-lg,
    .modal-xl {
        max-width: 800px
    }
}

@media (min-width: 1200px) {
    .modal-xl {
        max-width: 1140px
    }
}

.modal-fullscreen {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0
}

.modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0
}

.modal-fullscreen .modal-header {
    border-radius: 0
}

.modal-fullscreen .modal-body {
    overflow-y: auto
}

.modal-fullscreen .modal-footer {
    border-radius: 0
}

@media (max-width: 575.98px) {
    .modal-fullscreen-sm-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-sm-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-sm-down .modal-header {
        border-radius: 0
    }

    .modal-fullscreen-sm-down .modal-body {
        overflow-y: auto
    }

    .modal-fullscreen-sm-down .modal-footer {
        border-radius: 0
    }
}

@media (max-width: 767.98px) {
    .modal-fullscreen-md-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-md-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-md-down .modal-header {
        border-radius: 0
    }

    .modal-fullscreen-md-down .modal-body {
        overflow-y: auto
    }

    .modal-fullscreen-md-down .modal-footer {
        border-radius: 0
    }
}

@media (max-width: 991.98px) {
    .modal-fullscreen-lg-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-lg-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-lg-down .modal-header {
        border-radius: 0
    }

    .modal-fullscreen-lg-down .modal-body {
        overflow-y: auto
    }

    .modal-fullscreen-lg-down .modal-footer {
        border-radius: 0
    }
}

@media (max-width: 1199.98px) {
    .modal-fullscreen-xl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-xl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-xl-down .modal-header {
        border-radius: 0
    }

    .modal-fullscreen-xl-down .modal-body {
        overflow-y: auto
    }

    .modal-fullscreen-xl-down .modal-footer {
        border-radius: 0
    }
}

@media (max-width: 1399.98px) {
    .modal-fullscreen-xxl-down {
        width: 100vw;
        max-width: none;
        height: 100%;
        margin: 0
    }

    .modal-fullscreen-xxl-down .modal-content {
        height: 100%;
        border: 0;
        border-radius: 0
    }

    .modal-fullscreen-xxl-down .modal-header {
        border-radius: 0
    }

    .modal-fullscreen-xxl-down .modal-body {
        overflow-y: auto
    }

    .modal-fullscreen-xxl-down .modal-footer {
        border-radius: 0
    }
}

.tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    margin: 2rem;
    font-family: var(--bs-font-sans-serif);
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: .875rem;
    word-wrap: break-word;
    opacity: 0
}

.tooltip.show {
    opacity: .99
}

.tooltip .tooltip-arrow {
    position: absolute;
    display: block;
    width: .8rem;
    height: .4rem
}

.tooltip .tooltip-arrow::before {
    position: absolute;
    content: "";
    border-color: transparent;
    border-style: solid
}

.bs-tooltip-auto[data-popper-placement^=top],
.bs-tooltip-top {
    padding: .4rem 0
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,
.bs-tooltip-top .tooltip-arrow {
    bottom: 0
}

.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,
.bs-tooltip-top .tooltip-arrow::before {
    top: -1px;
    border-width: .4rem .4rem 0;
    border-top-color: #1f2937
}

.bs-tooltip-auto[data-popper-placement^=right],
.bs-tooltip-end {
    padding: 0 .4rem
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,
.bs-tooltip-end .tooltip-arrow {
    left: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,
.bs-tooltip-end .tooltip-arrow::before {
    right: -1px;
    border-width: .4rem .4rem .4rem 0;
    border-right-color: #1f2937
}

.bs-tooltip-auto[data-popper-placement^=bottom],
.bs-tooltip-bottom {
    padding: .4rem 0
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,
.bs-tooltip-bottom .tooltip-arrow {
    top: 0
}

.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,
.bs-tooltip-bottom .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 .4rem .4rem;
    border-bottom-color: #1f2937
}

.bs-tooltip-auto[data-popper-placement^=left],
.bs-tooltip-start {
    padding: 0 .4rem
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,
.bs-tooltip-start .tooltip-arrow {
    right: 0;
    width: .4rem;
    height: .8rem
}

.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,
.bs-tooltip-start .tooltip-arrow::before {
    left: -1px;
    border-width: .4rem 0 .4rem .4rem;
    border-left-color: #1f2937
}

.tooltip-inner {
    max-width: 200px;
    padding: .375rem .55rem;
    color: #fff;
    text-align: center;
    background-color: #1f2937;
    border-radius: .5rem
}

.popover {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1060;
    display: block;
    max-width: 276px;
    font-family: var(--bs-font-sans-serif);
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: .875rem;
    word-wrap: break-word;
    background-color: #1f2937;
    background-clip: padding-box;
    border: .0625rem solid rgba(17, 24, 39, .2);
    border-radius: 1rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
}

.popover .popover-arrow {
    position: absolute;
    display: block;
    width: 1rem;
    height: .5rem
}

.popover .popover-arrow::after,
.popover .popover-arrow::before {
    position: absolute;
    display: block;
    content: "";
    border-color: transparent;
    border-style: solid
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow,
.bs-popover-top > .popover-arrow {
    bottom: -.5625rem
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
    bottom: 0;
    border-width: .5rem .5rem 0;
    border-top-color: rgba(17, 24, 39, .25)
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after {
    bottom: .0625rem;
    border-width: .5rem .5rem 0;
    border-top-color: #1f2937
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow,
.bs-popover-end > .popover-arrow {
    left: -.5625rem;
    width: .5rem;
    height: 1rem
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
    left: 0;
    border-width: .5rem .5rem .5rem 0;
    border-right-color: rgba(17, 24, 39, .25)
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after {
    left: .0625rem;
    border-width: .5rem .5rem .5rem 0;
    border-right-color: #1f2937
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow,
.bs-popover-bottom > .popover-arrow {
    top: -.5625rem
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before {
    top: 0;
    border-width: 0 .5rem .5rem .5rem;
    border-bottom-color: rgba(17, 24, 39, .25)
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after {
    top: .0625rem;
    border-width: 0 .5rem .5rem .5rem;
    border-bottom-color: #1f2937
}

.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
    position: absolute;
    top: 0;
    left: 50%;
    display: block;
    width: 1rem;
    margin-left: -.5rem;
    content: "";
    border-bottom: .0625rem solid #19222d
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow,
.bs-popover-start > .popover-arrow {
    right: -.5625rem;
    width: .5rem;
    height: 1rem
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
    right: 0;
    border-width: .5rem 0 .5rem .5rem;
    border-left-color: rgba(17, 24, 39, .25)
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after {
    right: .0625rem;
    border-width: .5rem 0 .5rem .5rem;
    border-left-color: #1f2937
}

.popover-header {
    padding: .5rem 1rem;
    margin-bottom: 0;
    font-size: 1rem;
    color: #fff;
    background-color: #19222d;
    border-bottom: .0625rem solid #171e29;
    border-top-left-radius: .9375rem;
    border-top-right-radius: .9375rem
}

.popover-header:empty {
    display: none
}

.popover-body {
    padding: 1rem 1rem;
    color: #fff
}

.carousel {
    position: relative
}

.carousel.pointer-event {
    touch-action: pan-y
}

.carousel-inner {
    position: relative;
    width: 100%;
    overflow: hidden
}

.carousel-inner::after {
    display: block;
    clear: both;
    content: ""
}

.carousel-item {
    position: relative;
    display: none;
    float: left;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
    transition: transform .6s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .carousel-item {
        transition: none
    }
}

.carousel-item-next,
.carousel-item-prev,
.carousel-item.active {
    display: block
}

.active.carousel-item-end,
.carousel-item-next:not(.carousel-item-start) {
    transform: translateX(100%)
}

.active.carousel-item-start,
.carousel-item-prev:not(.carousel-item-end) {
    transform: translateX(-100%)
}

.carousel-fade .carousel-item {
    opacity: 0;
    transition-property: opacity;
    transform: none
}

.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end,
.carousel-fade .carousel-item.active {
    z-index: 1;
    opacity: 1
}

.carousel-fade .active.carousel-item-end,
.carousel-fade .active.carousel-item-start {
    z-index: 0;
    opacity: 0;
    transition: opacity 0s .6s
}

@media (prefers-reduced-motion: reduce) {

    .carousel-fade .active.carousel-item-end,
    .carousel-fade .active.carousel-item-start {
        transition: none
    }
}

.carousel-control-next,
.carousel-control-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    padding: 0;
    color: #fff;
    text-align: center;
    background: 0 0;
    border: 0;
    opacity: .5;
    transition: opacity .15s ease
}

@media (prefers-reduced-motion: reduce) {

    .carousel-control-next,
    .carousel-control-prev {
        transition: none
    }
}

.carousel-control-next:focus,
.carousel-control-next:hover,
.carousel-control-prev:focus,
.carousel-control-prev:hover {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: .9
}

.carousel-control-prev {
    left: 0
}

.carousel-control-next {
    right: 0
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: 100% 100%
}

.carousel-control-prev-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
}

.carousel-control-next-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
}

.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    padding: 0;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%;
    list-style: none
}

.carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: .5;
    transition: opacity .6s ease
}

@media (prefers-reduced-motion: reduce) {
    .carousel-indicators [data-bs-target] {
        transition: none
    }
}

.carousel-indicators .active {
    opacity: 1
}

.carousel-caption {
    position: absolute;
    right: 15%;
    bottom: 1.25rem;
    left: 15%;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: center
}

.carousel-dark .carousel-control-next-icon,
.carousel-dark .carousel-control-prev-icon {
    filter: invert(1) grayscale(100)
}

.carousel-dark .carousel-indicators [data-bs-target] {
    background-color: #111827
}

.carousel-dark .carousel-caption {
    color: #111827
}

@keyframes spinner-border {
    to {
        transform: rotate(360deg)
    }
}

.spinner-border {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: -.125em;
    border: .25em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: .75s linear infinite spinner-border
}

.spinner-border-sm {
    width: 1.2rem;
    height: 1.2rem;
    border-width: .2em
}

@keyframes spinner-grow {
    0% {
        transform: scale(0)
    }

    50% {
        opacity: 1;
        transform: none
    }
}

.spinner-grow {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    vertical-align: -.125em;
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    animation: .75s linear infinite spinner-grow
}

.spinner-grow-sm {
    width: 1.2rem;
    height: 1.2rem
}

@media (prefers-reduced-motion: reduce) {

    .spinner-border,
    .spinner-grow {
        animation-duration: 1.5s
    }
}

.clearfix::after {
    display: block;
    clear: both;
    content: ""
}

.link-primary {
    color: #1f2937
}

.link-primary:focus,
.link-primary:hover {
    color: #19212c
}

.link-secondary {
    color: #f0bc74
}

.link-secondary:focus,
.link-secondary:hover {
    color: #f3c990
}

.link-tertiary {
    color: #31316a
}

.link-tertiary:focus,
.link-tertiary:hover {
    color: #272755
}

.link-success {
    color: #10b981
}

.link-success:focus,
.link-success:hover {
    color: #40c79a
}

.link-info {
    color: #2361ce
}

.link-info:focus,
.link-info:hover {
    color: #1c4ea5
}

.link-warning {
    color: #fba918
}

.link-warning:focus,
.link-warning:hover {
    color: #fcba46
}

.link-danger {
    color: #e11d48
}

.link-danger:focus,
.link-danger:hover {
    color: #b4173a
}

.link-white {
    color: #fff
}

.link-white:focus,
.link-white:hover {
    color: #fff
}

.link-indigo {
    color: #4f46e5
}

.link-indigo:focus,
.link-indigo:hover {
    color: #3f38b7
}

.link-purple {
    color: #7c3aed
}

.link-purple:focus,
.link-purple:hover {
    color: #632ebe
}

.link-yellow-100 {
    color: #ffeed6
}

.link-yellow-100:focus,
.link-yellow-100:hover {
    color: #fff1de
}

.link-yellow-200 {
    color: #f5dbb8
}

.link-yellow-200:focus,
.link-yellow-200:hover {
    color: #f7e2c6
}

.link-gray-50 {
    color: #f9fafb
}

.link-gray-50:focus,
.link-gray-50:hover {
    color: #fafbfc
}

.link-gray-100 {
    color: #f2f4f6
}

.link-gray-100:focus,
.link-gray-100:hover {
    color: #f5f6f8
}

.link-gray-200 {
    color: #e5e7eb
}

.link-gray-200:focus,
.link-gray-200:hover {
    color: #eaecef
}

.link-gray-300 {
    color: #d1d5db
}

.link-gray-300:focus,
.link-gray-300:hover {
    color: #dadde2
}

.link-gray-400 {
    color: #9ca3af
}

.link-gray-400:focus,
.link-gray-400:hover {
    color: #b0b5bf
}

.link-gray-500 {
    color: #6b7280
}

.link-gray-500:focus,
.link-gray-500:hover {
    color: #565b66
}

.link-gray-600 {
    color: #4b5563
}

.link-gray-600:focus,
.link-gray-600:hover {
    color: #3c444f
}

.link-gray-700 {
    color: #374151
}

.link-gray-700:focus,
.link-gray-700:hover {
    color: #2c3441
}

.link-gray-800 {
    color: #1f2937
}

.link-gray-800:focus,
.link-gray-800:hover {
    color: #19212c
}

.link-gray-900 {
    color: #111827
}

.link-gray-900:focus,
.link-gray-900:hover {
    color: #0e131f
}

.ratio {
    position: relative;
    width: 100%
}

.ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""
}

.ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
}

.ratio-1x1 {
    --bs-aspect-ratio: 100%
}

.ratio-4x3 {
    --bs-aspect-ratio: calc(3 / 4 * 100%)
}

.ratio-16x9 {
    --bs-aspect-ratio: calc(9 / 16 * 100%)
}

.ratio-21x9 {
    --bs-aspect-ratio: calc(9 / 21 * 100%)
}

.fixed-top {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030
}

.fixed-bottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1030
}

.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020
}

@media (min-width: 576px) {
    .sticky-sm-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

@media (min-width: 768px) {
    .sticky-md-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

@media (min-width: 992px) {
    .sticky-lg-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

@media (min-width: 1200px) {
    .sticky-xl-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

@media (min-width: 1400px) {
    .sticky-xxl-top {
        position: sticky;
        top: 0;
        z-index: 1020
    }
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important
}

.stretched-link::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    content: ""
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.align-baseline {
    vertical-align: baseline !important
}

.align-top {
    vertical-align: top !important
}

.align-middle {
    vertical-align: middle !important
}

.align-bottom {
    vertical-align: bottom !important
}

.align-text-bottom {
    vertical-align: text-bottom !important
}

.align-text-top {
    vertical-align: text-top !important
}

.float-start {
    float: left !important
}

.float-end {
    float: right !important
}

.float-none {
    float: none !important
}

.overflow-auto {
    overflow: auto !important
}

.overflow-hidden {
    overflow: hidden !important
}

.overflow-visible {
    overflow: visible !important
}

.overflow-scroll {
    overflow: scroll !important
}

.d-inline {
    display: inline !important
}

.d-inline-block {
    display: inline-block !important
}

.d-block {
    display: block !important
}

.d-grid {
    display: grid !important
}

.d-table {
    display: table !important
}

.d-table-row {
    display: table-row !important
}

.d-table-cell {
    display: table-cell !important
}

.d-flex {
    display: flex !important
}

.d-inline-flex {
    display: inline-flex !important
}

.d-none {
    display: none !important
}

.shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important
}

.shadow-sm {
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2) !important
}

.shadow-lg {
    box-shadow: 0 1rem 3rem rgba(17, 24, 39, .175) !important
}

.shadow-none {
    box-shadow: none !important
}

.position-static {
    position: static !important
}

.position-relative {
    position: relative !important
}

.position-absolute {
    position: absolute !important
}

.position-fixed {
    position: fixed !important
}

.position-sticky {
    position: sticky !important
}

.top-0 {
    top: 0 !important
}

.top-50 {
    top: 50% !important
}

.top-100 {
    top: 100% !important
}

.bottom-0 {
    bottom: 0 !important
}

.bottom-50 {
    bottom: 50% !important
}

.bottom-100 {
    bottom: 100% !important
}

.start-0 {
    left: 0 !important
}

.start-50 {
    left: 50% !important
}

.start-100 {
    left: 100% !important
}

.end-0 {
    right: 0 !important
}

.end-50 {
    right: 50% !important
}

.end-100 {
    right: 100% !important
}

.translate-middle {
    transform: translate(-50%, -50%) !important
}

.translate-middle-x {
    transform: translateX(-50%) !important
}

.translate-middle-y {
    transform: translateY(-50%) !important
}

.border {
    border: .0625rem solid #e5e7eb !important
}

.border-0 {
    border: 0 !important
}

.border-top {
    border-top: .0625rem solid #e5e7eb !important
}

.border-top-0 {
    border-top: 0 !important
}

.border-end {
    border-right: .0625rem solid #e5e7eb !important
}

.border-end-0 {
    border-right: 0 !important
}

.border-bottom {
    border-bottom: .0625rem solid #e5e7eb !important
}

.border-bottom-0 {
    border-bottom: 0 !important
}

.border-start {
    border-left: .0625rem solid #e5e7eb !important
}

.border-start-0 {
    border-left: 0 !important
}

.border-primary {
    border-color: #1f2937 !important
}

.border-secondary {
    border-color: #f0bc74 !important
}

.border-tertiary {
    border-color: #31316a !important
}

.border-success {
    border-color: #10b981 !important
}

.border-info {
    border-color: #2361ce !important
}

.border-warning {
    border-color: #fba918 !important
}

.border-danger {
    border-color: #e11d48 !important
}

.border-white {
    border-color: #fff !important
}

.border-indigo {
    border-color: #4f46e5 !important
}

.border-purple {
    border-color: #7c3aed !important
}

.border-yellow-100 {
    border-color: #ffeed6 !important
}

.border-yellow-200 {
    border-color: #f5dbb8 !important
}

.border-gray-50 {
    border-color: #f9fafb !important
}

.border-gray-100 {
    border-color: #f2f4f6 !important
}

.border-gray-200 {
    border-color: #e5e7eb !important
}

.border-gray-300 {
    border-color: #d1d5db !important
}

.border-gray-400 {
    border-color: #9ca3af !important
}

.border-gray-500 {
    border-color: #6b7280 !important
}

.border-gray-600 {
    border-color: #4b5563 !important
}

.border-gray-700 {
    border-color: #374151 !important
}

.border-gray-800 {
    border-color: #1f2937 !important
}

.border-gray-900 {
    border-color: #111827 !important
}

.border-1 {
    border-width: 1px !important
}

.border-2 {
    border-width: 2px !important
}

.border-3 {
    border-width: 3px !important
}

.border-4 {
    border-width: 4px !important
}

.border-5 {
    border-width: 5px !important
}

.w-25 {
    width: 25% !important
}

.w-50 {
    width: 50% !important
}

.w-75 {
    width: 75% !important
}

.w-100 {
    width: 100% !important
}

.w-auto {
    width: auto !important
}

.fmxw-100 {
    max-width: 100px !important
}

.fmxw-200 {
    max-width: 200px !important
}

.fmxw-300 {
    max-width: 300px !important
}

.fmxw-400 {
    max-width: 400px !important
}

.fmxw-500 {
    max-width: 500px !important
}

.fmxw-999 {
    max-width: 999px !important
}

.vw-100 {
    width: 100vw !important
}

.min-vw-100 {
    min-width: 100vw !important
}

.h-25 {
    height: 25% !important
}

.h-50 {
    height: 50% !important
}

.h-75 {
    height: 75% !important
}

.h-100 {
    height: 100% !important
}

.h-auto {
    height: auto !important
}

.mh-100 {
    max-height: 100% !important
}

.vh-100 {
    height: 100vh !important
}

.min-vh-100 {
    min-height: 100vh !important
}

.flex-fill {
    flex: 1 1 auto !important
}

.flex-row {
    flex-direction: row !important
}

.flex-column {
    flex-direction: column !important
}

.flex-row-reverse {
    flex-direction: row-reverse !important
}

.flex-column-reverse {
    flex-direction: column-reverse !important
}

.flex-grow-0 {
    flex-grow: 0 !important
}

.flex-grow-1 {
    flex-grow: 1 !important
}

.flex-shrink-0 {
    flex-shrink: 0 !important
}

.flex-shrink-1 {
    flex-shrink: 1 !important
}

.flex-wrap {
    flex-wrap: wrap !important
}

.flex-nowrap {
    flex-wrap: nowrap !important
}

.flex-wrap-reverse {
    flex-wrap: wrap-reverse !important
}

.gap-0 {
    gap: 0 !important
}

.gap-1 {
    gap: .25rem !important
}

.gap-2 {
    gap: .5rem !important
}

.gap-3 {
    gap: 1rem !important
}

.gap-4 {
    gap: 1.5rem !important
}

.gap-5 {
    gap: 3rem !important
}

.gap-6 {
    gap: 5rem !important
}

.gap-7 {
    gap: 8rem !important
}

.gap-8 {
    gap: 10rem !important
}

.gap-9 {
    gap: 11rem !important
}

.gap-10 {
    gap: 14rem !important
}

.gap-11 {
    gap: 16rem !important
}

.gap-12 {
    gap: 20rem !important
}

.gap-sm {
    gap: 1rem !important
}

.gap-md {
    gap: 2rem !important
}

.gap-lg {
    gap: 4rem !important
}

.gap-xl {
    gap: 8rem !important
}

.justify-content-start {
    justify-content: flex-start !important
}

.justify-content-end {
    justify-content: flex-end !important
}

.justify-content-center {
    justify-content: center !important
}

.justify-content-between {
    justify-content: space-between !important
}

.justify-content-around {
    justify-content: space-around !important
}

.justify-content-evenly {
    justify-content: space-evenly !important
}

.align-items-start {
    align-items: flex-start !important
}

.align-items-end {
    align-items: flex-end !important
}

.align-items-center {
    align-items: center !important
}

.align-items-baseline {
    align-items: baseline !important
}

.align-items-stretch {
    align-items: stretch !important
}

.align-content-start {
    align-content: flex-start !important
}

.align-content-end {
    align-content: flex-end !important
}

.align-content-center {
    align-content: center !important
}

.align-content-between {
    align-content: space-between !important
}

.align-content-around {
    align-content: space-around !important
}

.align-content-stretch {
    align-content: stretch !important
}

.align-self-auto {
    align-self: auto !important
}

.align-self-start {
    align-self: flex-start !important
}

.align-self-end {
    align-self: flex-end !important
}

.align-self-center {
    align-self: center !important
}

.align-self-baseline {
    align-self: baseline !important
}

.align-self-stretch {
    align-self: stretch !important
}

.order-first {
    order: -1 !important
}

.order-0 {
    order: 0 !important
}

.order-1 {
    order: 1 !important
}

.order-2 {
    order: 2 !important
}

.order-3 {
    order: 3 !important
}

.order-4 {
    order: 4 !important
}

.order-5 {
    order: 5 !important
}

.order-last {
    order: 6 !important
}

.m-0 {
    margin: 0 !important
}

.m-1 {
    margin: .25rem !important
}

.m-2 {
    margin: .5rem !important
}

.m-3 {
    margin: 1rem !important
}

.m-4 {
    margin: 1.5rem !important
}

.m-5 {
    margin: 3rem !important
}

.m-6 {
    margin: 5rem !important
}

.m-7 {
    margin: 8rem !important
}

.m-8 {
    margin: 10rem !important
}

.m-9 {
    margin: 11rem !important
}

.m-10 {
    margin: 14rem !important
}

.m-11 {
    margin: 16rem !important
}

.m-12 {
    margin: 20rem !important
}

.m-sm {
    margin: 1rem !important
}

.m-md {
    margin: 2rem !important
}

.m-lg {
    margin: 4rem !important
}

.m-xl {
    margin: 8rem !important
}

.m-auto {
    margin: auto !important
}

.mx-0 {
    margin-right: 0 !important;
    margin-left: 0 !important
}

.mx-1 {
    margin-right: .25rem !important;
    margin-left: .25rem !important
}

.mx-2 {
    margin-right: .5rem !important;
    margin-left: .5rem !important
}

.mx-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important
}

.mx-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important
}

.mx-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important
}

.mx-6 {
    margin-right: 5rem !important;
    margin-left: 5rem !important
}

.mx-7 {
    margin-right: 8rem !important;
    margin-left: 8rem !important
}

.mx-8 {
    margin-right: 10rem !important;
    margin-left: 10rem !important
}

.mx-9 {
    margin-right: 11rem !important;
    margin-left: 11rem !important
}

.mx-10 {
    margin-right: 14rem !important;
    margin-left: 14rem !important
}

.mx-11 {
    margin-right: 16rem !important;
    margin-left: 16rem !important
}

.mx-12 {
    margin-right: 20rem !important;
    margin-left: 20rem !important
}

.mx-sm {
    margin-right: 1rem !important;
    margin-left: 1rem !important
}

.mx-md {
    margin-right: 2rem !important;
    margin-left: 2rem !important
}

.mx-lg {
    margin-right: 4rem !important;
    margin-left: 4rem !important
}

.mx-xl {
    margin-right: 8rem !important;
    margin-left: 8rem !important
}

.mx-auto {
    margin-right: auto !important;
    margin-left: auto !important
}

.my-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important
}

.my-1 {
    margin-top: .25rem !important;
    margin-bottom: .25rem !important
}

.my-2 {
    margin-top: .5rem !important;
    margin-bottom: .5rem !important
}

.my-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important
}

.my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important
}

.my-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important
}

.my-6 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important
}

.my-7 {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important
}

.my-8 {
    margin-top: 10rem !important;
    margin-bottom: 10rem !important
}

.my-9 {
    margin-top: 11rem !important;
    margin-bottom: 11rem !important
}

.my-10 {
    margin-top: 14rem !important;
    margin-bottom: 14rem !important
}

.my-11 {
    margin-top: 16rem !important;
    margin-bottom: 16rem !important
}

.my-12 {
    margin-top: 20rem !important;
    margin-bottom: 20rem !important
}

.my-sm {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important
}

.my-md {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important
}

.my-lg {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important
}

.my-xl {
    margin-top: 8rem !important;
    margin-bottom: 8rem !important
}

.my-auto {
    margin-top: auto !important;
    margin-bottom: auto !important
}

.mt-0 {
    margin-top: 0 !important
}

.mt-1 {
    margin-top: .25rem !important
}

.mt-2 {
    margin-top: .5rem !important
}

.mt-3 {
    margin-top: 1rem !important
}

.mt-4 {
    margin-top: 1.5rem !important
}

.mt-5 {
    margin-top: 3rem !important
}

.mt-6 {
    margin-top: 5rem !important
}

.mt-7 {
    margin-top: 8rem !important
}

.mt-8 {
    margin-top: 10rem !important
}

.mt-9 {
    margin-top: 11rem !important
}

.mt-10 {
    margin-top: 14rem !important
}

.mt-11 {
    margin-top: 16rem !important
}

.mt-12 {
    margin-top: 20rem !important
}

.mt-sm {
    margin-top: 1rem !important
}

.mt-md {
    margin-top: 2rem !important
}

.mt-lg {
    margin-top: 4rem !important
}

.mt-xl {
    margin-top: 8rem !important
}

.mt-auto {
    margin-top: auto !important
}

.me-0 {
    margin-right: 0 !important
}

.me-1 {
    margin-right: .25rem !important
}

.me-2 {
    margin-right: .5rem !important
}

.me-3 {
    margin-right: 1rem !important
}

.me-4 {
    margin-right: 1.5rem !important
}

.me-5 {
    margin-right: 3rem !important
}

.me-6 {
    margin-right: 5rem !important
}

.me-7 {
    margin-right: 8rem !important
}

.me-8 {
    margin-right: 10rem !important
}

.me-9 {
    margin-right: 11rem !important
}

.me-10 {
    margin-right: 14rem !important
}

.me-11 {
    margin-right: 16rem !important
}

.me-12 {
    margin-right: 20rem !important
}

.me-sm {
    margin-right: 1rem !important
}

.me-md {
    margin-right: 2rem !important
}

.me-lg {
    margin-right: 4rem !important
}

.me-xl {
    margin-right: 8rem !important
}

.me-auto {
    margin-right: auto !important
}

.mb-0 {
    margin-bottom: 0 !important
}

.mb-1 {
    margin-bottom: .25rem !important
}

.mb-2 {
    margin-bottom: .5rem !important
}

.mb-3 {
    margin-bottom: 1rem !important
}

.mb-4 {
    margin-bottom: 1.5rem !important
}

.mb-5 {
    margin-bottom: 3rem !important
}

.mb-6 {
    margin-bottom: 5rem !important
}

.mb-7 {
    margin-bottom: 8rem !important
}

.mb-8 {
    margin-bottom: 10rem !important
}

.mb-9 {
    margin-bottom: 11rem !important
}

.mb-10 {
    margin-bottom: 14rem !important
}

.mb-11 {
    margin-bottom: 16rem !important
}

.mb-12 {
    margin-bottom: 20rem !important
}

.mb-sm {
    margin-bottom: 1rem !important
}

.mb-md {
    margin-bottom: 2rem !important
}

.mb-lg {
    margin-bottom: 4rem !important
}

.mb-xl {
    margin-bottom: 8rem !important
}

.mb-auto {
    margin-bottom: auto !important
}

.ms-0 {
    margin-left: 0 !important
}

.ms-1 {
    margin-left: .25rem !important
}

.ms-2 {
    margin-left: .5rem !important
}

.ms-3 {
    margin-left: 1rem !important
}

.ms-4 {
    margin-left: 1.5rem !important
}

.ms-5 {
    margin-left: 3rem !important
}

.ms-6 {
    margin-left: 5rem !important
}

.ms-7 {
    margin-left: 8rem !important
}

.ms-8 {
    margin-left: 10rem !important
}

.ms-9 {
    margin-left: 11rem !important
}

.ms-10 {
    margin-left: 14rem !important
}

.ms-11 {
    margin-left: 16rem !important
}

.ms-12 {
    margin-left: 20rem !important
}

.ms-sm {
    margin-left: 1rem !important
}

.ms-md {
    margin-left: 2rem !important
}

.ms-lg {
    margin-left: 4rem !important
}

.ms-xl {
    margin-left: 8rem !important
}

.ms-auto {
    margin-left: auto !important
}

.m-n1 {
    margin: -.25rem !important
}

.m-n2 {
    margin: -.5rem !important
}

.m-n3 {
    margin: -1rem !important
}

.m-n4 {
    margin: -1.5rem !important
}

.m-n5 {
    margin: -3rem !important
}

.m-n6 {
    margin: -5rem !important
}

.m-n7 {
    margin: -8rem !important
}

.m-n8 {
    margin: -10rem !important
}

.m-n9 {
    margin: -11rem !important
}

.m-n10 {
    margin: -14rem !important
}

.m-n11 {
    margin: -16rem !important
}

.m-n12 {
    margin: -20rem !important
}

.m-nsm {
    margin: -1rem !important
}

.m-nmd {
    margin: -2rem !important
}

.m-nlg {
    margin: -4rem !important
}

.m-nxl {
    margin: -8rem !important
}

.mx-n1 {
    margin-right: -.25rem !important;
    margin-left: -.25rem !important
}

.mx-n2 {
    margin-right: -.5rem !important;
    margin-left: -.5rem !important
}

.mx-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important
}

.mx-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important
}

.mx-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important
}

.mx-n6 {
    margin-right: -5rem !important;
    margin-left: -5rem !important
}

.mx-n7 {
    margin-right: -8rem !important;
    margin-left: -8rem !important
}

.mx-n8 {
    margin-right: -10rem !important;
    margin-left: -10rem !important
}

.mx-n9 {
    margin-right: -11rem !important;
    margin-left: -11rem !important
}

.mx-n10 {
    margin-right: -14rem !important;
    margin-left: -14rem !important
}

.mx-n11 {
    margin-right: -16rem !important;
    margin-left: -16rem !important
}

.mx-n12 {
    margin-right: -20rem !important;
    margin-left: -20rem !important
}

.mx-nsm {
    margin-right: -1rem !important;
    margin-left: -1rem !important
}

.mx-nmd {
    margin-right: -2rem !important;
    margin-left: -2rem !important
}

.mx-nlg {
    margin-right: -4rem !important;
    margin-left: -4rem !important
}

.mx-nxl {
    margin-right: -8rem !important;
    margin-left: -8rem !important
}

.my-n1 {
    margin-top: -.25rem !important;
    margin-bottom: -.25rem !important
}

.my-n2 {
    margin-top: -.5rem !important;
    margin-bottom: -.5rem !important
}

.my-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important
}

.my-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important
}

.my-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important
}

.my-n6 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important
}

.my-n7 {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important
}

.my-n8 {
    margin-top: -10rem !important;
    margin-bottom: -10rem !important
}

.my-n9 {
    margin-top: -11rem !important;
    margin-bottom: -11rem !important
}

.my-n10 {
    margin-top: -14rem !important;
    margin-bottom: -14rem !important
}

.my-n11 {
    margin-top: -16rem !important;
    margin-bottom: -16rem !important
}

.my-n12 {
    margin-top: -20rem !important;
    margin-bottom: -20rem !important
}

.my-nsm {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important
}

.my-nmd {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important
}

.my-nlg {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important
}

.my-nxl {
    margin-top: -8rem !important;
    margin-bottom: -8rem !important
}

.mt-n1 {
    margin-top: -.25rem !important
}

.mt-n2 {
    margin-top: -.5rem !important
}

.mt-n3 {
    margin-top: -1rem !important
}

.mt-n4 {
    margin-top: -1.5rem !important
}

.mt-n5 {
    margin-top: -3rem !important
}

.mt-n6 {
    margin-top: -5rem !important
}

.mt-n7 {
    margin-top: -8rem !important
}

.mt-n8 {
    margin-top: -10rem !important
}

.mt-n9 {
    margin-top: -11rem !important
}

.mt-n10 {
    margin-top: -14rem !important
}

.mt-n11 {
    margin-top: -16rem !important
}

.mt-n12 {
    margin-top: -20rem !important
}

.mt-nsm {
    margin-top: -1rem !important
}

.mt-nmd {
    margin-top: -2rem !important
}

.mt-nlg {
    margin-top: -4rem !important
}

.mt-nxl {
    margin-top: -8rem !important
}

.me-n1 {
    margin-right: -.25rem !important
}

.me-n2 {
    margin-right: -.5rem !important
}

.me-n3 {
    margin-right: -1rem !important
}

.me-n4 {
    margin-right: -1.5rem !important
}

.me-n5 {
    margin-right: -3rem !important
}

.me-n6 {
    margin-right: -5rem !important
}

.me-n7 {
    margin-right: -8rem !important
}

.me-n8 {
    margin-right: -10rem !important
}

.me-n9 {
    margin-right: -11rem !important
}

.me-n10 {
    margin-right: -14rem !important
}

.me-n11 {
    margin-right: -16rem !important
}

.me-n12 {
    margin-right: -20rem !important
}

.me-nsm {
    margin-right: -1rem !important
}

.me-nmd {
    margin-right: -2rem !important
}

.me-nlg {
    margin-right: -4rem !important
}

.me-nxl {
    margin-right: -8rem !important
}

.mb-n1 {
    margin-bottom: -.25rem !important
}

.mb-n2 {
    margin-bottom: -.5rem !important
}

.mb-n3 {
    margin-bottom: -1rem !important
}

.mb-n4 {
    margin-bottom: -1.5rem !important
}

.mb-n5 {
    margin-bottom: -3rem !important
}

.mb-n6 {
    margin-bottom: -5rem !important
}

.mb-n7 {
    margin-bottom: -8rem !important
}

.mb-n8 {
    margin-bottom: -10rem !important
}

.mb-n9 {
    margin-bottom: -11rem !important
}

.mb-n10 {
    margin-bottom: -14rem !important
}

.mb-n11 {
    margin-bottom: -16rem !important
}

.mb-n12 {
    margin-bottom: -20rem !important
}

.mb-nsm {
    margin-bottom: -1rem !important
}

.mb-nmd {
    margin-bottom: -2rem !important
}

.mb-nlg {
    margin-bottom: -4rem !important
}

.mb-nxl {
    margin-bottom: -8rem !important
}

.ms-n1 {
    margin-left: -.25rem !important
}

.ms-n2 {
    margin-left: -.5rem !important
}

.ms-n3 {
    margin-left: -1rem !important
}

.ms-n4 {
    margin-left: -1.5rem !important
}

.ms-n5 {
    margin-left: -3rem !important
}

.ms-n6 {
    margin-left: -5rem !important
}

.ms-n7 {
    margin-left: -8rem !important
}

.ms-n8 {
    margin-left: -10rem !important
}

.ms-n9 {
    margin-left: -11rem !important
}

.ms-n10 {
    margin-left: -14rem !important
}

.ms-n11 {
    margin-left: -16rem !important
}

.ms-n12 {
    margin-left: -20rem !important
}

.ms-nsm {
    margin-left: -1rem !important
}

.ms-nmd {
    margin-left: -2rem !important
}

.ms-nlg {
    margin-left: -4rem !important
}

.ms-nxl {
    margin-left: -8rem !important
}

.p-0 {
    padding: 0 !important
}

.p-1 {
    padding: .25rem !important
}

.p-2 {
    padding: .5rem !important
}

.p-3 {
    padding: 1rem !important
}

.p-4 {
    padding: 1.5rem !important
}

.p-5 {
    padding: 3rem !important
}

.p-6 {
    padding: 5rem !important
}

.p-7 {
    padding: 8rem !important
}

.p-8 {
    padding: 10rem !important
}

.p-9 {
    padding: 11rem !important
}

.p-10 {
    padding: 14rem !important
}

.p-11 {
    padding: 16rem !important
}

.p-12 {
    padding: 20rem !important
}

.p-sm {
    padding: 1rem !important
}

.p-md {
    padding: 2rem !important
}

.p-lg {
    padding: 4rem !important
}

.p-xl {
    padding: 8rem !important
}

.px-0 {
    padding-right: 0 !important;
    padding-left: 0 !important
}

.px-1 {
    padding-right: .25rem !important;
    padding-left: .25rem !important
}

.px-2 {
    padding-right: .5rem !important;
    padding-left: .5rem !important
}

.px-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important
}

.px-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important
}

.px-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important
}

.px-6 {
    padding-right: 5rem !important;
    padding-left: 5rem !important
}

.px-7 {
    padding-right: 8rem !important;
    padding-left: 8rem !important
}

.px-8 {
    padding-right: 10rem !important;
    padding-left: 10rem !important
}

.px-9 {
    padding-right: 11rem !important;
    padding-left: 11rem !important
}

.px-10 {
    padding-right: 14rem !important;
    padding-left: 14rem !important
}

.px-11 {
    padding-right: 16rem !important;
    padding-left: 16rem !important
}

.px-12 {
    padding-right: 20rem !important;
    padding-left: 20rem !important
}

.px-sm {
    padding-right: 1rem !important;
    padding-left: 1rem !important
}

.px-md {
    padding-right: 2rem !important;
    padding-left: 2rem !important
}

.px-lg {
    padding-right: 4rem !important;
    padding-left: 4rem !important
}

.px-xl {
    padding-right: 8rem !important;
    padding-left: 8rem !important
}

.py-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important
}

.py-1 {
    padding-top: .25rem !important;
    padding-bottom: .25rem !important
}

.py-2 {
    padding-top: .5rem !important;
    padding-bottom: .5rem !important
}

.py-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important
}

.py-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important
}

.py-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important
}

.py-6 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important
}

.py-7 {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important
}

.py-8 {
    padding-top: 10rem !important;
    padding-bottom: 10rem !important
}

.py-9 {
    padding-top: 11rem !important;
    padding-bottom: 11rem !important
}

.py-10 {
    padding-top: 14rem !important;
    padding-bottom: 14rem !important
}

.py-11 {
    padding-top: 16rem !important;
    padding-bottom: 16rem !important
}

.py-12 {
    padding-top: 20rem !important;
    padding-bottom: 20rem !important
}

.py-sm {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important
}

.py-md {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important
}

.py-lg {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important
}

.py-xl {
    padding-top: 8rem !important;
    padding-bottom: 8rem !important
}

.pt-0 {
    padding-top: 0 !important
}

.pt-1 {
    padding-top: .25rem !important
}

.pt-2 {
    padding-top: .5rem !important
}

.pt-3 {
    padding-top: 1rem !important
}

.pt-4 {
    padding-top: 1.5rem !important
}

.pt-5 {
    padding-top: 3rem !important
}

.pt-6 {
    padding-top: 5rem !important
}

.pt-7 {
    padding-top: 8rem !important
}

.pt-8 {
    padding-top: 10rem !important
}

.pt-9 {
    padding-top: 11rem !important
}

.pt-10 {
    padding-top: 14rem !important
}

.pt-11 {
    padding-top: 16rem !important
}

.pt-12 {
    padding-top: 20rem !important
}

.pt-sm {
    padding-top: 1rem !important
}

.pt-md {
    padding-top: 2rem !important
}

.pt-lg {
    padding-top: 4rem !important
}

.pt-xl {
    padding-top: 8rem !important
}

.pe-0 {
    padding-right: 0 !important
}

.pe-1 {
    padding-right: .25rem !important
}

.pe-2 {
    padding-right: .5rem !important
}

.pe-3 {
    padding-right: 1rem !important
}

.pe-4 {
    padding-right: 1.5rem !important
}

.pe-5 {
    padding-right: 3rem !important
}

.pe-6 {
    padding-right: 5rem !important
}

.pe-7 {
    padding-right: 8rem !important
}

.pe-8 {
    padding-right: 10rem !important
}

.pe-9 {
    padding-right: 11rem !important
}

.pe-10 {
    padding-right: 14rem !important
}

.pe-11 {
    padding-right: 16rem !important
}

.pe-12 {
    padding-right: 20rem !important
}

.pe-sm {
    padding-right: 1rem !important
}

.pe-md {
    padding-right: 2rem !important
}

.pe-lg {
    padding-right: 4rem !important
}

.pe-xl {
    padding-right: 8rem !important
}

.pb-0 {
    padding-bottom: 0 !important
}

.pb-1 {
    padding-bottom: .25rem !important
}

.pb-2 {
    padding-bottom: .5rem !important
}

.pb-3 {
    padding-bottom: 1rem !important
}

.pb-4 {
    padding-bottom: 1.5rem !important
}

.pb-5 {
    padding-bottom: 3rem !important
}

.pb-6 {
    padding-bottom: 5rem !important
}

.pb-7 {
    padding-bottom: 8rem !important
}

.pb-8 {
    padding-bottom: 10rem !important
}

.pb-9 {
    padding-bottom: 11rem !important
}

.pb-10 {
    padding-bottom: 14rem !important
}

.pb-11 {
    padding-bottom: 16rem !important
}

.pb-12 {
    padding-bottom: 20rem !important
}

.pb-sm {
    padding-bottom: 1rem !important
}

.pb-md {
    padding-bottom: 2rem !important
}

.pb-lg {
    padding-bottom: 4rem !important
}

.pb-xl {
    padding-bottom: 8rem !important
}

.ps-0 {
    padding-left: 0 !important
}

.ps-1 {
    padding-left: .25rem !important
}

.ps-2 {
    padding-left: .5rem !important
}

.ps-3 {
    padding-left: 1rem !important
}

.ps-4 {
    padding-left: 1.5rem !important
}

.ps-5 {
    padding-left: 3rem !important
}

.ps-6 {
    padding-left: 5rem !important
}

.ps-7 {
    padding-left: 8rem !important
}

.ps-8 {
    padding-left: 10rem !important
}

.ps-9 {
    padding-left: 11rem !important
}

.ps-10 {
    padding-left: 14rem !important
}

.ps-11 {
    padding-left: 16rem !important
}

.ps-12 {
    padding-left: 20rem !important
}

.ps-sm {
    padding-left: 1rem !important
}

.ps-md {
    padding-left: 2rem !important
}

.ps-lg {
    padding-left: 4rem !important
}

.ps-xl {
    padding-left: 8rem !important
}

.font-monospace {
    font-family: var(--bs-font-monospace) !important
}

.fs-1 {
    font-size: calc(1.375rem + 1.5vw) !important
}

.fs-2 {
    font-size: calc(1.325rem + .9vw) !important
}

.fs-3 {
    font-size: calc(1.3rem + .6vw) !important
}

.fs-4 {
    font-size: calc(1.275rem + .3vw) !important
}

.fs-5 {
    font-size: 1.25rem !important
}

.fs-6 {
    font-size: 1rem !important
}

.fst-italic {
    font-style: italic !important
}

.fst-normal {
    font-style: normal !important
}

.fw-light {
    font-weight: 300 !important
}

.fw-lighter {
    font-weight: lighter !important
}

.fw-normal {
    font-weight: 400 !important
}

.fw-bold {
    font-weight: 500 !important
}

.fw-bolder {
    font-weight: 600 !important
}

.fw-extrabold {
    font-weight: 700 !important
}

.fw-black {
    font-weight: 800 !important
}

.lh-1 {
    line-height: 1 !important
}

.lh-sm {
    line-height: 1.25 !important
}

.lh-base {
    line-height: 1.5 !important
}

.lh-lg {
    line-height: 2 !important
}

.text-start {
    text-align: left !important
}

.text-end {
    text-align: right !important
}

.text-center {
    text-align: center !important
}

.text-decoration-none {
    text-decoration: none !important
}

.text-decoration-underline {
    text-decoration: underline !important
}

.text-decoration-line-through {
    text-decoration: line-through !important
}

.text-lowercase {
    text-transform: lowercase !important
}

.text-uppercase {
    text-transform: uppercase !important
}

.text-capitalize {
    text-transform: capitalize !important
}

.text-wrap {
    white-space: normal !important
}

.text-nowrap {
    white-space: nowrap !important
}

.text-break {
    word-wrap: break-word !important;
    word-break: break-word !important
}

.text-primary {
    color: #1f2937 !important
}

.text-secondary {
    color: #f0bc74 !important
}

.text-tertiary {
    color: #31316a !important
}

.text-success {
    color: #10b981 !important
}

.text-info {
    color: #2361ce !important
}

.text-warning {
    color: #fba918 !important
}

.text-danger {
    color: #e11d48 !important
}

.text-white {
    color: #fff !important
}

.text-indigo {
    color: #4f46e5 !important
}

.text-purple {
    color: #7c3aed !important
}

.text-yellow-100 {
    color: #ffeed6 !important
}

.text-yellow-200 {
    color: #f5dbb8 !important
}

.text-gray-50 {
    color: #f9fafb !important
}

.text-gray-100 {
    color: #f2f4f6 !important
}

.text-gray-200 {
    color: #e5e7eb !important
}

.text-gray-300 {
    color: #d1d5db !important
}

.text-gray-400 {
    color: #9ca3af !important
}

.text-gray-500 {
    color: #6b7280 !important
}

.text-gray-600 {
    color: #4b5563 !important
}

.text-gray-700 {
    color: #374151 !important
}

.text-gray-800 {
    color: #1f2937 !important
}

.text-gray-900 {
    color: #111827 !important
}

.text-body {
    color: #374151 !important
}

.text-muted {
    color: #58677d !important
}

.text-black-50 {
    color: rgba(17, 24, 39, .5) !important
}

.text-white-50 {
    color: rgba(255, 255, 255, .5) !important
}

.text-reset {
    color: inherit !important
}

.bg-primary {
    background-color: #1f2937 !important
}

.bg-secondary {
    background-color: #f0bc74 !important
}

.bg-tertiary {
    background-color: #31316a !important
}

.bg-success {
    background-color: #10b981 !important
}

.bg-info {
    background-color: #2361ce !important
}

.bg-warning {
    background-color: #fba918 !important
}

.bg-danger {
    background-color: #e11d48 !important
}

.bg-white {
    background-color: #fff !important
}

.bg-indigo {
    background-color: #4f46e5 !important
}

.bg-purple {
    background-color: #7c3aed !important
}

.bg-yellow-100 {
    background-color: #ffeed6 !important
}

.bg-yellow-200 {
    background-color: #f5dbb8 !important
}

.bg-gray-50 {
    background-color: #f9fafb !important
}

.bg-gray-100 {
    background-color: #f2f4f6 !important
}

.bg-gray-200 {
    background-color: #e5e7eb !important
}

.bg-gray-300 {
    background-color: #d1d5db !important
}

.bg-gray-400 {
    background-color: #9ca3af !important
}

.bg-gray-500 {
    background-color: #6b7280 !important
}

.bg-gray-600 {
    background-color: #4b5563 !important
}

.bg-gray-700 {
    background-color: #374151 !important
}

.bg-gray-800 {
    background-color: #1f2937 !important
}

.bg-gray-900 {
    background-color: #111827 !important
}

.bg-body {
    background-color: #f2f4f6 !important
}

.bg-transparent {
    background-color: transparent !important
}

.bg-gradient {
    background-image: var(--bs-gradient) !important
}

.user-select-all {
    -webkit-user-select: all !important;
    user-select: all !important
}

.user-select-auto {
    -webkit-user-select: auto !important;
    user-select: auto !important
}

.user-select-none {
    -webkit-user-select: none !important;
    user-select: none !important
}

.pe-none {
    pointer-events: none !important
}

.pe-auto {
    pointer-events: auto !important
}

.rounded {
    border-radius: .5rem !important
}

.rounded-0 {
    border-radius: 0 !important
}

.rounded-1 {
    border-radius: .35rem !important
}

.rounded-2 {
    border-radius: .5rem !important
}

.rounded-3 {
    border-radius: 1rem !important
}

.rounded-circle {
    border-radius: 50% !important
}

.rounded-pill {
    border-radius: 50rem !important
}

.rounded-top {
    border-top-left-radius: .5rem !important;
    border-top-right-radius: .5rem !important
}

.rounded-end {
    border-top-right-radius: .5rem !important;
    border-bottom-right-radius: .5rem !important
}

.rounded-bottom {
    border-bottom-right-radius: .5rem !important;
    border-bottom-left-radius: .5rem !important
}

.rounded-start {
    border-bottom-left-radius: .5rem !important;
    border-top-left-radius: .5rem !important
}

.visible {
    visibility: visible !important
}

.invisible {
    visibility: hidden !important
}

.blur-0 {
    backdrop-filter: blur(0) !important
}

.blur-1 {
    backdrop-filter: blur(1px) !important
}

.blur-2 {
    backdrop-filter: blur(2px) !important
}

.blur-3 {
    backdrop-filter: blur(3px) !important
}

.blur-4 {
    backdrop-filter: blur(4px) !important
}

.blur-5 {
    backdrop-filter: blur(5px) !important
}

.blur-6 {
    backdrop-filter: blur(6px) !important
}

.blur-7 {
    backdrop-filter: blur(7px) !important
}

.blur-8 {
    backdrop-filter: blur(8px) !important
}

.blur-9 {
    backdrop-filter: blur(91px) !important
}

.blur-10 {
    backdrop-filter: blur(10px) !important
}

.blur-11 {
    backdrop-filter: blur(11px) !important
}

.blur-12 {
    backdrop-filter: blur(12px) !important
}

.blur-13 {
    backdrop-filter: blur(13px) !important
}

.blur-14 {
    backdrop-filter: blur(14px) !important
}

.o-0 {
    opacity: 0 !important
}

.o-25 {
    opacity: .25 !important
}

.o-50 {
    opacity: .5 !important
}

.o-75 {
    opacity: .75 !important
}

.o-100 {
    opacity: 1 !important
}

.z-0 {
    z-index: 0 !important
}

.z-1 {
    z-index: 1 !important
}

.z-2 {
    z-index: 2 !important
}

.z-3 {
    z-index: 3 !important
}

.z-999 {
    z-index: 999 !important
}

.fmxh-100 {
    min-height: 100px !important
}

.fmxh-200 {
    min-height: 200px !important
}

.fmxh-300 {
    min-height: 300px !important
}

.fmxh-400 {
    min-height: 400px !important
}

.fmxh-500 {
    min-height: 500px !important
}

.fmxh-999 {
    min-height: 999px !important
}

@media (min-width: 576px) {
    .float-sm-start {
        float: left !important
    }

    .float-sm-end {
        float: right !important
    }

    .float-sm-none {
        float: none !important
    }

    .d-sm-inline {
        display: inline !important
    }

    .d-sm-inline-block {
        display: inline-block !important
    }

    .d-sm-block {
        display: block !important
    }

    .d-sm-grid {
        display: grid !important
    }

    .d-sm-table {
        display: table !important
    }

    .d-sm-table-row {
        display: table-row !important
    }

    .d-sm-table-cell {
        display: table-cell !important
    }

    .d-sm-flex {
        display: flex !important
    }

    .d-sm-inline-flex {
        display: inline-flex !important
    }

    .d-sm-none {
        display: none !important
    }

    .vh-sm-100 {
        height: 100vh !important
    }

    .flex-sm-fill {
        flex: 1 1 auto !important
    }

    .flex-sm-row {
        flex-direction: row !important
    }

    .flex-sm-column {
        flex-direction: column !important
    }

    .flex-sm-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-sm-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-sm-grow-0 {
        flex-grow: 0 !important
    }

    .flex-sm-grow-1 {
        flex-grow: 1 !important
    }

    .flex-sm-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-sm-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-sm-wrap {
        flex-wrap: wrap !important
    }

    .flex-sm-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-sm-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .gap-sm-0 {
        gap: 0 !important
    }

    .gap-sm-1 {
        gap: .25rem !important
    }

    .gap-sm-2 {
        gap: .5rem !important
    }

    .gap-sm-3 {
        gap: 1rem !important
    }

    .gap-sm-4 {
        gap: 1.5rem !important
    }

    .gap-sm-5 {
        gap: 3rem !important
    }

    .gap-sm-6 {
        gap: 5rem !important
    }

    .gap-sm-7 {
        gap: 8rem !important
    }

    .gap-sm-8 {
        gap: 10rem !important
    }

    .gap-sm-9 {
        gap: 11rem !important
    }

    .gap-sm-10 {
        gap: 14rem !important
    }

    .gap-sm-11 {
        gap: 16rem !important
    }

    .gap-sm-12 {
        gap: 20rem !important
    }

    .gap-sm-sm {
        gap: 1rem !important
    }

    .gap-sm-md {
        gap: 2rem !important
    }

    .gap-sm-lg {
        gap: 4rem !important
    }

    .gap-sm-xl {
        gap: 8rem !important
    }

    .justify-content-sm-start {
        justify-content: flex-start !important
    }

    .justify-content-sm-end {
        justify-content: flex-end !important
    }

    .justify-content-sm-center {
        justify-content: center !important
    }

    .justify-content-sm-between {
        justify-content: space-between !important
    }

    .justify-content-sm-around {
        justify-content: space-around !important
    }

    .justify-content-sm-evenly {
        justify-content: space-evenly !important
    }

    .align-items-sm-start {
        align-items: flex-start !important
    }

    .align-items-sm-end {
        align-items: flex-end !important
    }

    .align-items-sm-center {
        align-items: center !important
    }

    .align-items-sm-baseline {
        align-items: baseline !important
    }

    .align-items-sm-stretch {
        align-items: stretch !important
    }

    .align-content-sm-start {
        align-content: flex-start !important
    }

    .align-content-sm-end {
        align-content: flex-end !important
    }

    .align-content-sm-center {
        align-content: center !important
    }

    .align-content-sm-between {
        align-content: space-between !important
    }

    .align-content-sm-around {
        align-content: space-around !important
    }

    .align-content-sm-stretch {
        align-content: stretch !important
    }

    .align-self-sm-auto {
        align-self: auto !important
    }

    .align-self-sm-start {
        align-self: flex-start !important
    }

    .align-self-sm-end {
        align-self: flex-end !important
    }

    .align-self-sm-center {
        align-self: center !important
    }

    .align-self-sm-baseline {
        align-self: baseline !important
    }

    .align-self-sm-stretch {
        align-self: stretch !important
    }

    .order-sm-first {
        order: -1 !important
    }

    .order-sm-0 {
        order: 0 !important
    }

    .order-sm-1 {
        order: 1 !important
    }

    .order-sm-2 {
        order: 2 !important
    }

    .order-sm-3 {
        order: 3 !important
    }

    .order-sm-4 {
        order: 4 !important
    }

    .order-sm-5 {
        order: 5 !important
    }

    .order-sm-last {
        order: 6 !important
    }

    .m-sm-0 {
        margin: 0 !important
    }

    .m-sm-1 {
        margin: .25rem !important
    }

    .m-sm-2 {
        margin: .5rem !important
    }

    .m-sm-3 {
        margin: 1rem !important
    }

    .m-sm-4 {
        margin: 1.5rem !important
    }

    .m-sm-5 {
        margin: 3rem !important
    }

    .m-sm-6 {
        margin: 5rem !important
    }

    .m-sm-7 {
        margin: 8rem !important
    }

    .m-sm-8 {
        margin: 10rem !important
    }

    .m-sm-9 {
        margin: 11rem !important
    }

    .m-sm-10 {
        margin: 14rem !important
    }

    .m-sm-11 {
        margin: 16rem !important
    }

    .m-sm-12 {
        margin: 20rem !important
    }

    .m-sm-sm {
        margin: 1rem !important
    }

    .m-sm-md {
        margin: 2rem !important
    }

    .m-sm-lg {
        margin: 4rem !important
    }

    .m-sm-xl {
        margin: 8rem !important
    }

    .m-sm-auto {
        margin: auto !important
    }

    .mx-sm-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-sm-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-sm-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-sm-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-sm-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-sm-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-sm-6 {
        margin-right: 5rem !important;
        margin-left: 5rem !important
    }

    .mx-sm-7 {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-sm-8 {
        margin-right: 10rem !important;
        margin-left: 10rem !important
    }

    .mx-sm-9 {
        margin-right: 11rem !important;
        margin-left: 11rem !important
    }

    .mx-sm-10 {
        margin-right: 14rem !important;
        margin-left: 14rem !important
    }

    .mx-sm-11 {
        margin-right: 16rem !important;
        margin-left: 16rem !important
    }

    .mx-sm-12 {
        margin-right: 20rem !important;
        margin-left: 20rem !important
    }

    .mx-sm-sm {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-sm-md {
        margin-right: 2rem !important;
        margin-left: 2rem !important
    }

    .mx-sm-lg {
        margin-right: 4rem !important;
        margin-left: 4rem !important
    }

    .mx-sm-xl {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-sm-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-sm-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-sm-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-sm-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-sm-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-sm-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-sm-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-sm-6 {
        margin-top: 5rem !important;
        margin-bottom: 5rem !important
    }

    .my-sm-7 {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-sm-8 {
        margin-top: 10rem !important;
        margin-bottom: 10rem !important
    }

    .my-sm-9 {
        margin-top: 11rem !important;
        margin-bottom: 11rem !important
    }

    .my-sm-10 {
        margin-top: 14rem !important;
        margin-bottom: 14rem !important
    }

    .my-sm-11 {
        margin-top: 16rem !important;
        margin-bottom: 16rem !important
    }

    .my-sm-12 {
        margin-top: 20rem !important;
        margin-bottom: 20rem !important
    }

    .my-sm-sm {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-sm-md {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important
    }

    .my-sm-lg {
        margin-top: 4rem !important;
        margin-bottom: 4rem !important
    }

    .my-sm-xl {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-sm-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-sm-0 {
        margin-top: 0 !important
    }

    .mt-sm-1 {
        margin-top: .25rem !important
    }

    .mt-sm-2 {
        margin-top: .5rem !important
    }

    .mt-sm-3 {
        margin-top: 1rem !important
    }

    .mt-sm-4 {
        margin-top: 1.5rem !important
    }

    .mt-sm-5 {
        margin-top: 3rem !important
    }

    .mt-sm-6 {
        margin-top: 5rem !important
    }

    .mt-sm-7 {
        margin-top: 8rem !important
    }

    .mt-sm-8 {
        margin-top: 10rem !important
    }

    .mt-sm-9 {
        margin-top: 11rem !important
    }

    .mt-sm-10 {
        margin-top: 14rem !important
    }

    .mt-sm-11 {
        margin-top: 16rem !important
    }

    .mt-sm-12 {
        margin-top: 20rem !important
    }

    .mt-sm-sm {
        margin-top: 1rem !important
    }

    .mt-sm-md {
        margin-top: 2rem !important
    }

    .mt-sm-lg {
        margin-top: 4rem !important
    }

    .mt-sm-xl {
        margin-top: 8rem !important
    }

    .mt-sm-auto {
        margin-top: auto !important
    }

    .me-sm-0 {
        margin-right: 0 !important
    }

    .me-sm-1 {
        margin-right: .25rem !important
    }

    .me-sm-2 {
        margin-right: .5rem !important
    }

    .me-sm-3 {
        margin-right: 1rem !important
    }

    .me-sm-4 {
        margin-right: 1.5rem !important
    }

    .me-sm-5 {
        margin-right: 3rem !important
    }

    .me-sm-6 {
        margin-right: 5rem !important
    }

    .me-sm-7 {
        margin-right: 8rem !important
    }

    .me-sm-8 {
        margin-right: 10rem !important
    }

    .me-sm-9 {
        margin-right: 11rem !important
    }

    .me-sm-10 {
        margin-right: 14rem !important
    }

    .me-sm-11 {
        margin-right: 16rem !important
    }

    .me-sm-12 {
        margin-right: 20rem !important
    }

    .me-sm-sm {
        margin-right: 1rem !important
    }

    .me-sm-md {
        margin-right: 2rem !important
    }

    .me-sm-lg {
        margin-right: 4rem !important
    }

    .me-sm-xl {
        margin-right: 8rem !important
    }

    .me-sm-auto {
        margin-right: auto !important
    }

    .mb-sm-0 {
        margin-bottom: 0 !important
    }

    .mb-sm-1 {
        margin-bottom: .25rem !important
    }

    .mb-sm-2 {
        margin-bottom: .5rem !important
    }

    .mb-sm-3 {
        margin-bottom: 1rem !important
    }

    .mb-sm-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-sm-5 {
        margin-bottom: 3rem !important
    }

    .mb-sm-6 {
        margin-bottom: 5rem !important
    }

    .mb-sm-7 {
        margin-bottom: 8rem !important
    }

    .mb-sm-8 {
        margin-bottom: 10rem !important
    }

    .mb-sm-9 {
        margin-bottom: 11rem !important
    }

    .mb-sm-10 {
        margin-bottom: 14rem !important
    }

    .mb-sm-11 {
        margin-bottom: 16rem !important
    }

    .mb-sm-12 {
        margin-bottom: 20rem !important
    }

    .mb-sm-sm {
        margin-bottom: 1rem !important
    }

    .mb-sm-md {
        margin-bottom: 2rem !important
    }

    .mb-sm-lg {
        margin-bottom: 4rem !important
    }

    .mb-sm-xl {
        margin-bottom: 8rem !important
    }

    .mb-sm-auto {
        margin-bottom: auto !important
    }

    .ms-sm-0 {
        margin-left: 0 !important
    }

    .ms-sm-1 {
        margin-left: .25rem !important
    }

    .ms-sm-2 {
        margin-left: .5rem !important
    }

    .ms-sm-3 {
        margin-left: 1rem !important
    }

    .ms-sm-4 {
        margin-left: 1.5rem !important
    }

    .ms-sm-5 {
        margin-left: 3rem !important
    }

    .ms-sm-6 {
        margin-left: 5rem !important
    }

    .ms-sm-7 {
        margin-left: 8rem !important
    }

    .ms-sm-8 {
        margin-left: 10rem !important
    }

    .ms-sm-9 {
        margin-left: 11rem !important
    }

    .ms-sm-10 {
        margin-left: 14rem !important
    }

    .ms-sm-11 {
        margin-left: 16rem !important
    }

    .ms-sm-12 {
        margin-left: 20rem !important
    }

    .ms-sm-sm {
        margin-left: 1rem !important
    }

    .ms-sm-md {
        margin-left: 2rem !important
    }

    .ms-sm-lg {
        margin-left: 4rem !important
    }

    .ms-sm-xl {
        margin-left: 8rem !important
    }

    .ms-sm-auto {
        margin-left: auto !important
    }

    .m-sm-n1 {
        margin: -.25rem !important
    }

    .m-sm-n2 {
        margin: -.5rem !important
    }

    .m-sm-n3 {
        margin: -1rem !important
    }

    .m-sm-n4 {
        margin: -1.5rem !important
    }

    .m-sm-n5 {
        margin: -3rem !important
    }

    .m-sm-n6 {
        margin: -5rem !important
    }

    .m-sm-n7 {
        margin: -8rem !important
    }

    .m-sm-n8 {
        margin: -10rem !important
    }

    .m-sm-n9 {
        margin: -11rem !important
    }

    .m-sm-n10 {
        margin: -14rem !important
    }

    .m-sm-n11 {
        margin: -16rem !important
    }

    .m-sm-n12 {
        margin: -20rem !important
    }

    .m-sm-nsm {
        margin: -1rem !important
    }

    .m-sm-nmd {
        margin: -2rem !important
    }

    .m-sm-nlg {
        margin: -4rem !important
    }

    .m-sm-nxl {
        margin: -8rem !important
    }

    .mx-sm-n1 {
        margin-right: -.25rem !important;
        margin-left: -.25rem !important
    }

    .mx-sm-n2 {
        margin-right: -.5rem !important;
        margin-left: -.5rem !important
    }

    .mx-sm-n3 {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-sm-n4 {
        margin-right: -1.5rem !important;
        margin-left: -1.5rem !important
    }

    .mx-sm-n5 {
        margin-right: -3rem !important;
        margin-left: -3rem !important
    }

    .mx-sm-n6 {
        margin-right: -5rem !important;
        margin-left: -5rem !important
    }

    .mx-sm-n7 {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .mx-sm-n8 {
        margin-right: -10rem !important;
        margin-left: -10rem !important
    }

    .mx-sm-n9 {
        margin-right: -11rem !important;
        margin-left: -11rem !important
    }

    .mx-sm-n10 {
        margin-right: -14rem !important;
        margin-left: -14rem !important
    }

    .mx-sm-n11 {
        margin-right: -16rem !important;
        margin-left: -16rem !important
    }

    .mx-sm-n12 {
        margin-right: -20rem !important;
        margin-left: -20rem !important
    }

    .mx-sm-nsm {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-sm-nmd {
        margin-right: -2rem !important;
        margin-left: -2rem !important
    }

    .mx-sm-nlg {
        margin-right: -4rem !important;
        margin-left: -4rem !important
    }

    .mx-sm-nxl {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .my-sm-n1 {
        margin-top: -.25rem !important;
        margin-bottom: -.25rem !important
    }

    .my-sm-n2 {
        margin-top: -.5rem !important;
        margin-bottom: -.5rem !important
    }

    .my-sm-n3 {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-sm-n4 {
        margin-top: -1.5rem !important;
        margin-bottom: -1.5rem !important
    }

    .my-sm-n5 {
        margin-top: -3rem !important;
        margin-bottom: -3rem !important
    }

    .my-sm-n6 {
        margin-top: -5rem !important;
        margin-bottom: -5rem !important
    }

    .my-sm-n7 {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .my-sm-n8 {
        margin-top: -10rem !important;
        margin-bottom: -10rem !important
    }

    .my-sm-n9 {
        margin-top: -11rem !important;
        margin-bottom: -11rem !important
    }

    .my-sm-n10 {
        margin-top: -14rem !important;
        margin-bottom: -14rem !important
    }

    .my-sm-n11 {
        margin-top: -16rem !important;
        margin-bottom: -16rem !important
    }

    .my-sm-n12 {
        margin-top: -20rem !important;
        margin-bottom: -20rem !important
    }

    .my-sm-nsm {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-sm-nmd {
        margin-top: -2rem !important;
        margin-bottom: -2rem !important
    }

    .my-sm-nlg {
        margin-top: -4rem !important;
        margin-bottom: -4rem !important
    }

    .my-sm-nxl {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .mt-sm-n1 {
        margin-top: -.25rem !important
    }

    .mt-sm-n2 {
        margin-top: -.5rem !important
    }

    .mt-sm-n3 {
        margin-top: -1rem !important
    }

    .mt-sm-n4 {
        margin-top: -1.5rem !important
    }

    .mt-sm-n5 {
        margin-top: -3rem !important
    }

    .mt-sm-n6 {
        margin-top: -5rem !important
    }

    .mt-sm-n7 {
        margin-top: -8rem !important
    }

    .mt-sm-n8 {
        margin-top: -10rem !important
    }

    .mt-sm-n9 {
        margin-top: -11rem !important
    }

    .mt-sm-n10 {
        margin-top: -14rem !important
    }

    .mt-sm-n11 {
        margin-top: -16rem !important
    }

    .mt-sm-n12 {
        margin-top: -20rem !important
    }

    .mt-sm-nsm {
        margin-top: -1rem !important
    }

    .mt-sm-nmd {
        margin-top: -2rem !important
    }

    .mt-sm-nlg {
        margin-top: -4rem !important
    }

    .mt-sm-nxl {
        margin-top: -8rem !important
    }

    .me-sm-n1 {
        margin-right: -.25rem !important
    }

    .me-sm-n2 {
        margin-right: -.5rem !important
    }

    .me-sm-n3 {
        margin-right: -1rem !important
    }

    .me-sm-n4 {
        margin-right: -1.5rem !important
    }

    .me-sm-n5 {
        margin-right: -3rem !important
    }

    .me-sm-n6 {
        margin-right: -5rem !important
    }

    .me-sm-n7 {
        margin-right: -8rem !important
    }

    .me-sm-n8 {
        margin-right: -10rem !important
    }

    .me-sm-n9 {
        margin-right: -11rem !important
    }

    .me-sm-n10 {
        margin-right: -14rem !important
    }

    .me-sm-n11 {
        margin-right: -16rem !important
    }

    .me-sm-n12 {
        margin-right: -20rem !important
    }

    .me-sm-nsm {
        margin-right: -1rem !important
    }

    .me-sm-nmd {
        margin-right: -2rem !important
    }

    .me-sm-nlg {
        margin-right: -4rem !important
    }

    .me-sm-nxl {
        margin-right: -8rem !important
    }

    .mb-sm-n1 {
        margin-bottom: -.25rem !important
    }

    .mb-sm-n2 {
        margin-bottom: -.5rem !important
    }

    .mb-sm-n3 {
        margin-bottom: -1rem !important
    }

    .mb-sm-n4 {
        margin-bottom: -1.5rem !important
    }

    .mb-sm-n5 {
        margin-bottom: -3rem !important
    }

    .mb-sm-n6 {
        margin-bottom: -5rem !important
    }

    .mb-sm-n7 {
        margin-bottom: -8rem !important
    }

    .mb-sm-n8 {
        margin-bottom: -10rem !important
    }

    .mb-sm-n9 {
        margin-bottom: -11rem !important
    }

    .mb-sm-n10 {
        margin-bottom: -14rem !important
    }

    .mb-sm-n11 {
        margin-bottom: -16rem !important
    }

    .mb-sm-n12 {
        margin-bottom: -20rem !important
    }

    .mb-sm-nsm {
        margin-bottom: -1rem !important
    }

    .mb-sm-nmd {
        margin-bottom: -2rem !important
    }

    .mb-sm-nlg {
        margin-bottom: -4rem !important
    }

    .mb-sm-nxl {
        margin-bottom: -8rem !important
    }

    .ms-sm-n1 {
        margin-left: -.25rem !important
    }

    .ms-sm-n2 {
        margin-left: -.5rem !important
    }

    .ms-sm-n3 {
        margin-left: -1rem !important
    }

    .ms-sm-n4 {
        margin-left: -1.5rem !important
    }

    .ms-sm-n5 {
        margin-left: -3rem !important
    }

    .ms-sm-n6 {
        margin-left: -5rem !important
    }

    .ms-sm-n7 {
        margin-left: -8rem !important
    }

    .ms-sm-n8 {
        margin-left: -10rem !important
    }

    .ms-sm-n9 {
        margin-left: -11rem !important
    }

    .ms-sm-n10 {
        margin-left: -14rem !important
    }

    .ms-sm-n11 {
        margin-left: -16rem !important
    }

    .ms-sm-n12 {
        margin-left: -20rem !important
    }

    .ms-sm-nsm {
        margin-left: -1rem !important
    }

    .ms-sm-nmd {
        margin-left: -2rem !important
    }

    .ms-sm-nlg {
        margin-left: -4rem !important
    }

    .ms-sm-nxl {
        margin-left: -8rem !important
    }

    .p-sm-0 {
        padding: 0 !important
    }

    .p-sm-1 {
        padding: .25rem !important
    }

    .p-sm-2 {
        padding: .5rem !important
    }

    .p-sm-3 {
        padding: 1rem !important
    }

    .p-sm-4 {
        padding: 1.5rem !important
    }

    .p-sm-5 {
        padding: 3rem !important
    }

    .p-sm-6 {
        padding: 5rem !important
    }

    .p-sm-7 {
        padding: 8rem !important
    }

    .p-sm-8 {
        padding: 10rem !important
    }

    .p-sm-9 {
        padding: 11rem !important
    }

    .p-sm-10 {
        padding: 14rem !important
    }

    .p-sm-11 {
        padding: 16rem !important
    }

    .p-sm-12 {
        padding: 20rem !important
    }

    .p-sm-sm {
        padding: 1rem !important
    }

    .p-sm-md {
        padding: 2rem !important
    }

    .p-sm-lg {
        padding: 4rem !important
    }

    .p-sm-xl {
        padding: 8rem !important
    }

    .px-sm-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-sm-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-sm-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-sm-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-sm-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-sm-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .px-sm-6 {
        padding-right: 5rem !important;
        padding-left: 5rem !important
    }

    .px-sm-7 {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .px-sm-8 {
        padding-right: 10rem !important;
        padding-left: 10rem !important
    }

    .px-sm-9 {
        padding-right: 11rem !important;
        padding-left: 11rem !important
    }

    .px-sm-10 {
        padding-right: 14rem !important;
        padding-left: 14rem !important
    }

    .px-sm-11 {
        padding-right: 16rem !important;
        padding-left: 16rem !important
    }

    .px-sm-12 {
        padding-right: 20rem !important;
        padding-left: 20rem !important
    }

    .px-sm-sm {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-sm-md {
        padding-right: 2rem !important;
        padding-left: 2rem !important
    }

    .px-sm-lg {
        padding-right: 4rem !important;
        padding-left: 4rem !important
    }

    .px-sm-xl {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .py-sm-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-sm-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-sm-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-sm-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-sm-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-sm-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .py-sm-6 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important
    }

    .py-sm-7 {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .py-sm-8 {
        padding-top: 10rem !important;
        padding-bottom: 10rem !important
    }

    .py-sm-9 {
        padding-top: 11rem !important;
        padding-bottom: 11rem !important
    }

    .py-sm-10 {
        padding-top: 14rem !important;
        padding-bottom: 14rem !important
    }

    .py-sm-11 {
        padding-top: 16rem !important;
        padding-bottom: 16rem !important
    }

    .py-sm-12 {
        padding-top: 20rem !important;
        padding-bottom: 20rem !important
    }

    .py-sm-sm {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-sm-md {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important
    }

    .py-sm-lg {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important
    }

    .py-sm-xl {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .pt-sm-0 {
        padding-top: 0 !important
    }

    .pt-sm-1 {
        padding-top: .25rem !important
    }

    .pt-sm-2 {
        padding-top: .5rem !important
    }

    .pt-sm-3 {
        padding-top: 1rem !important
    }

    .pt-sm-4 {
        padding-top: 1.5rem !important
    }

    .pt-sm-5 {
        padding-top: 3rem !important
    }

    .pt-sm-6 {
        padding-top: 5rem !important
    }

    .pt-sm-7 {
        padding-top: 8rem !important
    }

    .pt-sm-8 {
        padding-top: 10rem !important
    }

    .pt-sm-9 {
        padding-top: 11rem !important
    }

    .pt-sm-10 {
        padding-top: 14rem !important
    }

    .pt-sm-11 {
        padding-top: 16rem !important
    }

    .pt-sm-12 {
        padding-top: 20rem !important
    }

    .pt-sm-sm {
        padding-top: 1rem !important
    }

    .pt-sm-md {
        padding-top: 2rem !important
    }

    .pt-sm-lg {
        padding-top: 4rem !important
    }

    .pt-sm-xl {
        padding-top: 8rem !important
    }

    .pe-sm-0 {
        padding-right: 0 !important
    }

    .pe-sm-1 {
        padding-right: .25rem !important
    }

    .pe-sm-2 {
        padding-right: .5rem !important
    }

    .pe-sm-3 {
        padding-right: 1rem !important
    }

    .pe-sm-4 {
        padding-right: 1.5rem !important
    }

    .pe-sm-5 {
        padding-right: 3rem !important
    }

    .pe-sm-6 {
        padding-right: 5rem !important
    }

    .pe-sm-7 {
        padding-right: 8rem !important
    }

    .pe-sm-8 {
        padding-right: 10rem !important
    }

    .pe-sm-9 {
        padding-right: 11rem !important
    }

    .pe-sm-10 {
        padding-right: 14rem !important
    }

    .pe-sm-11 {
        padding-right: 16rem !important
    }

    .pe-sm-12 {
        padding-right: 20rem !important
    }

    .pe-sm-sm {
        padding-right: 1rem !important
    }

    .pe-sm-md {
        padding-right: 2rem !important
    }

    .pe-sm-lg {
        padding-right: 4rem !important
    }

    .pe-sm-xl {
        padding-right: 8rem !important
    }

    .pb-sm-0 {
        padding-bottom: 0 !important
    }

    .pb-sm-1 {
        padding-bottom: .25rem !important
    }

    .pb-sm-2 {
        padding-bottom: .5rem !important
    }

    .pb-sm-3 {
        padding-bottom: 1rem !important
    }

    .pb-sm-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-sm-5 {
        padding-bottom: 3rem !important
    }

    .pb-sm-6 {
        padding-bottom: 5rem !important
    }

    .pb-sm-7 {
        padding-bottom: 8rem !important
    }

    .pb-sm-8 {
        padding-bottom: 10rem !important
    }

    .pb-sm-9 {
        padding-bottom: 11rem !important
    }

    .pb-sm-10 {
        padding-bottom: 14rem !important
    }

    .pb-sm-11 {
        padding-bottom: 16rem !important
    }

    .pb-sm-12 {
        padding-bottom: 20rem !important
    }

    .pb-sm-sm {
        padding-bottom: 1rem !important
    }

    .pb-sm-md {
        padding-bottom: 2rem !important
    }

    .pb-sm-lg {
        padding-bottom: 4rem !important
    }

    .pb-sm-xl {
        padding-bottom: 8rem !important
    }

    .ps-sm-0 {
        padding-left: 0 !important
    }

    .ps-sm-1 {
        padding-left: .25rem !important
    }

    .ps-sm-2 {
        padding-left: .5rem !important
    }

    .ps-sm-3 {
        padding-left: 1rem !important
    }

    .ps-sm-4 {
        padding-left: 1.5rem !important
    }

    .ps-sm-5 {
        padding-left: 3rem !important
    }

    .ps-sm-6 {
        padding-left: 5rem !important
    }

    .ps-sm-7 {
        padding-left: 8rem !important
    }

    .ps-sm-8 {
        padding-left: 10rem !important
    }

    .ps-sm-9 {
        padding-left: 11rem !important
    }

    .ps-sm-10 {
        padding-left: 14rem !important
    }

    .ps-sm-11 {
        padding-left: 16rem !important
    }

    .ps-sm-12 {
        padding-left: 20rem !important
    }

    .ps-sm-sm {
        padding-left: 1rem !important
    }

    .ps-sm-md {
        padding-left: 2rem !important
    }

    .ps-sm-lg {
        padding-left: 4rem !important
    }

    .ps-sm-xl {
        padding-left: 8rem !important
    }

    .text-sm-start {
        text-align: left !important
    }

    .text-sm-end {
        text-align: right !important
    }

    .text-sm-center {
        text-align: center !important
    }
}

@media (min-width: 768px) {
    .float-md-start {
        float: left !important
    }

    .float-md-end {
        float: right !important
    }

    .float-md-none {
        float: none !important
    }

    .d-md-inline {
        display: inline !important
    }

    .d-md-inline-block {
        display: inline-block !important
    }

    .d-md-block {
        display: block !important
    }

    .d-md-grid {
        display: grid !important
    }

    .d-md-table {
        display: table !important
    }

    .d-md-table-row {
        display: table-row !important
    }

    .d-md-table-cell {
        display: table-cell !important
    }

    .d-md-flex {
        display: flex !important
    }

    .d-md-inline-flex {
        display: inline-flex !important
    }

    .d-md-none {
        display: none !important
    }

    .vh-md-100 {
        height: 100vh !important
    }

    .flex-md-fill {
        flex: 1 1 auto !important
    }

    .flex-md-row {
        flex-direction: row !important
    }

    .flex-md-column {
        flex-direction: column !important
    }

    .flex-md-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-md-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-md-grow-0 {
        flex-grow: 0 !important
    }

    .flex-md-grow-1 {
        flex-grow: 1 !important
    }

    .flex-md-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-md-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-md-wrap {
        flex-wrap: wrap !important
    }

    .flex-md-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-md-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .gap-md-0 {
        gap: 0 !important
    }

    .gap-md-1 {
        gap: .25rem !important
    }

    .gap-md-2 {
        gap: .5rem !important
    }

    .gap-md-3 {
        gap: 1rem !important
    }

    .gap-md-4 {
        gap: 1.5rem !important
    }

    .gap-md-5 {
        gap: 3rem !important
    }

    .gap-md-6 {
        gap: 5rem !important
    }

    .gap-md-7 {
        gap: 8rem !important
    }

    .gap-md-8 {
        gap: 10rem !important
    }

    .gap-md-9 {
        gap: 11rem !important
    }

    .gap-md-10 {
        gap: 14rem !important
    }

    .gap-md-11 {
        gap: 16rem !important
    }

    .gap-md-12 {
        gap: 20rem !important
    }

    .gap-md-sm {
        gap: 1rem !important
    }

    .gap-md-md {
        gap: 2rem !important
    }

    .gap-md-lg {
        gap: 4rem !important
    }

    .gap-md-xl {
        gap: 8rem !important
    }

    .justify-content-md-start {
        justify-content: flex-start !important
    }

    .justify-content-md-end {
        justify-content: flex-end !important
    }

    .justify-content-md-center {
        justify-content: center !important
    }

    .justify-content-md-between {
        justify-content: space-between !important
    }

    .justify-content-md-around {
        justify-content: space-around !important
    }

    .justify-content-md-evenly {
        justify-content: space-evenly !important
    }

    .align-items-md-start {
        align-items: flex-start !important
    }

    .align-items-md-end {
        align-items: flex-end !important
    }

    .align-items-md-center {
        align-items: center !important
    }

    .align-items-md-baseline {
        align-items: baseline !important
    }

    .align-items-md-stretch {
        align-items: stretch !important
    }

    .align-content-md-start {
        align-content: flex-start !important
    }

    .align-content-md-end {
        align-content: flex-end !important
    }

    .align-content-md-center {
        align-content: center !important
    }

    .align-content-md-between {
        align-content: space-between !important
    }

    .align-content-md-around {
        align-content: space-around !important
    }

    .align-content-md-stretch {
        align-content: stretch !important
    }

    .align-self-md-auto {
        align-self: auto !important
    }

    .align-self-md-start {
        align-self: flex-start !important
    }

    .align-self-md-end {
        align-self: flex-end !important
    }

    .align-self-md-center {
        align-self: center !important
    }

    .align-self-md-baseline {
        align-self: baseline !important
    }

    .align-self-md-stretch {
        align-self: stretch !important
    }

    .order-md-first {
        order: -1 !important
    }

    .order-md-0 {
        order: 0 !important
    }

    .order-md-1 {
        order: 1 !important
    }

    .order-md-2 {
        order: 2 !important
    }

    .order-md-3 {
        order: 3 !important
    }

    .order-md-4 {
        order: 4 !important
    }

    .order-md-5 {
        order: 5 !important
    }

    .order-md-last {
        order: 6 !important
    }

    .m-md-0 {
        margin: 0 !important
    }

    .m-md-1 {
        margin: .25rem !important
    }

    .m-md-2 {
        margin: .5rem !important
    }

    .m-md-3 {
        margin: 1rem !important
    }

    .m-md-4 {
        margin: 1.5rem !important
    }

    .m-md-5 {
        margin: 3rem !important
    }

    .m-md-6 {
        margin: 5rem !important
    }

    .m-md-7 {
        margin: 8rem !important
    }

    .m-md-8 {
        margin: 10rem !important
    }

    .m-md-9 {
        margin: 11rem !important
    }

    .m-md-10 {
        margin: 14rem !important
    }

    .m-md-11 {
        margin: 16rem !important
    }

    .m-md-12 {
        margin: 20rem !important
    }

    .m-md-sm {
        margin: 1rem !important
    }

    .m-md-md {
        margin: 2rem !important
    }

    .m-md-lg {
        margin: 4rem !important
    }

    .m-md-xl {
        margin: 8rem !important
    }

    .m-md-auto {
        margin: auto !important
    }

    .mx-md-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-md-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-md-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-md-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-md-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-md-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-md-6 {
        margin-right: 5rem !important;
        margin-left: 5rem !important
    }

    .mx-md-7 {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-md-8 {
        margin-right: 10rem !important;
        margin-left: 10rem !important
    }

    .mx-md-9 {
        margin-right: 11rem !important;
        margin-left: 11rem !important
    }

    .mx-md-10 {
        margin-right: 14rem !important;
        margin-left: 14rem !important
    }

    .mx-md-11 {
        margin-right: 16rem !important;
        margin-left: 16rem !important
    }

    .mx-md-12 {
        margin-right: 20rem !important;
        margin-left: 20rem !important
    }

    .mx-md-sm {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-md-md {
        margin-right: 2rem !important;
        margin-left: 2rem !important
    }

    .mx-md-lg {
        margin-right: 4rem !important;
        margin-left: 4rem !important
    }

    .mx-md-xl {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-md-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-md-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-md-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-md-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-md-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-md-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-md-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-md-6 {
        margin-top: 5rem !important;
        margin-bottom: 5rem !important
    }

    .my-md-7 {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-md-8 {
        margin-top: 10rem !important;
        margin-bottom: 10rem !important
    }

    .my-md-9 {
        margin-top: 11rem !important;
        margin-bottom: 11rem !important
    }

    .my-md-10 {
        margin-top: 14rem !important;
        margin-bottom: 14rem !important
    }

    .my-md-11 {
        margin-top: 16rem !important;
        margin-bottom: 16rem !important
    }

    .my-md-12 {
        margin-top: 20rem !important;
        margin-bottom: 20rem !important
    }

    .my-md-sm {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-md-md {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important
    }

    .my-md-lg {
        margin-top: 4rem !important;
        margin-bottom: 4rem !important
    }

    .my-md-xl {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-md-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-md-0 {
        margin-top: 0 !important
    }

    .mt-md-1 {
        margin-top: .25rem !important
    }

    .mt-md-2 {
        margin-top: .5rem !important
    }

    .mt-md-3 {
        margin-top: 1rem !important
    }

    .mt-md-4 {
        margin-top: 1.5rem !important
    }

    .mt-md-5 {
        margin-top: 3rem !important
    }

    .mt-md-6 {
        margin-top: 5rem !important
    }

    .mt-md-7 {
        margin-top: 8rem !important
    }

    .mt-md-8 {
        margin-top: 10rem !important
    }

    .mt-md-9 {
        margin-top: 11rem !important
    }

    .mt-md-10 {
        margin-top: 14rem !important
    }

    .mt-md-11 {
        margin-top: 16rem !important
    }

    .mt-md-12 {
        margin-top: 20rem !important
    }

    .mt-md-sm {
        margin-top: 1rem !important
    }

    .mt-md-md {
        margin-top: 2rem !important
    }

    .mt-md-lg {
        margin-top: 4rem !important
    }

    .mt-md-xl {
        margin-top: 8rem !important
    }

    .mt-md-auto {
        margin-top: auto !important
    }

    .me-md-0 {
        margin-right: 0 !important
    }

    .me-md-1 {
        margin-right: .25rem !important
    }

    .me-md-2 {
        margin-right: .5rem !important
    }

    .me-md-3 {
        margin-right: 1rem !important
    }

    .me-md-4 {
        margin-right: 1.5rem !important
    }

    .me-md-5 {
        margin-right: 3rem !important
    }

    .me-md-6 {
        margin-right: 5rem !important
    }

    .me-md-7 {
        margin-right: 8rem !important
    }

    .me-md-8 {
        margin-right: 10rem !important
    }

    .me-md-9 {
        margin-right: 11rem !important
    }

    .me-md-10 {
        margin-right: 14rem !important
    }

    .me-md-11 {
        margin-right: 16rem !important
    }

    .me-md-12 {
        margin-right: 20rem !important
    }

    .me-md-sm {
        margin-right: 1rem !important
    }

    .me-md-md {
        margin-right: 2rem !important
    }

    .me-md-lg {
        margin-right: 4rem !important
    }

    .me-md-xl {
        margin-right: 8rem !important
    }

    .me-md-auto {
        margin-right: auto !important
    }

    .mb-md-0 {
        margin-bottom: 0 !important
    }

    .mb-md-1 {
        margin-bottom: .25rem !important
    }

    .mb-md-2 {
        margin-bottom: .5rem !important
    }

    .mb-md-3 {
        margin-bottom: 1rem !important
    }

    .mb-md-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-md-5 {
        margin-bottom: 3rem !important
    }

    .mb-md-6 {
        margin-bottom: 5rem !important
    }

    .mb-md-7 {
        margin-bottom: 8rem !important
    }

    .mb-md-8 {
        margin-bottom: 10rem !important
    }

    .mb-md-9 {
        margin-bottom: 11rem !important
    }

    .mb-md-10 {
        margin-bottom: 14rem !important
    }

    .mb-md-11 {
        margin-bottom: 16rem !important
    }

    .mb-md-12 {
        margin-bottom: 20rem !important
    }

    .mb-md-sm {
        margin-bottom: 1rem !important
    }

    .mb-md-md {
        margin-bottom: 2rem !important
    }

    .mb-md-lg {
        margin-bottom: 4rem !important
    }

    .mb-md-xl {
        margin-bottom: 8rem !important
    }

    .mb-md-auto {
        margin-bottom: auto !important
    }

    .ms-md-0 {
        margin-left: 0 !important
    }

    .ms-md-1 {
        margin-left: .25rem !important
    }

    .ms-md-2 {
        margin-left: .5rem !important
    }

    .ms-md-3 {
        margin-left: 1rem !important
    }

    .ms-md-4 {
        margin-left: 1.5rem !important
    }

    .ms-md-5 {
        margin-left: 3rem !important
    }

    .ms-md-6 {
        margin-left: 5rem !important
    }

    .ms-md-7 {
        margin-left: 8rem !important
    }

    .ms-md-8 {
        margin-left: 10rem !important
    }

    .ms-md-9 {
        margin-left: 11rem !important
    }

    .ms-md-10 {
        margin-left: 14rem !important
    }

    .ms-md-11 {
        margin-left: 16rem !important
    }

    .ms-md-12 {
        margin-left: 20rem !important
    }

    .ms-md-sm {
        margin-left: 1rem !important
    }

    .ms-md-md {
        margin-left: 2rem !important
    }

    .ms-md-lg {
        margin-left: 4rem !important
    }

    .ms-md-xl {
        margin-left: 8rem !important
    }

    .ms-md-auto {
        margin-left: auto !important
    }

    .m-md-n1 {
        margin: -.25rem !important
    }

    .m-md-n2 {
        margin: -.5rem !important
    }

    .m-md-n3 {
        margin: -1rem !important
    }

    .m-md-n4 {
        margin: -1.5rem !important
    }

    .m-md-n5 {
        margin: -3rem !important
    }

    .m-md-n6 {
        margin: -5rem !important
    }

    .m-md-n7 {
        margin: -8rem !important
    }

    .m-md-n8 {
        margin: -10rem !important
    }

    .m-md-n9 {
        margin: -11rem !important
    }

    .m-md-n10 {
        margin: -14rem !important
    }

    .m-md-n11 {
        margin: -16rem !important
    }

    .m-md-n12 {
        margin: -20rem !important
    }

    .m-md-nsm {
        margin: -1rem !important
    }

    .m-md-nmd {
        margin: -2rem !important
    }

    .m-md-nlg {
        margin: -4rem !important
    }

    .m-md-nxl {
        margin: -8rem !important
    }

    .mx-md-n1 {
        margin-right: -.25rem !important;
        margin-left: -.25rem !important
    }

    .mx-md-n2 {
        margin-right: -.5rem !important;
        margin-left: -.5rem !important
    }

    .mx-md-n3 {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-md-n4 {
        margin-right: -1.5rem !important;
        margin-left: -1.5rem !important
    }

    .mx-md-n5 {
        margin-right: -3rem !important;
        margin-left: -3rem !important
    }

    .mx-md-n6 {
        margin-right: -5rem !important;
        margin-left: -5rem !important
    }

    .mx-md-n7 {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .mx-md-n8 {
        margin-right: -10rem !important;
        margin-left: -10rem !important
    }

    .mx-md-n9 {
        margin-right: -11rem !important;
        margin-left: -11rem !important
    }

    .mx-md-n10 {
        margin-right: -14rem !important;
        margin-left: -14rem !important
    }

    .mx-md-n11 {
        margin-right: -16rem !important;
        margin-left: -16rem !important
    }

    .mx-md-n12 {
        margin-right: -20rem !important;
        margin-left: -20rem !important
    }

    .mx-md-nsm {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-md-nmd {
        margin-right: -2rem !important;
        margin-left: -2rem !important
    }

    .mx-md-nlg {
        margin-right: -4rem !important;
        margin-left: -4rem !important
    }

    .mx-md-nxl {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .my-md-n1 {
        margin-top: -.25rem !important;
        margin-bottom: -.25rem !important
    }

    .my-md-n2 {
        margin-top: -.5rem !important;
        margin-bottom: -.5rem !important
    }

    .my-md-n3 {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-md-n4 {
        margin-top: -1.5rem !important;
        margin-bottom: -1.5rem !important
    }

    .my-md-n5 {
        margin-top: -3rem !important;
        margin-bottom: -3rem !important
    }

    .my-md-n6 {
        margin-top: -5rem !important;
        margin-bottom: -5rem !important
    }

    .my-md-n7 {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .my-md-n8 {
        margin-top: -10rem !important;
        margin-bottom: -10rem !important
    }

    .my-md-n9 {
        margin-top: -11rem !important;
        margin-bottom: -11rem !important
    }

    .my-md-n10 {
        margin-top: -14rem !important;
        margin-bottom: -14rem !important
    }

    .my-md-n11 {
        margin-top: -16rem !important;
        margin-bottom: -16rem !important
    }

    .my-md-n12 {
        margin-top: -20rem !important;
        margin-bottom: -20rem !important
    }

    .my-md-nsm {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-md-nmd {
        margin-top: -2rem !important;
        margin-bottom: -2rem !important
    }

    .my-md-nlg {
        margin-top: -4rem !important;
        margin-bottom: -4rem !important
    }

    .my-md-nxl {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .mt-md-n1 {
        margin-top: -.25rem !important
    }

    .mt-md-n2 {
        margin-top: -.5rem !important
    }

    .mt-md-n3 {
        margin-top: -1rem !important
    }

    .mt-md-n4 {
        margin-top: -1.5rem !important
    }

    .mt-md-n5 {
        margin-top: -3rem !important
    }

    .mt-md-n6 {
        margin-top: -5rem !important
    }

    .mt-md-n7 {
        margin-top: -8rem !important
    }

    .mt-md-n8 {
        margin-top: -10rem !important
    }

    .mt-md-n9 {
        margin-top: -11rem !important
    }

    .mt-md-n10 {
        margin-top: -14rem !important
    }

    .mt-md-n11 {
        margin-top: -16rem !important
    }

    .mt-md-n12 {
        margin-top: -20rem !important
    }

    .mt-md-nsm {
        margin-top: -1rem !important
    }

    .mt-md-nmd {
        margin-top: -2rem !important
    }

    .mt-md-nlg {
        margin-top: -4rem !important
    }

    .mt-md-nxl {
        margin-top: -8rem !important
    }

    .me-md-n1 {
        margin-right: -.25rem !important
    }

    .me-md-n2 {
        margin-right: -.5rem !important
    }

    .me-md-n3 {
        margin-right: -1rem !important
    }

    .me-md-n4 {
        margin-right: -1.5rem !important
    }

    .me-md-n5 {
        margin-right: -3rem !important
    }

    .me-md-n6 {
        margin-right: -5rem !important
    }

    .me-md-n7 {
        margin-right: -8rem !important
    }

    .me-md-n8 {
        margin-right: -10rem !important
    }

    .me-md-n9 {
        margin-right: -11rem !important
    }

    .me-md-n10 {
        margin-right: -14rem !important
    }

    .me-md-n11 {
        margin-right: -16rem !important
    }

    .me-md-n12 {
        margin-right: -20rem !important
    }

    .me-md-nsm {
        margin-right: -1rem !important
    }

    .me-md-nmd {
        margin-right: -2rem !important
    }

    .me-md-nlg {
        margin-right: -4rem !important
    }

    .me-md-nxl {
        margin-right: -8rem !important
    }

    .mb-md-n1 {
        margin-bottom: -.25rem !important
    }

    .mb-md-n2 {
        margin-bottom: -.5rem !important
    }

    .mb-md-n3 {
        margin-bottom: -1rem !important
    }

    .mb-md-n4 {
        margin-bottom: -1.5rem !important
    }

    .mb-md-n5 {
        margin-bottom: -3rem !important
    }

    .mb-md-n6 {
        margin-bottom: -5rem !important
    }

    .mb-md-n7 {
        margin-bottom: -8rem !important
    }

    .mb-md-n8 {
        margin-bottom: -10rem !important
    }

    .mb-md-n9 {
        margin-bottom: -11rem !important
    }

    .mb-md-n10 {
        margin-bottom: -14rem !important
    }

    .mb-md-n11 {
        margin-bottom: -16rem !important
    }

    .mb-md-n12 {
        margin-bottom: -20rem !important
    }

    .mb-md-nsm {
        margin-bottom: -1rem !important
    }

    .mb-md-nmd {
        margin-bottom: -2rem !important
    }

    .mb-md-nlg {
        margin-bottom: -4rem !important
    }

    .mb-md-nxl {
        margin-bottom: -8rem !important
    }

    .ms-md-n1 {
        margin-left: -.25rem !important
    }

    .ms-md-n2 {
        margin-left: -.5rem !important
    }

    .ms-md-n3 {
        margin-left: -1rem !important
    }

    .ms-md-n4 {
        margin-left: -1.5rem !important
    }

    .ms-md-n5 {
        margin-left: -3rem !important
    }

    .ms-md-n6 {
        margin-left: -5rem !important
    }

    .ms-md-n7 {
        margin-left: -8rem !important
    }

    .ms-md-n8 {
        margin-left: -10rem !important
    }

    .ms-md-n9 {
        margin-left: -11rem !important
    }

    .ms-md-n10 {
        margin-left: -14rem !important
    }

    .ms-md-n11 {
        margin-left: -16rem !important
    }

    .ms-md-n12 {
        margin-left: -20rem !important
    }

    .ms-md-nsm {
        margin-left: -1rem !important
    }

    .ms-md-nmd {
        margin-left: -2rem !important
    }

    .ms-md-nlg {
        margin-left: -4rem !important
    }

    .ms-md-nxl {
        margin-left: -8rem !important
    }

    .p-md-0 {
        padding: 0 !important
    }

    .p-md-1 {
        padding: .25rem !important
    }

    .p-md-2 {
        padding: .5rem !important
    }

    .p-md-3 {
        padding: 1rem !important
    }

    .p-md-4 {
        padding: 1.5rem !important
    }

    .p-md-5 {
        padding: 3rem !important
    }

    .p-md-6 {
        padding: 5rem !important
    }

    .p-md-7 {
        padding: 8rem !important
    }

    .p-md-8 {
        padding: 10rem !important
    }

    .p-md-9 {
        padding: 11rem !important
    }

    .p-md-10 {
        padding: 14rem !important
    }

    .p-md-11 {
        padding: 16rem !important
    }

    .p-md-12 {
        padding: 20rem !important
    }

    .p-md-sm {
        padding: 1rem !important
    }

    .p-md-md {
        padding: 2rem !important
    }

    .p-md-lg {
        padding: 4rem !important
    }

    .p-md-xl {
        padding: 8rem !important
    }

    .px-md-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-md-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-md-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-md-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-md-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-md-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .px-md-6 {
        padding-right: 5rem !important;
        padding-left: 5rem !important
    }

    .px-md-7 {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .px-md-8 {
        padding-right: 10rem !important;
        padding-left: 10rem !important
    }

    .px-md-9 {
        padding-right: 11rem !important;
        padding-left: 11rem !important
    }

    .px-md-10 {
        padding-right: 14rem !important;
        padding-left: 14rem !important
    }

    .px-md-11 {
        padding-right: 16rem !important;
        padding-left: 16rem !important
    }

    .px-md-12 {
        padding-right: 20rem !important;
        padding-left: 20rem !important
    }

    .px-md-sm {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-md-md {
        padding-right: 2rem !important;
        padding-left: 2rem !important
    }

    .px-md-lg {
        padding-right: 4rem !important;
        padding-left: 4rem !important
    }

    .px-md-xl {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .py-md-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-md-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-md-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-md-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-md-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-md-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .py-md-6 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important
    }

    .py-md-7 {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .py-md-8 {
        padding-top: 10rem !important;
        padding-bottom: 10rem !important
    }

    .py-md-9 {
        padding-top: 11rem !important;
        padding-bottom: 11rem !important
    }

    .py-md-10 {
        padding-top: 14rem !important;
        padding-bottom: 14rem !important
    }

    .py-md-11 {
        padding-top: 16rem !important;
        padding-bottom: 16rem !important
    }

    .py-md-12 {
        padding-top: 20rem !important;
        padding-bottom: 20rem !important
    }

    .py-md-sm {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-md-md {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important
    }

    .py-md-lg {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important
    }

    .py-md-xl {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .pt-md-0 {
        padding-top: 0 !important
    }

    .pt-md-1 {
        padding-top: .25rem !important
    }

    .pt-md-2 {
        padding-top: .5rem !important
    }

    .pt-md-3 {
        padding-top: 1rem !important
    }

    .pt-md-4 {
        padding-top: 1.5rem !important
    }

    .pt-md-5 {
        padding-top: 3rem !important
    }

    .pt-md-6 {
        padding-top: 5rem !important
    }

    .pt-md-7 {
        padding-top: 8rem !important
    }

    .pt-md-8 {
        padding-top: 10rem !important
    }

    .pt-md-9 {
        padding-top: 11rem !important
    }

    .pt-md-10 {
        padding-top: 14rem !important
    }

    .pt-md-11 {
        padding-top: 16rem !important
    }

    .pt-md-12 {
        padding-top: 20rem !important
    }

    .pt-md-sm {
        padding-top: 1rem !important
    }

    .pt-md-md {
        padding-top: 2rem !important
    }

    .pt-md-lg {
        padding-top: 4rem !important
    }

    .pt-md-xl {
        padding-top: 8rem !important
    }

    .pe-md-0 {
        padding-right: 0 !important
    }

    .pe-md-1 {
        padding-right: .25rem !important
    }

    .pe-md-2 {
        padding-right: .5rem !important
    }

    .pe-md-3 {
        padding-right: 1rem !important
    }

    .pe-md-4 {
        padding-right: 1.5rem !important
    }

    .pe-md-5 {
        padding-right: 3rem !important
    }

    .pe-md-6 {
        padding-right: 5rem !important
    }

    .pe-md-7 {
        padding-right: 8rem !important
    }

    .pe-md-8 {
        padding-right: 10rem !important
    }

    .pe-md-9 {
        padding-right: 11rem !important
    }

    .pe-md-10 {
        padding-right: 14rem !important
    }

    .pe-md-11 {
        padding-right: 16rem !important
    }

    .pe-md-12 {
        padding-right: 20rem !important
    }

    .pe-md-sm {
        padding-right: 1rem !important
    }

    .pe-md-md {
        padding-right: 2rem !important
    }

    .pe-md-lg {
        padding-right: 4rem !important
    }

    .pe-md-xl {
        padding-right: 8rem !important
    }

    .pb-md-0 {
        padding-bottom: 0 !important
    }

    .pb-md-1 {
        padding-bottom: .25rem !important
    }

    .pb-md-2 {
        padding-bottom: .5rem !important
    }

    .pb-md-3 {
        padding-bottom: 1rem !important
    }

    .pb-md-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-md-5 {
        padding-bottom: 3rem !important
    }

    .pb-md-6 {
        padding-bottom: 5rem !important
    }

    .pb-md-7 {
        padding-bottom: 8rem !important
    }

    .pb-md-8 {
        padding-bottom: 10rem !important
    }

    .pb-md-9 {
        padding-bottom: 11rem !important
    }

    .pb-md-10 {
        padding-bottom: 14rem !important
    }

    .pb-md-11 {
        padding-bottom: 16rem !important
    }

    .pb-md-12 {
        padding-bottom: 20rem !important
    }

    .pb-md-sm {
        padding-bottom: 1rem !important
    }

    .pb-md-md {
        padding-bottom: 2rem !important
    }

    .pb-md-lg {
        padding-bottom: 4rem !important
    }

    .pb-md-xl {
        padding-bottom: 8rem !important
    }

    .ps-md-0 {
        padding-left: 0 !important
    }

    .ps-md-1 {
        padding-left: .25rem !important
    }

    .ps-md-2 {
        padding-left: .5rem !important
    }

    .ps-md-3 {
        padding-left: 1rem !important
    }

    .ps-md-4 {
        padding-left: 1.5rem !important
    }

    .ps-md-5 {
        padding-left: 3rem !important
    }

    .ps-md-6 {
        padding-left: 5rem !important
    }

    .ps-md-7 {
        padding-left: 8rem !important
    }

    .ps-md-8 {
        padding-left: 10rem !important
    }

    .ps-md-9 {
        padding-left: 11rem !important
    }

    .ps-md-10 {
        padding-left: 14rem !important
    }

    .ps-md-11 {
        padding-left: 16rem !important
    }

    .ps-md-12 {
        padding-left: 20rem !important
    }

    .ps-md-sm {
        padding-left: 1rem !important
    }

    .ps-md-md {
        padding-left: 2rem !important
    }

    .ps-md-lg {
        padding-left: 4rem !important
    }

    .ps-md-xl {
        padding-left: 8rem !important
    }

    .text-md-start {
        text-align: left !important
    }

    .text-md-end {
        text-align: right !important
    }

    .text-md-center {
        text-align: center !important
    }
}

@media (min-width: 992px) {
    .float-lg-start {
        float: left !important
    }

    .float-lg-end {
        float: right !important
    }

    .float-lg-none {
        float: none !important
    }

    .d-lg-inline {
        display: inline !important
    }

    .d-lg-inline-block {
        display: inline-block !important
    }

    .d-lg-block {
        display: block !important
    }

    .d-lg-grid {
        display: grid !important
    }

    .d-lg-table {
        display: table !important
    }

    .d-lg-table-row {
        display: table-row !important
    }

    .d-lg-table-cell {
        display: table-cell !important
    }

    .d-lg-flex {
        display: flex !important
    }

    .d-lg-inline-flex {
        display: inline-flex !important
    }

    .d-lg-none {
        display: none !important
    }

    .vh-lg-100 {
        height: 100vh !important
    }

    .flex-lg-fill {
        flex: 1 1 auto !important
    }

    .flex-lg-row {
        flex-direction: row !important
    }

    .flex-lg-column {
        flex-direction: column !important
    }

    .flex-lg-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-lg-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-lg-grow-0 {
        flex-grow: 0 !important
    }

    .flex-lg-grow-1 {
        flex-grow: 1 !important
    }

    .flex-lg-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-lg-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-lg-wrap {
        flex-wrap: wrap !important
    }

    .flex-lg-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-lg-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .gap-lg-0 {
        gap: 0 !important
    }

    .gap-lg-1 {
        gap: .25rem !important
    }

    .gap-lg-2 {
        gap: .5rem !important
    }

    .gap-lg-3 {
        gap: 1rem !important
    }

    .gap-lg-4 {
        gap: 1.5rem !important
    }

    .gap-lg-5 {
        gap: 3rem !important
    }

    .gap-lg-6 {
        gap: 5rem !important
    }

    .gap-lg-7 {
        gap: 8rem !important
    }

    .gap-lg-8 {
        gap: 10rem !important
    }

    .gap-lg-9 {
        gap: 11rem !important
    }

    .gap-lg-10 {
        gap: 14rem !important
    }

    .gap-lg-11 {
        gap: 16rem !important
    }

    .gap-lg-12 {
        gap: 20rem !important
    }

    .gap-lg-sm {
        gap: 1rem !important
    }

    .gap-lg-md {
        gap: 2rem !important
    }

    .gap-lg-lg {
        gap: 4rem !important
    }

    .gap-lg-xl {
        gap: 8rem !important
    }

    .justify-content-lg-start {
        justify-content: flex-start !important
    }

    .justify-content-lg-end {
        justify-content: flex-end !important
    }

    .justify-content-lg-center {
        justify-content: center !important
    }

    .justify-content-lg-between {
        justify-content: space-between !important
    }

    .justify-content-lg-around {
        justify-content: space-around !important
    }

    .justify-content-lg-evenly {
        justify-content: space-evenly !important
    }

    .align-items-lg-start {
        align-items: flex-start !important
    }

    .align-items-lg-end {
        align-items: flex-end !important
    }

    .align-items-lg-center {
        align-items: center !important
    }

    .align-items-lg-baseline {
        align-items: baseline !important
    }

    .align-items-lg-stretch {
        align-items: stretch !important
    }

    .align-content-lg-start {
        align-content: flex-start !important
    }

    .align-content-lg-end {
        align-content: flex-end !important
    }

    .align-content-lg-center {
        align-content: center !important
    }

    .align-content-lg-between {
        align-content: space-between !important
    }

    .align-content-lg-around {
        align-content: space-around !important
    }

    .align-content-lg-stretch {
        align-content: stretch !important
    }

    .align-self-lg-auto {
        align-self: auto !important
    }

    .align-self-lg-start {
        align-self: flex-start !important
    }

    .align-self-lg-end {
        align-self: flex-end !important
    }

    .align-self-lg-center {
        align-self: center !important
    }

    .align-self-lg-baseline {
        align-self: baseline !important
    }

    .align-self-lg-stretch {
        align-self: stretch !important
    }

    .order-lg-first {
        order: -1 !important
    }

    .order-lg-0 {
        order: 0 !important
    }

    .order-lg-1 {
        order: 1 !important
    }

    .order-lg-2 {
        order: 2 !important
    }

    .order-lg-3 {
        order: 3 !important
    }

    .order-lg-4 {
        order: 4 !important
    }

    .order-lg-5 {
        order: 5 !important
    }

    .order-lg-last {
        order: 6 !important
    }

    .m-lg-0 {
        margin: 0 !important
    }

    .m-lg-1 {
        margin: .25rem !important
    }

    .m-lg-2 {
        margin: .5rem !important
    }

    .m-lg-3 {
        margin: 1rem !important
    }

    .m-lg-4 {
        margin: 1.5rem !important
    }

    .m-lg-5 {
        margin: 3rem !important
    }

    .m-lg-6 {
        margin: 5rem !important
    }

    .m-lg-7 {
        margin: 8rem !important
    }

    .m-lg-8 {
        margin: 10rem !important
    }

    .m-lg-9 {
        margin: 11rem !important
    }

    .m-lg-10 {
        margin: 14rem !important
    }

    .m-lg-11 {
        margin: 16rem !important
    }

    .m-lg-12 {
        margin: 20rem !important
    }

    .m-lg-sm {
        margin: 1rem !important
    }

    .m-lg-md {
        margin: 2rem !important
    }

    .m-lg-lg {
        margin: 4rem !important
    }

    .m-lg-xl {
        margin: 8rem !important
    }

    .m-lg-auto {
        margin: auto !important
    }

    .mx-lg-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-lg-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-lg-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-lg-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-lg-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-lg-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-lg-6 {
        margin-right: 5rem !important;
        margin-left: 5rem !important
    }

    .mx-lg-7 {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-lg-8 {
        margin-right: 10rem !important;
        margin-left: 10rem !important
    }

    .mx-lg-9 {
        margin-right: 11rem !important;
        margin-left: 11rem !important
    }

    .mx-lg-10 {
        margin-right: 14rem !important;
        margin-left: 14rem !important
    }

    .mx-lg-11 {
        margin-right: 16rem !important;
        margin-left: 16rem !important
    }

    .mx-lg-12 {
        margin-right: 20rem !important;
        margin-left: 20rem !important
    }

    .mx-lg-sm {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-lg-md {
        margin-right: 2rem !important;
        margin-left: 2rem !important
    }

    .mx-lg-lg {
        margin-right: 4rem !important;
        margin-left: 4rem !important
    }

    .mx-lg-xl {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-lg-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-lg-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-lg-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-lg-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-lg-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-lg-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-lg-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-lg-6 {
        margin-top: 5rem !important;
        margin-bottom: 5rem !important
    }

    .my-lg-7 {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-lg-8 {
        margin-top: 10rem !important;
        margin-bottom: 10rem !important
    }

    .my-lg-9 {
        margin-top: 11rem !important;
        margin-bottom: 11rem !important
    }

    .my-lg-10 {
        margin-top: 14rem !important;
        margin-bottom: 14rem !important
    }

    .my-lg-11 {
        margin-top: 16rem !important;
        margin-bottom: 16rem !important
    }

    .my-lg-12 {
        margin-top: 20rem !important;
        margin-bottom: 20rem !important
    }

    .my-lg-sm {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-lg-md {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important
    }

    .my-lg-lg {
        margin-top: 4rem !important;
        margin-bottom: 4rem !important
    }

    .my-lg-xl {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-lg-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-lg-0 {
        margin-top: 0 !important
    }

    .mt-lg-1 {
        margin-top: .25rem !important
    }

    .mt-lg-2 {
        margin-top: .5rem !important
    }

    .mt-lg-3 {
        margin-top: 1rem !important
    }

    .mt-lg-4 {
        margin-top: 1.5rem !important
    }

    .mt-lg-5 {
        margin-top: 3rem !important
    }

    .mt-lg-6 {
        margin-top: 5rem !important
    }

    .mt-lg-7 {
        margin-top: 8rem !important
    }

    .mt-lg-8 {
        margin-top: 10rem !important
    }

    .mt-lg-9 {
        margin-top: 11rem !important
    }

    .mt-lg-10 {
        margin-top: 14rem !important
    }

    .mt-lg-11 {
        margin-top: 16rem !important
    }

    .mt-lg-12 {
        margin-top: 20rem !important
    }

    .mt-lg-sm {
        margin-top: 1rem !important
    }

    .mt-lg-md {
        margin-top: 2rem !important
    }

    .mt-lg-lg {
        margin-top: 4rem !important
    }

    .mt-lg-xl {
        margin-top: 8rem !important
    }

    .mt-lg-auto {
        margin-top: auto !important
    }

    .me-lg-0 {
        margin-right: 0 !important
    }

    .me-lg-1 {
        margin-right: .25rem !important
    }

    .me-lg-2 {
        margin-right: .5rem !important
    }

    .me-lg-3 {
        margin-right: 1rem !important
    }

    .me-lg-4 {
        margin-right: 1.5rem !important
    }

    .me-lg-5 {
        margin-right: 3rem !important
    }

    .me-lg-6 {
        margin-right: 5rem !important
    }

    .me-lg-7 {
        margin-right: 8rem !important
    }

    .me-lg-8 {
        margin-right: 10rem !important
    }

    .me-lg-9 {
        margin-right: 11rem !important
    }

    .me-lg-10 {
        margin-right: 14rem !important
    }

    .me-lg-11 {
        margin-right: 16rem !important
    }

    .me-lg-12 {
        margin-right: 20rem !important
    }

    .me-lg-sm {
        margin-right: 1rem !important
    }

    .me-lg-md {
        margin-right: 2rem !important
    }

    .me-lg-lg {
        margin-right: 4rem !important
    }

    .me-lg-xl {
        margin-right: 8rem !important
    }

    .me-lg-auto {
        margin-right: auto !important
    }

    .mb-lg-0 {
        margin-bottom: 0 !important
    }

    .mb-lg-1 {
        margin-bottom: .25rem !important
    }

    .mb-lg-2 {
        margin-bottom: .5rem !important
    }

    .mb-lg-3 {
        margin-bottom: 1rem !important
    }

    .mb-lg-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-lg-5 {
        margin-bottom: 3rem !important
    }

    .mb-lg-6 {
        margin-bottom: 5rem !important
    }

    .mb-lg-7 {
        margin-bottom: 8rem !important
    }

    .mb-lg-8 {
        margin-bottom: 10rem !important
    }

    .mb-lg-9 {
        margin-bottom: 11rem !important
    }

    .mb-lg-10 {
        margin-bottom: 14rem !important
    }

    .mb-lg-11 {
        margin-bottom: 16rem !important
    }

    .mb-lg-12 {
        margin-bottom: 20rem !important
    }

    .mb-lg-sm {
        margin-bottom: 1rem !important
    }

    .mb-lg-md {
        margin-bottom: 2rem !important
    }

    .mb-lg-lg {
        margin-bottom: 4rem !important
    }

    .mb-lg-xl {
        margin-bottom: 8rem !important
    }

    .mb-lg-auto {
        margin-bottom: auto !important
    }

    .ms-lg-0 {
        margin-left: 0 !important
    }

    .ms-lg-1 {
        margin-left: .25rem !important
    }

    .ms-lg-2 {
        margin-left: .5rem !important
    }

    .ms-lg-3 {
        margin-left: 1rem !important
    }

    .ms-lg-4 {
        margin-left: 1.5rem !important
    }

    .ms-lg-5 {
        margin-left: 3rem !important
    }

    .ms-lg-6 {
        margin-left: 5rem !important
    }

    .ms-lg-7 {
        margin-left: 8rem !important
    }

    .ms-lg-8 {
        margin-left: 10rem !important
    }

    .ms-lg-9 {
        margin-left: 11rem !important
    }

    .ms-lg-10 {
        margin-left: 14rem !important
    }

    .ms-lg-11 {
        margin-left: 16rem !important
    }

    .ms-lg-12 {
        margin-left: 20rem !important
    }

    .ms-lg-sm {
        margin-left: 1rem !important
    }

    .ms-lg-md {
        margin-left: 2rem !important
    }

    .ms-lg-lg {
        margin-left: 4rem !important
    }

    .ms-lg-xl {
        margin-left: 8rem !important
    }

    .ms-lg-auto {
        margin-left: auto !important
    }

    .m-lg-n1 {
        margin: -.25rem !important
    }

    .m-lg-n2 {
        margin: -.5rem !important
    }

    .m-lg-n3 {
        margin: -1rem !important
    }

    .m-lg-n4 {
        margin: -1.5rem !important
    }

    .m-lg-n5 {
        margin: -3rem !important
    }

    .m-lg-n6 {
        margin: -5rem !important
    }

    .m-lg-n7 {
        margin: -8rem !important
    }

    .m-lg-n8 {
        margin: -10rem !important
    }

    .m-lg-n9 {
        margin: -11rem !important
    }

    .m-lg-n10 {
        margin: -14rem !important
    }

    .m-lg-n11 {
        margin: -16rem !important
    }

    .m-lg-n12 {
        margin: -20rem !important
    }

    .m-lg-nsm {
        margin: -1rem !important
    }

    .m-lg-nmd {
        margin: -2rem !important
    }

    .m-lg-nlg {
        margin: -4rem !important
    }

    .m-lg-nxl {
        margin: -8rem !important
    }

    .mx-lg-n1 {
        margin-right: -.25rem !important;
        margin-left: -.25rem !important
    }

    .mx-lg-n2 {
        margin-right: -.5rem !important;
        margin-left: -.5rem !important
    }

    .mx-lg-n3 {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-lg-n4 {
        margin-right: -1.5rem !important;
        margin-left: -1.5rem !important
    }

    .mx-lg-n5 {
        margin-right: -3rem !important;
        margin-left: -3rem !important
    }

    .mx-lg-n6 {
        margin-right: -5rem !important;
        margin-left: -5rem !important
    }

    .mx-lg-n7 {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .mx-lg-n8 {
        margin-right: -10rem !important;
        margin-left: -10rem !important
    }

    .mx-lg-n9 {
        margin-right: -11rem !important;
        margin-left: -11rem !important
    }

    .mx-lg-n10 {
        margin-right: -14rem !important;
        margin-left: -14rem !important
    }

    .mx-lg-n11 {
        margin-right: -16rem !important;
        margin-left: -16rem !important
    }

    .mx-lg-n12 {
        margin-right: -20rem !important;
        margin-left: -20rem !important
    }

    .mx-lg-nsm {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-lg-nmd {
        margin-right: -2rem !important;
        margin-left: -2rem !important
    }

    .mx-lg-nlg {
        margin-right: -4rem !important;
        margin-left: -4rem !important
    }

    .mx-lg-nxl {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .my-lg-n1 {
        margin-top: -.25rem !important;
        margin-bottom: -.25rem !important
    }

    .my-lg-n2 {
        margin-top: -.5rem !important;
        margin-bottom: -.5rem !important
    }

    .my-lg-n3 {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-lg-n4 {
        margin-top: -1.5rem !important;
        margin-bottom: -1.5rem !important
    }

    .my-lg-n5 {
        margin-top: -3rem !important;
        margin-bottom: -3rem !important
    }

    .my-lg-n6 {
        margin-top: -5rem !important;
        margin-bottom: -5rem !important
    }

    .my-lg-n7 {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .my-lg-n8 {
        margin-top: -10rem !important;
        margin-bottom: -10rem !important
    }

    .my-lg-n9 {
        margin-top: -11rem !important;
        margin-bottom: -11rem !important
    }

    .my-lg-n10 {
        margin-top: -14rem !important;
        margin-bottom: -14rem !important
    }

    .my-lg-n11 {
        margin-top: -16rem !important;
        margin-bottom: -16rem !important
    }

    .my-lg-n12 {
        margin-top: -20rem !important;
        margin-bottom: -20rem !important
    }

    .my-lg-nsm {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-lg-nmd {
        margin-top: -2rem !important;
        margin-bottom: -2rem !important
    }

    .my-lg-nlg {
        margin-top: -4rem !important;
        margin-bottom: -4rem !important
    }

    .my-lg-nxl {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .mt-lg-n1 {
        margin-top: -.25rem !important
    }

    .mt-lg-n2 {
        margin-top: -.5rem !important
    }

    .mt-lg-n3 {
        margin-top: -1rem !important
    }

    .mt-lg-n4 {
        margin-top: -1.5rem !important
    }

    .mt-lg-n5 {
        margin-top: -3rem !important
    }

    .mt-lg-n6 {
        margin-top: -5rem !important
    }

    .mt-lg-n7 {
        margin-top: -8rem !important
    }

    .mt-lg-n8 {
        margin-top: -10rem !important
    }

    .mt-lg-n9 {
        margin-top: -11rem !important
    }

    .mt-lg-n10 {
        margin-top: -14rem !important
    }

    .mt-lg-n11 {
        margin-top: -16rem !important
    }

    .mt-lg-n12 {
        margin-top: -20rem !important
    }

    .mt-lg-nsm {
        margin-top: -1rem !important
    }

    .mt-lg-nmd {
        margin-top: -2rem !important
    }

    .mt-lg-nlg {
        margin-top: -4rem !important
    }

    .mt-lg-nxl {
        margin-top: -8rem !important
    }

    .me-lg-n1 {
        margin-right: -.25rem !important
    }

    .me-lg-n2 {
        margin-right: -.5rem !important
    }

    .me-lg-n3 {
        margin-right: -1rem !important
    }

    .me-lg-n4 {
        margin-right: -1.5rem !important
    }

    .me-lg-n5 {
        margin-right: -3rem !important
    }

    .me-lg-n6 {
        margin-right: -5rem !important
    }

    .me-lg-n7 {
        margin-right: -8rem !important
    }

    .me-lg-n8 {
        margin-right: -10rem !important
    }

    .me-lg-n9 {
        margin-right: -11rem !important
    }

    .me-lg-n10 {
        margin-right: -14rem !important
    }

    .me-lg-n11 {
        margin-right: -16rem !important
    }

    .me-lg-n12 {
        margin-right: -20rem !important
    }

    .me-lg-nsm {
        margin-right: -1rem !important
    }

    .me-lg-nmd {
        margin-right: -2rem !important
    }

    .me-lg-nlg {
        margin-right: -4rem !important
    }

    .me-lg-nxl {
        margin-right: -8rem !important
    }

    .mb-lg-n1 {
        margin-bottom: -.25rem !important
    }

    .mb-lg-n2 {
        margin-bottom: -.5rem !important
    }

    .mb-lg-n3 {
        margin-bottom: -1rem !important
    }

    .mb-lg-n4 {
        margin-bottom: -1.5rem !important
    }

    .mb-lg-n5 {
        margin-bottom: -3rem !important
    }

    .mb-lg-n6 {
        margin-bottom: -5rem !important
    }

    .mb-lg-n7 {
        margin-bottom: -8rem !important
    }

    .mb-lg-n8 {
        margin-bottom: -10rem !important
    }

    .mb-lg-n9 {
        margin-bottom: -11rem !important
    }

    .mb-lg-n10 {
        margin-bottom: -14rem !important
    }

    .mb-lg-n11 {
        margin-bottom: -16rem !important
    }

    .mb-lg-n12 {
        margin-bottom: -20rem !important
    }

    .mb-lg-nsm {
        margin-bottom: -1rem !important
    }

    .mb-lg-nmd {
        margin-bottom: -2rem !important
    }

    .mb-lg-nlg {
        margin-bottom: -4rem !important
    }

    .mb-lg-nxl {
        margin-bottom: -8rem !important
    }

    .ms-lg-n1 {
        margin-left: -.25rem !important
    }

    .ms-lg-n2 {
        margin-left: -.5rem !important
    }

    .ms-lg-n3 {
        margin-left: -1rem !important
    }

    .ms-lg-n4 {
        margin-left: -1.5rem !important
    }

    .ms-lg-n5 {
        margin-left: -3rem !important
    }

    .ms-lg-n6 {
        margin-left: -5rem !important
    }

    .ms-lg-n7 {
        margin-left: -8rem !important
    }

    .ms-lg-n8 {
        margin-left: -10rem !important
    }

    .ms-lg-n9 {
        margin-left: -11rem !important
    }

    .ms-lg-n10 {
        margin-left: -14rem !important
    }

    .ms-lg-n11 {
        margin-left: -16rem !important
    }

    .ms-lg-n12 {
        margin-left: -20rem !important
    }

    .ms-lg-nsm {
        margin-left: -1rem !important
    }

    .ms-lg-nmd {
        margin-left: -2rem !important
    }

    .ms-lg-nlg {
        margin-left: -4rem !important
    }

    .ms-lg-nxl {
        margin-left: -8rem !important
    }

    .p-lg-0 {
        padding: 0 !important
    }

    .p-lg-1 {
        padding: .25rem !important
    }

    .p-lg-2 {
        padding: .5rem !important
    }

    .p-lg-3 {
        padding: 1rem !important
    }

    .p-lg-4 {
        padding: 1.5rem !important
    }

    .p-lg-5 {
        padding: 3rem !important
    }

    .p-lg-6 {
        padding: 5rem !important
    }

    .p-lg-7 {
        padding: 8rem !important
    }

    .p-lg-8 {
        padding: 10rem !important
    }

    .p-lg-9 {
        padding: 11rem !important
    }

    .p-lg-10 {
        padding: 14rem !important
    }

    .p-lg-11 {
        padding: 16rem !important
    }

    .p-lg-12 {
        padding: 20rem !important
    }

    .p-lg-sm {
        padding: 1rem !important
    }

    .p-lg-md {
        padding: 2rem !important
    }

    .p-lg-lg {
        padding: 4rem !important
    }

    .p-lg-xl {
        padding: 8rem !important
    }

    .px-lg-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-lg-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-lg-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-lg-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-lg-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-lg-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .px-lg-6 {
        padding-right: 5rem !important;
        padding-left: 5rem !important
    }

    .px-lg-7 {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .px-lg-8 {
        padding-right: 10rem !important;
        padding-left: 10rem !important
    }

    .px-lg-9 {
        padding-right: 11rem !important;
        padding-left: 11rem !important
    }

    .px-lg-10 {
        padding-right: 14rem !important;
        padding-left: 14rem !important
    }

    .px-lg-11 {
        padding-right: 16rem !important;
        padding-left: 16rem !important
    }

    .px-lg-12 {
        padding-right: 20rem !important;
        padding-left: 20rem !important
    }

    .px-lg-sm {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-lg-md {
        padding-right: 2rem !important;
        padding-left: 2rem !important
    }

    .px-lg-lg {
        padding-right: 4rem !important;
        padding-left: 4rem !important
    }

    .px-lg-xl {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .py-lg-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-lg-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-lg-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-lg-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-lg-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-lg-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .py-lg-6 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important
    }

    .py-lg-7 {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .py-lg-8 {
        padding-top: 10rem !important;
        padding-bottom: 10rem !important
    }

    .py-lg-9 {
        padding-top: 11rem !important;
        padding-bottom: 11rem !important
    }

    .py-lg-10 {
        padding-top: 14rem !important;
        padding-bottom: 14rem !important
    }

    .py-lg-11 {
        padding-top: 16rem !important;
        padding-bottom: 16rem !important
    }

    .py-lg-12 {
        padding-top: 20rem !important;
        padding-bottom: 20rem !important
    }

    .py-lg-sm {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-lg-md {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important
    }

    .py-lg-lg {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important
    }

    .py-lg-xl {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .pt-lg-0 {
        padding-top: 0 !important
    }

    .pt-lg-1 {
        padding-top: .25rem !important
    }

    .pt-lg-2 {
        padding-top: .5rem !important
    }

    .pt-lg-3 {
        padding-top: 1rem !important
    }

    .pt-lg-4 {
        padding-top: 1.5rem !important
    }

    .pt-lg-5 {
        padding-top: 3rem !important
    }

    .pt-lg-6 {
        padding-top: 5rem !important
    }

    .pt-lg-7 {
        padding-top: 8rem !important
    }

    .pt-lg-8 {
        padding-top: 10rem !important
    }

    .pt-lg-9 {
        padding-top: 11rem !important
    }

    .pt-lg-10 {
        padding-top: 14rem !important
    }

    .pt-lg-11 {
        padding-top: 16rem !important
    }

    .pt-lg-12 {
        padding-top: 20rem !important
    }

    .pt-lg-sm {
        padding-top: 1rem !important
    }

    .pt-lg-md {
        padding-top: 2rem !important
    }

    .pt-lg-lg {
        padding-top: 4rem !important
    }

    .pt-lg-xl {
        padding-top: 8rem !important
    }

    .pe-lg-0 {
        padding-right: 0 !important
    }

    .pe-lg-1 {
        padding-right: .25rem !important
    }

    .pe-lg-2 {
        padding-right: .5rem !important
    }

    .pe-lg-3 {
        padding-right: 1rem !important
    }

    .pe-lg-4 {
        padding-right: 1.5rem !important
    }

    .pe-lg-5 {
        padding-right: 3rem !important
    }

    .pe-lg-6 {
        padding-right: 5rem !important
    }

    .pe-lg-7 {
        padding-right: 8rem !important
    }

    .pe-lg-8 {
        padding-right: 10rem !important
    }

    .pe-lg-9 {
        padding-right: 11rem !important
    }

    .pe-lg-10 {
        padding-right: 14rem !important
    }

    .pe-lg-11 {
        padding-right: 16rem !important
    }

    .pe-lg-12 {
        padding-right: 20rem !important
    }

    .pe-lg-sm {
        padding-right: 1rem !important
    }

    .pe-lg-md {
        padding-right: 2rem !important
    }

    .pe-lg-lg {
        padding-right: 4rem !important
    }

    .pe-lg-xl {
        padding-right: 8rem !important
    }

    .pb-lg-0 {
        padding-bottom: 0 !important
    }

    .pb-lg-1 {
        padding-bottom: .25rem !important
    }

    .pb-lg-2 {
        padding-bottom: .5rem !important
    }

    .pb-lg-3 {
        padding-bottom: 1rem !important
    }

    .pb-lg-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-lg-5 {
        padding-bottom: 3rem !important
    }

    .pb-lg-6 {
        padding-bottom: 5rem !important
    }

    .pb-lg-7 {
        padding-bottom: 8rem !important
    }

    .pb-lg-8 {
        padding-bottom: 10rem !important
    }

    .pb-lg-9 {
        padding-bottom: 11rem !important
    }

    .pb-lg-10 {
        padding-bottom: 14rem !important
    }

    .pb-lg-11 {
        padding-bottom: 16rem !important
    }

    .pb-lg-12 {
        padding-bottom: 20rem !important
    }

    .pb-lg-sm {
        padding-bottom: 1rem !important
    }

    .pb-lg-md {
        padding-bottom: 2rem !important
    }

    .pb-lg-lg {
        padding-bottom: 4rem !important
    }

    .pb-lg-xl {
        padding-bottom: 8rem !important
    }

    .ps-lg-0 {
        padding-left: 0 !important
    }

    .ps-lg-1 {
        padding-left: .25rem !important
    }

    .ps-lg-2 {
        padding-left: .5rem !important
    }

    .ps-lg-3 {
        padding-left: 1rem !important
    }

    .ps-lg-4 {
        padding-left: 1.5rem !important
    }

    .ps-lg-5 {
        padding-left: 3rem !important
    }

    .ps-lg-6 {
        padding-left: 5rem !important
    }

    .ps-lg-7 {
        padding-left: 8rem !important
    }

    .ps-lg-8 {
        padding-left: 10rem !important
    }

    .ps-lg-9 {
        padding-left: 11rem !important
    }

    .ps-lg-10 {
        padding-left: 14rem !important
    }

    .ps-lg-11 {
        padding-left: 16rem !important
    }

    .ps-lg-12 {
        padding-left: 20rem !important
    }

    .ps-lg-sm {
        padding-left: 1rem !important
    }

    .ps-lg-md {
        padding-left: 2rem !important
    }

    .ps-lg-lg {
        padding-left: 4rem !important
    }

    .ps-lg-xl {
        padding-left: 8rem !important
    }

    .text-lg-start {
        text-align: left !important
    }

    .text-lg-end {
        text-align: right !important
    }

    .text-lg-center {
        text-align: center !important
    }
}

@media (min-width: 1200px) {
    .float-xl-start {
        float: left !important
    }

    .float-xl-end {
        float: right !important
    }

    .float-xl-none {
        float: none !important
    }

    .d-xl-inline {
        display: inline !important
    }

    .d-xl-inline-block {
        display: inline-block !important
    }

    .d-xl-block {
        display: block !important
    }

    .d-xl-grid {
        display: grid !important
    }

    .d-xl-table {
        display: table !important
    }

    .d-xl-table-row {
        display: table-row !important
    }

    .d-xl-table-cell {
        display: table-cell !important
    }

    .d-xl-flex {
        display: flex !important
    }

    .d-xl-inline-flex {
        display: inline-flex !important
    }

    .d-xl-none {
        display: none !important
    }

    .vh-xl-100 {
        height: 100vh !important
    }

    .flex-xl-fill {
        flex: 1 1 auto !important
    }

    .flex-xl-row {
        flex-direction: row !important
    }

    .flex-xl-column {
        flex-direction: column !important
    }

    .flex-xl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xl-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-xl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .gap-xl-0 {
        gap: 0 !important
    }

    .gap-xl-1 {
        gap: .25rem !important
    }

    .gap-xl-2 {
        gap: .5rem !important
    }

    .gap-xl-3 {
        gap: 1rem !important
    }

    .gap-xl-4 {
        gap: 1.5rem !important
    }

    .gap-xl-5 {
        gap: 3rem !important
    }

    .gap-xl-6 {
        gap: 5rem !important
    }

    .gap-xl-7 {
        gap: 8rem !important
    }

    .gap-xl-8 {
        gap: 10rem !important
    }

    .gap-xl-9 {
        gap: 11rem !important
    }

    .gap-xl-10 {
        gap: 14rem !important
    }

    .gap-xl-11 {
        gap: 16rem !important
    }

    .gap-xl-12 {
        gap: 20rem !important
    }

    .gap-xl-sm {
        gap: 1rem !important
    }

    .gap-xl-md {
        gap: 2rem !important
    }

    .gap-xl-lg {
        gap: 4rem !important
    }

    .gap-xl-xl {
        gap: 8rem !important
    }

    .justify-content-xl-start {
        justify-content: flex-start !important
    }

    .justify-content-xl-end {
        justify-content: flex-end !important
    }

    .justify-content-xl-center {
        justify-content: center !important
    }

    .justify-content-xl-between {
        justify-content: space-between !important
    }

    .justify-content-xl-around {
        justify-content: space-around !important
    }

    .justify-content-xl-evenly {
        justify-content: space-evenly !important
    }

    .align-items-xl-start {
        align-items: flex-start !important
    }

    .align-items-xl-end {
        align-items: flex-end !important
    }

    .align-items-xl-center {
        align-items: center !important
    }

    .align-items-xl-baseline {
        align-items: baseline !important
    }

    .align-items-xl-stretch {
        align-items: stretch !important
    }

    .align-content-xl-start {
        align-content: flex-start !important
    }

    .align-content-xl-end {
        align-content: flex-end !important
    }

    .align-content-xl-center {
        align-content: center !important
    }

    .align-content-xl-between {
        align-content: space-between !important
    }

    .align-content-xl-around {
        align-content: space-around !important
    }

    .align-content-xl-stretch {
        align-content: stretch !important
    }

    .align-self-xl-auto {
        align-self: auto !important
    }

    .align-self-xl-start {
        align-self: flex-start !important
    }

    .align-self-xl-end {
        align-self: flex-end !important
    }

    .align-self-xl-center {
        align-self: center !important
    }

    .align-self-xl-baseline {
        align-self: baseline !important
    }

    .align-self-xl-stretch {
        align-self: stretch !important
    }

    .order-xl-first {
        order: -1 !important
    }

    .order-xl-0 {
        order: 0 !important
    }

    .order-xl-1 {
        order: 1 !important
    }

    .order-xl-2 {
        order: 2 !important
    }

    .order-xl-3 {
        order: 3 !important
    }

    .order-xl-4 {
        order: 4 !important
    }

    .order-xl-5 {
        order: 5 !important
    }

    .order-xl-last {
        order: 6 !important
    }

    .m-xl-0 {
        margin: 0 !important
    }

    .m-xl-1 {
        margin: .25rem !important
    }

    .m-xl-2 {
        margin: .5rem !important
    }

    .m-xl-3 {
        margin: 1rem !important
    }

    .m-xl-4 {
        margin: 1.5rem !important
    }

    .m-xl-5 {
        margin: 3rem !important
    }

    .m-xl-6 {
        margin: 5rem !important
    }

    .m-xl-7 {
        margin: 8rem !important
    }

    .m-xl-8 {
        margin: 10rem !important
    }

    .m-xl-9 {
        margin: 11rem !important
    }

    .m-xl-10 {
        margin: 14rem !important
    }

    .m-xl-11 {
        margin: 16rem !important
    }

    .m-xl-12 {
        margin: 20rem !important
    }

    .m-xl-sm {
        margin: 1rem !important
    }

    .m-xl-md {
        margin: 2rem !important
    }

    .m-xl-lg {
        margin: 4rem !important
    }

    .m-xl-xl {
        margin: 8rem !important
    }

    .m-xl-auto {
        margin: auto !important
    }

    .mx-xl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-xl-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-xl-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-xl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-xl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-xl-6 {
        margin-right: 5rem !important;
        margin-left: 5rem !important
    }

    .mx-xl-7 {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-xl-8 {
        margin-right: 10rem !important;
        margin-left: 10rem !important
    }

    .mx-xl-9 {
        margin-right: 11rem !important;
        margin-left: 11rem !important
    }

    .mx-xl-10 {
        margin-right: 14rem !important;
        margin-left: 14rem !important
    }

    .mx-xl-11 {
        margin-right: 16rem !important;
        margin-left: 16rem !important
    }

    .mx-xl-12 {
        margin-right: 20rem !important;
        margin-left: 20rem !important
    }

    .mx-xl-sm {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xl-md {
        margin-right: 2rem !important;
        margin-left: 2rem !important
    }

    .mx-xl-lg {
        margin-right: 4rem !important;
        margin-left: 4rem !important
    }

    .mx-xl-xl {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-xl-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-xl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-xl-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-xl-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-xl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-xl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-xl-6 {
        margin-top: 5rem !important;
        margin-bottom: 5rem !important
    }

    .my-xl-7 {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-xl-8 {
        margin-top: 10rem !important;
        margin-bottom: 10rem !important
    }

    .my-xl-9 {
        margin-top: 11rem !important;
        margin-bottom: 11rem !important
    }

    .my-xl-10 {
        margin-top: 14rem !important;
        margin-bottom: 14rem !important
    }

    .my-xl-11 {
        margin-top: 16rem !important;
        margin-bottom: 16rem !important
    }

    .my-xl-12 {
        margin-top: 20rem !important;
        margin-bottom: 20rem !important
    }

    .my-xl-sm {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xl-md {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important
    }

    .my-xl-lg {
        margin-top: 4rem !important;
        margin-bottom: 4rem !important
    }

    .my-xl-xl {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-xl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-xl-0 {
        margin-top: 0 !important
    }

    .mt-xl-1 {
        margin-top: .25rem !important
    }

    .mt-xl-2 {
        margin-top: .5rem !important
    }

    .mt-xl-3 {
        margin-top: 1rem !important
    }

    .mt-xl-4 {
        margin-top: 1.5rem !important
    }

    .mt-xl-5 {
        margin-top: 3rem !important
    }

    .mt-xl-6 {
        margin-top: 5rem !important
    }

    .mt-xl-7 {
        margin-top: 8rem !important
    }

    .mt-xl-8 {
        margin-top: 10rem !important
    }

    .mt-xl-9 {
        margin-top: 11rem !important
    }

    .mt-xl-10 {
        margin-top: 14rem !important
    }

    .mt-xl-11 {
        margin-top: 16rem !important
    }

    .mt-xl-12 {
        margin-top: 20rem !important
    }

    .mt-xl-sm {
        margin-top: 1rem !important
    }

    .mt-xl-md {
        margin-top: 2rem !important
    }

    .mt-xl-lg {
        margin-top: 4rem !important
    }

    .mt-xl-xl {
        margin-top: 8rem !important
    }

    .mt-xl-auto {
        margin-top: auto !important
    }

    .me-xl-0 {
        margin-right: 0 !important
    }

    .me-xl-1 {
        margin-right: .25rem !important
    }

    .me-xl-2 {
        margin-right: .5rem !important
    }

    .me-xl-3 {
        margin-right: 1rem !important
    }

    .me-xl-4 {
        margin-right: 1.5rem !important
    }

    .me-xl-5 {
        margin-right: 3rem !important
    }

    .me-xl-6 {
        margin-right: 5rem !important
    }

    .me-xl-7 {
        margin-right: 8rem !important
    }

    .me-xl-8 {
        margin-right: 10rem !important
    }

    .me-xl-9 {
        margin-right: 11rem !important
    }

    .me-xl-10 {
        margin-right: 14rem !important
    }

    .me-xl-11 {
        margin-right: 16rem !important
    }

    .me-xl-12 {
        margin-right: 20rem !important
    }

    .me-xl-sm {
        margin-right: 1rem !important
    }

    .me-xl-md {
        margin-right: 2rem !important
    }

    .me-xl-lg {
        margin-right: 4rem !important
    }

    .me-xl-xl {
        margin-right: 8rem !important
    }

    .me-xl-auto {
        margin-right: auto !important
    }

    .mb-xl-0 {
        margin-bottom: 0 !important
    }

    .mb-xl-1 {
        margin-bottom: .25rem !important
    }

    .mb-xl-2 {
        margin-bottom: .5rem !important
    }

    .mb-xl-3 {
        margin-bottom: 1rem !important
    }

    .mb-xl-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-xl-5 {
        margin-bottom: 3rem !important
    }

    .mb-xl-6 {
        margin-bottom: 5rem !important
    }

    .mb-xl-7 {
        margin-bottom: 8rem !important
    }

    .mb-xl-8 {
        margin-bottom: 10rem !important
    }

    .mb-xl-9 {
        margin-bottom: 11rem !important
    }

    .mb-xl-10 {
        margin-bottom: 14rem !important
    }

    .mb-xl-11 {
        margin-bottom: 16rem !important
    }

    .mb-xl-12 {
        margin-bottom: 20rem !important
    }

    .mb-xl-sm {
        margin-bottom: 1rem !important
    }

    .mb-xl-md {
        margin-bottom: 2rem !important
    }

    .mb-xl-lg {
        margin-bottom: 4rem !important
    }

    .mb-xl-xl {
        margin-bottom: 8rem !important
    }

    .mb-xl-auto {
        margin-bottom: auto !important
    }

    .ms-xl-0 {
        margin-left: 0 !important
    }

    .ms-xl-1 {
        margin-left: .25rem !important
    }

    .ms-xl-2 {
        margin-left: .5rem !important
    }

    .ms-xl-3 {
        margin-left: 1rem !important
    }

    .ms-xl-4 {
        margin-left: 1.5rem !important
    }

    .ms-xl-5 {
        margin-left: 3rem !important
    }

    .ms-xl-6 {
        margin-left: 5rem !important
    }

    .ms-xl-7 {
        margin-left: 8rem !important
    }

    .ms-xl-8 {
        margin-left: 10rem !important
    }

    .ms-xl-9 {
        margin-left: 11rem !important
    }

    .ms-xl-10 {
        margin-left: 14rem !important
    }

    .ms-xl-11 {
        margin-left: 16rem !important
    }

    .ms-xl-12 {
        margin-left: 20rem !important
    }

    .ms-xl-sm {
        margin-left: 1rem !important
    }

    .ms-xl-md {
        margin-left: 2rem !important
    }

    .ms-xl-lg {
        margin-left: 4rem !important
    }

    .ms-xl-xl {
        margin-left: 8rem !important
    }

    .ms-xl-auto {
        margin-left: auto !important
    }

    .m-xl-n1 {
        margin: -.25rem !important
    }

    .m-xl-n2 {
        margin: -.5rem !important
    }

    .m-xl-n3 {
        margin: -1rem !important
    }

    .m-xl-n4 {
        margin: -1.5rem !important
    }

    .m-xl-n5 {
        margin: -3rem !important
    }

    .m-xl-n6 {
        margin: -5rem !important
    }

    .m-xl-n7 {
        margin: -8rem !important
    }

    .m-xl-n8 {
        margin: -10rem !important
    }

    .m-xl-n9 {
        margin: -11rem !important
    }

    .m-xl-n10 {
        margin: -14rem !important
    }

    .m-xl-n11 {
        margin: -16rem !important
    }

    .m-xl-n12 {
        margin: -20rem !important
    }

    .m-xl-nsm {
        margin: -1rem !important
    }

    .m-xl-nmd {
        margin: -2rem !important
    }

    .m-xl-nlg {
        margin: -4rem !important
    }

    .m-xl-nxl {
        margin: -8rem !important
    }

    .mx-xl-n1 {
        margin-right: -.25rem !important;
        margin-left: -.25rem !important
    }

    .mx-xl-n2 {
        margin-right: -.5rem !important;
        margin-left: -.5rem !important
    }

    .mx-xl-n3 {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-xl-n4 {
        margin-right: -1.5rem !important;
        margin-left: -1.5rem !important
    }

    .mx-xl-n5 {
        margin-right: -3rem !important;
        margin-left: -3rem !important
    }

    .mx-xl-n6 {
        margin-right: -5rem !important;
        margin-left: -5rem !important
    }

    .mx-xl-n7 {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .mx-xl-n8 {
        margin-right: -10rem !important;
        margin-left: -10rem !important
    }

    .mx-xl-n9 {
        margin-right: -11rem !important;
        margin-left: -11rem !important
    }

    .mx-xl-n10 {
        margin-right: -14rem !important;
        margin-left: -14rem !important
    }

    .mx-xl-n11 {
        margin-right: -16rem !important;
        margin-left: -16rem !important
    }

    .mx-xl-n12 {
        margin-right: -20rem !important;
        margin-left: -20rem !important
    }

    .mx-xl-nsm {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-xl-nmd {
        margin-right: -2rem !important;
        margin-left: -2rem !important
    }

    .mx-xl-nlg {
        margin-right: -4rem !important;
        margin-left: -4rem !important
    }

    .mx-xl-nxl {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .my-xl-n1 {
        margin-top: -.25rem !important;
        margin-bottom: -.25rem !important
    }

    .my-xl-n2 {
        margin-top: -.5rem !important;
        margin-bottom: -.5rem !important
    }

    .my-xl-n3 {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-xl-n4 {
        margin-top: -1.5rem !important;
        margin-bottom: -1.5rem !important
    }

    .my-xl-n5 {
        margin-top: -3rem !important;
        margin-bottom: -3rem !important
    }

    .my-xl-n6 {
        margin-top: -5rem !important;
        margin-bottom: -5rem !important
    }

    .my-xl-n7 {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .my-xl-n8 {
        margin-top: -10rem !important;
        margin-bottom: -10rem !important
    }

    .my-xl-n9 {
        margin-top: -11rem !important;
        margin-bottom: -11rem !important
    }

    .my-xl-n10 {
        margin-top: -14rem !important;
        margin-bottom: -14rem !important
    }

    .my-xl-n11 {
        margin-top: -16rem !important;
        margin-bottom: -16rem !important
    }

    .my-xl-n12 {
        margin-top: -20rem !important;
        margin-bottom: -20rem !important
    }

    .my-xl-nsm {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-xl-nmd {
        margin-top: -2rem !important;
        margin-bottom: -2rem !important
    }

    .my-xl-nlg {
        margin-top: -4rem !important;
        margin-bottom: -4rem !important
    }

    .my-xl-nxl {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .mt-xl-n1 {
        margin-top: -.25rem !important
    }

    .mt-xl-n2 {
        margin-top: -.5rem !important
    }

    .mt-xl-n3 {
        margin-top: -1rem !important
    }

    .mt-xl-n4 {
        margin-top: -1.5rem !important
    }

    .mt-xl-n5 {
        margin-top: -3rem !important
    }

    .mt-xl-n6 {
        margin-top: -5rem !important
    }

    .mt-xl-n7 {
        margin-top: -8rem !important
    }

    .mt-xl-n8 {
        margin-top: -10rem !important
    }

    .mt-xl-n9 {
        margin-top: -11rem !important
    }

    .mt-xl-n10 {
        margin-top: -14rem !important
    }

    .mt-xl-n11 {
        margin-top: -16rem !important
    }

    .mt-xl-n12 {
        margin-top: -20rem !important
    }

    .mt-xl-nsm {
        margin-top: -1rem !important
    }

    .mt-xl-nmd {
        margin-top: -2rem !important
    }

    .mt-xl-nlg {
        margin-top: -4rem !important
    }

    .mt-xl-nxl {
        margin-top: -8rem !important
    }

    .me-xl-n1 {
        margin-right: -.25rem !important
    }

    .me-xl-n2 {
        margin-right: -.5rem !important
    }

    .me-xl-n3 {
        margin-right: -1rem !important
    }

    .me-xl-n4 {
        margin-right: -1.5rem !important
    }

    .me-xl-n5 {
        margin-right: -3rem !important
    }

    .me-xl-n6 {
        margin-right: -5rem !important
    }

    .me-xl-n7 {
        margin-right: -8rem !important
    }

    .me-xl-n8 {
        margin-right: -10rem !important
    }

    .me-xl-n9 {
        margin-right: -11rem !important
    }

    .me-xl-n10 {
        margin-right: -14rem !important
    }

    .me-xl-n11 {
        margin-right: -16rem !important
    }

    .me-xl-n12 {
        margin-right: -20rem !important
    }

    .me-xl-nsm {
        margin-right: -1rem !important
    }

    .me-xl-nmd {
        margin-right: -2rem !important
    }

    .me-xl-nlg {
        margin-right: -4rem !important
    }

    .me-xl-nxl {
        margin-right: -8rem !important
    }

    .mb-xl-n1 {
        margin-bottom: -.25rem !important
    }

    .mb-xl-n2 {
        margin-bottom: -.5rem !important
    }

    .mb-xl-n3 {
        margin-bottom: -1rem !important
    }

    .mb-xl-n4 {
        margin-bottom: -1.5rem !important
    }

    .mb-xl-n5 {
        margin-bottom: -3rem !important
    }

    .mb-xl-n6 {
        margin-bottom: -5rem !important
    }

    .mb-xl-n7 {
        margin-bottom: -8rem !important
    }

    .mb-xl-n8 {
        margin-bottom: -10rem !important
    }

    .mb-xl-n9 {
        margin-bottom: -11rem !important
    }

    .mb-xl-n10 {
        margin-bottom: -14rem !important
    }

    .mb-xl-n11 {
        margin-bottom: -16rem !important
    }

    .mb-xl-n12 {
        margin-bottom: -20rem !important
    }

    .mb-xl-nsm {
        margin-bottom: -1rem !important
    }

    .mb-xl-nmd {
        margin-bottom: -2rem !important
    }

    .mb-xl-nlg {
        margin-bottom: -4rem !important
    }

    .mb-xl-nxl {
        margin-bottom: -8rem !important
    }

    .ms-xl-n1 {
        margin-left: -.25rem !important
    }

    .ms-xl-n2 {
        margin-left: -.5rem !important
    }

    .ms-xl-n3 {
        margin-left: -1rem !important
    }

    .ms-xl-n4 {
        margin-left: -1.5rem !important
    }

    .ms-xl-n5 {
        margin-left: -3rem !important
    }

    .ms-xl-n6 {
        margin-left: -5rem !important
    }

    .ms-xl-n7 {
        margin-left: -8rem !important
    }

    .ms-xl-n8 {
        margin-left: -10rem !important
    }

    .ms-xl-n9 {
        margin-left: -11rem !important
    }

    .ms-xl-n10 {
        margin-left: -14rem !important
    }

    .ms-xl-n11 {
        margin-left: -16rem !important
    }

    .ms-xl-n12 {
        margin-left: -20rem !important
    }

    .ms-xl-nsm {
        margin-left: -1rem !important
    }

    .ms-xl-nmd {
        margin-left: -2rem !important
    }

    .ms-xl-nlg {
        margin-left: -4rem !important
    }

    .ms-xl-nxl {
        margin-left: -8rem !important
    }

    .p-xl-0 {
        padding: 0 !important
    }

    .p-xl-1 {
        padding: .25rem !important
    }

    .p-xl-2 {
        padding: .5rem !important
    }

    .p-xl-3 {
        padding: 1rem !important
    }

    .p-xl-4 {
        padding: 1.5rem !important
    }

    .p-xl-5 {
        padding: 3rem !important
    }

    .p-xl-6 {
        padding: 5rem !important
    }

    .p-xl-7 {
        padding: 8rem !important
    }

    .p-xl-8 {
        padding: 10rem !important
    }

    .p-xl-9 {
        padding: 11rem !important
    }

    .p-xl-10 {
        padding: 14rem !important
    }

    .p-xl-11 {
        padding: 16rem !important
    }

    .p-xl-12 {
        padding: 20rem !important
    }

    .p-xl-sm {
        padding: 1rem !important
    }

    .p-xl-md {
        padding: 2rem !important
    }

    .p-xl-lg {
        padding: 4rem !important
    }

    .p-xl-xl {
        padding: 8rem !important
    }

    .px-xl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-xl-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-xl-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-xl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-xl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .px-xl-6 {
        padding-right: 5rem !important;
        padding-left: 5rem !important
    }

    .px-xl-7 {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .px-xl-8 {
        padding-right: 10rem !important;
        padding-left: 10rem !important
    }

    .px-xl-9 {
        padding-right: 11rem !important;
        padding-left: 11rem !important
    }

    .px-xl-10 {
        padding-right: 14rem !important;
        padding-left: 14rem !important
    }

    .px-xl-11 {
        padding-right: 16rem !important;
        padding-left: 16rem !important
    }

    .px-xl-12 {
        padding-right: 20rem !important;
        padding-left: 20rem !important
    }

    .px-xl-sm {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xl-md {
        padding-right: 2rem !important;
        padding-left: 2rem !important
    }

    .px-xl-lg {
        padding-right: 4rem !important;
        padding-left: 4rem !important
    }

    .px-xl-xl {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .py-xl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-xl-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-xl-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-xl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-xl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .py-xl-6 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important
    }

    .py-xl-7 {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .py-xl-8 {
        padding-top: 10rem !important;
        padding-bottom: 10rem !important
    }

    .py-xl-9 {
        padding-top: 11rem !important;
        padding-bottom: 11rem !important
    }

    .py-xl-10 {
        padding-top: 14rem !important;
        padding-bottom: 14rem !important
    }

    .py-xl-11 {
        padding-top: 16rem !important;
        padding-bottom: 16rem !important
    }

    .py-xl-12 {
        padding-top: 20rem !important;
        padding-bottom: 20rem !important
    }

    .py-xl-sm {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xl-md {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important
    }

    .py-xl-lg {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important
    }

    .py-xl-xl {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .pt-xl-0 {
        padding-top: 0 !important
    }

    .pt-xl-1 {
        padding-top: .25rem !important
    }

    .pt-xl-2 {
        padding-top: .5rem !important
    }

    .pt-xl-3 {
        padding-top: 1rem !important
    }

    .pt-xl-4 {
        padding-top: 1.5rem !important
    }

    .pt-xl-5 {
        padding-top: 3rem !important
    }

    .pt-xl-6 {
        padding-top: 5rem !important
    }

    .pt-xl-7 {
        padding-top: 8rem !important
    }

    .pt-xl-8 {
        padding-top: 10rem !important
    }

    .pt-xl-9 {
        padding-top: 11rem !important
    }

    .pt-xl-10 {
        padding-top: 14rem !important
    }

    .pt-xl-11 {
        padding-top: 16rem !important
    }

    .pt-xl-12 {
        padding-top: 20rem !important
    }

    .pt-xl-sm {
        padding-top: 1rem !important
    }

    .pt-xl-md {
        padding-top: 2rem !important
    }

    .pt-xl-lg {
        padding-top: 4rem !important
    }

    .pt-xl-xl {
        padding-top: 8rem !important
    }

    .pe-xl-0 {
        padding-right: 0 !important
    }

    .pe-xl-1 {
        padding-right: .25rem !important
    }

    .pe-xl-2 {
        padding-right: .5rem !important
    }

    .pe-xl-3 {
        padding-right: 1rem !important
    }

    .pe-xl-4 {
        padding-right: 1.5rem !important
    }

    .pe-xl-5 {
        padding-right: 3rem !important
    }

    .pe-xl-6 {
        padding-right: 5rem !important
    }

    .pe-xl-7 {
        padding-right: 8rem !important
    }

    .pe-xl-8 {
        padding-right: 10rem !important
    }

    .pe-xl-9 {
        padding-right: 11rem !important
    }

    .pe-xl-10 {
        padding-right: 14rem !important
    }

    .pe-xl-11 {
        padding-right: 16rem !important
    }

    .pe-xl-12 {
        padding-right: 20rem !important
    }

    .pe-xl-sm {
        padding-right: 1rem !important
    }

    .pe-xl-md {
        padding-right: 2rem !important
    }

    .pe-xl-lg {
        padding-right: 4rem !important
    }

    .pe-xl-xl {
        padding-right: 8rem !important
    }

    .pb-xl-0 {
        padding-bottom: 0 !important
    }

    .pb-xl-1 {
        padding-bottom: .25rem !important
    }

    .pb-xl-2 {
        padding-bottom: .5rem !important
    }

    .pb-xl-3 {
        padding-bottom: 1rem !important
    }

    .pb-xl-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-xl-5 {
        padding-bottom: 3rem !important
    }

    .pb-xl-6 {
        padding-bottom: 5rem !important
    }

    .pb-xl-7 {
        padding-bottom: 8rem !important
    }

    .pb-xl-8 {
        padding-bottom: 10rem !important
    }

    .pb-xl-9 {
        padding-bottom: 11rem !important
    }

    .pb-xl-10 {
        padding-bottom: 14rem !important
    }

    .pb-xl-11 {
        padding-bottom: 16rem !important
    }

    .pb-xl-12 {
        padding-bottom: 20rem !important
    }

    .pb-xl-sm {
        padding-bottom: 1rem !important
    }

    .pb-xl-md {
        padding-bottom: 2rem !important
    }

    .pb-xl-lg {
        padding-bottom: 4rem !important
    }

    .pb-xl-xl {
        padding-bottom: 8rem !important
    }

    .ps-xl-0 {
        padding-left: 0 !important
    }

    .ps-xl-1 {
        padding-left: .25rem !important
    }

    .ps-xl-2 {
        padding-left: .5rem !important
    }

    .ps-xl-3 {
        padding-left: 1rem !important
    }

    .ps-xl-4 {
        padding-left: 1.5rem !important
    }

    .ps-xl-5 {
        padding-left: 3rem !important
    }

    .ps-xl-6 {
        padding-left: 5rem !important
    }

    .ps-xl-7 {
        padding-left: 8rem !important
    }

    .ps-xl-8 {
        padding-left: 10rem !important
    }

    .ps-xl-9 {
        padding-left: 11rem !important
    }

    .ps-xl-10 {
        padding-left: 14rem !important
    }

    .ps-xl-11 {
        padding-left: 16rem !important
    }

    .ps-xl-12 {
        padding-left: 20rem !important
    }

    .ps-xl-sm {
        padding-left: 1rem !important
    }

    .ps-xl-md {
        padding-left: 2rem !important
    }

    .ps-xl-lg {
        padding-left: 4rem !important
    }

    .ps-xl-xl {
        padding-left: 8rem !important
    }

    .text-xl-start {
        text-align: left !important
    }

    .text-xl-end {
        text-align: right !important
    }

    .text-xl-center {
        text-align: center !important
    }
}

@media (min-width: 1400px) {
    .float-xxl-start {
        float: left !important
    }

    .float-xxl-end {
        float: right !important
    }

    .float-xxl-none {
        float: none !important
    }

    .d-xxl-inline {
        display: inline !important
    }

    .d-xxl-inline-block {
        display: inline-block !important
    }

    .d-xxl-block {
        display: block !important
    }

    .d-xxl-grid {
        display: grid !important
    }

    .d-xxl-table {
        display: table !important
    }

    .d-xxl-table-row {
        display: table-row !important
    }

    .d-xxl-table-cell {
        display: table-cell !important
    }

    .d-xxl-flex {
        display: flex !important
    }

    .d-xxl-inline-flex {
        display: inline-flex !important
    }

    .d-xxl-none {
        display: none !important
    }

    .vh-xxl-100 {
        height: 100vh !important
    }

    .flex-xxl-fill {
        flex: 1 1 auto !important
    }

    .flex-xxl-row {
        flex-direction: row !important
    }

    .flex-xxl-column {
        flex-direction: column !important
    }

    .flex-xxl-row-reverse {
        flex-direction: row-reverse !important
    }

    .flex-xxl-column-reverse {
        flex-direction: column-reverse !important
    }

    .flex-xxl-grow-0 {
        flex-grow: 0 !important
    }

    .flex-xxl-grow-1 {
        flex-grow: 1 !important
    }

    .flex-xxl-shrink-0 {
        flex-shrink: 0 !important
    }

    .flex-xxl-shrink-1 {
        flex-shrink: 1 !important
    }

    .flex-xxl-wrap {
        flex-wrap: wrap !important
    }

    .flex-xxl-nowrap {
        flex-wrap: nowrap !important
    }

    .flex-xxl-wrap-reverse {
        flex-wrap: wrap-reverse !important
    }

    .gap-xxl-0 {
        gap: 0 !important
    }

    .gap-xxl-1 {
        gap: .25rem !important
    }

    .gap-xxl-2 {
        gap: .5rem !important
    }

    .gap-xxl-3 {
        gap: 1rem !important
    }

    .gap-xxl-4 {
        gap: 1.5rem !important
    }

    .gap-xxl-5 {
        gap: 3rem !important
    }

    .gap-xxl-6 {
        gap: 5rem !important
    }

    .gap-xxl-7 {
        gap: 8rem !important
    }

    .gap-xxl-8 {
        gap: 10rem !important
    }

    .gap-xxl-9 {
        gap: 11rem !important
    }

    .gap-xxl-10 {
        gap: 14rem !important
    }

    .gap-xxl-11 {
        gap: 16rem !important
    }

    .gap-xxl-12 {
        gap: 20rem !important
    }

    .gap-xxl-sm {
        gap: 1rem !important
    }

    .gap-xxl-md {
        gap: 2rem !important
    }

    .gap-xxl-lg {
        gap: 4rem !important
    }

    .gap-xxl-xl {
        gap: 8rem !important
    }

    .justify-content-xxl-start {
        justify-content: flex-start !important
    }

    .justify-content-xxl-end {
        justify-content: flex-end !important
    }

    .justify-content-xxl-center {
        justify-content: center !important
    }

    .justify-content-xxl-between {
        justify-content: space-between !important
    }

    .justify-content-xxl-around {
        justify-content: space-around !important
    }

    .justify-content-xxl-evenly {
        justify-content: space-evenly !important
    }

    .align-items-xxl-start {
        align-items: flex-start !important
    }

    .align-items-xxl-end {
        align-items: flex-end !important
    }

    .align-items-xxl-center {
        align-items: center !important
    }

    .align-items-xxl-baseline {
        align-items: baseline !important
    }

    .align-items-xxl-stretch {
        align-items: stretch !important
    }

    .align-content-xxl-start {
        align-content: flex-start !important
    }

    .align-content-xxl-end {
        align-content: flex-end !important
    }

    .align-content-xxl-center {
        align-content: center !important
    }

    .align-content-xxl-between {
        align-content: space-between !important
    }

    .align-content-xxl-around {
        align-content: space-around !important
    }

    .align-content-xxl-stretch {
        align-content: stretch !important
    }

    .align-self-xxl-auto {
        align-self: auto !important
    }

    .align-self-xxl-start {
        align-self: flex-start !important
    }

    .align-self-xxl-end {
        align-self: flex-end !important
    }

    .align-self-xxl-center {
        align-self: center !important
    }

    .align-self-xxl-baseline {
        align-self: baseline !important
    }

    .align-self-xxl-stretch {
        align-self: stretch !important
    }

    .order-xxl-first {
        order: -1 !important
    }

    .order-xxl-0 {
        order: 0 !important
    }

    .order-xxl-1 {
        order: 1 !important
    }

    .order-xxl-2 {
        order: 2 !important
    }

    .order-xxl-3 {
        order: 3 !important
    }

    .order-xxl-4 {
        order: 4 !important
    }

    .order-xxl-5 {
        order: 5 !important
    }

    .order-xxl-last {
        order: 6 !important
    }

    .m-xxl-0 {
        margin: 0 !important
    }

    .m-xxl-1 {
        margin: .25rem !important
    }

    .m-xxl-2 {
        margin: .5rem !important
    }

    .m-xxl-3 {
        margin: 1rem !important
    }

    .m-xxl-4 {
        margin: 1.5rem !important
    }

    .m-xxl-5 {
        margin: 3rem !important
    }

    .m-xxl-6 {
        margin: 5rem !important
    }

    .m-xxl-7 {
        margin: 8rem !important
    }

    .m-xxl-8 {
        margin: 10rem !important
    }

    .m-xxl-9 {
        margin: 11rem !important
    }

    .m-xxl-10 {
        margin: 14rem !important
    }

    .m-xxl-11 {
        margin: 16rem !important
    }

    .m-xxl-12 {
        margin: 20rem !important
    }

    .m-xxl-sm {
        margin: 1rem !important
    }

    .m-xxl-md {
        margin: 2rem !important
    }

    .m-xxl-lg {
        margin: 4rem !important
    }

    .m-xxl-xl {
        margin: 8rem !important
    }

    .m-xxl-auto {
        margin: auto !important
    }

    .mx-xxl-0 {
        margin-right: 0 !important;
        margin-left: 0 !important
    }

    .mx-xxl-1 {
        margin-right: .25rem !important;
        margin-left: .25rem !important
    }

    .mx-xxl-2 {
        margin-right: .5rem !important;
        margin-left: .5rem !important
    }

    .mx-xxl-3 {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xxl-4 {
        margin-right: 1.5rem !important;
        margin-left: 1.5rem !important
    }

    .mx-xxl-5 {
        margin-right: 3rem !important;
        margin-left: 3rem !important
    }

    .mx-xxl-6 {
        margin-right: 5rem !important;
        margin-left: 5rem !important
    }

    .mx-xxl-7 {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-xxl-8 {
        margin-right: 10rem !important;
        margin-left: 10rem !important
    }

    .mx-xxl-9 {
        margin-right: 11rem !important;
        margin-left: 11rem !important
    }

    .mx-xxl-10 {
        margin-right: 14rem !important;
        margin-left: 14rem !important
    }

    .mx-xxl-11 {
        margin-right: 16rem !important;
        margin-left: 16rem !important
    }

    .mx-xxl-12 {
        margin-right: 20rem !important;
        margin-left: 20rem !important
    }

    .mx-xxl-sm {
        margin-right: 1rem !important;
        margin-left: 1rem !important
    }

    .mx-xxl-md {
        margin-right: 2rem !important;
        margin-left: 2rem !important
    }

    .mx-xxl-lg {
        margin-right: 4rem !important;
        margin-left: 4rem !important
    }

    .mx-xxl-xl {
        margin-right: 8rem !important;
        margin-left: 8rem !important
    }

    .mx-xxl-auto {
        margin-right: auto !important;
        margin-left: auto !important
    }

    .my-xxl-0 {
        margin-top: 0 !important;
        margin-bottom: 0 !important
    }

    .my-xxl-1 {
        margin-top: .25rem !important;
        margin-bottom: .25rem !important
    }

    .my-xxl-2 {
        margin-top: .5rem !important;
        margin-bottom: .5rem !important
    }

    .my-xxl-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xxl-4 {
        margin-top: 1.5rem !important;
        margin-bottom: 1.5rem !important
    }

    .my-xxl-5 {
        margin-top: 3rem !important;
        margin-bottom: 3rem !important
    }

    .my-xxl-6 {
        margin-top: 5rem !important;
        margin-bottom: 5rem !important
    }

    .my-xxl-7 {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-xxl-8 {
        margin-top: 10rem !important;
        margin-bottom: 10rem !important
    }

    .my-xxl-9 {
        margin-top: 11rem !important;
        margin-bottom: 11rem !important
    }

    .my-xxl-10 {
        margin-top: 14rem !important;
        margin-bottom: 14rem !important
    }

    .my-xxl-11 {
        margin-top: 16rem !important;
        margin-bottom: 16rem !important
    }

    .my-xxl-12 {
        margin-top: 20rem !important;
        margin-bottom: 20rem !important
    }

    .my-xxl-sm {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important
    }

    .my-xxl-md {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important
    }

    .my-xxl-lg {
        margin-top: 4rem !important;
        margin-bottom: 4rem !important
    }

    .my-xxl-xl {
        margin-top: 8rem !important;
        margin-bottom: 8rem !important
    }

    .my-xxl-auto {
        margin-top: auto !important;
        margin-bottom: auto !important
    }

    .mt-xxl-0 {
        margin-top: 0 !important
    }

    .mt-xxl-1 {
        margin-top: .25rem !important
    }

    .mt-xxl-2 {
        margin-top: .5rem !important
    }

    .mt-xxl-3 {
        margin-top: 1rem !important
    }

    .mt-xxl-4 {
        margin-top: 1.5rem !important
    }

    .mt-xxl-5 {
        margin-top: 3rem !important
    }

    .mt-xxl-6 {
        margin-top: 5rem !important
    }

    .mt-xxl-7 {
        margin-top: 8rem !important
    }

    .mt-xxl-8 {
        margin-top: 10rem !important
    }

    .mt-xxl-9 {
        margin-top: 11rem !important
    }

    .mt-xxl-10 {
        margin-top: 14rem !important
    }

    .mt-xxl-11 {
        margin-top: 16rem !important
    }

    .mt-xxl-12 {
        margin-top: 20rem !important
    }

    .mt-xxl-sm {
        margin-top: 1rem !important
    }

    .mt-xxl-md {
        margin-top: 2rem !important
    }

    .mt-xxl-lg {
        margin-top: 4rem !important
    }

    .mt-xxl-xl {
        margin-top: 8rem !important
    }

    .mt-xxl-auto {
        margin-top: auto !important
    }

    .me-xxl-0 {
        margin-right: 0 !important
    }

    .me-xxl-1 {
        margin-right: .25rem !important
    }

    .me-xxl-2 {
        margin-right: .5rem !important
    }

    .me-xxl-3 {
        margin-right: 1rem !important
    }

    .me-xxl-4 {
        margin-right: 1.5rem !important
    }

    .me-xxl-5 {
        margin-right: 3rem !important
    }

    .me-xxl-6 {
        margin-right: 5rem !important
    }

    .me-xxl-7 {
        margin-right: 8rem !important
    }

    .me-xxl-8 {
        margin-right: 10rem !important
    }

    .me-xxl-9 {
        margin-right: 11rem !important
    }

    .me-xxl-10 {
        margin-right: 14rem !important
    }

    .me-xxl-11 {
        margin-right: 16rem !important
    }

    .me-xxl-12 {
        margin-right: 20rem !important
    }

    .me-xxl-sm {
        margin-right: 1rem !important
    }

    .me-xxl-md {
        margin-right: 2rem !important
    }

    .me-xxl-lg {
        margin-right: 4rem !important
    }

    .me-xxl-xl {
        margin-right: 8rem !important
    }

    .me-xxl-auto {
        margin-right: auto !important
    }

    .mb-xxl-0 {
        margin-bottom: 0 !important
    }

    .mb-xxl-1 {
        margin-bottom: .25rem !important
    }

    .mb-xxl-2 {
        margin-bottom: .5rem !important
    }

    .mb-xxl-3 {
        margin-bottom: 1rem !important
    }

    .mb-xxl-4 {
        margin-bottom: 1.5rem !important
    }

    .mb-xxl-5 {
        margin-bottom: 3rem !important
    }

    .mb-xxl-6 {
        margin-bottom: 5rem !important
    }

    .mb-xxl-7 {
        margin-bottom: 8rem !important
    }

    .mb-xxl-8 {
        margin-bottom: 10rem !important
    }

    .mb-xxl-9 {
        margin-bottom: 11rem !important
    }

    .mb-xxl-10 {
        margin-bottom: 14rem !important
    }

    .mb-xxl-11 {
        margin-bottom: 16rem !important
    }

    .mb-xxl-12 {
        margin-bottom: 20rem !important
    }

    .mb-xxl-sm {
        margin-bottom: 1rem !important
    }

    .mb-xxl-md {
        margin-bottom: 2rem !important
    }

    .mb-xxl-lg {
        margin-bottom: 4rem !important
    }

    .mb-xxl-xl {
        margin-bottom: 8rem !important
    }

    .mb-xxl-auto {
        margin-bottom: auto !important
    }

    .ms-xxl-0 {
        margin-left: 0 !important
    }

    .ms-xxl-1 {
        margin-left: .25rem !important
    }

    .ms-xxl-2 {
        margin-left: .5rem !important
    }

    .ms-xxl-3 {
        margin-left: 1rem !important
    }

    .ms-xxl-4 {
        margin-left: 1.5rem !important
    }

    .ms-xxl-5 {
        margin-left: 3rem !important
    }

    .ms-xxl-6 {
        margin-left: 5rem !important
    }

    .ms-xxl-7 {
        margin-left: 8rem !important
    }

    .ms-xxl-8 {
        margin-left: 10rem !important
    }

    .ms-xxl-9 {
        margin-left: 11rem !important
    }

    .ms-xxl-10 {
        margin-left: 14rem !important
    }

    .ms-xxl-11 {
        margin-left: 16rem !important
    }

    .ms-xxl-12 {
        margin-left: 20rem !important
    }

    .ms-xxl-sm {
        margin-left: 1rem !important
    }

    .ms-xxl-md {
        margin-left: 2rem !important
    }

    .ms-xxl-lg {
        margin-left: 4rem !important
    }

    .ms-xxl-xl {
        margin-left: 8rem !important
    }

    .ms-xxl-auto {
        margin-left: auto !important
    }

    .m-xxl-n1 {
        margin: -.25rem !important
    }

    .m-xxl-n2 {
        margin: -.5rem !important
    }

    .m-xxl-n3 {
        margin: -1rem !important
    }

    .m-xxl-n4 {
        margin: -1.5rem !important
    }

    .m-xxl-n5 {
        margin: -3rem !important
    }

    .m-xxl-n6 {
        margin: -5rem !important
    }

    .m-xxl-n7 {
        margin: -8rem !important
    }

    .m-xxl-n8 {
        margin: -10rem !important
    }

    .m-xxl-n9 {
        margin: -11rem !important
    }

    .m-xxl-n10 {
        margin: -14rem !important
    }

    .m-xxl-n11 {
        margin: -16rem !important
    }

    .m-xxl-n12 {
        margin: -20rem !important
    }

    .m-xxl-nsm {
        margin: -1rem !important
    }

    .m-xxl-nmd {
        margin: -2rem !important
    }

    .m-xxl-nlg {
        margin: -4rem !important
    }

    .m-xxl-nxl {
        margin: -8rem !important
    }

    .mx-xxl-n1 {
        margin-right: -.25rem !important;
        margin-left: -.25rem !important
    }

    .mx-xxl-n2 {
        margin-right: -.5rem !important;
        margin-left: -.5rem !important
    }

    .mx-xxl-n3 {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-xxl-n4 {
        margin-right: -1.5rem !important;
        margin-left: -1.5rem !important
    }

    .mx-xxl-n5 {
        margin-right: -3rem !important;
        margin-left: -3rem !important
    }

    .mx-xxl-n6 {
        margin-right: -5rem !important;
        margin-left: -5rem !important
    }

    .mx-xxl-n7 {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .mx-xxl-n8 {
        margin-right: -10rem !important;
        margin-left: -10rem !important
    }

    .mx-xxl-n9 {
        margin-right: -11rem !important;
        margin-left: -11rem !important
    }

    .mx-xxl-n10 {
        margin-right: -14rem !important;
        margin-left: -14rem !important
    }

    .mx-xxl-n11 {
        margin-right: -16rem !important;
        margin-left: -16rem !important
    }

    .mx-xxl-n12 {
        margin-right: -20rem !important;
        margin-left: -20rem !important
    }

    .mx-xxl-nsm {
        margin-right: -1rem !important;
        margin-left: -1rem !important
    }

    .mx-xxl-nmd {
        margin-right: -2rem !important;
        margin-left: -2rem !important
    }

    .mx-xxl-nlg {
        margin-right: -4rem !important;
        margin-left: -4rem !important
    }

    .mx-xxl-nxl {
        margin-right: -8rem !important;
        margin-left: -8rem !important
    }

    .my-xxl-n1 {
        margin-top: -.25rem !important;
        margin-bottom: -.25rem !important
    }

    .my-xxl-n2 {
        margin-top: -.5rem !important;
        margin-bottom: -.5rem !important
    }

    .my-xxl-n3 {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-xxl-n4 {
        margin-top: -1.5rem !important;
        margin-bottom: -1.5rem !important
    }

    .my-xxl-n5 {
        margin-top: -3rem !important;
        margin-bottom: -3rem !important
    }

    .my-xxl-n6 {
        margin-top: -5rem !important;
        margin-bottom: -5rem !important
    }

    .my-xxl-n7 {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .my-xxl-n8 {
        margin-top: -10rem !important;
        margin-bottom: -10rem !important
    }

    .my-xxl-n9 {
        margin-top: -11rem !important;
        margin-bottom: -11rem !important
    }

    .my-xxl-n10 {
        margin-top: -14rem !important;
        margin-bottom: -14rem !important
    }

    .my-xxl-n11 {
        margin-top: -16rem !important;
        margin-bottom: -16rem !important
    }

    .my-xxl-n12 {
        margin-top: -20rem !important;
        margin-bottom: -20rem !important
    }

    .my-xxl-nsm {
        margin-top: -1rem !important;
        margin-bottom: -1rem !important
    }

    .my-xxl-nmd {
        margin-top: -2rem !important;
        margin-bottom: -2rem !important
    }

    .my-xxl-nlg {
        margin-top: -4rem !important;
        margin-bottom: -4rem !important
    }

    .my-xxl-nxl {
        margin-top: -8rem !important;
        margin-bottom: -8rem !important
    }

    .mt-xxl-n1 {
        margin-top: -.25rem !important
    }

    .mt-xxl-n2 {
        margin-top: -.5rem !important
    }

    .mt-xxl-n3 {
        margin-top: -1rem !important
    }

    .mt-xxl-n4 {
        margin-top: -1.5rem !important
    }

    .mt-xxl-n5 {
        margin-top: -3rem !important
    }

    .mt-xxl-n6 {
        margin-top: -5rem !important
    }

    .mt-xxl-n7 {
        margin-top: -8rem !important
    }

    .mt-xxl-n8 {
        margin-top: -10rem !important
    }

    .mt-xxl-n9 {
        margin-top: -11rem !important
    }

    .mt-xxl-n10 {
        margin-top: -14rem !important
    }

    .mt-xxl-n11 {
        margin-top: -16rem !important
    }

    .mt-xxl-n12 {
        margin-top: -20rem !important
    }

    .mt-xxl-nsm {
        margin-top: -1rem !important
    }

    .mt-xxl-nmd {
        margin-top: -2rem !important
    }

    .mt-xxl-nlg {
        margin-top: -4rem !important
    }

    .mt-xxl-nxl {
        margin-top: -8rem !important
    }

    .me-xxl-n1 {
        margin-right: -.25rem !important
    }

    .me-xxl-n2 {
        margin-right: -.5rem !important
    }

    .me-xxl-n3 {
        margin-right: -1rem !important
    }

    .me-xxl-n4 {
        margin-right: -1.5rem !important
    }

    .me-xxl-n5 {
        margin-right: -3rem !important
    }

    .me-xxl-n6 {
        margin-right: -5rem !important
    }

    .me-xxl-n7 {
        margin-right: -8rem !important
    }

    .me-xxl-n8 {
        margin-right: -10rem !important
    }

    .me-xxl-n9 {
        margin-right: -11rem !important
    }

    .me-xxl-n10 {
        margin-right: -14rem !important
    }

    .me-xxl-n11 {
        margin-right: -16rem !important
    }

    .me-xxl-n12 {
        margin-right: -20rem !important
    }

    .me-xxl-nsm {
        margin-right: -1rem !important
    }

    .me-xxl-nmd {
        margin-right: -2rem !important
    }

    .me-xxl-nlg {
        margin-right: -4rem !important
    }

    .me-xxl-nxl {
        margin-right: -8rem !important
    }

    .mb-xxl-n1 {
        margin-bottom: -.25rem !important
    }

    .mb-xxl-n2 {
        margin-bottom: -.5rem !important
    }

    .mb-xxl-n3 {
        margin-bottom: -1rem !important
    }

    .mb-xxl-n4 {
        margin-bottom: -1.5rem !important
    }

    .mb-xxl-n5 {
        margin-bottom: -3rem !important
    }

    .mb-xxl-n6 {
        margin-bottom: -5rem !important
    }

    .mb-xxl-n7 {
        margin-bottom: -8rem !important
    }

    .mb-xxl-n8 {
        margin-bottom: -10rem !important
    }

    .mb-xxl-n9 {
        margin-bottom: -11rem !important
    }

    .mb-xxl-n10 {
        margin-bottom: -14rem !important
    }

    .mb-xxl-n11 {
        margin-bottom: -16rem !important
    }

    .mb-xxl-n12 {
        margin-bottom: -20rem !important
    }

    .mb-xxl-nsm {
        margin-bottom: -1rem !important
    }

    .mb-xxl-nmd {
        margin-bottom: -2rem !important
    }

    .mb-xxl-nlg {
        margin-bottom: -4rem !important
    }

    .mb-xxl-nxl {
        margin-bottom: -8rem !important
    }

    .ms-xxl-n1 {
        margin-left: -.25rem !important
    }

    .ms-xxl-n2 {
        margin-left: -.5rem !important
    }

    .ms-xxl-n3 {
        margin-left: -1rem !important
    }

    .ms-xxl-n4 {
        margin-left: -1.5rem !important
    }

    .ms-xxl-n5 {
        margin-left: -3rem !important
    }

    .ms-xxl-n6 {
        margin-left: -5rem !important
    }

    .ms-xxl-n7 {
        margin-left: -8rem !important
    }

    .ms-xxl-n8 {
        margin-left: -10rem !important
    }

    .ms-xxl-n9 {
        margin-left: -11rem !important
    }

    .ms-xxl-n10 {
        margin-left: -14rem !important
    }

    .ms-xxl-n11 {
        margin-left: -16rem !important
    }

    .ms-xxl-n12 {
        margin-left: -20rem !important
    }

    .ms-xxl-nsm {
        margin-left: -1rem !important
    }

    .ms-xxl-nmd {
        margin-left: -2rem !important
    }

    .ms-xxl-nlg {
        margin-left: -4rem !important
    }

    .ms-xxl-nxl {
        margin-left: -8rem !important
    }

    .p-xxl-0 {
        padding: 0 !important
    }

    .p-xxl-1 {
        padding: .25rem !important
    }

    .p-xxl-2 {
        padding: .5rem !important
    }

    .p-xxl-3 {
        padding: 1rem !important
    }

    .p-xxl-4 {
        padding: 1.5rem !important
    }

    .p-xxl-5 {
        padding: 3rem !important
    }

    .p-xxl-6 {
        padding: 5rem !important
    }

    .p-xxl-7 {
        padding: 8rem !important
    }

    .p-xxl-8 {
        padding: 10rem !important
    }

    .p-xxl-9 {
        padding: 11rem !important
    }

    .p-xxl-10 {
        padding: 14rem !important
    }

    .p-xxl-11 {
        padding: 16rem !important
    }

    .p-xxl-12 {
        padding: 20rem !important
    }

    .p-xxl-sm {
        padding: 1rem !important
    }

    .p-xxl-md {
        padding: 2rem !important
    }

    .p-xxl-lg {
        padding: 4rem !important
    }

    .p-xxl-xl {
        padding: 8rem !important
    }

    .px-xxl-0 {
        padding-right: 0 !important;
        padding-left: 0 !important
    }

    .px-xxl-1 {
        padding-right: .25rem !important;
        padding-left: .25rem !important
    }

    .px-xxl-2 {
        padding-right: .5rem !important;
        padding-left: .5rem !important
    }

    .px-xxl-3 {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xxl-4 {
        padding-right: 1.5rem !important;
        padding-left: 1.5rem !important
    }

    .px-xxl-5 {
        padding-right: 3rem !important;
        padding-left: 3rem !important
    }

    .px-xxl-6 {
        padding-right: 5rem !important;
        padding-left: 5rem !important
    }

    .px-xxl-7 {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .px-xxl-8 {
        padding-right: 10rem !important;
        padding-left: 10rem !important
    }

    .px-xxl-9 {
        padding-right: 11rem !important;
        padding-left: 11rem !important
    }

    .px-xxl-10 {
        padding-right: 14rem !important;
        padding-left: 14rem !important
    }

    .px-xxl-11 {
        padding-right: 16rem !important;
        padding-left: 16rem !important
    }

    .px-xxl-12 {
        padding-right: 20rem !important;
        padding-left: 20rem !important
    }

    .px-xxl-sm {
        padding-right: 1rem !important;
        padding-left: 1rem !important
    }

    .px-xxl-md {
        padding-right: 2rem !important;
        padding-left: 2rem !important
    }

    .px-xxl-lg {
        padding-right: 4rem !important;
        padding-left: 4rem !important
    }

    .px-xxl-xl {
        padding-right: 8rem !important;
        padding-left: 8rem !important
    }

    .py-xxl-0 {
        padding-top: 0 !important;
        padding-bottom: 0 !important
    }

    .py-xxl-1 {
        padding-top: .25rem !important;
        padding-bottom: .25rem !important
    }

    .py-xxl-2 {
        padding-top: .5rem !important;
        padding-bottom: .5rem !important
    }

    .py-xxl-3 {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xxl-4 {
        padding-top: 1.5rem !important;
        padding-bottom: 1.5rem !important
    }

    .py-xxl-5 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important
    }

    .py-xxl-6 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important
    }

    .py-xxl-7 {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .py-xxl-8 {
        padding-top: 10rem !important;
        padding-bottom: 10rem !important
    }

    .py-xxl-9 {
        padding-top: 11rem !important;
        padding-bottom: 11rem !important
    }

    .py-xxl-10 {
        padding-top: 14rem !important;
        padding-bottom: 14rem !important
    }

    .py-xxl-11 {
        padding-top: 16rem !important;
        padding-bottom: 16rem !important
    }

    .py-xxl-12 {
        padding-top: 20rem !important;
        padding-bottom: 20rem !important
    }

    .py-xxl-sm {
        padding-top: 1rem !important;
        padding-bottom: 1rem !important
    }

    .py-xxl-md {
        padding-top: 2rem !important;
        padding-bottom: 2rem !important
    }

    .py-xxl-lg {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important
    }

    .py-xxl-xl {
        padding-top: 8rem !important;
        padding-bottom: 8rem !important
    }

    .pt-xxl-0 {
        padding-top: 0 !important
    }

    .pt-xxl-1 {
        padding-top: .25rem !important
    }

    .pt-xxl-2 {
        padding-top: .5rem !important
    }

    .pt-xxl-3 {
        padding-top: 1rem !important
    }

    .pt-xxl-4 {
        padding-top: 1.5rem !important
    }

    .pt-xxl-5 {
        padding-top: 3rem !important
    }

    .pt-xxl-6 {
        padding-top: 5rem !important
    }

    .pt-xxl-7 {
        padding-top: 8rem !important
    }

    .pt-xxl-8 {
        padding-top: 10rem !important
    }

    .pt-xxl-9 {
        padding-top: 11rem !important
    }

    .pt-xxl-10 {
        padding-top: 14rem !important
    }

    .pt-xxl-11 {
        padding-top: 16rem !important
    }

    .pt-xxl-12 {
        padding-top: 20rem !important
    }

    .pt-xxl-sm {
        padding-top: 1rem !important
    }

    .pt-xxl-md {
        padding-top: 2rem !important
    }

    .pt-xxl-lg {
        padding-top: 4rem !important
    }

    .pt-xxl-xl {
        padding-top: 8rem !important
    }

    .pe-xxl-0 {
        padding-right: 0 !important
    }

    .pe-xxl-1 {
        padding-right: .25rem !important
    }

    .pe-xxl-2 {
        padding-right: .5rem !important
    }

    .pe-xxl-3 {
        padding-right: 1rem !important
    }

    .pe-xxl-4 {
        padding-right: 1.5rem !important
    }

    .pe-xxl-5 {
        padding-right: 3rem !important
    }

    .pe-xxl-6 {
        padding-right: 5rem !important
    }

    .pe-xxl-7 {
        padding-right: 8rem !important
    }

    .pe-xxl-8 {
        padding-right: 10rem !important
    }

    .pe-xxl-9 {
        padding-right: 11rem !important
    }

    .pe-xxl-10 {
        padding-right: 14rem !important
    }

    .pe-xxl-11 {
        padding-right: 16rem !important
    }

    .pe-xxl-12 {
        padding-right: 20rem !important
    }

    .pe-xxl-sm {
        padding-right: 1rem !important
    }

    .pe-xxl-md {
        padding-right: 2rem !important
    }

    .pe-xxl-lg {
        padding-right: 4rem !important
    }

    .pe-xxl-xl {
        padding-right: 8rem !important
    }

    .pb-xxl-0 {
        padding-bottom: 0 !important
    }

    .pb-xxl-1 {
        padding-bottom: .25rem !important
    }

    .pb-xxl-2 {
        padding-bottom: .5rem !important
    }

    .pb-xxl-3 {
        padding-bottom: 1rem !important
    }

    .pb-xxl-4 {
        padding-bottom: 1.5rem !important
    }

    .pb-xxl-5 {
        padding-bottom: 3rem !important
    }

    .pb-xxl-6 {
        padding-bottom: 5rem !important
    }

    .pb-xxl-7 {
        padding-bottom: 8rem !important
    }

    .pb-xxl-8 {
        padding-bottom: 10rem !important
    }

    .pb-xxl-9 {
        padding-bottom: 11rem !important
    }

    .pb-xxl-10 {
        padding-bottom: 14rem !important
    }

    .pb-xxl-11 {
        padding-bottom: 16rem !important
    }

    .pb-xxl-12 {
        padding-bottom: 20rem !important
    }

    .pb-xxl-sm {
        padding-bottom: 1rem !important
    }

    .pb-xxl-md {
        padding-bottom: 2rem !important
    }

    .pb-xxl-lg {
        padding-bottom: 4rem !important
    }

    .pb-xxl-xl {
        padding-bottom: 8rem !important
    }

    .ps-xxl-0 {
        padding-left: 0 !important
    }

    .ps-xxl-1 {
        padding-left: .25rem !important
    }

    .ps-xxl-2 {
        padding-left: .5rem !important
    }

    .ps-xxl-3 {
        padding-left: 1rem !important
    }

    .ps-xxl-4 {
        padding-left: 1.5rem !important
    }

    .ps-xxl-5 {
        padding-left: 3rem !important
    }

    .ps-xxl-6 {
        padding-left: 5rem !important
    }

    .ps-xxl-7 {
        padding-left: 8rem !important
    }

    .ps-xxl-8 {
        padding-left: 10rem !important
    }

    .ps-xxl-9 {
        padding-left: 11rem !important
    }

    .ps-xxl-10 {
        padding-left: 14rem !important
    }

    .ps-xxl-11 {
        padding-left: 16rem !important
    }

    .ps-xxl-12 {
        padding-left: 20rem !important
    }

    .ps-xxl-sm {
        padding-left: 1rem !important
    }

    .ps-xxl-md {
        padding-left: 2rem !important
    }

    .ps-xxl-lg {
        padding-left: 4rem !important
    }

    .ps-xxl-xl {
        padding-left: 8rem !important
    }

    .text-xxl-start {
        text-align: left !important
    }

    .text-xxl-end {
        text-align: right !important
    }

    .text-xxl-center {
        text-align: center !important
    }
}

@media (min-width: 1200px) {
    .fs-1 {
        font-size: 2.5rem !important
    }

    .fs-2 {
        font-size: 2rem !important
    }

    .fs-3 {
        font-size: 1.75rem !important
    }

    .fs-4 {
        font-size: 1.5rem !important
    }
}

@media print {
    .d-print-inline {
        display: inline !important
    }

    .d-print-inline-block {
        display: inline-block !important
    }

    .d-print-block {
        display: block !important
    }

    .d-print-grid {
        display: grid !important
    }

    .d-print-table {
        display: table !important
    }

    .d-print-table-row {
        display: table-row !important
    }

    .d-print-table-cell {
        display: table-cell !important
    }

    .d-print-flex {
        display: flex !important
    }

    .d-print-inline-flex {
        display: inline-flex !important
    }

    .d-print-none {
        display: none !important
    }
}

.navbar-main {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100
}

.navbar-main .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___})
}

.navbar .navbar-nav .nav-link {
    transition: all .8s all .2s ease
}

@media (max-width: 767.98px) {
    .navbar .navbar-nav .nav-link {
        font-size: 1.2rem;
        display: flex;
        -moz-justify-content: space-between;
        -ms-justify-content: space-between;
        justify-content: space-between;
        -ms-flex-pack: space-between;
        -moz-align-items: center;
        -ms-align-items: center;
        align-items: center
    }
}

.navbar .navbar-nav .nav-item .media:not(:last-child) {
    margin-bottom: 1.5rem
}

.navbar .navbar-nav .nav-item .nav-link:focus,
.navbar .navbar-nav .nav-item:focus {
    outline: 0 !important
}

.navbar .navbar-nav .dropdown .dropdown-menu {
    top: 100%
}

.navbar .navbar-nav .dropdown .dropdown-menu span {
    width: 30px
}

.navbar .navbar-nav .dropdown .dropdown-item {
    font-size: .875rem
}

@media (min-width: 992px) {

    .navbar .navbar-nav .dropdown-megamenu,
    .navbar .navbar-nav .dropdown-megamenu-md,
    .navbar .navbar-nav .dropdown-megamenu-sm {
        min-width: 580px
    }
}

.navbar .navbar-nav .dropdown-megamenu .megamenu-link,
.navbar .navbar-nav .dropdown-megamenu-md .megamenu-link,
.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-link {
    color: #111827;
    font-weight: 400;
    font-size: .875rem
}

.navbar .navbar-nav .dropdown-megamenu .megamenu-item,
.navbar .navbar-nav .dropdown-megamenu-md .megamenu-item,
.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-item {
    position: relative
}

.navbar .navbar-nav .dropdown-megamenu .megamenu-item:hover .megamenu-link,
.navbar .navbar-nav .dropdown-megamenu-md .megamenu-item:hover .megamenu-link,
.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-item:hover .megamenu-link {
    color: #1f2937
}

@media (min-width: 992px) {
    .navbar .navbar-nav .dropdown-megamenu-sm {
        min-width: 320px
    }
}

@media (min-width: 992px) {
    .navbar .navbar-nav .dropdown-megamenu-md {
        min-width: 960px
    }
}

@media (min-width: 992px) {
    .navbar .navbar-nav .dropdown-menu .dropdown-toggle .nav-link-arrow {
        transform: rotate(-90deg)
    }

    .navbar .navbar-nav .dropdown.show > .dropdown-toggle .nav-link-arrow {
        transform: rotate(180deg)
    }

    .navbar .navbar-nav .dropdown-toggle:hover .nav-link-arrow {
        transform: rotate(0)
    }
}

.navbar .navbar-nav .dropdown-submenu {
    position: relative
}

.navbar .navbar-nav .dropdown-submenu .dropdown-menu {
    top: 0;
    left: calc(100% - 2px);
    margin-left: .1rem;
    margin-right: .1rem;
    opacity: 0;
    display: none
}

.navbar .navbar-nav .dropdown-submenu .dropdown-menu.show {
    opacity: 1;
    pointer-events: all;
    display: block
}

.navbar .navbar-nav .nav-link-arrow {
    transition: transform .2s ease
}

.navbar-brand {
    font-size: .875rem;
    font-weight: 500;
    text-transform: uppercase
}

.navbar-brand img {
    height: 40px
}

.navbar-dark .navbar-brand-light {
    display: none
}

.navbar-dark .navbar-brand {
    color: #fff
}

.navbar-dark > .nav-item:hover > .nav-link {
    color: #1f2937
}

.navbar-light:not(.headroom--not-top) .btn-outline-soft {
    border-color: #1f2937;
    color: #1f2937
}

.navbar-light:not(.headroom--not-top) .btn-outline-soft:hover {
    background: #1f2937;
    color: #fff
}

.navbar-light .navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
}

.navbar-light .navbar-brand-dark {
    display: none
}

.navbar-light .navbar-brand {
    color: #1f2937
}

.dropdown-menu {
    top: 100%
}

.dropdown-menu span {
    width: 30px
}

.navbar-transparent {
    background-color: transparent;
    border: 0;
    box-shadow: none
}

@media (min-width: 992px) {
    .navbar-nav .nav-item [data-toggle=dropdown]::after {
        transition: all .2s ease
    }

    .navbar-nav .nav-item.show [data-toggle=dropdown]::after {
        transform: rotate(180deg)
    }

    .navbar-nav .nav-link i {
        margin-right: .3rem;
        font-size: .75rem
    }

    .navbar-nav .nav-link-icon {
        padding-left: .5rem;
        padding-right: .5rem;
        font-size: 1rem
    }

    .navbar-nav .nav-link-icon i {
        margin-right: 0
    }

    .navbar-nav .dropdown-menu {
        opacity: 0;
        pointer-events: none;
        margin: 0;
        border-radius: .35rem
    }

    .navbar-nav .dropdown-menu-end:before {
        right: 20px;
        left: auto
    }

    .navbar-nav .dropdown-menu-center {
        left: 50%;
        transform: translateX(-50%)
    }

    .navbar-nav .dropdown-megamenu-md.show,
    .navbar-nav .dropdown-megamenu.show,
    .navbar-nav .dropdown-menu.show {
        opacity: 1;
        pointer-events: auto
    }

    .navbar-nav .dropdown-megamenu-md.close,
    .navbar-nav .dropdown-megamenu.close,
    .navbar-nav .dropdown-menu.close {
        display: block
    }

    .navbar-nav .dropdown-submenu .dropdown-menu {
        transform: none
    }

    .navbar-nav .dropdown-menu {
        position: relative;
        display: block;
        opacity: 0;
        pointer-events: none;
        transition: all .2s ease
    }

    .navbar-nav .dropdown-submenu.show > .dropdown-menu,
    .navbar-nav .dropdown.show > .dropdown-menu {
        display: block;
        opacity: 1;
        pointer-events: auto
    }

    .navbar-nav .dropdown-menu-inner {
        position: relative;
        padding: 1rem
    }

    .navbar-transparent .navbar-nav .nav-link.disabled {
        color: rgba(255, 255, 255, .9)
    }

    .navbar-transparent .navbar-brand {
        color: rgba(255, 255, 255, .9)
    }
}

.navbar-collapse-header {
    display: none
}

.navbar-collapse {
    width: auto
}

@media (max-width: 991.98px) {
    .navbar-nav .nav-link {
        padding: .625rem 0
    }

    .navbar-nav .dropdown-menu {
        box-shadow: none;
        width: 100%
    }

    .navbar-nav .dropdown-menu .media svg {
        width: 30px
    }

    .dropdown-menu-center {
        right: 0;
        left: auto;
        transform: translate(0, 0)
    }
}

@media (max-width: 991.98px) and (max-width: 991.98px) {
    .dropdown-menu-center {
        transform: translateX(-75%)
    }
}

@media (max-width: 991.98px) {
    .navbar-collapse {
        width: calc(100% - 30px);
        position: absolute;
        top: 0;
        right: 15px;
        z-index: 1050;
        overflow-y: auto;
        height: calc(100vh - 30px) !important;
        opacity: 0
    }

    .navbar-collapse .navbar-toggler {
        position: relative;
        display: inline-block;
        width: 20px;
        height: 20px;
        padding: 0
    }

    .navbar-collapse .navbar-toggler span {
        display: block;
        position: absolute;
        width: 100%;
        height: 2px;
        border-radius: 2px;
        opacity: 1;
        background: #283448
    }

    .navbar-collapse .navbar-collapse-header {
        display: block;
        padding-bottom: 1rem;
        margin-bottom: 1rem
    }

    .navbar-collapse .collapse-brand img {
        height: 35px
    }

    .navbar-collapse .collapse-close {
        text-align: right
    }

    .navbar-collapse.collapsing,
    .navbar-collapse.show {
        padding: 1.5rem;
        border-radius: .35rem;
        background: #fff;
        animation: show-navbar-collapse .2s ease forwards;
        box-shadow: 0 0 20px rgba(0, 0, 0, .1)
    }

    .navbar-collapse.collapsing-out {
        animation: hide-navbar-collapse .2s ease forwards
    }
}

.navbar-dashboard {
    border-radius: .5rem
}

.navbar-theme-primary:not(.headroom) {
    background-color: #1f2937
}

.section {
    position: relative;
    padding-top: 3rem;
    padding-bottom: 3rem
}

.section-header {
    position: relative;
    padding-top: 9rem;
    padding-bottom: 3rem
}

@media (min-width: 576px) {
    .section {
        position: relative;
        padding-top: 5rem;
        padding-bottom: 5rem
    }

    .section-header {
        position: relative;
        padding-top: 8rem;
        padding-bottom: 8rem
    }

    .section-header.section-sm {
        padding-top: 4rem;
        padding-bottom: 3rem
    }

    .section-xl {
        padding-top: 8rem;
        padding-bottom: 8rem
    }

    .section-lg {
        padding-top: 6rem;
        padding-bottom: 6rem
    }

    .section-sm {
        padding-top: 3rem;
        padding-bottom: 3rem
    }
}

@media (min-width: 992px) {
    .section {
        position: relative;
        padding-top: 6rem;
        padding-bottom: 6rem
    }

    .section-header {
        position: relative;
        padding-top: 10rem;
        padding-bottom: 10rem
    }

    .section-header.section-sm {
        padding-top: 4rem;
        padding-bottom: 3rem
    }

    .section-xl {
        padding-top: 10rem;
        padding-bottom: 10rem
    }

    .section-lg {
        padding-top: 8rem;
        padding-bottom: 8rem
    }

    .section-sm {
        padding-top: 4rem;
        padding-bottom: 4rem
    }
}

@media (min-width: 768px) {
    .section-hero {
        height: 100vh
    }
}

.line-bottom::after {
    content: '';
    display: block;
    width: 80%;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -40%;
    height: 1px;
    background: radial-gradient(ellipse at center, #9ca3af 0, rgba(255, 255, 255, 0) 80%)
}

.section-profile-cover {
    height: 580px;
    background-size: cover;
    background-position: center center
}

@media (max-width: 767.98px) {
    .section-profile-cover {
        height: 400px
    }
}

.components-section > .form-control + .form-control {
    margin-top: .5rem
}

.components-section .badge,
.components-section .btn,
.components-section > .alert + .alert,
.components-section > .nav + .nav,
.components-section > .navbar + .navbar,
.components-section > .progress + .btn,
.components-section > .progress + .progress {
    margin-top: .5rem;
    margin-bottom: .5rem
}

.components-section .btn-group {
    margin-top: .5rem;
    margin-bottom: .5rem
}

.components-section .btn-group .btn {
    margin: 0
}

.components-section .alert {
    margin: 0
}

.components-section .alert + .alert {
    margin-top: 1.25rem
}

.components-section .badge {
    margin-right: .5rem
}

.components-section .modal-footer .btn {
    margin: 0
}

.copy-docs {
    position: absolute;
    top: 5px;
    right: 5px;
    transition: all .2s ease
}

.copy-docs.copied {
    background: #10b981
}

.copy-docs:hover {
    cursor: pointer
}

.kanban-container {
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch
}

.footer ul {
    margin-bottom: 0;
    padding: 0;
    list-style: none
}

.footer ul li {
    display: inline-block
}

.footer ul li a {
    text-decoration: none;
    position: relative;
    display: block;
    color: #374151
}

.footer ul li a:hover {
    color: #1f2937
}

.footer ul li .btn {
    margin: 0
}

.footer ul.links-horizontal:first-child a {
    padding-left: 0
}

.footer ul.links-horizontal:last-child a {
    padding-right: 0
}

.footer ul.links-vertical li {
    display: block;
    margin-left: -5px;
    margin-right: -5px
}

.footer ul.links-vertical li a {
    padding: 5px
}

.footer ul.links-vertical li a:hover {
    color: inherit !important
}

.footer ul.icon-box i {
    line-height: 1.7
}

.footer .social-buttons .btn,
.footer .social-buttons a {
    margin-top: 5px;
    margin-bottom: 5px;
    padding: .125rem .375rem
}

.footer .footer-brand {
    font-size: 1.25rem;
    font-weight: 500
}

.footer .footer-brand img.common {
    height: 40px
}

.footer .footer-brand img {
    height: 40px;
    width: 40px
}

.footer .footer-brand:focus,
.footer .footer-brand:hover {
    color: #111827
}

.footer .footer-language-link {
    font-size: .875rem
}

.footer .footer-language-link i {
    font-size: .75rem
}

.footer .copyright {
    font-size: .875rem
}

.footer .pull-center {
    display: inline-block;
    float: none
}

#doc-index:not(.collapse.show),
.doc-sidebar {
    display: none
}

@media (min-width: 992px) {
    #doc-index {
        display: block
    }

    .doc-sidebar {
        display: block;
        height: calc(100vh - 2rem);
        overflow-y: scroll;
        position: sticky;
        top: 2rem
    }

    .doc-sidebar .nav-link[data-toggle=collapse] > .icon {
        transform: rotateZ(-90deg);
        position: relative;
        right: .25rem
    }

    .doc-sidebar .nav .nav-item {
        font-size: .875rem
    }
}

.sidebar {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    max-height: 100%;
    overflow-y: auto;
    width: 100%;
    transition: max-width .1s
}

@media (prefers-reduced-motion: reduce) {
    .sidebar {
        transition: none
    }
}

@media (min-width: 768px) {
    .sidebar {
        width: 100%;
        max-width: 260px
    }
}

.sidebar .nav {
    white-space: nowrap
}

.sidebar .nav-item {
    margin-bottom: .2rem
}

.sidebar .nav-item.active > .nav-link {
    color: #f2f4f6;
    background-color: #374151
}

.sidebar .nav-item .nav-link {
    color: #fff;
    cursor: pointer
}

.sidebar .nav-item .nav-link:hover {
    color: #f2f4f6;
    background-color: #374151
}

.sidebar .nav-link + .multi-level {
    margin-top: .2rem
}

.sidebar .nav-link {
    font-size: 1rem;
    vertical-align: middle;
    padding: .55rem .75rem;
    border-radius: .5rem
}

.sidebar .nav-link .sidebar-icon {
    margin-right: .5rem;
    color: #9ca3af
}

.sidebar .nav-link .link-arrow {
    font-size: .875rem
}

.sidebar .nav-link[data-bs-toggle=collapse][aria-expanded=true] .link-arrow {
    transform: rotate(90deg);
    transition: all .2s ease
}

.sidebar .nav-link.active {
    color: #f2f4f6
}

.sidebar .multi-level .nav-link {
    padding-left: 53px
}

.sidebar .badge,
.sidebar .link-arrow,
.sidebar .notification-count,
.sidebar .sidebar-text {
    opacity: 1
}

.sidebar .sidebar-text-contracted {
    display: none
}

.sidebar.contracted {
    max-width: 95px
}

.sidebar.contracted .badge,
.sidebar.contracted .link-arrow,
.sidebar.contracted .sidebar-text {
    opacity: 0
}

.sidebar.contracted .notification-count {
    opacity: 1;
    position: absolute;
    top: 0;
    left: 40px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    font-size: .7rem;
    padding: .2rem
}

.sidebar.contracted .nav-item {
    position: relative
}

.sidebar.contracted .nav-item.active > .nav-link {
    background-color: #363c54;
    width: 44px
}

.sidebar.contracted .nav-item .nav-link:hover {
    background-color: #1f2937
}

.sidebar.contracted .sidebar-text-contracted {
    display: inline
}

.sidebar.contracted .multi-level .nav-link {
    padding-left: 17px
}

.sidebar.contracted .nav-item {
    white-space: nowrap
}

.sidebar.contracted .sidebar-icon {
    text-align: center
}

@media (min-width: 768px) {
    .sidebar.contracted + .content {
        margin-left: 95px
    }
}

.sidebar-inner {
    position: relative;
    overflow-y: hidden
}

.sidebar-heading {
    font-size: .75rem;
    text-transform: uppercase
}

.user-card {
    border-bottom: .0625rem solid #2e3650
}

@media (max-width: 575.98px) {
    .sidebar {
        width: 100%
    }
}

.content {
    overflow: hidden;
    padding: 0 1rem 0 1rem;
    transition: all .3s
}

@media (prefers-reduced-motion: reduce) {
    .content {
        transition: none
    }
}

@media (min-width: 992px) {
    .content {
        margin-left: 0px
    }
}

.sidebar-toggle {
    font-size: 1.3rem
}

.sidebar-toggle:focus,
.sidebar-toggle:hover {
    outline: 0;
    box-shadow: none;
    background: #d1d5db
}

iframe {
    border: 0
}

figcaption,
figure,
main {
    display: block;
    margin: 0
}

main {
    overflow: hidden
}

img {
    max-width: 100%
}

strong {
    font-weight: 500
}

button:focus {
    outline: 0
}

label {
    font-weight: 500;
    margin-bottom: .5rem
}

.disabled {
    cursor: not-allowed
}

.accordion-flush .accordion-button {
    background-color: transparent
}

.accordion-flush .accordion-button:not(.collapsed) {
    color: #31316a
}

.accordion-flush .accordion-button:focus {
    border-color: #d1d5db;
    box-shadow: none
}

.accordion-flush .accordion-collapse {
    border: 0
}

.alert-heading {
    font-weight: 500
}

.alert-icon {
    margin-bottom: .5rem
}

.alert-icon span {
    font-size: 2rem
}

.avatar + .avatar-content {
    display: inline-block;
    margin-left: .75rem
}

.avatar-sm {
    width: 1.5rem;
    height: 1.5rem
}

.avatar-sm img {
    width: 1.5rem;
    height: 1.5rem
}

.avatar {
    width: 2rem;
    height: 2rem
}

.avatar img {
    width: 2rem;
    height: 2rem
}

.avatar-md {
    width: 3rem;
    height: 3rem
}

.avatar-md img {
    width: 3rem;
    height: 3rem
}

.avatar-lg {
    width: 4.5rem;
    height: 4.5rem
}

.avatar-lg img {
    width: 4.5rem;
    height: 4.5rem
}

.avatar-xl {
    width: 8rem;
    height: 8rem
}

@media (max-width: 991.98px) {
    .avatar-xl {
        width: 4.5rem;
        height: 4.5rem
    }
}

.avatar-offline::before,
.avatar-online::before {
    position: absolute;
    border: 2px solid #fff;
    background-color: #10b981;
    display: block;
    top: 2px;
    left: 39px;
    content: "";
    border-radius: 50%;
    height: 10px;
    width: 10px
}

.avatar-offline::before {
    background-color: #e11d48
}

.avatar-group .avatar {
    position: relative;
    z-index: 0
}

.avatar-group .avatar img {
    border: 2px solid #fff
}

.avatar-group .avatar:hover {
    z-index: 3
}

.avatar-group .avatar + .avatar {
    margin-left: -1rem
}

.animate-down-1,
.animate-left-1,
.animate-right-1,
.animate-up-1,
.scale-down-1,
.scale-up-1 {
    transition: all .2s ease
}

.scale-up-1:hover {
    transform: scale(.55556)
}

.scale-up-hover-1:hover .scale {
    transform: scale(.55556)
}

.scale-down-1:hover {
    transform: scale(.4)
}

.animate-hover:hover .animate-up-1,
.animate-up-1:hover {
    transform: translate(0, -1px)
}

.animate-hover:hover .animate-right-1,
.animate-right-1:hover {
    transform: translate(1px, 0)
}

.animate-down-1:hover,
.animate-hover:hover .animate-down-1 {
    transform: translate(0, 1px)
}

.animate-hover:hover .animate-left-1,
.animate-left-1:hover {
    transform: translate(-1px, 0)
}

.animate-down-2,
.animate-left-2,
.animate-right-2,
.animate-up-2,
.scale-down-2,
.scale-up-2 {
    transition: all .2s ease
}

.scale-up-2:hover {
    transform: scale(1.11111)
}

.scale-up-hover-2:hover .scale {
    transform: scale(1.11111)
}

.scale-down-2:hover {
    transform: scale(.8)
}

.animate-hover:hover .animate-up-2,
.animate-up-2:hover {
    transform: translate(0, -2px)
}

.animate-hover:hover .animate-right-2,
.animate-right-2:hover {
    transform: translate(2px, 0)
}

.animate-down-2:hover,
.animate-hover:hover .animate-down-2 {
    transform: translate(0, 2px)
}

.animate-hover:hover .animate-left-2,
.animate-left-2:hover {
    transform: translate(-2px, 0)
}

.animate-down-3,
.animate-left-3,
.animate-right-3,
.animate-up-3,
.scale-down-3,
.scale-up-3 {
    transition: all .2s ease
}

.scale-up-3:hover {
    transform: scale(1.66667)
}

.scale-up-hover-3:hover .scale {
    transform: scale(1.66667)
}

.scale-down-3:hover {
    transform: scale(1.2)
}

.animate-hover:hover .animate-up-3,
.animate-up-3:hover {
    transform: translate(0, -3px)
}

.animate-hover:hover .animate-right-3,
.animate-right-3:hover {
    transform: translate(3px, 0)
}

.animate-down-3:hover,
.animate-hover:hover .animate-down-3 {
    transform: translate(0, 3px)
}

.animate-hover:hover .animate-left-3,
.animate-left-3:hover {
    transform: translate(-3px, 0)
}

.animate-down-4,
.animate-left-4,
.animate-right-4,
.animate-up-4,
.scale-down-4,
.scale-up-4 {
    transition: all .2s ease
}

.scale-up-4:hover {
    transform: scale(2.22222)
}

.scale-up-hover-4:hover .scale {
    transform: scale(2.22222)
}

.scale-down-4:hover {
    transform: scale(1.6)
}

.animate-hover:hover .animate-up-4,
.animate-up-4:hover {
    transform: translate(0, -4px)
}

.animate-hover:hover .animate-right-4,
.animate-right-4:hover {
    transform: translate(4px, 0)
}

.animate-down-4:hover,
.animate-hover:hover .animate-down-4 {
    transform: translate(0, 4px)
}

.animate-hover:hover .animate-left-4,
.animate-left-4:hover {
    transform: translate(-4px, 0)
}

.animate-down-5,
.animate-left-5,
.animate-right-5,
.animate-up-5,
.scale-down-5,
.scale-up-5 {
    transition: all .2s ease
}

.scale-up-5:hover {
    transform: scale(2.77778)
}

.scale-up-hover-5:hover .scale {
    transform: scale(2.77778)
}

.scale-down-5:hover {
    transform: scale(2)
}

.animate-hover:hover .animate-up-5,
.animate-up-5:hover {
    transform: translate(0, -5px)
}

.animate-hover:hover .animate-right-5,
.animate-right-5:hover {
    transform: translate(5px, 0)
}

.animate-down-5:hover,
.animate-hover:hover .animate-down-5 {
    transform: translate(0, 5px)
}

.animate-hover:hover .animate-left-5,
.animate-left-5:hover {
    transform: translate(-5px, 0)
}

.animate-down-6,
.animate-left-6,
.animate-right-6,
.animate-up-6,
.scale-down-6,
.scale-up-6 {
    transition: all .2s ease
}

.scale-up-6:hover {
    transform: scale(3.33333)
}

.scale-up-hover-6:hover .scale {
    transform: scale(3.33333)
}

.scale-down-6:hover {
    transform: scale(2.4)
}

.animate-hover:hover .animate-up-6,
.animate-up-6:hover {
    transform: translate(0, -6px)
}

.animate-hover:hover .animate-right-6,
.animate-right-6:hover {
    transform: translate(6px, 0)
}

.animate-down-6:hover,
.animate-hover:hover .animate-down-6 {
    transform: translate(0, 6px)
}

.animate-hover:hover .animate-left-6,
.animate-left-6:hover {
    transform: translate(-6px, 0)
}

.animate-down-7,
.animate-left-7,
.animate-right-7,
.animate-up-7,
.scale-down-7,
.scale-up-7 {
    transition: all .2s ease
}

.scale-up-7:hover {
    transform: scale(3.88889)
}

.scale-up-hover-7:hover .scale {
    transform: scale(3.88889)
}

.scale-down-7:hover {
    transform: scale(2.8)
}

.animate-hover:hover .animate-up-7,
.animate-up-7:hover {
    transform: translate(0, -7px)
}

.animate-hover:hover .animate-right-7,
.animate-right-7:hover {
    transform: translate(7px, 0)
}

.animate-down-7:hover,
.animate-hover:hover .animate-down-7 {
    transform: translate(0, 7px)
}

.animate-hover:hover .animate-left-7,
.animate-left-7:hover {
    transform: translate(-7px, 0)
}

.animate-down-8,
.animate-left-8,
.animate-right-8,
.animate-up-8,
.scale-down-8,
.scale-up-8 {
    transition: all .2s ease
}

.scale-up-8:hover {
    transform: scale(4.44444)
}

.scale-up-hover-8:hover .scale {
    transform: scale(4.44444)
}

.scale-down-8:hover {
    transform: scale(3.2)
}

.animate-hover:hover .animate-up-8,
.animate-up-8:hover {
    transform: translate(0, -8px)
}

.animate-hover:hover .animate-right-8,
.animate-right-8:hover {
    transform: translate(8px, 0)
}

.animate-down-8:hover,
.animate-hover:hover .animate-down-8 {
    transform: translate(0, 8px)
}

.animate-hover:hover .animate-left-8,
.animate-left-8:hover {
    transform: translate(-8px, 0)
}

.animate-down-9,
.animate-left-9,
.animate-right-9,
.animate-up-9,
.scale-down-9,
.scale-up-9 {
    transition: all .2s ease
}

.scale-up-9:hover {
    transform: scale(5)
}

.scale-up-hover-9:hover .scale {
    transform: scale(5)
}

.scale-down-9:hover {
    transform: scale(3.6)
}

.animate-hover:hover .animate-up-9,
.animate-up-9:hover {
    transform: translate(0, -9px)
}

.animate-hover:hover .animate-right-9,
.animate-right-9:hover {
    transform: translate(9px, 0)
}

.animate-down-9:hover,
.animate-hover:hover .animate-down-9 {
    transform: translate(0, 9px)
}

.animate-hover:hover .animate-left-9,
.animate-left-9:hover {
    transform: translate(-9px, 0)
}

@keyframes show-navbar-collapse {
    0% {
        opacity: 0;
        transform: scale(.95);
        transform-origin: 100% 0
    }

    100% {
        opacity: 1;
        transform: scale(1)
    }
}

@keyframes hide-navbar-collapse {
    from {
        opacity: 1;
        transform: scale(1);
        transform-origin: 100% 0
    }

    to {
        opacity: 0;
        transform: scale(.95)
    }
}

@keyframes show-navbar-dropdown {
    0% {
        opacity: 0;
        transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
        transition: visibility .45s, opacity .45s, transform .45s
    }

    100% {
        transform: translate(0, 0);
        opacity: 1
    }
}

@keyframes hide-navbar-dropdown {
    from {
        opacity: 1
    }

    to {
        opacity: 0;
        transform: translate(0, 10px)
    }
}

@keyframes show-dropdown {
    0% {
        opacity: 0;
        transform-origin: perspective(200px) rotateX(-2deg);
        transition: visibility .45s, opacity .5s
    }

    100% {
        opacity: 1
    }
}

@keyframes hide-dropdown {
    from {
        opacity: 1
    }

    to {
        opacity: 0;
        transform: translate(0, 10px)
    }
}

.bell-shake.shaking {
    animation: bellshake .5s cubic-bezier(.36, .07, .19, .97) both;
    backface-visibility: hidden;
    transform-origin: top right
}

:root {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1
}

.animate__animated {
    animation-duration: 1s;
    animation-duration: var(--animate-duration);
    animation-fill-mode: both
}

.animate__jackInTheBox {
    animation-name: jackInTheBox
}

@keyframes bellshake {
    0% {
        transform: rotate(0)
    }

    15% {
        transform: rotate(5deg)
    }

    30% {
        transform: rotate(-5deg)
    }

    45% {
        transform: rotate(4deg)
    }

    60% {
        transform: rotate(-4deg)
    }

    75% {
        transform: rotate(2deg)
    }

    85% {
        transform: rotate(-2deg)
    }

    92% {
        transform: rotate(1deg)
    }

    100% {
        transform: rotate(0)
    }
}

@keyframes jackInTheBox {
    from {
        opacity: 0;
        transform: scale(.1) rotate(30deg);
        transform-origin: center bottom
    }

    50% {
        transform: rotate(-10deg)
    }

    70% {
        transform: rotate(3deg)
    }

    to {
        opacity: 1;
        transform: scale(1)
    }
}

.animate__jackInTheBox {
    animation-name: jackInTheBox
}

[class*=shadow] {
    transition: all .2s ease
}

.badge {
    font-size: .75em;
    font-weight: 600
}

.badge a {
    color: #fff
}

.badge.super-badge {
    vertical-align: super
}

.badge-pill {
    padding-right: .875em;
    padding-left: .875em
}

.badge-inline {
    margin-right: .625rem
}

.badge-inline + span {
    top: 2px;
    position: relative
}

.badge-inline + span > a {
    text-decoration: underline
}

.badge-sm {
    padding: .2rem .6rem
}

.badge-lg {
    font-size: 1.25rem;
    padding: .35rem .85rem
}

.btn .badge-corner {
    position: absolute;
    top: -50%;
    right: .5rem;
    transform: translate(50%, 50%);
    margin: 0;
    border: 3px solid;
    padding-left: .5rem;
    padding-right: .5rem
}

.wi-tags a {
    display: inline-block;
    padding: .125rem .875rem;
    margin: .25rem;
    line-height: 2;
    font-size: .875rem;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    background-color: #fff
}

.pixel-pro-badge {
    position: relative;
    font-size: .875rem;
    text-transform: uppercase;
    font-weight: 500;
    right: -11px;
    padding: 4px 12px;
    top: -30px;
    background: #fff;
    border-radius: .35rem;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)
}

@media (max-width: 575.98px) {
    .pixel-pro-badge {
        font-size: 1rem;
        right: -13px;
        padding: 5px 10px;
        top: -23px
    }
}

.subscription-badge {
    top: -19px;
    right: -12px;
    font-size: .75rem
}

.btn.btn-circle {
    border-radius: 50%
}

.btn.btn-md {
    padding: .65rem 1.25rem
}

.btn.btn-xs {
    padding: .2rem .35rem;
    font-size: .55rem;
    box-shadow: none
}

.btn.large-form-btn {
    padding: 1.2rem 1rem
}

.btn.dashed-outline {
    border-style: dashed
}

.btn-icon-only {
    width: 2.575rem;
    height: 2.575rem;
    padding: 0;
    display: flex;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center
}

.btn-icon-only.btn-xs {
    width: 1.7rem;
    height: 1.7rem
}

.btn-group-sm > .btn-icon-only.btn,
.btn-icon-only.btn-sm {
    width: 2rem;
    height: 2rem
}

.btn-primary:hover {
    background-color: #161d27;
    border-color: #161d27
}

.btn-secondary:hover {
    background-color: #eeb15d;
    border-color: #eeb15d
}

.btn-tertiary:hover {
    background-color: #292959;
    border-color: #292959
}

.btn-success:hover {
    background-color: #0ea271;
    border-color: #0ea271
}

.btn-info:hover {
    background-color: #1f57b8;
    border-color: #1f57b8
}

.btn-warning:hover {
    background-color: #f59e04;
    border-color: #f59e04
}

.btn-danger:hover {
    background-color: #ca1a41;
    border-color: #ca1a41
}

.btn-white:hover {
    background-color: #f2f2f2;
    border-color: #f2f2f2
}

.btn-indigo:hover {
    background-color: #3a30e2;
    border-color: #3a30e2
}

.btn-purple:hover {
    background-color: #6c23eb;
    border-color: #6c23eb
}

.btn-yellow-100:hover {
    background-color: #ffe3bd;
    border-color: #ffe3bd
}

.btn-yellow-200:hover {
    background-color: #f2d0a2;
    border-color: #f2d0a2
}

.btn-gray-50:hover {
    background-color: #eaedf1;
    border-color: #eaedf1
}

.btn-gray-100:hover {
    background-color: #e3e7ec;
    border-color: #e3e7ec
}

.btn-gray-200:hover {
    background-color: #d7dae0;
    border-color: #d7dae0
}

.btn-gray-300:hover {
    background-color: #c3c8d0;
    border-color: #c3c8d0
}

.btn-gray-400:hover {
    background-color: #8e96a4;
    border-color: #8e96a4
}

.btn-gray-500:hover {
    background-color: #5f6672;
    border-color: #5f6672
}

.btn-gray-600:hover {
    background-color: #404954;
    border-color: #404954
}

.btn-gray-700:hover {
    background-color: #2d3542;
    border-color: #2d3542
}

.btn-gray-800:hover {
    background-color: #161d27;
    border-color: #161d27
}

.btn-gray-900:hover {
    background-color: #090d15;
    border-color: #090d15
}

.btn-facebook {
    color: #fff;
    background-color: #3b5999;
    border-color: #3b5999;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-facebook:hover {
    color: #fff;
    background-color: #324c82;
    border-color: #2f477a
}

.btn-check:focus + .btn-facebook,
.btn-facebook:focus {
    color: #fff;
    background-color: #324c82;
    border-color: #2f477a;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(88, 114, 168, .5)
}

.btn-check:active + .btn-facebook,
.btn-check:checked + .btn-facebook,
.btn-facebook.active,
.btn-facebook:active,
.show > .btn-facebook.dropdown-toggle {
    color: #fff;
    background-color: #2f477a;
    border-color: #2c4373
}

.btn-check:active + .btn-facebook:focus,
.btn-check:checked + .btn-facebook:focus,
.btn-facebook.active:focus,
.btn-facebook:active:focus,
.show > .btn-facebook.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(88, 114, 168, .5)
}

.btn-facebook.disabled,
.btn-facebook:disabled {
    color: #fff;
    background-color: #3b5999;
    border-color: #3b5999
}

.btn-facebook.btn-link {
    color: #3b5999;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-facebook.btn-link.active,
.btn-facebook.btn-link:focus,
.btn-facebook.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #3b5999
}

.btn-twitter {
    color: #1f2937;
    background-color: #1da1f2;
    border-color: #1da1f2;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-twitter:hover {
    color: #1f2937;
    background-color: #3faff4;
    border-color: #34aaf3
}

.btn-check:focus + .btn-twitter,
.btn-twitter:focus {
    color: #1f2937;
    background-color: #3faff4;
    border-color: #34aaf3;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(29, 143, 214, .5)
}

.btn-check:active + .btn-twitter,
.btn-check:checked + .btn-twitter,
.btn-twitter.active,
.btn-twitter:active,
.show > .btn-twitter.dropdown-toggle {
    color: #1f2937;
    background-color: #4ab4f5;
    border-color: #34aaf3
}

.btn-check:active + .btn-twitter:focus,
.btn-check:checked + .btn-twitter:focus,
.btn-twitter.active:focus,
.btn-twitter:active:focus,
.show > .btn-twitter.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(29, 143, 214, .5)
}

.btn-twitter.disabled,
.btn-twitter:disabled {
    color: #1f2937;
    background-color: #1da1f2;
    border-color: #1da1f2
}

.btn-twitter.btn-link {
    color: #1da1f2;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-twitter.btn-link.active,
.btn-twitter.btn-link:focus,
.btn-twitter.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #1da1f2
}

.btn-google {
    color: #fff;
    background-color: #db4337;
    border-color: #db4337;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-google:hover {
    color: #fff;
    background-color: #ba392f;
    border-color: #af362c
}

.btn-check:focus + .btn-google,
.btn-google:focus {
    color: #fff;
    background-color: #ba392f;
    border-color: #af362c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(224, 95, 85, .5)
}

.btn-check:active + .btn-google,
.btn-check:checked + .btn-google,
.btn-google.active,
.btn-google:active,
.show > .btn-google.dropdown-toggle {
    color: #fff;
    background-color: #af362c;
    border-color: #a43229
}

.btn-check:active + .btn-google:focus,
.btn-check:checked + .btn-google:focus,
.btn-google.active:focus,
.btn-google:active:focus,
.show > .btn-google.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(224, 95, 85, .5)
}

.btn-google.disabled,
.btn-google:disabled {
    color: #fff;
    background-color: #db4337;
    border-color: #db4337
}

.btn-google.btn-link {
    color: #db4337;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-google.btn-link.active,
.btn-google.btn-link:focus,
.btn-google.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #db4337
}

.btn-instagram {
    color: #fff;
    background-color: #e4405f;
    border-color: #e4405f;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-instagram:hover {
    color: #fff;
    background-color: #c23651;
    border-color: #b6334c
}

.btn-check:focus + .btn-instagram,
.btn-instagram:focus {
    color: #fff;
    background-color: #c23651;
    border-color: #b6334c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(232, 93, 119, .5)
}

.btn-check:active + .btn-instagram,
.btn-check:checked + .btn-instagram,
.btn-instagram.active,
.btn-instagram:active,
.show > .btn-instagram.dropdown-toggle {
    color: #fff;
    background-color: #b6334c;
    border-color: #ab3047
}

.btn-check:active + .btn-instagram:focus,
.btn-check:checked + .btn-instagram:focus,
.btn-instagram.active:focus,
.btn-instagram:active:focus,
.show > .btn-instagram.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(232, 93, 119, .5)
}

.btn-instagram.disabled,
.btn-instagram:disabled {
    color: #fff;
    background-color: #e4405f;
    border-color: #e4405f
}

.btn-instagram.btn-link {
    color: #e4405f;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-instagram.btn-link.active,
.btn-instagram.btn-link:focus,
.btn-instagram.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #e4405f
}

.btn-pinterest {
    color: #fff;
    background-color: #bd081c;
    border-color: #bd081c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-pinterest:hover {
    color: #fff;
    background-color: #a10718;
    border-color: #970616
}

.btn-check:focus + .btn-pinterest,
.btn-pinterest:focus {
    color: #fff;
    background-color: #a10718;
    border-color: #970616;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(199, 45, 62, .5)
}

.btn-check:active + .btn-pinterest,
.btn-check:checked + .btn-pinterest,
.btn-pinterest.active,
.btn-pinterest:active,
.show > .btn-pinterest.dropdown-toggle {
    color: #fff;
    background-color: #970616;
    border-color: #8e0615
}

.btn-check:active + .btn-pinterest:focus,
.btn-check:checked + .btn-pinterest:focus,
.btn-pinterest.active:focus,
.btn-pinterest:active:focus,
.show > .btn-pinterest.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(199, 45, 62, .5)
}

.btn-pinterest.disabled,
.btn-pinterest:disabled {
    color: #fff;
    background-color: #bd081c;
    border-color: #bd081c
}

.btn-pinterest.btn-link {
    color: #bd081c;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-pinterest.btn-link.active,
.btn-pinterest.btn-link:focus,
.btn-pinterest.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #bd081c
}

.btn-youtube {
    color: #fff;
    background-color: #cd201f;
    border-color: #cd201f;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-youtube:hover {
    color: #fff;
    background-color: #ae1b1a;
    border-color: #a41a19
}

.btn-check:focus + .btn-youtube,
.btn-youtube:focus {
    color: #fff;
    background-color: #ae1b1a;
    border-color: #a41a19;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(213, 65, 65, .5)
}

.btn-check:active + .btn-youtube,
.btn-check:checked + .btn-youtube,
.btn-youtube.active,
.btn-youtube:active,
.show > .btn-youtube.dropdown-toggle {
    color: #fff;
    background-color: #a41a19;
    border-color: #9a1817
}

.btn-check:active + .btn-youtube:focus,
.btn-check:checked + .btn-youtube:focus,
.btn-youtube.active:focus,
.btn-youtube:active:focus,
.show > .btn-youtube.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(213, 65, 65, .5)
}

.btn-youtube.disabled,
.btn-youtube:disabled {
    color: #fff;
    background-color: #cd201f;
    border-color: #cd201f
}

.btn-youtube.btn-link {
    color: #cd201f;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-youtube.btn-link.active,
.btn-youtube.btn-link:focus,
.btn-youtube.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #cd201f
}

.btn-slack {
    color: #1f2937;
    background-color: #3aaf85;
    border-color: #3aaf85;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-slack:hover {
    color: #1f2937;
    background-color: #58bb97;
    border-color: #4eb791
}

.btn-check:focus + .btn-slack,
.btn-slack:focus {
    color: #1f2937;
    background-color: #58bb97;
    border-color: #4eb791;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(54, 155, 121, .5)
}

.btn-check:active + .btn-slack,
.btn-check:checked + .btn-slack,
.btn-slack.active,
.btn-slack:active,
.show > .btn-slack.dropdown-toggle {
    color: #1f2937;
    background-color: #61bf9d;
    border-color: #4eb791
}

.btn-check:active + .btn-slack:focus,
.btn-check:checked + .btn-slack:focus,
.btn-slack.active:focus,
.btn-slack:active:focus,
.show > .btn-slack.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(54, 155, 121, .5)
}

.btn-slack.disabled,
.btn-slack:disabled {
    color: #1f2937;
    background-color: #3aaf85;
    border-color: #3aaf85
}

.btn-slack.btn-link {
    color: #3aaf85;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-slack.btn-link.active,
.btn-slack.btn-link:focus,
.btn-slack.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #3aaf85
}

.btn-dribbble {
    color: #fff;
    background-color: #ea4c89;
    border-color: #ea4c89;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-dribbble:hover {
    color: #fff;
    background-color: #c74174;
    border-color: #bb3d6e
}

.btn-check:focus + .btn-dribbble,
.btn-dribbble:focus {
    color: #fff;
    background-color: #c74174;
    border-color: #bb3d6e;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(237, 103, 155, .5)
}

.btn-check:active + .btn-dribbble,
.btn-check:checked + .btn-dribbble,
.btn-dribbble.active,
.btn-dribbble:active,
.show > .btn-dribbble.dropdown-toggle {
    color: #fff;
    background-color: #bb3d6e;
    border-color: #b03967
}

.btn-check:active + .btn-dribbble:focus,
.btn-check:checked + .btn-dribbble:focus,
.btn-dribbble.active:focus,
.btn-dribbble:active:focus,
.show > .btn-dribbble.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(237, 103, 155, .5)
}

.btn-dribbble.disabled,
.btn-dribbble:disabled {
    color: #fff;
    background-color: #ea4c89;
    border-color: #ea4c89
}

.btn-dribbble.btn-link {
    color: #ea4c89;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-dribbble.btn-link.active,
.btn-dribbble.btn-link:focus,
.btn-dribbble.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #ea4c89
}

.btn-dropbox {
    color: #fff;
    background-color: #1e90ff;
    border-color: #1e90ff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-dropbox:hover {
    color: #fff;
    background-color: #1a7ad9;
    border-color: #1873cc
}

.btn-check:focus + .btn-dropbox,
.btn-dropbox:focus {
    color: #fff;
    background-color: #1a7ad9;
    border-color: #1873cc;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(64, 161, 255, .5)
}

.btn-check:active + .btn-dropbox,
.btn-check:checked + .btn-dropbox,
.btn-dropbox.active,
.btn-dropbox:active,
.show > .btn-dropbox.dropdown-toggle {
    color: #fff;
    background-color: #1873cc;
    border-color: #176cbf
}

.btn-check:active + .btn-dropbox:focus,
.btn-check:checked + .btn-dropbox:focus,
.btn-dropbox.active:focus,
.btn-dropbox:active:focus,
.show > .btn-dropbox.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(64, 161, 255, .5)
}

.btn-dropbox.disabled,
.btn-dropbox:disabled {
    color: #fff;
    background-color: #1e90ff;
    border-color: #1e90ff
}

.btn-dropbox.btn-link {
    color: #1e90ff;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-dropbox.btn-link.active,
.btn-dropbox.btn-link:focus,
.btn-dropbox.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #1e90ff
}

.btn-twitch {
    color: #fff;
    background-color: #4b367c;
    border-color: #4b367c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-twitch:hover {
    color: #fff;
    background-color: #402e69;
    border-color: #3c2b63
}

.btn-check:focus + .btn-twitch,
.btn-twitch:focus {
    color: #fff;
    background-color: #402e69;
    border-color: #3c2b63;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(102, 84, 144, .5)
}

.btn-check:active + .btn-twitch,
.btn-check:checked + .btn-twitch,
.btn-twitch.active,
.btn-twitch:active,
.show > .btn-twitch.dropdown-toggle {
    color: #fff;
    background-color: #3c2b63;
    border-color: #38295d
}

.btn-check:active + .btn-twitch:focus,
.btn-check:checked + .btn-twitch:focus,
.btn-twitch.active:focus,
.btn-twitch:active:focus,
.show > .btn-twitch.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(102, 84, 144, .5)
}

.btn-twitch.disabled,
.btn-twitch:disabled {
    color: #fff;
    background-color: #4b367c;
    border-color: #4b367c
}

.btn-twitch.btn-link {
    color: #4b367c;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-twitch.btn-link.active,
.btn-twitch.btn-link:focus,
.btn-twitch.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #4b367c
}

.btn-paypal {
    color: #1f2937;
    background-color: #ecb32c;
    border-color: #ecb32c;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-paypal:hover {
    color: #1f2937;
    background-color: #efbe4c;
    border-color: #eebb41
}

.btn-check:focus + .btn-paypal,
.btn-paypal:focus {
    color: #1f2937;
    background-color: #efbe4c;
    border-color: #eebb41;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(205, 158, 46, .5)
}

.btn-check:active + .btn-paypal,
.btn-check:checked + .btn-paypal,
.btn-paypal.active,
.btn-paypal:active,
.show > .btn-paypal.dropdown-toggle {
    color: #1f2937;
    background-color: #f0c256;
    border-color: #eebb41
}

.btn-check:active + .btn-paypal:focus,
.btn-check:checked + .btn-paypal:focus,
.btn-paypal.active:focus,
.btn-paypal:active:focus,
.show > .btn-paypal.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(205, 158, 46, .5)
}

.btn-paypal.disabled,
.btn-paypal:disabled {
    color: #1f2937;
    background-color: #ecb32c;
    border-color: #ecb32c
}

.btn-paypal.btn-link {
    color: #ecb32c;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-paypal.btn-link.active,
.btn-paypal.btn-link:focus,
.btn-paypal.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #ecb32c
}

.btn-behance {
    color: #fff;
    background-color: #0057ff;
    border-color: #0057ff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-behance:hover {
    color: #fff;
    background-color: #004ad9;
    border-color: #0046cc
}

.btn-behance:focus,
.btn-check:focus + .btn-behance {
    color: #fff;
    background-color: #004ad9;
    border-color: #0046cc;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(38, 112, 255, .5)
}

.btn-behance.active,
.btn-behance:active,
.btn-check:active + .btn-behance,
.btn-check:checked + .btn-behance,
.show > .btn-behance.dropdown-toggle {
    color: #fff;
    background-color: #0046cc;
    border-color: #0041bf
}

.btn-behance.active:focus,
.btn-behance:active:focus,
.btn-check:active + .btn-behance:focus,
.btn-check:checked + .btn-behance:focus,
.show > .btn-behance.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(38, 112, 255, .5)
}

.btn-behance.disabled,
.btn-behance:disabled {
    color: #fff;
    background-color: #0057ff;
    border-color: #0057ff
}

.btn-behance.btn-link {
    color: #0057ff;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-behance.btn-link.active,
.btn-behance.btn-link:focus,
.btn-behance.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #0057ff
}

.btn-reddit {
    color: #fff;
    background-color: #e84422;
    border-color: #e84422;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-reddit:hover {
    color: #fff;
    background-color: #c53a1d;
    border-color: #ba361b
}

.btn-check:focus + .btn-reddit,
.btn-reddit:focus {
    color: #fff;
    background-color: #c53a1d;
    border-color: #ba361b;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(235, 96, 67, .5)
}

.btn-check:active + .btn-reddit,
.btn-check:checked + .btn-reddit,
.btn-reddit.active,
.btn-reddit:active,
.show > .btn-reddit.dropdown-toggle {
    color: #fff;
    background-color: #ba361b;
    border-color: #ae331a
}

.btn-check:active + .btn-reddit:focus,
.btn-check:checked + .btn-reddit:focus,
.btn-reddit.active:focus,
.btn-reddit:active:focus,
.show > .btn-reddit.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(235, 96, 67, .5)
}

.btn-reddit.disabled,
.btn-reddit:disabled {
    color: #fff;
    background-color: #e84422;
    border-color: #e84422
}

.btn-reddit.btn-link {
    color: #e84422;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-reddit.btn-link.active,
.btn-reddit.btn-link:focus,
.btn-reddit.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #e84422
}

.btn-github {
    color: #fff;
    background-color: #222;
    border-color: #222;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)
}

.btn-github:hover {
    color: #fff;
    background-color: #1d1d1d;
    border-color: #1b1b1b
}

.btn-check:focus + .btn-github,
.btn-github:focus {
    color: #fff;
    background-color: #1d1d1d;
    border-color: #1b1b1b;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(67, 67, 67, .5)
}

.btn-check:active + .btn-github,
.btn-check:checked + .btn-github,
.btn-github.active,
.btn-github:active,
.show > .btn-github.dropdown-toggle {
    color: #fff;
    background-color: #1b1b1b;
    border-color: #1a1a1a
}

.btn-check:active + .btn-github:focus,
.btn-check:checked + .btn-github:focus,
.btn-github.active:focus,
.btn-github:active:focus,
.show > .btn-github.dropdown-toggle:focus {
    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(67, 67, 67, .5)
}

.btn-github.disabled,
.btn-github:disabled {
    color: #fff;
    background-color: #222;
    border-color: #222
}

.btn-github.btn-link {
    color: #222;
    background: 0 0;
    box-shadow: none;
    border: 0;
    border-style: none
}

.btn-github.btn-link.active,
.btn-github.btn-link:focus,
.btn-github.btn-link:hover {
    background-color: transparent !important;
    box-shadow: none;
    border: 0;
    color: #222
}

.theme-settings-close {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: .65rem
}

.btn-close.theme-settings-close {
    background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_18___}) center/1em auto no-repeat;
    border: 0;
    border-radius: .5rem;
    opacity: .5
}

.breadcrumb-item {
    font-size: .75rem
}

.breadcrumb-item,
.breadcrumb-item a {
    color: #374151;
    font-weight: 400;
    font-size: .75rem
}

@media (min-width: 576px) {

    .breadcrumb-item,
    .breadcrumb-item a {
        font-size: .875rem
    }
}

.breadcrumb-transparent {
    background: 0 0;
    padding: 0
}

.breadcrumb-text-light .breadcrumb-item,
.breadcrumb-text-light .breadcrumb-item a {
    color: #fff
}

.breadcrumb-text-light .breadcrumb-item:before {
    color: #fff
}

.card {
    position: relative
}

.card .card-header {
    background: 0 0
}

.card.hover-state:hover {
    background-color: #f2f4f6
}

.card .profile-cover {
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    height: 200px
}

.card.notification-card {
    height: 633px
}

.card.notification-card .list-group-timeline {
    height: 520px;
    overflow: hidden;
    overflow-y: auto
}

@media (min-width: 992px) {
    .card.timeline-card:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        margin-left: .75rem;
        border: 8px solid #111827;
        border-color: transparent #e0e6ec #e0e6ec transparent;
        box-sizing: border-box;
        transform-origin: 0 0;
        transform: rotate(135deg);
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
    }

    .card.left-timeline-card:after {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        margin-right: -5px;
        border: 8px solid #111827;
        border-color: transparent #e0e6ec #e0e6ec transparent;
        box-sizing: border-box;
        transform-origin: 0 0;
        transform: rotate(-45deg);
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
    }
}

.message-wrapper .card,
.task-wrapper .card {
    border: 0
}

.customer-testimonial .content-wrapper:before {
    content: "";
    position: absolute;
    top: 25px;
    left: -1px;
    margin-left: .75rem;
    border: 8px solid #111827;
    border-color: transparent #e0e6ec #e0e6ec transparent;
    box-sizing: border-box;
    transform-origin: 0 0;
    transform: rotate(135deg);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
}

.card-footer {
    background-color: transparent
}

.card-stats {
    padding-left: 1.785rem
}

.card .card-blockquote {
    position: relative;
    padding: 2rem
}

.card .card-blockquote .svg-bg {
    display: block;
    position: absolute;
    width: 100%;
    height: 95px;
    top: -94px;
    left: 0
}

.card-lift-hover:hover {
    transform: translateY(-20px);
    transition: all .2s ease
}

@media (prefers-reduced-motion: reduce) {
    .card-lift-hover:hover {
        transition: none
    }
}

.page-preview {
    display: block;
    position: relative
}

.page-preview .show-on-hover {
    position: absolute;
    bottom: -25px;
    background: rgba(31, 41, 55, .85);
    padding: 10px 0;
    border-bottom-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
    width: calc(100% + 28px);
    left: -14px;
    opacity: 0;
    transition: .2s
}

@media (prefers-reduced-motion: reduce) {
    .page-preview .show-on-hover {
        transition: none
    }
}

.page-preview.page-preview-lg .show-on-hover {
    left: -30px;
    width: calc(100% + 60px);
    bottom: -20px
}

.page-preview:hover .show-on-hover {
    z-index: 99;
    opacity: 1
}

.carousel-caption,
.carousel-caption .h5,
.carousel-caption h5 {
    color: #fff
}

.carousel-indicators li {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: 0 0;
    border: 2px solid #fff
}

.carousel-indicators .active {
    opacity: 1;
    background: #fff
}

.carousel-control-next-icon,
.carousel-control-prev-icon {
    width: auto;
    height: auto;
    font-weight: 900
}

.carousel-control-prev-icon {
    background-image: none
}

.carousel-control-prev-icon::before {
    content: '\\f060';
    font-family: "Font Awesome 5 Free";
    font-size: 2rem
}

.carousel-control-next-icon {
    background-image: none
}

.carousel-control-next-icon:before {
    font-family: "Font Awesome 5 Free";
    content: "\\f061";
    font-size: 2rem
}

.close {
    transition: all .2s ease
}

.close > span:not(.sr-only) {
    display: block;
    height: 1.25rem;
    width: 1.25rem;
    background-color: transparent;
    color: rgba(0, 0, 0, .6);
    line-height: 17px;
    border-radius: 50%;
    font-size: 1.25rem;
    transition: all .2s ease
}

.close:focus,
.close:hover {
    background-color: transparent;
    color: rgba(0, 0, 0, .9);
    outline: 0
}

.close:focus span:not(.sr-only),
.close:hover span:not(.sr-only) {
    background-color: transparent
}

.counter-alternate::after {
    content: '\\f067';
    font-family: "Font Awesome 5 Free";
    position: absolute;
    font-size: 2.25rem;
    color: #1f2937;
    font-weight: 900
}

.custom-control-label:before {
    box-shadow: none;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

.custom-control-label span {
    position: relative;
    top: 2px
}

.custom-control-label {
    margin-bottom: 0
}

.custom-control-input:active ~ .custom-control-label::before {
    border-color: #1f2937
}

.custom-file-label {
    background-color: #f3f3f5
}

.custom-file-label::after {
    background-color: #f3f3f5
}

.custom-select {
    font-size: .875rem;
    box-shadow: none
}

.custom-select.custom-select-shadow {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);
    transition: box-shadow .15s ease
}

.custom-select.custom-select-shadow:focus {
    box-shadow: .1rem .1rem 0 rgba(229, 231, 235, .5)
}

.custom-select:hover {
    cursor: pointer
}

.apexcharts-tooltip {
    background-color: #fff !important;
    color: #374151 !important;
    border: 0 !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important;
    border-radius: .35rem !important
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    padding: 6px 10px !important;
    background: #e5e7eb !important;
    border-bottom: .0625rem solid #d1d5db !important
}

.apexcharts-xaxistooltip {
    color: #374151 !important;
    border: 0 !important;
    background-color: #fff !important;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important;
    border-radius: .35rem !important
}

.apexcharts-xaxistooltip-bottom::before {
    border-bottom-color: #fff !important
}

.apexcharts-xaxistooltip-bottom::after {
    border-bottom-color: #fff !important
}

.apexcharts-tooltip-marker {
    min-width: 10px !important;
    min-height: 10px !important;
    margin-right: 8px !important
}

.apexcharts-tooltip-y-group {
    padding: 4px 0 5px !important
}

.ct-bar {
    stroke-linecap: round;
    stroke-width: 10px
}

.ct-label {
    fill: #374151;
    color: #374151;
    font-size: .75rem;
    margin-top: 6px;
    font-weight: 500
}

.ct-slice-pie {
    stroke: #fff;
    stroke-width: 3px
}

.ct-chart-donut .ct-series {
    stroke: #fff;
    stroke-width: 3px
}

.ct-chart-donut .ct-label,
.ct-chart-pie .ct-label {
    font-size: .75rem;
    font-weight: 500
}

.small-chart {
    margin-left: -1rem
}

.ct-chart-donut .ct-label,
.ct-chart-pie .ct-label {
    color: #fff;
    fill: #fff;
    font-size: 1rem;
    font-weight: 500
}

.ct-series-g .ct-grid {
    stroke: #f8bd7a;
    stroke-width: 2px;
    stroke-dasharray: 2px
}

.ct-series-g .ct-label.ct-horizontal.ct-end {
    margin-left: -9px;
    margin-top: 10px;
    color: #1f2937
}

.dropdown-menu .dropdown-header,
.dropdown-menu .dropdown-item {
    padding: .5rem 1rem;
    font-size: .875rem
}

.dropdown-menu .dropdown-header .dropdown-icon,
.dropdown-menu .dropdown-item .dropdown-icon {
    height: 1.25rem;
    width: 1.25rem
}

.dropdown-menu .dropdown-header {
    color: #111827;
    font-weight: 500
}

.dropdown-menu .dropdown-item {
    transition: all .2s ease;
    font-weight: 400
}

.show .dropdown-menu {
    animation: show-dropdown .2s ease forwards
}

.dropdown-menu.dropdown-menu-xs {
    min-width: 120px;
    max-width: 120px;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)
}

.dropdown-menu-sm {
    min-width: 100px;
    border: 1rem
}

.dropdown-menu-md {
    min-width: 180px;
    border: 1rem
}

.dropdown-menu-lg {
    min-width: 350px;
    border-radius: 1rem
}

@media (max-width: 575.98px) {
    .dropdown-menu-lg {
        min-width: 300px
    }
}

[data-toggle]:hover {
    cursor: pointer
}

.dropdown-toggle:after,
.dropend .dropdown-toggle:after,
.dropstart .dropdown-toggle:before,
.dropup .dropdown-toggle:after {
    display: none
}

.dropzone {
    min-height: 150px;
    border: 2px dashed #4b5563;
    background: #fff
}

.dropzone:hover {
    background-color: #e5e7eb
}

.dropzone .dz-message .dz-button {
    font-size: 1.25rem;
    font-weight: 500
}

.icon {
    height: 2rem
}

.icon.icon-xxs {
    height: 1rem
}

.icon.icon-xs {
    height: 1.25rem
}

.icon.icon-sm {
    height: 1.5rem
}

.icon.icon-lg {
    height: 3.5rem
}

.icon.icon-xl {
    height: 4.5rem
}

.icon.icon-xxl {
    height: 6rem
}

.icon.active-dot svg {
    height: .7rem
}

.icon-shape {
    width: 4rem;
    height: 4rem;
    display: inline-flex;
    align-items: center;
    justify-content: center
}

.icon-shape svg {
    height: 2rem
}

.icon-shape.icon-xxs {
    width: 1.5rem;
    height: 1.5rem
}

.icon-shape.icon-xxs svg {
    height: 1rem
}

.icon-shape.icon-xs {
    width: 2.5rem;
    height: 2.5rem
}

.icon-shape.icon-xs svg {
    height: 1.25rem
}

.icon-shape.icon-sm {
    width: 3.275rem;
    height: 3.275rem
}

.icon-shape.icon-sm svg {
    height: 1.5rem
}

.icon-shape.icon-lg {
    width: 5rem;
    height: 5rem
}

.icon-shape.icon-lg svg {
    height: 3.5rem
}

.icon-shape.icon-xl {
    width: 6rem;
    height: 6rem
}

.icon-shape.icon-xl svg {
    height: 4.5rem
}

.icon-shape.icon-xxl {
    width: 7.5rem;
    height: 7.5rem
}

.icon-shape.icon-xxl svg {
    height: 6rem
}

.rating-star:hover {
    cursor: pointer;
    color: #fba918
}

.toggle-icon {
    height: 1.875rem
}

.w--20 {
    width: 20px
}

.calendar {
    width: 3.125rem;
    line-height: 1;
    flex-direction: column;
    text-align: center;
    border-radius: .5rem
}

.calendar .calendar-month {
    background-color: #e11d48;
    color: #fff;
    border-radius: .5rem .5rem 0 0;
    padding: .275rem;
    font-weight: 500
}

.calendar .calendar-day {
    font-size: 1.5rem;
    padding: .25rem;
    background-color: #f2f4f6;
    border-top: 0;
    border-radius: 0 0 .5rem .5rem;
    color: #1f2937;
    font-weight: 500
}

.dot {
    width: 12px;
    height: 12px
}

.bell-dot {
    display: inline-block;
    position: absolute;
    top: -11px;
    right: 6px;
    height: 10px;
    width: 10px;
    border: 2px solid #f2f4f6
}

.notification-bell.unread::before {
    position: absolute;
    content: "";
    background-color: #e11d48;
    right: 12px;
    top: 7px;
    height: .75rem;
    width: .75rem;
    border-radius: 50%;
    border: 2px solid #f2f4f6
}

.bootstrap-big-icon {
    position: absolute;
    opacity: .05;
    transform: rotate(17deg)
}

@media (min-width: 992px) {
    .bootstrap-big-icon {
        right: -20%;
        bottom: 6%
    }
}

@media (min-width: 1200px) {
    .bootstrap-big-icon {
        right: -10%;
        bottom: 6%
    }
}

.github-big-icon {
    position: absolute;
    right: 80px
}

.github-big-icon svg {
    color: #9ca3af;
    height: 800px;
    opacity: .2
}

.icon-shape-primary {
    color: #1f2937;
    background-color: rgba(31, 41, 55, .3)
}

.icon-shape-secondary {
    color: #f0bc74;
    background-color: rgba(240, 188, 116, .3)
}

.icon-shape-tertiary {
    color: #31316a;
    background-color: rgba(49, 49, 106, .3)
}

.icon-shape-success {
    color: #10b981;
    background-color: rgba(16, 185, 129, .3)
}

.icon-shape-info {
    color: #2361ce;
    background-color: rgba(35, 97, 206, .3)
}

.icon-shape-warning {
    color: #fba918;
    background-color: rgba(251, 169, 24, .3)
}

.icon-shape-danger {
    color: #e11d48;
    background-color: rgba(225, 29, 72, .3)
}

.icon-shape-white {
    color: #fff;
    background-color: rgba(255, 255, 255, .3)
}

.icon-shape-indigo {
    color: #4f46e5;
    background-color: rgba(79, 70, 229, .3)
}

.icon-shape-purple {
    color: #7c3aed;
    background-color: rgba(124, 58, 237, .3)
}

.icon-shape-yellow-100 {
    color: #ffeed6;
    background-color: rgba(255, 238, 214, .3)
}

.icon-shape-yellow-200 {
    color: #f5dbb8;
    background-color: rgba(245, 219, 184, .3)
}

.icon-shape-gray-50 {
    color: #f9fafb;
    background-color: rgba(249, 250, 251, .3)
}

.icon-shape-gray-100 {
    color: #f2f4f6;
    background-color: rgba(242, 244, 246, .3)
}

.icon-shape-gray-200 {
    color: #e5e7eb;
    background-color: rgba(229, 231, 235, .3)
}

.icon-shape-gray-300 {
    color: #d1d5db;
    background-color: rgba(209, 213, 219, .3)
}

.icon-shape-gray-400 {
    color: #9ca3af;
    background-color: rgba(156, 163, 175, .3)
}

.icon-shape-gray-500 {
    color: #6b7280;
    background-color: rgba(107, 114, 128, .3)
}

.icon-shape-gray-600 {
    color: #4b5563;
    background-color: rgba(75, 85, 99, .3)
}

.icon-shape-gray-700 {
    color: #374151;
    background-color: rgba(55, 65, 81, .3)
}

.icon-shape-gray-800 {
    color: #1f2937;
    background-color: rgba(31, 41, 55, .3)
}

.icon-shape-gray-900 {
    color: #111827;
    background-color: rgba(17, 24, 39, .3)
}

.image-xl {
    height: 20rem
}

.image-xl img {
    height: 20rem
}

.image-lg {
    height: 12rem
}

.image-lg img {
    height: 12rem
}

.image-md {
    height: 5.5rem
}

.image-md img {
    height: 5.5rem
}

.image-sm {
    height: 3rem
}

.image-sm img {
    height: 3rem
}

.image-xs {
    height: 1.5rem
}

.image-xs img {
    height: 1.5rem
}

.image-small {
    height: 1rem
}

.image-small img {
    height: 1rem
}

.full-image {
    height: 100%
}

.language-flag {
    width: auto;
    height: 1rem;
    margin-right: .4rem;
    position: relative;
    top: -2px
}

.home-pattern {
    fill: #f2f4f6
}

.form-bg-image {
    background-repeat: no-repeat !important;
    background-position: top center !important
}

.list-group-space .list-group-item {
    margin-bottom: 1.5rem;
    border-radius: .5rem
}

.list-group-item {
    border: 0
}

.list-group-item.active {
    z-index: 2;
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.list-group-item i {
    width: 1rem
}

.list-group-img {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    vertical-align: top;
    margin: -.1rem 1.2rem 0 -.2rem
}

.list-group-content {
    flex: 1 1;
    min-width: 0
}

.list-group-content > p {
    color: #6b7280;
    line-height: 1.5;
    margin: .2rem 0 0
}

.list-group-heading {
    font-size: 1rem;
    color: #1f2937
}

.list-group-heading > .small,
.list-group-heading > small {
    float: right;
    color: #6b7280;
    font-weight: 500
}

.list-group.simple-list .list-group-item {
    background: 0 0;
    border: none;
    padding: .375rem .125rem
}

.list-group.simple-list .list-group-item i {
    vertical-align: middle;
    width: 35px;
    display: inline-block
}

.list-group.kanban-list {
    position: relative;
    padding-bottom: 45px
}

.list-group.kanban-list .card {
    margin-bottom: .75rem;
    cursor: pointer
}

.list-group.kanban-list .new-card {
    position: absolute;
    bottom: 0
}

.news-list .row > [class*=col] {
    padding: 0 .25rem
}

.news-list > li:not(:last-child) {
    margin-bottom: .75rem
}

.news-list img {
    min-height: 100%;
    object-fit: cover
}

.map {
    height: 400px;
    width: 100%;
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%)
}

.mapouter {
    position: relative;
    text-align: right;
    height: 500px;
    width: 100%
}

.gmap_canvas {
    overflow: hidden;
    background: 0 0 !important;
    height: 500px;
    width: 100%;
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%)
}

.gmap_canvas #gmap_canvas {
    width: 100%;
    height: 500px
}

#mapbox {
    width: 100%;
    height: 600px;
    z-index: 1
}

.leaflet-popup-content-wrapper {
    padding: 8px 8px 8px 0
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)
}

.leaflet-container a.leaflet-popup-close-button {
    padding: 7px 15px 0 0
}

.logo-map {
    position: absolute;
    right: 0;
    z-index: 3
}

.search-map {
    position: absolute;
    z-index: 3;
    bottom: 30px;
    width: 100%
}

.svgMap-map-wrapper {
    position: relative;
    width: 100%;
    padding-top: 50%;
    overflow: hidden;
    background: #fff;
    color: #1f2937
}

.svgMap-map-wrapper * {
    box-sizing: border-box;
    outline: 0
}

.svgMap-map-wrapper .svgMap-map-image {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0
}

.svgMap-map-wrapper .svgMap-map-controls-wrapper {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 1;
    display: flex;
    overflow: hidden;
    border-radius: .5rem;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)
}

.svgMap-map-wrapper .svgMap-map-controls-move,
.svgMap-map-wrapper .svgMap-map-controls-zoom {
    display: flex;
    margin-right: 5px;
    overflow: hidden;
    background: #fff
}

.svgMap-map-wrapper .svgMap-map-controls-move:last-child,
.svgMap-map-wrapper .svgMap-map-controls-zoom:last-child {
    margin-right: 0
}

.svgMap-map-wrapper .svgMap-control-button {
    cursor: pointer;
    width: 30px;
    height: 30px;
    position: relative
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #e5e7eb;
    transition: background-color .2s
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {
    width: 11px;
    height: 3px
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:before {
    background: #111
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:before {
    background: #ccc
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button:after {
    width: 3px;
    height: 11px
}

.svgMap-map-wrapper .svgMap-country {
    cursor: pointer;
    stroke: #fff;
    stroke-width: 1;
    stroke-linejoin: round;
    vector-effect: non-scaling-stroke;
    transition: fill .2s, stroke .2s
}

.svgMap-map-wrapper .svgMap-country.svgMap-active,
.svgMap-map-wrapper .svgMap-country:hover {
    stroke: #e5e7eb
}

.svgMap-map-wrapper .svgMap-country.svgMap-active {
    stroke-width: 1.5
}

.svgMap-tooltip {
    box-shadow: 0 0 3px rgba(0, 0, 0, .2);
    position: absolute;
    z-index: 2;
    border-radius: 2px;
    background: #fff;
    transform: translate(-50%, -100%);
    border-bottom: 1px solid #e5e7eb;
    display: none;
    pointer-events: none;
    min-width: 60px
}

.svgMap-tooltip.svgMap-tooltip-flipped {
    transform: translate(-50%, 0);
    border-bottom: 0;
    border-top: 1px solid #e5e7eb
}

.svgMap-tooltip.svgMap-active {
    display: block
}

.svgMap-tooltip .svgMap-tooltip-content-container {
    position: relative;
    padding: 10px 20px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container {
    text-align: center;
    margin: 2px 0 5px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container.svgMap-tooltip-flag-container-emoji {
    font-size: 50px;
    line-height: 0;
    padding: 25px 0 15px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container .svgMap-tooltip-flag {
    display: block;
    margin: auto;
    width: auto;
    height: 32px;
    padding: 2px;
    background: rgba(0, 0, 0, .15);
    border-radius: 2px
}

.svgMap-tooltip .svgMap-tooltip-title {
    white-space: nowrap;
    font-size: 18px;
    line-height: 28px;
    padding: 0 0 8px;
    text-align: center
}

.svgMap-tooltip .svgMap-tooltip-content {
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    color: #777;
    margin: -5px 0 0
}

.svgMap-tooltip .svgMap-tooltip-content table {
    padding: 0;
    border-spacing: 0;
    margin: auto
}

.svgMap-tooltip .svgMap-tooltip-content table td {
    padding: 2px 0;
    text-align: left
}

.svgMap-tooltip .svgMap-tooltip-content table td span {
    color: #111
}

.svgMap-tooltip .svgMap-tooltip-content table td:first-child {
    padding-right: 10px;
    text-align: right
}

.svgMap-tooltip .svgMap-tooltip-content table td sup {
    vertical-align: baseline;
    position: relative;
    top: -5px
}

.svgMap-tooltip .svgMap-tooltip-content .svgMap-tooltip-no-data {
    padding: 2px 0;
    color: #777;
    font-style: italic
}

.svgMap-tooltip .svgMap-tooltip-pointer {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    height: 10px;
    width: 30px
}

.svgMap-tooltip .svgMap-tooltip-pointer:after {
    content: '';
    width: 20px;
    height: 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg)
}

.svgMap-tooltip.svgMap-tooltip-flipped .svgMap-tooltip-pointer {
    bottom: auto;
    top: -10px;
    transform: translateX(-50%) scaleY(-1)
}

.modal.static-example {
    position: relative;
    display: block
}

.modal-content {
    border: 0;
    border-radius: .5rem
}

.modal-fluid .modal-dialog {
    margin-top: 0;
    margin-bottom: 0
}

.modal-fluid .modal-content {
    border-radius: 0
}

.modal-primary .modal-title {
    color: color-yiq(#1f2937)
}

.modal-primary .modal-footer,
.modal-primary .modal-header {
    border-color: rgba(31, 41, 55, .075)
}

.modal-primary .modal-content {
    background-color: #1f2937;
    color: color-yiq(#1f2937)
}

.modal-primary .modal-content .heading {
    color: color-yiq(#1f2937)
}

.modal-primary .close > span:not(.sr-only) {
    color: #fff
}

.modal-secondary .modal-title {
    color: color-yiq(#f0bc74)
}

.modal-secondary .modal-footer,
.modal-secondary .modal-header {
    border-color: rgba(240, 188, 116, .075)
}

.modal-secondary .modal-content {
    background-color: #f0bc74;
    color: color-yiq(#f0bc74)
}

.modal-secondary .modal-content .heading {
    color: color-yiq(#f0bc74)
}

.modal-secondary .close > span:not(.sr-only) {
    color: #fff
}

.modal-tertiary .modal-title {
    color: color-yiq(#31316a)
}

.modal-tertiary .modal-footer,
.modal-tertiary .modal-header {
    border-color: rgba(49, 49, 106, .075)
}

.modal-tertiary .modal-content {
    background-color: #31316a;
    color: color-yiq(#31316a)
}

.modal-tertiary .modal-content .heading {
    color: color-yiq(#31316a)
}

.modal-tertiary .close > span:not(.sr-only) {
    color: #fff
}

.modal-success .modal-title {
    color: color-yiq(#10b981)
}

.modal-success .modal-footer,
.modal-success .modal-header {
    border-color: rgba(16, 185, 129, .075)
}

.modal-success .modal-content {
    background-color: #10b981;
    color: color-yiq(#10b981)
}

.modal-success .modal-content .heading {
    color: color-yiq(#10b981)
}

.modal-success .close > span:not(.sr-only) {
    color: #fff
}

.modal-info .modal-title {
    color: color-yiq(#2361ce)
}

.modal-info .modal-footer,
.modal-info .modal-header {
    border-color: rgba(35, 97, 206, .075)
}

.modal-info .modal-content {
    background-color: #2361ce;
    color: color-yiq(#2361ce)
}

.modal-info .modal-content .heading {
    color: color-yiq(#2361ce)
}

.modal-info .close > span:not(.sr-only) {
    color: #fff
}

.modal-warning .modal-title {
    color: color-yiq(#fba918)
}

.modal-warning .modal-footer,
.modal-warning .modal-header {
    border-color: rgba(251, 169, 24, .075)
}

.modal-warning .modal-content {
    background-color: #fba918;
    color: color-yiq(#fba918)
}

.modal-warning .modal-content .heading {
    color: color-yiq(#fba918)
}

.modal-warning .close > span:not(.sr-only) {
    color: #fff
}

.modal-danger .modal-title {
    color: color-yiq(#e11d48)
}

.modal-danger .modal-footer,
.modal-danger .modal-header {
    border-color: rgba(225, 29, 72, .075)
}

.modal-danger .modal-content {
    background-color: #e11d48;
    color: color-yiq(#e11d48)
}

.modal-danger .modal-content .heading {
    color: color-yiq(#e11d48)
}

.modal-danger .close > span:not(.sr-only) {
    color: #fff
}

.modal-white .modal-title {
    color: color-yiq(#fff)
}

.modal-white .modal-footer,
.modal-white .modal-header {
    border-color: rgba(255, 255, 255, .075)
}

.modal-white .modal-content {
    background-color: #fff;
    color: color-yiq(#fff)
}

.modal-white .modal-content .heading {
    color: color-yiq(#fff)
}

.modal-white .close > span:not(.sr-only) {
    color: #fff
}

.modal-indigo .modal-title {
    color: color-yiq(#4f46e5)
}

.modal-indigo .modal-footer,
.modal-indigo .modal-header {
    border-color: rgba(79, 70, 229, .075)
}

.modal-indigo .modal-content {
    background-color: #4f46e5;
    color: color-yiq(#4f46e5)
}

.modal-indigo .modal-content .heading {
    color: color-yiq(#4f46e5)
}

.modal-indigo .close > span:not(.sr-only) {
    color: #fff
}

.modal-purple .modal-title {
    color: color-yiq(#7c3aed)
}

.modal-purple .modal-footer,
.modal-purple .modal-header {
    border-color: rgba(124, 58, 237, .075)
}

.modal-purple .modal-content {
    background-color: #7c3aed;
    color: color-yiq(#7c3aed)
}

.modal-purple .modal-content .heading {
    color: color-yiq(#7c3aed)
}

.modal-purple .close > span:not(.sr-only) {
    color: #fff
}

.modal-yellow-100 .modal-title {
    color: color-yiq(#ffeed6)
}

.modal-yellow-100 .modal-footer,
.modal-yellow-100 .modal-header {
    border-color: rgba(255, 238, 214, .075)
}

.modal-yellow-100 .modal-content {
    background-color: #ffeed6;
    color: color-yiq(#ffeed6)
}

.modal-yellow-100 .modal-content .heading {
    color: color-yiq(#ffeed6)
}

.modal-yellow-100 .close > span:not(.sr-only) {
    color: #fff
}

.modal-yellow-200 .modal-title {
    color: color-yiq(#f5dbb8)
}

.modal-yellow-200 .modal-footer,
.modal-yellow-200 .modal-header {
    border-color: rgba(245, 219, 184, .075)
}

.modal-yellow-200 .modal-content {
    background-color: #f5dbb8;
    color: color-yiq(#f5dbb8)
}

.modal-yellow-200 .modal-content .heading {
    color: color-yiq(#f5dbb8)
}

.modal-yellow-200 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-50 .modal-title {
    color: color-yiq(#f9fafb)
}

.modal-gray-50 .modal-footer,
.modal-gray-50 .modal-header {
    border-color: rgba(249, 250, 251, .075)
}

.modal-gray-50 .modal-content {
    background-color: #f9fafb;
    color: color-yiq(#f9fafb)
}

.modal-gray-50 .modal-content .heading {
    color: color-yiq(#f9fafb)
}

.modal-gray-50 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-100 .modal-title {
    color: color-yiq(#f2f4f6)
}

.modal-gray-100 .modal-footer,
.modal-gray-100 .modal-header {
    border-color: rgba(242, 244, 246, .075)
}

.modal-gray-100 .modal-content {
    background-color: #f2f4f6;
    color: color-yiq(#f2f4f6)
}

.modal-gray-100 .modal-content .heading {
    color: color-yiq(#f2f4f6)
}

.modal-gray-100 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-200 .modal-title {
    color: color-yiq(#e5e7eb)
}

.modal-gray-200 .modal-footer,
.modal-gray-200 .modal-header {
    border-color: rgba(229, 231, 235, .075)
}

.modal-gray-200 .modal-content {
    background-color: #e5e7eb;
    color: color-yiq(#e5e7eb)
}

.modal-gray-200 .modal-content .heading {
    color: color-yiq(#e5e7eb)
}

.modal-gray-200 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-300 .modal-title {
    color: color-yiq(#d1d5db)
}

.modal-gray-300 .modal-footer,
.modal-gray-300 .modal-header {
    border-color: rgba(209, 213, 219, .075)
}

.modal-gray-300 .modal-content {
    background-color: #d1d5db;
    color: color-yiq(#d1d5db)
}

.modal-gray-300 .modal-content .heading {
    color: color-yiq(#d1d5db)
}

.modal-gray-300 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-400 .modal-title {
    color: color-yiq(#9ca3af)
}

.modal-gray-400 .modal-footer,
.modal-gray-400 .modal-header {
    border-color: rgba(156, 163, 175, .075)
}

.modal-gray-400 .modal-content {
    background-color: #9ca3af;
    color: color-yiq(#9ca3af)
}

.modal-gray-400 .modal-content .heading {
    color: color-yiq(#9ca3af)
}

.modal-gray-400 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-500 .modal-title {
    color: color-yiq(#6b7280)
}

.modal-gray-500 .modal-footer,
.modal-gray-500 .modal-header {
    border-color: rgba(107, 114, 128, .075)
}

.modal-gray-500 .modal-content {
    background-color: #6b7280;
    color: color-yiq(#6b7280)
}

.modal-gray-500 .modal-content .heading {
    color: color-yiq(#6b7280)
}

.modal-gray-500 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-600 .modal-title {
    color: color-yiq(#4b5563)
}

.modal-gray-600 .modal-footer,
.modal-gray-600 .modal-header {
    border-color: rgba(75, 85, 99, .075)
}

.modal-gray-600 .modal-content {
    background-color: #4b5563;
    color: color-yiq(#4b5563)
}

.modal-gray-600 .modal-content .heading {
    color: color-yiq(#4b5563)
}

.modal-gray-600 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-700 .modal-title {
    color: color-yiq(#374151)
}

.modal-gray-700 .modal-footer,
.modal-gray-700 .modal-header {
    border-color: rgba(55, 65, 81, .075)
}

.modal-gray-700 .modal-content {
    background-color: #374151;
    color: color-yiq(#374151)
}

.modal-gray-700 .modal-content .heading {
    color: color-yiq(#374151)
}

.modal-gray-700 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-800 .modal-title {
    color: color-yiq(#1f2937)
}

.modal-gray-800 .modal-footer,
.modal-gray-800 .modal-header {
    border-color: rgba(31, 41, 55, .075)
}

.modal-gray-800 .modal-content {
    background-color: #1f2937;
    color: color-yiq(#1f2937)
}

.modal-gray-800 .modal-content .heading {
    color: color-yiq(#1f2937)
}

.modal-gray-800 .close > span:not(.sr-only) {
    color: #fff
}

.modal-gray-900 .modal-title {
    color: color-yiq(#111827)
}

.modal-gray-900 .modal-footer,
.modal-gray-900 .modal-header {
    border-color: rgba(17, 24, 39, .075)
}

.modal-gray-900 .modal-content {
    background-color: #111827;
    color: color-yiq(#111827)
}

.modal-gray-900 .modal-content .heading {
    color: color-yiq(#111827)
}

.modal-gray-900 .close > span:not(.sr-only) {
    color: #fff
}

.nav-link {
    color: #1f2937
}

.nav-link.active,
.nav-link:hover {
    color: #1f2937
}

.nav-link.active img,
.nav-link:hover img {
    opacity: inherit;
    transition: all .2s ease
}

.nav-link span {
    position: relative
}

.nav-tabs .nav-item {
    margin-bottom: 0
}

.nav-tabs .nav-link {
    border: 0;
    padding: 1rem 1rem;
    background-color: #fff
}

.nav-tabs .nav-link.active {
    color: #fff;
    background-color: #1f2937
}

.nav-tabs.nav-dark .nav-link.active {
    color: #fff;
    background-color: #12358a
}

.nav-tabs.nav-light .nav-link.active {
    color: #111827;
    background-color: #9ca3af
}

.nav-tabs.nav-light .nav-link:hover {
    color: #111827
}

.nav-pills .nav-item:not(:last-child) {
    padding-right: 1rem
}

.nav-pills .nav-link {
    padding: .75rem .85rem;
    transition: all .2s ease;
    box-shadow: none;
    border: 1px solid #9ca3af
}

.nav-pills .nav-link.avatar-link {
    border: 0
}

.nav-pills .nav-link:hover {
    color: #1f2937
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: #1f2937;
    background-color: #f8f8f8;
    border-color: #1f2937
}

.nav-pills.rounded .nav-link {
    border-radius: 30px
}

.nav-pills.rounded.vertical-tab .nav-link {
    margin-bottom: .625rem;
    min-width: 100px
}

.nav-pills.rounded.vertical-tab .nav-item:not(:last-child) {
    padding-right: 0
}

.nav-pills.bordered-pill-md .nav-link {
    border: .125rem solid #e5e7eb;
    font-weight: 500
}

.nav-pills.vertical-tab .nav-link {
    margin-bottom: .625rem
}

.nav-pills.vertical-tab .nav-item:not(:last-child) {
    padding-right: 0
}

.nav-pills .nav-item {
    margin-bottom: 1rem
}

@media (max-width: 575.98px) {
    .nav-pills:not(.nav-pills-circle) .nav-item {
        padding-right: 0
    }
}

.nav-pill-circle .nav-link {
    display: flex;
    text-align: center;
    height: 80px;
    width: 80px;
    padding: 0;
    box-shadow: none;
    border-radius: 50%;
    align-items: center;
    justify-content: center
}

.nav-pill-circle .nav-link.avatar-link {
    box-shadow: none
}

.nav-pill-circle.vertical-tab .nav-link-icon i,
.nav-pill-circle.vertical-tab .nav-link-icon svg {
    font-size: 1.5rem
}

.nav-pill-circle.vertical-tab .nav-item:not(:last-child) {
    padding-right: 0
}

.nav-pill-circle .nav-link-icon i,
.nav-pill-circle .nav-link-icon svg {
    font-size: 1.25rem;
    margin: 0;
    display: block
}

.nav-pill-square .nav-link {
    text-align: center;
    min-width: 80px;
    box-shadow: none;
    display: flex;
    align-items: center;
    justify-content: center
}

.nav-pill-square.vertical-tab .nav-link {
    margin-bottom: .625rem;
    min-width: 100px
}

.nav-pill-square.vertical-tab .nav-item:not(:last-child) {
    padding-right: 0
}

.nav-pill-square .nav-link-icon i,
.nav-pill-square .nav-link-icon svg {
    font-size: 1.25rem;
    margin: 0;
    display: block;
    line-height: 50px
}

.nav-wrapper {
    padding: 1rem 0;
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem
}

.nav-wrapper + .card {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem
}

.tab-content > .tab-pane {
    display: none
}

.tab-content > .tab-pane pre {
    padding: 0;
    margin: 0
}

.tab-content > .active {
    display: block
}

@media (min-width: 992px) {
    .nav-pills .nav-item {
        margin-bottom: 0
    }
}

.circle-pagination .page-link,
.circle-pagination span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 50%
}

.dataTable-pagination-list {
    display: flex;
    padding-left: 0;
    list-style: none
}

.dataTable-pagination-list li > a {
    position: relative;
    display: block;
    color: #1f2937;
    background-color: #fff;
    border: .0625rem solid #9ca3af;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .dataTable-pagination-list li > a {
        transition: none
    }
}

.dataTable-pagination-list li > a:hover {
    z-index: 2;
    color: #000;
    background-color: #e5e7eb;
    border-color: #d1d5db
}

.dataTable-pagination-list li > a:focus {
    z-index: 3;
    color: #000;
    background-color: #e5e7eb;
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.dataTable-pagination-list li:not(:first-child) a {
    margin-left: -.0625rem
}

.dataTable-pagination-list li.active a {
    z-index: 3;
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.dataTable-pagination-list li.disabled a {
    color: #4b5563;
    pointer-events: none;
    background-color: #fff;
    border-color: #d1d5db
}

.popover {
    border: 0
}

.popover-header {
    font-weight: 500
}

.popover-primary {
    background-color: #1f2937
}

.popover-primary .popover-header {
    background-color: #1f2937;
    color: color-yiq(#1f2937)
}

.popover-primary .popover-body {
    color: color-yiq(#1f2937)
}

.popover-primary .popover-header {
    border-color: rgba(31, 41, 55, .2)
}

.popover-primary.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-primary.bs-popover-top .arrow::after {
    border-top-color: #1f2937
}

.popover-primary.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-primary.bs-popover-end .arrow::after {
    border-right-color: #1f2937
}

.popover-primary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-primary.bs-popover-bottom .arrow::after {
    border-bottom-color: #1f2937
}

.popover-primary.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-primary.bs-popover-start .arrow::after {
    border-left-color: #1f2937
}

.popover-secondary {
    background-color: #f0bc74
}

.popover-secondary .popover-header {
    background-color: #f0bc74;
    color: color-yiq(#f0bc74)
}

.popover-secondary .popover-body {
    color: color-yiq(#f0bc74)
}

.popover-secondary .popover-header {
    border-color: rgba(240, 188, 116, .2)
}

.popover-secondary.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-secondary.bs-popover-top .arrow::after {
    border-top-color: #f0bc74
}

.popover-secondary.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-secondary.bs-popover-end .arrow::after {
    border-right-color: #f0bc74
}

.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-secondary.bs-popover-bottom .arrow::after {
    border-bottom-color: #f0bc74
}

.popover-secondary.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-secondary.bs-popover-start .arrow::after {
    border-left-color: #f0bc74
}

.popover-tertiary {
    background-color: #31316a
}

.popover-tertiary .popover-header {
    background-color: #31316a;
    color: color-yiq(#31316a)
}

.popover-tertiary .popover-body {
    color: color-yiq(#31316a)
}

.popover-tertiary .popover-header {
    border-color: rgba(49, 49, 106, .2)
}

.popover-tertiary.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-tertiary.bs-popover-top .arrow::after {
    border-top-color: #31316a
}

.popover-tertiary.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-tertiary.bs-popover-end .arrow::after {
    border-right-color: #31316a
}

.popover-tertiary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-tertiary.bs-popover-bottom .arrow::after {
    border-bottom-color: #31316a
}

.popover-tertiary.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-tertiary.bs-popover-start .arrow::after {
    border-left-color: #31316a
}

.popover-success {
    background-color: #10b981
}

.popover-success .popover-header {
    background-color: #10b981;
    color: color-yiq(#10b981)
}

.popover-success .popover-body {
    color: color-yiq(#10b981)
}

.popover-success .popover-header {
    border-color: rgba(16, 185, 129, .2)
}

.popover-success.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-success.bs-popover-top .arrow::after {
    border-top-color: #10b981
}

.popover-success.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-success.bs-popover-end .arrow::after {
    border-right-color: #10b981
}

.popover-success.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-success.bs-popover-bottom .arrow::after {
    border-bottom-color: #10b981
}

.popover-success.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-success.bs-popover-start .arrow::after {
    border-left-color: #10b981
}

.popover-info {
    background-color: #2361ce
}

.popover-info .popover-header {
    background-color: #2361ce;
    color: color-yiq(#2361ce)
}

.popover-info .popover-body {
    color: color-yiq(#2361ce)
}

.popover-info .popover-header {
    border-color: rgba(35, 97, 206, .2)
}

.popover-info.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-info.bs-popover-top .arrow::after {
    border-top-color: #2361ce
}

.popover-info.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-info.bs-popover-end .arrow::after {
    border-right-color: #2361ce
}

.popover-info.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-info.bs-popover-bottom .arrow::after {
    border-bottom-color: #2361ce
}

.popover-info.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-info.bs-popover-start .arrow::after {
    border-left-color: #2361ce
}

.popover-warning {
    background-color: #fba918
}

.popover-warning .popover-header {
    background-color: #fba918;
    color: color-yiq(#fba918)
}

.popover-warning .popover-body {
    color: color-yiq(#fba918)
}

.popover-warning .popover-header {
    border-color: rgba(251, 169, 24, .2)
}

.popover-warning.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-warning.bs-popover-top .arrow::after {
    border-top-color: #fba918
}

.popover-warning.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-warning.bs-popover-end .arrow::after {
    border-right-color: #fba918
}

.popover-warning.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-warning.bs-popover-bottom .arrow::after {
    border-bottom-color: #fba918
}

.popover-warning.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-warning.bs-popover-start .arrow::after {
    border-left-color: #fba918
}

.popover-danger {
    background-color: #e11d48
}

.popover-danger .popover-header {
    background-color: #e11d48;
    color: color-yiq(#e11d48)
}

.popover-danger .popover-body {
    color: color-yiq(#e11d48)
}

.popover-danger .popover-header {
    border-color: rgba(225, 29, 72, .2)
}

.popover-danger.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-danger.bs-popover-top .arrow::after {
    border-top-color: #e11d48
}

.popover-danger.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-danger.bs-popover-end .arrow::after {
    border-right-color: #e11d48
}

.popover-danger.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-danger.bs-popover-bottom .arrow::after {
    border-bottom-color: #e11d48
}

.popover-danger.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-danger.bs-popover-start .arrow::after {
    border-left-color: #e11d48
}

.popover-white {
    background-color: #fff
}

.popover-white .popover-header {
    background-color: #fff;
    color: color-yiq(#fff)
}

.popover-white .popover-body {
    color: color-yiq(#fff)
}

.popover-white .popover-header {
    border-color: rgba(255, 255, 255, .2)
}

.popover-white.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-white.bs-popover-top .arrow::after {
    border-top-color: #fff
}

.popover-white.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-white.bs-popover-end .arrow::after {
    border-right-color: #fff
}

.popover-white.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-white.bs-popover-bottom .arrow::after {
    border-bottom-color: #fff
}

.popover-white.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-white.bs-popover-start .arrow::after {
    border-left-color: #fff
}

.popover-indigo {
    background-color: #4f46e5
}

.popover-indigo .popover-header {
    background-color: #4f46e5;
    color: color-yiq(#4f46e5)
}

.popover-indigo .popover-body {
    color: color-yiq(#4f46e5)
}

.popover-indigo .popover-header {
    border-color: rgba(79, 70, 229, .2)
}

.popover-indigo.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-indigo.bs-popover-top .arrow::after {
    border-top-color: #4f46e5
}

.popover-indigo.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-indigo.bs-popover-end .arrow::after {
    border-right-color: #4f46e5
}

.popover-indigo.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-indigo.bs-popover-bottom .arrow::after {
    border-bottom-color: #4f46e5
}

.popover-indigo.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-indigo.bs-popover-start .arrow::after {
    border-left-color: #4f46e5
}

.popover-purple {
    background-color: #7c3aed
}

.popover-purple .popover-header {
    background-color: #7c3aed;
    color: color-yiq(#7c3aed)
}

.popover-purple .popover-body {
    color: color-yiq(#7c3aed)
}

.popover-purple .popover-header {
    border-color: rgba(124, 58, 237, .2)
}

.popover-purple.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-purple.bs-popover-top .arrow::after {
    border-top-color: #7c3aed
}

.popover-purple.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-purple.bs-popover-end .arrow::after {
    border-right-color: #7c3aed
}

.popover-purple.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-purple.bs-popover-bottom .arrow::after {
    border-bottom-color: #7c3aed
}

.popover-purple.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-purple.bs-popover-start .arrow::after {
    border-left-color: #7c3aed
}

.popover-yellow-100 {
    background-color: #ffeed6
}

.popover-yellow-100 .popover-header {
    background-color: #ffeed6;
    color: color-yiq(#ffeed6)
}

.popover-yellow-100 .popover-body {
    color: color-yiq(#ffeed6)
}

.popover-yellow-100 .popover-header {
    border-color: rgba(255, 238, 214, .2)
}

.popover-yellow-100.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-yellow-100.bs-popover-top .arrow::after {
    border-top-color: #ffeed6
}

.popover-yellow-100.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-yellow-100.bs-popover-end .arrow::after {
    border-right-color: #ffeed6
}

.popover-yellow-100.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-yellow-100.bs-popover-bottom .arrow::after {
    border-bottom-color: #ffeed6
}

.popover-yellow-100.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-yellow-100.bs-popover-start .arrow::after {
    border-left-color: #ffeed6
}

.popover-yellow-200 {
    background-color: #f5dbb8
}

.popover-yellow-200 .popover-header {
    background-color: #f5dbb8;
    color: color-yiq(#f5dbb8)
}

.popover-yellow-200 .popover-body {
    color: color-yiq(#f5dbb8)
}

.popover-yellow-200 .popover-header {
    border-color: rgba(245, 219, 184, .2)
}

.popover-yellow-200.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-yellow-200.bs-popover-top .arrow::after {
    border-top-color: #f5dbb8
}

.popover-yellow-200.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-yellow-200.bs-popover-end .arrow::after {
    border-right-color: #f5dbb8
}

.popover-yellow-200.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-yellow-200.bs-popover-bottom .arrow::after {
    border-bottom-color: #f5dbb8
}

.popover-yellow-200.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-yellow-200.bs-popover-start .arrow::after {
    border-left-color: #f5dbb8
}

.popover-gray-50 {
    background-color: #f9fafb
}

.popover-gray-50 .popover-header {
    background-color: #f9fafb;
    color: color-yiq(#f9fafb)
}

.popover-gray-50 .popover-body {
    color: color-yiq(#f9fafb)
}

.popover-gray-50 .popover-header {
    border-color: rgba(249, 250, 251, .2)
}

.popover-gray-50.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-50.bs-popover-top .arrow::after {
    border-top-color: #f9fafb
}

.popover-gray-50.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-50.bs-popover-end .arrow::after {
    border-right-color: #f9fafb
}

.popover-gray-50.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-50.bs-popover-bottom .arrow::after {
    border-bottom-color: #f9fafb
}

.popover-gray-50.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-50.bs-popover-start .arrow::after {
    border-left-color: #f9fafb
}

.popover-gray-100 {
    background-color: #f2f4f6
}

.popover-gray-100 .popover-header {
    background-color: #f2f4f6;
    color: color-yiq(#f2f4f6)
}

.popover-gray-100 .popover-body {
    color: color-yiq(#f2f4f6)
}

.popover-gray-100 .popover-header {
    border-color: rgba(242, 244, 246, .2)
}

.popover-gray-100.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-100.bs-popover-top .arrow::after {
    border-top-color: #f2f4f6
}

.popover-gray-100.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-100.bs-popover-end .arrow::after {
    border-right-color: #f2f4f6
}

.popover-gray-100.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-100.bs-popover-bottom .arrow::after {
    border-bottom-color: #f2f4f6
}

.popover-gray-100.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-100.bs-popover-start .arrow::after {
    border-left-color: #f2f4f6
}

.popover-gray-200 {
    background-color: #e5e7eb
}

.popover-gray-200 .popover-header {
    background-color: #e5e7eb;
    color: color-yiq(#e5e7eb)
}

.popover-gray-200 .popover-body {
    color: color-yiq(#e5e7eb)
}

.popover-gray-200 .popover-header {
    border-color: rgba(229, 231, 235, .2)
}

.popover-gray-200.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-200.bs-popover-top .arrow::after {
    border-top-color: #e5e7eb
}

.popover-gray-200.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-200.bs-popover-end .arrow::after {
    border-right-color: #e5e7eb
}

.popover-gray-200.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-200.bs-popover-bottom .arrow::after {
    border-bottom-color: #e5e7eb
}

.popover-gray-200.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-200.bs-popover-start .arrow::after {
    border-left-color: #e5e7eb
}

.popover-gray-300 {
    background-color: #d1d5db
}

.popover-gray-300 .popover-header {
    background-color: #d1d5db;
    color: color-yiq(#d1d5db)
}

.popover-gray-300 .popover-body {
    color: color-yiq(#d1d5db)
}

.popover-gray-300 .popover-header {
    border-color: rgba(209, 213, 219, .2)
}

.popover-gray-300.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-300.bs-popover-top .arrow::after {
    border-top-color: #d1d5db
}

.popover-gray-300.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-300.bs-popover-end .arrow::after {
    border-right-color: #d1d5db
}

.popover-gray-300.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-300.bs-popover-bottom .arrow::after {
    border-bottom-color: #d1d5db
}

.popover-gray-300.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-300.bs-popover-start .arrow::after {
    border-left-color: #d1d5db
}

.popover-gray-400 {
    background-color: #9ca3af
}

.popover-gray-400 .popover-header {
    background-color: #9ca3af;
    color: color-yiq(#9ca3af)
}

.popover-gray-400 .popover-body {
    color: color-yiq(#9ca3af)
}

.popover-gray-400 .popover-header {
    border-color: rgba(156, 163, 175, .2)
}

.popover-gray-400.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-400.bs-popover-top .arrow::after {
    border-top-color: #9ca3af
}

.popover-gray-400.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-400.bs-popover-end .arrow::after {
    border-right-color: #9ca3af
}

.popover-gray-400.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-400.bs-popover-bottom .arrow::after {
    border-bottom-color: #9ca3af
}

.popover-gray-400.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-400.bs-popover-start .arrow::after {
    border-left-color: #9ca3af
}

.popover-gray-500 {
    background-color: #6b7280
}

.popover-gray-500 .popover-header {
    background-color: #6b7280;
    color: color-yiq(#6b7280)
}

.popover-gray-500 .popover-body {
    color: color-yiq(#6b7280)
}

.popover-gray-500 .popover-header {
    border-color: rgba(107, 114, 128, .2)
}

.popover-gray-500.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-500.bs-popover-top .arrow::after {
    border-top-color: #6b7280
}

.popover-gray-500.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-500.bs-popover-end .arrow::after {
    border-right-color: #6b7280
}

.popover-gray-500.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-500.bs-popover-bottom .arrow::after {
    border-bottom-color: #6b7280
}

.popover-gray-500.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-500.bs-popover-start .arrow::after {
    border-left-color: #6b7280
}

.popover-gray-600 {
    background-color: #4b5563
}

.popover-gray-600 .popover-header {
    background-color: #4b5563;
    color: color-yiq(#4b5563)
}

.popover-gray-600 .popover-body {
    color: color-yiq(#4b5563)
}

.popover-gray-600 .popover-header {
    border-color: rgba(75, 85, 99, .2)
}

.popover-gray-600.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-600.bs-popover-top .arrow::after {
    border-top-color: #4b5563
}

.popover-gray-600.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-600.bs-popover-end .arrow::after {
    border-right-color: #4b5563
}

.popover-gray-600.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-600.bs-popover-bottom .arrow::after {
    border-bottom-color: #4b5563
}

.popover-gray-600.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-600.bs-popover-start .arrow::after {
    border-left-color: #4b5563
}

.popover-gray-700 {
    background-color: #374151
}

.popover-gray-700 .popover-header {
    background-color: #374151;
    color: color-yiq(#374151)
}

.popover-gray-700 .popover-body {
    color: color-yiq(#374151)
}

.popover-gray-700 .popover-header {
    border-color: rgba(55, 65, 81, .2)
}

.popover-gray-700.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-700.bs-popover-top .arrow::after {
    border-top-color: #374151
}

.popover-gray-700.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-700.bs-popover-end .arrow::after {
    border-right-color: #374151
}

.popover-gray-700.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-700.bs-popover-bottom .arrow::after {
    border-bottom-color: #374151
}

.popover-gray-700.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-700.bs-popover-start .arrow::after {
    border-left-color: #374151
}

.popover-gray-800 {
    background-color: #1f2937
}

.popover-gray-800 .popover-header {
    background-color: #1f2937;
    color: color-yiq(#1f2937)
}

.popover-gray-800 .popover-body {
    color: color-yiq(#1f2937)
}

.popover-gray-800 .popover-header {
    border-color: rgba(31, 41, 55, .2)
}

.popover-gray-800.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-800.bs-popover-top .arrow::after {
    border-top-color: #1f2937
}

.popover-gray-800.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-800.bs-popover-end .arrow::after {
    border-right-color: #1f2937
}

.popover-gray-800.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-800.bs-popover-bottom .arrow::after {
    border-bottom-color: #1f2937
}

.popover-gray-800.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-800.bs-popover-start .arrow::after {
    border-left-color: #1f2937
}

.popover-gray-900 {
    background-color: #111827
}

.popover-gray-900 .popover-header {
    background-color: #111827;
    color: color-yiq(#111827)
}

.popover-gray-900 .popover-body {
    color: color-yiq(#111827)
}

.popover-gray-900 .popover-header {
    border-color: rgba(17, 24, 39, .2)
}

.popover-gray-900.bs-popover-auto[data-popper-placement^=top] .arrow::after,
.popover-gray-900.bs-popover-top .arrow::after {
    border-top-color: #111827
}

.popover-gray-900.bs-popover-auto[data-popper-placement^=right] .arrow::after,
.popover-gray-900.bs-popover-end .arrow::after {
    border-right-color: #111827
}

.popover-gray-900.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,
.popover-gray-900.bs-popover-bottom .arrow::after {
    border-bottom-color: #111827
}

.popover-gray-900.bs-popover-auto[data-popper-placement^=left] .arrow::after,
.popover-gray-900.bs-popover-start .arrow::after {
    border-left-color: #111827
}

.progress-wrapper {
    position: relative
}

.progress-bar {
    box-shadow: none;
    border-radius: 0;
    height: auto
}

.progress {
    height: 6px;
    margin-bottom: 1rem;
    overflow: hidden;
    background-color: #e5e7eb;
    font-size: .75rem;
    font-weight: 500;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1)
}

.progress-xl {
    height: .8rem
}

.progress-lg {
    height: .6rem
}

.progress-sm {
    height: .2rem
}

.progress-info {
    display: flex;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    justify-content: space-between;
    -ms-flex-pack: space-between;
    margin-bottom: .5rem
}

.progress-info .progress-label span {
    display: inline-block;
    color: #1f2937;
    font-size: .875rem;
    font-weight: 500
}

.progress-info .progress-percentage {
    text-align: right
}

.progress-info .progress-percentage span {
    display: inline-block;
    color: #6b7280;
    font-size: .75rem;
    font-weight: 500
}

.info-xl .progress-label span,
.info-xl .progress-percentage span {
    font-size: .875rem
}

.info-xl .progress-percentage {
    text-align: right
}

.progress-tooltip {
    background: #1f2937;
    color: #fff;
    font-weight: 500;
    padding: .25rem .375rem;
    line-height: 1;
    font-size: .75rem;
    position: relative;
    border-radius: .35rem
}

.progress-tooltip:after {
    content: " ";
    position: absolute;
    top: 100%;
    left: 10px;
    border: solid transparent;
    height: 0;
    width: 0;
    pointer-events: none;
    border-top-color: #111827;
    border-width: 6px
}

@keyframes animate-positive {
    0% {
        width: 0%
    }
}

.progress-info .bg-primary::after {
    border-top-color: #1f2937
}

.progress-info .bg-secondary::after {
    border-top-color: #f0bc74
}

.progress-info .bg-tertiary::after {
    border-top-color: #31316a
}

.progress-info .bg-success::after {
    border-top-color: #10b981
}

.progress-info .bg-info::after {
    border-top-color: #2361ce
}

.progress-info .bg-warning::after {
    border-top-color: #fba918
}

.progress-info .bg-danger::after {
    border-top-color: #e11d48
}

.progress-info .bg-white::after {
    border-top-color: #fff
}

.progress-info .bg-indigo::after {
    border-top-color: #4f46e5
}

.progress-info .bg-purple::after {
    border-top-color: #7c3aed
}

.progress-info .bg-yellow-100::after {
    border-top-color: #ffeed6
}

.progress-info .bg-yellow-200::after {
    border-top-color: #f5dbb8
}

.progress-info .bg-gray-50::after {
    border-top-color: #f9fafb
}

.progress-info .bg-gray-100::after {
    border-top-color: #f2f4f6
}

.progress-info .bg-gray-200::after {
    border-top-color: #e5e7eb
}

.progress-info .bg-gray-300::after {
    border-top-color: #d1d5db
}

.progress-info .bg-gray-400::after {
    border-top-color: #9ca3af
}

.progress-info .bg-gray-500::after {
    border-top-color: #6b7280
}

.progress-info .bg-gray-600::after {
    border-top-color: #4b5563
}

.progress-info .bg-gray-700::after {
    border-top-color: #374151
}

.progress-info .bg-gray-800::after {
    border-top-color: #1f2937
}

.progress-info .bg-gray-900::after {
    border-top-color: #111827
}

.choices__inner {
    background-color: #fff;
    border-color: #d1d5db;
    border-radius: .5rem
}

.choices__list.choices__list--dropdown {
    border-color: #d1d5db;
    margin-top: .5rem;
    border-radius: .5rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
}

.choices .is-open .choices__inner,
.choices.is-focused .choices__inner {
    background-color: #fff;
    border-color: #d1d5db;
    border-radius: .5rem
}

.choices__list--multiple .choices__item.is-highlighted {
    background-color: #e5e7eb;
    border-color: #d1d5db
}

.is-disabled .choices__list--multiple .choices__item {
    background-color: #9ca3af;
    border-color: #d1d5db
}

.choices__list--dropdown .choices__item--selectable.is-highlighted {
    background-color: #e5e7eb
}

.choices__input {
    background-color: transparent
}

.choices__list--multiple .choices__item {
    background-color: #1f2937;
    border: 0;
    border-radius: .5rem
}

.avatar-sm {
    width: 1.5rem;
    height: 1.5rem
}

.avatar-md {
    width: 3rem;
    height: 3rem
}

.avatar-lg {
    width: 4.5rem;
    height: 4.5rem
}

.step {
    position: relative;
    margin-bottom: 4rem;
    border-radius: 6px
}

.step .step-shape {
    display: inline-flex;
    width: 7rem;
    height: 7rem;
    text-align: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center
}

.step .step-shape i,
.step .step-shape svg {
    font-size: 2rem
}

.step .step-shape .step-number {
    position: absolute;
    font-weight: 500;
    top: -10px;
    width: 32px;
    height: 32px;
    border-width: .125rem;
    border-style: solid;
    line-height: 1.7
}

.step .step-shape.bordered {
    border-width: .125rem;
    border-style: solid
}

.step .step-shape.bordered .step-number {
    background-color: #fff;
    top: -12px
}

.step .step-shape.rounded-circle .step-number {
    margin-right: 1.275rem
}

.step .icon-lg {
    font-size: 4.5rem
}

.step .back-layer {
    display: flex;
    position: absolute;
    font-size: 12rem;
    z-index: 0;
    top: 0
}

.table thead th {
    padding-top: .75rem;
    padding-bottom: .75rem;
    font-size: .75rem;
    text-transform: uppercase;
    font-weight: 600;
    border-top: 0
}

.table th {
    font-weight: 500;
    padding: 1rem
}

.table td .progress {
    height: 3px;
    width: 120px;
    margin: 0
}

.table td,
.table th {
    font-size: .875rem;
    /* ceyhun white-space: nowrap */
}

.table.user-table thead th {
    border-top: 0
}

.table.align-items-center td,
.table.align-items-center th {
    vertical-align: middle
}

.table .thead-dark th {
    background-color: #1f2937;
    color: #fff
}

.table .thead-dark th a {
    color: #1f2937
}

.table .thead-light th {
    background-color: #f2f4f6;
    color: #1f2937
}

.table .thead-light th a {
    color: #1f2937
}

.table-hover tr {
    transition: all .2s ease
}

@media (prefers-reduced-motion: reduce) {
    .table-hover tr {
        transition: none
    }
}

.table-flush td,
.table-flush th {
    border-left: 0;
    border-right: 0
}

.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
    border-top: 0
}

.table-flush tbody tr:last-child td,
.table-flush tbody tr:last-child th {
    border-bottom: 0
}

.card .table {
    margin-bottom: 0
}

.card .table td,
.card .table th {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}

.table [data-sort] {
    cursor: pointer
}

.table .custom-toggle {
    display: block
}

.table .thead-dark [data-sort]::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    margin-left: .25rem
}

.table .thead-light [data-sort]::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    margin-left: .25rem
}

.dataTables_wrapper .dataTables_info {
    padding-left: 1.5rem
}

.dataTables_wrapper .dataTables_paginate {
    padding-right: 1.5rem
}

.dataTables_wrapper .dataTables_length label {
    padding-left: 1.5rem
}

.dataTables_wrapper .dataTables_filter {
    padding-right: 1.5rem
}

.dataTable-bottom,
.dataTable-top {
    display: flex;
    width: 100%;
    justify-content: space-between
}

@media (max-width: 767.98px) {

    .dataTable-bottom,
    .dataTable-top {
        flex-direction: column
    }

    .dataTable-bottom .dataTable-info,
    .dataTable-top .dataTable-info {
        margin-bottom: 1rem
    }
}

.dataTable-top {
    padding: 0 1rem 1rem 1rem
}

.dataTable-bottom {
    padding: 1.5rem 1rem 0 1rem
}

.dataTable-pagination {
    display: flex;
    padding-left: 0;
    list-style: none
}

.dataTable-pagination a {
    padding: .375rem .75rem
}

.dataTable-pagination li:first-child a {
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem
}

.dataTable-pagination li:last-child a {
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem
}

.dataTable-pagination > li:not(:first-child) a {
    margin-left: -.0625rem
}

.dataTable-pagination > li.active a {
    z-index: 3;
    color: #fff;
    background-color: #1f2937;
    border-color: #1f2937
}

.dataTable-pagination > li.disabled a {
    color: #4b5563;
    pointer-events: none;
    background-color: #fff;
    border-color: #d1d5db
}

.dataTable-pagination > li a {
    position: relative;
    display: block;
    color: #1f2937;
    background-color: #fff;
    border: .0625rem solid #9ca3af
}

.dataTable-pagination > li a:hover {
    z-index: 2;
    color: #000;
    background-color: #e5e7eb;
    border-color: #d1d5db
}

.dataTable-pagination > li a:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.dataTable-selector {
    display: inline-block;
    width: auto;
    height: calc(1.5em + 1.125rem);
    padding: .5rem 2rem .5rem 1rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6b7280;
    vertical-align: middle;
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 1rem center;
    background-size: 16px 12px;
    border: .0625rem solid #d1d5db;
    border-radius: .5rem;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125);
    appearance: none
}

.dataTable-selector:focus {
    border-color: #4d6689;
    outline: 0;
    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125), 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.dataTable-selector:focus::-ms-value {
    color: #6b7280;
    background-color: #fff
}

.dataTable-selector[multiple],
.dataTable-selector[size]:not([size="1"]) {
    height: auto;
    padding-right: 1rem;
    background-image: none
}

.dataTable-selector:disabled {
    color: #4b5563;
    background-color: #e5e7eb
}

.dataTable-selector:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #6b7280
}

.dataTable-input {
    display: block;
    width: 100%;
    min-height: calc(1.5em + 1.125rem);
    padding: .5rem 1rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #6b7280;
    background-color: #fff;
    background-clip: padding-box;
    border: .0625rem solid #d1d5db;
    appearance: none;
    border-radius: .5rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out
}

@media (prefers-reduced-motion: reduce) {
    .dataTable-input {
        transition: none
    }
}

.dataTable-input:focus {
    color: #6b7280;
    background-color: #fff;
    border-color: #4d6689;
    outline: 0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07), 0 0 0 .18rem rgba(31, 41, 55, .25)
}

.dataTable-input::placeholder {
    color: #4b5563;
    opacity: 1
}

.dataTable-input:disabled,
.dataTable-input[readonly] {
    background-color: #e5e7eb;
    opacity: 1
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: Inter, sans-serif;
    font-weight: 500
}

.p,
ol li,
p,
ul li {
    font-family: var(--bs-font-sans-serif);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.6
}

.text-action,
a {
    color: #1f2937;
    transition: all .2s ease
}

.text-action:hover,
a:hover {
    color: #000;
    cursor: pointer
}

.lead + .btn-wrapper {
    margin-top: 3rem
}

@media (max-width: 767.98px) {
    .lead {
        font-size: 1rem
    }
}

.line-through {
    -webkit-text-decoration: line-through;
    text-decoration: line-through
}

.text-italic {
    font-style: italic !important
}

.description {
    font-size: .875rem
}

.hover\\:underline:hover {
    text-decoration: underline
}

.heading {
    font-size: 2rem;
    font-weight: 500
}

@media (max-width: 767.98px) {
    .display-2 {
        font-size: 1.875rem
    }
}

@media (max-width: 991.98px) {
    .display-3 {
        font-size: 1.875rem
    }
}

@media (max-width: 575.98px) {
    .display-4 {
        font-size: 1.5rem
    }
}

.blockquote {
    font-style: italic
}

@media (max-width: 767.98px) {
    .blockquote.blockquote-large {
        font-size: 1.25rem
    }
}

.blockquote .blockquote-footer {
    font-size: .875rem;
    font-weight: 600
}

@media (max-width: 767.98px) {
    .blockquote .blockquote-footer {
        font-size: 1.25rem
    }
}

.font-small {
    font-size: .875rem;
    font-weight: 300
}

.font-base {
    font-size: 1rem;
    font-weight: 300
}

.font-medium {
    font-size: 1.25rem;
    font-weight: 300
}

code[class*=language-],
pre[class*=language-] {
    text-shadow: none;
    font-family: var(--bs-font-sans-serif);
    font-weight: 500
}

.text-primary,
.text-primary:hover {
    color: #1f2937 !important
}

.text-primary .display-1,
.text-primary .display-2,
.text-primary .display-3,
.text-primary .display-4,
.text-primary .h1,
.text-primary .h2,
.text-primary .h3,
.text-primary .h4,
.text-primary .h5,
.text-primary .h6,
.text-primary a:not(.btn),
.text-primary h1,
.text-primary h2,
.text-primary h3,
.text-primary h4,
.text-primary h5,
.text-primary h6 {
    color: #1f2937
}

.text-primary .text-muted {
    color: rgba(31, 41, 55, .7) !important
}

.text-secondary,
.text-secondary:hover {
    color: #f0bc74 !important
}

.text-secondary .display-1,
.text-secondary .display-2,
.text-secondary .display-3,
.text-secondary .display-4,
.text-secondary .h1,
.text-secondary .h2,
.text-secondary .h3,
.text-secondary .h4,
.text-secondary .h5,
.text-secondary .h6,
.text-secondary a:not(.btn),
.text-secondary h1,
.text-secondary h2,
.text-secondary h3,
.text-secondary h4,
.text-secondary h5,
.text-secondary h6 {
    color: #f0bc74
}

.text-secondary .text-muted {
    color: rgba(240, 188, 116, .7) !important
}

.text-tertiary,
.text-tertiary:hover {
    color: #31316a !important
}

.text-tertiary .display-1,
.text-tertiary .display-2,
.text-tertiary .display-3,
.text-tertiary .display-4,
.text-tertiary .h1,
.text-tertiary .h2,
.text-tertiary .h3,
.text-tertiary .h4,
.text-tertiary .h5,
.text-tertiary .h6,
.text-tertiary a:not(.btn),
.text-tertiary h1,
.text-tertiary h2,
.text-tertiary h3,
.text-tertiary h4,
.text-tertiary h5,
.text-tertiary h6 {
    color: #31316a
}

.text-tertiary .text-muted {
    color: rgba(49, 49, 106, .7) !important
}

.text-success,
.text-success:hover {
    color: #10b981 !important
}

.text-success .display-1,
.text-success .display-2,
.text-success .display-3,
.text-success .display-4,
.text-success .h1,
.text-success .h2,
.text-success .h3,
.text-success .h4,
.text-success .h5,
.text-success .h6,
.text-success a:not(.btn),
.text-success h1,
.text-success h2,
.text-success h3,
.text-success h4,
.text-success h5,
.text-success h6 {
    color: #10b981
}

.text-success .text-muted {
    color: rgba(16, 185, 129, .7) !important
}

.text-info,
.text-info:hover {
    color: #2361ce !important
}

.text-info .display-1,
.text-info .display-2,
.text-info .display-3,
.text-info .display-4,
.text-info .h1,
.text-info .h2,
.text-info .h3,
.text-info .h4,
.text-info .h5,
.text-info .h6,
.text-info a:not(.btn),
.text-info h1,
.text-info h2,
.text-info h3,
.text-info h4,
.text-info h5,
.text-info h6 {
    color: #2361ce
}

.text-info .text-muted {
    color: rgba(35, 97, 206, .7) !important
}

.text-warning,
.text-warning:hover {
    color: #fba918 !important
}

.text-warning .display-1,
.text-warning .display-2,
.text-warning .display-3,
.text-warning .display-4,
.text-warning .h1,
.text-warning .h2,
.text-warning .h3,
.text-warning .h4,
.text-warning .h5,
.text-warning .h6,
.text-warning a:not(.btn),
.text-warning h1,
.text-warning h2,
.text-warning h3,
.text-warning h4,
.text-warning h5,
.text-warning h6 {
    color: #fba918
}

.text-warning .text-muted {
    color: rgba(251, 169, 24, .7) !important
}

.text-danger,
.text-danger:hover {
    color: #e11d48 !important
}

.text-danger .display-1,
.text-danger .display-2,
.text-danger .display-3,
.text-danger .display-4,
.text-danger .h1,
.text-danger .h2,
.text-danger .h3,
.text-danger .h4,
.text-danger .h5,
.text-danger .h6,
.text-danger a:not(.btn),
.text-danger h1,
.text-danger h2,
.text-danger h3,
.text-danger h4,
.text-danger h5,
.text-danger h6 {
    color: #e11d48
}

.text-danger .text-muted {
    color: rgba(225, 29, 72, .7) !important
}

.text-white,
.text-white:hover {
    color: #fff !important
}

.text-white .display-1,
.text-white .display-2,
.text-white .display-3,
.text-white .display-4,
.text-white .h1,
.text-white .h2,
.text-white .h3,
.text-white .h4,
.text-white .h5,
.text-white .h6,
.text-white a:not(.btn),
.text-white h1,
.text-white h2,
.text-white h3,
.text-white h4,
.text-white h5,
.text-white h6 {
    color: #fff
}

.text-white .text-muted {
    color: rgba(255, 255, 255, .7) !important
}

.text-indigo,
.text-indigo:hover {
    color: #4f46e5 !important
}

.text-indigo .display-1,
.text-indigo .display-2,
.text-indigo .display-3,
.text-indigo .display-4,
.text-indigo .h1,
.text-indigo .h2,
.text-indigo .h3,
.text-indigo .h4,
.text-indigo .h5,
.text-indigo .h6,
.text-indigo a:not(.btn),
.text-indigo h1,
.text-indigo h2,
.text-indigo h3,
.text-indigo h4,
.text-indigo h5,
.text-indigo h6 {
    color: #4f46e5
}

.text-indigo .text-muted {
    color: rgba(79, 70, 229, .7) !important
}

.text-purple,
.text-purple:hover {
    color: #7c3aed !important
}

.text-purple .display-1,
.text-purple .display-2,
.text-purple .display-3,
.text-purple .display-4,
.text-purple .h1,
.text-purple .h2,
.text-purple .h3,
.text-purple .h4,
.text-purple .h5,
.text-purple .h6,
.text-purple a:not(.btn),
.text-purple h1,
.text-purple h2,
.text-purple h3,
.text-purple h4,
.text-purple h5,
.text-purple h6 {
    color: #7c3aed
}

.text-purple .text-muted {
    color: rgba(124, 58, 237, .7) !important
}

.text-yellow-100,
.text-yellow-100:hover {
    color: #ffeed6 !important
}

.text-yellow-100 .display-1,
.text-yellow-100 .display-2,
.text-yellow-100 .display-3,
.text-yellow-100 .display-4,
.text-yellow-100 .h1,
.text-yellow-100 .h2,
.text-yellow-100 .h3,
.text-yellow-100 .h4,
.text-yellow-100 .h5,
.text-yellow-100 .h6,
.text-yellow-100 a:not(.btn),
.text-yellow-100 h1,
.text-yellow-100 h2,
.text-yellow-100 h3,
.text-yellow-100 h4,
.text-yellow-100 h5,
.text-yellow-100 h6 {
    color: #ffeed6
}

.text-yellow-100 .text-muted {
    color: rgba(255, 238, 214, .7) !important
}

.text-yellow-200,
.text-yellow-200:hover {
    color: #f5dbb8 !important
}

.text-yellow-200 .display-1,
.text-yellow-200 .display-2,
.text-yellow-200 .display-3,
.text-yellow-200 .display-4,
.text-yellow-200 .h1,
.text-yellow-200 .h2,
.text-yellow-200 .h3,
.text-yellow-200 .h4,
.text-yellow-200 .h5,
.text-yellow-200 .h6,
.text-yellow-200 a:not(.btn),
.text-yellow-200 h1,
.text-yellow-200 h2,
.text-yellow-200 h3,
.text-yellow-200 h4,
.text-yellow-200 h5,
.text-yellow-200 h6 {
    color: #f5dbb8
}

.text-yellow-200 .text-muted {
    color: rgba(245, 219, 184, .7) !important
}

.text-gray-50,
.text-gray-50:hover {
    color: #f9fafb !important
}

.text-gray-50 .display-1,
.text-gray-50 .display-2,
.text-gray-50 .display-3,
.text-gray-50 .display-4,
.text-gray-50 .h1,
.text-gray-50 .h2,
.text-gray-50 .h3,
.text-gray-50 .h4,
.text-gray-50 .h5,
.text-gray-50 .h6,
.text-gray-50 a:not(.btn),
.text-gray-50 h1,
.text-gray-50 h2,
.text-gray-50 h3,
.text-gray-50 h4,
.text-gray-50 h5,
.text-gray-50 h6 {
    color: #f9fafb
}

.text-gray-50 .text-muted {
    color: rgba(249, 250, 251, .7) !important
}

.text-gray-100,
.text-gray-100:hover {
    color: #f2f4f6 !important
}

.text-gray-100 .display-1,
.text-gray-100 .display-2,
.text-gray-100 .display-3,
.text-gray-100 .display-4,
.text-gray-100 .h1,
.text-gray-100 .h2,
.text-gray-100 .h3,
.text-gray-100 .h4,
.text-gray-100 .h5,
.text-gray-100 .h6,
.text-gray-100 a:not(.btn),
.text-gray-100 h1,
.text-gray-100 h2,
.text-gray-100 h3,
.text-gray-100 h4,
.text-gray-100 h5,
.text-gray-100 h6 {
    color: #f2f4f6
}

.text-gray-100 .text-muted {
    color: rgba(242, 244, 246, .7) !important
}

.text-gray-200,
.text-gray-200:hover {
    color: #e5e7eb !important
}

.text-gray-200 .display-1,
.text-gray-200 .display-2,
.text-gray-200 .display-3,
.text-gray-200 .display-4,
.text-gray-200 .h1,
.text-gray-200 .h2,
.text-gray-200 .h3,
.text-gray-200 .h4,
.text-gray-200 .h5,
.text-gray-200 .h6,
.text-gray-200 a:not(.btn),
.text-gray-200 h1,
.text-gray-200 h2,
.text-gray-200 h3,
.text-gray-200 h4,
.text-gray-200 h5,
.text-gray-200 h6 {
    color: #e5e7eb
}

.text-gray-200 .text-muted {
    color: rgba(229, 231, 235, .7) !important
}

.text-gray-300,
.text-gray-300:hover {
    color: #d1d5db !important
}

.text-gray-300 .display-1,
.text-gray-300 .display-2,
.text-gray-300 .display-3,
.text-gray-300 .display-4,
.text-gray-300 .h1,
.text-gray-300 .h2,
.text-gray-300 .h3,
.text-gray-300 .h4,
.text-gray-300 .h5,
.text-gray-300 .h6,
.text-gray-300 a:not(.btn),
.text-gray-300 h1,
.text-gray-300 h2,
.text-gray-300 h3,
.text-gray-300 h4,
.text-gray-300 h5,
.text-gray-300 h6 {
    color: #d1d5db
}

.text-gray-300 .text-muted {
    color: rgba(209, 213, 219, .7) !important
}

.text-gray-400,
.text-gray-400:hover {
    color: #9ca3af !important
}

.text-gray-400 .display-1,
.text-gray-400 .display-2,
.text-gray-400 .display-3,
.text-gray-400 .display-4,
.text-gray-400 .h1,
.text-gray-400 .h2,
.text-gray-400 .h3,
.text-gray-400 .h4,
.text-gray-400 .h5,
.text-gray-400 .h6,
.text-gray-400 a:not(.btn),
.text-gray-400 h1,
.text-gray-400 h2,
.text-gray-400 h3,
.text-gray-400 h4,
.text-gray-400 h5,
.text-gray-400 h6 {
    color: #9ca3af
}

.text-gray-400 .text-muted {
    color: rgba(156, 163, 175, .7) !important
}

.text-gray-500,
.text-gray-500:hover {
    color: #6b7280 !important
}

.text-gray-500 .display-1,
.text-gray-500 .display-2,
.text-gray-500 .display-3,
.text-gray-500 .display-4,
.text-gray-500 .h1,
.text-gray-500 .h2,
.text-gray-500 .h3,
.text-gray-500 .h4,
.text-gray-500 .h5,
.text-gray-500 .h6,
.text-gray-500 a:not(.btn),
.text-gray-500 h1,
.text-gray-500 h2,
.text-gray-500 h3,
.text-gray-500 h4,
.text-gray-500 h5,
.text-gray-500 h6 {
    color: #6b7280
}

.text-gray-500 .text-muted {
    color: rgba(107, 114, 128, .7) !important
}

.text-gray-600,
.text-gray-600:hover {
    color: #4b5563 !important
}

.text-gray-600 .display-1,
.text-gray-600 .display-2,
.text-gray-600 .display-3,
.text-gray-600 .display-4,
.text-gray-600 .h1,
.text-gray-600 .h2,
.text-gray-600 .h3,
.text-gray-600 .h4,
.text-gray-600 .h5,
.text-gray-600 .h6,
.text-gray-600 a:not(.btn),
.text-gray-600 h1,
.text-gray-600 h2,
.text-gray-600 h3,
.text-gray-600 h4,
.text-gray-600 h5,
.text-gray-600 h6 {
    color: #4b5563
}

.text-gray-600 .text-muted {
    color: rgba(75, 85, 99, .7) !important
}

.text-gray-700,
.text-gray-700:hover {
    color: #374151 !important
}

.text-gray-700 .display-1,
.text-gray-700 .display-2,
.text-gray-700 .display-3,
.text-gray-700 .display-4,
.text-gray-700 .h1,
.text-gray-700 .h2,
.text-gray-700 .h3,
.text-gray-700 .h4,
.text-gray-700 .h5,
.text-gray-700 .h6,
.text-gray-700 a:not(.btn),
.text-gray-700 h1,
.text-gray-700 h2,
.text-gray-700 h3,
.text-gray-700 h4,
.text-gray-700 h5,
.text-gray-700 h6 {
    color: #374151
}

.text-gray-700 .text-muted {
    color: rgba(55, 65, 81, .7) !important
}

.text-gray-800,
.text-gray-800:hover {
    color: #1f2937 !important
}

.text-gray-800 .display-1,
.text-gray-800 .display-2,
.text-gray-800 .display-3,
.text-gray-800 .display-4,
.text-gray-800 .h1,
.text-gray-800 .h2,
.text-gray-800 .h3,
.text-gray-800 .h4,
.text-gray-800 .h5,
.text-gray-800 .h6,
.text-gray-800 a:not(.btn),
.text-gray-800 h1,
.text-gray-800 h2,
.text-gray-800 h3,
.text-gray-800 h4,
.text-gray-800 h5,
.text-gray-800 h6 {
    color: #1f2937
}

.text-gray-800 .text-muted {
    color: rgba(31, 41, 55, .7) !important
}

.text-gray-900,
.text-gray-900:hover {
    color: #111827 !important
}

.text-gray-900 .display-1,
.text-gray-900 .display-2,
.text-gray-900 .display-3,
.text-gray-900 .display-4,
.text-gray-900 .h1,
.text-gray-900 .h2,
.text-gray-900 .h3,
.text-gray-900 .h4,
.text-gray-900 .h5,
.text-gray-900 .h6,
.text-gray-900 a:not(.btn),
.text-gray-900 h1,
.text-gray-900 h2,
.text-gray-900 h3,
.text-gray-900 h4,
.text-gray-900 h5,
.text-gray-900 h6 {
    color: #111827
}

.text-gray-900 .text-muted {
    color: rgba(17, 24, 39, .7) !important
}

article img {
    margin: 40px 0
}

article blockquote,
article ol,
article p,
article ul {
    margin-bottom: 20px
}

article ol li,
article p,
article ul li {
    font-size: 1.2rem
}

article .h1,
article .h2,
article .h3,
article .h4,
article .h5,
article .h6,
article h1,
article h2,
article h3,
article h4,
article h5,
article h6 {
    margin-bottom: 30px
}

.folder-structure li {
    font-size: 1.2rem
}

.truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.list-group-timeline .list-group-item {
    position: relative
}

.list-group-timeline .list-group-item .col-auto {
    z-index: 999
}

.list-group-timeline .list-group-item::before {
    content: "";
    position: absolute;
    top: 0;
    left: 4px;
    height: 100%;
    border-left: 2px solid #e5e7eb
}

.list-group-timeline .list-group-item::after {
    content: "";
    position: absolute;
    top: 15px;
    left: 8px;
    width: 10px;
    height: 10px;
    margin-top: .425rem;
    margin-left: -.5rem;
    border: 2px solid #e5e7eb;
    background: #fff;
    border-radius: .5rem
}

.tooltip-inner {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)
}

.chartist-tooltip {
    position: absolute;
    display: inline-block;
    opacity: 0;
    min-width: 5em;
    padding: .5em;
    background: #e5e7eb;
    border: 1px solid #9ca3af;
    border-radius: .5rem;
    color: #1f2937;
    font-weight: 500;
    text-align: center;
    pointer-events: none;
    z-index: 1;
    transition: all .2s ease
}

.chartist-tooltip:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    width: 0;
    height: 0;
    margin-left: -15px;
    border: 15px solid transparent;
    border-top-color: #e5e7eb
}

.chartist-tooltip.tooltip-show {
    opacity: 1
}

.ct-area,
.ct-line {
    pointer-events: none
}

.fc-h-event {
    border: 0;
    padding: 3px;
    display: block
}

.fc-daygrid-day-frame {
    padding: 5px;
    border: .0625rem solid #e5e7eb
}

.fc-daygrid-day {
    transition: all .2s ease
}

.fc .fc-scrollgrid,
.fc .fc-scrollgrid table {
    border-color: #fff
}

.fc .fc-scrollgrid {
    border-collapse: collapse !important
}

.fc-daygrid-day:hover {
    cursor: pointer;
    background: rgba(240, 188, 116, .2)
}

.fc .fc-highlight {
    background-color: rgba(240, 188, 116, .2)
}

@media (min-width: 768px) {
    .fc .fc-col-header-cell-cushion::before {
        margin-right: 10px
    }
}

.fc .fc-daygrid-day-frame {
    padding: 5px;
    border: .0625rem solid #e5e7eb;
    width: 100%;
    height: 190px
}

@media (max-width: 575.98px) {
    .fc .fc-daygrid-day-frame {
        height: 100%
    }
}

.fc .fc-col-header-cell-cushion {
    padding: 6px 8px
}

@media (max-width: 575.98px) {
    .fc .fc-toolbar .btn {
        padding: .25rem .45rem
    }

    .fc .fc-toolbar .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
        margin-left: .35em
    }
}

.fc-daygrid-event {
    font-weight: 500;
    border-radius: .35rem
}

.fc-direction-ltr .fc-daygrid-event {
    padding-right: 10px;
    padding-left: 10px
}

.fc-daygrid-day-number {
    font-weight: 500
}

@media (max-width: 767.98px) {
    .fc .fc-toolbar-title {
        font-size: 1rem
    }
}

.datepicker .datepicker-cell.selected,
.datepicker .datepicker-cell.selected:hover {
    background: #1f2937
}

[data-simplebar] {
    position: fixed;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: flex-start
}

.simplebar-wrapper {
    overflow: hidden;
    width: inherit;
    height: inherit;
    max-width: inherit;
    max-height: inherit
}

.simplebar-mask {
    direction: inherit;
    position: absolute;
    overflow: hidden;
    padding: 0;
    margin: 0;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: auto !important;
    height: auto !important;
    z-index: 0
}

.simplebar-offset {
    direction: inherit !important;
    box-sizing: inherit !important;
    resize: none !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 0;
    margin: 0;
    -webkit-overflow-scrolling: touch
}

.simplebar-content-wrapper {
    direction: inherit;
    box-sizing: border-box !important;
    position: relative;
    display: block;
    height: 100%;
    width: auto;
    max-width: 100%;
    max-height: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
    width: 0;
    height: 0
}

.simplebar-content:after,
.simplebar-content:before {
    content: ' ';
    display: table
}

.simplebar-placeholder {
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    pointer-events: none
}

.simplebar-height-auto-observer-wrapper {
    box-sizing: inherit !important;
    height: 100%;
    width: 100%;
    max-width: 1px;
    position: relative;
    float: left;
    max-height: 1px;
    overflow: hidden;
    z-index: -1;
    padding: 0;
    margin: 0;
    pointer-events: none;
    flex-grow: inherit;
    flex-shrink: 0;
    flex-basis: 0
}

.simplebar-height-auto-observer {
    box-sizing: inherit;
    display: block;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 1000%;
    width: 1000%;
    min-height: 1px;
    min-width: 1px;
    overflow: hidden;
    pointer-events: none;
    z-index: -1
}

.simplebar-track {
    z-index: 1;
    position: absolute;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden
}

[data-simplebar].simplebar-dragging .simplebar-content {
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none
}

[data-simplebar].simplebar-dragging .simplebar-track {
    pointer-events: all
}

.simplebar-scrollbar {
    position: absolute;
    left: 0;
    right: 0;
    min-height: 10px
}

.simplebar-scrollbar:before {
    position: absolute;
    content: '';
    background: #000;
    border-radius: 7px;
    left: 2px;
    right: 2px;
    opacity: 0;
    transition: opacity .2s .5s linear
}

.simplebar-hover .simplebar-scrollbar:before,
.simplebar-mouse-entered .simplebar-scrollbar:before,
.simplebar-scrolling .simplebar-scrollbar:before {
    opacity: .5;
    transition-delay: 0s;
    transition-duration: 0s
}

.simplebar-scrollbar.simplebar-visible:before {
    opacity: .5;
    transition-delay: 0s;
    transition-duration: 0s
}

.simplebar-track.simplebar-vertical {
    top: 0;
    width: 11px
}

.simplebar-scrollbar:before {
    top: 2px;
    bottom: 2px;
    left: 2px;
    right: 2px
}

.simplebar-track.simplebar-horizontal {
    left: 0;
    height: 11px
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
    right: auto;
    left: 0;
    top: 0;
    bottom: 0;
    min-height: 0;
    min-width: 10px;
    width: auto
}

[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
    right: auto;
    left: 0
}

.simplebar-dummy-scrollbar-size {
    direction: rtl;
    position: fixed;
    opacity: 0;
    visibility: hidden;
    height: 500px;
    width: 500px;
    overflow-y: hidden;
    overflow-x: scroll;
    -ms-overflow-style: scrollbar !important
}

.simplebar-dummy-scrollbar-size > div {
    width: 200%;
    height: 200%;
    margin: 10px 0
}

.simplebar-hide-scrollbar {
    position: fixed;
    left: 0;
    visibility: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none
}

.simplebar-scrollbar::before {
    background-color: #0d1116
}

.svgMap-map-wrapper {
    position: relative;
    width: 100%;
    height: 300px;
    padding-top: 0;
    overflow: hidden;
    background: #fff;
    color: #fff
}

.svgMap-map-wrapper * {
    box-sizing: border-box
}

.svgMap-map-wrapper :focus:not(:focus-visible) {
    outline: 0
}

.svgMap-map-wrapper .svgMap-map-image {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0
}

.svgMap-map-wrapper .svgMap-map-controls-wrapper {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 1;
    display: flex;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    border-radius: .5rem
}

.svgMap-map-wrapper .svgMap-map-controls-move,
.svgMap-map-wrapper .svgMap-map-controls-zoom {
    display: flex;
    margin-right: 5px;
    overflow: hidden;
    background: #111827
}

.svgMap-map-wrapper .svgMap-map-controls-move:last-child,
.svgMap-map-wrapper .svgMap-map-controls-zoom:last-child {
    margin-right: 0
}

.svgMap-map-wrapper .svgMap-control-button {
    background-color: transparent;
    border: none;
    border-radius: 0;
    color: inherit;
    font: inherit;
    line-height: inherit;
    margin: 0;
    padding: 0;
    overflow: visible;
    text-transform: none;
    appearance: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    position: relative
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #d1d5db;
    transition: background-color .2s
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {
    width: 11px;
    height: 3px
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:before {
    background: #fff
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:after,
.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:before {
    background: #9ca3af
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button {
    margin: 1px 0 1px 1px
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button:after {
    width: 3px;
    height: 11px
}

.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-out-button {
    margin: 1px 1px 1px 0
}

.svgMap-map-wrapper .svgMap-country {
    cursor: pointer;
    stroke: #fff;
    stroke-width: 1;
    stroke-linejoin: round;
    vector-effect: non-scaling-stroke;
    transition: fill .2s, stroke .2s
}

.svgMap-map-wrapper .svgMap-country.svgMap-active,
.svgMap-map-wrapper .svgMap-country:hover {
    stroke: #e11d48
}

.svgMap-map-wrapper .svgMap-country.svgMap-active {
    stroke-width: #e11d48
}

.svgMap-tooltip {
    position: absolute;
    z-index: 2;
    background: #fff;
    transform: translate(-50%, -100%);
    display: none;
    pointer-events: none;
    min-width: 60px;
    border: .0625rem solid #e5e7eb;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    border-radius: .5rem
}

.svgMap-tooltip.svgMap-tooltip-flipped {
    transform: translate(-50%, 0);
    border-bottom: 0;
    border-top: 1px solid #000
}

.svgMap-tooltip.svgMap-active {
    display: block
}

.svgMap-tooltip .svgMap-tooltip-content-container {
    position: relative;
    padding: 10px 20px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container {
    text-align: left;
    margin: 2px 0 5px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container.svgMap-tooltip-flag-container-emoji {
    font-size: 40px;
    line-height: 0;
    padding: 25px 0 15px
}

.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container .svgMap-tooltip-flag {
    display: block;
    width: auto;
    height: 35px;
    border: 2px solid #fff;
    border-radius: .5rem
}

.svgMap-tooltip .svgMap-tooltip-title {
    font-size: 1.25rem;
    font-weight: 500;
    white-space: nowrap;
    padding: 0 0 8px;
    text-align: left
}

.svgMap-tooltip .svgMap-tooltip-content {
    white-space: nowrap;
    font-size: .875rem;
    font-weight: 400;
    color: #d1d5db
}

.svgMap-tooltip .svgMap-tooltip-content table {
    padding: 0;
    border-spacing: 0
}

.svgMap-tooltip .svgMap-tooltip-content table td {
    padding: 2px 0;
    text-align: left;
    font-weight: 400
}

.svgMap-tooltip .svgMap-tooltip-content table td span {
    color: #10b981;
    font-weight: 500
}

.svgMap-tooltip .svgMap-tooltip-content table td:first-child {
    padding-right: 15px;
    text-align: left;
    color: #374151
}

.svgMap-tooltip .svgMap-tooltip-content table td sup {
    vertical-align: baseline;
    position: relative;
    top: -5px
}

.svgMap-tooltip .svgMap-tooltip-content .svgMap-tooltip-no-data {
    padding: 2px 0;
    color: #d1d5db;
    font-style: italic
}

.svgMap-tooltip .svgMap-tooltip-pointer {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    height: 10px;
    width: 30px
}

.svgMap-tooltip .svgMap-tooltip-pointer:after {
    content: "";
    width: 20px;
    height: 20px;
    background: #fff;
    border: .0625rem solid #e5e7eb;
    position: absolute;
    bottom: 6px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg)
}

.svgMap-tooltip.svgMap-tooltip-flipped .svgMap-tooltip-pointer {
    bottom: auto;
    top: -10px;
    transform: translateX(-50%) scaleY(-1)
}

.swal2-container.swal2-backdrop-show,
.swal2-container.swal2-noanimation {
    background: rgba(31, 41, 55, .8) !important
}

.swal2-popup {
    color: #374151 !important;
    border: 0 !important
}

.swal2-title {
    color: #1f2937 !important;
    font-weight: 700 !important
}

.swal2-content {
    color: #4b5563 !important
}

.swal2-styled {
    padding: .5rem 1rem
}

.swal2-styled.swal2-confirm {
    background-color: #2361ce !important;
    border-radius: .5rem !important
}

.swal2-icon .swal2-icon-content {
    font-size: 2.5em !important
}

.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
    opacity: 0
}

.swal2-icon.swal2-success .swal2-success-fix {
    opacity: 0
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {
    animation: swal2-animate-success-line-tip .55s
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {
    animation: swal2-animate-success-line-long .55s
}

.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {
    animation: swal2-rotate-success-circular-line 3.25s ease-in
}

.noUi-target,
.noUi-target * {
    -webkit-touch-callout: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    touch-action: none;
    user-select: none;
    box-sizing: border-box
}

.noUi-target {
    position: relative;
    direction: ltr
}

.noUi-base,
.noUi-connects {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1
}

.noUi-connects {
    overflow: hidden;
    z-index: 0
}

.noUi-connect,
.noUi-origin {
    will-change: transform;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform-origin: 0 0
}

html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
    left: auto;
    right: 0
}

.noUi-vertical .noUi-origin {
    width: 0
}

.noUi-horizontal .noUi-origin {
    height: 0
}

.noUi-handle {
    position: absolute
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
    transition: transform .3s
}

.noUi-state-drag * {
    cursor: inherit !important
}

.noUi-horizontal {
    height: 5px
}

.noUi-horizontal .noUi-handle {
    left: -17px;
    top: -10px
}

.noUi-vertical {
    width: 5px;
    height: 340px
}

.noUi-vertical .noUi-handle {
    width: 18px;
    height: 34px;
    left: -6px;
    top: -17px
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
    right: -17px;
    left: auto
}

.noUi-connects {
    border-radius: 3px
}

.noUi-connect {
    background: #1f2937
}

.noUi-draggable {
    cursor: ew-resize
}

.noUi-vertical .noUi-draggable {
    cursor: ns-resize
}

.noUi-handle {
    border: 1px solid #f2f4f6;
    border-radius: 3px;
    background: #fff;
    cursor: default;
    outline: 0
}

.noUi-handle:hover {
    cursor: grab;
    cursor: -moz-grab;
    background-color: #9ca3af
}

.noUi-handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    background-color: #9ca3af;
    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5)
}

.noUi-handle:focus {
    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5);
    background-color: #9ca3af
}

.noUi-active {
    outline: 0
}

[disabled] .noUi-connect {
    background: #9ca3af
}

[disabled] .noUi-handle,
[disabled].noUi-handle,
[disabled].noUi-target {
    cursor: not-allowed
}

.noUi-pips,
.noUi-pips * {
    box-sizing: border-box
}

.noUi-pips {
    position: absolute;
    color: #1f2937;
    font-size: .75rem
}

.noUi-value {
    margin-top: 5px;
    position: absolute;
    white-space: nowrap;
    text-align: center
}

.noUi-value-sub {
    color: #9ca3af;
    font-size: .75rem
}

.noUi-marker {
    position: absolute;
    background: #1f2937
}

.noUi-marker-sub {
    background: #1f2937
}

.noUi-marker-large {
    background: #1f2937
}

.noUi-pips-horizontal {
    padding: 12px 0;
    height: auto;
    top: 100%;
    left: 0;
    width: 100%
}

.noUi-value-horizontal {
    transform: translate(-50%, 50%)
}

.noUi-rtl .noUi-value-horizontal {
    transform: translate(50%, 50%)
}

.noUi-marker-horizontal.noUi-marker {
    margin-left: -1px;
    width: 2px;
    height: 5px
}

.noUi-marker-horizontal.noUi-marker-sub {
    height: 10px
}

.noUi-marker-horizontal.noUi-marker-large {
    height: 12px
}

.noUi-pips-vertical {
    padding: 0 10px;
    height: 100%;
    top: 0;
    left: 100%
}

.noUi-value-vertical {
    transform: translate(0, -50%, 0);
    padding-left: 25px
}

.noUi-rtl .noUi-value-vertical {
    transform: translate(0, 50%)
}

.noUi-marker-vertical.noUi-marker {
    width: 5px;
    height: 2px;
    margin-top: -1px
}

.noUi-marker-vertical.noUi-marker-sub {
    width: 10px
}

.noUi-marker-vertical.noUi-marker-large {
    width: 15px
}

.noUi-tooltip {
    background: #fff;
    color: #1f2937;
    font-size: .75rem;
    font-weight: 400;
    display: block;
    position: absolute;
    padding: 5px 10px;
    text-align: center;
    white-space: nowrap;
    border-radius: .5rem;
    border: .0625rem solid #9ca3af
}

.noUi-horizontal .noUi-tooltip {
    transform: translate(-50%, 0);
    left: 50%;
    bottom: 30px
}

.noUi-vertical .noUi-tooltip {
    transform: translate(0, -50%);
    top: 50%;
    right: 120%
}

.noUi-target {
    background: #9ca3af;
    border-radius: 5px;
    border: 0;
    box-shadow: inset 0 2px 5px rgba(140, 152, 164, .2);
    margin: 15px 0;
    cursor: pointer
}

.noUi-horizontal {
    height: 5px
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
    right: -10px
}

.noUi-vertical {
    width: 5px
}

.noUi-connect {
    background: #1f2937;
    box-shadow: none
}

.noUi-handle {
    position: absolute;
    border: 1px solid #1f2937;
    border-radius: 50%;
    width: 23px;
    height: 23px;
    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);
    background: #fff;
    transition: all 150ms cubic-bezier(.17, .01, .28, 1.06)
}

.noUi-vertical .noUi-handle {
    border: 1px solid #374151;
    border-radius: 3px;
    background: #fff;
    cursor: default;
    box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #f2f4f6, 0 3px 6px -3px #e5e7eb;
    outline: 0
}

.noUi-vertical .noUi-handle:hover {
    cursor: grab;
    cursor: -moz-grab;
    background-color: #9ca3af
}

.noUi-vertical .noUi-handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    background-color: #9ca3af;
    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5)
}

.noUi-vertical .noUi-handle:focus {
    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5);
    background-color: #9ca3af
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
    transform: scale(1.2)
}

.input-slider--cyan .noUi-connect {
    background: #63b1bd
}

.input-slider--cyan.noUi-horizontal .noUi-handle,
.input-slider--cyan.noUi-vertical .noUi-handle {
    background-color: #63b1bd
}

.input-slider--red .noUi-connect {
    background: #e11d48
}

.input-slider--red.noUi-horizontal .noUi-handle,
.input-slider--red.noUi-vertical .noUi-handle {
    background-color: #e11d48
}

.input-slider--green .noUi-connect {
    background: #10b981
}

.input-slider--green.noUi-horizontal .noUi-handle,
.input-slider--green.noUi-vertical .noUi-handle {
    background-color: #10b981
}

.input-slider--yellow .noUi-connect {
    background: #f3c78e
}

.input-slider--yellow.noUi-horizontal .noUi-handle,
.input-slider--yellow.noUi-vertical .noUi-handle {
    background-color: #f3c78e
}

.input-slider--pink .noUi-connect {
    background: #ef4683
}

.input-slider--pink.noUi-horizontal .noUi-handle,
.input-slider--pink.noUi-vertical .noUi-handle {
    background-color: #ef4683
}

[disabled] .noUi-connect,
[disabled].noUi-connect {
    background: #e5e7eb
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
    cursor: not-allowed
}

.range-slider-value {
    font-size: .75rem;
    font-weight: 500;
    background-color: rgba(31, 41, 55, .7);
    color: color-yiq(#1f2937);
    border-radius: 10px;
    padding: .4em .8em .3em .85em
}

.range-slider-wrapper .upper-info {
    font-weight: 400;
    margin-bottom: 5px
}

.input-slider-value-output {
    background: #1f2937;
    color: #fff;
    padding: 4px 8px;
    position: relative;
    top: 12px;
    font-size: 11px;
    border-radius: 2px
}

.input-slider-value-output:after {
    bottom: 100%;
    left: 10px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: #1f2937;
    border-bottom-color: #333;
    border-width: 4px;
    margin-left: -4px
}

.input-slider-value-output.left:after {
    left: 10px;
    right: auto
}

.input-slider-value-output.right:after {
    right: 10px;
    left: auto
}

@media (min-width: 992px) {
    .form-control.form-control-lg {
        padding: 1rem 1rem
    }
}

.search-bar .form-control {
    width: 280px;
    transition: width .2s ease-in-out
}

@media (max-width: 575.98px) {
    .search-bar .form-control {
        width: 120px
    }

    .search-bar .form-control:focus {
        width: 150px
    }
}

.form-check-input.round-check[type=checkbox] {
    border-radius: 50%
}

.form-switch {
    padding-left: 2.75em
}

.form-switch .form-check-input {
    height: 1.275em
}

.input-group .form-control:focus {
    border-color: #d1d5db
}

.input-group .form-control:focus + .input-group-text {
    border-color: #d1d5db
}

.input-group-text {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07)
}

.form-select .form-select-lg {
    padding: .5rem 2rem .5rem 1rem
}

.file-field input[type=file] {
    max-width: 230px;
    position: absolute;
    cursor: pointer;
    opacity: 0;
    padding-bottom: 30px
}

.file-field svg {
    cursor: pointer
}

.datepicker-dropdown {
    z-index: 9999
}

.card {

    border-radius: 10px
}

.c-details span {
    font-weight: 300;
    font-size: 13px
}

.icon {
    width: 50px;
    height: 50px;
    background-color: #eee;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 39px
}

.badge span {
    background-color: #fffbec;
    width: 60px;
    height: 25px;
    padding-bottom: 3px;
    border-radius: 5px;
    display: flex;
    color: #fed85d;
    justify-content: center;
    align-items: center
}

.progress {
    height: 10px;
    border-radius: 10px
}

.progress div {
    background-color: red
}

.text1 {
    font-size: 14px;
    font-weight: 600
}

.text2 {
    color: #a5aec0
}


.clock {

    position: relative;
    background-size: contain; /* Resmi dive sığdırır */
    background-position: center; /* Resmi ortalar */
    background-repeat: no-repeat; /* Tekrar etmesini engeller */
}

.clock-text-box {

    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/site.css"],"names":[],"mappings":"AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,sBAAsB;IAClE,0BAA0B,EAAE,qBAAqB;IACjD,aAAa,EAAE,uCAAuC;AAC1D;;AAEA;IACI,oBAAoB,EAAE,4CAA4C;AACtE;;AAEA;IACI,aAAa,EAAE,0BAA0B;AAC7C;;;AAGA;;;IAGI,iCAAiC;IACjC,gBAAgB;;IAEhB,8CAA8C;IAC9C,qBAAqB;IACrB,wBAAwB;;AAE5B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,4CAC8B,0BAA0B;IACpD,gBAAgB;IAChB,gBAAgB,EAAE,+BAA+B;IACjD,yBAAyB;IACzB,YAAY;IACZ,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,SAAO;IACP,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gDAAgD;IAChD;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;IACI,iDAAiD;IACjD,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,iCAAiC;IACjC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,wBAAwB;IACxB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;IACzC,yGAAyG;IACzG;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,8BAA8B;IAC9B,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;IAYI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,yCAAyC;IACzC,iCAAiC;IACjC,YAAY;IAEZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,aAAa;IACb;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,aAAa;IACb;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;;;IAII,qCAAqC;IACrC,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;;;IAMI,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,gCAAgC;IAChC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,8BAA8B;IAC9B,oBAAoB;IACpB,6CAA6C;IAC7C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;;;;;;IAMI,WAAW;IACX,uCAAuC;IACvC,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;IAEI;;;;QAII;IACJ;AACJ;;AAEA;;IAEI;;;;;QAKI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yCAAyC;IACzC,2CAA2C;IAC3C;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,2CAA2C;IAC3C,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,iCAAiC;IACjC,6CAA6C;IAC7C,gCAAgC;IAChC,2CAA2C;IAC3C,+BAA+B;IAC/B,4CAA4C;IAC5C,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gDAAgD;IAChD;AACJ;;AAEA;IACI,+CAA+C;IAC/C;AACJ;;AAEA;IACI,8CAA8C;IAC9C;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAE9B,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;IAC1C;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IAEpB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IAEpB,uBAAuB;IACvB,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,gBAAgB;IAEhB,yIAAgI;IAAhI;AACJ;;AAEA;IACI;QAEI,wBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IAEzB;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IAEzB;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IAEpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IAEpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,sCAAsC;IACtC,0BAA0B;IAC1B,8BAA8B;IAC9B,oBAAoB;IACpB,mDAAmD;IAEnD;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IAEzB,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,yDAA0J;IAC1J,gCAAgC;IAChC,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,UAAU;IACV,6BAA6B;IAE7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;IAE/C,iHAAyG;IAAzG,yGAAyG;IAEzG;AACJ;;AAEA;IACI;QAEI,wBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,SAAS;IACT,mBAAmB;IACnB,+CAA+C;IAE/C,8GAAyG;IAAzG,yGAAyG;IACzG;AACJ;;AAEA;IACI;QAEI,qBAAe;QAAf;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,kCAAkC;IAClC,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;;IAGI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B;AACJ;;AAEA;;;;IAII,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;;;IAII,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,iCAAiC;IACjC,yDAA4P;IAC5P,4BAA4B;IAC5B,uDAAuD;IACvD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB,kGAA6d;IAC7d,yDAAyD;IACzD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,iCAAiC;IACjC,yDAA4U;IAC5U,4BAA4B;IAC5B,uDAAuD;IACvD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII,qBAAqB;IACrB,kGAA6iB;IAC7iB,yDAAyD;IACzD;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,6BAA6B;IAC7B,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;IAGI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,sBAAsB;IACtB,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAC9B,qBAAqB;IACrB;AACJ;;AAEA;IACI,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,WAAW;IACX,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;;;IAGI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,wBAAwB;IACxB;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,kCAAkC;IAClC,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,qCAAqC;IACrC;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;;;;;;IAMI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,kCAAkC;IAClC,oBAAoB;IACpB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,6CAA6C;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC;AACJ;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;IACvC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,gCAAgC;IAChC;AACJ;;AAEA;;IAEI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;;IAEA;QACI,SAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,0DAAiS;IACjS;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,0DAAiS;IACjS,4BAA4B;IAC5B,wBAAwB;IACxB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,8BAA8B;IAC9B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kMAAkM;IAClM;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;;IAEI,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,cAAc;IACd,0FAA8W;IAC9W,SAAS;IACT,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,8CAA8C;IAC9C;AACJ;;AAEA;;IAEI,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,0CAA0C;IAC1C,4BAA4B;IAC5B,mCAAmC;IACnC,yEAAyE;IACzE;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,0CAA0C;IAC1C,4BAA4B;IAC5B,2CAA2C;IAC3C,yCAAyC;IACzC;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,sBAAsB;IACtB,4BAA4B;IAC5B,2CAA2C;IAC3C,oBAAoB;IACpB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,qCAAqC;IACrC,gCAAgC;IAChC;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kCAAkC;IAClC,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,OAAO;IACP,YAAY;IACZ;AACJ;;AAEA;;IAEI,WAAW;IACX,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;;IAEI,UAAU;IACV,iCAAiC;IACjC;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;IAC5B,2CAA2C;IAC3C,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,2BAA2B;IAC3B;AACJ;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;;IAEI,OAAO;IACP,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,cAAc;IACd,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,MAAM;IACN,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,aAAa;IACb,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;;IAEI,QAAQ;IACR,iCAAiC;IACjC;AACJ;;AAEA;;IAEI,eAAe;IACf,iCAAiC;IACjC;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,qCAAqC;IACrC,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,mBAAmB;IAEnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B;AACJ;;AAEA;;;IAGI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;;;;IAII,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;IAChC,+BAA+B;IAC/B,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,OAAO;IACP;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,MAAM;QACN;IACJ;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,aAAa;QACb,mCAAmC;QACnC,kCAAkC;QAClC,8BAA8B;QAC9B,4BAA4B;QAC5B,wBAAwB;QACxB,uBAAuB;QACvB;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;;;QAGI;IACJ;AACJ;;AAEA;;;IAGI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,MAAM;IACN,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,oBAAoB;QACpB,SAAS;QACT;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;;;QAGI,UAAU;QACV;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,UAAU;QACV,oBAAoB;QACpB;IACJ;;IAEA;;QAEI,cAAc;QACd,UAAU;QACV;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,kBAAkB;QAClB,MAAM;QACN,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,qCAAqC;QACrC;IACJ;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV;IACJ;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf,qBAAqB;QACrB,gBAAgB;QAChB,iDAAiD;QACjD;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,cAAc;QACd,0BAA0B;QAC1B,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI,aAAa;QACb;IACJ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;QACrB;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;QACnB;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,+DAA+D;QAC/D;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mDAAmD;QACnD;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,8DAA8D;IAE9D,2BAA2B;IAC3B;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,2CAA2C;IAC3C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,kCAAkC;QAClC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;IACxB,uBAAuB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;;;;;IAKI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,gBAAgB;IAChB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV;AACJ;;AAEA;IACI,0FAA8W;IAC9W,SAAS;IACT,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;;QAEI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,OAAO;QACP,mBAAmB;QACnB,yBAAyB;QACzB,qDAAqD;QACrD,sBAAsB;QACtB,qBAAqB;QACrB,yBAAyB;QACzB;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,kBAAkB;QAClB,yBAAyB;QACzB,qDAAqD;QACrD,sBAAsB;QACtB,qBAAqB;QACrB,yBAAyB;QACzB;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,yBAAyB;IACzB,qDAAqD;IACrD,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,eAAe;IACf,gCAAgC;IAChC,iCAAiC;IACjC,wBAAwB;IACxB,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B,wBAAwB;IACxB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,oBAAoB;IACpB,oFAAoF;IACpF;AACJ;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,iCAAiC;IACjC,oFAAoF;IACpF;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,QAAQ;IACR,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,SAAO;IACP;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,YAAY;IACZ,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAEhB;AACJ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;IACb,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,gCAAgC;IAChC,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,8BAA8B;IAC9B;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;IACnC,kCAAkC;IAClC,8BAA8B;IAC9B,4BAA4B;IAC5B;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,SAAS;IACT,QAAQ;IACR,oBAAoB;IACpB,yBAAyB;IACzB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iDAAgP;IAChP;AACJ;;AAEA;IACI,iDAAgP;IAChP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,8BAA8B;IAC9B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,yDAAiP;IACjP,4BAA4B;IAC5B,sCAAsC;IACtC,0BAA0B;IAC1B,8BAA8B;IAC9B,oBAAoB;IACpB,mDAAmD;IAEnD;AACJ;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;IAE9B,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;IAC1C;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;;;;;;;IAYI,8BAA8B;IAC9B;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,iBAAiB;IACjB,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;;;;;IAiBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,QAAQ;IACR;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;;IAGI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI,MAAM;IACN;AACJ;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;IACI,WAAW;IACX,OAAO;IACP,MAAM;IACN,SAAS;IACT,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,6CAA6C;IAC7C;AACJ;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IAEpB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,iCAAiC;IACjC,aAAa;IACb,oBAAoB;IACpB,eAAe;IACf,8BAA8B;IAC9B,0BAA0B;IAC1B,kCAAkC;IAClC,6CAA6C;IAC7C;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,2BAA2B;IAC3B,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,6CAA6C;IAC7C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,MAAM;IACN;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT;AACJ;;AAEA;IACI,6BAA6B;IAC7B,QAAQ;IACR;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,mDAAmD;IACnD,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+EAA+E;IAC/E;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI,6CAA6C;IAC7C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;;AAGA;;IAEI,kBAAkB;IAClB,wBAAwB,EAAE,wBAAwB;IAClD,2BAA2B,EAAE,kBAAkB;IAC/C,4BAA4B,EAAE,6BAA6B;AAC/D;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&amp;display=swap);\n\n.backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.8); /* Beyaz yarı saydam */\n    backdrop-filter: blur(5px); /* Buzlu cam efekti */\n    z-index: 1040; /* Modalın z-index'inden düşük olmalı */\n}\n\n.modal-open .container {\n    pointer-events: none; /* Sayfanın geri kalanını tıklanamaz yapar */\n}\n\n.modal {\n    z-index: 1050; /* Modal en üstte olmalı */\n}\n\n\n.rotate {\n\n\n    /* Border is the new background */\n    background: none;\n\n    /* Rotate from top left corner (not default) */\n    transform-origin: 0 0;\n    transform: rotate(90deg);\n\n}\n\n.datepicker {\n    display: none\n}\n\n.datepicker.active {\n    display: block\n}\n\ninput[type=\"range\"]::-webkit-slider-thumb {\n    -webkit-appearance: none; /* Override default look */\n    appearance: none;\n    margin-top: -1px; /* Centers thumb on the track */\n    background-color: #5cd5eb;\n    height: 1rem;\n    width: 1rem;\n}\n\n.leaflet-container {\n\n    width: 100vw;\n    height: 100vh;\n}\n\n.tab-selected {\n    color: #32557f !important;\n    font-weight: bold;\n    text-decoration: none;\n    border-bottom: 3px solid #32557f;\n    padding-bottom: 3px;\n}\n\n.datepicker-dropdown {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 20;\n    padding-top: 4px\n}\n\n.datepicker-dropdown.datepicker-orient-top {\n    padding-top: 0;\n    padding-bottom: 4px\n}\n\n.datepicker-picker {\n    display: inline-block;\n    border-radius: 4px;\n    background-color: #fff\n}\n\n.datepicker-dropdown .datepicker-picker {\n    box-shadow: 0 2px 3px rgba(17, 24, 39, .1), 0 0 0 1px rgba(17, 24, 39, .1)\n}\n\n.datepicker-picker span {\n    display: block;\n    flex: 1;\n    border: 0;\n    border-radius: 4px;\n    cursor: default;\n    text-align: center;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    user-select: none\n}\n\n.datepicker-main {\n    padding: 2px\n}\n\n.datepicker-footer {\n    box-shadow: inset 0 1px 1px rgba(17, 24, 39, .1);\n    background-color: #9ca3af\n}\n\n.datepicker-controls,\n.datepicker-grid,\n.datepicker-view,\n.datepicker-view .days-of-week {\n    display: flex\n}\n\n.datepicker-grid {\n    flex-wrap: wrap\n}\n\n.datepicker-view .days .datepicker-cell,\n.datepicker-view .dow {\n    flex-basis: 14.28571%\n}\n\n.datepicker-view.datepicker-grid .datepicker-cell {\n    flex-basis: 25%\n}\n\n.datepicker-cell,\n.datepicker-view .week {\n    height: 2.25rem;\n    line-height: 2.25rem\n}\n\n.datepicker-title {\n    box-shadow: inset 0 -1px 1px rgba(17, 24, 39, .1);\n    background-color: #9ca3af;\n    padding: .375rem .75rem;\n    text-align: center;\n    font-weight: 700\n}\n\n.datepicker-header .datepicker-controls {\n    padding: 2px 2px 0\n}\n\n.datepicker-controls .button {\n    display: inline-flex;\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    border: 1px solid #808998;\n    border-radius: 4px;\n    box-shadow: none;\n    background-color: #fff;\n    cursor: pointer;\n    padding: calc(.375em - 1px) .75em;\n    height: 2.25em;\n    vertical-align: top;\n    text-align: center;\n    line-height: 1.5;\n    white-space: nowrap;\n    color: #1f2937;\n    font-size: 1rem\n}\n\n.datepicker-controls .button:active,\n.datepicker-controls .button:focus {\n    outline: 0\n}\n\n.datepicker-controls .button:hover {\n    border-color: #5b6371;\n    color: #1f2937\n}\n\n.datepicker-controls .button:focus {\n    border-color: #3273dc;\n    color: #1f2937\n}\n\n.datepicker-controls .button:focus:not(:active) {\n    box-shadow: 0 0 0 .125em rgba(50, 115, 220, .25)\n}\n\n.datepicker-controls .button:active {\n    border-color: #384f80;\n    color: #1f2937\n}\n\n.datepicker-controls .button[disabled] {\n    cursor: not-allowed\n}\n\n.datepicker-header .datepicker-controls .button {\n    border-color: transparent;\n    font-weight: 700\n}\n\n.datepicker-header .datepicker-controls .button:hover {\n    background-color: #f9f9f9\n}\n\n.datepicker-header .datepicker-controls .button:focus:not(:active) {\n    box-shadow: 0 0 0 .125em rgba(255, 255, 255, .25)\n}\n\n.datepicker-header .datepicker-controls .button:active {\n    background-color: #f2f2f2\n}\n\n.datepicker-header .datepicker-controls .button[disabled] {\n    box-shadow: none\n}\n\n.datepicker-footer .datepicker-controls .button {\n    margin: calc(.375rem - 1px) .375rem;\n    border-radius: 2px;\n    width: 100%;\n    font-size: .75rem\n}\n\n.datepicker-controls .view-switch {\n    flex: auto\n}\n\n.datepicker-controls .next-btn,\n.datepicker-controls .prev-btn {\n    padding-right: .375rem;\n    padding-left: .375rem;\n    width: 2.25rem\n}\n\n.datepicker-controls .next-btn.disabled,\n.datepicker-controls .prev-btn.disabled {\n    visibility: hidden\n}\n\n.datepicker-view .dow {\n    height: 1.5rem;\n    line-height: 1.5rem;\n    font-size: .875rem;\n    font-weight: 700\n}\n\n.datepicker-view .week {\n    width: 2.25rem;\n    color: #5b6371;\n    font-size: .75rem\n}\n\n@media (max-width: 22.5rem) {\n    .datepicker-view .week {\n        width: 1.96875rem\n    }\n}\n\n.datepicker-grid {\n    width: 15.75rem\n}\n\n@media (max-width: 22.5rem) {\n    .calendar-weeks + .days .datepicker-grid {\n        width: 13.78125rem\n    }\n}\n\n.datepicker-cell:not(.disabled):hover {\n    background-color: #f9f9f9;\n    cursor: pointer\n}\n\n.datepicker-cell.focused:not(.selected) {\n    background-color: #8e96a4\n}\n\n.datepicker-cell.selected,\n.datepicker-cell.selected:hover {\n    background-color: #3273dc;\n    color: #fff;\n    font-weight: 600\n}\n\n.datepicker-cell.disabled {\n    color: #808998\n}\n\n.datepicker-cell.next:not(.disabled),\n.datepicker-cell.prev:not(.disabled) {\n    color: #7a7a7a\n}\n\n.datepicker-cell.next.selected,\n.datepicker-cell.prev.selected {\n    color: #e6e6e6\n}\n\n.datepicker-cell.highlighted:not(.selected):not(.range):not(.today) {\n    border-radius: 0;\n    background-color: #9ca3af\n}\n\n.datepicker-cell.highlighted:not(.selected):not(.range):not(.today):not(.disabled):hover {\n    background-color: #959ca9\n}\n\n.datepicker-cell.highlighted:not(.selected):not(.range):not(.today).focused {\n    background-color: #8e96a4\n}\n\n.datepicker-cell.today:not(.selected) {\n    background-color: #00d1b2\n}\n\n.datepicker-cell.today:not(.selected):not(.disabled) {\n    color: #fff\n}\n\n.datepicker-cell.today.focused:not(.selected) {\n    background-color: #00c4a7\n}\n\n.datepicker-cell.range-end:not(.selected),\n.datepicker-cell.range-start:not(.selected) {\n    background-color: #5b6371;\n    color: #fff\n}\n\n.datepicker-cell.range-end.focused:not(.selected),\n.datepicker-cell.range-start.focused:not(.selected) {\n    background-color: #555d69\n}\n\n.datepicker-cell.range-start {\n    border-radius: 4px 0 0 4px\n}\n\n.datepicker-cell.range-end {\n    border-radius: 0 4px 4px 0\n}\n\n.datepicker-cell.range {\n    border-radius: 0;\n    background-color: #808998\n}\n\n.datepicker-cell.range:not(.disabled):not(.focused):not(.today):hover {\n    background-color: #798293\n}\n\n.datepicker-cell.range.disabled {\n    color: #666f7f\n}\n\n.datepicker-cell.range.focused {\n    background-color: #727c8d\n}\n\n.datepicker-view.datepicker-grid .datepicker-cell {\n    height: 4.5rem;\n    line-height: 4.5rem\n}\n\n.datepicker-input.in-edit {\n    border-color: #2366d1\n}\n\n.datepicker-input.in-edit:active,\n.datepicker-input.in-edit:focus {\n    box-shadow: 0 0 .25em .25em rgba(35, 102, 209, .2)\n}\n\n:root {\n    --bs-blue: #2361ce;\n    --bs-indigo: #4F46E5;\n    --bs-purple: #7C3AED;\n    --bs-pink: #EF4683;\n    --bs-red: #E11D48;\n    --bs-orange: #FBA918;\n    --bs-yellow: #f3c78e;\n    --bs-green: #10B981;\n    --bs-teal: #1E90FF;\n    --bs-cyan: #63b1bd;\n    --bs-white: #ffffff;\n    --bs-gray: #4B5563;\n    --bs-gray-dark: #1F2937;\n    --bs-primary: #1F2937;\n    --bs-secondary: #f0bc74;\n    --bs-tertiary: #31316A;\n    --bs-success: #10B981;\n    --bs-info: #2361ce;\n    --bs-warning: #FBA918;\n    --bs-danger: #E11D48;\n    --bs-white: #ffffff;\n    --bs-indigo: #4F46E5;\n    --bs-purple: #7C3AED;\n    --bs-yellow-100: #ffeed6;\n    --bs-yellow-200: #f5dbb8;\n    --bs-gray-50: #F9FAFB;\n    --bs-gray-100: #F2F4F6;\n    --bs-gray-200: #E5E7EB;\n    --bs-gray-300: #D1D5DB;\n    --bs-gray-400: #9CA3AF;\n    --bs-gray-500: #6B7280;\n    --bs-gray-600: #4B5563;\n    --bs-gray-700: #374151;\n    --bs-gray-800: #1F2937;\n    --bs-gray-900: #111827;\n    --bs-font-sans-serif: \"Inter\", sans-serif;\n    --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0))\n}\n\n*,\n::after,\n::before {\n    box-sizing: border-box\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    :root {\n        scroll-behavior: smooth\n    }\n}\n\nbody {\n    margin: 0;\n    font-family: var(--bs-font-sans-serif);\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #374151;\n    background-color: #f2f4f6;\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(17, 24, 39, 0)\n}\n\nhr {\n    margin: 1rem 0;\n    color: inherit;\n    background-color: currentColor;\n    border: 0;\n    opacity: .25\n}\n\nhr:not([size]) {\n    height: .0625rem\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: .5rem;\n    font-weight: 500;\n    line-height: 1.3;\n    color: #111827\n}\n\n.h1,\nh1 {\n    font-size: calc(1.375rem + 1.5vw)\n}\n\n@media (min-width: 1200px) {\n\n    .h1,\n    h1 {\n        font-size: 2.5rem\n    }\n}\n\n.h2,\nh2 {\n    font-size: calc(1.325rem + .9vw)\n}\n\n@media (min-width: 1200px) {\n\n    .h2,\n    h2 {\n        font-size: 2rem\n    }\n}\n\n.h3,\nh3 {\n    font-size: calc(1.3rem + .6vw)\n}\n\n@media (min-width: 1200px) {\n\n    .h3,\n    h3 {\n        font-size: 1.75rem\n    }\n}\n\n.h4,\nh4 {\n    font-size: calc(1.275rem + .3vw)\n}\n\n@media (min-width: 1200px) {\n\n    .h4,\n    h4 {\n        font-size: 1.5rem\n    }\n}\n\n.h5,\nh5 {\n    font-size: 1.25rem\n}\n\n.h6,\nh6 {\n    font-size: 1rem\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nabbr[data-bs-original-title],\nabbr[title] {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n    cursor: help;\n    -webkit-text-decoration-skip-ink: none;\n    text-decoration-skip-ink: none\n}\n\naddress {\n    margin-bottom: 1rem;\n    font-style: normal;\n    line-height: inherit\n}\n\nol,\nul {\n    padding-left: 2rem\n}\n\ndl,\nol,\nul {\n    margin-top: 0;\n    margin-bottom: 1rem\n}\n\nol ol,\nol ul,\nul ol,\nul ul {\n    margin-bottom: 0\n}\n\ndt {\n    font-weight: 500\n}\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0\n}\n\nblockquote {\n    margin: 0 0 1rem\n}\n\nb,\nstrong {\n    font-weight: 600\n}\n\n.small,\nsmall {\n    font-size: .875em\n}\n\n.mark,\nmark {\n    padding: .2em;\n    background-color: #fcf8e3\n}\n\nsub,\nsup {\n    position: relative;\n    font-size: .75em;\n    line-height: 0;\n    vertical-align: baseline\n}\n\nsub {\n    bottom: -.25em\n}\n\nsup {\n    top: -.5em\n}\n\na {\n    color: #1f2937;\n    text-decoration: none\n}\n\na:hover {\n    color: #000;\n    text-decoration: none\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n    color: inherit;\n    text-decoration: none\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: var(--bs-font-monospace);\n    font-size: 1em;\n    direction: ltr;\n    unicode-bidi: bidi-override\n}\n\npre {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    font-size: .875em\n}\n\npre code {\n    font-size: inherit;\n    color: inherit;\n    word-break: normal\n}\n\ncode {\n    font-size: .875em;\n    color: #ef4683;\n    word-wrap: break-word\n}\n\na > code {\n    color: inherit\n}\n\nkbd {\n    padding: .2rem .4rem;\n    font-size: .875em;\n    color: #fff;\n    background-color: #111827;\n    border-radius: .35rem\n}\n\nkbd kbd {\n    padding: 0;\n    font-size: 1em;\n    font-weight: 500\n}\n\nfigure {\n    margin: 0 0 1rem\n}\n\nimg,\nsvg {\n    vertical-align: middle\n}\n\ntable {\n    caption-side: bottom;\n    border-collapse: collapse\n}\n\ncaption {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n    color: #58677d;\n    text-align: left\n}\n\nth {\n    text-align: inherit;\n    text-align: -webkit-match-parent\n}\n\ntbody,\ntd,\ntfoot,\nth,\nthead,\ntr {\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0\n}\n\nlabel {\n    display: inline-block\n}\n\nbutton {\n    border-radius: 0\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 0\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\n[role=button] {\n    cursor: pointer\n}\n\nselect {\n    word-wrap: normal\n}\n\nselect:disabled {\n    opacity: 1\n}\n\n[list]::-webkit-calendar-picker-indicator {\n    display: none\n}\n\n[type=button],\n[type=reset],\n[type=submit],\nbutton {\n    -webkit-appearance: button\n}\n\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled),\nbutton:not(:disabled) {\n    cursor: pointer\n}\n\n::-moz-focus-inner {\n    padding: 0;\n    border-style: none\n}\n\ntextarea {\n    resize: vertical\n}\n\nfieldset {\n    min-width: 0;\n    padding: 0;\n    margin: 0;\n    border: 0\n}\n\nlegend {\n    float: left;\n    width: 100%;\n    padding: 0;\n    margin-bottom: .5rem;\n    font-size: calc(1.275rem + .3vw);\n    line-height: inherit\n}\n\n@media (min-width: 1200px) {\n    legend {\n        font-size: 1.5rem\n    }\n}\n\nlegend + * {\n    clear: left\n}\n\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-year-field {\n    padding: 0\n}\n\n::-webkit-inner-spin-button {\n    height: auto\n}\n\n[type=search] {\n    outline-offset: -2px;\n    -webkit-appearance: textfield\n}\n\n::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\n::-webkit-color-swatch-wrapper {\n    padding: 0\n}\n\n::file-selector-button {\n    font: inherit\n}\n\n::-webkit-file-upload-button {\n    font: inherit;\n    -webkit-appearance: button\n}\n\noutput {\n    display: inline-block\n}\n\niframe {\n    border: 0\n}\n\nsummary {\n    display: list-item;\n    cursor: pointer\n}\n\nprogress {\n    vertical-align: baseline\n}\n\n[hidden] {\n    display: none !important\n}\n\n.lead {\n    font-size: 1.25rem;\n    font-weight: 300\n}\n\n.display-1 {\n    font-size: calc(1.625rem + 4.5vw);\n    font-weight: 500;\n    line-height: 1.3\n}\n\n@media (min-width: 1200px) {\n    .display-1 {\n        font-size: 5rem\n    }\n}\n\n.display-2 {\n    font-size: calc(1.475rem + 2.7vw);\n    font-weight: 500;\n    line-height: 1.3\n}\n\n@media (min-width: 1200px) {\n    .display-2 {\n        font-size: 3.5rem\n    }\n}\n\n.display-3 {\n    font-size: calc(1.375rem + 1.5vw);\n    font-weight: 500;\n    line-height: 1.3\n}\n\n@media (min-width: 1200px) {\n    .display-3 {\n        font-size: 2.5rem\n    }\n}\n\n.display-4 {\n    font-size: calc(1.3125rem + .75vw);\n    font-weight: 500;\n    line-height: 1.3\n}\n\n@media (min-width: 1200px) {\n    .display-4 {\n        font-size: 1.875rem\n    }\n}\n\n.display-5 {\n    font-size: 1.2rem;\n    font-weight: 500;\n    line-height: 1.3\n}\n\n.display-6 {\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.3\n}\n\n.list-unstyled {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline {\n    padding-left: 0;\n    list-style: none\n}\n\n.list-inline-item {\n    display: inline-block\n}\n\n.list-inline-item:not(:last-child) {\n    margin-right: .5rem\n}\n\n.initialism {\n    font-size: .875em;\n    text-transform: uppercase\n}\n\n.blockquote {\n    margin-bottom: 1rem;\n    font-size: 1.25rem\n}\n\n.blockquote > :last-child {\n    margin-bottom: 0\n}\n\n.blockquote-footer {\n    margin-top: -1rem;\n    margin-bottom: 1rem;\n    font-size: .875em;\n    color: #4b5563\n}\n\n.blockquote-footer::before {\n    content: \"\\2014\\00A0\"\n}\n\n.img-fluid {\n    max-width: 100%;\n    height: auto\n}\n\n.img-thumbnail {\n    padding: .25rem;\n    background-color: #f2f4f6;\n    border: .0625rem solid #d1d5db;\n    border-radius: .5rem;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    max-width: 100%;\n    height: auto\n}\n\n.figure {\n    display: inline-block\n}\n\n.figure-img {\n    margin-bottom: .5rem;\n    line-height: 1\n}\n\n.figure-caption {\n    font-size: .875em;\n    color: #4b5563\n}\n\n.container,\n.container-fluid,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl {\n    width: 100%;\n    padding-right: var(--bs-gutter-x, 1rem);\n    padding-left: var(--bs-gutter-x, 1rem);\n    margin-right: auto;\n    margin-left: auto\n}\n\n@media (min-width: 576px) {\n\n    .container,\n    .container-sm {\n        max-width: 540px\n    }\n}\n\n@media (min-width: 768px) {\n\n    .container,\n    .container-md,\n    .container-sm {\n        max-width: 720px\n    }\n}\n\n@media (min-width: 992px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm {\n        max-width: 960px\n    }\n}\n\n@media (min-width: 1200px) {\n\n    .container,\n    .container-lg,\n    .container-md,\n    .container-sm,\n    .container-xl {\n        max-width: 1140px\n    }\n}\n\n.row {\n    --bs-gutter-x: 1.5rem;\n    --bs-gutter-y: 0;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: calc(var(--bs-gutter-y) * -1);\n    margin-right: calc(var(--bs-gutter-x) / -2);\n    margin-left: calc(var(--bs-gutter-x) / -2)\n}\n\n.row > * {\n    flex-shrink: 0;\n    width: 100%;\n    max-width: 100%;\n    padding-right: calc(var(--bs-gutter-x) / 2);\n    padding-left: calc(var(--bs-gutter-x) / 2);\n    margin-top: var(--bs-gutter-y)\n}\n\n.col {\n    flex: 1 0 0%\n}\n\n.row-cols-auto > * {\n    flex: 0 0 auto;\n    width: auto\n}\n\n.row-cols-1 > * {\n    flex: 0 0 auto;\n    width: 100%\n}\n\n.row-cols-2 > * {\n    flex: 0 0 auto;\n    width: 50%\n}\n\n.row-cols-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333%\n}\n\n.row-cols-4 > * {\n    flex: 0 0 auto;\n    width: 25%\n}\n\n.row-cols-5 > * {\n    flex: 0 0 auto;\n    width: 20%\n}\n\n.row-cols-6 > * {\n    flex: 0 0 auto;\n    width: 16.66667%\n}\n\n.col-auto {\n    flex: 0 0 auto;\n    width: auto\n}\n\n.col-1 {\n    flex: 0 0 auto;\n    width: 8.33333%\n}\n\n.col-2 {\n    flex: 0 0 auto;\n    width: 16.66667%\n}\n\n.col-3 {\n    flex: 0 0 auto;\n    width: 25%\n}\n\n.col-4 {\n    flex: 0 0 auto;\n    width: 33.33333%\n}\n\n.col-5 {\n    flex: 0 0 auto;\n    width: 41.66667%\n}\n\n.col-6 {\n    flex: 0 0 auto;\n    width: 50%\n}\n\n.col-7 {\n    flex: 0 0 auto;\n    width: 58.33333%\n}\n\n.col-8 {\n    flex: 0 0 auto;\n    width: 66.66667%\n}\n\n.col-9 {\n    flex: 0 0 auto;\n    width: 75%\n}\n\n.col-10 {\n    flex: 0 0 auto;\n    width: 83.33333%\n}\n\n.col-11 {\n    flex: 0 0 auto;\n    width: 91.66667%\n}\n\n.col-12 {\n    flex: 0 0 auto;\n    width: 100%\n}\n\n.offset-1 {\n    margin-left: 8.33333%\n}\n\n.offset-2 {\n    margin-left: 16.66667%\n}\n\n.offset-3 {\n    margin-left: 25%\n}\n\n.offset-4 {\n    margin-left: 33.33333%\n}\n\n.offset-5 {\n    margin-left: 41.66667%\n}\n\n.offset-6 {\n    margin-left: 50%\n}\n\n.offset-7 {\n    margin-left: 58.33333%\n}\n\n.offset-8 {\n    margin-left: 66.66667%\n}\n\n.offset-9 {\n    margin-left: 75%\n}\n\n.offset-10 {\n    margin-left: 83.33333%\n}\n\n.offset-11 {\n    margin-left: 91.66667%\n}\n\n.g-0,\n.gx-0 {\n    --bs-gutter-x: 0\n}\n\n.g-0,\n.gy-0 {\n    --bs-gutter-y: 0\n}\n\n.g-1,\n.gx-1 {\n    --bs-gutter-x: 0.25rem\n}\n\n.g-1,\n.gy-1 {\n    --bs-gutter-y: 0.25rem\n}\n\n.g-2,\n.gx-2 {\n    --bs-gutter-x: 0.5rem\n}\n\n.g-2,\n.gy-2 {\n    --bs-gutter-y: 0.5rem\n}\n\n.g-3,\n.gx-3 {\n    --bs-gutter-x: 1rem\n}\n\n.g-3,\n.gy-3 {\n    --bs-gutter-y: 1rem\n}\n\n.g-4,\n.gx-4 {\n    --bs-gutter-x: 1.5rem\n}\n\n.g-4,\n.gy-4 {\n    --bs-gutter-y: 1.5rem\n}\n\n.g-5,\n.gx-5 {\n    --bs-gutter-x: 3rem\n}\n\n.g-5,\n.gy-5 {\n    --bs-gutter-y: 3rem\n}\n\n.g-6,\n.gx-6 {\n    --bs-gutter-x: 5rem\n}\n\n.g-6,\n.gy-6 {\n    --bs-gutter-y: 5rem\n}\n\n.g-7,\n.gx-7 {\n    --bs-gutter-x: 8rem\n}\n\n.g-7,\n.gy-7 {\n    --bs-gutter-y: 8rem\n}\n\n.g-8,\n.gx-8 {\n    --bs-gutter-x: 10rem\n}\n\n.g-8,\n.gy-8 {\n    --bs-gutter-y: 10rem\n}\n\n.g-9,\n.gx-9 {\n    --bs-gutter-x: 11rem\n}\n\n.g-9,\n.gy-9 {\n    --bs-gutter-y: 11rem\n}\n\n.g-10,\n.gx-10 {\n    --bs-gutter-x: 14rem\n}\n\n.g-10,\n.gy-10 {\n    --bs-gutter-y: 14rem\n}\n\n.g-11,\n.gx-11 {\n    --bs-gutter-x: 16rem\n}\n\n.g-11,\n.gy-11 {\n    --bs-gutter-y: 16rem\n}\n\n.g-12,\n.gx-12 {\n    --bs-gutter-x: 20rem\n}\n\n.g-12,\n.gy-12 {\n    --bs-gutter-y: 20rem\n}\n\n.g-sm,\n.gx-sm {\n    --bs-gutter-x: 1rem\n}\n\n.g-sm,\n.gy-sm {\n    --bs-gutter-y: 1rem\n}\n\n.g-md,\n.gx-md {\n    --bs-gutter-x: 2rem\n}\n\n.g-md,\n.gy-md {\n    --bs-gutter-y: 2rem\n}\n\n.g-lg,\n.gx-lg {\n    --bs-gutter-x: 4rem\n}\n\n.g-lg,\n.gy-lg {\n    --bs-gutter-y: 4rem\n}\n\n.g-xl,\n.gx-xl {\n    --bs-gutter-x: 8rem\n}\n\n.g-xl,\n.gy-xl {\n    --bs-gutter-y: 8rem\n}\n\n@media (min-width: 576px) {\n    .col-sm {\n        flex: 1 0 0%\n    }\n\n    .row-cols-sm-auto > * {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-sm-1 > * {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-sm-2 > * {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-sm-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .row-cols-sm-4 > * {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-sm-5 > * {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-sm-6 > * {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-sm-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-sm-1 {\n        flex: 0 0 auto;\n        width: 8.33333%\n    }\n\n    .col-sm-2 {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-sm-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-sm-4 {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .col-sm-5 {\n        flex: 0 0 auto;\n        width: 41.66667%\n    }\n\n    .col-sm-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-sm-7 {\n        flex: 0 0 auto;\n        width: 58.33333%\n    }\n\n    .col-sm-8 {\n        flex: 0 0 auto;\n        width: 66.66667%\n    }\n\n    .col-sm-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-sm-10 {\n        flex: 0 0 auto;\n        width: 83.33333%\n    }\n\n    .col-sm-11 {\n        flex: 0 0 auto;\n        width: 91.66667%\n    }\n\n    .col-sm-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-sm-0 {\n        margin-left: 0\n    }\n\n    .offset-sm-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-sm-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-sm-3 {\n        margin-left: 25%\n    }\n\n    .offset-sm-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-sm-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-sm-6 {\n        margin-left: 50%\n    }\n\n    .offset-sm-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-sm-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-sm-9 {\n        margin-left: 75%\n    }\n\n    .offset-sm-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-sm-11 {\n        margin-left: 91.66667%\n    }\n\n    .g-sm-0,\n    .gx-sm-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-sm-0,\n    .gy-sm-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-sm-1,\n    .gx-sm-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-sm-1,\n    .gy-sm-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-sm-2,\n    .gx-sm-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-sm-2,\n    .gy-sm-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-sm-3,\n    .gx-sm-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-sm-3,\n    .gy-sm-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-sm-4,\n    .gx-sm-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-sm-4,\n    .gy-sm-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-sm-5,\n    .gx-sm-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-sm-5,\n    .gy-sm-5 {\n        --bs-gutter-y: 3rem\n    }\n\n    .g-sm-6,\n    .gx-sm-6 {\n        --bs-gutter-x: 5rem\n    }\n\n    .g-sm-6,\n    .gy-sm-6 {\n        --bs-gutter-y: 5rem\n    }\n\n    .g-sm-7,\n    .gx-sm-7 {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-sm-7,\n    .gy-sm-7 {\n        --bs-gutter-y: 8rem\n    }\n\n    .g-sm-8,\n    .gx-sm-8 {\n        --bs-gutter-x: 10rem\n    }\n\n    .g-sm-8,\n    .gy-sm-8 {\n        --bs-gutter-y: 10rem\n    }\n\n    .g-sm-9,\n    .gx-sm-9 {\n        --bs-gutter-x: 11rem\n    }\n\n    .g-sm-9,\n    .gy-sm-9 {\n        --bs-gutter-y: 11rem\n    }\n\n    .g-sm-10,\n    .gx-sm-10 {\n        --bs-gutter-x: 14rem\n    }\n\n    .g-sm-10,\n    .gy-sm-10 {\n        --bs-gutter-y: 14rem\n    }\n\n    .g-sm-11,\n    .gx-sm-11 {\n        --bs-gutter-x: 16rem\n    }\n\n    .g-sm-11,\n    .gy-sm-11 {\n        --bs-gutter-y: 16rem\n    }\n\n    .g-sm-12,\n    .gx-sm-12 {\n        --bs-gutter-x: 20rem\n    }\n\n    .g-sm-12,\n    .gy-sm-12 {\n        --bs-gutter-y: 20rem\n    }\n\n    .g-sm-sm,\n    .gx-sm-sm {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-sm-sm,\n    .gy-sm-sm {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-sm-md,\n    .gx-sm-md {\n        --bs-gutter-x: 2rem\n    }\n\n    .g-sm-md,\n    .gy-sm-md {\n        --bs-gutter-y: 2rem\n    }\n\n    .g-sm-lg,\n    .gx-sm-lg {\n        --bs-gutter-x: 4rem\n    }\n\n    .g-sm-lg,\n    .gy-sm-lg {\n        --bs-gutter-y: 4rem\n    }\n\n    .g-sm-xl,\n    .gx-sm-xl {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-sm-xl,\n    .gy-sm-xl {\n        --bs-gutter-y: 8rem\n    }\n}\n\n@media (min-width: 768px) {\n    .col-md {\n        flex: 1 0 0%\n    }\n\n    .row-cols-md-auto > * {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-md-1 > * {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-md-2 > * {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-md-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .row-cols-md-4 > * {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-md-5 > * {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-md-6 > * {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-md-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-md-1 {\n        flex: 0 0 auto;\n        width: 8.33333%\n    }\n\n    .col-md-2 {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-md-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-md-4 {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .col-md-5 {\n        flex: 0 0 auto;\n        width: 41.66667%\n    }\n\n    .col-md-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-md-7 {\n        flex: 0 0 auto;\n        width: 58.33333%\n    }\n\n    .col-md-8 {\n        flex: 0 0 auto;\n        width: 66.66667%\n    }\n\n    .col-md-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-md-10 {\n        flex: 0 0 auto;\n        width: 83.33333%\n    }\n\n    .col-md-11 {\n        flex: 0 0 auto;\n        width: 91.66667%\n    }\n\n    .col-md-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-md-0 {\n        margin-left: 0\n    }\n\n    .offset-md-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-md-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-md-3 {\n        margin-left: 25%\n    }\n\n    .offset-md-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-md-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-md-6 {\n        margin-left: 50%\n    }\n\n    .offset-md-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-md-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-md-9 {\n        margin-left: 75%\n    }\n\n    .offset-md-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-md-11 {\n        margin-left: 91.66667%\n    }\n\n    .g-md-0,\n    .gx-md-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-md-0,\n    .gy-md-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-md-1,\n    .gx-md-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-md-1,\n    .gy-md-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-md-2,\n    .gx-md-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-md-2,\n    .gy-md-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-md-3,\n    .gx-md-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-md-3,\n    .gy-md-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-md-4,\n    .gx-md-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-md-4,\n    .gy-md-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-md-5,\n    .gx-md-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-md-5,\n    .gy-md-5 {\n        --bs-gutter-y: 3rem\n    }\n\n    .g-md-6,\n    .gx-md-6 {\n        --bs-gutter-x: 5rem\n    }\n\n    .g-md-6,\n    .gy-md-6 {\n        --bs-gutter-y: 5rem\n    }\n\n    .g-md-7,\n    .gx-md-7 {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-md-7,\n    .gy-md-7 {\n        --bs-gutter-y: 8rem\n    }\n\n    .g-md-8,\n    .gx-md-8 {\n        --bs-gutter-x: 10rem\n    }\n\n    .g-md-8,\n    .gy-md-8 {\n        --bs-gutter-y: 10rem\n    }\n\n    .g-md-9,\n    .gx-md-9 {\n        --bs-gutter-x: 11rem\n    }\n\n    .g-md-9,\n    .gy-md-9 {\n        --bs-gutter-y: 11rem\n    }\n\n    .g-md-10,\n    .gx-md-10 {\n        --bs-gutter-x: 14rem\n    }\n\n    .g-md-10,\n    .gy-md-10 {\n        --bs-gutter-y: 14rem\n    }\n\n    .g-md-11,\n    .gx-md-11 {\n        --bs-gutter-x: 16rem\n    }\n\n    .g-md-11,\n    .gy-md-11 {\n        --bs-gutter-y: 16rem\n    }\n\n    .g-md-12,\n    .gx-md-12 {\n        --bs-gutter-x: 20rem\n    }\n\n    .g-md-12,\n    .gy-md-12 {\n        --bs-gutter-y: 20rem\n    }\n\n    .g-md-sm,\n    .gx-md-sm {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-md-sm,\n    .gy-md-sm {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-md-md,\n    .gx-md-md {\n        --bs-gutter-x: 2rem\n    }\n\n    .g-md-md,\n    .gy-md-md {\n        --bs-gutter-y: 2rem\n    }\n\n    .g-md-lg,\n    .gx-md-lg {\n        --bs-gutter-x: 4rem\n    }\n\n    .g-md-lg,\n    .gy-md-lg {\n        --bs-gutter-y: 4rem\n    }\n\n    .g-md-xl,\n    .gx-md-xl {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-md-xl,\n    .gy-md-xl {\n        --bs-gutter-y: 8rem\n    }\n}\n\n@media (min-width: 992px) {\n    .col-lg {\n        flex: 1 0 0%\n    }\n\n    .row-cols-lg-auto > * {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-lg-1 > * {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-lg-2 > * {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-lg-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .row-cols-lg-4 > * {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-lg-5 > * {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-lg-6 > * {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-lg-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-lg-1 {\n        flex: 0 0 auto;\n        width: 8.33333%\n    }\n\n    .col-lg-2 {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-lg-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-lg-4 {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .col-lg-5 {\n        flex: 0 0 auto;\n        width: 41.66667%\n    }\n\n    .col-lg-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-lg-7 {\n        flex: 0 0 auto;\n        width: 58.33333%\n    }\n\n    .col-lg-8 {\n        flex: 0 0 auto;\n        width: 66.66667%\n    }\n\n    .col-lg-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-lg-10 {\n        flex: 0 0 auto;\n        width: 83.33333%\n    }\n\n    .col-lg-11 {\n        flex: 0 0 auto;\n        width: 91.66667%\n    }\n\n    .col-lg-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-lg-0 {\n        margin-left: 0\n    }\n\n    .offset-lg-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-lg-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-lg-3 {\n        margin-left: 25%\n    }\n\n    .offset-lg-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-lg-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-lg-6 {\n        margin-left: 50%\n    }\n\n    .offset-lg-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-lg-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-lg-9 {\n        margin-left: 75%\n    }\n\n    .offset-lg-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-lg-11 {\n        margin-left: 91.66667%\n    }\n\n    .g-lg-0,\n    .gx-lg-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-lg-0,\n    .gy-lg-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-lg-1,\n    .gx-lg-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-lg-1,\n    .gy-lg-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-lg-2,\n    .gx-lg-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-lg-2,\n    .gy-lg-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-lg-3,\n    .gx-lg-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-lg-3,\n    .gy-lg-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-lg-4,\n    .gx-lg-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-lg-4,\n    .gy-lg-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-lg-5,\n    .gx-lg-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-lg-5,\n    .gy-lg-5 {\n        --bs-gutter-y: 3rem\n    }\n\n    .g-lg-6,\n    .gx-lg-6 {\n        --bs-gutter-x: 5rem\n    }\n\n    .g-lg-6,\n    .gy-lg-6 {\n        --bs-gutter-y: 5rem\n    }\n\n    .g-lg-7,\n    .gx-lg-7 {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-lg-7,\n    .gy-lg-7 {\n        --bs-gutter-y: 8rem\n    }\n\n    .g-lg-8,\n    .gx-lg-8 {\n        --bs-gutter-x: 10rem\n    }\n\n    .g-lg-8,\n    .gy-lg-8 {\n        --bs-gutter-y: 10rem\n    }\n\n    .g-lg-9,\n    .gx-lg-9 {\n        --bs-gutter-x: 11rem\n    }\n\n    .g-lg-9,\n    .gy-lg-9 {\n        --bs-gutter-y: 11rem\n    }\n\n    .g-lg-10,\n    .gx-lg-10 {\n        --bs-gutter-x: 14rem\n    }\n\n    .g-lg-10,\n    .gy-lg-10 {\n        --bs-gutter-y: 14rem\n    }\n\n    .g-lg-11,\n    .gx-lg-11 {\n        --bs-gutter-x: 16rem\n    }\n\n    .g-lg-11,\n    .gy-lg-11 {\n        --bs-gutter-y: 16rem\n    }\n\n    .g-lg-12,\n    .gx-lg-12 {\n        --bs-gutter-x: 20rem\n    }\n\n    .g-lg-12,\n    .gy-lg-12 {\n        --bs-gutter-y: 20rem\n    }\n\n    .g-lg-sm,\n    .gx-lg-sm {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-lg-sm,\n    .gy-lg-sm {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-lg-md,\n    .gx-lg-md {\n        --bs-gutter-x: 2rem\n    }\n\n    .g-lg-md,\n    .gy-lg-md {\n        --bs-gutter-y: 2rem\n    }\n\n    .g-lg-lg,\n    .gx-lg-lg {\n        --bs-gutter-x: 4rem\n    }\n\n    .g-lg-lg,\n    .gy-lg-lg {\n        --bs-gutter-y: 4rem\n    }\n\n    .g-lg-xl,\n    .gx-lg-xl {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-lg-xl,\n    .gy-lg-xl {\n        --bs-gutter-y: 8rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .col-xl {\n        flex: 1 0 0%\n    }\n\n    .row-cols-xl-auto > * {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-xl-1 > * {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-xl-2 > * {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-xl-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .row-cols-xl-4 > * {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-xl-5 > * {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-xl-6 > * {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-xl-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-xl-1 {\n        flex: 0 0 auto;\n        width: 8.33333%\n    }\n\n    .col-xl-2 {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-xl-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-xl-4 {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .col-xl-5 {\n        flex: 0 0 auto;\n        width: 41.66667%\n    }\n\n    .col-xl-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-xl-7 {\n        flex: 0 0 auto;\n        width: 58.33333%\n    }\n\n    .col-xl-8 {\n        flex: 0 0 auto;\n        width: 66.66667%\n    }\n\n    .col-xl-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-xl-10 {\n        flex: 0 0 auto;\n        width: 83.33333%\n    }\n\n    .col-xl-11 {\n        flex: 0 0 auto;\n        width: 91.66667%\n    }\n\n    .col-xl-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-xl-0 {\n        margin-left: 0\n    }\n\n    .offset-xl-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-xl-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-xl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xl-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-xl-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-xl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xl-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-xl-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-xl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xl-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-xl-11 {\n        margin-left: 91.66667%\n    }\n\n    .g-xl-0,\n    .gx-xl-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-xl-0,\n    .gy-xl-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-xl-1,\n    .gx-xl-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-xl-1,\n    .gy-xl-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-xl-2,\n    .gx-xl-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-xl-2,\n    .gy-xl-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-xl-3,\n    .gx-xl-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xl-3,\n    .gy-xl-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xl-4,\n    .gx-xl-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-xl-4,\n    .gy-xl-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-xl-5,\n    .gx-xl-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-xl-5,\n    .gy-xl-5 {\n        --bs-gutter-y: 3rem\n    }\n\n    .g-xl-6,\n    .gx-xl-6 {\n        --bs-gutter-x: 5rem\n    }\n\n    .g-xl-6,\n    .gy-xl-6 {\n        --bs-gutter-y: 5rem\n    }\n\n    .g-xl-7,\n    .gx-xl-7 {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-xl-7,\n    .gy-xl-7 {\n        --bs-gutter-y: 8rem\n    }\n\n    .g-xl-8,\n    .gx-xl-8 {\n        --bs-gutter-x: 10rem\n    }\n\n    .g-xl-8,\n    .gy-xl-8 {\n        --bs-gutter-y: 10rem\n    }\n\n    .g-xl-9,\n    .gx-xl-9 {\n        --bs-gutter-x: 11rem\n    }\n\n    .g-xl-9,\n    .gy-xl-9 {\n        --bs-gutter-y: 11rem\n    }\n\n    .g-xl-10,\n    .gx-xl-10 {\n        --bs-gutter-x: 14rem\n    }\n\n    .g-xl-10,\n    .gy-xl-10 {\n        --bs-gutter-y: 14rem\n    }\n\n    .g-xl-11,\n    .gx-xl-11 {\n        --bs-gutter-x: 16rem\n    }\n\n    .g-xl-11,\n    .gy-xl-11 {\n        --bs-gutter-y: 16rem\n    }\n\n    .g-xl-12,\n    .gx-xl-12 {\n        --bs-gutter-x: 20rem\n    }\n\n    .g-xl-12,\n    .gy-xl-12 {\n        --bs-gutter-y: 20rem\n    }\n\n    .g-xl-sm,\n    .gx-xl-sm {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xl-sm,\n    .gy-xl-sm {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xl-md,\n    .gx-xl-md {\n        --bs-gutter-x: 2rem\n    }\n\n    .g-xl-md,\n    .gy-xl-md {\n        --bs-gutter-y: 2rem\n    }\n\n    .g-xl-lg,\n    .gx-xl-lg {\n        --bs-gutter-x: 4rem\n    }\n\n    .g-xl-lg,\n    .gy-xl-lg {\n        --bs-gutter-y: 4rem\n    }\n\n    .g-xl-xl,\n    .gx-xl-xl {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-xl-xl,\n    .gy-xl-xl {\n        --bs-gutter-y: 8rem\n    }\n}\n\n@media (min-width: 1400px) {\n    .col-xxl {\n        flex: 1 0 0%\n    }\n\n    .row-cols-xxl-auto > * {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .row-cols-xxl-1 > * {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .row-cols-xxl-2 > * {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .row-cols-xxl-3 > * {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .row-cols-xxl-4 > * {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .row-cols-xxl-5 > * {\n        flex: 0 0 auto;\n        width: 20%\n    }\n\n    .row-cols-xxl-6 > * {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-xxl-auto {\n        flex: 0 0 auto;\n        width: auto\n    }\n\n    .col-xxl-1 {\n        flex: 0 0 auto;\n        width: 8.33333%\n    }\n\n    .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 16.66667%\n    }\n\n    .col-xxl-3 {\n        flex: 0 0 auto;\n        width: 25%\n    }\n\n    .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 33.33333%\n    }\n\n    .col-xxl-5 {\n        flex: 0 0 auto;\n        width: 41.66667%\n    }\n\n    .col-xxl-6 {\n        flex: 0 0 auto;\n        width: 50%\n    }\n\n    .col-xxl-7 {\n        flex: 0 0 auto;\n        width: 58.33333%\n    }\n\n    .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 66.66667%\n    }\n\n    .col-xxl-9 {\n        flex: 0 0 auto;\n        width: 75%\n    }\n\n    .col-xxl-10 {\n        flex: 0 0 auto;\n        width: 83.33333%\n    }\n\n    .col-xxl-11 {\n        flex: 0 0 auto;\n        width: 91.66667%\n    }\n\n    .col-xxl-12 {\n        flex: 0 0 auto;\n        width: 100%\n    }\n\n    .offset-xxl-0 {\n        margin-left: 0\n    }\n\n    .offset-xxl-1 {\n        margin-left: 8.33333%\n    }\n\n    .offset-xxl-2 {\n        margin-left: 16.66667%\n    }\n\n    .offset-xxl-3 {\n        margin-left: 25%\n    }\n\n    .offset-xxl-4 {\n        margin-left: 33.33333%\n    }\n\n    .offset-xxl-5 {\n        margin-left: 41.66667%\n    }\n\n    .offset-xxl-6 {\n        margin-left: 50%\n    }\n\n    .offset-xxl-7 {\n        margin-left: 58.33333%\n    }\n\n    .offset-xxl-8 {\n        margin-left: 66.66667%\n    }\n\n    .offset-xxl-9 {\n        margin-left: 75%\n    }\n\n    .offset-xxl-10 {\n        margin-left: 83.33333%\n    }\n\n    .offset-xxl-11 {\n        margin-left: 91.66667%\n    }\n\n    .g-xxl-0,\n    .gx-xxl-0 {\n        --bs-gutter-x: 0\n    }\n\n    .g-xxl-0,\n    .gy-xxl-0 {\n        --bs-gutter-y: 0\n    }\n\n    .g-xxl-1,\n    .gx-xxl-1 {\n        --bs-gutter-x: 0.25rem\n    }\n\n    .g-xxl-1,\n    .gy-xxl-1 {\n        --bs-gutter-y: 0.25rem\n    }\n\n    .g-xxl-2,\n    .gx-xxl-2 {\n        --bs-gutter-x: 0.5rem\n    }\n\n    .g-xxl-2,\n    .gy-xxl-2 {\n        --bs-gutter-y: 0.5rem\n    }\n\n    .g-xxl-3,\n    .gx-xxl-3 {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xxl-3,\n    .gy-xxl-3 {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xxl-4,\n    .gx-xxl-4 {\n        --bs-gutter-x: 1.5rem\n    }\n\n    .g-xxl-4,\n    .gy-xxl-4 {\n        --bs-gutter-y: 1.5rem\n    }\n\n    .g-xxl-5,\n    .gx-xxl-5 {\n        --bs-gutter-x: 3rem\n    }\n\n    .g-xxl-5,\n    .gy-xxl-5 {\n        --bs-gutter-y: 3rem\n    }\n\n    .g-xxl-6,\n    .gx-xxl-6 {\n        --bs-gutter-x: 5rem\n    }\n\n    .g-xxl-6,\n    .gy-xxl-6 {\n        --bs-gutter-y: 5rem\n    }\n\n    .g-xxl-7,\n    .gx-xxl-7 {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-xxl-7,\n    .gy-xxl-7 {\n        --bs-gutter-y: 8rem\n    }\n\n    .g-xxl-8,\n    .gx-xxl-8 {\n        --bs-gutter-x: 10rem\n    }\n\n    .g-xxl-8,\n    .gy-xxl-8 {\n        --bs-gutter-y: 10rem\n    }\n\n    .g-xxl-9,\n    .gx-xxl-9 {\n        --bs-gutter-x: 11rem\n    }\n\n    .g-xxl-9,\n    .gy-xxl-9 {\n        --bs-gutter-y: 11rem\n    }\n\n    .g-xxl-10,\n    .gx-xxl-10 {\n        --bs-gutter-x: 14rem\n    }\n\n    .g-xxl-10,\n    .gy-xxl-10 {\n        --bs-gutter-y: 14rem\n    }\n\n    .g-xxl-11,\n    .gx-xxl-11 {\n        --bs-gutter-x: 16rem\n    }\n\n    .g-xxl-11,\n    .gy-xxl-11 {\n        --bs-gutter-y: 16rem\n    }\n\n    .g-xxl-12,\n    .gx-xxl-12 {\n        --bs-gutter-x: 20rem\n    }\n\n    .g-xxl-12,\n    .gy-xxl-12 {\n        --bs-gutter-y: 20rem\n    }\n\n    .g-xxl-sm,\n    .gx-xxl-sm {\n        --bs-gutter-x: 1rem\n    }\n\n    .g-xxl-sm,\n    .gy-xxl-sm {\n        --bs-gutter-y: 1rem\n    }\n\n    .g-xxl-md,\n    .gx-xxl-md {\n        --bs-gutter-x: 2rem\n    }\n\n    .g-xxl-md,\n    .gy-xxl-md {\n        --bs-gutter-y: 2rem\n    }\n\n    .g-xxl-lg,\n    .gx-xxl-lg {\n        --bs-gutter-x: 4rem\n    }\n\n    .g-xxl-lg,\n    .gy-xxl-lg {\n        --bs-gutter-y: 4rem\n    }\n\n    .g-xxl-xl,\n    .gx-xxl-xl {\n        --bs-gutter-x: 8rem\n    }\n\n    .g-xxl-xl,\n    .gy-xxl-xl {\n        --bs-gutter-y: 8rem\n    }\n}\n\n.table {\n    --bs-table-bg: transparent;\n    --bs-table-accent-bg: transparent;\n    --bs-table-striped-color: #374151;\n    --bs-table-striped-bg: rgba(17, 24, 39, 0.05);\n    --bs-table-active-color: #374151;\n    --bs-table-active-bg: rgba(17, 24, 39, 0.1);\n    --bs-table-hover-color: #374151;\n    --bs-table-hover-bg: rgba(17, 24, 39, 0.075);\n    width: 100%;\n    margin-bottom: 1rem;\n    color: #374151;\n    vertical-align: top;\n    border-color: #e5e7eb\n}\n\n.table > :not(caption) > * > * {\n    padding: .75rem .5rem;\n    background-color: var(--bs-table-bg);\n    border-bottom-width: .0625rem;\n    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg)\n}\n\n.table > tbody {\n    vertical-align: inherit\n}\n\n.table > thead {\n    vertical-align: bottom\n}\n\n.table > :not(:last-child) > :last-child > * {\n    border-bottom-color: currentColor\n}\n\n.caption-top {\n    caption-side: top\n}\n\n.table-sm > :not(caption) > * > * {\n    padding: .25rem .25rem\n}\n\n.table-bordered > :not(caption) > * {\n    border-width: .0625rem 0\n}\n\n.table-bordered > :not(caption) > * > * {\n    border-width: 0 .0625rem\n}\n\n.table-borderless > :not(caption) > * > * {\n    border-bottom-width: 0\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) {\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\n    color: var(--bs-table-striped-color)\n}\n\n.table-active {\n    --bs-table-accent-bg: var(--bs-table-active-bg);\n    color: var(--bs-table-active-color)\n}\n\n.table-hover > tbody > tr:hover {\n    --bs-table-accent-bg: var(--bs-table-hover-bg);\n    color: var(--bs-table-hover-color)\n}\n\n.table-primary {\n    --bs-table-bg: #d2d4d7;\n    --bs-table-striped-bg: #c9cbcf;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #c0c3c7;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #c5c7cb;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #c0c3c7\n}\n\n.table-secondary {\n    --bs-table-bg: #fcf2e3;\n    --bs-table-striped-bg: #f1e8da;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #e6ded2;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #ebe3d6;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #e6ded2\n}\n\n.table-success {\n    --bs-table-bg: #cff1e6;\n    --bs-table-striped-bg: #c6e7dd;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #bdddd5;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #c2e2d9;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #bdddd5\n}\n\n.table-info {\n    --bs-table-bg: #d3dff5;\n    --bs-table-striped-bg: #cad6ec;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #c1cde2;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #c6d1e7;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #c1cde2\n}\n\n.table-warning {\n    --bs-table-bg: #feeed1;\n    --bs-table-striped-bg: #f3e4c9;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #e8dac2;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #eddfc5;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #e8dac2\n}\n\n.table-danger {\n    --bs-table-bg: #f9d2da;\n    --bs-table-striped-bg: #eecad2;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #e3c1ca;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #e9c5ce;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #e3c1ca\n}\n\n.table-light {\n    --bs-table-bg: #9CA3AF;\n    --bs-table-striped-bg: #969da9;\n    --bs-table-striped-color: #1F2937;\n    --bs-table-active-bg: #9097a3;\n    --bs-table-active-color: #1F2937;\n    --bs-table-hover-bg: #939aa6;\n    --bs-table-hover-color: #1F2937;\n    color: #1f2937;\n    border-color: #9097a3\n}\n\n.table-dark {\n    --bs-table-bg: #1F2937;\n    --bs-table-striped-bg: #2a3441;\n    --bs-table-striped-color: #ffffff;\n    --bs-table-active-bg: #353e4b;\n    --bs-table-active-color: #ffffff;\n    --bs-table-hover-bg: #303946;\n    --bs-table-hover-color: #ffffff;\n    color: #fff;\n    border-color: #353e4b\n}\n\n.table-responsive {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch\n}\n\n@media (max-width: 575.98px) {\n    .table-responsive-sm {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media (max-width: 767.98px) {\n    .table-responsive-md {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media (max-width: 991.98px) {\n    .table-responsive-lg {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .table-responsive-xl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .table-responsive-xxl {\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch\n    }\n}\n\n.form-label {\n    margin-bottom: .5rem\n}\n\n.col-form-label {\n    padding-top: .5625rem;\n    padding-bottom: .5625rem;\n    margin-bottom: 0;\n    font-size: inherit;\n    line-height: 1.5\n}\n\n.col-form-label-lg {\n    padding-top: .5625rem;\n    padding-bottom: .5625rem;\n    font-size: 1.25rem\n}\n\n.col-form-label-sm {\n    padding-top: .4375rem;\n    padding-bottom: .4375rem;\n    font-size: .875rem\n}\n\n.form-text {\n    margin-top: .25rem;\n    font-size: .875em;\n    color: #58677d\n}\n\n.form-control {\n    display: block;\n    width: 100%;\n    padding: .5rem 1rem;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6b7280;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: .0625rem solid #d1d5db;\n    -webkit-appearance: none;\n    appearance: none;\n    border-radius: .5rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-control {\n        transition: none\n    }\n}\n\n.form-control[type=file] {\n    overflow: hidden\n}\n\n.form-control[type=file]:not(:disabled):not([readonly]) {\n    cursor: pointer\n}\n\n.form-control:focus {\n    color: #6b7280;\n    background-color: #fff;\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07), 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.form-control::-webkit-date-and-time-value {\n    height: 1.5em\n}\n\n.form-control::placeholder {\n    color: #4b5563;\n    opacity: 1\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n    background-color: #e5e7eb;\n    opacity: 1\n}\n\n.form-control::file-selector-button {\n    padding: .5rem 1rem;\n    margin: -.5rem -1rem;\n    -webkit-margin-end: 1rem;\n    margin-inline-end: 1rem;\n    color: #6b7280;\n    background-color: #fff;\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: .0625rem;\n    border-radius: 0;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-control::file-selector-button {\n        transition: none\n    }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: #f2f2f2\n}\n\n.form-control::-webkit-file-upload-button {\n    padding: .5rem 1rem;\n    margin: -.5rem -1rem;\n    -webkit-margin-end: 1rem;\n    margin-inline-end: 1rem;\n    color: #6b7280;\n    background-color: #fff;\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: .0625rem;\n    border-radius: 0;\n    -webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-control::-webkit-file-upload-button {\n        -webkit-transition: none;\n        transition: none\n    }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: #f2f2f2\n}\n\n.form-control-plaintext {\n    display: block;\n    width: 100%;\n    padding: .5rem 0;\n    margin-bottom: 0;\n    line-height: 1.5;\n    color: #374151;\n    background-color: transparent;\n    border: solid transparent;\n    border-width: .0625rem 0\n}\n\n.form-control-plaintext.form-control-lg,\n.form-control-plaintext.form-control-sm {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.form-control-sm {\n    min-height: calc(1.5em + .875rem);\n    padding: .375rem .625rem;\n    font-size: .875rem;\n    border-radius: .5rem\n}\n\n.form-control-sm::file-selector-button {\n    padding: .375rem .625rem;\n    margin: -.375rem -.625rem;\n    -webkit-margin-end: .625rem;\n    margin-inline-end: .625rem\n}\n\n.form-control-sm::-webkit-file-upload-button {\n    padding: .375rem .625rem;\n    margin: -.375rem -.625rem;\n    -webkit-margin-end: .625rem;\n    margin-inline-end: .625rem\n}\n\n.form-control-lg {\n    min-height: calc(1.5em + 1.125rem);\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: .5rem\n}\n\n.form-control-lg::file-selector-button {\n    padding: .5rem 1rem;\n    margin: -.5rem -1rem;\n    -webkit-margin-end: 1rem;\n    margin-inline-end: 1rem\n}\n\n.form-control-lg::-webkit-file-upload-button {\n    padding: .5rem 1rem;\n    margin: -.5rem -1rem;\n    -webkit-margin-end: 1rem;\n    margin-inline-end: 1rem\n}\n\ntextarea.form-control {\n    min-height: calc(1.5em + 1.125rem)\n}\n\ntextarea.form-control-sm {\n    min-height: calc(1.5em + .875rem)\n}\n\ntextarea.form-control-lg {\n    min-height: calc(1.5em + 1.125rem)\n}\n\n.form-control-color {\n    max-width: 3rem;\n    height: auto;\n    padding: .5rem\n}\n\n.form-control-color:not(:disabled):not([readonly]) {\n    cursor: pointer\n}\n\n.form-control-color::-moz-color-swatch {\n    height: 1.5em;\n    border-radius: .5rem\n}\n\n.form-control-color::-webkit-color-swatch {\n    height: 1.5em;\n    border-radius: .5rem\n}\n\n.form-select {\n    display: block;\n    width: 100%;\n    padding: .5rem 1rem .5rem 1rem;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6b7280;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231F2937' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 1rem center;\n    background-size: 16px 12px;\n    border: .0625rem solid #d1d5db;\n    border-radius: .5rem;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125);\n    -webkit-appearance: none;\n    appearance: none\n}\n\n.form-select:focus {\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125), 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.form-select[multiple],\n.form-select[size]:not([size=\"1\"]) {\n    padding-right: 1rem;\n    background-image: none\n}\n\n.form-select:disabled {\n    color: #4b5563;\n    background-color: #e5e7eb\n}\n\n.form-select:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #6b7280\n}\n\n.form-select-sm {\n    padding-top: .375rem;\n    padding-bottom: .375rem;\n    padding-left: .625rem;\n    font-size: .875rem\n}\n\n.form-select-lg {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n    padding-left: 1rem;\n    font-size: 1.25rem\n}\n\n.form-check {\n    display: block;\n    min-height: 1.5rem;\n    padding-left: 1.625em;\n    margin-bottom: .125rem\n}\n\n.form-check .form-check-input {\n    float: left;\n    margin-left: -1.625em\n}\n\n.form-check-input {\n    width: 1.125em;\n    height: 1.125em;\n    margin-top: .1875em;\n    vertical-align: top;\n    background-color: #f2f4f6;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n    border: 1px solid #d1d5db;\n    -webkit-appearance: none;\n    appearance: none;\n    -webkit-print-color-adjust: exact;\n    color-adjust: exact;\n    transition: background-color .2s ease-in-out, background-position .2s ease-in-out, border-color .2s ease-in-out, box-shadow .2s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-check-input {\n        transition: none\n    }\n}\n\n.form-check-input[type=checkbox] {\n    border-radius: .25em\n}\n\n.form-check-input[type=radio] {\n    border-radius: 50%\n}\n\n.form-check-input:active {\n    filter: brightness(90%)\n}\n\n.form-check-input:focus {\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.form-check-input:checked {\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.form-check-input:checked[type=checkbox] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\")\n}\n\n.form-check-input:checked[type=radio] {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\")\n}\n\n.form-check-input[type=checkbox]:indeterminate {\n    background-color: #1f2937;\n    border-color: #1f2937;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\")\n}\n\n.form-check-input:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: .5\n}\n\n.form-check-input:disabled ~ .form-check-label,\n.form-check-input[disabled] ~ .form-check-label {\n    opacity: .5\n}\n\n.form-switch {\n    padding-left: 2.75em\n}\n\n.form-switch .form-check-input {\n    width: 2.25em;\n    margin-left: -2.75em;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%234B5563'/%3e%3c/svg%3e\");\n    background-position: left center;\n    border-radius: 2.25em;\n    transition: background-position .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-switch .form-check-input {\n        transition: none\n    }\n}\n\n.form-switch .form-check-input:focus {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%234d6689'/%3e%3c/svg%3e\")\n}\n\n.form-switch .form-check-input:checked {\n    background-position: right center;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\")\n}\n\n.form-check-inline {\n    display: inline-block;\n    margin-right: 1rem\n}\n\n.btn-check {\n    position: absolute;\n    clip: rect(0, 0, 0, 0);\n    pointer-events: none\n}\n\n.btn-check:disabled + .btn,\n.btn-check[disabled] + .btn {\n    pointer-events: none;\n    filter: none;\n    opacity: .65\n}\n\n.form-range {\n    width: 100%;\n    height: 1.36rem;\n    padding: 0;\n    background-color: transparent;\n    -webkit-appearance: none;\n    appearance: none\n}\n\n.form-range:focus {\n    outline: 0\n}\n\n.form-range:focus::-webkit-slider-thumb {\n    box-shadow: 0 0 0 1px #f2f4f6, 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.form-range:focus::-moz-range-thumb {\n    box-shadow: 0 0 0 1px #f2f4f6, 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.form-range::-moz-focus-outer {\n    border: 0\n}\n\n.form-range::-webkit-slider-thumb {\n    width: 1rem;\n    height: 1rem;\n    margin-top: -.25rem;\n    background-color: #1f2937;\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0 .1rem .25rem rgba(17, 24, 39, .1);\n    -webkit-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    -webkit-appearance: none;\n    appearance: none\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-range::-webkit-slider-thumb {\n        -webkit-transition: none;\n        transition: none\n    }\n}\n\n.form-range::-webkit-slider-thumb:active {\n    background-color: #627fa7\n}\n\n.form-range::-webkit-slider-runnable-track {\n    width: 100%;\n    height: .5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #d1d5db;\n    border-color: transparent;\n    border-radius: 1rem;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)\n}\n\n.form-range::-moz-range-thumb {\n    width: 1rem;\n    height: 1rem;\n    background-color: #1f2937;\n    border: 0;\n    border-radius: 1rem;\n    box-shadow: 0 .1rem .25rem rgba(17, 24, 39, .1);\n    -moz-transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    appearance: none\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-range::-moz-range-thumb {\n        -moz-transition: none;\n        transition: none\n    }\n}\n\n.form-range::-moz-range-thumb:active {\n    background-color: #627fa7\n}\n\n.form-range::-moz-range-track {\n    width: 100%;\n    height: .5rem;\n    color: transparent;\n    cursor: pointer;\n    background-color: #d1d5db;\n    border-color: transparent;\n    border-radius: 1rem;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)\n}\n\n.form-range:disabled {\n    pointer-events: none\n}\n\n.form-range:disabled::-webkit-slider-thumb {\n    background-color: #6b7280\n}\n\n.form-range:disabled::-moz-range-thumb {\n    background-color: #6b7280\n}\n\n.form-floating {\n    position: relative\n}\n\n.form-floating > .form-control,\n.form-floating > .form-select {\n    height: 3.625rem;\n    padding: 1rem 1rem\n}\n\n.form-floating > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    padding: 1rem 1rem;\n    pointer-events: none;\n    border: .0625rem solid transparent;\n    transform-origin: 0 0;\n    transition: opacity .1s ease-in-out, transform .1s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .form-floating > label {\n        transition: none\n    }\n}\n\n.form-floating > .form-control::placeholder {\n    color: transparent\n}\n\n.form-floating > .form-control:focus,\n.form-floating > .form-control:not(:placeholder-shown) {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating > .form-control:-webkit-autofill {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating > .form-select {\n    padding-top: 1.625rem;\n    padding-bottom: .625rem\n}\n\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n    opacity: .65;\n    transform: scale(.85) translateY(-.5rem) translateX(.15rem)\n}\n\n.form-floating > .form-control:-webkit-autofill ~ label {\n    opacity: .65;\n    transform: scale(.85) translateY(-.5rem) translateX(.15rem)\n}\n\n.input-group {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    width: 100%\n}\n\n.input-group > .form-control,\n.input-group > .form-select {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0\n}\n\n.input-group > .form-control:focus,\n.input-group > .form-select:focus {\n    z-index: 3\n}\n\n.input-group .btn {\n    position: relative;\n    z-index: 2\n}\n\n.input-group .btn:focus {\n    z-index: 3\n}\n\n.input-group-text {\n    display: flex;\n    align-items: center;\n    padding: .5rem .625rem;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #9ca3af;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #fff;\n    border: .0625rem solid #d1d5db;\n    border-radius: .5rem\n}\n\n.input-group-lg > .btn,\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text {\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: .5rem\n}\n\n.input-group-sm > .btn,\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text {\n    padding: .375rem .625rem;\n    font-size: .875rem;\n    border-radius: .5rem\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n    padding-right: 2rem\n}\n\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n    margin-left: -.0625rem;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.valid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: .875em;\n    color: #10b981\n}\n\n.valid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .375rem .55rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    color: #1f2937;\n    background-color: rgba(16, 185, 129, .99);\n    border-radius: .5rem\n}\n\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip,\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip {\n    display: block\n}\n\n.form-control.is-valid,\n.was-validated .form-control:valid {\n    border-color: #10b981;\n    padding-right: calc(1.5em + 1rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2310B981' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(.375em + .25rem) center;\n    background-size: calc(.75em + .5rem) calc(.75em + .5rem)\n}\n\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n    border-color: #10b981;\n    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n    padding-right: calc(1.5em + 1rem);\n    background-position: top calc(.375em + .25rem) right calc(.375em + .25rem)\n}\n\n.form-select.is-valid,\n.was-validated .form-select:valid {\n    border-color: #10b981\n}\n\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"],\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"] {\n    padding-right: 3.5rem;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231F2937' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2310B981' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n    background-position: right 1rem center, center right 2rem;\n    background-size: 16px 12px, calc(.75em + .5rem) calc(.75em + .5rem)\n}\n\n.form-select.is-valid:focus,\n.was-validated .form-select:valid:focus {\n    border-color: #10b981;\n    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)\n}\n\n.form-check-input.is-valid,\n.was-validated .form-check-input:valid {\n    border-color: #10b981\n}\n\n.form-check-input.is-valid:checked,\n.was-validated .form-check-input:valid:checked {\n    background-color: #10b981\n}\n\n.form-check-input.is-valid:focus,\n.was-validated .form-check-input:valid:focus {\n    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .25)\n}\n\n.form-check-input.is-valid ~ .form-check-label,\n.was-validated .form-check-input:valid ~ .form-check-label {\n    color: #10b981\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n    margin-left: .5em\n}\n\n.input-group .form-control.is-valid,\n.input-group .form-select.is-valid,\n.was-validated .input-group .form-control:valid,\n.was-validated .input-group .form-select:valid {\n    z-index: 1\n}\n\n.input-group .form-control.is-valid:focus,\n.input-group .form-select.is-valid:focus,\n.was-validated .input-group .form-control:valid:focus,\n.was-validated .input-group .form-select:valid:focus {\n    z-index: 3\n}\n\n.invalid-feedback {\n    display: none;\n    width: 100%;\n    margin-top: .25rem;\n    font-size: .875em;\n    color: #e11d48\n}\n\n.invalid-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%;\n    padding: .375rem .55rem;\n    margin-top: .1rem;\n    font-size: .875rem;\n    color: #fff;\n    background-color: rgba(225, 29, 72, .99);\n    border-radius: .5rem\n}\n\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip,\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip {\n    display: block\n}\n\n.form-control.is-invalid,\n.was-validated .form-control:invalid {\n    border-color: #e11d48;\n    padding-right: calc(1.5em + 1rem);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23E11D48' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23E11D48' stroke='none'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right calc(.375em + .25rem) center;\n    background-size: calc(.75em + .5rem) calc(.75em + .5rem)\n}\n\n.form-control.is-invalid:focus,\n.was-validated .form-control:invalid:focus {\n    border-color: #e11d48;\n    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n    padding-right: calc(1.5em + 1rem);\n    background-position: top calc(.375em + .25rem) right calc(.375em + .25rem)\n}\n\n.form-select.is-invalid,\n.was-validated .form-select:invalid {\n    border-color: #e11d48\n}\n\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"],\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"] {\n    padding-right: 3.5rem;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231F2937' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23E11D48' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23E11D48' stroke='none'/%3e%3c/svg%3e\");\n    background-position: right 1rem center, center right 2rem;\n    background-size: 16px 12px, calc(.75em + .5rem) calc(.75em + .5rem)\n}\n\n.form-select.is-invalid:focus,\n.was-validated .form-select:invalid:focus {\n    border-color: #e11d48;\n    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)\n}\n\n.form-check-input.is-invalid,\n.was-validated .form-check-input:invalid {\n    border-color: #e11d48\n}\n\n.form-check-input.is-invalid:checked,\n.was-validated .form-check-input:invalid:checked {\n    background-color: #e11d48\n}\n\n.form-check-input.is-invalid:focus,\n.was-validated .form-check-input:invalid:focus {\n    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .25)\n}\n\n.form-check-input.is-invalid ~ .form-check-label,\n.was-validated .form-check-input:invalid ~ .form-check-label {\n    color: #e11d48\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n    margin-left: .5em\n}\n\n.input-group .form-control.is-invalid,\n.input-group .form-select.is-invalid,\n.was-validated .input-group .form-control:invalid,\n.was-validated .input-group .form-select:invalid {\n    z-index: 2\n}\n\n.input-group .form-control.is-invalid:focus,\n.input-group .form-select.is-invalid:focus,\n.was-validated .input-group .form-control:invalid:focus,\n.was-validated .input-group .form-select:invalid:focus {\n    z-index: 3\n}\n\n.btn {\n    display: inline-block;\n    font-weight: 500;\n    line-height: 1.5;\n    color: #374151;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: .0625rem solid transparent;\n    padding: .5rem 1rem;\n    font-size: .875rem;\n    border-radius: .5rem;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .btn {\n        transition: none\n    }\n}\n\n.btn:hover {\n    color: #374151\n}\n\n.btn-check:focus + .btn,\n.btn:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.btn-check:active + .btn,\n.btn-check:checked + .btn,\n.btn.active,\n.btn:active {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125)\n}\n\n.btn-check:active + .btn:focus,\n.btn-check:checked + .btn:focus,\n.btn.active:focus,\n.btn:active:focus {\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25), inset 0 3px 5px rgba(17, 24, 39, .125)\n}\n\n.btn.disabled,\n.btn:disabled,\nfieldset:disabled .btn {\n    pointer-events: none;\n    opacity: .65;\n    box-shadow: none\n}\n\n.btn-primary {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-primary:hover {\n    color: #fff;\n    background-color: #1a232f;\n    border-color: #19212c\n}\n\n.btn-check:focus + .btn-primary,\n.btn-primary:focus {\n    color: #fff;\n    background-color: #1a232f;\n    border-color: #19212c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(65, 73, 85, .5)\n}\n\n.btn-check:active + .btn-primary,\n.btn-check:checked + .btn-primary,\n.btn-primary.active,\n.btn-primary:active,\n.show > .btn-primary.dropdown-toggle {\n    color: #fff;\n    background-color: #19212c;\n    border-color: #171f29\n}\n\n.btn-check:active + .btn-primary:focus,\n.btn-check:checked + .btn-primary:focus,\n.btn-primary.active:focus,\n.btn-primary:active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(65, 73, 85, .5)\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-secondary {\n    color: #1f2937;\n    background-color: #f0bc74;\n    border-color: #f0bc74;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-secondary:hover {\n    color: #1f2937;\n    background-color: #f2c689;\n    border-color: #f2c382\n}\n\n.btn-check:focus + .btn-secondary,\n.btn-secondary:focus {\n    color: #1f2937;\n    background-color: #f2c689;\n    border-color: #f2c382;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(209, 166, 107, .5)\n}\n\n.btn-check:active + .btn-secondary,\n.btn-check:checked + .btn-secondary,\n.btn-secondary.active,\n.btn-secondary:active,\n.show > .btn-secondary.dropdown-toggle {\n    color: #1f2937;\n    background-color: #f3c990;\n    border-color: #f2c382\n}\n\n.btn-check:active + .btn-secondary:focus,\n.btn-check:checked + .btn-secondary:focus,\n.btn-secondary.active:focus,\n.btn-secondary:active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(209, 166, 107, .5)\n}\n\n.btn-secondary.disabled,\n.btn-secondary:disabled {\n    color: #1f2937;\n    background-color: #f0bc74;\n    border-color: #f0bc74\n}\n\n.btn-tertiary {\n    color: #fff;\n    background-color: #31316a;\n    border-color: #31316a;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-tertiary:hover {\n    color: #fff;\n    background-color: #2a2a5a;\n    border-color: #272755\n}\n\n.btn-check:focus + .btn-tertiary,\n.btn-tertiary:focus {\n    color: #fff;\n    background-color: #2a2a5a;\n    border-color: #272755;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(80, 80, 128, .5)\n}\n\n.btn-check:active + .btn-tertiary,\n.btn-check:checked + .btn-tertiary,\n.btn-tertiary.active,\n.btn-tertiary:active,\n.show > .btn-tertiary.dropdown-toggle {\n    color: #fff;\n    background-color: #272755;\n    border-color: #252550\n}\n\n.btn-check:active + .btn-tertiary:focus,\n.btn-check:checked + .btn-tertiary:focus,\n.btn-tertiary.active:focus,\n.btn-tertiary:active:focus,\n.show > .btn-tertiary.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(80, 80, 128, .5)\n}\n\n.btn-tertiary.disabled,\n.btn-tertiary:disabled {\n    color: #fff;\n    background-color: #31316a;\n    border-color: #31316a\n}\n\n.btn-success {\n    color: #1f2937;\n    background-color: #10b981;\n    border-color: #10b981;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-success:hover {\n    color: #1f2937;\n    background-color: #34c494;\n    border-color: #28c08e\n}\n\n.btn-check:focus + .btn-success,\n.btn-success:focus {\n    color: #1f2937;\n    background-color: #34c494;\n    border-color: #28c08e;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(18, 163, 118, .5)\n}\n\n.btn-check:active + .btn-success,\n.btn-check:checked + .btn-success,\n.btn-success.active,\n.btn-success:active,\n.show > .btn-success.dropdown-toggle {\n    color: #1f2937;\n    background-color: #40c79a;\n    border-color: #28c08e\n}\n\n.btn-check:active + .btn-success:focus,\n.btn-check:checked + .btn-success:focus,\n.btn-success.active:focus,\n.btn-success:active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(18, 163, 118, .5)\n}\n\n.btn-success.disabled,\n.btn-success:disabled {\n    color: #1f2937;\n    background-color: #10b981;\n    border-color: #10b981\n}\n\n.btn-info {\n    color: #fff;\n    background-color: #2361ce;\n    border-color: #2361ce;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-info:hover {\n    color: #fff;\n    background-color: #1e52af;\n    border-color: #1c4ea5\n}\n\n.btn-check:focus + .btn-info,\n.btn-info:focus {\n    color: #fff;\n    background-color: #1e52af;\n    border-color: #1c4ea5;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(68, 121, 213, .5)\n}\n\n.btn-check:active + .btn-info,\n.btn-check:checked + .btn-info,\n.btn-info.active,\n.btn-info:active,\n.show > .btn-info.dropdown-toggle {\n    color: #fff;\n    background-color: #1c4ea5;\n    border-color: #1a499b\n}\n\n.btn-check:active + .btn-info:focus,\n.btn-check:checked + .btn-info:focus,\n.btn-info.active:focus,\n.btn-info:active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(68, 121, 213, .5)\n}\n\n.btn-info.disabled,\n.btn-info:disabled {\n    color: #fff;\n    background-color: #2361ce;\n    border-color: #2361ce\n}\n\n.btn-warning {\n    color: #1f2937;\n    background-color: #fba918;\n    border-color: #fba918;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-warning:hover {\n    color: #1f2937;\n    background-color: #fcb63b;\n    border-color: #fbb22f\n}\n\n.btn-check:focus + .btn-warning,\n.btn-warning:focus {\n    color: #1f2937;\n    background-color: #fcb63b;\n    border-color: #fbb22f;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(218, 150, 29, .5)\n}\n\n.btn-check:active + .btn-warning,\n.btn-check:checked + .btn-warning,\n.btn-warning.active,\n.btn-warning:active,\n.show > .btn-warning.dropdown-toggle {\n    color: #1f2937;\n    background-color: #fcba46;\n    border-color: #fbb22f\n}\n\n.btn-check:active + .btn-warning:focus,\n.btn-check:checked + .btn-warning:focus,\n.btn-warning.active:focus,\n.btn-warning:active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(218, 150, 29, .5)\n}\n\n.btn-warning.disabled,\n.btn-warning:disabled {\n    color: #1f2937;\n    background-color: #fba918;\n    border-color: #fba918\n}\n\n.btn-danger {\n    color: #fff;\n    background-color: #e11d48;\n    border-color: #e11d48;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-danger:hover {\n    color: #fff;\n    background-color: #bf193d;\n    border-color: #b4173a\n}\n\n.btn-check:focus + .btn-danger,\n.btn-danger:focus {\n    color: #fff;\n    background-color: #bf193d;\n    border-color: #b4173a;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(230, 63, 99, .5)\n}\n\n.btn-check:active + .btn-danger,\n.btn-check:checked + .btn-danger,\n.btn-danger.active,\n.btn-danger:active,\n.show > .btn-danger.dropdown-toggle {\n    color: #fff;\n    background-color: #b4173a;\n    border-color: #a91636\n}\n\n.btn-check:active + .btn-danger:focus,\n.btn-check:checked + .btn-danger:focus,\n.btn-danger.active:focus,\n.btn-danger:active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(230, 63, 99, .5)\n}\n\n.btn-danger.disabled,\n.btn-danger:disabled {\n    color: #fff;\n    background-color: #e11d48;\n    border-color: #e11d48\n}\n\n.btn-white {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-white:hover {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.btn-check:focus + .btn-white,\n.btn-white:focus {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(221, 223, 225, .5)\n}\n\n.btn-check:active + .btn-white,\n.btn-check:checked + .btn-white,\n.btn-white.active,\n.btn-white:active,\n.show > .btn-white.dropdown-toggle {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.btn-check:active + .btn-white:focus,\n.btn-check:checked + .btn-white:focus,\n.btn-white.active:focus,\n.btn-white:active:focus,\n.show > .btn-white.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(221, 223, 225, .5)\n}\n\n.btn-white.disabled,\n.btn-white:disabled {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.btn-indigo {\n    color: #fff;\n    background-color: #4f46e5;\n    border-color: #4f46e5;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-indigo:hover {\n    color: #fff;\n    background-color: #433cc3;\n    border-color: #3f38b7\n}\n\n.btn-check:focus + .btn-indigo,\n.btn-indigo:focus {\n    color: #fff;\n    background-color: #433cc3;\n    border-color: #3f38b7;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(105, 98, 233, .5)\n}\n\n.btn-check:active + .btn-indigo,\n.btn-check:checked + .btn-indigo,\n.btn-indigo.active,\n.btn-indigo:active,\n.show > .btn-indigo.dropdown-toggle {\n    color: #fff;\n    background-color: #3f38b7;\n    border-color: #3b35ac\n}\n\n.btn-check:active + .btn-indigo:focus,\n.btn-check:checked + .btn-indigo:focus,\n.btn-indigo.active:focus,\n.btn-indigo:active:focus,\n.show > .btn-indigo.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(105, 98, 233, .5)\n}\n\n.btn-indigo.disabled,\n.btn-indigo:disabled {\n    color: #fff;\n    background-color: #4f46e5;\n    border-color: #4f46e5\n}\n\n.btn-purple {\n    color: #fff;\n    background-color: #7c3aed;\n    border-color: #7c3aed;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-purple:hover {\n    color: #fff;\n    background-color: #6931c9;\n    border-color: #632ebe\n}\n\n.btn-check:focus + .btn-purple,\n.btn-purple:focus {\n    color: #fff;\n    background-color: #6931c9;\n    border-color: #632ebe;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(144, 88, 240, .5)\n}\n\n.btn-check:active + .btn-purple,\n.btn-check:checked + .btn-purple,\n.btn-purple.active,\n.btn-purple:active,\n.show > .btn-purple.dropdown-toggle {\n    color: #fff;\n    background-color: #632ebe;\n    border-color: #5d2cb2\n}\n\n.btn-check:active + .btn-purple:focus,\n.btn-check:checked + .btn-purple:focus,\n.btn-purple.active:focus,\n.btn-purple:active:focus,\n.show > .btn-purple.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(144, 88, 240, .5)\n}\n\n.btn-purple.disabled,\n.btn-purple:disabled {\n    color: #fff;\n    background-color: #7c3aed;\n    border-color: #7c3aed\n}\n\n.btn-yellow-100 {\n    color: #1f2937;\n    background-color: #ffeed6;\n    border-color: #ffeed6;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-yellow-100:hover {\n    color: #1f2937;\n    background-color: #fff1dc;\n    border-color: #fff0da\n}\n\n.btn-check:focus + .btn-yellow-100,\n.btn-yellow-100:focus {\n    color: #1f2937;\n    background-color: #fff1dc;\n    border-color: #fff0da;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(221, 208, 190, .5)\n}\n\n.btn-check:active + .btn-yellow-100,\n.btn-check:checked + .btn-yellow-100,\n.btn-yellow-100.active,\n.btn-yellow-100:active,\n.show > .btn-yellow-100.dropdown-toggle {\n    color: #1f2937;\n    background-color: #fff1de;\n    border-color: #fff0da\n}\n\n.btn-check:active + .btn-yellow-100:focus,\n.btn-check:checked + .btn-yellow-100:focus,\n.btn-yellow-100.active:focus,\n.btn-yellow-100:active:focus,\n.show > .btn-yellow-100.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(221, 208, 190, .5)\n}\n\n.btn-yellow-100.disabled,\n.btn-yellow-100:disabled {\n    color: #1f2937;\n    background-color: #ffeed6;\n    border-color: #ffeed6\n}\n\n.btn-yellow-200 {\n    color: #1f2937;\n    background-color: #f5dbb8;\n    border-color: #f5dbb8;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-yellow-200:hover {\n    color: #1f2937;\n    background-color: #f7e0c3;\n    border-color: #f6dfbf\n}\n\n.btn-check:focus + .btn-yellow-200,\n.btn-yellow-200:focus {\n    color: #1f2937;\n    background-color: #f7e0c3;\n    border-color: #f6dfbf;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(213, 192, 165, .5)\n}\n\n.btn-check:active + .btn-yellow-200,\n.btn-check:checked + .btn-yellow-200,\n.btn-yellow-200.active,\n.btn-yellow-200:active,\n.show > .btn-yellow-200.dropdown-toggle {\n    color: #1f2937;\n    background-color: #f7e2c6;\n    border-color: #f6dfbf\n}\n\n.btn-check:active + .btn-yellow-200:focus,\n.btn-check:checked + .btn-yellow-200:focus,\n.btn-yellow-200.active:focus,\n.btn-yellow-200:active:focus,\n.show > .btn-yellow-200.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(213, 192, 165, .5)\n}\n\n.btn-yellow-200.disabled,\n.btn-yellow-200:disabled {\n    color: #1f2937;\n    background-color: #f5dbb8;\n    border-color: #f5dbb8\n}\n\n.btn-gray-50 {\n    color: #1f2937;\n    background-color: #f9fafb;\n    border-color: #f9fafb;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-50:hover {\n    color: #1f2937;\n    background-color: #fafbfc;\n    border-color: #fafbfb\n}\n\n.btn-check:focus + .btn-gray-50,\n.btn-gray-50:focus {\n    color: #1f2937;\n    background-color: #fafbfc;\n    border-color: #fafbfb;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(216, 219, 222, .5)\n}\n\n.btn-check:active + .btn-gray-50,\n.btn-check:checked + .btn-gray-50,\n.btn-gray-50.active,\n.btn-gray-50:active,\n.show > .btn-gray-50.dropdown-toggle {\n    color: #1f2937;\n    background-color: #fafbfc;\n    border-color: #fafbfb\n}\n\n.btn-check:active + .btn-gray-50:focus,\n.btn-check:checked + .btn-gray-50:focus,\n.btn-gray-50.active:focus,\n.btn-gray-50:active:focus,\n.show > .btn-gray-50.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(216, 219, 222, .5)\n}\n\n.btn-gray-50.disabled,\n.btn-gray-50:disabled {\n    color: #1f2937;\n    background-color: #f9fafb;\n    border-color: #f9fafb\n}\n\n.btn-gray-100 {\n    color: #1f2937;\n    background-color: #f2f4f6;\n    border-color: #f2f4f6;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-100:hover {\n    color: #1f2937;\n    background-color: #f4f6f7;\n    border-color: #f3f5f7\n}\n\n.btn-check:focus + .btn-gray-100,\n.btn-gray-100:focus {\n    color: #1f2937;\n    background-color: #f4f6f7;\n    border-color: #f3f5f7;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(210, 214, 217, .5)\n}\n\n.btn-check:active + .btn-gray-100,\n.btn-check:checked + .btn-gray-100,\n.btn-gray-100.active,\n.btn-gray-100:active,\n.show > .btn-gray-100.dropdown-toggle {\n    color: #1f2937;\n    background-color: #f5f6f8;\n    border-color: #f3f5f7\n}\n\n.btn-check:active + .btn-gray-100:focus,\n.btn-check:checked + .btn-gray-100:focus,\n.btn-gray-100.active:focus,\n.btn-gray-100:active:focus,\n.show > .btn-gray-100.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(210, 214, 217, .5)\n}\n\n.btn-gray-100.disabled,\n.btn-gray-100:disabled {\n    color: #1f2937;\n    background-color: #f2f4f6;\n    border-color: #f2f4f6\n}\n\n.btn-gray-200 {\n    color: #1f2937;\n    background-color: #e5e7eb;\n    border-color: #e5e7eb;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-200:hover {\n    color: #1f2937;\n    background-color: #e9ebee;\n    border-color: #e8e9ed\n}\n\n.btn-check:focus + .btn-gray-200,\n.btn-gray-200:focus {\n    color: #1f2937;\n    background-color: #e9ebee;\n    border-color: #e8e9ed;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(199, 203, 208, .5)\n}\n\n.btn-check:active + .btn-gray-200,\n.btn-check:checked + .btn-gray-200,\n.btn-gray-200.active,\n.btn-gray-200:active,\n.show > .btn-gray-200.dropdown-toggle {\n    color: #1f2937;\n    background-color: #eaecef;\n    border-color: #e8e9ed\n}\n\n.btn-check:active + .btn-gray-200:focus,\n.btn-check:checked + .btn-gray-200:focus,\n.btn-gray-200.active:focus,\n.btn-gray-200:active:focus,\n.show > .btn-gray-200.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(199, 203, 208, .5)\n}\n\n.btn-gray-200.disabled,\n.btn-gray-200:disabled {\n    color: #1f2937;\n    background-color: #e5e7eb;\n    border-color: #e5e7eb\n}\n\n.btn-gray-300 {\n    color: #1f2937;\n    background-color: #d1d5db;\n    border-color: #d1d5db;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-300:hover {\n    color: #1f2937;\n    background-color: #d8dbe0;\n    border-color: #d6d9df\n}\n\n.btn-check:focus + .btn-gray-300,\n.btn-gray-300:focus {\n    color: #1f2937;\n    background-color: #d8dbe0;\n    border-color: #d6d9df;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(182, 187, 194, .5)\n}\n\n.btn-check:active + .btn-gray-300,\n.btn-check:checked + .btn-gray-300,\n.btn-gray-300.active,\n.btn-gray-300:active,\n.show > .btn-gray-300.dropdown-toggle {\n    color: #1f2937;\n    background-color: #dadde2;\n    border-color: #d6d9df\n}\n\n.btn-check:active + .btn-gray-300:focus,\n.btn-check:checked + .btn-gray-300:focus,\n.btn-gray-300.active:focus,\n.btn-gray-300:active:focus,\n.show > .btn-gray-300.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(182, 187, 194, .5)\n}\n\n.btn-gray-300.disabled,\n.btn-gray-300:disabled {\n    color: #1f2937;\n    background-color: #d1d5db;\n    border-color: #d1d5db\n}\n\n.btn-gray-400 {\n    color: #1f2937;\n    background-color: #9ca3af;\n    border-color: #9ca3af;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-400:hover {\n    color: #1f2937;\n    background-color: #abb1bb;\n    border-color: #a6acb7\n}\n\n.btn-check:focus + .btn-gray-400,\n.btn-gray-400:focus {\n    color: #1f2937;\n    background-color: #abb1bb;\n    border-color: #a6acb7;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(137, 145, 157, .5)\n}\n\n.btn-check:active + .btn-gray-400,\n.btn-check:checked + .btn-gray-400,\n.btn-gray-400.active,\n.btn-gray-400:active,\n.show > .btn-gray-400.dropdown-toggle {\n    color: #1f2937;\n    background-color: #b0b5bf;\n    border-color: #a6acb7\n}\n\n.btn-check:active + .btn-gray-400:focus,\n.btn-check:checked + .btn-gray-400:focus,\n.btn-gray-400.active:focus,\n.btn-gray-400:active:focus,\n.show > .btn-gray-400.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(137, 145, 157, .5)\n}\n\n.btn-gray-400.disabled,\n.btn-gray-400:disabled {\n    color: #1f2937;\n    background-color: #9ca3af;\n    border-color: #9ca3af\n}\n\n.btn-gray-500 {\n    color: #fff;\n    background-color: #6b7280;\n    border-color: #6b7280;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-500:hover {\n    color: #fff;\n    background-color: #5b616d;\n    border-color: #565b66\n}\n\n.btn-check:focus + .btn-gray-500,\n.btn-gray-500:focus {\n    color: #fff;\n    background-color: #5b616d;\n    border-color: #565b66;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(129, 135, 147, .5)\n}\n\n.btn-check:active + .btn-gray-500,\n.btn-check:checked + .btn-gray-500,\n.btn-gray-500.active,\n.btn-gray-500:active,\n.show > .btn-gray-500.dropdown-toggle {\n    color: #fff;\n    background-color: #565b66;\n    border-color: #505660\n}\n\n.btn-check:active + .btn-gray-500:focus,\n.btn-check:checked + .btn-gray-500:focus,\n.btn-gray-500.active:focus,\n.btn-gray-500:active:focus,\n.show > .btn-gray-500.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(129, 135, 147, .5)\n}\n\n.btn-gray-500.disabled,\n.btn-gray-500:disabled {\n    color: #fff;\n    background-color: #6b7280;\n    border-color: #6b7280\n}\n\n.btn-gray-600 {\n    color: #fff;\n    background-color: #4b5563;\n    border-color: #4b5563;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-600:hover {\n    color: #fff;\n    background-color: #404854;\n    border-color: #3c444f\n}\n\n.btn-check:focus + .btn-gray-600,\n.btn-gray-600:focus {\n    color: #fff;\n    background-color: #404854;\n    border-color: #3c444f;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(102, 111, 122, .5)\n}\n\n.btn-check:active + .btn-gray-600,\n.btn-check:checked + .btn-gray-600,\n.btn-gray-600.active,\n.btn-gray-600:active,\n.show > .btn-gray-600.dropdown-toggle {\n    color: #fff;\n    background-color: #3c444f;\n    border-color: #38404a\n}\n\n.btn-check:active + .btn-gray-600:focus,\n.btn-check:checked + .btn-gray-600:focus,\n.btn-gray-600.active:focus,\n.btn-gray-600:active:focus,\n.show > .btn-gray-600.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(102, 111, 122, .5)\n}\n\n.btn-gray-600.disabled,\n.btn-gray-600:disabled {\n    color: #fff;\n    background-color: #4b5563;\n    border-color: #4b5563\n}\n\n.btn-gray-700 {\n    color: #fff;\n    background-color: #374151;\n    border-color: #374151;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-700:hover {\n    color: #fff;\n    background-color: #2f3745;\n    border-color: #2c3441\n}\n\n.btn-check:focus + .btn-gray-700,\n.btn-gray-700:focus {\n    color: #fff;\n    background-color: #2f3745;\n    border-color: #2c3441;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(85, 94, 107, .5)\n}\n\n.btn-check:active + .btn-gray-700,\n.btn-check:checked + .btn-gray-700,\n.btn-gray-700.active,\n.btn-gray-700:active,\n.show > .btn-gray-700.dropdown-toggle {\n    color: #fff;\n    background-color: #2c3441;\n    border-color: #29313d\n}\n\n.btn-check:active + .btn-gray-700:focus,\n.btn-check:checked + .btn-gray-700:focus,\n.btn-gray-700.active:focus,\n.btn-gray-700:active:focus,\n.show > .btn-gray-700.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(85, 94, 107, .5)\n}\n\n.btn-gray-700.disabled,\n.btn-gray-700:disabled {\n    color: #fff;\n    background-color: #374151;\n    border-color: #374151\n}\n\n.btn-gray-800 {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-800:hover {\n    color: #fff;\n    background-color: #1a232f;\n    border-color: #19212c\n}\n\n.btn-check:focus + .btn-gray-800,\n.btn-gray-800:focus {\n    color: #fff;\n    background-color: #1a232f;\n    border-color: #19212c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(65, 73, 85, .5)\n}\n\n.btn-check:active + .btn-gray-800,\n.btn-check:checked + .btn-gray-800,\n.btn-gray-800.active,\n.btn-gray-800:active,\n.show > .btn-gray-800.dropdown-toggle {\n    color: #fff;\n    background-color: #19212c;\n    border-color: #171f29\n}\n\n.btn-check:active + .btn-gray-800:focus,\n.btn-check:checked + .btn-gray-800:focus,\n.btn-gray-800.active:focus,\n.btn-gray-800:active:focus,\n.show > .btn-gray-800.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(65, 73, 85, .5)\n}\n\n.btn-gray-800.disabled,\n.btn-gray-800:disabled {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-gray-900 {\n    color: #fff;\n    background-color: #111827;\n    border-color: #111827;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-gray-900:hover {\n    color: #fff;\n    background-color: #0e1421;\n    border-color: #0e131f\n}\n\n.btn-check:focus + .btn-gray-900,\n.btn-gray-900:focus {\n    color: #fff;\n    background-color: #0e1421;\n    border-color: #0e131f;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(53, 59, 71, .5)\n}\n\n.btn-check:active + .btn-gray-900,\n.btn-check:checked + .btn-gray-900,\n.btn-gray-900.active,\n.btn-gray-900:active,\n.show > .btn-gray-900.dropdown-toggle {\n    color: #fff;\n    background-color: #0e131f;\n    border-color: #0d121d\n}\n\n.btn-check:active + .btn-gray-900:focus,\n.btn-check:checked + .btn-gray-900:focus,\n.btn-gray-900.active:focus,\n.btn-gray-900:active:focus,\n.show > .btn-gray-900.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(53, 59, 71, .5)\n}\n\n.btn-gray-900.disabled,\n.btn-gray-900:disabled {\n    color: #fff;\n    background-color: #111827;\n    border-color: #111827\n}\n\n.btn-outline-primary {\n    color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-outline-primary:hover {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-check:focus + .btn-outline-primary,\n.btn-outline-primary:focus {\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .5)\n}\n\n.btn-check:active + .btn-outline-primary,\n.btn-check:checked + .btn-outline-primary,\n.btn-outline-primary.active,\n.btn-outline-primary.dropdown-toggle.show,\n.btn-outline-primary:active {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-check:active + .btn-outline-primary:focus,\n.btn-check:checked + .btn-outline-primary:focus,\n.btn-outline-primary.active:focus,\n.btn-outline-primary.dropdown-toggle.show:focus,\n.btn-outline-primary:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(31, 41, 55, .5)\n}\n\n.btn-outline-primary.disabled,\n.btn-outline-primary:disabled {\n    color: #1f2937;\n    background-color: transparent\n}\n\n.btn-outline-secondary {\n    color: #f0bc74;\n    border-color: #f0bc74\n}\n\n.btn-outline-secondary:hover {\n    color: #1f2937;\n    background-color: #f0bc74;\n    border-color: #f0bc74\n}\n\n.btn-check:focus + .btn-outline-secondary,\n.btn-outline-secondary:focus {\n    box-shadow: 0 0 0 .18rem rgba(240, 188, 116, .5)\n}\n\n.btn-check:active + .btn-outline-secondary,\n.btn-check:checked + .btn-outline-secondary,\n.btn-outline-secondary.active,\n.btn-outline-secondary.dropdown-toggle.show,\n.btn-outline-secondary:active {\n    color: #1f2937;\n    background-color: #f0bc74;\n    border-color: #f0bc74\n}\n\n.btn-check:active + .btn-outline-secondary:focus,\n.btn-check:checked + .btn-outline-secondary:focus,\n.btn-outline-secondary.active:focus,\n.btn-outline-secondary.dropdown-toggle.show:focus,\n.btn-outline-secondary:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(240, 188, 116, .5)\n}\n\n.btn-outline-secondary.disabled,\n.btn-outline-secondary:disabled {\n    color: #f0bc74;\n    background-color: transparent\n}\n\n.btn-outline-tertiary {\n    color: #31316a;\n    border-color: #31316a\n}\n\n.btn-outline-tertiary:hover {\n    color: #fff;\n    background-color: #31316a;\n    border-color: #31316a\n}\n\n.btn-check:focus + .btn-outline-tertiary,\n.btn-outline-tertiary:focus {\n    box-shadow: 0 0 0 .18rem rgba(49, 49, 106, .5)\n}\n\n.btn-check:active + .btn-outline-tertiary,\n.btn-check:checked + .btn-outline-tertiary,\n.btn-outline-tertiary.active,\n.btn-outline-tertiary.dropdown-toggle.show,\n.btn-outline-tertiary:active {\n    color: #fff;\n    background-color: #31316a;\n    border-color: #31316a\n}\n\n.btn-check:active + .btn-outline-tertiary:focus,\n.btn-check:checked + .btn-outline-tertiary:focus,\n.btn-outline-tertiary.active:focus,\n.btn-outline-tertiary.dropdown-toggle.show:focus,\n.btn-outline-tertiary:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(49, 49, 106, .5)\n}\n\n.btn-outline-tertiary.disabled,\n.btn-outline-tertiary:disabled {\n    color: #31316a;\n    background-color: transparent\n}\n\n.btn-outline-success {\n    color: #10b981;\n    border-color: #10b981\n}\n\n.btn-outline-success:hover {\n    color: #1f2937;\n    background-color: #10b981;\n    border-color: #10b981\n}\n\n.btn-check:focus + .btn-outline-success,\n.btn-outline-success:focus {\n    box-shadow: 0 0 0 .18rem rgba(16, 185, 129, .5)\n}\n\n.btn-check:active + .btn-outline-success,\n.btn-check:checked + .btn-outline-success,\n.btn-outline-success.active,\n.btn-outline-success.dropdown-toggle.show,\n.btn-outline-success:active {\n    color: #1f2937;\n    background-color: #10b981;\n    border-color: #10b981\n}\n\n.btn-check:active + .btn-outline-success:focus,\n.btn-check:checked + .btn-outline-success:focus,\n.btn-outline-success.active:focus,\n.btn-outline-success.dropdown-toggle.show:focus,\n.btn-outline-success:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(16, 185, 129, .5)\n}\n\n.btn-outline-success.disabled,\n.btn-outline-success:disabled {\n    color: #10b981;\n    background-color: transparent\n}\n\n.btn-outline-info {\n    color: #2361ce;\n    border-color: #2361ce\n}\n\n.btn-outline-info:hover {\n    color: #fff;\n    background-color: #2361ce;\n    border-color: #2361ce\n}\n\n.btn-check:focus + .btn-outline-info,\n.btn-outline-info:focus {\n    box-shadow: 0 0 0 .18rem rgba(35, 97, 206, .5)\n}\n\n.btn-check:active + .btn-outline-info,\n.btn-check:checked + .btn-outline-info,\n.btn-outline-info.active,\n.btn-outline-info.dropdown-toggle.show,\n.btn-outline-info:active {\n    color: #fff;\n    background-color: #2361ce;\n    border-color: #2361ce\n}\n\n.btn-check:active + .btn-outline-info:focus,\n.btn-check:checked + .btn-outline-info:focus,\n.btn-outline-info.active:focus,\n.btn-outline-info.dropdown-toggle.show:focus,\n.btn-outline-info:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(35, 97, 206, .5)\n}\n\n.btn-outline-info.disabled,\n.btn-outline-info:disabled {\n    color: #2361ce;\n    background-color: transparent\n}\n\n.btn-outline-warning {\n    color: #fba918;\n    border-color: #fba918\n}\n\n.btn-outline-warning:hover {\n    color: #1f2937;\n    background-color: #fba918;\n    border-color: #fba918\n}\n\n.btn-check:focus + .btn-outline-warning,\n.btn-outline-warning:focus {\n    box-shadow: 0 0 0 .18rem rgba(251, 169, 24, .5)\n}\n\n.btn-check:active + .btn-outline-warning,\n.btn-check:checked + .btn-outline-warning,\n.btn-outline-warning.active,\n.btn-outline-warning.dropdown-toggle.show,\n.btn-outline-warning:active {\n    color: #1f2937;\n    background-color: #fba918;\n    border-color: #fba918\n}\n\n.btn-check:active + .btn-outline-warning:focus,\n.btn-check:checked + .btn-outline-warning:focus,\n.btn-outline-warning.active:focus,\n.btn-outline-warning.dropdown-toggle.show:focus,\n.btn-outline-warning:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(251, 169, 24, .5)\n}\n\n.btn-outline-warning.disabled,\n.btn-outline-warning:disabled {\n    color: #fba918;\n    background-color: transparent\n}\n\n.btn-outline-danger {\n    color: #e11d48;\n    border-color: #e11d48\n}\n\n.btn-outline-danger:hover {\n    color: #fff;\n    background-color: #e11d48;\n    border-color: #e11d48\n}\n\n.btn-check:focus + .btn-outline-danger,\n.btn-outline-danger:focus {\n    box-shadow: 0 0 0 .18rem rgba(225, 29, 72, .5)\n}\n\n.btn-check:active + .btn-outline-danger,\n.btn-check:checked + .btn-outline-danger,\n.btn-outline-danger.active,\n.btn-outline-danger.dropdown-toggle.show,\n.btn-outline-danger:active {\n    color: #fff;\n    background-color: #e11d48;\n    border-color: #e11d48\n}\n\n.btn-check:active + .btn-outline-danger:focus,\n.btn-check:checked + .btn-outline-danger:focus,\n.btn-outline-danger.active:focus,\n.btn-outline-danger.dropdown-toggle.show:focus,\n.btn-outline-danger:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(225, 29, 72, .5)\n}\n\n.btn-outline-danger.disabled,\n.btn-outline-danger:disabled {\n    color: #e11d48;\n    background-color: transparent\n}\n\n.btn-outline-white {\n    color: #fff;\n    border-color: #fff\n}\n\n.btn-outline-white:hover {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.btn-check:focus + .btn-outline-white,\n.btn-outline-white:focus {\n    box-shadow: 0 0 0 .18rem rgba(255, 255, 255, .5)\n}\n\n.btn-check:active + .btn-outline-white,\n.btn-check:checked + .btn-outline-white,\n.btn-outline-white.active,\n.btn-outline-white.dropdown-toggle.show,\n.btn-outline-white:active {\n    color: #1f2937;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.btn-check:active + .btn-outline-white:focus,\n.btn-check:checked + .btn-outline-white:focus,\n.btn-outline-white.active:focus,\n.btn-outline-white.dropdown-toggle.show:focus,\n.btn-outline-white:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(255, 255, 255, .5)\n}\n\n.btn-outline-white.disabled,\n.btn-outline-white:disabled {\n    color: #fff;\n    background-color: transparent\n}\n\n.btn-outline-indigo {\n    color: #4f46e5;\n    border-color: #4f46e5\n}\n\n.btn-outline-indigo:hover {\n    color: #fff;\n    background-color: #4f46e5;\n    border-color: #4f46e5\n}\n\n.btn-check:focus + .btn-outline-indigo,\n.btn-outline-indigo:focus {\n    box-shadow: 0 0 0 .18rem rgba(79, 70, 229, .5)\n}\n\n.btn-check:active + .btn-outline-indigo,\n.btn-check:checked + .btn-outline-indigo,\n.btn-outline-indigo.active,\n.btn-outline-indigo.dropdown-toggle.show,\n.btn-outline-indigo:active {\n    color: #fff;\n    background-color: #4f46e5;\n    border-color: #4f46e5\n}\n\n.btn-check:active + .btn-outline-indigo:focus,\n.btn-check:checked + .btn-outline-indigo:focus,\n.btn-outline-indigo.active:focus,\n.btn-outline-indigo.dropdown-toggle.show:focus,\n.btn-outline-indigo:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(79, 70, 229, .5)\n}\n\n.btn-outline-indigo.disabled,\n.btn-outline-indigo:disabled {\n    color: #4f46e5;\n    background-color: transparent\n}\n\n.btn-outline-purple {\n    color: #7c3aed;\n    border-color: #7c3aed\n}\n\n.btn-outline-purple:hover {\n    color: #fff;\n    background-color: #7c3aed;\n    border-color: #7c3aed\n}\n\n.btn-check:focus + .btn-outline-purple,\n.btn-outline-purple:focus {\n    box-shadow: 0 0 0 .18rem rgba(124, 58, 237, .5)\n}\n\n.btn-check:active + .btn-outline-purple,\n.btn-check:checked + .btn-outline-purple,\n.btn-outline-purple.active,\n.btn-outline-purple.dropdown-toggle.show,\n.btn-outline-purple:active {\n    color: #fff;\n    background-color: #7c3aed;\n    border-color: #7c3aed\n}\n\n.btn-check:active + .btn-outline-purple:focus,\n.btn-check:checked + .btn-outline-purple:focus,\n.btn-outline-purple.active:focus,\n.btn-outline-purple.dropdown-toggle.show:focus,\n.btn-outline-purple:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(124, 58, 237, .5)\n}\n\n.btn-outline-purple.disabled,\n.btn-outline-purple:disabled {\n    color: #7c3aed;\n    background-color: transparent\n}\n\n.btn-outline-yellow-100 {\n    color: #ffeed6;\n    border-color: #ffeed6\n}\n\n.btn-outline-yellow-100:hover {\n    color: #1f2937;\n    background-color: #ffeed6;\n    border-color: #ffeed6\n}\n\n.btn-check:focus + .btn-outline-yellow-100,\n.btn-outline-yellow-100:focus {\n    box-shadow: 0 0 0 .18rem rgba(255, 238, 214, .5)\n}\n\n.btn-check:active + .btn-outline-yellow-100,\n.btn-check:checked + .btn-outline-yellow-100,\n.btn-outline-yellow-100.active,\n.btn-outline-yellow-100.dropdown-toggle.show,\n.btn-outline-yellow-100:active {\n    color: #1f2937;\n    background-color: #ffeed6;\n    border-color: #ffeed6\n}\n\n.btn-check:active + .btn-outline-yellow-100:focus,\n.btn-check:checked + .btn-outline-yellow-100:focus,\n.btn-outline-yellow-100.active:focus,\n.btn-outline-yellow-100.dropdown-toggle.show:focus,\n.btn-outline-yellow-100:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(255, 238, 214, .5)\n}\n\n.btn-outline-yellow-100.disabled,\n.btn-outline-yellow-100:disabled {\n    color: #ffeed6;\n    background-color: transparent\n}\n\n.btn-outline-yellow-200 {\n    color: #f5dbb8;\n    border-color: #f5dbb8\n}\n\n.btn-outline-yellow-200:hover {\n    color: #1f2937;\n    background-color: #f5dbb8;\n    border-color: #f5dbb8\n}\n\n.btn-check:focus + .btn-outline-yellow-200,\n.btn-outline-yellow-200:focus {\n    box-shadow: 0 0 0 .18rem rgba(245, 219, 184, .5)\n}\n\n.btn-check:active + .btn-outline-yellow-200,\n.btn-check:checked + .btn-outline-yellow-200,\n.btn-outline-yellow-200.active,\n.btn-outline-yellow-200.dropdown-toggle.show,\n.btn-outline-yellow-200:active {\n    color: #1f2937;\n    background-color: #f5dbb8;\n    border-color: #f5dbb8\n}\n\n.btn-check:active + .btn-outline-yellow-200:focus,\n.btn-check:checked + .btn-outline-yellow-200:focus,\n.btn-outline-yellow-200.active:focus,\n.btn-outline-yellow-200.dropdown-toggle.show:focus,\n.btn-outline-yellow-200:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(245, 219, 184, .5)\n}\n\n.btn-outline-yellow-200.disabled,\n.btn-outline-yellow-200:disabled {\n    color: #f5dbb8;\n    background-color: transparent\n}\n\n.btn-outline-gray-50 {\n    color: #f9fafb;\n    border-color: #f9fafb\n}\n\n.btn-outline-gray-50:hover {\n    color: #1f2937;\n    background-color: #f9fafb;\n    border-color: #f9fafb\n}\n\n.btn-check:focus + .btn-outline-gray-50,\n.btn-outline-gray-50:focus {\n    box-shadow: 0 0 0 .18rem rgba(249, 250, 251, .5)\n}\n\n.btn-check:active + .btn-outline-gray-50,\n.btn-check:checked + .btn-outline-gray-50,\n.btn-outline-gray-50.active,\n.btn-outline-gray-50.dropdown-toggle.show,\n.btn-outline-gray-50:active {\n    color: #1f2937;\n    background-color: #f9fafb;\n    border-color: #f9fafb\n}\n\n.btn-check:active + .btn-outline-gray-50:focus,\n.btn-check:checked + .btn-outline-gray-50:focus,\n.btn-outline-gray-50.active:focus,\n.btn-outline-gray-50.dropdown-toggle.show:focus,\n.btn-outline-gray-50:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(249, 250, 251, .5)\n}\n\n.btn-outline-gray-50.disabled,\n.btn-outline-gray-50:disabled {\n    color: #f9fafb;\n    background-color: transparent\n}\n\n.btn-outline-gray-100 {\n    color: #f2f4f6;\n    border-color: #f2f4f6\n}\n\n.btn-outline-gray-100:hover {\n    color: #1f2937;\n    background-color: #f2f4f6;\n    border-color: #f2f4f6\n}\n\n.btn-check:focus + .btn-outline-gray-100,\n.btn-outline-gray-100:focus {\n    box-shadow: 0 0 0 .18rem rgba(242, 244, 246, .5)\n}\n\n.btn-check:active + .btn-outline-gray-100,\n.btn-check:checked + .btn-outline-gray-100,\n.btn-outline-gray-100.active,\n.btn-outline-gray-100.dropdown-toggle.show,\n.btn-outline-gray-100:active {\n    color: #1f2937;\n    background-color: #f2f4f6;\n    border-color: #f2f4f6\n}\n\n.btn-check:active + .btn-outline-gray-100:focus,\n.btn-check:checked + .btn-outline-gray-100:focus,\n.btn-outline-gray-100.active:focus,\n.btn-outline-gray-100.dropdown-toggle.show:focus,\n.btn-outline-gray-100:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(242, 244, 246, .5)\n}\n\n.btn-outline-gray-100.disabled,\n.btn-outline-gray-100:disabled {\n    color: #f2f4f6;\n    background-color: transparent\n}\n\n.btn-outline-gray-200 {\n    color: #e5e7eb;\n    border-color: #e5e7eb\n}\n\n.btn-outline-gray-200:hover {\n    color: #1f2937;\n    background-color: #e5e7eb;\n    border-color: #e5e7eb\n}\n\n.btn-check:focus + .btn-outline-gray-200,\n.btn-outline-gray-200:focus {\n    box-shadow: 0 0 0 .18rem rgba(229, 231, 235, .5)\n}\n\n.btn-check:active + .btn-outline-gray-200,\n.btn-check:checked + .btn-outline-gray-200,\n.btn-outline-gray-200.active,\n.btn-outline-gray-200.dropdown-toggle.show,\n.btn-outline-gray-200:active {\n    color: #1f2937;\n    background-color: #e5e7eb;\n    border-color: #e5e7eb\n}\n\n.btn-check:active + .btn-outline-gray-200:focus,\n.btn-check:checked + .btn-outline-gray-200:focus,\n.btn-outline-gray-200.active:focus,\n.btn-outline-gray-200.dropdown-toggle.show:focus,\n.btn-outline-gray-200:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(229, 231, 235, .5)\n}\n\n.btn-outline-gray-200.disabled,\n.btn-outline-gray-200:disabled {\n    color: #e5e7eb;\n    background-color: transparent\n}\n\n.btn-outline-gray-300 {\n    color: #d1d5db;\n    border-color: #d1d5db\n}\n\n.btn-outline-gray-300:hover {\n    color: #1f2937;\n    background-color: #d1d5db;\n    border-color: #d1d5db\n}\n\n.btn-check:focus + .btn-outline-gray-300,\n.btn-outline-gray-300:focus {\n    box-shadow: 0 0 0 .18rem rgba(209, 213, 219, .5)\n}\n\n.btn-check:active + .btn-outline-gray-300,\n.btn-check:checked + .btn-outline-gray-300,\n.btn-outline-gray-300.active,\n.btn-outline-gray-300.dropdown-toggle.show,\n.btn-outline-gray-300:active {\n    color: #1f2937;\n    background-color: #d1d5db;\n    border-color: #d1d5db\n}\n\n.btn-check:active + .btn-outline-gray-300:focus,\n.btn-check:checked + .btn-outline-gray-300:focus,\n.btn-outline-gray-300.active:focus,\n.btn-outline-gray-300.dropdown-toggle.show:focus,\n.btn-outline-gray-300:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(209, 213, 219, .5)\n}\n\n.btn-outline-gray-300.disabled,\n.btn-outline-gray-300:disabled {\n    color: #d1d5db;\n    background-color: transparent\n}\n\n.btn-outline-gray-400 {\n    color: #9ca3af;\n    border-color: #9ca3af\n}\n\n.btn-outline-gray-400:hover {\n    color: #1f2937;\n    background-color: #9ca3af;\n    border-color: #9ca3af\n}\n\n.btn-check:focus + .btn-outline-gray-400,\n.btn-outline-gray-400:focus {\n    box-shadow: 0 0 0 .18rem rgba(156, 163, 175, .5)\n}\n\n.btn-check:active + .btn-outline-gray-400,\n.btn-check:checked + .btn-outline-gray-400,\n.btn-outline-gray-400.active,\n.btn-outline-gray-400.dropdown-toggle.show,\n.btn-outline-gray-400:active {\n    color: #1f2937;\n    background-color: #9ca3af;\n    border-color: #9ca3af\n}\n\n.btn-check:active + .btn-outline-gray-400:focus,\n.btn-check:checked + .btn-outline-gray-400:focus,\n.btn-outline-gray-400.active:focus,\n.btn-outline-gray-400.dropdown-toggle.show:focus,\n.btn-outline-gray-400:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(156, 163, 175, .5)\n}\n\n.btn-outline-gray-400.disabled,\n.btn-outline-gray-400:disabled {\n    color: #9ca3af;\n    background-color: transparent\n}\n\n.btn-outline-gray-500 {\n    color: #6b7280;\n    border-color: #6b7280\n}\n\n.btn-outline-gray-500:hover {\n    color: #fff;\n    background-color: #6b7280;\n    border-color: #6b7280\n}\n\n.btn-check:focus + .btn-outline-gray-500,\n.btn-outline-gray-500:focus {\n    box-shadow: 0 0 0 .18rem rgba(107, 114, 128, .5)\n}\n\n.btn-check:active + .btn-outline-gray-500,\n.btn-check:checked + .btn-outline-gray-500,\n.btn-outline-gray-500.active,\n.btn-outline-gray-500.dropdown-toggle.show,\n.btn-outline-gray-500:active {\n    color: #fff;\n    background-color: #6b7280;\n    border-color: #6b7280\n}\n\n.btn-check:active + .btn-outline-gray-500:focus,\n.btn-check:checked + .btn-outline-gray-500:focus,\n.btn-outline-gray-500.active:focus,\n.btn-outline-gray-500.dropdown-toggle.show:focus,\n.btn-outline-gray-500:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(107, 114, 128, .5)\n}\n\n.btn-outline-gray-500.disabled,\n.btn-outline-gray-500:disabled {\n    color: #6b7280;\n    background-color: transparent\n}\n\n.btn-outline-gray-600 {\n    color: #4b5563;\n    border-color: #4b5563\n}\n\n.btn-outline-gray-600:hover {\n    color: #fff;\n    background-color: #4b5563;\n    border-color: #4b5563\n}\n\n.btn-check:focus + .btn-outline-gray-600,\n.btn-outline-gray-600:focus {\n    box-shadow: 0 0 0 .18rem rgba(75, 85, 99, .5)\n}\n\n.btn-check:active + .btn-outline-gray-600,\n.btn-check:checked + .btn-outline-gray-600,\n.btn-outline-gray-600.active,\n.btn-outline-gray-600.dropdown-toggle.show,\n.btn-outline-gray-600:active {\n    color: #fff;\n    background-color: #4b5563;\n    border-color: #4b5563\n}\n\n.btn-check:active + .btn-outline-gray-600:focus,\n.btn-check:checked + .btn-outline-gray-600:focus,\n.btn-outline-gray-600.active:focus,\n.btn-outline-gray-600.dropdown-toggle.show:focus,\n.btn-outline-gray-600:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(75, 85, 99, .5)\n}\n\n.btn-outline-gray-600.disabled,\n.btn-outline-gray-600:disabled {\n    color: #4b5563;\n    background-color: transparent\n}\n\n.btn-outline-gray-700 {\n    color: #374151;\n    border-color: #374151\n}\n\n.btn-outline-gray-700:hover {\n    color: #fff;\n    background-color: #374151;\n    border-color: #374151\n}\n\n.btn-check:focus + .btn-outline-gray-700,\n.btn-outline-gray-700:focus {\n    box-shadow: 0 0 0 .18rem rgba(55, 65, 81, .5)\n}\n\n.btn-check:active + .btn-outline-gray-700,\n.btn-check:checked + .btn-outline-gray-700,\n.btn-outline-gray-700.active,\n.btn-outline-gray-700.dropdown-toggle.show,\n.btn-outline-gray-700:active {\n    color: #fff;\n    background-color: #374151;\n    border-color: #374151\n}\n\n.btn-check:active + .btn-outline-gray-700:focus,\n.btn-check:checked + .btn-outline-gray-700:focus,\n.btn-outline-gray-700.active:focus,\n.btn-outline-gray-700.dropdown-toggle.show:focus,\n.btn-outline-gray-700:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(55, 65, 81, .5)\n}\n\n.btn-outline-gray-700.disabled,\n.btn-outline-gray-700:disabled {\n    color: #374151;\n    background-color: transparent\n}\n\n.btn-outline-gray-800 {\n    color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-outline-gray-800:hover {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-check:focus + .btn-outline-gray-800,\n.btn-outline-gray-800:focus {\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .5)\n}\n\n.btn-check:active + .btn-outline-gray-800,\n.btn-check:checked + .btn-outline-gray-800,\n.btn-outline-gray-800.active,\n.btn-outline-gray-800.dropdown-toggle.show,\n.btn-outline-gray-800:active {\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.btn-check:active + .btn-outline-gray-800:focus,\n.btn-check:checked + .btn-outline-gray-800:focus,\n.btn-outline-gray-800.active:focus,\n.btn-outline-gray-800.dropdown-toggle.show:focus,\n.btn-outline-gray-800:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(31, 41, 55, .5)\n}\n\n.btn-outline-gray-800.disabled,\n.btn-outline-gray-800:disabled {\n    color: #1f2937;\n    background-color: transparent\n}\n\n.btn-outline-gray-900 {\n    color: #111827;\n    border-color: #111827\n}\n\n.btn-outline-gray-900:hover {\n    color: #fff;\n    background-color: #111827;\n    border-color: #111827\n}\n\n.btn-check:focus + .btn-outline-gray-900,\n.btn-outline-gray-900:focus {\n    box-shadow: 0 0 0 .18rem rgba(17, 24, 39, .5)\n}\n\n.btn-check:active + .btn-outline-gray-900,\n.btn-check:checked + .btn-outline-gray-900,\n.btn-outline-gray-900.active,\n.btn-outline-gray-900.dropdown-toggle.show,\n.btn-outline-gray-900:active {\n    color: #fff;\n    background-color: #111827;\n    border-color: #111827\n}\n\n.btn-check:active + .btn-outline-gray-900:focus,\n.btn-check:checked + .btn-outline-gray-900:focus,\n.btn-outline-gray-900.active:focus,\n.btn-outline-gray-900.dropdown-toggle.show:focus,\n.btn-outline-gray-900:active:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(17, 24, 39, .5)\n}\n\n.btn-outline-gray-900.disabled,\n.btn-outline-gray-900:disabled {\n    color: #111827;\n    background-color: transparent\n}\n\n.btn-link {\n    font-weight: 400;\n    color: #1f2937;\n    text-decoration: none\n}\n\n.btn-link:hover {\n    color: #000;\n    text-decoration: none\n}\n\n.btn-link:focus {\n    text-decoration: none\n}\n\n.btn-link.disabled,\n.btn-link:disabled {\n    color: #4b5563\n}\n\n.btn-group-lg > .btn,\n.btn-lg {\n    padding: .5rem 1rem;\n    font-size: 1.25rem;\n    border-radius: .5rem\n}\n\n.btn-group-sm > .btn,\n.btn-sm {\n    padding: .375rem .625rem;\n    font-size: .875rem;\n    border-radius: .5rem\n}\n\n.fade {\n    transition: opacity .15s linear\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .fade {\n        transition: none\n    }\n}\n\n.fade:not(.show) {\n    opacity: 0\n}\n\n.collapse:not(.show) {\n    display: none\n}\n\n.collapsing {\n    height: 0;\n    overflow: hidden;\n    transition: height .35s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .collapsing {\n        transition: none\n    }\n}\n\n.dropdown,\n.dropend,\n.dropstart,\n.dropup {\n    position: relative\n}\n\n.dropdown-toggle {\n    white-space: nowrap\n}\n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid;\n    border-right: .3em solid transparent;\n    border-bottom: 0;\n    border-left: .3em solid transparent\n}\n\n.dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropdown-menu {\n    position: absolute;\n    z-index: 1000;\n    display: none;\n    min-width: 12rem;\n    padding: .5rem 0;\n    margin: 0;\n    font-size: .875rem;\n    color: #374151;\n    text-align: left;\n    list-style: none;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: .0625rem solid #e5e7eb;\n    border-radius: .35rem;\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05)\n}\n\n.dropdown-menu[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: .125rem\n}\n\n.dropdown-menu-start {\n    --bs-position: start\n}\n\n.dropdown-menu-start[data-bs-popper] {\n    right: auto;\n    left: 0\n}\n\n.dropdown-menu-end {\n    --bs-position: end\n}\n\n.dropdown-menu-end[data-bs-popper] {\n    right: 0;\n    left: auto\n}\n\n@media (min-width: 576px) {\n    .dropdown-menu-sm-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-sm-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-sm-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-sm-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width: 768px) {\n    .dropdown-menu-md-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-md-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-md-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-md-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width: 992px) {\n    .dropdown-menu-lg-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-lg-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-lg-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-lg-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width: 1200px) {\n    .dropdown-menu-xl-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-xl-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-xl-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-xl-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n@media (min-width: 1400px) {\n    .dropdown-menu-xxl-start {\n        --bs-position: start\n    }\n\n    .dropdown-menu-xxl-start[data-bs-popper] {\n        right: auto;\n        left: 0\n    }\n\n    .dropdown-menu-xxl-end {\n        --bs-position: end\n    }\n\n    .dropdown-menu-xxl-end[data-bs-popper] {\n        right: 0;\n        left: auto\n    }\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: .125rem\n}\n\n.dropup .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: 0;\n    border-right: .3em solid transparent;\n    border-bottom: .3em solid;\n    border-left: .3em solid transparent\n}\n\n.dropup .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: .125rem\n}\n\n.dropend .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid transparent;\n    border-right: 0;\n    border-bottom: .3em solid transparent;\n    border-left: .3em solid\n}\n\n.dropend .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropend .dropdown-toggle::after {\n    vertical-align: 0\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: .125rem\n}\n\n.dropstart .dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    vertical-align: .255em;\n    content: \"\"\n}\n\n.dropstart .dropdown-toggle::after {\n    display: none\n}\n\n.dropstart .dropdown-toggle::before {\n    display: inline-block;\n    margin-right: .255em;\n    vertical-align: .255em;\n    content: \"\";\n    border-top: .3em solid transparent;\n    border-right: .3em solid;\n    border-bottom: .3em solid transparent\n}\n\n.dropstart .dropdown-toggle:empty::after {\n    margin-left: 0\n}\n\n.dropstart .dropdown-toggle::before {\n    vertical-align: 0\n}\n\n.dropdown-divider {\n    height: 0;\n    margin: .5rem 0;\n    overflow: hidden;\n    border-top: 1px solid #e5e7eb\n}\n\n.dropdown-item {\n    display: block;\n    width: 100%;\n    padding: .25rem 1rem;\n    clear: both;\n    font-weight: 400;\n    color: #111827;\n    text-align: inherit;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0\n}\n\n.dropdown-item:focus,\n.dropdown-item:hover {\n    color: #090d15;\n    background-color: #f2f4f6\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n    color: #111827;\n    text-decoration: none;\n    background-color: #e5e7eb\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n    color: #4b5563;\n    pointer-events: none;\n    background-color: transparent\n}\n\n.dropdown-menu.show {\n    display: block\n}\n\n.dropdown-header {\n    display: block;\n    padding: .5rem 1rem;\n    margin-bottom: 0;\n    font-size: .875rem;\n    color: #111827;\n    white-space: nowrap\n}\n\n.dropdown-item-text {\n    display: block;\n    padding: .25rem 1rem;\n    color: #111827\n}\n\n.dropdown-menu-dark {\n    color: #d1d5db;\n    background-color: #1f2937;\n    border-color: #e5e7eb\n}\n\n.dropdown-menu-dark .dropdown-item {\n    color: #d1d5db\n}\n\n.dropdown-menu-dark .dropdown-item:focus,\n.dropdown-menu-dark .dropdown-item:hover {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .15)\n}\n\n.dropdown-menu-dark .dropdown-item.active,\n.dropdown-menu-dark .dropdown-item:active {\n    color: #111827;\n    background-color: #e5e7eb\n}\n\n.dropdown-menu-dark .dropdown-item.disabled,\n.dropdown-menu-dark .dropdown-item:disabled {\n    color: #6b7280\n}\n\n.dropdown-menu-dark .dropdown-divider {\n    border-color: #e5e7eb\n}\n\n.dropdown-menu-dark .dropdown-item-text {\n    color: #d1d5db\n}\n\n.dropdown-menu-dark .dropdown-header {\n    color: #6b7280\n}\n\n.btn-group,\n.btn-group-vertical {\n    position: relative;\n    display: inline-flex;\n    vertical-align: middle\n}\n\n.btn-group-vertical > .btn,\n.btn-group > .btn {\n    position: relative;\n    flex: 1 1 auto\n}\n\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn.active,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:hover,\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn.active,\n.btn-group > .btn:active,\n.btn-group > .btn:focus,\n.btn-group > .btn:hover {\n    z-index: 1\n}\n\n.btn-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start\n}\n\n.btn-toolbar .input-group {\n    width: auto\n}\n\n.btn-group > .btn-group:not(:first-child),\n.btn-group > .btn:not(:first-child) {\n    margin-left: -.0625rem\n}\n\n.btn-group > .btn-group:not(:last-child) > .btn,\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0\n}\n\n.btn-group > .btn-group:not(:first-child) > .btn,\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.dropdown-toggle-split {\n    padding-right: .75rem;\n    padding-left: .75rem\n}\n\n.dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after {\n    margin-left: 0\n}\n\n.dropstart .dropdown-toggle-split::before {\n    margin-right: 0\n}\n\n.btn-group-sm > .btn + .dropdown-toggle-split,\n.btn-sm + .dropdown-toggle-split {\n    padding-right: .46875rem;\n    padding-left: .46875rem\n}\n\n.btn-group-lg > .btn + .dropdown-toggle-split,\n.btn-lg + .dropdown-toggle-split {\n    padding-right: .75rem;\n    padding-left: .75rem\n}\n\n.btn-group.show .dropdown-toggle {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125)\n}\n\n.btn-group.show .dropdown-toggle.btn-link {\n    box-shadow: none\n}\n\n.btn-group-vertical {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center\n}\n\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n    width: 100%\n}\n\n.btn-group-vertical > .btn-group:not(:first-child),\n.btn-group-vertical > .btn:not(:first-child) {\n    margin-top: -.0625rem\n}\n\n.btn-group-vertical > .btn-group:not(:last-child) > .btn,\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0\n}\n\n.btn-group-vertical > .btn-group:not(:first-child) > .btn,\n.btn-group-vertical > .btn ~ .btn {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav {\n    display: flex;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.nav-link {\n    display: block;\n    padding: .5rem 1rem;\n    color: #1f2937;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .nav-link {\n        transition: none\n    }\n}\n\n.nav-link:focus,\n.nav-link:hover {\n    color: #1f2937\n}\n\n.nav-link.disabled {\n    color: #4b5563;\n    pointer-events: none;\n    cursor: default\n}\n\n.nav-tabs {\n    border-bottom: .0625rem solid #9ca3af\n}\n\n.nav-tabs .nav-link {\n    margin-bottom: -.0625rem;\n    background: 0 0;\n    border: .0625rem solid transparent;\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem\n}\n\n.nav-tabs .nav-link:focus,\n.nav-tabs .nav-link:hover {\n    border-color: #e5e7eb #e5e7eb #9ca3af;\n    isolation: isolate\n}\n\n.nav-tabs .nav-link.disabled {\n    color: #4b5563;\n    background-color: transparent;\n    border-color: transparent\n}\n\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n    color: #374151;\n    background-color: #9ca3af;\n    border-color: #9ca3af\n}\n\n.nav-tabs .dropdown-menu {\n    margin-top: -.0625rem;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0\n}\n\n.nav-pills .nav-link {\n    background: 0 0;\n    border: 0;\n    border-radius: .5rem\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n    color: #1f2937;\n    background-color: #f8f8f8\n}\n\n.nav-fill .nav-item,\n.nav-fill > .nav-link {\n    flex: 1 1 auto;\n    text-align: center\n}\n\n.nav-justified .nav-item,\n.nav-justified > .nav-link {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n    width: 100%\n}\n\n.tab-content > .tab-pane {\n    display: none\n}\n\n.tab-content > .active {\n    display: block\n}\n\n.navbar {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 1rem;\n    padding-bottom: 1rem\n}\n\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-lg,\n.navbar > .container-md,\n.navbar > .container-sm,\n.navbar > .container-xl {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between\n}\n\n.navbar-brand {\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 1rem;\n    font-size: 1.25rem;\n    white-space: nowrap\n}\n\n.navbar-nav {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none\n}\n\n.navbar-nav .nav-link {\n    padding-right: 0;\n    padding-left: 0\n}\n\n.navbar-nav .dropdown-menu {\n    position: static\n}\n\n.navbar-text {\n    padding-top: .5rem;\n    padding-bottom: .5rem\n}\n\n.navbar-collapse {\n    flex-basis: 100%;\n    flex-grow: 1;\n    align-items: center\n}\n\n.navbar-toggler {\n    padding: .4rem .6rem;\n    font-size: 1.25rem;\n    line-height: 1;\n    background-color: transparent;\n    border: .0625rem solid transparent;\n    border-radius: .5rem;\n    transition: box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .navbar-toggler {\n        transition: none\n    }\n}\n\n.navbar-toggler:hover {\n    text-decoration: none\n}\n\n.navbar-toggler:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem\n}\n\n.navbar-toggler-icon {\n    display: inline-block;\n    width: 1.5em;\n    height: 1.5em;\n    vertical-align: middle;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 100%\n}\n\n.navbar-nav-scroll {\n    max-height: var(--bs-scroll-height, 75vh);\n    overflow-y: auto\n}\n\n@media (min-width: 576px) {\n    .navbar-expand-sm {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-sm .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-sm .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-sm .navbar-nav .nav-link {\n        padding-right: .8rem;\n        padding-left: .8rem\n    }\n\n    .navbar-expand-sm .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-sm .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-sm .navbar-toggler {\n        display: none\n    }\n}\n\n@media (min-width: 768px) {\n    .navbar-expand-md {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-md .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-md .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-md .navbar-nav .nav-link {\n        padding-right: .8rem;\n        padding-left: .8rem\n    }\n\n    .navbar-expand-md .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-md .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-md .navbar-toggler {\n        display: none\n    }\n}\n\n@media (min-width: 992px) {\n    .navbar-expand-lg {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-lg .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-lg .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-lg .navbar-nav .nav-link {\n        padding-right: .8rem;\n        padding-left: .8rem\n    }\n\n    .navbar-expand-lg .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-lg .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-lg .navbar-toggler {\n        display: none\n    }\n}\n\n@media (min-width: 1200px) {\n    .navbar-expand-xl {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-xl .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-xl .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-xl .navbar-nav .nav-link {\n        padding-right: .8rem;\n        padding-left: .8rem\n    }\n\n    .navbar-expand-xl .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-xl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-xl .navbar-toggler {\n        display: none\n    }\n}\n\n@media (min-width: 1400px) {\n    .navbar-expand-xxl {\n        flex-wrap: nowrap;\n        justify-content: flex-start\n    }\n\n    .navbar-expand-xxl .navbar-nav {\n        flex-direction: row\n    }\n\n    .navbar-expand-xxl .navbar-nav .dropdown-menu {\n        position: absolute\n    }\n\n    .navbar-expand-xxl .navbar-nav .nav-link {\n        padding-right: .8rem;\n        padding-left: .8rem\n    }\n\n    .navbar-expand-xxl .navbar-nav-scroll {\n        overflow: visible\n    }\n\n    .navbar-expand-xxl .navbar-collapse {\n        display: flex !important;\n        flex-basis: auto\n    }\n\n    .navbar-expand-xxl .navbar-toggler {\n        display: none\n    }\n}\n\n.navbar-expand {\n    flex-wrap: nowrap;\n    justify-content: flex-start\n}\n\n.navbar-expand .navbar-nav {\n    flex-direction: row\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n    position: absolute\n}\n\n.navbar-expand .navbar-nav .nav-link {\n    padding-right: .8rem;\n    padding-left: .8rem\n}\n\n.navbar-expand .navbar-nav-scroll {\n    overflow: visible\n}\n\n.navbar-expand .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto\n}\n\n.navbar-expand .navbar-toggler {\n    display: none\n}\n\n.navbar-light .navbar-brand {\n    color: #111827\n}\n\n.navbar-light .navbar-brand:focus,\n.navbar-light .navbar-brand:hover {\n    color: #111827\n}\n\n.navbar-light .navbar-nav .nav-link {\n    color: rgba(17, 24, 39, .9)\n}\n\n.navbar-light .navbar-nav .nav-link:focus,\n.navbar-light .navbar-nav .nav-link:hover {\n    color: #111827\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n    color: rgba(17, 24, 39, .9)\n}\n\n.navbar-light .navbar-nav .nav-link.active,\n.navbar-light .navbar-nav .show > .nav-link {\n    color: #111827\n}\n\n.navbar-light .navbar-toggler {\n    color: rgba(17, 24, 39, .9);\n    border-color: rgba(17, 24, 39, .1)\n}\n\n.navbar-light .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2817, 24, 39, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n.navbar-light .navbar-text {\n    color: rgba(17, 24, 39, .9)\n}\n\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:focus,\n.navbar-light .navbar-text a:hover {\n    color: #111827\n}\n\n.navbar-dark .navbar-brand {\n    color: #fff\n}\n\n.navbar-dark .navbar-brand:focus,\n.navbar-dark .navbar-brand:hover {\n    color: #fff\n}\n\n.navbar-dark .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, .9)\n}\n\n.navbar-dark .navbar-nav .nav-link:focus,\n.navbar-dark .navbar-nav .nav-link:hover {\n    color: #fff\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, .9)\n}\n\n.navbar-dark .navbar-nav .nav-link.active,\n.navbar-dark .navbar-nav .show > .nav-link {\n    color: #fff\n}\n\n.navbar-dark .navbar-toggler {\n    color: rgba(255, 255, 255, .9);\n    border-color: rgba(255, 255, 255, .1)\n}\n\n.navbar-dark .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.9%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")\n}\n\n.navbar-dark .navbar-text {\n    color: rgba(255, 255, 255, .9)\n}\n\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:focus,\n.navbar-dark .navbar-text a:hover {\n    color: #fff\n}\n\n.card {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: .0625rem solid rgba(17, 24, 39, .125);\n    border-radius: .5rem\n}\n\n.card > hr {\n    margin-right: 0;\n    margin-left: 0\n}\n\n.card > .list-group {\n    border-top: inherit;\n    border-bottom: inherit\n}\n\n.card > .list-group:first-child {\n    border-top-width: 0;\n    border-top-left-radius: .4375rem;\n    border-top-right-radius: .4375rem\n}\n\n.card > .list-group:last-child {\n    border-bottom-width: 0;\n    border-bottom-right-radius: .4375rem;\n    border-bottom-left-radius: .4375rem\n}\n\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n    border-top: 0\n}\n\n.card-body {\n    flex: 1 1 auto;\n    padding: 1.25rem 1.5rem\n}\n\n.card-title {\n    margin-bottom: .875rem\n}\n\n.card-subtitle {\n    margin-top: -.4375rem;\n    margin-bottom: 0\n}\n\n.card-text:last-child {\n    margin-bottom: 0\n}\n\n.card-link:hover {\n    text-decoration: none\n}\n\n.card-link + .card-link {\n    margin-left: 1.5rem\n}\n\n.card-header {\n    padding: 1.25rem 1.5rem;\n    margin-bottom: 0;\n    background-color: rgba(17, 24, 39, .03);\n    border-bottom: .0625rem solid rgba(17, 24, 39, .125)\n}\n\n.card-header:first-child {\n    border-radius: .4375rem .4375rem 0 0\n}\n\n.card-footer {\n    padding: 1.25rem 1.5rem;\n    background-color: rgba(17, 24, 39, .03);\n    border-top: .0625rem solid rgba(17, 24, 39, .125)\n}\n\n.card-footer:last-child {\n    border-radius: 0 0 .4375rem .4375rem\n}\n\n.card-header-tabs {\n    margin-right: -.75rem;\n    margin-bottom: -1.25rem;\n    margin-left: -.75rem;\n    border-bottom: 0\n}\n\n.card-header-tabs .nav-link.active {\n    background-color: #fff;\n    border-bottom-color: #fff\n}\n\n.card-header-pills {\n    margin-right: -.75rem;\n    margin-left: -.75rem\n}\n\n.card-img-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding: 1rem;\n    border-radius: .4375rem\n}\n\n.card-img,\n.card-img-bottom,\n.card-img-top {\n    width: 100%\n}\n\n.card-img,\n.card-img-top {\n    border-top-left-radius: .4375rem;\n    border-top-right-radius: .4375rem\n}\n\n.card-img,\n.card-img-bottom {\n    border-bottom-right-radius: .4375rem;\n    border-bottom-left-radius: .4375rem\n}\n\n.card-group > .card {\n    margin-bottom: .75rem\n}\n\n@media (min-width: 576px) {\n    .card-group {\n        display: flex;\n        flex-flow: row wrap\n    }\n\n    .card-group > .card {\n        flex: 1 0 0%;\n        margin-bottom: 0\n    }\n\n    .card-group > .card + .card {\n        margin-left: 0;\n        border-left: 0\n    }\n\n    .card-group > .card:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0\n    }\n\n    .card-group > .card:not(:last-child) .card-header,\n    .card-group > .card:not(:last-child) .card-img-top {\n        border-top-right-radius: 0\n    }\n\n    .card-group > .card:not(:last-child) .card-footer,\n    .card-group > .card:not(:last-child) .card-img-bottom {\n        border-bottom-right-radius: 0\n    }\n\n    .card-group > .card:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0\n    }\n\n    .card-group > .card:not(:first-child) .card-header,\n    .card-group > .card:not(:first-child) .card-img-top {\n        border-top-left-radius: 0\n    }\n\n    .card-group > .card:not(:first-child) .card-footer,\n    .card-group > .card:not(:first-child) .card-img-bottom {\n        border-bottom-left-radius: 0\n    }\n}\n\n.accordion-button {\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 1rem 1.25rem;\n    font-size: 1rem;\n    color: #374151;\n    text-align: left;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    overflow-anchor: none;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out, border-radius .15s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .accordion-button {\n        transition: none\n    }\n}\n\n.accordion-button:not(.collapsed) {\n    color: #4b5563;\n    background-color: #f2f4f6;\n    box-shadow: inset 0 -.0625rem 0 #e5e7eb\n}\n\n.accordion-button:not(.collapsed)::after {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%234B5563'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    transform: rotate(180deg)\n}\n\n.accordion-button::after {\n    flex-shrink: 0;\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-left: auto;\n    content: \"\";\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23374151'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-size: 1.25rem;\n    transition: transform .2s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .accordion-button::after {\n        transition: none\n    }\n}\n\n.accordion-button:hover {\n    z-index: 2\n}\n\n.accordion-button:focus {\n    z-index: 3;\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.accordion-header {\n    margin-bottom: 0\n}\n\n.accordion-item {\n    background-color: transparent;\n    border: .0625rem solid #e5e7eb\n}\n\n.accordion-item:first-of-type {\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem\n}\n\n.accordion-item:first-of-type .accordion-button {\n    border-top-left-radius: .4375rem;\n    border-top-right-radius: .4375rem\n}\n\n.accordion-item:not(:first-of-type) {\n    border-top: 0\n}\n\n.accordion-item:last-of-type {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem\n}\n\n.accordion-item:last-of-type .accordion-button.collapsed {\n    border-bottom-right-radius: .4375rem;\n    border-bottom-left-radius: .4375rem\n}\n\n.accordion-item:last-of-type .accordion-collapse {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem\n}\n\n.accordion-body {\n    padding: 1rem 1.25rem\n}\n\n.accordion-flush .accordion-collapse {\n    border-width: 0\n}\n\n.accordion-flush .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    border-radius: 0\n}\n\n.accordion-flush .accordion-item:first-child {\n    border-top: 0\n}\n\n.accordion-flush .accordion-item:last-child {\n    border-bottom: 0\n}\n\n.accordion-flush .accordion-item .accordion-button {\n    border-radius: 0\n}\n\n.breadcrumb {\n    display: flex;\n    flex-wrap: wrap;\n    padding: .5rem 1rem;\n    margin-bottom: 1rem;\n    list-style: none;\n    background-color: #e5e7eb;\n    border-radius: .5rem\n}\n\n.breadcrumb-item + .breadcrumb-item {\n    padding-left: .5rem\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n    float: left;\n    padding-right: .5rem;\n    color: #4b5563;\n    content: var(--bs-breadcrumb-divider, \"/\")\n}\n\n.breadcrumb-item.active {\n    color: #4b5563\n}\n\n.pagination {\n    display: flex;\n    padding-left: 0;\n    list-style: none\n}\n\n.page-link {\n    position: relative;\n    display: block;\n    color: #1f2937;\n    background-color: #fff;\n    border: .0625rem solid #9ca3af;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .page-link {\n        transition: none\n    }\n}\n\n.page-link:hover {\n    z-index: 2;\n    color: #000;\n    background-color: #e5e7eb;\n    border-color: #d1d5db\n}\n\n.page-link:focus {\n    z-index: 3;\n    color: #000;\n    background-color: #e5e7eb;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.page-item:not(:first-child) .page-link {\n    margin-left: -.0625rem\n}\n\n.page-item.active .page-link {\n    z-index: 3;\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.page-item.disabled .page-link {\n    color: #4b5563;\n    pointer-events: none;\n    background-color: #fff;\n    border-color: #d1d5db\n}\n\n.page-link {\n    padding: .375rem .75rem\n}\n\n.page-item:first-child .page-link {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem\n}\n\n.page-item:last-child .page-link {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem\n}\n\n.pagination-lg .page-link {\n    padding: .75rem 1.5rem;\n    font-size: 1.25rem\n}\n\n.pagination-lg .page-item:first-child .page-link {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem\n}\n\n.pagination-lg .page-item:last-child .page-link {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem\n}\n\n.pagination-sm .page-link {\n    padding: .25rem .5rem;\n    font-size: .875rem\n}\n\n.pagination-sm .page-item:first-child .page-link {\n    border-top-left-radius: .35rem;\n    border-bottom-left-radius: .35rem\n}\n\n.pagination-sm .page-item:last-child .page-link {\n    border-top-right-radius: .35rem;\n    border-bottom-right-radius: .35rem\n}\n\n.badge {\n    display: inline-block;\n    padding: .2rem .4rem;\n    font-size: .75em;\n    font-weight: 600;\n    line-height: 1;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: .5rem\n}\n\n.badge:empty {\n    display: none\n}\n\n.btn .badge {\n    position: relative;\n    top: -1px\n}\n\n.alert {\n    position: relative;\n    padding: 1rem 1rem;\n    margin-bottom: 1rem;\n    border: .0625rem solid transparent;\n    border-radius: .5rem\n}\n\n.alert-heading {\n    color: inherit\n}\n\n.alert-link {\n    font-weight: 500\n}\n\n.alert-dismissible {\n    padding-right: 3rem\n}\n\n.alert-dismissible .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: 1.25rem 1rem\n}\n\n.alert-primary {\n    color: #131921;\n    background-color: #d2d4d7;\n    border-color: #bcbfc3\n}\n\n.alert-primary .alert-link {\n    color: #0f141a\n}\n\n.alert-secondary {\n    color: #907146;\n    background-color: #fcf2e3;\n    border-color: #fbebd5\n}\n\n.alert-secondary .alert-link {\n    color: #735a38\n}\n\n.alert-tertiary {\n    color: #1d1d40;\n    background-color: #d6d6e1;\n    border-color: #c1c1d2\n}\n\n.alert-tertiary .alert-link {\n    color: #171733\n}\n\n.alert-success {\n    color: #0a6f4d;\n    background-color: #cff1e6;\n    border-color: #b7ead9\n}\n\n.alert-success .alert-link {\n    color: #08593e\n}\n\n.alert-info {\n    color: #153a7c;\n    background-color: #d3dff5;\n    border-color: #bdd0f0\n}\n\n.alert-info .alert-link {\n    color: #112e63\n}\n\n.alert-warning {\n    color: #97650e;\n    background-color: #feeed1;\n    border-color: #fee5ba\n}\n\n.alert-warning .alert-link {\n    color: #79510b\n}\n\n.alert-danger {\n    color: #87112b;\n    background-color: #f9d2da;\n    border-color: #f6bbc8\n}\n\n.alert-danger .alert-link {\n    color: #6c0e22\n}\n\n.alert-white {\n    color: #797f87;\n    background-color: #fff;\n    border-color: #fff\n}\n\n.alert-white .alert-link {\n    color: #61666c\n}\n\n.alert-indigo {\n    color: #2f2a89;\n    background-color: #dcdafa;\n    border-color: #cac8f7\n}\n\n.alert-indigo .alert-link {\n    color: #26226e\n}\n\n.alert-purple {\n    color: #4a238e;\n    background-color: #e5d8fb;\n    border-color: #d8c4fa\n}\n\n.alert-purple .alert-link {\n    color: #3b1c72\n}\n\n.alert-yellow-100 {\n    color: #998f80;\n    background-color: #fffcf7;\n    border-color: #fffaf3\n}\n\n.alert-yellow-100 .alert-link {\n    color: #7a7266\n}\n\n.alert-yellow-200 {\n    color: #93836e;\n    background-color: #fdf8f1;\n    border-color: #fcf4ea\n}\n\n.alert-yellow-200 .alert-link {\n    color: #766958\n}\n\n.alert-gray-50 {\n    color: #767d85;\n    background-color: #fefefe;\n    border-color: #fdfefe\n}\n\n.alert-gray-50 .alert-link {\n    color: #5e646a\n}\n\n.alert-gray-100 {\n    color: #919294;\n    background-color: #fcfdfd;\n    border-color: #fbfcfc\n}\n\n.alert-gray-100 .alert-link {\n    color: #747576\n}\n\n.alert-gray-200 {\n    color: #898b8d;\n    background-color: #fafafb;\n    border-color: #f7f8f9\n}\n\n.alert-gray-200 .alert-link {\n    color: #6e6f71\n}\n\n.alert-gray-300 {\n    color: #7d8083;\n    background-color: #f6f7f8;\n    border-color: #f1f2f4\n}\n\n.alert-gray-300 .alert-link {\n    color: #646669\n}\n\n.alert-gray-400 {\n    color: #5e6269;\n    background-color: #ebedef;\n    border-color: #e1e3e7\n}\n\n.alert-gray-400 .alert-link {\n    color: #4b4e54\n}\n\n.alert-gray-500 {\n    color: #40444d;\n    background-color: #e1e3e6;\n    border-color: #d3d5d9\n}\n\n.alert-gray-500 .alert-link {\n    color: #33363e\n}\n\n.alert-gray-600 {\n    color: #2d333b;\n    background-color: #dbdde0;\n    border-color: #c9ccd0\n}\n\n.alert-gray-600 .alert-link {\n    color: #24292f\n}\n\n.alert-gray-700 {\n    color: #212731;\n    background-color: #d7d9dc;\n    border-color: #c3c6cb\n}\n\n.alert-gray-700 .alert-link {\n    color: #1a1f27\n}\n\n.alert-gray-800 {\n    color: #131921;\n    background-color: #d2d4d7;\n    border-color: #bcbfc3\n}\n\n.alert-gray-800 .alert-link {\n    color: #0f141a\n}\n\n.alert-gray-900 {\n    color: #0a0e17;\n    background-color: #cfd1d4;\n    border-color: #b8babe\n}\n\n.alert-gray-900 .alert-link {\n    color: #080b12\n}\n\n@keyframes progress-bar-stripes {\n    0% {\n        background-position-x: 1rem\n    }\n}\n\n.progress {\n    display: flex;\n    height: 1rem;\n    overflow: hidden;\n    font-size: .75rem;\n    background-color: #e5e7eb;\n    border-radius: .5rem;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125)\n}\n\n.progress-bar {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    overflow: hidden;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #1f2937;\n    transition: width .6s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .progress-bar {\n        transition: none\n    }\n}\n\n.progress-bar-striped {\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, .15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .15) 50%, rgba(255, 255, 255, .15) 75%, transparent 75%, transparent);\n    background-size: 1rem 1rem\n}\n\n.progress-bar-animated {\n    animation: 1s linear infinite progress-bar-stripes\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .progress-bar-animated {\n        animation: none\n    }\n}\n\n.list-group {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n    border-radius: .5rem\n}\n\n.list-group-numbered {\n    list-style-type: none;\n    counter-reset: section\n}\n\n.list-group-numbered > li::before {\n    content: counters(section, \".\") \". \";\n    counter-increment: section\n}\n\n.list-group-item-action {\n    width: 100%;\n    color: #374151;\n    text-align: inherit\n}\n\n.list-group-item-action:focus,\n.list-group-item-action:hover {\n    z-index: 1;\n    color: #374151;\n    text-decoration: none;\n    background-color: #f2f4f6\n}\n\n.list-group-item-action:active {\n    color: #374151;\n    background-color: #e5e7eb\n}\n\n.list-group-item {\n    position: relative;\n    display: block;\n    padding: .5rem 1rem;\n    color: #374151;\n    background-color: #fff;\n    border: .0625rem solid rgba(17, 24, 39, .125)\n}\n\n.list-group-item:first-child {\n    border-top-left-radius: inherit;\n    border-top-right-radius: inherit\n}\n\n.list-group-item:last-child {\n    border-bottom-right-radius: inherit;\n    border-bottom-left-radius: inherit\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n    color: #4b5563;\n    pointer-events: none;\n    background-color: #fff\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.list-group-item + .list-group-item {\n    border-top-width: 0\n}\n\n.list-group-item + .list-group-item.active {\n    margin-top: -.0625rem;\n    border-top-width: .0625rem\n}\n\n.list-group-horizontal {\n    flex-direction: row\n}\n\n.list-group-horizontal > .list-group-item:first-child {\n    border-bottom-left-radius: .5rem;\n    border-top-right-radius: 0\n}\n\n.list-group-horizontal > .list-group-item:last-child {\n    border-top-right-radius: .5rem;\n    border-bottom-left-radius: 0\n}\n\n.list-group-horizontal > .list-group-item.active {\n    margin-top: 0\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item {\n    border-top-width: .0625rem;\n    border-left-width: 0\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n    margin-left: -.0625rem;\n    border-left-width: .0625rem\n}\n\n@media (min-width: 576px) {\n    .list-group-horizontal-sm {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-sm > .list-group-item:first-child {\n        border-bottom-left-radius: .5rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-sm > .list-group-item:last-child {\n        border-top-right-radius: .5rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-sm > .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-sm > .list-group-item + .list-group-item {\n        border-top-width: .0625rem;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n        margin-left: -.0625rem;\n        border-left-width: .0625rem\n    }\n}\n\n@media (min-width: 768px) {\n    .list-group-horizontal-md {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-md > .list-group-item:first-child {\n        border-bottom-left-radius: .5rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-md > .list-group-item:last-child {\n        border-top-right-radius: .5rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-md > .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-md > .list-group-item + .list-group-item {\n        border-top-width: .0625rem;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n        margin-left: -.0625rem;\n        border-left-width: .0625rem\n    }\n}\n\n@media (min-width: 992px) {\n    .list-group-horizontal-lg {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-lg > .list-group-item:first-child {\n        border-bottom-left-radius: .5rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-lg > .list-group-item:last-child {\n        border-top-right-radius: .5rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-lg > .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-lg > .list-group-item + .list-group-item {\n        border-top-width: .0625rem;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n        margin-left: -.0625rem;\n        border-left-width: .0625rem\n    }\n}\n\n@media (min-width: 1200px) {\n    .list-group-horizontal-xl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xl > .list-group-item:first-child {\n        border-bottom-left-radius: .5rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xl > .list-group-item:last-child {\n        border-top-right-radius: .5rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xl > .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xl > .list-group-item + .list-group-item {\n        border-top-width: .0625rem;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n        margin-left: -.0625rem;\n        border-left-width: .0625rem\n    }\n}\n\n@media (min-width: 1400px) {\n    .list-group-horizontal-xxl {\n        flex-direction: row\n    }\n\n    .list-group-horizontal-xxl > .list-group-item:first-child {\n        border-bottom-left-radius: .5rem;\n        border-top-right-radius: 0\n    }\n\n    .list-group-horizontal-xxl > .list-group-item:last-child {\n        border-top-right-radius: .5rem;\n        border-bottom-left-radius: 0\n    }\n\n    .list-group-horizontal-xxl > .list-group-item.active {\n        margin-top: 0\n    }\n\n    .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n        border-top-width: .0625rem;\n        border-left-width: 0\n    }\n\n    .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n        margin-left: -.0625rem;\n        border-left-width: .0625rem\n    }\n}\n\n.list-group-flush {\n    border-radius: 0\n}\n\n.list-group-flush > .list-group-item {\n    border-width: 0 0 .0625rem\n}\n\n.list-group-flush > .list-group-item:last-child {\n    border-bottom-width: 0\n}\n\n.list-group-item-primary {\n    color: #131921;\n    background-color: #d2d4d7\n}\n\n.list-group-item-primary.list-group-item-action:focus,\n.list-group-item-primary.list-group-item-action:hover {\n    color: #131921;\n    background-color: #bdbfc2\n}\n\n.list-group-item-primary.list-group-item-action.active {\n    color: #fff;\n    background-color: #131921;\n    border-color: #131921\n}\n\n.list-group-item-secondary {\n    color: #907146;\n    background-color: #fcf2e3\n}\n\n.list-group-item-secondary.list-group-item-action:focus,\n.list-group-item-secondary.list-group-item-action:hover {\n    color: #907146;\n    background-color: #e3dacc\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n    color: #fff;\n    background-color: #907146;\n    border-color: #907146\n}\n\n.list-group-item-tertiary {\n    color: #1d1d40;\n    background-color: #d6d6e1\n}\n\n.list-group-item-tertiary.list-group-item-action:focus,\n.list-group-item-tertiary.list-group-item-action:hover {\n    color: #1d1d40;\n    background-color: #c1c1cb\n}\n\n.list-group-item-tertiary.list-group-item-action.active {\n    color: #fff;\n    background-color: #1d1d40;\n    border-color: #1d1d40\n}\n\n.list-group-item-success {\n    color: #0a6f4d;\n    background-color: #cff1e6\n}\n\n.list-group-item-success.list-group-item-action:focus,\n.list-group-item-success.list-group-item-action:hover {\n    color: #0a6f4d;\n    background-color: #bad9cf\n}\n\n.list-group-item-success.list-group-item-action.active {\n    color: #fff;\n    background-color: #0a6f4d;\n    border-color: #0a6f4d\n}\n\n.list-group-item-info {\n    color: #153a7c;\n    background-color: #d3dff5\n}\n\n.list-group-item-info.list-group-item-action:focus,\n.list-group-item-info.list-group-item-action:hover {\n    color: #153a7c;\n    background-color: #bec9dd\n}\n\n.list-group-item-info.list-group-item-action.active {\n    color: #fff;\n    background-color: #153a7c;\n    border-color: #153a7c\n}\n\n.list-group-item-warning {\n    color: #97650e;\n    background-color: #feeed1\n}\n\n.list-group-item-warning.list-group-item-action:focus,\n.list-group-item-warning.list-group-item-action:hover {\n    color: #97650e;\n    background-color: #e5d6bc\n}\n\n.list-group-item-warning.list-group-item-action.active {\n    color: #fff;\n    background-color: #97650e;\n    border-color: #97650e\n}\n\n.list-group-item-danger {\n    color: #87112b;\n    background-color: #f9d2da\n}\n\n.list-group-item-danger.list-group-item-action:focus,\n.list-group-item-danger.list-group-item-action:hover {\n    color: #87112b;\n    background-color: #e0bdc4\n}\n\n.list-group-item-danger.list-group-item-action.active {\n    color: #fff;\n    background-color: #87112b;\n    border-color: #87112b\n}\n\n.list-group-item-white {\n    color: #797f87;\n    background-color: #fff\n}\n\n.list-group-item-white.list-group-item-action:focus,\n.list-group-item-white.list-group-item-action:hover {\n    color: #797f87;\n    background-color: #e6e6e6\n}\n\n.list-group-item-white.list-group-item-action.active {\n    color: #fff;\n    background-color: #797f87;\n    border-color: #797f87\n}\n\n.list-group-item-indigo {\n    color: #2f2a89;\n    background-color: #dcdafa\n}\n\n.list-group-item-indigo.list-group-item-action:focus,\n.list-group-item-indigo.list-group-item-action:hover {\n    color: #2f2a89;\n    background-color: #c6c4e1\n}\n\n.list-group-item-indigo.list-group-item-action.active {\n    color: #fff;\n    background-color: #2f2a89;\n    border-color: #2f2a89\n}\n\n.list-group-item-purple {\n    color: #4a238e;\n    background-color: #e5d8fb\n}\n\n.list-group-item-purple.list-group-item-action:focus,\n.list-group-item-purple.list-group-item-action:hover {\n    color: #4a238e;\n    background-color: #cec2e2\n}\n\n.list-group-item-purple.list-group-item-action.active {\n    color: #fff;\n    background-color: #4a238e;\n    border-color: #4a238e\n}\n\n.list-group-item-yellow-100 {\n    color: #998f80;\n    background-color: #fffcf7\n}\n\n.list-group-item-yellow-100.list-group-item-action:focus,\n.list-group-item-yellow-100.list-group-item-action:hover {\n    color: #998f80;\n    background-color: #e6e3de\n}\n\n.list-group-item-yellow-100.list-group-item-action.active {\n    color: #fff;\n    background-color: #998f80;\n    border-color: #998f80\n}\n\n.list-group-item-yellow-200 {\n    color: #93836e;\n    background-color: #fdf8f1\n}\n\n.list-group-item-yellow-200.list-group-item-action:focus,\n.list-group-item-yellow-200.list-group-item-action:hover {\n    color: #93836e;\n    background-color: #e4dfd9\n}\n\n.list-group-item-yellow-200.list-group-item-action.active {\n    color: #fff;\n    background-color: #93836e;\n    border-color: #93836e\n}\n\n.list-group-item-gray-50 {\n    color: #767d85;\n    background-color: #fefefe\n}\n\n.list-group-item-gray-50.list-group-item-action:focus,\n.list-group-item-gray-50.list-group-item-action:hover {\n    color: #767d85;\n    background-color: #e5e5e5\n}\n\n.list-group-item-gray-50.list-group-item-action.active {\n    color: #fff;\n    background-color: #767d85;\n    border-color: #767d85\n}\n\n.list-group-item-gray-100 {\n    color: #919294;\n    background-color: #fcfdfd\n}\n\n.list-group-item-gray-100.list-group-item-action:focus,\n.list-group-item-gray-100.list-group-item-action:hover {\n    color: #919294;\n    background-color: #e3e4e4\n}\n\n.list-group-item-gray-100.list-group-item-action.active {\n    color: #fff;\n    background-color: #919294;\n    border-color: #919294\n}\n\n.list-group-item-gray-200 {\n    color: #898b8d;\n    background-color: #fafafb\n}\n\n.list-group-item-gray-200.list-group-item-action:focus,\n.list-group-item-gray-200.list-group-item-action:hover {\n    color: #898b8d;\n    background-color: #e1e1e2\n}\n\n.list-group-item-gray-200.list-group-item-action.active {\n    color: #fff;\n    background-color: #898b8d;\n    border-color: #898b8d\n}\n\n.list-group-item-gray-300 {\n    color: #7d8083;\n    background-color: #f6f7f8\n}\n\n.list-group-item-gray-300.list-group-item-action:focus,\n.list-group-item-gray-300.list-group-item-action:hover {\n    color: #7d8083;\n    background-color: #dddedf\n}\n\n.list-group-item-gray-300.list-group-item-action.active {\n    color: #fff;\n    background-color: #7d8083;\n    border-color: #7d8083\n}\n\n.list-group-item-gray-400 {\n    color: #5e6269;\n    background-color: #ebedef\n}\n\n.list-group-item-gray-400.list-group-item-action:focus,\n.list-group-item-gray-400.list-group-item-action:hover {\n    color: #5e6269;\n    background-color: #d4d5d7\n}\n\n.list-group-item-gray-400.list-group-item-action.active {\n    color: #fff;\n    background-color: #5e6269;\n    border-color: #5e6269\n}\n\n.list-group-item-gray-500 {\n    color: #40444d;\n    background-color: #e1e3e6\n}\n\n.list-group-item-gray-500.list-group-item-action:focus,\n.list-group-item-gray-500.list-group-item-action:hover {\n    color: #40444d;\n    background-color: #cbcccf\n}\n\n.list-group-item-gray-500.list-group-item-action.active {\n    color: #fff;\n    background-color: #40444d;\n    border-color: #40444d\n}\n\n.list-group-item-gray-600 {\n    color: #2d333b;\n    background-color: #dbdde0\n}\n\n.list-group-item-gray-600.list-group-item-action:focus,\n.list-group-item-gray-600.list-group-item-action:hover {\n    color: #2d333b;\n    background-color: #c5c7ca\n}\n\n.list-group-item-gray-600.list-group-item-action.active {\n    color: #fff;\n    background-color: #2d333b;\n    border-color: #2d333b\n}\n\n.list-group-item-gray-700 {\n    color: #212731;\n    background-color: #d7d9dc\n}\n\n.list-group-item-gray-700.list-group-item-action:focus,\n.list-group-item-gray-700.list-group-item-action:hover {\n    color: #212731;\n    background-color: #c2c3c6\n}\n\n.list-group-item-gray-700.list-group-item-action.active {\n    color: #fff;\n    background-color: #212731;\n    border-color: #212731\n}\n\n.list-group-item-gray-800 {\n    color: #131921;\n    background-color: #d2d4d7\n}\n\n.list-group-item-gray-800.list-group-item-action:focus,\n.list-group-item-gray-800.list-group-item-action:hover {\n    color: #131921;\n    background-color: #bdbfc2\n}\n\n.list-group-item-gray-800.list-group-item-action.active {\n    color: #fff;\n    background-color: #131921;\n    border-color: #131921\n}\n\n.list-group-item-gray-900 {\n    color: #0a0e17;\n    background-color: #cfd1d4\n}\n\n.list-group-item-gray-900.list-group-item-action:focus,\n.list-group-item-gray-900.list-group-item-action:hover {\n    color: #0a0e17;\n    background-color: #babcbf\n}\n\n.list-group-item-gray-900.list-group-item-action.active {\n    color: #fff;\n    background-color: #0a0e17;\n    border-color: #0a0e17\n}\n\n.btn-close {\n    box-sizing: content-box;\n    width: 1em;\n    height: 1em;\n    padding: .25em .25em;\n    color: #111827;\n    background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23111827'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n    border: 0;\n    border-radius: .5rem;\n    opacity: .5\n}\n\n.btn-close:hover {\n    color: #111827;\n    text-decoration: none;\n    opacity: .75\n}\n\n.btn-close:focus {\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25);\n    opacity: 1\n}\n\n.btn-close.disabled,\n.btn-close:disabled {\n    pointer-events: none;\n    -webkit-user-select: none;\n    user-select: none;\n    opacity: .25\n}\n\n.btn-close-white {\n    filter: invert(1) grayscale(100%) brightness(200%)\n}\n\n.toast {\n    width: 350px;\n    max-width: 100%;\n    font-size: .875rem;\n    pointer-events: auto;\n    background-color: rgba(255, 255, 255, .85);\n    background-clip: padding-box;\n    border: 1px solid rgba(0, 0, 0, .1);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06);\n    border-radius: .5rem\n}\n\n.toast:not(.showing):not(.show) {\n    opacity: 0\n}\n\n.toast.hide {\n    display: none\n}\n\n.toast-container {\n    width: max-content;\n    max-width: 100%;\n    pointer-events: none\n}\n\n.toast-container > :not(:last-child) {\n    margin-bottom: 1rem\n}\n\n.toast-header {\n    display: flex;\n    align-items: center;\n    padding: .25rem .75rem;\n    color: #4b5563;\n    background-color: rgba(255, 255, 255, .85);\n    background-clip: padding-box;\n    border-bottom: 1px solid rgba(0, 0, 0, .05);\n    border-top-left-radius: calc(.5rem - 1px);\n    border-top-right-radius: calc(.5rem - 1px)\n}\n\n.toast-header .btn-close {\n    margin-right: -.375rem;\n    margin-left: .75rem\n}\n\n.toast-body {\n    padding: .75rem;\n    word-wrap: break-word\n}\n\n.modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1050;\n    display: none;\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    outline: 0\n}\n\n.modal-dialog {\n    position: relative;\n    width: auto;\n    margin: .5rem;\n    pointer-events: none\n}\n\n.modal.fade .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(0, -50px)\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .modal.fade .modal-dialog {\n        transition: none\n    }\n}\n\n.modal.show .modal-dialog {\n    transform: none\n}\n\n.modal.modal-static .modal-dialog {\n    transform: scale(1.02)\n}\n\n.modal-dialog-scrollable {\n    height: calc(100% - 1rem)\n}\n\n.modal-dialog-scrollable .modal-content {\n    max-height: 100%;\n    overflow: hidden\n}\n\n.modal-dialog-scrollable .modal-body {\n    overflow-y: auto\n}\n\n.modal-dialog-centered {\n    display: flex;\n    align-items: center;\n    min-height: calc(100% - 1rem)\n}\n\n.modal-content {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    pointer-events: auto;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: .0625rem solid rgba(17, 24, 39, .2);\n    border-radius: .5rem;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    outline: 0\n}\n\n.modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1040;\n    width: 100vw;\n    height: 100vh;\n    background-color: #111827\n}\n\n.modal-backdrop.fade {\n    opacity: 0\n}\n\n.modal-backdrop.show {\n    opacity: .5\n}\n\n.modal-header {\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1rem;\n    border-bottom: .0625rem solid #e5e7eb;\n    border-top-left-radius: .4375rem;\n    border-top-right-radius: .4375rem\n}\n\n.modal-header .btn-close {\n    padding: .5rem .5rem;\n    margin: -.5rem -.5rem -.5rem auto\n}\n\n.modal-title {\n    margin-bottom: 0;\n    line-height: 1.5\n}\n\n.modal-body {\n    position: relative;\n    flex: 1 1 auto;\n    padding: 1rem\n}\n\n.modal-footer {\n    display: flex;\n    flex-wrap: wrap;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: flex-end;\n    padding: .75rem;\n    border-top: .0625rem solid #e5e7eb;\n    border-bottom-right-radius: .4375rem;\n    border-bottom-left-radius: .4375rem\n}\n\n.modal-footer > * {\n    margin: .25rem\n}\n\n@media (min-width: 576px) {\n    .modal-dialog {\n        max-width: 500px;\n        margin: 1.75rem auto\n    }\n\n    .modal-dialog-scrollable {\n        height: calc(100% - 3.5rem)\n    }\n\n    .modal-dialog-centered {\n        min-height: calc(100% - 3.5rem)\n    }\n\n    .modal-content {\n        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n    }\n\n    .modal-sm {\n        max-width: 300px\n    }\n}\n\n@media (min-width: 992px) {\n\n    .modal-lg,\n    .modal-xl {\n        max-width: 800px\n    }\n}\n\n@media (min-width: 1200px) {\n    .modal-xl {\n        max-width: 1140px\n    }\n}\n\n.modal-fullscreen {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0\n}\n\n.modal-fullscreen .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0\n}\n\n.modal-fullscreen .modal-header {\n    border-radius: 0\n}\n\n.modal-fullscreen .modal-body {\n    overflow-y: auto\n}\n\n.modal-fullscreen .modal-footer {\n    border-radius: 0\n}\n\n@media (max-width: 575.98px) {\n    .modal-fullscreen-sm-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-header {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-sm-down .modal-body {\n        overflow-y: auto\n    }\n\n    .modal-fullscreen-sm-down .modal-footer {\n        border-radius: 0\n    }\n}\n\n@media (max-width: 767.98px) {\n    .modal-fullscreen-md-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-md-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-md-down .modal-header {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-md-down .modal-body {\n        overflow-y: auto\n    }\n\n    .modal-fullscreen-md-down .modal-footer {\n        border-radius: 0\n    }\n}\n\n@media (max-width: 991.98px) {\n    .modal-fullscreen-lg-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-header {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-lg-down .modal-body {\n        overflow-y: auto\n    }\n\n    .modal-fullscreen-lg-down .modal-footer {\n        border-radius: 0\n    }\n}\n\n@media (max-width: 1199.98px) {\n    .modal-fullscreen-xl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-header {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xl-down .modal-body {\n        overflow-y: auto\n    }\n\n    .modal-fullscreen-xl-down .modal-footer {\n        border-radius: 0\n    }\n}\n\n@media (max-width: 1399.98px) {\n    .modal-fullscreen-xxl-down {\n        width: 100vw;\n        max-width: none;\n        height: 100%;\n        margin: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-content {\n        height: 100%;\n        border: 0;\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-header {\n        border-radius: 0\n    }\n\n    .modal-fullscreen-xxl-down .modal-body {\n        overflow-y: auto\n    }\n\n    .modal-fullscreen-xxl-down .modal-footer {\n        border-radius: 0\n    }\n}\n\n.tooltip {\n    position: absolute;\n    z-index: 1070;\n    display: block;\n    margin: 2rem;\n    font-family: var(--bs-font-sans-serif);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: .875rem;\n    word-wrap: break-word;\n    opacity: 0\n}\n\n.tooltip.show {\n    opacity: .99\n}\n\n.tooltip .tooltip-arrow {\n    position: absolute;\n    display: block;\n    width: .8rem;\n    height: .4rem\n}\n\n.tooltip .tooltip-arrow::before {\n    position: absolute;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid\n}\n\n.bs-tooltip-auto[data-popper-placement^=top],\n.bs-tooltip-top {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow,\n.bs-tooltip-top .tooltip-arrow {\n    bottom: 0\n}\n\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before,\n.bs-tooltip-top .tooltip-arrow::before {\n    top: -1px;\n    border-width: .4rem .4rem 0;\n    border-top-color: #1f2937\n}\n\n.bs-tooltip-auto[data-popper-placement^=right],\n.bs-tooltip-end {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow,\n.bs-tooltip-end .tooltip-arrow {\n    left: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before,\n.bs-tooltip-end .tooltip-arrow::before {\n    right: -1px;\n    border-width: .4rem .4rem .4rem 0;\n    border-right-color: #1f2937\n}\n\n.bs-tooltip-auto[data-popper-placement^=bottom],\n.bs-tooltip-bottom {\n    padding: .4rem 0\n}\n\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow,\n.bs-tooltip-bottom .tooltip-arrow {\n    top: 0\n}\n\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before,\n.bs-tooltip-bottom .tooltip-arrow::before {\n    bottom: -1px;\n    border-width: 0 .4rem .4rem;\n    border-bottom-color: #1f2937\n}\n\n.bs-tooltip-auto[data-popper-placement^=left],\n.bs-tooltip-start {\n    padding: 0 .4rem\n}\n\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow,\n.bs-tooltip-start .tooltip-arrow {\n    right: 0;\n    width: .4rem;\n    height: .8rem\n}\n\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before,\n.bs-tooltip-start .tooltip-arrow::before {\n    left: -1px;\n    border-width: .4rem 0 .4rem .4rem;\n    border-left-color: #1f2937\n}\n\n.tooltip-inner {\n    max-width: 200px;\n    padding: .375rem .55rem;\n    color: #fff;\n    text-align: center;\n    background-color: #1f2937;\n    border-radius: .5rem\n}\n\n.popover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 1060;\n    display: block;\n    max-width: 276px;\n    font-family: var(--bs-font-sans-serif);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5;\n    text-align: left;\n    text-align: start;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-break: normal;\n    word-spacing: normal;\n    white-space: normal;\n    line-break: auto;\n    font-size: .875rem;\n    word-wrap: break-word;\n    background-color: #1f2937;\n    background-clip: padding-box;\n    border: .0625rem solid rgba(17, 24, 39, .2);\n    border-radius: 1rem;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n}\n\n.popover .popover-arrow {\n    position: absolute;\n    display: block;\n    width: 1rem;\n    height: .5rem\n}\n\n.popover .popover-arrow::after,\n.popover .popover-arrow::before {\n    position: absolute;\n    display: block;\n    content: \"\";\n    border-color: transparent;\n    border-style: solid\n}\n\n.bs-popover-auto[data-popper-placement^=top] > .popover-arrow,\n.bs-popover-top > .popover-arrow {\n    bottom: -.5625rem\n}\n\n.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,\n.bs-popover-top > .popover-arrow::before {\n    bottom: 0;\n    border-width: .5rem .5rem 0;\n    border-top-color: rgba(17, 24, 39, .25)\n}\n\n.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,\n.bs-popover-top > .popover-arrow::after {\n    bottom: .0625rem;\n    border-width: .5rem .5rem 0;\n    border-top-color: #1f2937\n}\n\n.bs-popover-auto[data-popper-placement^=right] > .popover-arrow,\n.bs-popover-end > .popover-arrow {\n    left: -.5625rem;\n    width: .5rem;\n    height: 1rem\n}\n\n.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,\n.bs-popover-end > .popover-arrow::before {\n    left: 0;\n    border-width: .5rem .5rem .5rem 0;\n    border-right-color: rgba(17, 24, 39, .25)\n}\n\n.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,\n.bs-popover-end > .popover-arrow::after {\n    left: .0625rem;\n    border-width: .5rem .5rem .5rem 0;\n    border-right-color: #1f2937\n}\n\n.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow,\n.bs-popover-bottom > .popover-arrow {\n    top: -.5625rem\n}\n\n.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,\n.bs-popover-bottom > .popover-arrow::before {\n    top: 0;\n    border-width: 0 .5rem .5rem .5rem;\n    border-bottom-color: rgba(17, 24, 39, .25)\n}\n\n.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,\n.bs-popover-bottom > .popover-arrow::after {\n    top: .0625rem;\n    border-width: 0 .5rem .5rem .5rem;\n    border-bottom-color: #1f2937\n}\n\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: 1rem;\n    margin-left: -.5rem;\n    content: \"\";\n    border-bottom: .0625rem solid #19222d\n}\n\n.bs-popover-auto[data-popper-placement^=left] > .popover-arrow,\n.bs-popover-start > .popover-arrow {\n    right: -.5625rem;\n    width: .5rem;\n    height: 1rem\n}\n\n.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,\n.bs-popover-start > .popover-arrow::before {\n    right: 0;\n    border-width: .5rem 0 .5rem .5rem;\n    border-left-color: rgba(17, 24, 39, .25)\n}\n\n.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,\n.bs-popover-start > .popover-arrow::after {\n    right: .0625rem;\n    border-width: .5rem 0 .5rem .5rem;\n    border-left-color: #1f2937\n}\n\n.popover-header {\n    padding: .5rem 1rem;\n    margin-bottom: 0;\n    font-size: 1rem;\n    color: #fff;\n    background-color: #19222d;\n    border-bottom: .0625rem solid #171e29;\n    border-top-left-radius: .9375rem;\n    border-top-right-radius: .9375rem\n}\n\n.popover-header:empty {\n    display: none\n}\n\n.popover-body {\n    padding: 1rem 1rem;\n    color: #fff\n}\n\n.carousel {\n    position: relative\n}\n\n.carousel.pointer-event {\n    touch-action: pan-y\n}\n\n.carousel-inner {\n    position: relative;\n    width: 100%;\n    overflow: hidden\n}\n\n.carousel-inner::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.carousel-item {\n    position: relative;\n    display: none;\n    float: left;\n    width: 100%;\n    margin-right: -100%;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    transition: transform .6s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .carousel-item {\n        transition: none\n    }\n}\n\n.carousel-item-next,\n.carousel-item-prev,\n.carousel-item.active {\n    display: block\n}\n\n.active.carousel-item-end,\n.carousel-item-next:not(.carousel-item-start) {\n    transform: translateX(100%)\n}\n\n.active.carousel-item-start,\n.carousel-item-prev:not(.carousel-item-end) {\n    transform: translateX(-100%)\n}\n\n.carousel-fade .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none\n}\n\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end,\n.carousel-fade .carousel-item.active {\n    z-index: 1;\n    opacity: 1\n}\n\n.carousel-fade .active.carousel-item-end,\n.carousel-fade .active.carousel-item-start {\n    z-index: 0;\n    opacity: 0;\n    transition: opacity 0s .6s\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .carousel-fade .active.carousel-item-end,\n    .carousel-fade .active.carousel-item-start {\n        transition: none\n    }\n}\n\n.carousel-control-next,\n.carousel-control-prev {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 15%;\n    padding: 0;\n    color: #fff;\n    text-align: center;\n    background: 0 0;\n    border: 0;\n    opacity: .5;\n    transition: opacity .15s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .carousel-control-next,\n    .carousel-control-prev {\n        transition: none\n    }\n}\n\n.carousel-control-next:focus,\n.carousel-control-next:hover,\n.carousel-control-prev:focus,\n.carousel-control-prev:hover {\n    color: #fff;\n    text-decoration: none;\n    outline: 0;\n    opacity: .9\n}\n\n.carousel-control-prev {\n    left: 0\n}\n\n.carousel-control-next {\n    right: 0\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-position: 50%;\n    background-size: 100% 100%\n}\n\n.carousel-control-prev-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23ffffff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\")\n}\n\n.carousel-control-next-icon {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23ffffff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\")\n}\n\n.carousel-indicators {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 2;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    margin-right: 15%;\n    margin-bottom: 1rem;\n    margin-left: 15%;\n    list-style: none\n}\n\n.carousel-indicators [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: 30px;\n    height: 3px;\n    padding: 0;\n    margin-right: 3px;\n    margin-left: 3px;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 0;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    opacity: .5;\n    transition: opacity .6s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .carousel-indicators [data-bs-target] {\n        transition: none\n    }\n}\n\n.carousel-indicators .active {\n    opacity: 1\n}\n\n.carousel-caption {\n    position: absolute;\n    right: 15%;\n    bottom: 1.25rem;\n    left: 15%;\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n    color: #fff;\n    text-align: center\n}\n\n.carousel-dark .carousel-control-next-icon,\n.carousel-dark .carousel-control-prev-icon {\n    filter: invert(1) grayscale(100)\n}\n\n.carousel-dark .carousel-indicators [data-bs-target] {\n    background-color: #111827\n}\n\n.carousel-dark .carousel-caption {\n    color: #111827\n}\n\n@keyframes spinner-border {\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n.spinner-border {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    vertical-align: -.125em;\n    border: .25em solid currentColor;\n    border-right-color: transparent;\n    border-radius: 50%;\n    animation: .75s linear infinite spinner-border\n}\n\n.spinner-border-sm {\n    width: 1.2rem;\n    height: 1.2rem;\n    border-width: .2em\n}\n\n@keyframes spinner-grow {\n    0% {\n        transform: scale(0)\n    }\n\n    50% {\n        opacity: 1;\n        transform: none\n    }\n}\n\n.spinner-grow {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n    vertical-align: -.125em;\n    background-color: currentColor;\n    border-radius: 50%;\n    opacity: 0;\n    animation: .75s linear infinite spinner-grow\n}\n\n.spinner-grow-sm {\n    width: 1.2rem;\n    height: 1.2rem\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n    .spinner-border,\n    .spinner-grow {\n        animation-duration: 1.5s\n    }\n}\n\n.clearfix::after {\n    display: block;\n    clear: both;\n    content: \"\"\n}\n\n.link-primary {\n    color: #1f2937\n}\n\n.link-primary:focus,\n.link-primary:hover {\n    color: #19212c\n}\n\n.link-secondary {\n    color: #f0bc74\n}\n\n.link-secondary:focus,\n.link-secondary:hover {\n    color: #f3c990\n}\n\n.link-tertiary {\n    color: #31316a\n}\n\n.link-tertiary:focus,\n.link-tertiary:hover {\n    color: #272755\n}\n\n.link-success {\n    color: #10b981\n}\n\n.link-success:focus,\n.link-success:hover {\n    color: #40c79a\n}\n\n.link-info {\n    color: #2361ce\n}\n\n.link-info:focus,\n.link-info:hover {\n    color: #1c4ea5\n}\n\n.link-warning {\n    color: #fba918\n}\n\n.link-warning:focus,\n.link-warning:hover {\n    color: #fcba46\n}\n\n.link-danger {\n    color: #e11d48\n}\n\n.link-danger:focus,\n.link-danger:hover {\n    color: #b4173a\n}\n\n.link-white {\n    color: #fff\n}\n\n.link-white:focus,\n.link-white:hover {\n    color: #fff\n}\n\n.link-indigo {\n    color: #4f46e5\n}\n\n.link-indigo:focus,\n.link-indigo:hover {\n    color: #3f38b7\n}\n\n.link-purple {\n    color: #7c3aed\n}\n\n.link-purple:focus,\n.link-purple:hover {\n    color: #632ebe\n}\n\n.link-yellow-100 {\n    color: #ffeed6\n}\n\n.link-yellow-100:focus,\n.link-yellow-100:hover {\n    color: #fff1de\n}\n\n.link-yellow-200 {\n    color: #f5dbb8\n}\n\n.link-yellow-200:focus,\n.link-yellow-200:hover {\n    color: #f7e2c6\n}\n\n.link-gray-50 {\n    color: #f9fafb\n}\n\n.link-gray-50:focus,\n.link-gray-50:hover {\n    color: #fafbfc\n}\n\n.link-gray-100 {\n    color: #f2f4f6\n}\n\n.link-gray-100:focus,\n.link-gray-100:hover {\n    color: #f5f6f8\n}\n\n.link-gray-200 {\n    color: #e5e7eb\n}\n\n.link-gray-200:focus,\n.link-gray-200:hover {\n    color: #eaecef\n}\n\n.link-gray-300 {\n    color: #d1d5db\n}\n\n.link-gray-300:focus,\n.link-gray-300:hover {\n    color: #dadde2\n}\n\n.link-gray-400 {\n    color: #9ca3af\n}\n\n.link-gray-400:focus,\n.link-gray-400:hover {\n    color: #b0b5bf\n}\n\n.link-gray-500 {\n    color: #6b7280\n}\n\n.link-gray-500:focus,\n.link-gray-500:hover {\n    color: #565b66\n}\n\n.link-gray-600 {\n    color: #4b5563\n}\n\n.link-gray-600:focus,\n.link-gray-600:hover {\n    color: #3c444f\n}\n\n.link-gray-700 {\n    color: #374151\n}\n\n.link-gray-700:focus,\n.link-gray-700:hover {\n    color: #2c3441\n}\n\n.link-gray-800 {\n    color: #1f2937\n}\n\n.link-gray-800:focus,\n.link-gray-800:hover {\n    color: #19212c\n}\n\n.link-gray-900 {\n    color: #111827\n}\n\n.link-gray-900:focus,\n.link-gray-900:hover {\n    color: #0e131f\n}\n\n.ratio {\n    position: relative;\n    width: 100%\n}\n\n.ratio::before {\n    display: block;\n    padding-top: var(--bs-aspect-ratio);\n    content: \"\"\n}\n\n.ratio > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\n}\n\n.ratio-1x1 {\n    --bs-aspect-ratio: 100%\n}\n\n.ratio-4x3 {\n    --bs-aspect-ratio: calc(3 / 4 * 100%)\n}\n\n.ratio-16x9 {\n    --bs-aspect-ratio: calc(9 / 16 * 100%)\n}\n\n.ratio-21x9 {\n    --bs-aspect-ratio: calc(9 / 21 * 100%)\n}\n\n.fixed-top {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.fixed-bottom {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1030\n}\n\n.sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020\n}\n\n@media (min-width: 576px) {\n    .sticky-sm-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n@media (min-width: 768px) {\n    .sticky-md-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n@media (min-width: 992px) {\n    .sticky-lg-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n@media (min-width: 1200px) {\n    .sticky-xl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n@media (min-width: 1400px) {\n    .sticky-xxl-top {\n        position: sticky;\n        top: 0;\n        z-index: 1020\n    }\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n    position: absolute !important;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    clip: rect(0, 0, 0, 0) !important;\n    white-space: nowrap !important;\n    border: 0 !important\n}\n\n.stretched-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    content: \"\"\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.align-baseline {\n    vertical-align: baseline !important\n}\n\n.align-top {\n    vertical-align: top !important\n}\n\n.align-middle {\n    vertical-align: middle !important\n}\n\n.align-bottom {\n    vertical-align: bottom !important\n}\n\n.align-text-bottom {\n    vertical-align: text-bottom !important\n}\n\n.align-text-top {\n    vertical-align: text-top !important\n}\n\n.float-start {\n    float: left !important\n}\n\n.float-end {\n    float: right !important\n}\n\n.float-none {\n    float: none !important\n}\n\n.overflow-auto {\n    overflow: auto !important\n}\n\n.overflow-hidden {\n    overflow: hidden !important\n}\n\n.overflow-visible {\n    overflow: visible !important\n}\n\n.overflow-scroll {\n    overflow: scroll !important\n}\n\n.d-inline {\n    display: inline !important\n}\n\n.d-inline-block {\n    display: inline-block !important\n}\n\n.d-block {\n    display: block !important\n}\n\n.d-grid {\n    display: grid !important\n}\n\n.d-table {\n    display: table !important\n}\n\n.d-table-row {\n    display: table-row !important\n}\n\n.d-table-cell {\n    display: table-cell !important\n}\n\n.d-flex {\n    display: flex !important\n}\n\n.d-inline-flex {\n    display: inline-flex !important\n}\n\n.d-none {\n    display: none !important\n}\n\n.shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important\n}\n\n.shadow-sm {\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2) !important\n}\n\n.shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(17, 24, 39, .175) !important\n}\n\n.shadow-none {\n    box-shadow: none !important\n}\n\n.position-static {\n    position: static !important\n}\n\n.position-relative {\n    position: relative !important\n}\n\n.position-absolute {\n    position: absolute !important\n}\n\n.position-fixed {\n    position: fixed !important\n}\n\n.position-sticky {\n    position: sticky !important\n}\n\n.top-0 {\n    top: 0 !important\n}\n\n.top-50 {\n    top: 50% !important\n}\n\n.top-100 {\n    top: 100% !important\n}\n\n.bottom-0 {\n    bottom: 0 !important\n}\n\n.bottom-50 {\n    bottom: 50% !important\n}\n\n.bottom-100 {\n    bottom: 100% !important\n}\n\n.start-0 {\n    left: 0 !important\n}\n\n.start-50 {\n    left: 50% !important\n}\n\n.start-100 {\n    left: 100% !important\n}\n\n.end-0 {\n    right: 0 !important\n}\n\n.end-50 {\n    right: 50% !important\n}\n\n.end-100 {\n    right: 100% !important\n}\n\n.translate-middle {\n    transform: translate(-50%, -50%) !important\n}\n\n.translate-middle-x {\n    transform: translateX(-50%) !important\n}\n\n.translate-middle-y {\n    transform: translateY(-50%) !important\n}\n\n.border {\n    border: .0625rem solid #e5e7eb !important\n}\n\n.border-0 {\n    border: 0 !important\n}\n\n.border-top {\n    border-top: .0625rem solid #e5e7eb !important\n}\n\n.border-top-0 {\n    border-top: 0 !important\n}\n\n.border-end {\n    border-right: .0625rem solid #e5e7eb !important\n}\n\n.border-end-0 {\n    border-right: 0 !important\n}\n\n.border-bottom {\n    border-bottom: .0625rem solid #e5e7eb !important\n}\n\n.border-bottom-0 {\n    border-bottom: 0 !important\n}\n\n.border-start {\n    border-left: .0625rem solid #e5e7eb !important\n}\n\n.border-start-0 {\n    border-left: 0 !important\n}\n\n.border-primary {\n    border-color: #1f2937 !important\n}\n\n.border-secondary {\n    border-color: #f0bc74 !important\n}\n\n.border-tertiary {\n    border-color: #31316a !important\n}\n\n.border-success {\n    border-color: #10b981 !important\n}\n\n.border-info {\n    border-color: #2361ce !important\n}\n\n.border-warning {\n    border-color: #fba918 !important\n}\n\n.border-danger {\n    border-color: #e11d48 !important\n}\n\n.border-white {\n    border-color: #fff !important\n}\n\n.border-indigo {\n    border-color: #4f46e5 !important\n}\n\n.border-purple {\n    border-color: #7c3aed !important\n}\n\n.border-yellow-100 {\n    border-color: #ffeed6 !important\n}\n\n.border-yellow-200 {\n    border-color: #f5dbb8 !important\n}\n\n.border-gray-50 {\n    border-color: #f9fafb !important\n}\n\n.border-gray-100 {\n    border-color: #f2f4f6 !important\n}\n\n.border-gray-200 {\n    border-color: #e5e7eb !important\n}\n\n.border-gray-300 {\n    border-color: #d1d5db !important\n}\n\n.border-gray-400 {\n    border-color: #9ca3af !important\n}\n\n.border-gray-500 {\n    border-color: #6b7280 !important\n}\n\n.border-gray-600 {\n    border-color: #4b5563 !important\n}\n\n.border-gray-700 {\n    border-color: #374151 !important\n}\n\n.border-gray-800 {\n    border-color: #1f2937 !important\n}\n\n.border-gray-900 {\n    border-color: #111827 !important\n}\n\n.border-1 {\n    border-width: 1px !important\n}\n\n.border-2 {\n    border-width: 2px !important\n}\n\n.border-3 {\n    border-width: 3px !important\n}\n\n.border-4 {\n    border-width: 4px !important\n}\n\n.border-5 {\n    border-width: 5px !important\n}\n\n.w-25 {\n    width: 25% !important\n}\n\n.w-50 {\n    width: 50% !important\n}\n\n.w-75 {\n    width: 75% !important\n}\n\n.w-100 {\n    width: 100% !important\n}\n\n.w-auto {\n    width: auto !important\n}\n\n.fmxw-100 {\n    max-width: 100px !important\n}\n\n.fmxw-200 {\n    max-width: 200px !important\n}\n\n.fmxw-300 {\n    max-width: 300px !important\n}\n\n.fmxw-400 {\n    max-width: 400px !important\n}\n\n.fmxw-500 {\n    max-width: 500px !important\n}\n\n.fmxw-999 {\n    max-width: 999px !important\n}\n\n.vw-100 {\n    width: 100vw !important\n}\n\n.min-vw-100 {\n    min-width: 100vw !important\n}\n\n.h-25 {\n    height: 25% !important\n}\n\n.h-50 {\n    height: 50% !important\n}\n\n.h-75 {\n    height: 75% !important\n}\n\n.h-100 {\n    height: 100% !important\n}\n\n.h-auto {\n    height: auto !important\n}\n\n.mh-100 {\n    max-height: 100% !important\n}\n\n.vh-100 {\n    height: 100vh !important\n}\n\n.min-vh-100 {\n    min-height: 100vh !important\n}\n\n.flex-fill {\n    flex: 1 1 auto !important\n}\n\n.flex-row {\n    flex-direction: row !important\n}\n\n.flex-column {\n    flex-direction: column !important\n}\n\n.flex-row-reverse {\n    flex-direction: row-reverse !important\n}\n\n.flex-column-reverse {\n    flex-direction: column-reverse !important\n}\n\n.flex-grow-0 {\n    flex-grow: 0 !important\n}\n\n.flex-grow-1 {\n    flex-grow: 1 !important\n}\n\n.flex-shrink-0 {\n    flex-shrink: 0 !important\n}\n\n.flex-shrink-1 {\n    flex-shrink: 1 !important\n}\n\n.flex-wrap {\n    flex-wrap: wrap !important\n}\n\n.flex-nowrap {\n    flex-wrap: nowrap !important\n}\n\n.flex-wrap-reverse {\n    flex-wrap: wrap-reverse !important\n}\n\n.gap-0 {\n    gap: 0 !important\n}\n\n.gap-1 {\n    gap: .25rem !important\n}\n\n.gap-2 {\n    gap: .5rem !important\n}\n\n.gap-3 {\n    gap: 1rem !important\n}\n\n.gap-4 {\n    gap: 1.5rem !important\n}\n\n.gap-5 {\n    gap: 3rem !important\n}\n\n.gap-6 {\n    gap: 5rem !important\n}\n\n.gap-7 {\n    gap: 8rem !important\n}\n\n.gap-8 {\n    gap: 10rem !important\n}\n\n.gap-9 {\n    gap: 11rem !important\n}\n\n.gap-10 {\n    gap: 14rem !important\n}\n\n.gap-11 {\n    gap: 16rem !important\n}\n\n.gap-12 {\n    gap: 20rem !important\n}\n\n.gap-sm {\n    gap: 1rem !important\n}\n\n.gap-md {\n    gap: 2rem !important\n}\n\n.gap-lg {\n    gap: 4rem !important\n}\n\n.gap-xl {\n    gap: 8rem !important\n}\n\n.justify-content-start {\n    justify-content: flex-start !important\n}\n\n.justify-content-end {\n    justify-content: flex-end !important\n}\n\n.justify-content-center {\n    justify-content: center !important\n}\n\n.justify-content-between {\n    justify-content: space-between !important\n}\n\n.justify-content-around {\n    justify-content: space-around !important\n}\n\n.justify-content-evenly {\n    justify-content: space-evenly !important\n}\n\n.align-items-start {\n    align-items: flex-start !important\n}\n\n.align-items-end {\n    align-items: flex-end !important\n}\n\n.align-items-center {\n    align-items: center !important\n}\n\n.align-items-baseline {\n    align-items: baseline !important\n}\n\n.align-items-stretch {\n    align-items: stretch !important\n}\n\n.align-content-start {\n    align-content: flex-start !important\n}\n\n.align-content-end {\n    align-content: flex-end !important\n}\n\n.align-content-center {\n    align-content: center !important\n}\n\n.align-content-between {\n    align-content: space-between !important\n}\n\n.align-content-around {\n    align-content: space-around !important\n}\n\n.align-content-stretch {\n    align-content: stretch !important\n}\n\n.align-self-auto {\n    align-self: auto !important\n}\n\n.align-self-start {\n    align-self: flex-start !important\n}\n\n.align-self-end {\n    align-self: flex-end !important\n}\n\n.align-self-center {\n    align-self: center !important\n}\n\n.align-self-baseline {\n    align-self: baseline !important\n}\n\n.align-self-stretch {\n    align-self: stretch !important\n}\n\n.order-first {\n    order: -1 !important\n}\n\n.order-0 {\n    order: 0 !important\n}\n\n.order-1 {\n    order: 1 !important\n}\n\n.order-2 {\n    order: 2 !important\n}\n\n.order-3 {\n    order: 3 !important\n}\n\n.order-4 {\n    order: 4 !important\n}\n\n.order-5 {\n    order: 5 !important\n}\n\n.order-last {\n    order: 6 !important\n}\n\n.m-0 {\n    margin: 0 !important\n}\n\n.m-1 {\n    margin: .25rem !important\n}\n\n.m-2 {\n    margin: .5rem !important\n}\n\n.m-3 {\n    margin: 1rem !important\n}\n\n.m-4 {\n    margin: 1.5rem !important\n}\n\n.m-5 {\n    margin: 3rem !important\n}\n\n.m-6 {\n    margin: 5rem !important\n}\n\n.m-7 {\n    margin: 8rem !important\n}\n\n.m-8 {\n    margin: 10rem !important\n}\n\n.m-9 {\n    margin: 11rem !important\n}\n\n.m-10 {\n    margin: 14rem !important\n}\n\n.m-11 {\n    margin: 16rem !important\n}\n\n.m-12 {\n    margin: 20rem !important\n}\n\n.m-sm {\n    margin: 1rem !important\n}\n\n.m-md {\n    margin: 2rem !important\n}\n\n.m-lg {\n    margin: 4rem !important\n}\n\n.m-xl {\n    margin: 8rem !important\n}\n\n.m-auto {\n    margin: auto !important\n}\n\n.mx-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important\n}\n\n.mx-1 {\n    margin-right: .25rem !important;\n    margin-left: .25rem !important\n}\n\n.mx-2 {\n    margin-right: .5rem !important;\n    margin-left: .5rem !important\n}\n\n.mx-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important\n}\n\n.mx-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important\n}\n\n.mx-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important\n}\n\n.mx-6 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important\n}\n\n.mx-7 {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important\n}\n\n.mx-8 {\n    margin-right: 10rem !important;\n    margin-left: 10rem !important\n}\n\n.mx-9 {\n    margin-right: 11rem !important;\n    margin-left: 11rem !important\n}\n\n.mx-10 {\n    margin-right: 14rem !important;\n    margin-left: 14rem !important\n}\n\n.mx-11 {\n    margin-right: 16rem !important;\n    margin-left: 16rem !important\n}\n\n.mx-12 {\n    margin-right: 20rem !important;\n    margin-left: 20rem !important\n}\n\n.mx-sm {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important\n}\n\n.mx-md {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important\n}\n\n.mx-lg {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important\n}\n\n.mx-xl {\n    margin-right: 8rem !important;\n    margin-left: 8rem !important\n}\n\n.mx-auto {\n    margin-right: auto !important;\n    margin-left: auto !important\n}\n\n.my-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important\n}\n\n.my-1 {\n    margin-top: .25rem !important;\n    margin-bottom: .25rem !important\n}\n\n.my-2 {\n    margin-top: .5rem !important;\n    margin-bottom: .5rem !important\n}\n\n.my-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important\n}\n\n.my-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important\n}\n\n.my-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important\n}\n\n.my-6 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important\n}\n\n.my-7 {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important\n}\n\n.my-8 {\n    margin-top: 10rem !important;\n    margin-bottom: 10rem !important\n}\n\n.my-9 {\n    margin-top: 11rem !important;\n    margin-bottom: 11rem !important\n}\n\n.my-10 {\n    margin-top: 14rem !important;\n    margin-bottom: 14rem !important\n}\n\n.my-11 {\n    margin-top: 16rem !important;\n    margin-bottom: 16rem !important\n}\n\n.my-12 {\n    margin-top: 20rem !important;\n    margin-bottom: 20rem !important\n}\n\n.my-sm {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important\n}\n\n.my-md {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important\n}\n\n.my-lg {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important\n}\n\n.my-xl {\n    margin-top: 8rem !important;\n    margin-bottom: 8rem !important\n}\n\n.my-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important\n}\n\n.mt-0 {\n    margin-top: 0 !important\n}\n\n.mt-1 {\n    margin-top: .25rem !important\n}\n\n.mt-2 {\n    margin-top: .5rem !important\n}\n\n.mt-3 {\n    margin-top: 1rem !important\n}\n\n.mt-4 {\n    margin-top: 1.5rem !important\n}\n\n.mt-5 {\n    margin-top: 3rem !important\n}\n\n.mt-6 {\n    margin-top: 5rem !important\n}\n\n.mt-7 {\n    margin-top: 8rem !important\n}\n\n.mt-8 {\n    margin-top: 10rem !important\n}\n\n.mt-9 {\n    margin-top: 11rem !important\n}\n\n.mt-10 {\n    margin-top: 14rem !important\n}\n\n.mt-11 {\n    margin-top: 16rem !important\n}\n\n.mt-12 {\n    margin-top: 20rem !important\n}\n\n.mt-sm {\n    margin-top: 1rem !important\n}\n\n.mt-md {\n    margin-top: 2rem !important\n}\n\n.mt-lg {\n    margin-top: 4rem !important\n}\n\n.mt-xl {\n    margin-top: 8rem !important\n}\n\n.mt-auto {\n    margin-top: auto !important\n}\n\n.me-0 {\n    margin-right: 0 !important\n}\n\n.me-1 {\n    margin-right: .25rem !important\n}\n\n.me-2 {\n    margin-right: .5rem !important\n}\n\n.me-3 {\n    margin-right: 1rem !important\n}\n\n.me-4 {\n    margin-right: 1.5rem !important\n}\n\n.me-5 {\n    margin-right: 3rem !important\n}\n\n.me-6 {\n    margin-right: 5rem !important\n}\n\n.me-7 {\n    margin-right: 8rem !important\n}\n\n.me-8 {\n    margin-right: 10rem !important\n}\n\n.me-9 {\n    margin-right: 11rem !important\n}\n\n.me-10 {\n    margin-right: 14rem !important\n}\n\n.me-11 {\n    margin-right: 16rem !important\n}\n\n.me-12 {\n    margin-right: 20rem !important\n}\n\n.me-sm {\n    margin-right: 1rem !important\n}\n\n.me-md {\n    margin-right: 2rem !important\n}\n\n.me-lg {\n    margin-right: 4rem !important\n}\n\n.me-xl {\n    margin-right: 8rem !important\n}\n\n.me-auto {\n    margin-right: auto !important\n}\n\n.mb-0 {\n    margin-bottom: 0 !important\n}\n\n.mb-1 {\n    margin-bottom: .25rem !important\n}\n\n.mb-2 {\n    margin-bottom: .5rem !important\n}\n\n.mb-3 {\n    margin-bottom: 1rem !important\n}\n\n.mb-4 {\n    margin-bottom: 1.5rem !important\n}\n\n.mb-5 {\n    margin-bottom: 3rem !important\n}\n\n.mb-6 {\n    margin-bottom: 5rem !important\n}\n\n.mb-7 {\n    margin-bottom: 8rem !important\n}\n\n.mb-8 {\n    margin-bottom: 10rem !important\n}\n\n.mb-9 {\n    margin-bottom: 11rem !important\n}\n\n.mb-10 {\n    margin-bottom: 14rem !important\n}\n\n.mb-11 {\n    margin-bottom: 16rem !important\n}\n\n.mb-12 {\n    margin-bottom: 20rem !important\n}\n\n.mb-sm {\n    margin-bottom: 1rem !important\n}\n\n.mb-md {\n    margin-bottom: 2rem !important\n}\n\n.mb-lg {\n    margin-bottom: 4rem !important\n}\n\n.mb-xl {\n    margin-bottom: 8rem !important\n}\n\n.mb-auto {\n    margin-bottom: auto !important\n}\n\n.ms-0 {\n    margin-left: 0 !important\n}\n\n.ms-1 {\n    margin-left: .25rem !important\n}\n\n.ms-2 {\n    margin-left: .5rem !important\n}\n\n.ms-3 {\n    margin-left: 1rem !important\n}\n\n.ms-4 {\n    margin-left: 1.5rem !important\n}\n\n.ms-5 {\n    margin-left: 3rem !important\n}\n\n.ms-6 {\n    margin-left: 5rem !important\n}\n\n.ms-7 {\n    margin-left: 8rem !important\n}\n\n.ms-8 {\n    margin-left: 10rem !important\n}\n\n.ms-9 {\n    margin-left: 11rem !important\n}\n\n.ms-10 {\n    margin-left: 14rem !important\n}\n\n.ms-11 {\n    margin-left: 16rem !important\n}\n\n.ms-12 {\n    margin-left: 20rem !important\n}\n\n.ms-sm {\n    margin-left: 1rem !important\n}\n\n.ms-md {\n    margin-left: 2rem !important\n}\n\n.ms-lg {\n    margin-left: 4rem !important\n}\n\n.ms-xl {\n    margin-left: 8rem !important\n}\n\n.ms-auto {\n    margin-left: auto !important\n}\n\n.m-n1 {\n    margin: -.25rem !important\n}\n\n.m-n2 {\n    margin: -.5rem !important\n}\n\n.m-n3 {\n    margin: -1rem !important\n}\n\n.m-n4 {\n    margin: -1.5rem !important\n}\n\n.m-n5 {\n    margin: -3rem !important\n}\n\n.m-n6 {\n    margin: -5rem !important\n}\n\n.m-n7 {\n    margin: -8rem !important\n}\n\n.m-n8 {\n    margin: -10rem !important\n}\n\n.m-n9 {\n    margin: -11rem !important\n}\n\n.m-n10 {\n    margin: -14rem !important\n}\n\n.m-n11 {\n    margin: -16rem !important\n}\n\n.m-n12 {\n    margin: -20rem !important\n}\n\n.m-nsm {\n    margin: -1rem !important\n}\n\n.m-nmd {\n    margin: -2rem !important\n}\n\n.m-nlg {\n    margin: -4rem !important\n}\n\n.m-nxl {\n    margin: -8rem !important\n}\n\n.mx-n1 {\n    margin-right: -.25rem !important;\n    margin-left: -.25rem !important\n}\n\n.mx-n2 {\n    margin-right: -.5rem !important;\n    margin-left: -.5rem !important\n}\n\n.mx-n3 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important\n}\n\n.mx-n4 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important\n}\n\n.mx-n5 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important\n}\n\n.mx-n6 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important\n}\n\n.mx-n7 {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important\n}\n\n.mx-n8 {\n    margin-right: -10rem !important;\n    margin-left: -10rem !important\n}\n\n.mx-n9 {\n    margin-right: -11rem !important;\n    margin-left: -11rem !important\n}\n\n.mx-n10 {\n    margin-right: -14rem !important;\n    margin-left: -14rem !important\n}\n\n.mx-n11 {\n    margin-right: -16rem !important;\n    margin-left: -16rem !important\n}\n\n.mx-n12 {\n    margin-right: -20rem !important;\n    margin-left: -20rem !important\n}\n\n.mx-nsm {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important\n}\n\n.mx-nmd {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important\n}\n\n.mx-nlg {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important\n}\n\n.mx-nxl {\n    margin-right: -8rem !important;\n    margin-left: -8rem !important\n}\n\n.my-n1 {\n    margin-top: -.25rem !important;\n    margin-bottom: -.25rem !important\n}\n\n.my-n2 {\n    margin-top: -.5rem !important;\n    margin-bottom: -.5rem !important\n}\n\n.my-n3 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important\n}\n\n.my-n4 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important\n}\n\n.my-n5 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important\n}\n\n.my-n6 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important\n}\n\n.my-n7 {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important\n}\n\n.my-n8 {\n    margin-top: -10rem !important;\n    margin-bottom: -10rem !important\n}\n\n.my-n9 {\n    margin-top: -11rem !important;\n    margin-bottom: -11rem !important\n}\n\n.my-n10 {\n    margin-top: -14rem !important;\n    margin-bottom: -14rem !important\n}\n\n.my-n11 {\n    margin-top: -16rem !important;\n    margin-bottom: -16rem !important\n}\n\n.my-n12 {\n    margin-top: -20rem !important;\n    margin-bottom: -20rem !important\n}\n\n.my-nsm {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important\n}\n\n.my-nmd {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important\n}\n\n.my-nlg {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important\n}\n\n.my-nxl {\n    margin-top: -8rem !important;\n    margin-bottom: -8rem !important\n}\n\n.mt-n1 {\n    margin-top: -.25rem !important\n}\n\n.mt-n2 {\n    margin-top: -.5rem !important\n}\n\n.mt-n3 {\n    margin-top: -1rem !important\n}\n\n.mt-n4 {\n    margin-top: -1.5rem !important\n}\n\n.mt-n5 {\n    margin-top: -3rem !important\n}\n\n.mt-n6 {\n    margin-top: -5rem !important\n}\n\n.mt-n7 {\n    margin-top: -8rem !important\n}\n\n.mt-n8 {\n    margin-top: -10rem !important\n}\n\n.mt-n9 {\n    margin-top: -11rem !important\n}\n\n.mt-n10 {\n    margin-top: -14rem !important\n}\n\n.mt-n11 {\n    margin-top: -16rem !important\n}\n\n.mt-n12 {\n    margin-top: -20rem !important\n}\n\n.mt-nsm {\n    margin-top: -1rem !important\n}\n\n.mt-nmd {\n    margin-top: -2rem !important\n}\n\n.mt-nlg {\n    margin-top: -4rem !important\n}\n\n.mt-nxl {\n    margin-top: -8rem !important\n}\n\n.me-n1 {\n    margin-right: -.25rem !important\n}\n\n.me-n2 {\n    margin-right: -.5rem !important\n}\n\n.me-n3 {\n    margin-right: -1rem !important\n}\n\n.me-n4 {\n    margin-right: -1.5rem !important\n}\n\n.me-n5 {\n    margin-right: -3rem !important\n}\n\n.me-n6 {\n    margin-right: -5rem !important\n}\n\n.me-n7 {\n    margin-right: -8rem !important\n}\n\n.me-n8 {\n    margin-right: -10rem !important\n}\n\n.me-n9 {\n    margin-right: -11rem !important\n}\n\n.me-n10 {\n    margin-right: -14rem !important\n}\n\n.me-n11 {\n    margin-right: -16rem !important\n}\n\n.me-n12 {\n    margin-right: -20rem !important\n}\n\n.me-nsm {\n    margin-right: -1rem !important\n}\n\n.me-nmd {\n    margin-right: -2rem !important\n}\n\n.me-nlg {\n    margin-right: -4rem !important\n}\n\n.me-nxl {\n    margin-right: -8rem !important\n}\n\n.mb-n1 {\n    margin-bottom: -.25rem !important\n}\n\n.mb-n2 {\n    margin-bottom: -.5rem !important\n}\n\n.mb-n3 {\n    margin-bottom: -1rem !important\n}\n\n.mb-n4 {\n    margin-bottom: -1.5rem !important\n}\n\n.mb-n5 {\n    margin-bottom: -3rem !important\n}\n\n.mb-n6 {\n    margin-bottom: -5rem !important\n}\n\n.mb-n7 {\n    margin-bottom: -8rem !important\n}\n\n.mb-n8 {\n    margin-bottom: -10rem !important\n}\n\n.mb-n9 {\n    margin-bottom: -11rem !important\n}\n\n.mb-n10 {\n    margin-bottom: -14rem !important\n}\n\n.mb-n11 {\n    margin-bottom: -16rem !important\n}\n\n.mb-n12 {\n    margin-bottom: -20rem !important\n}\n\n.mb-nsm {\n    margin-bottom: -1rem !important\n}\n\n.mb-nmd {\n    margin-bottom: -2rem !important\n}\n\n.mb-nlg {\n    margin-bottom: -4rem !important\n}\n\n.mb-nxl {\n    margin-bottom: -8rem !important\n}\n\n.ms-n1 {\n    margin-left: -.25rem !important\n}\n\n.ms-n2 {\n    margin-left: -.5rem !important\n}\n\n.ms-n3 {\n    margin-left: -1rem !important\n}\n\n.ms-n4 {\n    margin-left: -1.5rem !important\n}\n\n.ms-n5 {\n    margin-left: -3rem !important\n}\n\n.ms-n6 {\n    margin-left: -5rem !important\n}\n\n.ms-n7 {\n    margin-left: -8rem !important\n}\n\n.ms-n8 {\n    margin-left: -10rem !important\n}\n\n.ms-n9 {\n    margin-left: -11rem !important\n}\n\n.ms-n10 {\n    margin-left: -14rem !important\n}\n\n.ms-n11 {\n    margin-left: -16rem !important\n}\n\n.ms-n12 {\n    margin-left: -20rem !important\n}\n\n.ms-nsm {\n    margin-left: -1rem !important\n}\n\n.ms-nmd {\n    margin-left: -2rem !important\n}\n\n.ms-nlg {\n    margin-left: -4rem !important\n}\n\n.ms-nxl {\n    margin-left: -8rem !important\n}\n\n.p-0 {\n    padding: 0 !important\n}\n\n.p-1 {\n    padding: .25rem !important\n}\n\n.p-2 {\n    padding: .5rem !important\n}\n\n.p-3 {\n    padding: 1rem !important\n}\n\n.p-4 {\n    padding: 1.5rem !important\n}\n\n.p-5 {\n    padding: 3rem !important\n}\n\n.p-6 {\n    padding: 5rem !important\n}\n\n.p-7 {\n    padding: 8rem !important\n}\n\n.p-8 {\n    padding: 10rem !important\n}\n\n.p-9 {\n    padding: 11rem !important\n}\n\n.p-10 {\n    padding: 14rem !important\n}\n\n.p-11 {\n    padding: 16rem !important\n}\n\n.p-12 {\n    padding: 20rem !important\n}\n\n.p-sm {\n    padding: 1rem !important\n}\n\n.p-md {\n    padding: 2rem !important\n}\n\n.p-lg {\n    padding: 4rem !important\n}\n\n.p-xl {\n    padding: 8rem !important\n}\n\n.px-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important\n}\n\n.px-1 {\n    padding-right: .25rem !important;\n    padding-left: .25rem !important\n}\n\n.px-2 {\n    padding-right: .5rem !important;\n    padding-left: .5rem !important\n}\n\n.px-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important\n}\n\n.px-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important\n}\n\n.px-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important\n}\n\n.px-6 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important\n}\n\n.px-7 {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important\n}\n\n.px-8 {\n    padding-right: 10rem !important;\n    padding-left: 10rem !important\n}\n\n.px-9 {\n    padding-right: 11rem !important;\n    padding-left: 11rem !important\n}\n\n.px-10 {\n    padding-right: 14rem !important;\n    padding-left: 14rem !important\n}\n\n.px-11 {\n    padding-right: 16rem !important;\n    padding-left: 16rem !important\n}\n\n.px-12 {\n    padding-right: 20rem !important;\n    padding-left: 20rem !important\n}\n\n.px-sm {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important\n}\n\n.px-md {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important\n}\n\n.px-lg {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important\n}\n\n.px-xl {\n    padding-right: 8rem !important;\n    padding-left: 8rem !important\n}\n\n.py-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important\n}\n\n.py-1 {\n    padding-top: .25rem !important;\n    padding-bottom: .25rem !important\n}\n\n.py-2 {\n    padding-top: .5rem !important;\n    padding-bottom: .5rem !important\n}\n\n.py-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important\n}\n\n.py-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important\n}\n\n.py-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important\n}\n\n.py-6 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important\n}\n\n.py-7 {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important\n}\n\n.py-8 {\n    padding-top: 10rem !important;\n    padding-bottom: 10rem !important\n}\n\n.py-9 {\n    padding-top: 11rem !important;\n    padding-bottom: 11rem !important\n}\n\n.py-10 {\n    padding-top: 14rem !important;\n    padding-bottom: 14rem !important\n}\n\n.py-11 {\n    padding-top: 16rem !important;\n    padding-bottom: 16rem !important\n}\n\n.py-12 {\n    padding-top: 20rem !important;\n    padding-bottom: 20rem !important\n}\n\n.py-sm {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important\n}\n\n.py-md {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important\n}\n\n.py-lg {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important\n}\n\n.py-xl {\n    padding-top: 8rem !important;\n    padding-bottom: 8rem !important\n}\n\n.pt-0 {\n    padding-top: 0 !important\n}\n\n.pt-1 {\n    padding-top: .25rem !important\n}\n\n.pt-2 {\n    padding-top: .5rem !important\n}\n\n.pt-3 {\n    padding-top: 1rem !important\n}\n\n.pt-4 {\n    padding-top: 1.5rem !important\n}\n\n.pt-5 {\n    padding-top: 3rem !important\n}\n\n.pt-6 {\n    padding-top: 5rem !important\n}\n\n.pt-7 {\n    padding-top: 8rem !important\n}\n\n.pt-8 {\n    padding-top: 10rem !important\n}\n\n.pt-9 {\n    padding-top: 11rem !important\n}\n\n.pt-10 {\n    padding-top: 14rem !important\n}\n\n.pt-11 {\n    padding-top: 16rem !important\n}\n\n.pt-12 {\n    padding-top: 20rem !important\n}\n\n.pt-sm {\n    padding-top: 1rem !important\n}\n\n.pt-md {\n    padding-top: 2rem !important\n}\n\n.pt-lg {\n    padding-top: 4rem !important\n}\n\n.pt-xl {\n    padding-top: 8rem !important\n}\n\n.pe-0 {\n    padding-right: 0 !important\n}\n\n.pe-1 {\n    padding-right: .25rem !important\n}\n\n.pe-2 {\n    padding-right: .5rem !important\n}\n\n.pe-3 {\n    padding-right: 1rem !important\n}\n\n.pe-4 {\n    padding-right: 1.5rem !important\n}\n\n.pe-5 {\n    padding-right: 3rem !important\n}\n\n.pe-6 {\n    padding-right: 5rem !important\n}\n\n.pe-7 {\n    padding-right: 8rem !important\n}\n\n.pe-8 {\n    padding-right: 10rem !important\n}\n\n.pe-9 {\n    padding-right: 11rem !important\n}\n\n.pe-10 {\n    padding-right: 14rem !important\n}\n\n.pe-11 {\n    padding-right: 16rem !important\n}\n\n.pe-12 {\n    padding-right: 20rem !important\n}\n\n.pe-sm {\n    padding-right: 1rem !important\n}\n\n.pe-md {\n    padding-right: 2rem !important\n}\n\n.pe-lg {\n    padding-right: 4rem !important\n}\n\n.pe-xl {\n    padding-right: 8rem !important\n}\n\n.pb-0 {\n    padding-bottom: 0 !important\n}\n\n.pb-1 {\n    padding-bottom: .25rem !important\n}\n\n.pb-2 {\n    padding-bottom: .5rem !important\n}\n\n.pb-3 {\n    padding-bottom: 1rem !important\n}\n\n.pb-4 {\n    padding-bottom: 1.5rem !important\n}\n\n.pb-5 {\n    padding-bottom: 3rem !important\n}\n\n.pb-6 {\n    padding-bottom: 5rem !important\n}\n\n.pb-7 {\n    padding-bottom: 8rem !important\n}\n\n.pb-8 {\n    padding-bottom: 10rem !important\n}\n\n.pb-9 {\n    padding-bottom: 11rem !important\n}\n\n.pb-10 {\n    padding-bottom: 14rem !important\n}\n\n.pb-11 {\n    padding-bottom: 16rem !important\n}\n\n.pb-12 {\n    padding-bottom: 20rem !important\n}\n\n.pb-sm {\n    padding-bottom: 1rem !important\n}\n\n.pb-md {\n    padding-bottom: 2rem !important\n}\n\n.pb-lg {\n    padding-bottom: 4rem !important\n}\n\n.pb-xl {\n    padding-bottom: 8rem !important\n}\n\n.ps-0 {\n    padding-left: 0 !important\n}\n\n.ps-1 {\n    padding-left: .25rem !important\n}\n\n.ps-2 {\n    padding-left: .5rem !important\n}\n\n.ps-3 {\n    padding-left: 1rem !important\n}\n\n.ps-4 {\n    padding-left: 1.5rem !important\n}\n\n.ps-5 {\n    padding-left: 3rem !important\n}\n\n.ps-6 {\n    padding-left: 5rem !important\n}\n\n.ps-7 {\n    padding-left: 8rem !important\n}\n\n.ps-8 {\n    padding-left: 10rem !important\n}\n\n.ps-9 {\n    padding-left: 11rem !important\n}\n\n.ps-10 {\n    padding-left: 14rem !important\n}\n\n.ps-11 {\n    padding-left: 16rem !important\n}\n\n.ps-12 {\n    padding-left: 20rem !important\n}\n\n.ps-sm {\n    padding-left: 1rem !important\n}\n\n.ps-md {\n    padding-left: 2rem !important\n}\n\n.ps-lg {\n    padding-left: 4rem !important\n}\n\n.ps-xl {\n    padding-left: 8rem !important\n}\n\n.font-monospace {\n    font-family: var(--bs-font-monospace) !important\n}\n\n.fs-1 {\n    font-size: calc(1.375rem + 1.5vw) !important\n}\n\n.fs-2 {\n    font-size: calc(1.325rem + .9vw) !important\n}\n\n.fs-3 {\n    font-size: calc(1.3rem + .6vw) !important\n}\n\n.fs-4 {\n    font-size: calc(1.275rem + .3vw) !important\n}\n\n.fs-5 {\n    font-size: 1.25rem !important\n}\n\n.fs-6 {\n    font-size: 1rem !important\n}\n\n.fst-italic {\n    font-style: italic !important\n}\n\n.fst-normal {\n    font-style: normal !important\n}\n\n.fw-light {\n    font-weight: 300 !important\n}\n\n.fw-lighter {\n    font-weight: lighter !important\n}\n\n.fw-normal {\n    font-weight: 400 !important\n}\n\n.fw-bold {\n    font-weight: 500 !important\n}\n\n.fw-bolder {\n    font-weight: 600 !important\n}\n\n.fw-extrabold {\n    font-weight: 700 !important\n}\n\n.fw-black {\n    font-weight: 800 !important\n}\n\n.lh-1 {\n    line-height: 1 !important\n}\n\n.lh-sm {\n    line-height: 1.25 !important\n}\n\n.lh-base {\n    line-height: 1.5 !important\n}\n\n.lh-lg {\n    line-height: 2 !important\n}\n\n.text-start {\n    text-align: left !important\n}\n\n.text-end {\n    text-align: right !important\n}\n\n.text-center {\n    text-align: center !important\n}\n\n.text-decoration-none {\n    text-decoration: none !important\n}\n\n.text-decoration-underline {\n    text-decoration: underline !important\n}\n\n.text-decoration-line-through {\n    text-decoration: line-through !important\n}\n\n.text-lowercase {\n    text-transform: lowercase !important\n}\n\n.text-uppercase {\n    text-transform: uppercase !important\n}\n\n.text-capitalize {\n    text-transform: capitalize !important\n}\n\n.text-wrap {\n    white-space: normal !important\n}\n\n.text-nowrap {\n    white-space: nowrap !important\n}\n\n.text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important\n}\n\n.text-primary {\n    color: #1f2937 !important\n}\n\n.text-secondary {\n    color: #f0bc74 !important\n}\n\n.text-tertiary {\n    color: #31316a !important\n}\n\n.text-success {\n    color: #10b981 !important\n}\n\n.text-info {\n    color: #2361ce !important\n}\n\n.text-warning {\n    color: #fba918 !important\n}\n\n.text-danger {\n    color: #e11d48 !important\n}\n\n.text-white {\n    color: #fff !important\n}\n\n.text-indigo {\n    color: #4f46e5 !important\n}\n\n.text-purple {\n    color: #7c3aed !important\n}\n\n.text-yellow-100 {\n    color: #ffeed6 !important\n}\n\n.text-yellow-200 {\n    color: #f5dbb8 !important\n}\n\n.text-gray-50 {\n    color: #f9fafb !important\n}\n\n.text-gray-100 {\n    color: #f2f4f6 !important\n}\n\n.text-gray-200 {\n    color: #e5e7eb !important\n}\n\n.text-gray-300 {\n    color: #d1d5db !important\n}\n\n.text-gray-400 {\n    color: #9ca3af !important\n}\n\n.text-gray-500 {\n    color: #6b7280 !important\n}\n\n.text-gray-600 {\n    color: #4b5563 !important\n}\n\n.text-gray-700 {\n    color: #374151 !important\n}\n\n.text-gray-800 {\n    color: #1f2937 !important\n}\n\n.text-gray-900 {\n    color: #111827 !important\n}\n\n.text-body {\n    color: #374151 !important\n}\n\n.text-muted {\n    color: #58677d !important\n}\n\n.text-black-50 {\n    color: rgba(17, 24, 39, .5) !important\n}\n\n.text-white-50 {\n    color: rgba(255, 255, 255, .5) !important\n}\n\n.text-reset {\n    color: inherit !important\n}\n\n.bg-primary {\n    background-color: #1f2937 !important\n}\n\n.bg-secondary {\n    background-color: #f0bc74 !important\n}\n\n.bg-tertiary {\n    background-color: #31316a !important\n}\n\n.bg-success {\n    background-color: #10b981 !important\n}\n\n.bg-info {\n    background-color: #2361ce !important\n}\n\n.bg-warning {\n    background-color: #fba918 !important\n}\n\n.bg-danger {\n    background-color: #e11d48 !important\n}\n\n.bg-white {\n    background-color: #fff !important\n}\n\n.bg-indigo {\n    background-color: #4f46e5 !important\n}\n\n.bg-purple {\n    background-color: #7c3aed !important\n}\n\n.bg-yellow-100 {\n    background-color: #ffeed6 !important\n}\n\n.bg-yellow-200 {\n    background-color: #f5dbb8 !important\n}\n\n.bg-gray-50 {\n    background-color: #f9fafb !important\n}\n\n.bg-gray-100 {\n    background-color: #f2f4f6 !important\n}\n\n.bg-gray-200 {\n    background-color: #e5e7eb !important\n}\n\n.bg-gray-300 {\n    background-color: #d1d5db !important\n}\n\n.bg-gray-400 {\n    background-color: #9ca3af !important\n}\n\n.bg-gray-500 {\n    background-color: #6b7280 !important\n}\n\n.bg-gray-600 {\n    background-color: #4b5563 !important\n}\n\n.bg-gray-700 {\n    background-color: #374151 !important\n}\n\n.bg-gray-800 {\n    background-color: #1f2937 !important\n}\n\n.bg-gray-900 {\n    background-color: #111827 !important\n}\n\n.bg-body {\n    background-color: #f2f4f6 !important\n}\n\n.bg-transparent {\n    background-color: transparent !important\n}\n\n.bg-gradient {\n    background-image: var(--bs-gradient) !important\n}\n\n.user-select-all {\n    -webkit-user-select: all !important;\n    user-select: all !important\n}\n\n.user-select-auto {\n    -webkit-user-select: auto !important;\n    user-select: auto !important\n}\n\n.user-select-none {\n    -webkit-user-select: none !important;\n    user-select: none !important\n}\n\n.pe-none {\n    pointer-events: none !important\n}\n\n.pe-auto {\n    pointer-events: auto !important\n}\n\n.rounded {\n    border-radius: .5rem !important\n}\n\n.rounded-0 {\n    border-radius: 0 !important\n}\n\n.rounded-1 {\n    border-radius: .35rem !important\n}\n\n.rounded-2 {\n    border-radius: .5rem !important\n}\n\n.rounded-3 {\n    border-radius: 1rem !important\n}\n\n.rounded-circle {\n    border-radius: 50% !important\n}\n\n.rounded-pill {\n    border-radius: 50rem !important\n}\n\n.rounded-top {\n    border-top-left-radius: .5rem !important;\n    border-top-right-radius: .5rem !important\n}\n\n.rounded-end {\n    border-top-right-radius: .5rem !important;\n    border-bottom-right-radius: .5rem !important\n}\n\n.rounded-bottom {\n    border-bottom-right-radius: .5rem !important;\n    border-bottom-left-radius: .5rem !important\n}\n\n.rounded-start {\n    border-bottom-left-radius: .5rem !important;\n    border-top-left-radius: .5rem !important\n}\n\n.visible {\n    visibility: visible !important\n}\n\n.invisible {\n    visibility: hidden !important\n}\n\n.blur-0 {\n    -webkit-backdrop-filter: blur(0) !important;\n    backdrop-filter: blur(0) !important\n}\n\n.blur-1 {\n    -webkit-backdrop-filter: blur(1px) !important;\n    backdrop-filter: blur(1px) !important\n}\n\n.blur-2 {\n    -webkit-backdrop-filter: blur(2px) !important;\n    backdrop-filter: blur(2px) !important\n}\n\n.blur-3 {\n    -webkit-backdrop-filter: blur(3px) !important;\n    backdrop-filter: blur(3px) !important\n}\n\n.blur-4 {\n    -webkit-backdrop-filter: blur(4px) !important;\n    backdrop-filter: blur(4px) !important\n}\n\n.blur-5 {\n    -webkit-backdrop-filter: blur(5px) !important;\n    backdrop-filter: blur(5px) !important\n}\n\n.blur-6 {\n    -webkit-backdrop-filter: blur(6px) !important;\n    backdrop-filter: blur(6px) !important\n}\n\n.blur-7 {\n    -webkit-backdrop-filter: blur(7px) !important;\n    backdrop-filter: blur(7px) !important\n}\n\n.blur-8 {\n    -webkit-backdrop-filter: blur(8px) !important;\n    backdrop-filter: blur(8px) !important\n}\n\n.blur-9 {\n    -webkit-backdrop-filter: blur(91px) !important;\n    backdrop-filter: blur(91px) !important\n}\n\n.blur-10 {\n    -webkit-backdrop-filter: blur(10px) !important;\n    backdrop-filter: blur(10px) !important\n}\n\n.blur-11 {\n    -webkit-backdrop-filter: blur(11px) !important;\n    backdrop-filter: blur(11px) !important\n}\n\n.blur-12 {\n    -webkit-backdrop-filter: blur(12px) !important;\n    backdrop-filter: blur(12px) !important\n}\n\n.blur-13 {\n    -webkit-backdrop-filter: blur(13px) !important;\n    backdrop-filter: blur(13px) !important\n}\n\n.blur-14 {\n    -webkit-backdrop-filter: blur(14px) !important;\n    backdrop-filter: blur(14px) !important\n}\n\n.o-0 {\n    opacity: 0 !important\n}\n\n.o-25 {\n    opacity: .25 !important\n}\n\n.o-50 {\n    opacity: .5 !important\n}\n\n.o-75 {\n    opacity: .75 !important\n}\n\n.o-100 {\n    opacity: 1 !important\n}\n\n.z-0 {\n    z-index: 0 !important\n}\n\n.z-1 {\n    z-index: 1 !important\n}\n\n.z-2 {\n    z-index: 2 !important\n}\n\n.z-3 {\n    z-index: 3 !important\n}\n\n.z-999 {\n    z-index: 999 !important\n}\n\n.fmxh-100 {\n    min-height: 100px !important\n}\n\n.fmxh-200 {\n    min-height: 200px !important\n}\n\n.fmxh-300 {\n    min-height: 300px !important\n}\n\n.fmxh-400 {\n    min-height: 400px !important\n}\n\n.fmxh-500 {\n    min-height: 500px !important\n}\n\n.fmxh-999 {\n    min-height: 999px !important\n}\n\n@media (min-width: 576px) {\n    .float-sm-start {\n        float: left !important\n    }\n\n    .float-sm-end {\n        float: right !important\n    }\n\n    .float-sm-none {\n        float: none !important\n    }\n\n    .d-sm-inline {\n        display: inline !important\n    }\n\n    .d-sm-inline-block {\n        display: inline-block !important\n    }\n\n    .d-sm-block {\n        display: block !important\n    }\n\n    .d-sm-grid {\n        display: grid !important\n    }\n\n    .d-sm-table {\n        display: table !important\n    }\n\n    .d-sm-table-row {\n        display: table-row !important\n    }\n\n    .d-sm-table-cell {\n        display: table-cell !important\n    }\n\n    .d-sm-flex {\n        display: flex !important\n    }\n\n    .d-sm-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-sm-none {\n        display: none !important\n    }\n\n    .vh-sm-100 {\n        height: 100vh !important\n    }\n\n    .flex-sm-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-sm-row {\n        flex-direction: row !important\n    }\n\n    .flex-sm-column {\n        flex-direction: column !important\n    }\n\n    .flex-sm-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-sm-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-sm-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-sm-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-sm-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-sm-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-sm-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-sm-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-sm-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .gap-sm-0 {\n        gap: 0 !important\n    }\n\n    .gap-sm-1 {\n        gap: .25rem !important\n    }\n\n    .gap-sm-2 {\n        gap: .5rem !important\n    }\n\n    .gap-sm-3 {\n        gap: 1rem !important\n    }\n\n    .gap-sm-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-sm-5 {\n        gap: 3rem !important\n    }\n\n    .gap-sm-6 {\n        gap: 5rem !important\n    }\n\n    .gap-sm-7 {\n        gap: 8rem !important\n    }\n\n    .gap-sm-8 {\n        gap: 10rem !important\n    }\n\n    .gap-sm-9 {\n        gap: 11rem !important\n    }\n\n    .gap-sm-10 {\n        gap: 14rem !important\n    }\n\n    .gap-sm-11 {\n        gap: 16rem !important\n    }\n\n    .gap-sm-12 {\n        gap: 20rem !important\n    }\n\n    .gap-sm-sm {\n        gap: 1rem !important\n    }\n\n    .gap-sm-md {\n        gap: 2rem !important\n    }\n\n    .gap-sm-lg {\n        gap: 4rem !important\n    }\n\n    .gap-sm-xl {\n        gap: 8rem !important\n    }\n\n    .justify-content-sm-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-sm-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-sm-center {\n        justify-content: center !important\n    }\n\n    .justify-content-sm-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-sm-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-sm-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-sm-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-sm-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-sm-center {\n        align-items: center !important\n    }\n\n    .align-items-sm-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-sm-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-sm-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-sm-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-sm-center {\n        align-content: center !important\n    }\n\n    .align-content-sm-between {\n        align-content: space-between !important\n    }\n\n    .align-content-sm-around {\n        align-content: space-around !important\n    }\n\n    .align-content-sm-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-sm-auto {\n        align-self: auto !important\n    }\n\n    .align-self-sm-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-sm-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-sm-center {\n        align-self: center !important\n    }\n\n    .align-self-sm-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-sm-stretch {\n        align-self: stretch !important\n    }\n\n    .order-sm-first {\n        order: -1 !important\n    }\n\n    .order-sm-0 {\n        order: 0 !important\n    }\n\n    .order-sm-1 {\n        order: 1 !important\n    }\n\n    .order-sm-2 {\n        order: 2 !important\n    }\n\n    .order-sm-3 {\n        order: 3 !important\n    }\n\n    .order-sm-4 {\n        order: 4 !important\n    }\n\n    .order-sm-5 {\n        order: 5 !important\n    }\n\n    .order-sm-last {\n        order: 6 !important\n    }\n\n    .m-sm-0 {\n        margin: 0 !important\n    }\n\n    .m-sm-1 {\n        margin: .25rem !important\n    }\n\n    .m-sm-2 {\n        margin: .5rem !important\n    }\n\n    .m-sm-3 {\n        margin: 1rem !important\n    }\n\n    .m-sm-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-sm-5 {\n        margin: 3rem !important\n    }\n\n    .m-sm-6 {\n        margin: 5rem !important\n    }\n\n    .m-sm-7 {\n        margin: 8rem !important\n    }\n\n    .m-sm-8 {\n        margin: 10rem !important\n    }\n\n    .m-sm-9 {\n        margin: 11rem !important\n    }\n\n    .m-sm-10 {\n        margin: 14rem !important\n    }\n\n    .m-sm-11 {\n        margin: 16rem !important\n    }\n\n    .m-sm-12 {\n        margin: 20rem !important\n    }\n\n    .m-sm-sm {\n        margin: 1rem !important\n    }\n\n    .m-sm-md {\n        margin: 2rem !important\n    }\n\n    .m-sm-lg {\n        margin: 4rem !important\n    }\n\n    .m-sm-xl {\n        margin: 8rem !important\n    }\n\n    .m-sm-auto {\n        margin: auto !important\n    }\n\n    .mx-sm-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-sm-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-sm-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-sm-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-sm-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-sm-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-sm-6 {\n        margin-right: 5rem !important;\n        margin-left: 5rem !important\n    }\n\n    .mx-sm-7 {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-sm-8 {\n        margin-right: 10rem !important;\n        margin-left: 10rem !important\n    }\n\n    .mx-sm-9 {\n        margin-right: 11rem !important;\n        margin-left: 11rem !important\n    }\n\n    .mx-sm-10 {\n        margin-right: 14rem !important;\n        margin-left: 14rem !important\n    }\n\n    .mx-sm-11 {\n        margin-right: 16rem !important;\n        margin-left: 16rem !important\n    }\n\n    .mx-sm-12 {\n        margin-right: 20rem !important;\n        margin-left: 20rem !important\n    }\n\n    .mx-sm-sm {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-sm-md {\n        margin-right: 2rem !important;\n        margin-left: 2rem !important\n    }\n\n    .mx-sm-lg {\n        margin-right: 4rem !important;\n        margin-left: 4rem !important\n    }\n\n    .mx-sm-xl {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-sm-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-sm-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-sm-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-sm-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-sm-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-sm-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-sm-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-sm-6 {\n        margin-top: 5rem !important;\n        margin-bottom: 5rem !important\n    }\n\n    .my-sm-7 {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-sm-8 {\n        margin-top: 10rem !important;\n        margin-bottom: 10rem !important\n    }\n\n    .my-sm-9 {\n        margin-top: 11rem !important;\n        margin-bottom: 11rem !important\n    }\n\n    .my-sm-10 {\n        margin-top: 14rem !important;\n        margin-bottom: 14rem !important\n    }\n\n    .my-sm-11 {\n        margin-top: 16rem !important;\n        margin-bottom: 16rem !important\n    }\n\n    .my-sm-12 {\n        margin-top: 20rem !important;\n        margin-bottom: 20rem !important\n    }\n\n    .my-sm-sm {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-sm-md {\n        margin-top: 2rem !important;\n        margin-bottom: 2rem !important\n    }\n\n    .my-sm-lg {\n        margin-top: 4rem !important;\n        margin-bottom: 4rem !important\n    }\n\n    .my-sm-xl {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-sm-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-sm-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-sm-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-sm-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-sm-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-sm-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-sm-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-sm-6 {\n        margin-top: 5rem !important\n    }\n\n    .mt-sm-7 {\n        margin-top: 8rem !important\n    }\n\n    .mt-sm-8 {\n        margin-top: 10rem !important\n    }\n\n    .mt-sm-9 {\n        margin-top: 11rem !important\n    }\n\n    .mt-sm-10 {\n        margin-top: 14rem !important\n    }\n\n    .mt-sm-11 {\n        margin-top: 16rem !important\n    }\n\n    .mt-sm-12 {\n        margin-top: 20rem !important\n    }\n\n    .mt-sm-sm {\n        margin-top: 1rem !important\n    }\n\n    .mt-sm-md {\n        margin-top: 2rem !important\n    }\n\n    .mt-sm-lg {\n        margin-top: 4rem !important\n    }\n\n    .mt-sm-xl {\n        margin-top: 8rem !important\n    }\n\n    .mt-sm-auto {\n        margin-top: auto !important\n    }\n\n    .me-sm-0 {\n        margin-right: 0 !important\n    }\n\n    .me-sm-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-sm-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-sm-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-sm-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-sm-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-sm-6 {\n        margin-right: 5rem !important\n    }\n\n    .me-sm-7 {\n        margin-right: 8rem !important\n    }\n\n    .me-sm-8 {\n        margin-right: 10rem !important\n    }\n\n    .me-sm-9 {\n        margin-right: 11rem !important\n    }\n\n    .me-sm-10 {\n        margin-right: 14rem !important\n    }\n\n    .me-sm-11 {\n        margin-right: 16rem !important\n    }\n\n    .me-sm-12 {\n        margin-right: 20rem !important\n    }\n\n    .me-sm-sm {\n        margin-right: 1rem !important\n    }\n\n    .me-sm-md {\n        margin-right: 2rem !important\n    }\n\n    .me-sm-lg {\n        margin-right: 4rem !important\n    }\n\n    .me-sm-xl {\n        margin-right: 8rem !important\n    }\n\n    .me-sm-auto {\n        margin-right: auto !important\n    }\n\n    .mb-sm-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-sm-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-sm-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-sm-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-sm-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-sm-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-sm-6 {\n        margin-bottom: 5rem !important\n    }\n\n    .mb-sm-7 {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-sm-8 {\n        margin-bottom: 10rem !important\n    }\n\n    .mb-sm-9 {\n        margin-bottom: 11rem !important\n    }\n\n    .mb-sm-10 {\n        margin-bottom: 14rem !important\n    }\n\n    .mb-sm-11 {\n        margin-bottom: 16rem !important\n    }\n\n    .mb-sm-12 {\n        margin-bottom: 20rem !important\n    }\n\n    .mb-sm-sm {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-sm-md {\n        margin-bottom: 2rem !important\n    }\n\n    .mb-sm-lg {\n        margin-bottom: 4rem !important\n    }\n\n    .mb-sm-xl {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-sm-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-sm-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-sm-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-sm-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-sm-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-sm-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-sm-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-sm-6 {\n        margin-left: 5rem !important\n    }\n\n    .ms-sm-7 {\n        margin-left: 8rem !important\n    }\n\n    .ms-sm-8 {\n        margin-left: 10rem !important\n    }\n\n    .ms-sm-9 {\n        margin-left: 11rem !important\n    }\n\n    .ms-sm-10 {\n        margin-left: 14rem !important\n    }\n\n    .ms-sm-11 {\n        margin-left: 16rem !important\n    }\n\n    .ms-sm-12 {\n        margin-left: 20rem !important\n    }\n\n    .ms-sm-sm {\n        margin-left: 1rem !important\n    }\n\n    .ms-sm-md {\n        margin-left: 2rem !important\n    }\n\n    .ms-sm-lg {\n        margin-left: 4rem !important\n    }\n\n    .ms-sm-xl {\n        margin-left: 8rem !important\n    }\n\n    .ms-sm-auto {\n        margin-left: auto !important\n    }\n\n    .m-sm-n1 {\n        margin: -.25rem !important\n    }\n\n    .m-sm-n2 {\n        margin: -.5rem !important\n    }\n\n    .m-sm-n3 {\n        margin: -1rem !important\n    }\n\n    .m-sm-n4 {\n        margin: -1.5rem !important\n    }\n\n    .m-sm-n5 {\n        margin: -3rem !important\n    }\n\n    .m-sm-n6 {\n        margin: -5rem !important\n    }\n\n    .m-sm-n7 {\n        margin: -8rem !important\n    }\n\n    .m-sm-n8 {\n        margin: -10rem !important\n    }\n\n    .m-sm-n9 {\n        margin: -11rem !important\n    }\n\n    .m-sm-n10 {\n        margin: -14rem !important\n    }\n\n    .m-sm-n11 {\n        margin: -16rem !important\n    }\n\n    .m-sm-n12 {\n        margin: -20rem !important\n    }\n\n    .m-sm-nsm {\n        margin: -1rem !important\n    }\n\n    .m-sm-nmd {\n        margin: -2rem !important\n    }\n\n    .m-sm-nlg {\n        margin: -4rem !important\n    }\n\n    .m-sm-nxl {\n        margin: -8rem !important\n    }\n\n    .mx-sm-n1 {\n        margin-right: -.25rem !important;\n        margin-left: -.25rem !important\n    }\n\n    .mx-sm-n2 {\n        margin-right: -.5rem !important;\n        margin-left: -.5rem !important\n    }\n\n    .mx-sm-n3 {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-sm-n4 {\n        margin-right: -1.5rem !important;\n        margin-left: -1.5rem !important\n    }\n\n    .mx-sm-n5 {\n        margin-right: -3rem !important;\n        margin-left: -3rem !important\n    }\n\n    .mx-sm-n6 {\n        margin-right: -5rem !important;\n        margin-left: -5rem !important\n    }\n\n    .mx-sm-n7 {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .mx-sm-n8 {\n        margin-right: -10rem !important;\n        margin-left: -10rem !important\n    }\n\n    .mx-sm-n9 {\n        margin-right: -11rem !important;\n        margin-left: -11rem !important\n    }\n\n    .mx-sm-n10 {\n        margin-right: -14rem !important;\n        margin-left: -14rem !important\n    }\n\n    .mx-sm-n11 {\n        margin-right: -16rem !important;\n        margin-left: -16rem !important\n    }\n\n    .mx-sm-n12 {\n        margin-right: -20rem !important;\n        margin-left: -20rem !important\n    }\n\n    .mx-sm-nsm {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-sm-nmd {\n        margin-right: -2rem !important;\n        margin-left: -2rem !important\n    }\n\n    .mx-sm-nlg {\n        margin-right: -4rem !important;\n        margin-left: -4rem !important\n    }\n\n    .mx-sm-nxl {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .my-sm-n1 {\n        margin-top: -.25rem !important;\n        margin-bottom: -.25rem !important\n    }\n\n    .my-sm-n2 {\n        margin-top: -.5rem !important;\n        margin-bottom: -.5rem !important\n    }\n\n    .my-sm-n3 {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-sm-n4 {\n        margin-top: -1.5rem !important;\n        margin-bottom: -1.5rem !important\n    }\n\n    .my-sm-n5 {\n        margin-top: -3rem !important;\n        margin-bottom: -3rem !important\n    }\n\n    .my-sm-n6 {\n        margin-top: -5rem !important;\n        margin-bottom: -5rem !important\n    }\n\n    .my-sm-n7 {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .my-sm-n8 {\n        margin-top: -10rem !important;\n        margin-bottom: -10rem !important\n    }\n\n    .my-sm-n9 {\n        margin-top: -11rem !important;\n        margin-bottom: -11rem !important\n    }\n\n    .my-sm-n10 {\n        margin-top: -14rem !important;\n        margin-bottom: -14rem !important\n    }\n\n    .my-sm-n11 {\n        margin-top: -16rem !important;\n        margin-bottom: -16rem !important\n    }\n\n    .my-sm-n12 {\n        margin-top: -20rem !important;\n        margin-bottom: -20rem !important\n    }\n\n    .my-sm-nsm {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-sm-nmd {\n        margin-top: -2rem !important;\n        margin-bottom: -2rem !important\n    }\n\n    .my-sm-nlg {\n        margin-top: -4rem !important;\n        margin-bottom: -4rem !important\n    }\n\n    .my-sm-nxl {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .mt-sm-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mt-sm-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mt-sm-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mt-sm-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mt-sm-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mt-sm-n6 {\n        margin-top: -5rem !important\n    }\n\n    .mt-sm-n7 {\n        margin-top: -8rem !important\n    }\n\n    .mt-sm-n8 {\n        margin-top: -10rem !important\n    }\n\n    .mt-sm-n9 {\n        margin-top: -11rem !important\n    }\n\n    .mt-sm-n10 {\n        margin-top: -14rem !important\n    }\n\n    .mt-sm-n11 {\n        margin-top: -16rem !important\n    }\n\n    .mt-sm-n12 {\n        margin-top: -20rem !important\n    }\n\n    .mt-sm-nsm {\n        margin-top: -1rem !important\n    }\n\n    .mt-sm-nmd {\n        margin-top: -2rem !important\n    }\n\n    .mt-sm-nlg {\n        margin-top: -4rem !important\n    }\n\n    .mt-sm-nxl {\n        margin-top: -8rem !important\n    }\n\n    .me-sm-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .me-sm-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .me-sm-n3 {\n        margin-right: -1rem !important\n    }\n\n    .me-sm-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .me-sm-n5 {\n        margin-right: -3rem !important\n    }\n\n    .me-sm-n6 {\n        margin-right: -5rem !important\n    }\n\n    .me-sm-n7 {\n        margin-right: -8rem !important\n    }\n\n    .me-sm-n8 {\n        margin-right: -10rem !important\n    }\n\n    .me-sm-n9 {\n        margin-right: -11rem !important\n    }\n\n    .me-sm-n10 {\n        margin-right: -14rem !important\n    }\n\n    .me-sm-n11 {\n        margin-right: -16rem !important\n    }\n\n    .me-sm-n12 {\n        margin-right: -20rem !important\n    }\n\n    .me-sm-nsm {\n        margin-right: -1rem !important\n    }\n\n    .me-sm-nmd {\n        margin-right: -2rem !important\n    }\n\n    .me-sm-nlg {\n        margin-right: -4rem !important\n    }\n\n    .me-sm-nxl {\n        margin-right: -8rem !important\n    }\n\n    .mb-sm-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .mb-sm-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .mb-sm-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-sm-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .mb-sm-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .mb-sm-n6 {\n        margin-bottom: -5rem !important\n    }\n\n    .mb-sm-n7 {\n        margin-bottom: -8rem !important\n    }\n\n    .mb-sm-n8 {\n        margin-bottom: -10rem !important\n    }\n\n    .mb-sm-n9 {\n        margin-bottom: -11rem !important\n    }\n\n    .mb-sm-n10 {\n        margin-bottom: -14rem !important\n    }\n\n    .mb-sm-n11 {\n        margin-bottom: -16rem !important\n    }\n\n    .mb-sm-n12 {\n        margin-bottom: -20rem !important\n    }\n\n    .mb-sm-nsm {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-sm-nmd {\n        margin-bottom: -2rem !important\n    }\n\n    .mb-sm-nlg {\n        margin-bottom: -4rem !important\n    }\n\n    .mb-sm-nxl {\n        margin-bottom: -8rem !important\n    }\n\n    .ms-sm-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .ms-sm-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .ms-sm-n3 {\n        margin-left: -1rem !important\n    }\n\n    .ms-sm-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .ms-sm-n5 {\n        margin-left: -3rem !important\n    }\n\n    .ms-sm-n6 {\n        margin-left: -5rem !important\n    }\n\n    .ms-sm-n7 {\n        margin-left: -8rem !important\n    }\n\n    .ms-sm-n8 {\n        margin-left: -10rem !important\n    }\n\n    .ms-sm-n9 {\n        margin-left: -11rem !important\n    }\n\n    .ms-sm-n10 {\n        margin-left: -14rem !important\n    }\n\n    .ms-sm-n11 {\n        margin-left: -16rem !important\n    }\n\n    .ms-sm-n12 {\n        margin-left: -20rem !important\n    }\n\n    .ms-sm-nsm {\n        margin-left: -1rem !important\n    }\n\n    .ms-sm-nmd {\n        margin-left: -2rem !important\n    }\n\n    .ms-sm-nlg {\n        margin-left: -4rem !important\n    }\n\n    .ms-sm-nxl {\n        margin-left: -8rem !important\n    }\n\n    .p-sm-0 {\n        padding: 0 !important\n    }\n\n    .p-sm-1 {\n        padding: .25rem !important\n    }\n\n    .p-sm-2 {\n        padding: .5rem !important\n    }\n\n    .p-sm-3 {\n        padding: 1rem !important\n    }\n\n    .p-sm-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-sm-5 {\n        padding: 3rem !important\n    }\n\n    .p-sm-6 {\n        padding: 5rem !important\n    }\n\n    .p-sm-7 {\n        padding: 8rem !important\n    }\n\n    .p-sm-8 {\n        padding: 10rem !important\n    }\n\n    .p-sm-9 {\n        padding: 11rem !important\n    }\n\n    .p-sm-10 {\n        padding: 14rem !important\n    }\n\n    .p-sm-11 {\n        padding: 16rem !important\n    }\n\n    .p-sm-12 {\n        padding: 20rem !important\n    }\n\n    .p-sm-sm {\n        padding: 1rem !important\n    }\n\n    .p-sm-md {\n        padding: 2rem !important\n    }\n\n    .p-sm-lg {\n        padding: 4rem !important\n    }\n\n    .p-sm-xl {\n        padding: 8rem !important\n    }\n\n    .px-sm-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-sm-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-sm-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-sm-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-sm-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-sm-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .px-sm-6 {\n        padding-right: 5rem !important;\n        padding-left: 5rem !important\n    }\n\n    .px-sm-7 {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .px-sm-8 {\n        padding-right: 10rem !important;\n        padding-left: 10rem !important\n    }\n\n    .px-sm-9 {\n        padding-right: 11rem !important;\n        padding-left: 11rem !important\n    }\n\n    .px-sm-10 {\n        padding-right: 14rem !important;\n        padding-left: 14rem !important\n    }\n\n    .px-sm-11 {\n        padding-right: 16rem !important;\n        padding-left: 16rem !important\n    }\n\n    .px-sm-12 {\n        padding-right: 20rem !important;\n        padding-left: 20rem !important\n    }\n\n    .px-sm-sm {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-sm-md {\n        padding-right: 2rem !important;\n        padding-left: 2rem !important\n    }\n\n    .px-sm-lg {\n        padding-right: 4rem !important;\n        padding-left: 4rem !important\n    }\n\n    .px-sm-xl {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .py-sm-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-sm-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-sm-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-sm-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-sm-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-sm-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .py-sm-6 {\n        padding-top: 5rem !important;\n        padding-bottom: 5rem !important\n    }\n\n    .py-sm-7 {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .py-sm-8 {\n        padding-top: 10rem !important;\n        padding-bottom: 10rem !important\n    }\n\n    .py-sm-9 {\n        padding-top: 11rem !important;\n        padding-bottom: 11rem !important\n    }\n\n    .py-sm-10 {\n        padding-top: 14rem !important;\n        padding-bottom: 14rem !important\n    }\n\n    .py-sm-11 {\n        padding-top: 16rem !important;\n        padding-bottom: 16rem !important\n    }\n\n    .py-sm-12 {\n        padding-top: 20rem !important;\n        padding-bottom: 20rem !important\n    }\n\n    .py-sm-sm {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-sm-md {\n        padding-top: 2rem !important;\n        padding-bottom: 2rem !important\n    }\n\n    .py-sm-lg {\n        padding-top: 4rem !important;\n        padding-bottom: 4rem !important\n    }\n\n    .py-sm-xl {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .pt-sm-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-sm-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-sm-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-sm-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-sm-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-sm-5 {\n        padding-top: 3rem !important\n    }\n\n    .pt-sm-6 {\n        padding-top: 5rem !important\n    }\n\n    .pt-sm-7 {\n        padding-top: 8rem !important\n    }\n\n    .pt-sm-8 {\n        padding-top: 10rem !important\n    }\n\n    .pt-sm-9 {\n        padding-top: 11rem !important\n    }\n\n    .pt-sm-10 {\n        padding-top: 14rem !important\n    }\n\n    .pt-sm-11 {\n        padding-top: 16rem !important\n    }\n\n    .pt-sm-12 {\n        padding-top: 20rem !important\n    }\n\n    .pt-sm-sm {\n        padding-top: 1rem !important\n    }\n\n    .pt-sm-md {\n        padding-top: 2rem !important\n    }\n\n    .pt-sm-lg {\n        padding-top: 4rem !important\n    }\n\n    .pt-sm-xl {\n        padding-top: 8rem !important\n    }\n\n    .pe-sm-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-sm-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-sm-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-sm-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-sm-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-sm-5 {\n        padding-right: 3rem !important\n    }\n\n    .pe-sm-6 {\n        padding-right: 5rem !important\n    }\n\n    .pe-sm-7 {\n        padding-right: 8rem !important\n    }\n\n    .pe-sm-8 {\n        padding-right: 10rem !important\n    }\n\n    .pe-sm-9 {\n        padding-right: 11rem !important\n    }\n\n    .pe-sm-10 {\n        padding-right: 14rem !important\n    }\n\n    .pe-sm-11 {\n        padding-right: 16rem !important\n    }\n\n    .pe-sm-12 {\n        padding-right: 20rem !important\n    }\n\n    .pe-sm-sm {\n        padding-right: 1rem !important\n    }\n\n    .pe-sm-md {\n        padding-right: 2rem !important\n    }\n\n    .pe-sm-lg {\n        padding-right: 4rem !important\n    }\n\n    .pe-sm-xl {\n        padding-right: 8rem !important\n    }\n\n    .pb-sm-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-sm-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-sm-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-sm-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-sm-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-sm-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pb-sm-6 {\n        padding-bottom: 5rem !important\n    }\n\n    .pb-sm-7 {\n        padding-bottom: 8rem !important\n    }\n\n    .pb-sm-8 {\n        padding-bottom: 10rem !important\n    }\n\n    .pb-sm-9 {\n        padding-bottom: 11rem !important\n    }\n\n    .pb-sm-10 {\n        padding-bottom: 14rem !important\n    }\n\n    .pb-sm-11 {\n        padding-bottom: 16rem !important\n    }\n\n    .pb-sm-12 {\n        padding-bottom: 20rem !important\n    }\n\n    .pb-sm-sm {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-sm-md {\n        padding-bottom: 2rem !important\n    }\n\n    .pb-sm-lg {\n        padding-bottom: 4rem !important\n    }\n\n    .pb-sm-xl {\n        padding-bottom: 8rem !important\n    }\n\n    .ps-sm-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-sm-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-sm-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-sm-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-sm-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-sm-5 {\n        padding-left: 3rem !important\n    }\n\n    .ps-sm-6 {\n        padding-left: 5rem !important\n    }\n\n    .ps-sm-7 {\n        padding-left: 8rem !important\n    }\n\n    .ps-sm-8 {\n        padding-left: 10rem !important\n    }\n\n    .ps-sm-9 {\n        padding-left: 11rem !important\n    }\n\n    .ps-sm-10 {\n        padding-left: 14rem !important\n    }\n\n    .ps-sm-11 {\n        padding-left: 16rem !important\n    }\n\n    .ps-sm-12 {\n        padding-left: 20rem !important\n    }\n\n    .ps-sm-sm {\n        padding-left: 1rem !important\n    }\n\n    .ps-sm-md {\n        padding-left: 2rem !important\n    }\n\n    .ps-sm-lg {\n        padding-left: 4rem !important\n    }\n\n    .ps-sm-xl {\n        padding-left: 8rem !important\n    }\n\n    .text-sm-start {\n        text-align: left !important\n    }\n\n    .text-sm-end {\n        text-align: right !important\n    }\n\n    .text-sm-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 768px) {\n    .float-md-start {\n        float: left !important\n    }\n\n    .float-md-end {\n        float: right !important\n    }\n\n    .float-md-none {\n        float: none !important\n    }\n\n    .d-md-inline {\n        display: inline !important\n    }\n\n    .d-md-inline-block {\n        display: inline-block !important\n    }\n\n    .d-md-block {\n        display: block !important\n    }\n\n    .d-md-grid {\n        display: grid !important\n    }\n\n    .d-md-table {\n        display: table !important\n    }\n\n    .d-md-table-row {\n        display: table-row !important\n    }\n\n    .d-md-table-cell {\n        display: table-cell !important\n    }\n\n    .d-md-flex {\n        display: flex !important\n    }\n\n    .d-md-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-md-none {\n        display: none !important\n    }\n\n    .vh-md-100 {\n        height: 100vh !important\n    }\n\n    .flex-md-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-md-row {\n        flex-direction: row !important\n    }\n\n    .flex-md-column {\n        flex-direction: column !important\n    }\n\n    .flex-md-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-md-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-md-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-md-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-md-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-md-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-md-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-md-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-md-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .gap-md-0 {\n        gap: 0 !important\n    }\n\n    .gap-md-1 {\n        gap: .25rem !important\n    }\n\n    .gap-md-2 {\n        gap: .5rem !important\n    }\n\n    .gap-md-3 {\n        gap: 1rem !important\n    }\n\n    .gap-md-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-md-5 {\n        gap: 3rem !important\n    }\n\n    .gap-md-6 {\n        gap: 5rem !important\n    }\n\n    .gap-md-7 {\n        gap: 8rem !important\n    }\n\n    .gap-md-8 {\n        gap: 10rem !important\n    }\n\n    .gap-md-9 {\n        gap: 11rem !important\n    }\n\n    .gap-md-10 {\n        gap: 14rem !important\n    }\n\n    .gap-md-11 {\n        gap: 16rem !important\n    }\n\n    .gap-md-12 {\n        gap: 20rem !important\n    }\n\n    .gap-md-sm {\n        gap: 1rem !important\n    }\n\n    .gap-md-md {\n        gap: 2rem !important\n    }\n\n    .gap-md-lg {\n        gap: 4rem !important\n    }\n\n    .gap-md-xl {\n        gap: 8rem !important\n    }\n\n    .justify-content-md-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-md-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-md-center {\n        justify-content: center !important\n    }\n\n    .justify-content-md-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-md-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-md-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-md-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-md-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-md-center {\n        align-items: center !important\n    }\n\n    .align-items-md-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-md-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-md-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-md-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-md-center {\n        align-content: center !important\n    }\n\n    .align-content-md-between {\n        align-content: space-between !important\n    }\n\n    .align-content-md-around {\n        align-content: space-around !important\n    }\n\n    .align-content-md-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-md-auto {\n        align-self: auto !important\n    }\n\n    .align-self-md-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-md-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-md-center {\n        align-self: center !important\n    }\n\n    .align-self-md-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-md-stretch {\n        align-self: stretch !important\n    }\n\n    .order-md-first {\n        order: -1 !important\n    }\n\n    .order-md-0 {\n        order: 0 !important\n    }\n\n    .order-md-1 {\n        order: 1 !important\n    }\n\n    .order-md-2 {\n        order: 2 !important\n    }\n\n    .order-md-3 {\n        order: 3 !important\n    }\n\n    .order-md-4 {\n        order: 4 !important\n    }\n\n    .order-md-5 {\n        order: 5 !important\n    }\n\n    .order-md-last {\n        order: 6 !important\n    }\n\n    .m-md-0 {\n        margin: 0 !important\n    }\n\n    .m-md-1 {\n        margin: .25rem !important\n    }\n\n    .m-md-2 {\n        margin: .5rem !important\n    }\n\n    .m-md-3 {\n        margin: 1rem !important\n    }\n\n    .m-md-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-md-5 {\n        margin: 3rem !important\n    }\n\n    .m-md-6 {\n        margin: 5rem !important\n    }\n\n    .m-md-7 {\n        margin: 8rem !important\n    }\n\n    .m-md-8 {\n        margin: 10rem !important\n    }\n\n    .m-md-9 {\n        margin: 11rem !important\n    }\n\n    .m-md-10 {\n        margin: 14rem !important\n    }\n\n    .m-md-11 {\n        margin: 16rem !important\n    }\n\n    .m-md-12 {\n        margin: 20rem !important\n    }\n\n    .m-md-sm {\n        margin: 1rem !important\n    }\n\n    .m-md-md {\n        margin: 2rem !important\n    }\n\n    .m-md-lg {\n        margin: 4rem !important\n    }\n\n    .m-md-xl {\n        margin: 8rem !important\n    }\n\n    .m-md-auto {\n        margin: auto !important\n    }\n\n    .mx-md-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-md-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-md-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-md-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-md-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-md-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-md-6 {\n        margin-right: 5rem !important;\n        margin-left: 5rem !important\n    }\n\n    .mx-md-7 {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-md-8 {\n        margin-right: 10rem !important;\n        margin-left: 10rem !important\n    }\n\n    .mx-md-9 {\n        margin-right: 11rem !important;\n        margin-left: 11rem !important\n    }\n\n    .mx-md-10 {\n        margin-right: 14rem !important;\n        margin-left: 14rem !important\n    }\n\n    .mx-md-11 {\n        margin-right: 16rem !important;\n        margin-left: 16rem !important\n    }\n\n    .mx-md-12 {\n        margin-right: 20rem !important;\n        margin-left: 20rem !important\n    }\n\n    .mx-md-sm {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-md-md {\n        margin-right: 2rem !important;\n        margin-left: 2rem !important\n    }\n\n    .mx-md-lg {\n        margin-right: 4rem !important;\n        margin-left: 4rem !important\n    }\n\n    .mx-md-xl {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-md-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-md-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-md-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-md-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-md-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-md-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-md-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-md-6 {\n        margin-top: 5rem !important;\n        margin-bottom: 5rem !important\n    }\n\n    .my-md-7 {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-md-8 {\n        margin-top: 10rem !important;\n        margin-bottom: 10rem !important\n    }\n\n    .my-md-9 {\n        margin-top: 11rem !important;\n        margin-bottom: 11rem !important\n    }\n\n    .my-md-10 {\n        margin-top: 14rem !important;\n        margin-bottom: 14rem !important\n    }\n\n    .my-md-11 {\n        margin-top: 16rem !important;\n        margin-bottom: 16rem !important\n    }\n\n    .my-md-12 {\n        margin-top: 20rem !important;\n        margin-bottom: 20rem !important\n    }\n\n    .my-md-sm {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-md-md {\n        margin-top: 2rem !important;\n        margin-bottom: 2rem !important\n    }\n\n    .my-md-lg {\n        margin-top: 4rem !important;\n        margin-bottom: 4rem !important\n    }\n\n    .my-md-xl {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-md-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-md-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-md-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-md-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-md-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-md-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-md-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-md-6 {\n        margin-top: 5rem !important\n    }\n\n    .mt-md-7 {\n        margin-top: 8rem !important\n    }\n\n    .mt-md-8 {\n        margin-top: 10rem !important\n    }\n\n    .mt-md-9 {\n        margin-top: 11rem !important\n    }\n\n    .mt-md-10 {\n        margin-top: 14rem !important\n    }\n\n    .mt-md-11 {\n        margin-top: 16rem !important\n    }\n\n    .mt-md-12 {\n        margin-top: 20rem !important\n    }\n\n    .mt-md-sm {\n        margin-top: 1rem !important\n    }\n\n    .mt-md-md {\n        margin-top: 2rem !important\n    }\n\n    .mt-md-lg {\n        margin-top: 4rem !important\n    }\n\n    .mt-md-xl {\n        margin-top: 8rem !important\n    }\n\n    .mt-md-auto {\n        margin-top: auto !important\n    }\n\n    .me-md-0 {\n        margin-right: 0 !important\n    }\n\n    .me-md-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-md-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-md-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-md-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-md-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-md-6 {\n        margin-right: 5rem !important\n    }\n\n    .me-md-7 {\n        margin-right: 8rem !important\n    }\n\n    .me-md-8 {\n        margin-right: 10rem !important\n    }\n\n    .me-md-9 {\n        margin-right: 11rem !important\n    }\n\n    .me-md-10 {\n        margin-right: 14rem !important\n    }\n\n    .me-md-11 {\n        margin-right: 16rem !important\n    }\n\n    .me-md-12 {\n        margin-right: 20rem !important\n    }\n\n    .me-md-sm {\n        margin-right: 1rem !important\n    }\n\n    .me-md-md {\n        margin-right: 2rem !important\n    }\n\n    .me-md-lg {\n        margin-right: 4rem !important\n    }\n\n    .me-md-xl {\n        margin-right: 8rem !important\n    }\n\n    .me-md-auto {\n        margin-right: auto !important\n    }\n\n    .mb-md-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-md-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-md-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-md-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-md-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-md-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-md-6 {\n        margin-bottom: 5rem !important\n    }\n\n    .mb-md-7 {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-md-8 {\n        margin-bottom: 10rem !important\n    }\n\n    .mb-md-9 {\n        margin-bottom: 11rem !important\n    }\n\n    .mb-md-10 {\n        margin-bottom: 14rem !important\n    }\n\n    .mb-md-11 {\n        margin-bottom: 16rem !important\n    }\n\n    .mb-md-12 {\n        margin-bottom: 20rem !important\n    }\n\n    .mb-md-sm {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-md-md {\n        margin-bottom: 2rem !important\n    }\n\n    .mb-md-lg {\n        margin-bottom: 4rem !important\n    }\n\n    .mb-md-xl {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-md-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-md-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-md-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-md-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-md-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-md-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-md-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-md-6 {\n        margin-left: 5rem !important\n    }\n\n    .ms-md-7 {\n        margin-left: 8rem !important\n    }\n\n    .ms-md-8 {\n        margin-left: 10rem !important\n    }\n\n    .ms-md-9 {\n        margin-left: 11rem !important\n    }\n\n    .ms-md-10 {\n        margin-left: 14rem !important\n    }\n\n    .ms-md-11 {\n        margin-left: 16rem !important\n    }\n\n    .ms-md-12 {\n        margin-left: 20rem !important\n    }\n\n    .ms-md-sm {\n        margin-left: 1rem !important\n    }\n\n    .ms-md-md {\n        margin-left: 2rem !important\n    }\n\n    .ms-md-lg {\n        margin-left: 4rem !important\n    }\n\n    .ms-md-xl {\n        margin-left: 8rem !important\n    }\n\n    .ms-md-auto {\n        margin-left: auto !important\n    }\n\n    .m-md-n1 {\n        margin: -.25rem !important\n    }\n\n    .m-md-n2 {\n        margin: -.5rem !important\n    }\n\n    .m-md-n3 {\n        margin: -1rem !important\n    }\n\n    .m-md-n4 {\n        margin: -1.5rem !important\n    }\n\n    .m-md-n5 {\n        margin: -3rem !important\n    }\n\n    .m-md-n6 {\n        margin: -5rem !important\n    }\n\n    .m-md-n7 {\n        margin: -8rem !important\n    }\n\n    .m-md-n8 {\n        margin: -10rem !important\n    }\n\n    .m-md-n9 {\n        margin: -11rem !important\n    }\n\n    .m-md-n10 {\n        margin: -14rem !important\n    }\n\n    .m-md-n11 {\n        margin: -16rem !important\n    }\n\n    .m-md-n12 {\n        margin: -20rem !important\n    }\n\n    .m-md-nsm {\n        margin: -1rem !important\n    }\n\n    .m-md-nmd {\n        margin: -2rem !important\n    }\n\n    .m-md-nlg {\n        margin: -4rem !important\n    }\n\n    .m-md-nxl {\n        margin: -8rem !important\n    }\n\n    .mx-md-n1 {\n        margin-right: -.25rem !important;\n        margin-left: -.25rem !important\n    }\n\n    .mx-md-n2 {\n        margin-right: -.5rem !important;\n        margin-left: -.5rem !important\n    }\n\n    .mx-md-n3 {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-md-n4 {\n        margin-right: -1.5rem !important;\n        margin-left: -1.5rem !important\n    }\n\n    .mx-md-n5 {\n        margin-right: -3rem !important;\n        margin-left: -3rem !important\n    }\n\n    .mx-md-n6 {\n        margin-right: -5rem !important;\n        margin-left: -5rem !important\n    }\n\n    .mx-md-n7 {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .mx-md-n8 {\n        margin-right: -10rem !important;\n        margin-left: -10rem !important\n    }\n\n    .mx-md-n9 {\n        margin-right: -11rem !important;\n        margin-left: -11rem !important\n    }\n\n    .mx-md-n10 {\n        margin-right: -14rem !important;\n        margin-left: -14rem !important\n    }\n\n    .mx-md-n11 {\n        margin-right: -16rem !important;\n        margin-left: -16rem !important\n    }\n\n    .mx-md-n12 {\n        margin-right: -20rem !important;\n        margin-left: -20rem !important\n    }\n\n    .mx-md-nsm {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-md-nmd {\n        margin-right: -2rem !important;\n        margin-left: -2rem !important\n    }\n\n    .mx-md-nlg {\n        margin-right: -4rem !important;\n        margin-left: -4rem !important\n    }\n\n    .mx-md-nxl {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .my-md-n1 {\n        margin-top: -.25rem !important;\n        margin-bottom: -.25rem !important\n    }\n\n    .my-md-n2 {\n        margin-top: -.5rem !important;\n        margin-bottom: -.5rem !important\n    }\n\n    .my-md-n3 {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-md-n4 {\n        margin-top: -1.5rem !important;\n        margin-bottom: -1.5rem !important\n    }\n\n    .my-md-n5 {\n        margin-top: -3rem !important;\n        margin-bottom: -3rem !important\n    }\n\n    .my-md-n6 {\n        margin-top: -5rem !important;\n        margin-bottom: -5rem !important\n    }\n\n    .my-md-n7 {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .my-md-n8 {\n        margin-top: -10rem !important;\n        margin-bottom: -10rem !important\n    }\n\n    .my-md-n9 {\n        margin-top: -11rem !important;\n        margin-bottom: -11rem !important\n    }\n\n    .my-md-n10 {\n        margin-top: -14rem !important;\n        margin-bottom: -14rem !important\n    }\n\n    .my-md-n11 {\n        margin-top: -16rem !important;\n        margin-bottom: -16rem !important\n    }\n\n    .my-md-n12 {\n        margin-top: -20rem !important;\n        margin-bottom: -20rem !important\n    }\n\n    .my-md-nsm {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-md-nmd {\n        margin-top: -2rem !important;\n        margin-bottom: -2rem !important\n    }\n\n    .my-md-nlg {\n        margin-top: -4rem !important;\n        margin-bottom: -4rem !important\n    }\n\n    .my-md-nxl {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .mt-md-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mt-md-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mt-md-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mt-md-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mt-md-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mt-md-n6 {\n        margin-top: -5rem !important\n    }\n\n    .mt-md-n7 {\n        margin-top: -8rem !important\n    }\n\n    .mt-md-n8 {\n        margin-top: -10rem !important\n    }\n\n    .mt-md-n9 {\n        margin-top: -11rem !important\n    }\n\n    .mt-md-n10 {\n        margin-top: -14rem !important\n    }\n\n    .mt-md-n11 {\n        margin-top: -16rem !important\n    }\n\n    .mt-md-n12 {\n        margin-top: -20rem !important\n    }\n\n    .mt-md-nsm {\n        margin-top: -1rem !important\n    }\n\n    .mt-md-nmd {\n        margin-top: -2rem !important\n    }\n\n    .mt-md-nlg {\n        margin-top: -4rem !important\n    }\n\n    .mt-md-nxl {\n        margin-top: -8rem !important\n    }\n\n    .me-md-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .me-md-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .me-md-n3 {\n        margin-right: -1rem !important\n    }\n\n    .me-md-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .me-md-n5 {\n        margin-right: -3rem !important\n    }\n\n    .me-md-n6 {\n        margin-right: -5rem !important\n    }\n\n    .me-md-n7 {\n        margin-right: -8rem !important\n    }\n\n    .me-md-n8 {\n        margin-right: -10rem !important\n    }\n\n    .me-md-n9 {\n        margin-right: -11rem !important\n    }\n\n    .me-md-n10 {\n        margin-right: -14rem !important\n    }\n\n    .me-md-n11 {\n        margin-right: -16rem !important\n    }\n\n    .me-md-n12 {\n        margin-right: -20rem !important\n    }\n\n    .me-md-nsm {\n        margin-right: -1rem !important\n    }\n\n    .me-md-nmd {\n        margin-right: -2rem !important\n    }\n\n    .me-md-nlg {\n        margin-right: -4rem !important\n    }\n\n    .me-md-nxl {\n        margin-right: -8rem !important\n    }\n\n    .mb-md-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .mb-md-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .mb-md-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-md-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .mb-md-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .mb-md-n6 {\n        margin-bottom: -5rem !important\n    }\n\n    .mb-md-n7 {\n        margin-bottom: -8rem !important\n    }\n\n    .mb-md-n8 {\n        margin-bottom: -10rem !important\n    }\n\n    .mb-md-n9 {\n        margin-bottom: -11rem !important\n    }\n\n    .mb-md-n10 {\n        margin-bottom: -14rem !important\n    }\n\n    .mb-md-n11 {\n        margin-bottom: -16rem !important\n    }\n\n    .mb-md-n12 {\n        margin-bottom: -20rem !important\n    }\n\n    .mb-md-nsm {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-md-nmd {\n        margin-bottom: -2rem !important\n    }\n\n    .mb-md-nlg {\n        margin-bottom: -4rem !important\n    }\n\n    .mb-md-nxl {\n        margin-bottom: -8rem !important\n    }\n\n    .ms-md-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .ms-md-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .ms-md-n3 {\n        margin-left: -1rem !important\n    }\n\n    .ms-md-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .ms-md-n5 {\n        margin-left: -3rem !important\n    }\n\n    .ms-md-n6 {\n        margin-left: -5rem !important\n    }\n\n    .ms-md-n7 {\n        margin-left: -8rem !important\n    }\n\n    .ms-md-n8 {\n        margin-left: -10rem !important\n    }\n\n    .ms-md-n9 {\n        margin-left: -11rem !important\n    }\n\n    .ms-md-n10 {\n        margin-left: -14rem !important\n    }\n\n    .ms-md-n11 {\n        margin-left: -16rem !important\n    }\n\n    .ms-md-n12 {\n        margin-left: -20rem !important\n    }\n\n    .ms-md-nsm {\n        margin-left: -1rem !important\n    }\n\n    .ms-md-nmd {\n        margin-left: -2rem !important\n    }\n\n    .ms-md-nlg {\n        margin-left: -4rem !important\n    }\n\n    .ms-md-nxl {\n        margin-left: -8rem !important\n    }\n\n    .p-md-0 {\n        padding: 0 !important\n    }\n\n    .p-md-1 {\n        padding: .25rem !important\n    }\n\n    .p-md-2 {\n        padding: .5rem !important\n    }\n\n    .p-md-3 {\n        padding: 1rem !important\n    }\n\n    .p-md-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-md-5 {\n        padding: 3rem !important\n    }\n\n    .p-md-6 {\n        padding: 5rem !important\n    }\n\n    .p-md-7 {\n        padding: 8rem !important\n    }\n\n    .p-md-8 {\n        padding: 10rem !important\n    }\n\n    .p-md-9 {\n        padding: 11rem !important\n    }\n\n    .p-md-10 {\n        padding: 14rem !important\n    }\n\n    .p-md-11 {\n        padding: 16rem !important\n    }\n\n    .p-md-12 {\n        padding: 20rem !important\n    }\n\n    .p-md-sm {\n        padding: 1rem !important\n    }\n\n    .p-md-md {\n        padding: 2rem !important\n    }\n\n    .p-md-lg {\n        padding: 4rem !important\n    }\n\n    .p-md-xl {\n        padding: 8rem !important\n    }\n\n    .px-md-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-md-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-md-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-md-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-md-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-md-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .px-md-6 {\n        padding-right: 5rem !important;\n        padding-left: 5rem !important\n    }\n\n    .px-md-7 {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .px-md-8 {\n        padding-right: 10rem !important;\n        padding-left: 10rem !important\n    }\n\n    .px-md-9 {\n        padding-right: 11rem !important;\n        padding-left: 11rem !important\n    }\n\n    .px-md-10 {\n        padding-right: 14rem !important;\n        padding-left: 14rem !important\n    }\n\n    .px-md-11 {\n        padding-right: 16rem !important;\n        padding-left: 16rem !important\n    }\n\n    .px-md-12 {\n        padding-right: 20rem !important;\n        padding-left: 20rem !important\n    }\n\n    .px-md-sm {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-md-md {\n        padding-right: 2rem !important;\n        padding-left: 2rem !important\n    }\n\n    .px-md-lg {\n        padding-right: 4rem !important;\n        padding-left: 4rem !important\n    }\n\n    .px-md-xl {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .py-md-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-md-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-md-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-md-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-md-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-md-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .py-md-6 {\n        padding-top: 5rem !important;\n        padding-bottom: 5rem !important\n    }\n\n    .py-md-7 {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .py-md-8 {\n        padding-top: 10rem !important;\n        padding-bottom: 10rem !important\n    }\n\n    .py-md-9 {\n        padding-top: 11rem !important;\n        padding-bottom: 11rem !important\n    }\n\n    .py-md-10 {\n        padding-top: 14rem !important;\n        padding-bottom: 14rem !important\n    }\n\n    .py-md-11 {\n        padding-top: 16rem !important;\n        padding-bottom: 16rem !important\n    }\n\n    .py-md-12 {\n        padding-top: 20rem !important;\n        padding-bottom: 20rem !important\n    }\n\n    .py-md-sm {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-md-md {\n        padding-top: 2rem !important;\n        padding-bottom: 2rem !important\n    }\n\n    .py-md-lg {\n        padding-top: 4rem !important;\n        padding-bottom: 4rem !important\n    }\n\n    .py-md-xl {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .pt-md-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-md-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-md-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-md-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-md-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-md-5 {\n        padding-top: 3rem !important\n    }\n\n    .pt-md-6 {\n        padding-top: 5rem !important\n    }\n\n    .pt-md-7 {\n        padding-top: 8rem !important\n    }\n\n    .pt-md-8 {\n        padding-top: 10rem !important\n    }\n\n    .pt-md-9 {\n        padding-top: 11rem !important\n    }\n\n    .pt-md-10 {\n        padding-top: 14rem !important\n    }\n\n    .pt-md-11 {\n        padding-top: 16rem !important\n    }\n\n    .pt-md-12 {\n        padding-top: 20rem !important\n    }\n\n    .pt-md-sm {\n        padding-top: 1rem !important\n    }\n\n    .pt-md-md {\n        padding-top: 2rem !important\n    }\n\n    .pt-md-lg {\n        padding-top: 4rem !important\n    }\n\n    .pt-md-xl {\n        padding-top: 8rem !important\n    }\n\n    .pe-md-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-md-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-md-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-md-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-md-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-md-5 {\n        padding-right: 3rem !important\n    }\n\n    .pe-md-6 {\n        padding-right: 5rem !important\n    }\n\n    .pe-md-7 {\n        padding-right: 8rem !important\n    }\n\n    .pe-md-8 {\n        padding-right: 10rem !important\n    }\n\n    .pe-md-9 {\n        padding-right: 11rem !important\n    }\n\n    .pe-md-10 {\n        padding-right: 14rem !important\n    }\n\n    .pe-md-11 {\n        padding-right: 16rem !important\n    }\n\n    .pe-md-12 {\n        padding-right: 20rem !important\n    }\n\n    .pe-md-sm {\n        padding-right: 1rem !important\n    }\n\n    .pe-md-md {\n        padding-right: 2rem !important\n    }\n\n    .pe-md-lg {\n        padding-right: 4rem !important\n    }\n\n    .pe-md-xl {\n        padding-right: 8rem !important\n    }\n\n    .pb-md-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-md-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-md-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-md-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-md-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-md-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pb-md-6 {\n        padding-bottom: 5rem !important\n    }\n\n    .pb-md-7 {\n        padding-bottom: 8rem !important\n    }\n\n    .pb-md-8 {\n        padding-bottom: 10rem !important\n    }\n\n    .pb-md-9 {\n        padding-bottom: 11rem !important\n    }\n\n    .pb-md-10 {\n        padding-bottom: 14rem !important\n    }\n\n    .pb-md-11 {\n        padding-bottom: 16rem !important\n    }\n\n    .pb-md-12 {\n        padding-bottom: 20rem !important\n    }\n\n    .pb-md-sm {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-md-md {\n        padding-bottom: 2rem !important\n    }\n\n    .pb-md-lg {\n        padding-bottom: 4rem !important\n    }\n\n    .pb-md-xl {\n        padding-bottom: 8rem !important\n    }\n\n    .ps-md-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-md-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-md-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-md-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-md-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-md-5 {\n        padding-left: 3rem !important\n    }\n\n    .ps-md-6 {\n        padding-left: 5rem !important\n    }\n\n    .ps-md-7 {\n        padding-left: 8rem !important\n    }\n\n    .ps-md-8 {\n        padding-left: 10rem !important\n    }\n\n    .ps-md-9 {\n        padding-left: 11rem !important\n    }\n\n    .ps-md-10 {\n        padding-left: 14rem !important\n    }\n\n    .ps-md-11 {\n        padding-left: 16rem !important\n    }\n\n    .ps-md-12 {\n        padding-left: 20rem !important\n    }\n\n    .ps-md-sm {\n        padding-left: 1rem !important\n    }\n\n    .ps-md-md {\n        padding-left: 2rem !important\n    }\n\n    .ps-md-lg {\n        padding-left: 4rem !important\n    }\n\n    .ps-md-xl {\n        padding-left: 8rem !important\n    }\n\n    .text-md-start {\n        text-align: left !important\n    }\n\n    .text-md-end {\n        text-align: right !important\n    }\n\n    .text-md-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 992px) {\n    .float-lg-start {\n        float: left !important\n    }\n\n    .float-lg-end {\n        float: right !important\n    }\n\n    .float-lg-none {\n        float: none !important\n    }\n\n    .d-lg-inline {\n        display: inline !important\n    }\n\n    .d-lg-inline-block {\n        display: inline-block !important\n    }\n\n    .d-lg-block {\n        display: block !important\n    }\n\n    .d-lg-grid {\n        display: grid !important\n    }\n\n    .d-lg-table {\n        display: table !important\n    }\n\n    .d-lg-table-row {\n        display: table-row !important\n    }\n\n    .d-lg-table-cell {\n        display: table-cell !important\n    }\n\n    .d-lg-flex {\n        display: flex !important\n    }\n\n    .d-lg-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-lg-none {\n        display: none !important\n    }\n\n    .vh-lg-100 {\n        height: 100vh !important\n    }\n\n    .flex-lg-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-lg-row {\n        flex-direction: row !important\n    }\n\n    .flex-lg-column {\n        flex-direction: column !important\n    }\n\n    .flex-lg-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-lg-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-lg-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-lg-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-lg-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-lg-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-lg-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-lg-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-lg-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .gap-lg-0 {\n        gap: 0 !important\n    }\n\n    .gap-lg-1 {\n        gap: .25rem !important\n    }\n\n    .gap-lg-2 {\n        gap: .5rem !important\n    }\n\n    .gap-lg-3 {\n        gap: 1rem !important\n    }\n\n    .gap-lg-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-lg-5 {\n        gap: 3rem !important\n    }\n\n    .gap-lg-6 {\n        gap: 5rem !important\n    }\n\n    .gap-lg-7 {\n        gap: 8rem !important\n    }\n\n    .gap-lg-8 {\n        gap: 10rem !important\n    }\n\n    .gap-lg-9 {\n        gap: 11rem !important\n    }\n\n    .gap-lg-10 {\n        gap: 14rem !important\n    }\n\n    .gap-lg-11 {\n        gap: 16rem !important\n    }\n\n    .gap-lg-12 {\n        gap: 20rem !important\n    }\n\n    .gap-lg-sm {\n        gap: 1rem !important\n    }\n\n    .gap-lg-md {\n        gap: 2rem !important\n    }\n\n    .gap-lg-lg {\n        gap: 4rem !important\n    }\n\n    .gap-lg-xl {\n        gap: 8rem !important\n    }\n\n    .justify-content-lg-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-lg-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-lg-center {\n        justify-content: center !important\n    }\n\n    .justify-content-lg-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-lg-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-lg-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-lg-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-lg-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-lg-center {\n        align-items: center !important\n    }\n\n    .align-items-lg-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-lg-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-lg-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-lg-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-lg-center {\n        align-content: center !important\n    }\n\n    .align-content-lg-between {\n        align-content: space-between !important\n    }\n\n    .align-content-lg-around {\n        align-content: space-around !important\n    }\n\n    .align-content-lg-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-lg-auto {\n        align-self: auto !important\n    }\n\n    .align-self-lg-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-lg-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-lg-center {\n        align-self: center !important\n    }\n\n    .align-self-lg-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-lg-stretch {\n        align-self: stretch !important\n    }\n\n    .order-lg-first {\n        order: -1 !important\n    }\n\n    .order-lg-0 {\n        order: 0 !important\n    }\n\n    .order-lg-1 {\n        order: 1 !important\n    }\n\n    .order-lg-2 {\n        order: 2 !important\n    }\n\n    .order-lg-3 {\n        order: 3 !important\n    }\n\n    .order-lg-4 {\n        order: 4 !important\n    }\n\n    .order-lg-5 {\n        order: 5 !important\n    }\n\n    .order-lg-last {\n        order: 6 !important\n    }\n\n    .m-lg-0 {\n        margin: 0 !important\n    }\n\n    .m-lg-1 {\n        margin: .25rem !important\n    }\n\n    .m-lg-2 {\n        margin: .5rem !important\n    }\n\n    .m-lg-3 {\n        margin: 1rem !important\n    }\n\n    .m-lg-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-lg-5 {\n        margin: 3rem !important\n    }\n\n    .m-lg-6 {\n        margin: 5rem !important\n    }\n\n    .m-lg-7 {\n        margin: 8rem !important\n    }\n\n    .m-lg-8 {\n        margin: 10rem !important\n    }\n\n    .m-lg-9 {\n        margin: 11rem !important\n    }\n\n    .m-lg-10 {\n        margin: 14rem !important\n    }\n\n    .m-lg-11 {\n        margin: 16rem !important\n    }\n\n    .m-lg-12 {\n        margin: 20rem !important\n    }\n\n    .m-lg-sm {\n        margin: 1rem !important\n    }\n\n    .m-lg-md {\n        margin: 2rem !important\n    }\n\n    .m-lg-lg {\n        margin: 4rem !important\n    }\n\n    .m-lg-xl {\n        margin: 8rem !important\n    }\n\n    .m-lg-auto {\n        margin: auto !important\n    }\n\n    .mx-lg-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-lg-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-lg-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-lg-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-lg-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-lg-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-lg-6 {\n        margin-right: 5rem !important;\n        margin-left: 5rem !important\n    }\n\n    .mx-lg-7 {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-lg-8 {\n        margin-right: 10rem !important;\n        margin-left: 10rem !important\n    }\n\n    .mx-lg-9 {\n        margin-right: 11rem !important;\n        margin-left: 11rem !important\n    }\n\n    .mx-lg-10 {\n        margin-right: 14rem !important;\n        margin-left: 14rem !important\n    }\n\n    .mx-lg-11 {\n        margin-right: 16rem !important;\n        margin-left: 16rem !important\n    }\n\n    .mx-lg-12 {\n        margin-right: 20rem !important;\n        margin-left: 20rem !important\n    }\n\n    .mx-lg-sm {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-lg-md {\n        margin-right: 2rem !important;\n        margin-left: 2rem !important\n    }\n\n    .mx-lg-lg {\n        margin-right: 4rem !important;\n        margin-left: 4rem !important\n    }\n\n    .mx-lg-xl {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-lg-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-lg-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-lg-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-lg-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-lg-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-lg-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-lg-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-lg-6 {\n        margin-top: 5rem !important;\n        margin-bottom: 5rem !important\n    }\n\n    .my-lg-7 {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-lg-8 {\n        margin-top: 10rem !important;\n        margin-bottom: 10rem !important\n    }\n\n    .my-lg-9 {\n        margin-top: 11rem !important;\n        margin-bottom: 11rem !important\n    }\n\n    .my-lg-10 {\n        margin-top: 14rem !important;\n        margin-bottom: 14rem !important\n    }\n\n    .my-lg-11 {\n        margin-top: 16rem !important;\n        margin-bottom: 16rem !important\n    }\n\n    .my-lg-12 {\n        margin-top: 20rem !important;\n        margin-bottom: 20rem !important\n    }\n\n    .my-lg-sm {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-lg-md {\n        margin-top: 2rem !important;\n        margin-bottom: 2rem !important\n    }\n\n    .my-lg-lg {\n        margin-top: 4rem !important;\n        margin-bottom: 4rem !important\n    }\n\n    .my-lg-xl {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-lg-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-lg-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-lg-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-lg-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-lg-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-lg-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-lg-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-lg-6 {\n        margin-top: 5rem !important\n    }\n\n    .mt-lg-7 {\n        margin-top: 8rem !important\n    }\n\n    .mt-lg-8 {\n        margin-top: 10rem !important\n    }\n\n    .mt-lg-9 {\n        margin-top: 11rem !important\n    }\n\n    .mt-lg-10 {\n        margin-top: 14rem !important\n    }\n\n    .mt-lg-11 {\n        margin-top: 16rem !important\n    }\n\n    .mt-lg-12 {\n        margin-top: 20rem !important\n    }\n\n    .mt-lg-sm {\n        margin-top: 1rem !important\n    }\n\n    .mt-lg-md {\n        margin-top: 2rem !important\n    }\n\n    .mt-lg-lg {\n        margin-top: 4rem !important\n    }\n\n    .mt-lg-xl {\n        margin-top: 8rem !important\n    }\n\n    .mt-lg-auto {\n        margin-top: auto !important\n    }\n\n    .me-lg-0 {\n        margin-right: 0 !important\n    }\n\n    .me-lg-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-lg-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-lg-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-lg-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-lg-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-lg-6 {\n        margin-right: 5rem !important\n    }\n\n    .me-lg-7 {\n        margin-right: 8rem !important\n    }\n\n    .me-lg-8 {\n        margin-right: 10rem !important\n    }\n\n    .me-lg-9 {\n        margin-right: 11rem !important\n    }\n\n    .me-lg-10 {\n        margin-right: 14rem !important\n    }\n\n    .me-lg-11 {\n        margin-right: 16rem !important\n    }\n\n    .me-lg-12 {\n        margin-right: 20rem !important\n    }\n\n    .me-lg-sm {\n        margin-right: 1rem !important\n    }\n\n    .me-lg-md {\n        margin-right: 2rem !important\n    }\n\n    .me-lg-lg {\n        margin-right: 4rem !important\n    }\n\n    .me-lg-xl {\n        margin-right: 8rem !important\n    }\n\n    .me-lg-auto {\n        margin-right: auto !important\n    }\n\n    .mb-lg-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-lg-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-lg-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-lg-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-lg-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-lg-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-lg-6 {\n        margin-bottom: 5rem !important\n    }\n\n    .mb-lg-7 {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-lg-8 {\n        margin-bottom: 10rem !important\n    }\n\n    .mb-lg-9 {\n        margin-bottom: 11rem !important\n    }\n\n    .mb-lg-10 {\n        margin-bottom: 14rem !important\n    }\n\n    .mb-lg-11 {\n        margin-bottom: 16rem !important\n    }\n\n    .mb-lg-12 {\n        margin-bottom: 20rem !important\n    }\n\n    .mb-lg-sm {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-lg-md {\n        margin-bottom: 2rem !important\n    }\n\n    .mb-lg-lg {\n        margin-bottom: 4rem !important\n    }\n\n    .mb-lg-xl {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-lg-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-lg-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-lg-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-lg-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-lg-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-lg-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-lg-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-lg-6 {\n        margin-left: 5rem !important\n    }\n\n    .ms-lg-7 {\n        margin-left: 8rem !important\n    }\n\n    .ms-lg-8 {\n        margin-left: 10rem !important\n    }\n\n    .ms-lg-9 {\n        margin-left: 11rem !important\n    }\n\n    .ms-lg-10 {\n        margin-left: 14rem !important\n    }\n\n    .ms-lg-11 {\n        margin-left: 16rem !important\n    }\n\n    .ms-lg-12 {\n        margin-left: 20rem !important\n    }\n\n    .ms-lg-sm {\n        margin-left: 1rem !important\n    }\n\n    .ms-lg-md {\n        margin-left: 2rem !important\n    }\n\n    .ms-lg-lg {\n        margin-left: 4rem !important\n    }\n\n    .ms-lg-xl {\n        margin-left: 8rem !important\n    }\n\n    .ms-lg-auto {\n        margin-left: auto !important\n    }\n\n    .m-lg-n1 {\n        margin: -.25rem !important\n    }\n\n    .m-lg-n2 {\n        margin: -.5rem !important\n    }\n\n    .m-lg-n3 {\n        margin: -1rem !important\n    }\n\n    .m-lg-n4 {\n        margin: -1.5rem !important\n    }\n\n    .m-lg-n5 {\n        margin: -3rem !important\n    }\n\n    .m-lg-n6 {\n        margin: -5rem !important\n    }\n\n    .m-lg-n7 {\n        margin: -8rem !important\n    }\n\n    .m-lg-n8 {\n        margin: -10rem !important\n    }\n\n    .m-lg-n9 {\n        margin: -11rem !important\n    }\n\n    .m-lg-n10 {\n        margin: -14rem !important\n    }\n\n    .m-lg-n11 {\n        margin: -16rem !important\n    }\n\n    .m-lg-n12 {\n        margin: -20rem !important\n    }\n\n    .m-lg-nsm {\n        margin: -1rem !important\n    }\n\n    .m-lg-nmd {\n        margin: -2rem !important\n    }\n\n    .m-lg-nlg {\n        margin: -4rem !important\n    }\n\n    .m-lg-nxl {\n        margin: -8rem !important\n    }\n\n    .mx-lg-n1 {\n        margin-right: -.25rem !important;\n        margin-left: -.25rem !important\n    }\n\n    .mx-lg-n2 {\n        margin-right: -.5rem !important;\n        margin-left: -.5rem !important\n    }\n\n    .mx-lg-n3 {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-lg-n4 {\n        margin-right: -1.5rem !important;\n        margin-left: -1.5rem !important\n    }\n\n    .mx-lg-n5 {\n        margin-right: -3rem !important;\n        margin-left: -3rem !important\n    }\n\n    .mx-lg-n6 {\n        margin-right: -5rem !important;\n        margin-left: -5rem !important\n    }\n\n    .mx-lg-n7 {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .mx-lg-n8 {\n        margin-right: -10rem !important;\n        margin-left: -10rem !important\n    }\n\n    .mx-lg-n9 {\n        margin-right: -11rem !important;\n        margin-left: -11rem !important\n    }\n\n    .mx-lg-n10 {\n        margin-right: -14rem !important;\n        margin-left: -14rem !important\n    }\n\n    .mx-lg-n11 {\n        margin-right: -16rem !important;\n        margin-left: -16rem !important\n    }\n\n    .mx-lg-n12 {\n        margin-right: -20rem !important;\n        margin-left: -20rem !important\n    }\n\n    .mx-lg-nsm {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-lg-nmd {\n        margin-right: -2rem !important;\n        margin-left: -2rem !important\n    }\n\n    .mx-lg-nlg {\n        margin-right: -4rem !important;\n        margin-left: -4rem !important\n    }\n\n    .mx-lg-nxl {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .my-lg-n1 {\n        margin-top: -.25rem !important;\n        margin-bottom: -.25rem !important\n    }\n\n    .my-lg-n2 {\n        margin-top: -.5rem !important;\n        margin-bottom: -.5rem !important\n    }\n\n    .my-lg-n3 {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-lg-n4 {\n        margin-top: -1.5rem !important;\n        margin-bottom: -1.5rem !important\n    }\n\n    .my-lg-n5 {\n        margin-top: -3rem !important;\n        margin-bottom: -3rem !important\n    }\n\n    .my-lg-n6 {\n        margin-top: -5rem !important;\n        margin-bottom: -5rem !important\n    }\n\n    .my-lg-n7 {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .my-lg-n8 {\n        margin-top: -10rem !important;\n        margin-bottom: -10rem !important\n    }\n\n    .my-lg-n9 {\n        margin-top: -11rem !important;\n        margin-bottom: -11rem !important\n    }\n\n    .my-lg-n10 {\n        margin-top: -14rem !important;\n        margin-bottom: -14rem !important\n    }\n\n    .my-lg-n11 {\n        margin-top: -16rem !important;\n        margin-bottom: -16rem !important\n    }\n\n    .my-lg-n12 {\n        margin-top: -20rem !important;\n        margin-bottom: -20rem !important\n    }\n\n    .my-lg-nsm {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-lg-nmd {\n        margin-top: -2rem !important;\n        margin-bottom: -2rem !important\n    }\n\n    .my-lg-nlg {\n        margin-top: -4rem !important;\n        margin-bottom: -4rem !important\n    }\n\n    .my-lg-nxl {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .mt-lg-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mt-lg-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mt-lg-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mt-lg-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mt-lg-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mt-lg-n6 {\n        margin-top: -5rem !important\n    }\n\n    .mt-lg-n7 {\n        margin-top: -8rem !important\n    }\n\n    .mt-lg-n8 {\n        margin-top: -10rem !important\n    }\n\n    .mt-lg-n9 {\n        margin-top: -11rem !important\n    }\n\n    .mt-lg-n10 {\n        margin-top: -14rem !important\n    }\n\n    .mt-lg-n11 {\n        margin-top: -16rem !important\n    }\n\n    .mt-lg-n12 {\n        margin-top: -20rem !important\n    }\n\n    .mt-lg-nsm {\n        margin-top: -1rem !important\n    }\n\n    .mt-lg-nmd {\n        margin-top: -2rem !important\n    }\n\n    .mt-lg-nlg {\n        margin-top: -4rem !important\n    }\n\n    .mt-lg-nxl {\n        margin-top: -8rem !important\n    }\n\n    .me-lg-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .me-lg-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .me-lg-n3 {\n        margin-right: -1rem !important\n    }\n\n    .me-lg-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .me-lg-n5 {\n        margin-right: -3rem !important\n    }\n\n    .me-lg-n6 {\n        margin-right: -5rem !important\n    }\n\n    .me-lg-n7 {\n        margin-right: -8rem !important\n    }\n\n    .me-lg-n8 {\n        margin-right: -10rem !important\n    }\n\n    .me-lg-n9 {\n        margin-right: -11rem !important\n    }\n\n    .me-lg-n10 {\n        margin-right: -14rem !important\n    }\n\n    .me-lg-n11 {\n        margin-right: -16rem !important\n    }\n\n    .me-lg-n12 {\n        margin-right: -20rem !important\n    }\n\n    .me-lg-nsm {\n        margin-right: -1rem !important\n    }\n\n    .me-lg-nmd {\n        margin-right: -2rem !important\n    }\n\n    .me-lg-nlg {\n        margin-right: -4rem !important\n    }\n\n    .me-lg-nxl {\n        margin-right: -8rem !important\n    }\n\n    .mb-lg-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .mb-lg-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .mb-lg-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-lg-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .mb-lg-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .mb-lg-n6 {\n        margin-bottom: -5rem !important\n    }\n\n    .mb-lg-n7 {\n        margin-bottom: -8rem !important\n    }\n\n    .mb-lg-n8 {\n        margin-bottom: -10rem !important\n    }\n\n    .mb-lg-n9 {\n        margin-bottom: -11rem !important\n    }\n\n    .mb-lg-n10 {\n        margin-bottom: -14rem !important\n    }\n\n    .mb-lg-n11 {\n        margin-bottom: -16rem !important\n    }\n\n    .mb-lg-n12 {\n        margin-bottom: -20rem !important\n    }\n\n    .mb-lg-nsm {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-lg-nmd {\n        margin-bottom: -2rem !important\n    }\n\n    .mb-lg-nlg {\n        margin-bottom: -4rem !important\n    }\n\n    .mb-lg-nxl {\n        margin-bottom: -8rem !important\n    }\n\n    .ms-lg-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .ms-lg-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .ms-lg-n3 {\n        margin-left: -1rem !important\n    }\n\n    .ms-lg-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .ms-lg-n5 {\n        margin-left: -3rem !important\n    }\n\n    .ms-lg-n6 {\n        margin-left: -5rem !important\n    }\n\n    .ms-lg-n7 {\n        margin-left: -8rem !important\n    }\n\n    .ms-lg-n8 {\n        margin-left: -10rem !important\n    }\n\n    .ms-lg-n9 {\n        margin-left: -11rem !important\n    }\n\n    .ms-lg-n10 {\n        margin-left: -14rem !important\n    }\n\n    .ms-lg-n11 {\n        margin-left: -16rem !important\n    }\n\n    .ms-lg-n12 {\n        margin-left: -20rem !important\n    }\n\n    .ms-lg-nsm {\n        margin-left: -1rem !important\n    }\n\n    .ms-lg-nmd {\n        margin-left: -2rem !important\n    }\n\n    .ms-lg-nlg {\n        margin-left: -4rem !important\n    }\n\n    .ms-lg-nxl {\n        margin-left: -8rem !important\n    }\n\n    .p-lg-0 {\n        padding: 0 !important\n    }\n\n    .p-lg-1 {\n        padding: .25rem !important\n    }\n\n    .p-lg-2 {\n        padding: .5rem !important\n    }\n\n    .p-lg-3 {\n        padding: 1rem !important\n    }\n\n    .p-lg-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-lg-5 {\n        padding: 3rem !important\n    }\n\n    .p-lg-6 {\n        padding: 5rem !important\n    }\n\n    .p-lg-7 {\n        padding: 8rem !important\n    }\n\n    .p-lg-8 {\n        padding: 10rem !important\n    }\n\n    .p-lg-9 {\n        padding: 11rem !important\n    }\n\n    .p-lg-10 {\n        padding: 14rem !important\n    }\n\n    .p-lg-11 {\n        padding: 16rem !important\n    }\n\n    .p-lg-12 {\n        padding: 20rem !important\n    }\n\n    .p-lg-sm {\n        padding: 1rem !important\n    }\n\n    .p-lg-md {\n        padding: 2rem !important\n    }\n\n    .p-lg-lg {\n        padding: 4rem !important\n    }\n\n    .p-lg-xl {\n        padding: 8rem !important\n    }\n\n    .px-lg-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-lg-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-lg-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-lg-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-lg-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-lg-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .px-lg-6 {\n        padding-right: 5rem !important;\n        padding-left: 5rem !important\n    }\n\n    .px-lg-7 {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .px-lg-8 {\n        padding-right: 10rem !important;\n        padding-left: 10rem !important\n    }\n\n    .px-lg-9 {\n        padding-right: 11rem !important;\n        padding-left: 11rem !important\n    }\n\n    .px-lg-10 {\n        padding-right: 14rem !important;\n        padding-left: 14rem !important\n    }\n\n    .px-lg-11 {\n        padding-right: 16rem !important;\n        padding-left: 16rem !important\n    }\n\n    .px-lg-12 {\n        padding-right: 20rem !important;\n        padding-left: 20rem !important\n    }\n\n    .px-lg-sm {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-lg-md {\n        padding-right: 2rem !important;\n        padding-left: 2rem !important\n    }\n\n    .px-lg-lg {\n        padding-right: 4rem !important;\n        padding-left: 4rem !important\n    }\n\n    .px-lg-xl {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .py-lg-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-lg-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-lg-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-lg-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-lg-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-lg-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .py-lg-6 {\n        padding-top: 5rem !important;\n        padding-bottom: 5rem !important\n    }\n\n    .py-lg-7 {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .py-lg-8 {\n        padding-top: 10rem !important;\n        padding-bottom: 10rem !important\n    }\n\n    .py-lg-9 {\n        padding-top: 11rem !important;\n        padding-bottom: 11rem !important\n    }\n\n    .py-lg-10 {\n        padding-top: 14rem !important;\n        padding-bottom: 14rem !important\n    }\n\n    .py-lg-11 {\n        padding-top: 16rem !important;\n        padding-bottom: 16rem !important\n    }\n\n    .py-lg-12 {\n        padding-top: 20rem !important;\n        padding-bottom: 20rem !important\n    }\n\n    .py-lg-sm {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-lg-md {\n        padding-top: 2rem !important;\n        padding-bottom: 2rem !important\n    }\n\n    .py-lg-lg {\n        padding-top: 4rem !important;\n        padding-bottom: 4rem !important\n    }\n\n    .py-lg-xl {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .pt-lg-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-lg-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-lg-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-lg-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-lg-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-lg-5 {\n        padding-top: 3rem !important\n    }\n\n    .pt-lg-6 {\n        padding-top: 5rem !important\n    }\n\n    .pt-lg-7 {\n        padding-top: 8rem !important\n    }\n\n    .pt-lg-8 {\n        padding-top: 10rem !important\n    }\n\n    .pt-lg-9 {\n        padding-top: 11rem !important\n    }\n\n    .pt-lg-10 {\n        padding-top: 14rem !important\n    }\n\n    .pt-lg-11 {\n        padding-top: 16rem !important\n    }\n\n    .pt-lg-12 {\n        padding-top: 20rem !important\n    }\n\n    .pt-lg-sm {\n        padding-top: 1rem !important\n    }\n\n    .pt-lg-md {\n        padding-top: 2rem !important\n    }\n\n    .pt-lg-lg {\n        padding-top: 4rem !important\n    }\n\n    .pt-lg-xl {\n        padding-top: 8rem !important\n    }\n\n    .pe-lg-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-lg-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-lg-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-lg-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-lg-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-lg-5 {\n        padding-right: 3rem !important\n    }\n\n    .pe-lg-6 {\n        padding-right: 5rem !important\n    }\n\n    .pe-lg-7 {\n        padding-right: 8rem !important\n    }\n\n    .pe-lg-8 {\n        padding-right: 10rem !important\n    }\n\n    .pe-lg-9 {\n        padding-right: 11rem !important\n    }\n\n    .pe-lg-10 {\n        padding-right: 14rem !important\n    }\n\n    .pe-lg-11 {\n        padding-right: 16rem !important\n    }\n\n    .pe-lg-12 {\n        padding-right: 20rem !important\n    }\n\n    .pe-lg-sm {\n        padding-right: 1rem !important\n    }\n\n    .pe-lg-md {\n        padding-right: 2rem !important\n    }\n\n    .pe-lg-lg {\n        padding-right: 4rem !important\n    }\n\n    .pe-lg-xl {\n        padding-right: 8rem !important\n    }\n\n    .pb-lg-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-lg-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-lg-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-lg-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-lg-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-lg-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pb-lg-6 {\n        padding-bottom: 5rem !important\n    }\n\n    .pb-lg-7 {\n        padding-bottom: 8rem !important\n    }\n\n    .pb-lg-8 {\n        padding-bottom: 10rem !important\n    }\n\n    .pb-lg-9 {\n        padding-bottom: 11rem !important\n    }\n\n    .pb-lg-10 {\n        padding-bottom: 14rem !important\n    }\n\n    .pb-lg-11 {\n        padding-bottom: 16rem !important\n    }\n\n    .pb-lg-12 {\n        padding-bottom: 20rem !important\n    }\n\n    .pb-lg-sm {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-lg-md {\n        padding-bottom: 2rem !important\n    }\n\n    .pb-lg-lg {\n        padding-bottom: 4rem !important\n    }\n\n    .pb-lg-xl {\n        padding-bottom: 8rem !important\n    }\n\n    .ps-lg-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-lg-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-lg-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-lg-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-lg-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-lg-5 {\n        padding-left: 3rem !important\n    }\n\n    .ps-lg-6 {\n        padding-left: 5rem !important\n    }\n\n    .ps-lg-7 {\n        padding-left: 8rem !important\n    }\n\n    .ps-lg-8 {\n        padding-left: 10rem !important\n    }\n\n    .ps-lg-9 {\n        padding-left: 11rem !important\n    }\n\n    .ps-lg-10 {\n        padding-left: 14rem !important\n    }\n\n    .ps-lg-11 {\n        padding-left: 16rem !important\n    }\n\n    .ps-lg-12 {\n        padding-left: 20rem !important\n    }\n\n    .ps-lg-sm {\n        padding-left: 1rem !important\n    }\n\n    .ps-lg-md {\n        padding-left: 2rem !important\n    }\n\n    .ps-lg-lg {\n        padding-left: 4rem !important\n    }\n\n    .ps-lg-xl {\n        padding-left: 8rem !important\n    }\n\n    .text-lg-start {\n        text-align: left !important\n    }\n\n    .text-lg-end {\n        text-align: right !important\n    }\n\n    .text-lg-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .float-xl-start {\n        float: left !important\n    }\n\n    .float-xl-end {\n        float: right !important\n    }\n\n    .float-xl-none {\n        float: none !important\n    }\n\n    .d-xl-inline {\n        display: inline !important\n    }\n\n    .d-xl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xl-block {\n        display: block !important\n    }\n\n    .d-xl-grid {\n        display: grid !important\n    }\n\n    .d-xl-table {\n        display: table !important\n    }\n\n    .d-xl-table-row {\n        display: table-row !important\n    }\n\n    .d-xl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xl-flex {\n        display: flex !important\n    }\n\n    .d-xl-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-xl-none {\n        display: none !important\n    }\n\n    .vh-xl-100 {\n        height: 100vh !important\n    }\n\n    .flex-xl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-xl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .gap-xl-0 {\n        gap: 0 !important\n    }\n\n    .gap-xl-1 {\n        gap: .25rem !important\n    }\n\n    .gap-xl-2 {\n        gap: .5rem !important\n    }\n\n    .gap-xl-3 {\n        gap: 1rem !important\n    }\n\n    .gap-xl-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-xl-5 {\n        gap: 3rem !important\n    }\n\n    .gap-xl-6 {\n        gap: 5rem !important\n    }\n\n    .gap-xl-7 {\n        gap: 8rem !important\n    }\n\n    .gap-xl-8 {\n        gap: 10rem !important\n    }\n\n    .gap-xl-9 {\n        gap: 11rem !important\n    }\n\n    .gap-xl-10 {\n        gap: 14rem !important\n    }\n\n    .gap-xl-11 {\n        gap: 16rem !important\n    }\n\n    .gap-xl-12 {\n        gap: 20rem !important\n    }\n\n    .gap-xl-sm {\n        gap: 1rem !important\n    }\n\n    .gap-xl-md {\n        gap: 2rem !important\n    }\n\n    .gap-xl-lg {\n        gap: 4rem !important\n    }\n\n    .gap-xl-xl {\n        gap: 8rem !important\n    }\n\n    .justify-content-xl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xl-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-xl-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-xl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xl-center {\n        align-items: center !important\n    }\n\n    .align-items-xl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xl-center {\n        align-content: center !important\n    }\n\n    .align-content-xl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xl-center {\n        align-self: center !important\n    }\n\n    .align-self-xl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xl-stretch {\n        align-self: stretch !important\n    }\n\n    .order-xl-first {\n        order: -1 !important\n    }\n\n    .order-xl-0 {\n        order: 0 !important\n    }\n\n    .order-xl-1 {\n        order: 1 !important\n    }\n\n    .order-xl-2 {\n        order: 2 !important\n    }\n\n    .order-xl-3 {\n        order: 3 !important\n    }\n\n    .order-xl-4 {\n        order: 4 !important\n    }\n\n    .order-xl-5 {\n        order: 5 !important\n    }\n\n    .order-xl-last {\n        order: 6 !important\n    }\n\n    .m-xl-0 {\n        margin: 0 !important\n    }\n\n    .m-xl-1 {\n        margin: .25rem !important\n    }\n\n    .m-xl-2 {\n        margin: .5rem !important\n    }\n\n    .m-xl-3 {\n        margin: 1rem !important\n    }\n\n    .m-xl-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-xl-5 {\n        margin: 3rem !important\n    }\n\n    .m-xl-6 {\n        margin: 5rem !important\n    }\n\n    .m-xl-7 {\n        margin: 8rem !important\n    }\n\n    .m-xl-8 {\n        margin: 10rem !important\n    }\n\n    .m-xl-9 {\n        margin: 11rem !important\n    }\n\n    .m-xl-10 {\n        margin: 14rem !important\n    }\n\n    .m-xl-11 {\n        margin: 16rem !important\n    }\n\n    .m-xl-12 {\n        margin: 20rem !important\n    }\n\n    .m-xl-sm {\n        margin: 1rem !important\n    }\n\n    .m-xl-md {\n        margin: 2rem !important\n    }\n\n    .m-xl-lg {\n        margin: 4rem !important\n    }\n\n    .m-xl-xl {\n        margin: 8rem !important\n    }\n\n    .m-xl-auto {\n        margin: auto !important\n    }\n\n    .mx-xl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-xl-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-xl-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-xl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-xl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-xl-6 {\n        margin-right: 5rem !important;\n        margin-left: 5rem !important\n    }\n\n    .mx-xl-7 {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-xl-8 {\n        margin-right: 10rem !important;\n        margin-left: 10rem !important\n    }\n\n    .mx-xl-9 {\n        margin-right: 11rem !important;\n        margin-left: 11rem !important\n    }\n\n    .mx-xl-10 {\n        margin-right: 14rem !important;\n        margin-left: 14rem !important\n    }\n\n    .mx-xl-11 {\n        margin-right: 16rem !important;\n        margin-left: 16rem !important\n    }\n\n    .mx-xl-12 {\n        margin-right: 20rem !important;\n        margin-left: 20rem !important\n    }\n\n    .mx-xl-sm {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xl-md {\n        margin-right: 2rem !important;\n        margin-left: 2rem !important\n    }\n\n    .mx-xl-lg {\n        margin-right: 4rem !important;\n        margin-left: 4rem !important\n    }\n\n    .mx-xl-xl {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-xl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-xl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-xl-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-xl-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-xl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-xl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-xl-6 {\n        margin-top: 5rem !important;\n        margin-bottom: 5rem !important\n    }\n\n    .my-xl-7 {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-xl-8 {\n        margin-top: 10rem !important;\n        margin-bottom: 10rem !important\n    }\n\n    .my-xl-9 {\n        margin-top: 11rem !important;\n        margin-bottom: 11rem !important\n    }\n\n    .my-xl-10 {\n        margin-top: 14rem !important;\n        margin-bottom: 14rem !important\n    }\n\n    .my-xl-11 {\n        margin-top: 16rem !important;\n        margin-bottom: 16rem !important\n    }\n\n    .my-xl-12 {\n        margin-top: 20rem !important;\n        margin-bottom: 20rem !important\n    }\n\n    .my-xl-sm {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xl-md {\n        margin-top: 2rem !important;\n        margin-bottom: 2rem !important\n    }\n\n    .my-xl-lg {\n        margin-top: 4rem !important;\n        margin-bottom: 4rem !important\n    }\n\n    .my-xl-xl {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-xl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-xl-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-xl-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-xl-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-xl-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-xl-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-xl-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-xl-6 {\n        margin-top: 5rem !important\n    }\n\n    .mt-xl-7 {\n        margin-top: 8rem !important\n    }\n\n    .mt-xl-8 {\n        margin-top: 10rem !important\n    }\n\n    .mt-xl-9 {\n        margin-top: 11rem !important\n    }\n\n    .mt-xl-10 {\n        margin-top: 14rem !important\n    }\n\n    .mt-xl-11 {\n        margin-top: 16rem !important\n    }\n\n    .mt-xl-12 {\n        margin-top: 20rem !important\n    }\n\n    .mt-xl-sm {\n        margin-top: 1rem !important\n    }\n\n    .mt-xl-md {\n        margin-top: 2rem !important\n    }\n\n    .mt-xl-lg {\n        margin-top: 4rem !important\n    }\n\n    .mt-xl-xl {\n        margin-top: 8rem !important\n    }\n\n    .mt-xl-auto {\n        margin-top: auto !important\n    }\n\n    .me-xl-0 {\n        margin-right: 0 !important\n    }\n\n    .me-xl-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-xl-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-xl-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-xl-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-xl-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-xl-6 {\n        margin-right: 5rem !important\n    }\n\n    .me-xl-7 {\n        margin-right: 8rem !important\n    }\n\n    .me-xl-8 {\n        margin-right: 10rem !important\n    }\n\n    .me-xl-9 {\n        margin-right: 11rem !important\n    }\n\n    .me-xl-10 {\n        margin-right: 14rem !important\n    }\n\n    .me-xl-11 {\n        margin-right: 16rem !important\n    }\n\n    .me-xl-12 {\n        margin-right: 20rem !important\n    }\n\n    .me-xl-sm {\n        margin-right: 1rem !important\n    }\n\n    .me-xl-md {\n        margin-right: 2rem !important\n    }\n\n    .me-xl-lg {\n        margin-right: 4rem !important\n    }\n\n    .me-xl-xl {\n        margin-right: 8rem !important\n    }\n\n    .me-xl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-xl-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-xl-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-xl-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xl-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-xl-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-xl-6 {\n        margin-bottom: 5rem !important\n    }\n\n    .mb-xl-7 {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-xl-8 {\n        margin-bottom: 10rem !important\n    }\n\n    .mb-xl-9 {\n        margin-bottom: 11rem !important\n    }\n\n    .mb-xl-10 {\n        margin-bottom: 14rem !important\n    }\n\n    .mb-xl-11 {\n        margin-bottom: 16rem !important\n    }\n\n    .mb-xl-12 {\n        margin-bottom: 20rem !important\n    }\n\n    .mb-xl-sm {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xl-md {\n        margin-bottom: 2rem !important\n    }\n\n    .mb-xl-lg {\n        margin-bottom: 4rem !important\n    }\n\n    .mb-xl-xl {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-xl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-xl-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-xl-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-xl-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-xl-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-xl-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-xl-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-xl-6 {\n        margin-left: 5rem !important\n    }\n\n    .ms-xl-7 {\n        margin-left: 8rem !important\n    }\n\n    .ms-xl-8 {\n        margin-left: 10rem !important\n    }\n\n    .ms-xl-9 {\n        margin-left: 11rem !important\n    }\n\n    .ms-xl-10 {\n        margin-left: 14rem !important\n    }\n\n    .ms-xl-11 {\n        margin-left: 16rem !important\n    }\n\n    .ms-xl-12 {\n        margin-left: 20rem !important\n    }\n\n    .ms-xl-sm {\n        margin-left: 1rem !important\n    }\n\n    .ms-xl-md {\n        margin-left: 2rem !important\n    }\n\n    .ms-xl-lg {\n        margin-left: 4rem !important\n    }\n\n    .ms-xl-xl {\n        margin-left: 8rem !important\n    }\n\n    .ms-xl-auto {\n        margin-left: auto !important\n    }\n\n    .m-xl-n1 {\n        margin: -.25rem !important\n    }\n\n    .m-xl-n2 {\n        margin: -.5rem !important\n    }\n\n    .m-xl-n3 {\n        margin: -1rem !important\n    }\n\n    .m-xl-n4 {\n        margin: -1.5rem !important\n    }\n\n    .m-xl-n5 {\n        margin: -3rem !important\n    }\n\n    .m-xl-n6 {\n        margin: -5rem !important\n    }\n\n    .m-xl-n7 {\n        margin: -8rem !important\n    }\n\n    .m-xl-n8 {\n        margin: -10rem !important\n    }\n\n    .m-xl-n9 {\n        margin: -11rem !important\n    }\n\n    .m-xl-n10 {\n        margin: -14rem !important\n    }\n\n    .m-xl-n11 {\n        margin: -16rem !important\n    }\n\n    .m-xl-n12 {\n        margin: -20rem !important\n    }\n\n    .m-xl-nsm {\n        margin: -1rem !important\n    }\n\n    .m-xl-nmd {\n        margin: -2rem !important\n    }\n\n    .m-xl-nlg {\n        margin: -4rem !important\n    }\n\n    .m-xl-nxl {\n        margin: -8rem !important\n    }\n\n    .mx-xl-n1 {\n        margin-right: -.25rem !important;\n        margin-left: -.25rem !important\n    }\n\n    .mx-xl-n2 {\n        margin-right: -.5rem !important;\n        margin-left: -.5rem !important\n    }\n\n    .mx-xl-n3 {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-xl-n4 {\n        margin-right: -1.5rem !important;\n        margin-left: -1.5rem !important\n    }\n\n    .mx-xl-n5 {\n        margin-right: -3rem !important;\n        margin-left: -3rem !important\n    }\n\n    .mx-xl-n6 {\n        margin-right: -5rem !important;\n        margin-left: -5rem !important\n    }\n\n    .mx-xl-n7 {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .mx-xl-n8 {\n        margin-right: -10rem !important;\n        margin-left: -10rem !important\n    }\n\n    .mx-xl-n9 {\n        margin-right: -11rem !important;\n        margin-left: -11rem !important\n    }\n\n    .mx-xl-n10 {\n        margin-right: -14rem !important;\n        margin-left: -14rem !important\n    }\n\n    .mx-xl-n11 {\n        margin-right: -16rem !important;\n        margin-left: -16rem !important\n    }\n\n    .mx-xl-n12 {\n        margin-right: -20rem !important;\n        margin-left: -20rem !important\n    }\n\n    .mx-xl-nsm {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-xl-nmd {\n        margin-right: -2rem !important;\n        margin-left: -2rem !important\n    }\n\n    .mx-xl-nlg {\n        margin-right: -4rem !important;\n        margin-left: -4rem !important\n    }\n\n    .mx-xl-nxl {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .my-xl-n1 {\n        margin-top: -.25rem !important;\n        margin-bottom: -.25rem !important\n    }\n\n    .my-xl-n2 {\n        margin-top: -.5rem !important;\n        margin-bottom: -.5rem !important\n    }\n\n    .my-xl-n3 {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-xl-n4 {\n        margin-top: -1.5rem !important;\n        margin-bottom: -1.5rem !important\n    }\n\n    .my-xl-n5 {\n        margin-top: -3rem !important;\n        margin-bottom: -3rem !important\n    }\n\n    .my-xl-n6 {\n        margin-top: -5rem !important;\n        margin-bottom: -5rem !important\n    }\n\n    .my-xl-n7 {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .my-xl-n8 {\n        margin-top: -10rem !important;\n        margin-bottom: -10rem !important\n    }\n\n    .my-xl-n9 {\n        margin-top: -11rem !important;\n        margin-bottom: -11rem !important\n    }\n\n    .my-xl-n10 {\n        margin-top: -14rem !important;\n        margin-bottom: -14rem !important\n    }\n\n    .my-xl-n11 {\n        margin-top: -16rem !important;\n        margin-bottom: -16rem !important\n    }\n\n    .my-xl-n12 {\n        margin-top: -20rem !important;\n        margin-bottom: -20rem !important\n    }\n\n    .my-xl-nsm {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-xl-nmd {\n        margin-top: -2rem !important;\n        margin-bottom: -2rem !important\n    }\n\n    .my-xl-nlg {\n        margin-top: -4rem !important;\n        margin-bottom: -4rem !important\n    }\n\n    .my-xl-nxl {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .mt-xl-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mt-xl-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mt-xl-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mt-xl-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mt-xl-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mt-xl-n6 {\n        margin-top: -5rem !important\n    }\n\n    .mt-xl-n7 {\n        margin-top: -8rem !important\n    }\n\n    .mt-xl-n8 {\n        margin-top: -10rem !important\n    }\n\n    .mt-xl-n9 {\n        margin-top: -11rem !important\n    }\n\n    .mt-xl-n10 {\n        margin-top: -14rem !important\n    }\n\n    .mt-xl-n11 {\n        margin-top: -16rem !important\n    }\n\n    .mt-xl-n12 {\n        margin-top: -20rem !important\n    }\n\n    .mt-xl-nsm {\n        margin-top: -1rem !important\n    }\n\n    .mt-xl-nmd {\n        margin-top: -2rem !important\n    }\n\n    .mt-xl-nlg {\n        margin-top: -4rem !important\n    }\n\n    .mt-xl-nxl {\n        margin-top: -8rem !important\n    }\n\n    .me-xl-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .me-xl-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .me-xl-n3 {\n        margin-right: -1rem !important\n    }\n\n    .me-xl-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .me-xl-n5 {\n        margin-right: -3rem !important\n    }\n\n    .me-xl-n6 {\n        margin-right: -5rem !important\n    }\n\n    .me-xl-n7 {\n        margin-right: -8rem !important\n    }\n\n    .me-xl-n8 {\n        margin-right: -10rem !important\n    }\n\n    .me-xl-n9 {\n        margin-right: -11rem !important\n    }\n\n    .me-xl-n10 {\n        margin-right: -14rem !important\n    }\n\n    .me-xl-n11 {\n        margin-right: -16rem !important\n    }\n\n    .me-xl-n12 {\n        margin-right: -20rem !important\n    }\n\n    .me-xl-nsm {\n        margin-right: -1rem !important\n    }\n\n    .me-xl-nmd {\n        margin-right: -2rem !important\n    }\n\n    .me-xl-nlg {\n        margin-right: -4rem !important\n    }\n\n    .me-xl-nxl {\n        margin-right: -8rem !important\n    }\n\n    .mb-xl-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .mb-xl-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .mb-xl-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-xl-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .mb-xl-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .mb-xl-n6 {\n        margin-bottom: -5rem !important\n    }\n\n    .mb-xl-n7 {\n        margin-bottom: -8rem !important\n    }\n\n    .mb-xl-n8 {\n        margin-bottom: -10rem !important\n    }\n\n    .mb-xl-n9 {\n        margin-bottom: -11rem !important\n    }\n\n    .mb-xl-n10 {\n        margin-bottom: -14rem !important\n    }\n\n    .mb-xl-n11 {\n        margin-bottom: -16rem !important\n    }\n\n    .mb-xl-n12 {\n        margin-bottom: -20rem !important\n    }\n\n    .mb-xl-nsm {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-xl-nmd {\n        margin-bottom: -2rem !important\n    }\n\n    .mb-xl-nlg {\n        margin-bottom: -4rem !important\n    }\n\n    .mb-xl-nxl {\n        margin-bottom: -8rem !important\n    }\n\n    .ms-xl-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .ms-xl-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .ms-xl-n3 {\n        margin-left: -1rem !important\n    }\n\n    .ms-xl-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .ms-xl-n5 {\n        margin-left: -3rem !important\n    }\n\n    .ms-xl-n6 {\n        margin-left: -5rem !important\n    }\n\n    .ms-xl-n7 {\n        margin-left: -8rem !important\n    }\n\n    .ms-xl-n8 {\n        margin-left: -10rem !important\n    }\n\n    .ms-xl-n9 {\n        margin-left: -11rem !important\n    }\n\n    .ms-xl-n10 {\n        margin-left: -14rem !important\n    }\n\n    .ms-xl-n11 {\n        margin-left: -16rem !important\n    }\n\n    .ms-xl-n12 {\n        margin-left: -20rem !important\n    }\n\n    .ms-xl-nsm {\n        margin-left: -1rem !important\n    }\n\n    .ms-xl-nmd {\n        margin-left: -2rem !important\n    }\n\n    .ms-xl-nlg {\n        margin-left: -4rem !important\n    }\n\n    .ms-xl-nxl {\n        margin-left: -8rem !important\n    }\n\n    .p-xl-0 {\n        padding: 0 !important\n    }\n\n    .p-xl-1 {\n        padding: .25rem !important\n    }\n\n    .p-xl-2 {\n        padding: .5rem !important\n    }\n\n    .p-xl-3 {\n        padding: 1rem !important\n    }\n\n    .p-xl-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-xl-5 {\n        padding: 3rem !important\n    }\n\n    .p-xl-6 {\n        padding: 5rem !important\n    }\n\n    .p-xl-7 {\n        padding: 8rem !important\n    }\n\n    .p-xl-8 {\n        padding: 10rem !important\n    }\n\n    .p-xl-9 {\n        padding: 11rem !important\n    }\n\n    .p-xl-10 {\n        padding: 14rem !important\n    }\n\n    .p-xl-11 {\n        padding: 16rem !important\n    }\n\n    .p-xl-12 {\n        padding: 20rem !important\n    }\n\n    .p-xl-sm {\n        padding: 1rem !important\n    }\n\n    .p-xl-md {\n        padding: 2rem !important\n    }\n\n    .p-xl-lg {\n        padding: 4rem !important\n    }\n\n    .p-xl-xl {\n        padding: 8rem !important\n    }\n\n    .px-xl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-xl-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-xl-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-xl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-xl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .px-xl-6 {\n        padding-right: 5rem !important;\n        padding-left: 5rem !important\n    }\n\n    .px-xl-7 {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .px-xl-8 {\n        padding-right: 10rem !important;\n        padding-left: 10rem !important\n    }\n\n    .px-xl-9 {\n        padding-right: 11rem !important;\n        padding-left: 11rem !important\n    }\n\n    .px-xl-10 {\n        padding-right: 14rem !important;\n        padding-left: 14rem !important\n    }\n\n    .px-xl-11 {\n        padding-right: 16rem !important;\n        padding-left: 16rem !important\n    }\n\n    .px-xl-12 {\n        padding-right: 20rem !important;\n        padding-left: 20rem !important\n    }\n\n    .px-xl-sm {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xl-md {\n        padding-right: 2rem !important;\n        padding-left: 2rem !important\n    }\n\n    .px-xl-lg {\n        padding-right: 4rem !important;\n        padding-left: 4rem !important\n    }\n\n    .px-xl-xl {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .py-xl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-xl-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-xl-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-xl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-xl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .py-xl-6 {\n        padding-top: 5rem !important;\n        padding-bottom: 5rem !important\n    }\n\n    .py-xl-7 {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .py-xl-8 {\n        padding-top: 10rem !important;\n        padding-bottom: 10rem !important\n    }\n\n    .py-xl-9 {\n        padding-top: 11rem !important;\n        padding-bottom: 11rem !important\n    }\n\n    .py-xl-10 {\n        padding-top: 14rem !important;\n        padding-bottom: 14rem !important\n    }\n\n    .py-xl-11 {\n        padding-top: 16rem !important;\n        padding-bottom: 16rem !important\n    }\n\n    .py-xl-12 {\n        padding-top: 20rem !important;\n        padding-bottom: 20rem !important\n    }\n\n    .py-xl-sm {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xl-md {\n        padding-top: 2rem !important;\n        padding-bottom: 2rem !important\n    }\n\n    .py-xl-lg {\n        padding-top: 4rem !important;\n        padding-bottom: 4rem !important\n    }\n\n    .py-xl-xl {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .pt-xl-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-xl-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-xl-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-xl-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-xl-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-xl-5 {\n        padding-top: 3rem !important\n    }\n\n    .pt-xl-6 {\n        padding-top: 5rem !important\n    }\n\n    .pt-xl-7 {\n        padding-top: 8rem !important\n    }\n\n    .pt-xl-8 {\n        padding-top: 10rem !important\n    }\n\n    .pt-xl-9 {\n        padding-top: 11rem !important\n    }\n\n    .pt-xl-10 {\n        padding-top: 14rem !important\n    }\n\n    .pt-xl-11 {\n        padding-top: 16rem !important\n    }\n\n    .pt-xl-12 {\n        padding-top: 20rem !important\n    }\n\n    .pt-xl-sm {\n        padding-top: 1rem !important\n    }\n\n    .pt-xl-md {\n        padding-top: 2rem !important\n    }\n\n    .pt-xl-lg {\n        padding-top: 4rem !important\n    }\n\n    .pt-xl-xl {\n        padding-top: 8rem !important\n    }\n\n    .pe-xl-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-xl-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-xl-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-xl-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-xl-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-xl-5 {\n        padding-right: 3rem !important\n    }\n\n    .pe-xl-6 {\n        padding-right: 5rem !important\n    }\n\n    .pe-xl-7 {\n        padding-right: 8rem !important\n    }\n\n    .pe-xl-8 {\n        padding-right: 10rem !important\n    }\n\n    .pe-xl-9 {\n        padding-right: 11rem !important\n    }\n\n    .pe-xl-10 {\n        padding-right: 14rem !important\n    }\n\n    .pe-xl-11 {\n        padding-right: 16rem !important\n    }\n\n    .pe-xl-12 {\n        padding-right: 20rem !important\n    }\n\n    .pe-xl-sm {\n        padding-right: 1rem !important\n    }\n\n    .pe-xl-md {\n        padding-right: 2rem !important\n    }\n\n    .pe-xl-lg {\n        padding-right: 4rem !important\n    }\n\n    .pe-xl-xl {\n        padding-right: 8rem !important\n    }\n\n    .pb-xl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-xl-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-xl-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-xl-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xl-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-xl-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pb-xl-6 {\n        padding-bottom: 5rem !important\n    }\n\n    .pb-xl-7 {\n        padding-bottom: 8rem !important\n    }\n\n    .pb-xl-8 {\n        padding-bottom: 10rem !important\n    }\n\n    .pb-xl-9 {\n        padding-bottom: 11rem !important\n    }\n\n    .pb-xl-10 {\n        padding-bottom: 14rem !important\n    }\n\n    .pb-xl-11 {\n        padding-bottom: 16rem !important\n    }\n\n    .pb-xl-12 {\n        padding-bottom: 20rem !important\n    }\n\n    .pb-xl-sm {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xl-md {\n        padding-bottom: 2rem !important\n    }\n\n    .pb-xl-lg {\n        padding-bottom: 4rem !important\n    }\n\n    .pb-xl-xl {\n        padding-bottom: 8rem !important\n    }\n\n    .ps-xl-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-xl-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-xl-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-xl-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-xl-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-xl-5 {\n        padding-left: 3rem !important\n    }\n\n    .ps-xl-6 {\n        padding-left: 5rem !important\n    }\n\n    .ps-xl-7 {\n        padding-left: 8rem !important\n    }\n\n    .ps-xl-8 {\n        padding-left: 10rem !important\n    }\n\n    .ps-xl-9 {\n        padding-left: 11rem !important\n    }\n\n    .ps-xl-10 {\n        padding-left: 14rem !important\n    }\n\n    .ps-xl-11 {\n        padding-left: 16rem !important\n    }\n\n    .ps-xl-12 {\n        padding-left: 20rem !important\n    }\n\n    .ps-xl-sm {\n        padding-left: 1rem !important\n    }\n\n    .ps-xl-md {\n        padding-left: 2rem !important\n    }\n\n    .ps-xl-lg {\n        padding-left: 4rem !important\n    }\n\n    .ps-xl-xl {\n        padding-left: 8rem !important\n    }\n\n    .text-xl-start {\n        text-align: left !important\n    }\n\n    .text-xl-end {\n        text-align: right !important\n    }\n\n    .text-xl-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 1400px) {\n    .float-xxl-start {\n        float: left !important\n    }\n\n    .float-xxl-end {\n        float: right !important\n    }\n\n    .float-xxl-none {\n        float: none !important\n    }\n\n    .d-xxl-inline {\n        display: inline !important\n    }\n\n    .d-xxl-inline-block {\n        display: inline-block !important\n    }\n\n    .d-xxl-block {\n        display: block !important\n    }\n\n    .d-xxl-grid {\n        display: grid !important\n    }\n\n    .d-xxl-table {\n        display: table !important\n    }\n\n    .d-xxl-table-row {\n        display: table-row !important\n    }\n\n    .d-xxl-table-cell {\n        display: table-cell !important\n    }\n\n    .d-xxl-flex {\n        display: flex !important\n    }\n\n    .d-xxl-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-xxl-none {\n        display: none !important\n    }\n\n    .vh-xxl-100 {\n        height: 100vh !important\n    }\n\n    .flex-xxl-fill {\n        flex: 1 1 auto !important\n    }\n\n    .flex-xxl-row {\n        flex-direction: row !important\n    }\n\n    .flex-xxl-column {\n        flex-direction: column !important\n    }\n\n    .flex-xxl-row-reverse {\n        flex-direction: row-reverse !important\n    }\n\n    .flex-xxl-column-reverse {\n        flex-direction: column-reverse !important\n    }\n\n    .flex-xxl-grow-0 {\n        flex-grow: 0 !important\n    }\n\n    .flex-xxl-grow-1 {\n        flex-grow: 1 !important\n    }\n\n    .flex-xxl-shrink-0 {\n        flex-shrink: 0 !important\n    }\n\n    .flex-xxl-shrink-1 {\n        flex-shrink: 1 !important\n    }\n\n    .flex-xxl-wrap {\n        flex-wrap: wrap !important\n    }\n\n    .flex-xxl-nowrap {\n        flex-wrap: nowrap !important\n    }\n\n    .flex-xxl-wrap-reverse {\n        flex-wrap: wrap-reverse !important\n    }\n\n    .gap-xxl-0 {\n        gap: 0 !important\n    }\n\n    .gap-xxl-1 {\n        gap: .25rem !important\n    }\n\n    .gap-xxl-2 {\n        gap: .5rem !important\n    }\n\n    .gap-xxl-3 {\n        gap: 1rem !important\n    }\n\n    .gap-xxl-4 {\n        gap: 1.5rem !important\n    }\n\n    .gap-xxl-5 {\n        gap: 3rem !important\n    }\n\n    .gap-xxl-6 {\n        gap: 5rem !important\n    }\n\n    .gap-xxl-7 {\n        gap: 8rem !important\n    }\n\n    .gap-xxl-8 {\n        gap: 10rem !important\n    }\n\n    .gap-xxl-9 {\n        gap: 11rem !important\n    }\n\n    .gap-xxl-10 {\n        gap: 14rem !important\n    }\n\n    .gap-xxl-11 {\n        gap: 16rem !important\n    }\n\n    .gap-xxl-12 {\n        gap: 20rem !important\n    }\n\n    .gap-xxl-sm {\n        gap: 1rem !important\n    }\n\n    .gap-xxl-md {\n        gap: 2rem !important\n    }\n\n    .gap-xxl-lg {\n        gap: 4rem !important\n    }\n\n    .gap-xxl-xl {\n        gap: 8rem !important\n    }\n\n    .justify-content-xxl-start {\n        justify-content: flex-start !important\n    }\n\n    .justify-content-xxl-end {\n        justify-content: flex-end !important\n    }\n\n    .justify-content-xxl-center {\n        justify-content: center !important\n    }\n\n    .justify-content-xxl-between {\n        justify-content: space-between !important\n    }\n\n    .justify-content-xxl-around {\n        justify-content: space-around !important\n    }\n\n    .justify-content-xxl-evenly {\n        justify-content: space-evenly !important\n    }\n\n    .align-items-xxl-start {\n        align-items: flex-start !important\n    }\n\n    .align-items-xxl-end {\n        align-items: flex-end !important\n    }\n\n    .align-items-xxl-center {\n        align-items: center !important\n    }\n\n    .align-items-xxl-baseline {\n        align-items: baseline !important\n    }\n\n    .align-items-xxl-stretch {\n        align-items: stretch !important\n    }\n\n    .align-content-xxl-start {\n        align-content: flex-start !important\n    }\n\n    .align-content-xxl-end {\n        align-content: flex-end !important\n    }\n\n    .align-content-xxl-center {\n        align-content: center !important\n    }\n\n    .align-content-xxl-between {\n        align-content: space-between !important\n    }\n\n    .align-content-xxl-around {\n        align-content: space-around !important\n    }\n\n    .align-content-xxl-stretch {\n        align-content: stretch !important\n    }\n\n    .align-self-xxl-auto {\n        align-self: auto !important\n    }\n\n    .align-self-xxl-start {\n        align-self: flex-start !important\n    }\n\n    .align-self-xxl-end {\n        align-self: flex-end !important\n    }\n\n    .align-self-xxl-center {\n        align-self: center !important\n    }\n\n    .align-self-xxl-baseline {\n        align-self: baseline !important\n    }\n\n    .align-self-xxl-stretch {\n        align-self: stretch !important\n    }\n\n    .order-xxl-first {\n        order: -1 !important\n    }\n\n    .order-xxl-0 {\n        order: 0 !important\n    }\n\n    .order-xxl-1 {\n        order: 1 !important\n    }\n\n    .order-xxl-2 {\n        order: 2 !important\n    }\n\n    .order-xxl-3 {\n        order: 3 !important\n    }\n\n    .order-xxl-4 {\n        order: 4 !important\n    }\n\n    .order-xxl-5 {\n        order: 5 !important\n    }\n\n    .order-xxl-last {\n        order: 6 !important\n    }\n\n    .m-xxl-0 {\n        margin: 0 !important\n    }\n\n    .m-xxl-1 {\n        margin: .25rem !important\n    }\n\n    .m-xxl-2 {\n        margin: .5rem !important\n    }\n\n    .m-xxl-3 {\n        margin: 1rem !important\n    }\n\n    .m-xxl-4 {\n        margin: 1.5rem !important\n    }\n\n    .m-xxl-5 {\n        margin: 3rem !important\n    }\n\n    .m-xxl-6 {\n        margin: 5rem !important\n    }\n\n    .m-xxl-7 {\n        margin: 8rem !important\n    }\n\n    .m-xxl-8 {\n        margin: 10rem !important\n    }\n\n    .m-xxl-9 {\n        margin: 11rem !important\n    }\n\n    .m-xxl-10 {\n        margin: 14rem !important\n    }\n\n    .m-xxl-11 {\n        margin: 16rem !important\n    }\n\n    .m-xxl-12 {\n        margin: 20rem !important\n    }\n\n    .m-xxl-sm {\n        margin: 1rem !important\n    }\n\n    .m-xxl-md {\n        margin: 2rem !important\n    }\n\n    .m-xxl-lg {\n        margin: 4rem !important\n    }\n\n    .m-xxl-xl {\n        margin: 8rem !important\n    }\n\n    .m-xxl-auto {\n        margin: auto !important\n    }\n\n    .mx-xxl-0 {\n        margin-right: 0 !important;\n        margin-left: 0 !important\n    }\n\n    .mx-xxl-1 {\n        margin-right: .25rem !important;\n        margin-left: .25rem !important\n    }\n\n    .mx-xxl-2 {\n        margin-right: .5rem !important;\n        margin-left: .5rem !important\n    }\n\n    .mx-xxl-3 {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xxl-4 {\n        margin-right: 1.5rem !important;\n        margin-left: 1.5rem !important\n    }\n\n    .mx-xxl-5 {\n        margin-right: 3rem !important;\n        margin-left: 3rem !important\n    }\n\n    .mx-xxl-6 {\n        margin-right: 5rem !important;\n        margin-left: 5rem !important\n    }\n\n    .mx-xxl-7 {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-xxl-8 {\n        margin-right: 10rem !important;\n        margin-left: 10rem !important\n    }\n\n    .mx-xxl-9 {\n        margin-right: 11rem !important;\n        margin-left: 11rem !important\n    }\n\n    .mx-xxl-10 {\n        margin-right: 14rem !important;\n        margin-left: 14rem !important\n    }\n\n    .mx-xxl-11 {\n        margin-right: 16rem !important;\n        margin-left: 16rem !important\n    }\n\n    .mx-xxl-12 {\n        margin-right: 20rem !important;\n        margin-left: 20rem !important\n    }\n\n    .mx-xxl-sm {\n        margin-right: 1rem !important;\n        margin-left: 1rem !important\n    }\n\n    .mx-xxl-md {\n        margin-right: 2rem !important;\n        margin-left: 2rem !important\n    }\n\n    .mx-xxl-lg {\n        margin-right: 4rem !important;\n        margin-left: 4rem !important\n    }\n\n    .mx-xxl-xl {\n        margin-right: 8rem !important;\n        margin-left: 8rem !important\n    }\n\n    .mx-xxl-auto {\n        margin-right: auto !important;\n        margin-left: auto !important\n    }\n\n    .my-xxl-0 {\n        margin-top: 0 !important;\n        margin-bottom: 0 !important\n    }\n\n    .my-xxl-1 {\n        margin-top: .25rem !important;\n        margin-bottom: .25rem !important\n    }\n\n    .my-xxl-2 {\n        margin-top: .5rem !important;\n        margin-bottom: .5rem !important\n    }\n\n    .my-xxl-3 {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xxl-4 {\n        margin-top: 1.5rem !important;\n        margin-bottom: 1.5rem !important\n    }\n\n    .my-xxl-5 {\n        margin-top: 3rem !important;\n        margin-bottom: 3rem !important\n    }\n\n    .my-xxl-6 {\n        margin-top: 5rem !important;\n        margin-bottom: 5rem !important\n    }\n\n    .my-xxl-7 {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-xxl-8 {\n        margin-top: 10rem !important;\n        margin-bottom: 10rem !important\n    }\n\n    .my-xxl-9 {\n        margin-top: 11rem !important;\n        margin-bottom: 11rem !important\n    }\n\n    .my-xxl-10 {\n        margin-top: 14rem !important;\n        margin-bottom: 14rem !important\n    }\n\n    .my-xxl-11 {\n        margin-top: 16rem !important;\n        margin-bottom: 16rem !important\n    }\n\n    .my-xxl-12 {\n        margin-top: 20rem !important;\n        margin-bottom: 20rem !important\n    }\n\n    .my-xxl-sm {\n        margin-top: 1rem !important;\n        margin-bottom: 1rem !important\n    }\n\n    .my-xxl-md {\n        margin-top: 2rem !important;\n        margin-bottom: 2rem !important\n    }\n\n    .my-xxl-lg {\n        margin-top: 4rem !important;\n        margin-bottom: 4rem !important\n    }\n\n    .my-xxl-xl {\n        margin-top: 8rem !important;\n        margin-bottom: 8rem !important\n    }\n\n    .my-xxl-auto {\n        margin-top: auto !important;\n        margin-bottom: auto !important\n    }\n\n    .mt-xxl-0 {\n        margin-top: 0 !important\n    }\n\n    .mt-xxl-1 {\n        margin-top: .25rem !important\n    }\n\n    .mt-xxl-2 {\n        margin-top: .5rem !important\n    }\n\n    .mt-xxl-3 {\n        margin-top: 1rem !important\n    }\n\n    .mt-xxl-4 {\n        margin-top: 1.5rem !important\n    }\n\n    .mt-xxl-5 {\n        margin-top: 3rem !important\n    }\n\n    .mt-xxl-6 {\n        margin-top: 5rem !important\n    }\n\n    .mt-xxl-7 {\n        margin-top: 8rem !important\n    }\n\n    .mt-xxl-8 {\n        margin-top: 10rem !important\n    }\n\n    .mt-xxl-9 {\n        margin-top: 11rem !important\n    }\n\n    .mt-xxl-10 {\n        margin-top: 14rem !important\n    }\n\n    .mt-xxl-11 {\n        margin-top: 16rem !important\n    }\n\n    .mt-xxl-12 {\n        margin-top: 20rem !important\n    }\n\n    .mt-xxl-sm {\n        margin-top: 1rem !important\n    }\n\n    .mt-xxl-md {\n        margin-top: 2rem !important\n    }\n\n    .mt-xxl-lg {\n        margin-top: 4rem !important\n    }\n\n    .mt-xxl-xl {\n        margin-top: 8rem !important\n    }\n\n    .mt-xxl-auto {\n        margin-top: auto !important\n    }\n\n    .me-xxl-0 {\n        margin-right: 0 !important\n    }\n\n    .me-xxl-1 {\n        margin-right: .25rem !important\n    }\n\n    .me-xxl-2 {\n        margin-right: .5rem !important\n    }\n\n    .me-xxl-3 {\n        margin-right: 1rem !important\n    }\n\n    .me-xxl-4 {\n        margin-right: 1.5rem !important\n    }\n\n    .me-xxl-5 {\n        margin-right: 3rem !important\n    }\n\n    .me-xxl-6 {\n        margin-right: 5rem !important\n    }\n\n    .me-xxl-7 {\n        margin-right: 8rem !important\n    }\n\n    .me-xxl-8 {\n        margin-right: 10rem !important\n    }\n\n    .me-xxl-9 {\n        margin-right: 11rem !important\n    }\n\n    .me-xxl-10 {\n        margin-right: 14rem !important\n    }\n\n    .me-xxl-11 {\n        margin-right: 16rem !important\n    }\n\n    .me-xxl-12 {\n        margin-right: 20rem !important\n    }\n\n    .me-xxl-sm {\n        margin-right: 1rem !important\n    }\n\n    .me-xxl-md {\n        margin-right: 2rem !important\n    }\n\n    .me-xxl-lg {\n        margin-right: 4rem !important\n    }\n\n    .me-xxl-xl {\n        margin-right: 8rem !important\n    }\n\n    .me-xxl-auto {\n        margin-right: auto !important\n    }\n\n    .mb-xxl-0 {\n        margin-bottom: 0 !important\n    }\n\n    .mb-xxl-1 {\n        margin-bottom: .25rem !important\n    }\n\n    .mb-xxl-2 {\n        margin-bottom: .5rem !important\n    }\n\n    .mb-xxl-3 {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xxl-4 {\n        margin-bottom: 1.5rem !important\n    }\n\n    .mb-xxl-5 {\n        margin-bottom: 3rem !important\n    }\n\n    .mb-xxl-6 {\n        margin-bottom: 5rem !important\n    }\n\n    .mb-xxl-7 {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-xxl-8 {\n        margin-bottom: 10rem !important\n    }\n\n    .mb-xxl-9 {\n        margin-bottom: 11rem !important\n    }\n\n    .mb-xxl-10 {\n        margin-bottom: 14rem !important\n    }\n\n    .mb-xxl-11 {\n        margin-bottom: 16rem !important\n    }\n\n    .mb-xxl-12 {\n        margin-bottom: 20rem !important\n    }\n\n    .mb-xxl-sm {\n        margin-bottom: 1rem !important\n    }\n\n    .mb-xxl-md {\n        margin-bottom: 2rem !important\n    }\n\n    .mb-xxl-lg {\n        margin-bottom: 4rem !important\n    }\n\n    .mb-xxl-xl {\n        margin-bottom: 8rem !important\n    }\n\n    .mb-xxl-auto {\n        margin-bottom: auto !important\n    }\n\n    .ms-xxl-0 {\n        margin-left: 0 !important\n    }\n\n    .ms-xxl-1 {\n        margin-left: .25rem !important\n    }\n\n    .ms-xxl-2 {\n        margin-left: .5rem !important\n    }\n\n    .ms-xxl-3 {\n        margin-left: 1rem !important\n    }\n\n    .ms-xxl-4 {\n        margin-left: 1.5rem !important\n    }\n\n    .ms-xxl-5 {\n        margin-left: 3rem !important\n    }\n\n    .ms-xxl-6 {\n        margin-left: 5rem !important\n    }\n\n    .ms-xxl-7 {\n        margin-left: 8rem !important\n    }\n\n    .ms-xxl-8 {\n        margin-left: 10rem !important\n    }\n\n    .ms-xxl-9 {\n        margin-left: 11rem !important\n    }\n\n    .ms-xxl-10 {\n        margin-left: 14rem !important\n    }\n\n    .ms-xxl-11 {\n        margin-left: 16rem !important\n    }\n\n    .ms-xxl-12 {\n        margin-left: 20rem !important\n    }\n\n    .ms-xxl-sm {\n        margin-left: 1rem !important\n    }\n\n    .ms-xxl-md {\n        margin-left: 2rem !important\n    }\n\n    .ms-xxl-lg {\n        margin-left: 4rem !important\n    }\n\n    .ms-xxl-xl {\n        margin-left: 8rem !important\n    }\n\n    .ms-xxl-auto {\n        margin-left: auto !important\n    }\n\n    .m-xxl-n1 {\n        margin: -.25rem !important\n    }\n\n    .m-xxl-n2 {\n        margin: -.5rem !important\n    }\n\n    .m-xxl-n3 {\n        margin: -1rem !important\n    }\n\n    .m-xxl-n4 {\n        margin: -1.5rem !important\n    }\n\n    .m-xxl-n5 {\n        margin: -3rem !important\n    }\n\n    .m-xxl-n6 {\n        margin: -5rem !important\n    }\n\n    .m-xxl-n7 {\n        margin: -8rem !important\n    }\n\n    .m-xxl-n8 {\n        margin: -10rem !important\n    }\n\n    .m-xxl-n9 {\n        margin: -11rem !important\n    }\n\n    .m-xxl-n10 {\n        margin: -14rem !important\n    }\n\n    .m-xxl-n11 {\n        margin: -16rem !important\n    }\n\n    .m-xxl-n12 {\n        margin: -20rem !important\n    }\n\n    .m-xxl-nsm {\n        margin: -1rem !important\n    }\n\n    .m-xxl-nmd {\n        margin: -2rem !important\n    }\n\n    .m-xxl-nlg {\n        margin: -4rem !important\n    }\n\n    .m-xxl-nxl {\n        margin: -8rem !important\n    }\n\n    .mx-xxl-n1 {\n        margin-right: -.25rem !important;\n        margin-left: -.25rem !important\n    }\n\n    .mx-xxl-n2 {\n        margin-right: -.5rem !important;\n        margin-left: -.5rem !important\n    }\n\n    .mx-xxl-n3 {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-xxl-n4 {\n        margin-right: -1.5rem !important;\n        margin-left: -1.5rem !important\n    }\n\n    .mx-xxl-n5 {\n        margin-right: -3rem !important;\n        margin-left: -3rem !important\n    }\n\n    .mx-xxl-n6 {\n        margin-right: -5rem !important;\n        margin-left: -5rem !important\n    }\n\n    .mx-xxl-n7 {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .mx-xxl-n8 {\n        margin-right: -10rem !important;\n        margin-left: -10rem !important\n    }\n\n    .mx-xxl-n9 {\n        margin-right: -11rem !important;\n        margin-left: -11rem !important\n    }\n\n    .mx-xxl-n10 {\n        margin-right: -14rem !important;\n        margin-left: -14rem !important\n    }\n\n    .mx-xxl-n11 {\n        margin-right: -16rem !important;\n        margin-left: -16rem !important\n    }\n\n    .mx-xxl-n12 {\n        margin-right: -20rem !important;\n        margin-left: -20rem !important\n    }\n\n    .mx-xxl-nsm {\n        margin-right: -1rem !important;\n        margin-left: -1rem !important\n    }\n\n    .mx-xxl-nmd {\n        margin-right: -2rem !important;\n        margin-left: -2rem !important\n    }\n\n    .mx-xxl-nlg {\n        margin-right: -4rem !important;\n        margin-left: -4rem !important\n    }\n\n    .mx-xxl-nxl {\n        margin-right: -8rem !important;\n        margin-left: -8rem !important\n    }\n\n    .my-xxl-n1 {\n        margin-top: -.25rem !important;\n        margin-bottom: -.25rem !important\n    }\n\n    .my-xxl-n2 {\n        margin-top: -.5rem !important;\n        margin-bottom: -.5rem !important\n    }\n\n    .my-xxl-n3 {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-xxl-n4 {\n        margin-top: -1.5rem !important;\n        margin-bottom: -1.5rem !important\n    }\n\n    .my-xxl-n5 {\n        margin-top: -3rem !important;\n        margin-bottom: -3rem !important\n    }\n\n    .my-xxl-n6 {\n        margin-top: -5rem !important;\n        margin-bottom: -5rem !important\n    }\n\n    .my-xxl-n7 {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .my-xxl-n8 {\n        margin-top: -10rem !important;\n        margin-bottom: -10rem !important\n    }\n\n    .my-xxl-n9 {\n        margin-top: -11rem !important;\n        margin-bottom: -11rem !important\n    }\n\n    .my-xxl-n10 {\n        margin-top: -14rem !important;\n        margin-bottom: -14rem !important\n    }\n\n    .my-xxl-n11 {\n        margin-top: -16rem !important;\n        margin-bottom: -16rem !important\n    }\n\n    .my-xxl-n12 {\n        margin-top: -20rem !important;\n        margin-bottom: -20rem !important\n    }\n\n    .my-xxl-nsm {\n        margin-top: -1rem !important;\n        margin-bottom: -1rem !important\n    }\n\n    .my-xxl-nmd {\n        margin-top: -2rem !important;\n        margin-bottom: -2rem !important\n    }\n\n    .my-xxl-nlg {\n        margin-top: -4rem !important;\n        margin-bottom: -4rem !important\n    }\n\n    .my-xxl-nxl {\n        margin-top: -8rem !important;\n        margin-bottom: -8rem !important\n    }\n\n    .mt-xxl-n1 {\n        margin-top: -.25rem !important\n    }\n\n    .mt-xxl-n2 {\n        margin-top: -.5rem !important\n    }\n\n    .mt-xxl-n3 {\n        margin-top: -1rem !important\n    }\n\n    .mt-xxl-n4 {\n        margin-top: -1.5rem !important\n    }\n\n    .mt-xxl-n5 {\n        margin-top: -3rem !important\n    }\n\n    .mt-xxl-n6 {\n        margin-top: -5rem !important\n    }\n\n    .mt-xxl-n7 {\n        margin-top: -8rem !important\n    }\n\n    .mt-xxl-n8 {\n        margin-top: -10rem !important\n    }\n\n    .mt-xxl-n9 {\n        margin-top: -11rem !important\n    }\n\n    .mt-xxl-n10 {\n        margin-top: -14rem !important\n    }\n\n    .mt-xxl-n11 {\n        margin-top: -16rem !important\n    }\n\n    .mt-xxl-n12 {\n        margin-top: -20rem !important\n    }\n\n    .mt-xxl-nsm {\n        margin-top: -1rem !important\n    }\n\n    .mt-xxl-nmd {\n        margin-top: -2rem !important\n    }\n\n    .mt-xxl-nlg {\n        margin-top: -4rem !important\n    }\n\n    .mt-xxl-nxl {\n        margin-top: -8rem !important\n    }\n\n    .me-xxl-n1 {\n        margin-right: -.25rem !important\n    }\n\n    .me-xxl-n2 {\n        margin-right: -.5rem !important\n    }\n\n    .me-xxl-n3 {\n        margin-right: -1rem !important\n    }\n\n    .me-xxl-n4 {\n        margin-right: -1.5rem !important\n    }\n\n    .me-xxl-n5 {\n        margin-right: -3rem !important\n    }\n\n    .me-xxl-n6 {\n        margin-right: -5rem !important\n    }\n\n    .me-xxl-n7 {\n        margin-right: -8rem !important\n    }\n\n    .me-xxl-n8 {\n        margin-right: -10rem !important\n    }\n\n    .me-xxl-n9 {\n        margin-right: -11rem !important\n    }\n\n    .me-xxl-n10 {\n        margin-right: -14rem !important\n    }\n\n    .me-xxl-n11 {\n        margin-right: -16rem !important\n    }\n\n    .me-xxl-n12 {\n        margin-right: -20rem !important\n    }\n\n    .me-xxl-nsm {\n        margin-right: -1rem !important\n    }\n\n    .me-xxl-nmd {\n        margin-right: -2rem !important\n    }\n\n    .me-xxl-nlg {\n        margin-right: -4rem !important\n    }\n\n    .me-xxl-nxl {\n        margin-right: -8rem !important\n    }\n\n    .mb-xxl-n1 {\n        margin-bottom: -.25rem !important\n    }\n\n    .mb-xxl-n2 {\n        margin-bottom: -.5rem !important\n    }\n\n    .mb-xxl-n3 {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-xxl-n4 {\n        margin-bottom: -1.5rem !important\n    }\n\n    .mb-xxl-n5 {\n        margin-bottom: -3rem !important\n    }\n\n    .mb-xxl-n6 {\n        margin-bottom: -5rem !important\n    }\n\n    .mb-xxl-n7 {\n        margin-bottom: -8rem !important\n    }\n\n    .mb-xxl-n8 {\n        margin-bottom: -10rem !important\n    }\n\n    .mb-xxl-n9 {\n        margin-bottom: -11rem !important\n    }\n\n    .mb-xxl-n10 {\n        margin-bottom: -14rem !important\n    }\n\n    .mb-xxl-n11 {\n        margin-bottom: -16rem !important\n    }\n\n    .mb-xxl-n12 {\n        margin-bottom: -20rem !important\n    }\n\n    .mb-xxl-nsm {\n        margin-bottom: -1rem !important\n    }\n\n    .mb-xxl-nmd {\n        margin-bottom: -2rem !important\n    }\n\n    .mb-xxl-nlg {\n        margin-bottom: -4rem !important\n    }\n\n    .mb-xxl-nxl {\n        margin-bottom: -8rem !important\n    }\n\n    .ms-xxl-n1 {\n        margin-left: -.25rem !important\n    }\n\n    .ms-xxl-n2 {\n        margin-left: -.5rem !important\n    }\n\n    .ms-xxl-n3 {\n        margin-left: -1rem !important\n    }\n\n    .ms-xxl-n4 {\n        margin-left: -1.5rem !important\n    }\n\n    .ms-xxl-n5 {\n        margin-left: -3rem !important\n    }\n\n    .ms-xxl-n6 {\n        margin-left: -5rem !important\n    }\n\n    .ms-xxl-n7 {\n        margin-left: -8rem !important\n    }\n\n    .ms-xxl-n8 {\n        margin-left: -10rem !important\n    }\n\n    .ms-xxl-n9 {\n        margin-left: -11rem !important\n    }\n\n    .ms-xxl-n10 {\n        margin-left: -14rem !important\n    }\n\n    .ms-xxl-n11 {\n        margin-left: -16rem !important\n    }\n\n    .ms-xxl-n12 {\n        margin-left: -20rem !important\n    }\n\n    .ms-xxl-nsm {\n        margin-left: -1rem !important\n    }\n\n    .ms-xxl-nmd {\n        margin-left: -2rem !important\n    }\n\n    .ms-xxl-nlg {\n        margin-left: -4rem !important\n    }\n\n    .ms-xxl-nxl {\n        margin-left: -8rem !important\n    }\n\n    .p-xxl-0 {\n        padding: 0 !important\n    }\n\n    .p-xxl-1 {\n        padding: .25rem !important\n    }\n\n    .p-xxl-2 {\n        padding: .5rem !important\n    }\n\n    .p-xxl-3 {\n        padding: 1rem !important\n    }\n\n    .p-xxl-4 {\n        padding: 1.5rem !important\n    }\n\n    .p-xxl-5 {\n        padding: 3rem !important\n    }\n\n    .p-xxl-6 {\n        padding: 5rem !important\n    }\n\n    .p-xxl-7 {\n        padding: 8rem !important\n    }\n\n    .p-xxl-8 {\n        padding: 10rem !important\n    }\n\n    .p-xxl-9 {\n        padding: 11rem !important\n    }\n\n    .p-xxl-10 {\n        padding: 14rem !important\n    }\n\n    .p-xxl-11 {\n        padding: 16rem !important\n    }\n\n    .p-xxl-12 {\n        padding: 20rem !important\n    }\n\n    .p-xxl-sm {\n        padding: 1rem !important\n    }\n\n    .p-xxl-md {\n        padding: 2rem !important\n    }\n\n    .p-xxl-lg {\n        padding: 4rem !important\n    }\n\n    .p-xxl-xl {\n        padding: 8rem !important\n    }\n\n    .px-xxl-0 {\n        padding-right: 0 !important;\n        padding-left: 0 !important\n    }\n\n    .px-xxl-1 {\n        padding-right: .25rem !important;\n        padding-left: .25rem !important\n    }\n\n    .px-xxl-2 {\n        padding-right: .5rem !important;\n        padding-left: .5rem !important\n    }\n\n    .px-xxl-3 {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xxl-4 {\n        padding-right: 1.5rem !important;\n        padding-left: 1.5rem !important\n    }\n\n    .px-xxl-5 {\n        padding-right: 3rem !important;\n        padding-left: 3rem !important\n    }\n\n    .px-xxl-6 {\n        padding-right: 5rem !important;\n        padding-left: 5rem !important\n    }\n\n    .px-xxl-7 {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .px-xxl-8 {\n        padding-right: 10rem !important;\n        padding-left: 10rem !important\n    }\n\n    .px-xxl-9 {\n        padding-right: 11rem !important;\n        padding-left: 11rem !important\n    }\n\n    .px-xxl-10 {\n        padding-right: 14rem !important;\n        padding-left: 14rem !important\n    }\n\n    .px-xxl-11 {\n        padding-right: 16rem !important;\n        padding-left: 16rem !important\n    }\n\n    .px-xxl-12 {\n        padding-right: 20rem !important;\n        padding-left: 20rem !important\n    }\n\n    .px-xxl-sm {\n        padding-right: 1rem !important;\n        padding-left: 1rem !important\n    }\n\n    .px-xxl-md {\n        padding-right: 2rem !important;\n        padding-left: 2rem !important\n    }\n\n    .px-xxl-lg {\n        padding-right: 4rem !important;\n        padding-left: 4rem !important\n    }\n\n    .px-xxl-xl {\n        padding-right: 8rem !important;\n        padding-left: 8rem !important\n    }\n\n    .py-xxl-0 {\n        padding-top: 0 !important;\n        padding-bottom: 0 !important\n    }\n\n    .py-xxl-1 {\n        padding-top: .25rem !important;\n        padding-bottom: .25rem !important\n    }\n\n    .py-xxl-2 {\n        padding-top: .5rem !important;\n        padding-bottom: .5rem !important\n    }\n\n    .py-xxl-3 {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xxl-4 {\n        padding-top: 1.5rem !important;\n        padding-bottom: 1.5rem !important\n    }\n\n    .py-xxl-5 {\n        padding-top: 3rem !important;\n        padding-bottom: 3rem !important\n    }\n\n    .py-xxl-6 {\n        padding-top: 5rem !important;\n        padding-bottom: 5rem !important\n    }\n\n    .py-xxl-7 {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .py-xxl-8 {\n        padding-top: 10rem !important;\n        padding-bottom: 10rem !important\n    }\n\n    .py-xxl-9 {\n        padding-top: 11rem !important;\n        padding-bottom: 11rem !important\n    }\n\n    .py-xxl-10 {\n        padding-top: 14rem !important;\n        padding-bottom: 14rem !important\n    }\n\n    .py-xxl-11 {\n        padding-top: 16rem !important;\n        padding-bottom: 16rem !important\n    }\n\n    .py-xxl-12 {\n        padding-top: 20rem !important;\n        padding-bottom: 20rem !important\n    }\n\n    .py-xxl-sm {\n        padding-top: 1rem !important;\n        padding-bottom: 1rem !important\n    }\n\n    .py-xxl-md {\n        padding-top: 2rem !important;\n        padding-bottom: 2rem !important\n    }\n\n    .py-xxl-lg {\n        padding-top: 4rem !important;\n        padding-bottom: 4rem !important\n    }\n\n    .py-xxl-xl {\n        padding-top: 8rem !important;\n        padding-bottom: 8rem !important\n    }\n\n    .pt-xxl-0 {\n        padding-top: 0 !important\n    }\n\n    .pt-xxl-1 {\n        padding-top: .25rem !important\n    }\n\n    .pt-xxl-2 {\n        padding-top: .5rem !important\n    }\n\n    .pt-xxl-3 {\n        padding-top: 1rem !important\n    }\n\n    .pt-xxl-4 {\n        padding-top: 1.5rem !important\n    }\n\n    .pt-xxl-5 {\n        padding-top: 3rem !important\n    }\n\n    .pt-xxl-6 {\n        padding-top: 5rem !important\n    }\n\n    .pt-xxl-7 {\n        padding-top: 8rem !important\n    }\n\n    .pt-xxl-8 {\n        padding-top: 10rem !important\n    }\n\n    .pt-xxl-9 {\n        padding-top: 11rem !important\n    }\n\n    .pt-xxl-10 {\n        padding-top: 14rem !important\n    }\n\n    .pt-xxl-11 {\n        padding-top: 16rem !important\n    }\n\n    .pt-xxl-12 {\n        padding-top: 20rem !important\n    }\n\n    .pt-xxl-sm {\n        padding-top: 1rem !important\n    }\n\n    .pt-xxl-md {\n        padding-top: 2rem !important\n    }\n\n    .pt-xxl-lg {\n        padding-top: 4rem !important\n    }\n\n    .pt-xxl-xl {\n        padding-top: 8rem !important\n    }\n\n    .pe-xxl-0 {\n        padding-right: 0 !important\n    }\n\n    .pe-xxl-1 {\n        padding-right: .25rem !important\n    }\n\n    .pe-xxl-2 {\n        padding-right: .5rem !important\n    }\n\n    .pe-xxl-3 {\n        padding-right: 1rem !important\n    }\n\n    .pe-xxl-4 {\n        padding-right: 1.5rem !important\n    }\n\n    .pe-xxl-5 {\n        padding-right: 3rem !important\n    }\n\n    .pe-xxl-6 {\n        padding-right: 5rem !important\n    }\n\n    .pe-xxl-7 {\n        padding-right: 8rem !important\n    }\n\n    .pe-xxl-8 {\n        padding-right: 10rem !important\n    }\n\n    .pe-xxl-9 {\n        padding-right: 11rem !important\n    }\n\n    .pe-xxl-10 {\n        padding-right: 14rem !important\n    }\n\n    .pe-xxl-11 {\n        padding-right: 16rem !important\n    }\n\n    .pe-xxl-12 {\n        padding-right: 20rem !important\n    }\n\n    .pe-xxl-sm {\n        padding-right: 1rem !important\n    }\n\n    .pe-xxl-md {\n        padding-right: 2rem !important\n    }\n\n    .pe-xxl-lg {\n        padding-right: 4rem !important\n    }\n\n    .pe-xxl-xl {\n        padding-right: 8rem !important\n    }\n\n    .pb-xxl-0 {\n        padding-bottom: 0 !important\n    }\n\n    .pb-xxl-1 {\n        padding-bottom: .25rem !important\n    }\n\n    .pb-xxl-2 {\n        padding-bottom: .5rem !important\n    }\n\n    .pb-xxl-3 {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xxl-4 {\n        padding-bottom: 1.5rem !important\n    }\n\n    .pb-xxl-5 {\n        padding-bottom: 3rem !important\n    }\n\n    .pb-xxl-6 {\n        padding-bottom: 5rem !important\n    }\n\n    .pb-xxl-7 {\n        padding-bottom: 8rem !important\n    }\n\n    .pb-xxl-8 {\n        padding-bottom: 10rem !important\n    }\n\n    .pb-xxl-9 {\n        padding-bottom: 11rem !important\n    }\n\n    .pb-xxl-10 {\n        padding-bottom: 14rem !important\n    }\n\n    .pb-xxl-11 {\n        padding-bottom: 16rem !important\n    }\n\n    .pb-xxl-12 {\n        padding-bottom: 20rem !important\n    }\n\n    .pb-xxl-sm {\n        padding-bottom: 1rem !important\n    }\n\n    .pb-xxl-md {\n        padding-bottom: 2rem !important\n    }\n\n    .pb-xxl-lg {\n        padding-bottom: 4rem !important\n    }\n\n    .pb-xxl-xl {\n        padding-bottom: 8rem !important\n    }\n\n    .ps-xxl-0 {\n        padding-left: 0 !important\n    }\n\n    .ps-xxl-1 {\n        padding-left: .25rem !important\n    }\n\n    .ps-xxl-2 {\n        padding-left: .5rem !important\n    }\n\n    .ps-xxl-3 {\n        padding-left: 1rem !important\n    }\n\n    .ps-xxl-4 {\n        padding-left: 1.5rem !important\n    }\n\n    .ps-xxl-5 {\n        padding-left: 3rem !important\n    }\n\n    .ps-xxl-6 {\n        padding-left: 5rem !important\n    }\n\n    .ps-xxl-7 {\n        padding-left: 8rem !important\n    }\n\n    .ps-xxl-8 {\n        padding-left: 10rem !important\n    }\n\n    .ps-xxl-9 {\n        padding-left: 11rem !important\n    }\n\n    .ps-xxl-10 {\n        padding-left: 14rem !important\n    }\n\n    .ps-xxl-11 {\n        padding-left: 16rem !important\n    }\n\n    .ps-xxl-12 {\n        padding-left: 20rem !important\n    }\n\n    .ps-xxl-sm {\n        padding-left: 1rem !important\n    }\n\n    .ps-xxl-md {\n        padding-left: 2rem !important\n    }\n\n    .ps-xxl-lg {\n        padding-left: 4rem !important\n    }\n\n    .ps-xxl-xl {\n        padding-left: 8rem !important\n    }\n\n    .text-xxl-start {\n        text-align: left !important\n    }\n\n    .text-xxl-end {\n        text-align: right !important\n    }\n\n    .text-xxl-center {\n        text-align: center !important\n    }\n}\n\n@media (min-width: 1200px) {\n    .fs-1 {\n        font-size: 2.5rem !important\n    }\n\n    .fs-2 {\n        font-size: 2rem !important\n    }\n\n    .fs-3 {\n        font-size: 1.75rem !important\n    }\n\n    .fs-4 {\n        font-size: 1.5rem !important\n    }\n}\n\n@media print {\n    .d-print-inline {\n        display: inline !important\n    }\n\n    .d-print-inline-block {\n        display: inline-block !important\n    }\n\n    .d-print-block {\n        display: block !important\n    }\n\n    .d-print-grid {\n        display: grid !important\n    }\n\n    .d-print-table {\n        display: table !important\n    }\n\n    .d-print-table-row {\n        display: table-row !important\n    }\n\n    .d-print-table-cell {\n        display: table-cell !important\n    }\n\n    .d-print-flex {\n        display: flex !important\n    }\n\n    .d-print-inline-flex {\n        display: inline-flex !important\n    }\n\n    .d-print-none {\n        display: none !important\n    }\n}\n\n.navbar-main {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 100\n}\n\n.navbar-main .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 0.9)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\")\n}\n\n.navbar .navbar-nav .nav-link {\n    transition: all .8s all .2s ease\n}\n\n@media (max-width: 767.98px) {\n    .navbar .navbar-nav .nav-link {\n        font-size: 1.2rem;\n        display: flex;\n        -moz-justify-content: space-between;\n        -ms-justify-content: space-between;\n        justify-content: space-between;\n        -ms-flex-pack: space-between;\n        -moz-align-items: center;\n        -ms-align-items: center;\n        align-items: center\n    }\n}\n\n.navbar .navbar-nav .nav-item .media:not(:last-child) {\n    margin-bottom: 1.5rem\n}\n\n.navbar .navbar-nav .nav-item .nav-link:focus,\n.navbar .navbar-nav .nav-item:focus {\n    outline: 0 !important\n}\n\n.navbar .navbar-nav .dropdown .dropdown-menu {\n    top: 100%\n}\n\n.navbar .navbar-nav .dropdown .dropdown-menu span {\n    width: 30px\n}\n\n.navbar .navbar-nav .dropdown .dropdown-item {\n    font-size: .875rem\n}\n\n@media (min-width: 992px) {\n\n    .navbar .navbar-nav .dropdown-megamenu,\n    .navbar .navbar-nav .dropdown-megamenu-md,\n    .navbar .navbar-nav .dropdown-megamenu-sm {\n        min-width: 580px\n    }\n}\n\n.navbar .navbar-nav .dropdown-megamenu .megamenu-link,\n.navbar .navbar-nav .dropdown-megamenu-md .megamenu-link,\n.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-link {\n    color: #111827;\n    font-weight: 400;\n    font-size: .875rem\n}\n\n.navbar .navbar-nav .dropdown-megamenu .megamenu-item,\n.navbar .navbar-nav .dropdown-megamenu-md .megamenu-item,\n.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-item {\n    position: relative\n}\n\n.navbar .navbar-nav .dropdown-megamenu .megamenu-item:hover .megamenu-link,\n.navbar .navbar-nav .dropdown-megamenu-md .megamenu-item:hover .megamenu-link,\n.navbar .navbar-nav .dropdown-megamenu-sm .megamenu-item:hover .megamenu-link {\n    color: #1f2937\n}\n\n@media (min-width: 992px) {\n    .navbar .navbar-nav .dropdown-megamenu-sm {\n        min-width: 320px\n    }\n}\n\n@media (min-width: 992px) {\n    .navbar .navbar-nav .dropdown-megamenu-md {\n        min-width: 960px\n    }\n}\n\n@media (min-width: 992px) {\n    .navbar .navbar-nav .dropdown-menu .dropdown-toggle .nav-link-arrow {\n        transform: rotate(-90deg)\n    }\n\n    .navbar .navbar-nav .dropdown.show > .dropdown-toggle .nav-link-arrow {\n        transform: rotate(180deg)\n    }\n\n    .navbar .navbar-nav .dropdown-toggle:hover .nav-link-arrow {\n        transform: rotate(0)\n    }\n}\n\n.navbar .navbar-nav .dropdown-submenu {\n    position: relative\n}\n\n.navbar .navbar-nav .dropdown-submenu .dropdown-menu {\n    top: 0;\n    left: calc(100% - 2px);\n    margin-left: .1rem;\n    margin-right: .1rem;\n    opacity: 0;\n    display: none\n}\n\n.navbar .navbar-nav .dropdown-submenu .dropdown-menu.show {\n    opacity: 1;\n    pointer-events: all;\n    display: block\n}\n\n.navbar .navbar-nav .nav-link-arrow {\n    transition: transform .2s ease\n}\n\n.navbar-brand {\n    font-size: .875rem;\n    font-weight: 500;\n    text-transform: uppercase\n}\n\n.navbar-brand img {\n    height: 40px\n}\n\n.navbar-dark .navbar-brand-light {\n    display: none\n}\n\n.navbar-dark .navbar-brand {\n    color: #fff\n}\n\n.navbar-dark > .nav-item:hover > .nav-link {\n    color: #1f2937\n}\n\n.navbar-light:not(.headroom--not-top) .btn-outline-soft {\n    border-color: #1f2937;\n    color: #1f2937\n}\n\n.navbar-light:not(.headroom--not-top) .btn-outline-soft:hover {\n    background: #1f2937;\n    color: #fff\n}\n\n.navbar-light .navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='rgba(17, 24, 39, 0.9)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\")\n}\n\n.navbar-light .navbar-brand-dark {\n    display: none\n}\n\n.navbar-light .navbar-brand {\n    color: #1f2937\n}\n\n.dropdown-menu {\n    top: 100%\n}\n\n.dropdown-menu span {\n    width: 30px\n}\n\n.navbar-transparent {\n    background-color: transparent;\n    border: 0;\n    box-shadow: none\n}\n\n@media (min-width: 992px) {\n    .navbar-nav .nav-item [data-toggle=dropdown]::after {\n        transition: all .2s ease\n    }\n\n    .navbar-nav .nav-item.show [data-toggle=dropdown]::after {\n        transform: rotate(180deg)\n    }\n\n    .navbar-nav .nav-link i {\n        margin-right: .3rem;\n        font-size: .75rem\n    }\n\n    .navbar-nav .nav-link-icon {\n        padding-left: .5rem;\n        padding-right: .5rem;\n        font-size: 1rem\n    }\n\n    .navbar-nav .nav-link-icon i {\n        margin-right: 0\n    }\n\n    .navbar-nav .dropdown-menu {\n        opacity: 0;\n        pointer-events: none;\n        margin: 0;\n        border-radius: .35rem\n    }\n\n    .navbar-nav .dropdown-menu-end:before {\n        right: 20px;\n        left: auto\n    }\n\n    .navbar-nav .dropdown-menu-center {\n        left: 50%;\n        transform: translateX(-50%)\n    }\n\n    .navbar-nav .dropdown-megamenu-md.show,\n    .navbar-nav .dropdown-megamenu.show,\n    .navbar-nav .dropdown-menu.show {\n        opacity: 1;\n        pointer-events: auto\n    }\n\n    .navbar-nav .dropdown-megamenu-md.close,\n    .navbar-nav .dropdown-megamenu.close,\n    .navbar-nav .dropdown-menu.close {\n        display: block\n    }\n\n    .navbar-nav .dropdown-submenu .dropdown-menu {\n        transform: none\n    }\n\n    .navbar-nav .dropdown-menu {\n        position: relative;\n        display: block;\n        opacity: 0;\n        pointer-events: none;\n        transition: all .2s ease\n    }\n\n    .navbar-nav .dropdown-submenu.show > .dropdown-menu,\n    .navbar-nav .dropdown.show > .dropdown-menu {\n        display: block;\n        opacity: 1;\n        pointer-events: auto\n    }\n\n    .navbar-nav .dropdown-menu-inner {\n        position: relative;\n        padding: 1rem\n    }\n\n    .navbar-transparent .navbar-nav .nav-link.disabled {\n        color: rgba(255, 255, 255, .9)\n    }\n\n    .navbar-transparent .navbar-brand {\n        color: rgba(255, 255, 255, .9)\n    }\n}\n\n.navbar-collapse-header {\n    display: none\n}\n\n.navbar-collapse {\n    width: auto\n}\n\n@media (max-width: 991.98px) {\n    .navbar-nav .nav-link {\n        padding: .625rem 0\n    }\n\n    .navbar-nav .dropdown-menu {\n        box-shadow: none;\n        width: 100%\n    }\n\n    .navbar-nav .dropdown-menu .media svg {\n        width: 30px\n    }\n\n    .dropdown-menu-center {\n        right: 0;\n        left: auto;\n        transform: translate(0, 0)\n    }\n}\n\n@media (max-width: 991.98px) and (max-width: 991.98px) {\n    .dropdown-menu-center {\n        transform: translateX(-75%)\n    }\n}\n\n@media (max-width: 991.98px) {\n    .navbar-collapse {\n        width: calc(100% - 30px);\n        position: absolute;\n        top: 0;\n        right: 15px;\n        z-index: 1050;\n        overflow-y: auto;\n        height: calc(100vh - 30px) !important;\n        opacity: 0\n    }\n\n    .navbar-collapse .navbar-toggler {\n        position: relative;\n        display: inline-block;\n        width: 20px;\n        height: 20px;\n        padding: 0\n    }\n\n    .navbar-collapse .navbar-toggler span {\n        display: block;\n        position: absolute;\n        width: 100%;\n        height: 2px;\n        border-radius: 2px;\n        opacity: 1;\n        background: #283448\n    }\n\n    .navbar-collapse .navbar-collapse-header {\n        display: block;\n        padding-bottom: 1rem;\n        margin-bottom: 1rem\n    }\n\n    .navbar-collapse .collapse-brand img {\n        height: 35px\n    }\n\n    .navbar-collapse .collapse-close {\n        text-align: right\n    }\n\n    .navbar-collapse.collapsing,\n    .navbar-collapse.show {\n        padding: 1.5rem;\n        border-radius: .35rem;\n        background: #fff;\n        animation: show-navbar-collapse .2s ease forwards;\n        box-shadow: 0 0 20px rgba(0, 0, 0, .1)\n    }\n\n    .navbar-collapse.collapsing-out {\n        animation: hide-navbar-collapse .2s ease forwards\n    }\n}\n\n.navbar-dashboard {\n    border-radius: .5rem\n}\n\n.navbar-theme-primary:not(.headroom) {\n    background-color: #1f2937\n}\n\n.section {\n    position: relative;\n    padding-top: 3rem;\n    padding-bottom: 3rem\n}\n\n.section-header {\n    position: relative;\n    padding-top: 9rem;\n    padding-bottom: 3rem\n}\n\n@media (min-width: 576px) {\n    .section {\n        position: relative;\n        padding-top: 5rem;\n        padding-bottom: 5rem\n    }\n\n    .section-header {\n        position: relative;\n        padding-top: 8rem;\n        padding-bottom: 8rem\n    }\n\n    .section-header.section-sm {\n        padding-top: 4rem;\n        padding-bottom: 3rem\n    }\n\n    .section-xl {\n        padding-top: 8rem;\n        padding-bottom: 8rem\n    }\n\n    .section-lg {\n        padding-top: 6rem;\n        padding-bottom: 6rem\n    }\n\n    .section-sm {\n        padding-top: 3rem;\n        padding-bottom: 3rem\n    }\n}\n\n@media (min-width: 992px) {\n    .section {\n        position: relative;\n        padding-top: 6rem;\n        padding-bottom: 6rem\n    }\n\n    .section-header {\n        position: relative;\n        padding-top: 10rem;\n        padding-bottom: 10rem\n    }\n\n    .section-header.section-sm {\n        padding-top: 4rem;\n        padding-bottom: 3rem\n    }\n\n    .section-xl {\n        padding-top: 10rem;\n        padding-bottom: 10rem\n    }\n\n    .section-lg {\n        padding-top: 8rem;\n        padding-bottom: 8rem\n    }\n\n    .section-sm {\n        padding-top: 4rem;\n        padding-bottom: 4rem\n    }\n}\n\n@media (min-width: 768px) {\n    .section-hero {\n        height: 100vh\n    }\n}\n\n.line-bottom::after {\n    content: '';\n    display: block;\n    width: 80%;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    margin-left: -40%;\n    height: 1px;\n    background: radial-gradient(ellipse at center, #9ca3af 0, rgba(255, 255, 255, 0) 80%)\n}\n\n.section-profile-cover {\n    height: 580px;\n    background-size: cover;\n    background-position: center center\n}\n\n@media (max-width: 767.98px) {\n    .section-profile-cover {\n        height: 400px\n    }\n}\n\n.components-section > .form-control + .form-control {\n    margin-top: .5rem\n}\n\n.components-section .badge,\n.components-section .btn,\n.components-section > .alert + .alert,\n.components-section > .nav + .nav,\n.components-section > .navbar + .navbar,\n.components-section > .progress + .btn,\n.components-section > .progress + .progress {\n    margin-top: .5rem;\n    margin-bottom: .5rem\n}\n\n.components-section .btn-group {\n    margin-top: .5rem;\n    margin-bottom: .5rem\n}\n\n.components-section .btn-group .btn {\n    margin: 0\n}\n\n.components-section .alert {\n    margin: 0\n}\n\n.components-section .alert + .alert {\n    margin-top: 1.25rem\n}\n\n.components-section .badge {\n    margin-right: .5rem\n}\n\n.components-section .modal-footer .btn {\n    margin: 0\n}\n\n.copy-docs {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    transition: all .2s ease\n}\n\n.copy-docs.copied {\n    background: #10b981\n}\n\n.copy-docs:hover {\n    cursor: pointer\n}\n\n.kanban-container {\n    overflow-x: scroll;\n    -webkit-overflow-scrolling: touch\n}\n\n.footer ul {\n    margin-bottom: 0;\n    padding: 0;\n    list-style: none\n}\n\n.footer ul li {\n    display: inline-block\n}\n\n.footer ul li a {\n    text-decoration: none;\n    position: relative;\n    display: block;\n    color: #374151\n}\n\n.footer ul li a:hover {\n    color: #1f2937\n}\n\n.footer ul li .btn {\n    margin: 0\n}\n\n.footer ul.links-horizontal:first-child a {\n    padding-left: 0\n}\n\n.footer ul.links-horizontal:last-child a {\n    padding-right: 0\n}\n\n.footer ul.links-vertical li {\n    display: block;\n    margin-left: -5px;\n    margin-right: -5px\n}\n\n.footer ul.links-vertical li a {\n    padding: 5px\n}\n\n.footer ul.links-vertical li a:hover {\n    color: inherit !important\n}\n\n.footer ul.icon-box i {\n    line-height: 1.7\n}\n\n.footer .social-buttons .btn,\n.footer .social-buttons a {\n    margin-top: 5px;\n    margin-bottom: 5px;\n    padding: .125rem .375rem\n}\n\n.footer .footer-brand {\n    font-size: 1.25rem;\n    font-weight: 500\n}\n\n.footer .footer-brand img.common {\n    height: 40px\n}\n\n.footer .footer-brand img {\n    height: 40px;\n    width: 40px\n}\n\n.footer .footer-brand:focus,\n.footer .footer-brand:hover {\n    color: #111827\n}\n\n.footer .footer-language-link {\n    font-size: .875rem\n}\n\n.footer .footer-language-link i {\n    font-size: .75rem\n}\n\n.footer .copyright {\n    font-size: .875rem\n}\n\n.footer .pull-center {\n    display: inline-block;\n    float: none\n}\n\n#doc-index:not(.collapse.show),\n.doc-sidebar {\n    display: none\n}\n\n@media (min-width: 992px) {\n    #doc-index {\n        display: block\n    }\n\n    .doc-sidebar {\n        display: block;\n        height: calc(100vh - 2rem);\n        overflow-y: scroll;\n        position: sticky;\n        top: 2rem\n    }\n\n    .doc-sidebar .nav-link[data-toggle=collapse] > .icon {\n        transform: rotateZ(-90deg);\n        position: relative;\n        right: .25rem\n    }\n\n    .doc-sidebar .nav .nav-item {\n        font-size: .875rem\n    }\n}\n\n.sidebar {\n    display: block;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 100;\n    max-height: 100%;\n    overflow-y: auto;\n    width: 100%;\n    transition: max-width .1s\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .sidebar {\n        transition: none\n    }\n}\n\n@media (min-width: 768px) {\n    .sidebar {\n        width: 100%;\n        max-width: 260px\n    }\n}\n\n.sidebar .nav {\n    white-space: nowrap\n}\n\n.sidebar .nav-item {\n    margin-bottom: .2rem\n}\n\n.sidebar .nav-item.active > .nav-link {\n    color: #f2f4f6;\n    background-color: #374151\n}\n\n.sidebar .nav-item .nav-link {\n    color: #fff;\n    cursor: pointer\n}\n\n.sidebar .nav-item .nav-link:hover {\n    color: #f2f4f6;\n    background-color: #374151\n}\n\n.sidebar .nav-link + .multi-level {\n    margin-top: .2rem\n}\n\n.sidebar .nav-link {\n    font-size: 1rem;\n    vertical-align: middle;\n    padding: .55rem .75rem;\n    border-radius: .5rem\n}\n\n.sidebar .nav-link .sidebar-icon {\n    margin-right: .5rem;\n    color: #9ca3af\n}\n\n.sidebar .nav-link .link-arrow {\n    font-size: .875rem\n}\n\n.sidebar .nav-link[data-bs-toggle=collapse][aria-expanded=true] .link-arrow {\n    transform: rotate(90deg);\n    transition: all .2s ease\n}\n\n.sidebar .nav-link.active {\n    color: #f2f4f6\n}\n\n.sidebar .multi-level .nav-link {\n    padding-left: 53px\n}\n\n.sidebar .badge,\n.sidebar .link-arrow,\n.sidebar .notification-count,\n.sidebar .sidebar-text {\n    opacity: 1\n}\n\n.sidebar .sidebar-text-contracted {\n    display: none\n}\n\n.sidebar.contracted {\n    max-width: 95px\n}\n\n.sidebar.contracted .badge,\n.sidebar.contracted .link-arrow,\n.sidebar.contracted .sidebar-text {\n    opacity: 0\n}\n\n.sidebar.contracted .notification-count {\n    opacity: 1;\n    position: absolute;\n    top: 0;\n    left: 40px;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    font-size: .7rem;\n    padding: .2rem\n}\n\n.sidebar.contracted .nav-item {\n    position: relative\n}\n\n.sidebar.contracted .nav-item.active > .nav-link {\n    background-color: #363c54;\n    width: 44px\n}\n\n.sidebar.contracted .nav-item .nav-link:hover {\n    background-color: #1f2937\n}\n\n.sidebar.contracted .sidebar-text-contracted {\n    display: inline\n}\n\n.sidebar.contracted .multi-level .nav-link {\n    padding-left: 17px\n}\n\n.sidebar.contracted .nav-item {\n    white-space: nowrap\n}\n\n.sidebar.contracted .sidebar-icon {\n    text-align: center\n}\n\n@media (min-width: 768px) {\n    .sidebar.contracted + .content {\n        margin-left: 95px\n    }\n}\n\n.sidebar-inner {\n    position: relative;\n    overflow-y: hidden\n}\n\n.sidebar-heading {\n    font-size: .75rem;\n    text-transform: uppercase\n}\n\n.user-card {\n    border-bottom: .0625rem solid #2e3650\n}\n\n@media (max-width: 575.98px) {\n    .sidebar {\n        width: 100%\n    }\n}\n\n.content {\n    overflow: hidden;\n    padding: 0 1rem 0 1rem;\n    transition: all .3s\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .content {\n        transition: none\n    }\n}\n\n@media (min-width: 992px) {\n    .content {\n        margin-left: 0px\n    }\n}\n\n.sidebar-toggle {\n    font-size: 1.3rem\n}\n\n.sidebar-toggle:focus,\n.sidebar-toggle:hover {\n    outline: 0;\n    box-shadow: none;\n    background: #d1d5db\n}\n\niframe {\n    border: 0\n}\n\nfigcaption,\nfigure,\nmain {\n    display: block;\n    margin: 0\n}\n\nmain {\n    overflow: hidden\n}\n\nimg {\n    max-width: 100%\n}\n\nstrong {\n    font-weight: 500\n}\n\nbutton:focus {\n    outline: 0\n}\n\nlabel {\n    font-weight: 500;\n    margin-bottom: .5rem\n}\n\n.disabled {\n    cursor: not-allowed\n}\n\n.accordion-flush .accordion-button {\n    background-color: transparent\n}\n\n.accordion-flush .accordion-button:not(.collapsed) {\n    color: #31316a\n}\n\n.accordion-flush .accordion-button:focus {\n    border-color: #d1d5db;\n    box-shadow: none\n}\n\n.accordion-flush .accordion-collapse {\n    border: 0\n}\n\n.alert-heading {\n    font-weight: 500\n}\n\n.alert-icon {\n    margin-bottom: .5rem\n}\n\n.alert-icon span {\n    font-size: 2rem\n}\n\n.avatar + .avatar-content {\n    display: inline-block;\n    margin-left: .75rem\n}\n\n.avatar-sm {\n    width: 1.5rem;\n    height: 1.5rem\n}\n\n.avatar-sm img {\n    width: 1.5rem;\n    height: 1.5rem\n}\n\n.avatar {\n    width: 2rem;\n    height: 2rem\n}\n\n.avatar img {\n    width: 2rem;\n    height: 2rem\n}\n\n.avatar-md {\n    width: 3rem;\n    height: 3rem\n}\n\n.avatar-md img {\n    width: 3rem;\n    height: 3rem\n}\n\n.avatar-lg {\n    width: 4.5rem;\n    height: 4.5rem\n}\n\n.avatar-lg img {\n    width: 4.5rem;\n    height: 4.5rem\n}\n\n.avatar-xl {\n    width: 8rem;\n    height: 8rem\n}\n\n@media (max-width: 991.98px) {\n    .avatar-xl {\n        width: 4.5rem;\n        height: 4.5rem\n    }\n}\n\n.avatar-offline::before,\n.avatar-online::before {\n    position: absolute;\n    border: 2px solid #fff;\n    background-color: #10b981;\n    display: block;\n    top: 2px;\n    left: 39px;\n    content: \"\";\n    border-radius: 50%;\n    height: 10px;\n    width: 10px\n}\n\n.avatar-offline::before {\n    background-color: #e11d48\n}\n\n.avatar-group .avatar {\n    position: relative;\n    z-index: 0\n}\n\n.avatar-group .avatar img {\n    border: 2px solid #fff\n}\n\n.avatar-group .avatar:hover {\n    z-index: 3\n}\n\n.avatar-group .avatar + .avatar {\n    margin-left: -1rem\n}\n\n.animate-down-1,\n.animate-left-1,\n.animate-right-1,\n.animate-up-1,\n.scale-down-1,\n.scale-up-1 {\n    transition: all .2s ease\n}\n\n.scale-up-1:hover {\n    transform: scale(.55556)\n}\n\n.scale-up-hover-1:hover .scale {\n    transform: scale(.55556)\n}\n\n.scale-down-1:hover {\n    transform: scale(.4)\n}\n\n.animate-hover:hover .animate-up-1,\n.animate-up-1:hover {\n    transform: translate(0, -1px)\n}\n\n.animate-hover:hover .animate-right-1,\n.animate-right-1:hover {\n    transform: translate(1px, 0)\n}\n\n.animate-down-1:hover,\n.animate-hover:hover .animate-down-1 {\n    transform: translate(0, 1px)\n}\n\n.animate-hover:hover .animate-left-1,\n.animate-left-1:hover {\n    transform: translate(-1px, 0)\n}\n\n.animate-down-2,\n.animate-left-2,\n.animate-right-2,\n.animate-up-2,\n.scale-down-2,\n.scale-up-2 {\n    transition: all .2s ease\n}\n\n.scale-up-2:hover {\n    transform: scale(1.11111)\n}\n\n.scale-up-hover-2:hover .scale {\n    transform: scale(1.11111)\n}\n\n.scale-down-2:hover {\n    transform: scale(.8)\n}\n\n.animate-hover:hover .animate-up-2,\n.animate-up-2:hover {\n    transform: translate(0, -2px)\n}\n\n.animate-hover:hover .animate-right-2,\n.animate-right-2:hover {\n    transform: translate(2px, 0)\n}\n\n.animate-down-2:hover,\n.animate-hover:hover .animate-down-2 {\n    transform: translate(0, 2px)\n}\n\n.animate-hover:hover .animate-left-2,\n.animate-left-2:hover {\n    transform: translate(-2px, 0)\n}\n\n.animate-down-3,\n.animate-left-3,\n.animate-right-3,\n.animate-up-3,\n.scale-down-3,\n.scale-up-3 {\n    transition: all .2s ease\n}\n\n.scale-up-3:hover {\n    transform: scale(1.66667)\n}\n\n.scale-up-hover-3:hover .scale {\n    transform: scale(1.66667)\n}\n\n.scale-down-3:hover {\n    transform: scale(1.2)\n}\n\n.animate-hover:hover .animate-up-3,\n.animate-up-3:hover {\n    transform: translate(0, -3px)\n}\n\n.animate-hover:hover .animate-right-3,\n.animate-right-3:hover {\n    transform: translate(3px, 0)\n}\n\n.animate-down-3:hover,\n.animate-hover:hover .animate-down-3 {\n    transform: translate(0, 3px)\n}\n\n.animate-hover:hover .animate-left-3,\n.animate-left-3:hover {\n    transform: translate(-3px, 0)\n}\n\n.animate-down-4,\n.animate-left-4,\n.animate-right-4,\n.animate-up-4,\n.scale-down-4,\n.scale-up-4 {\n    transition: all .2s ease\n}\n\n.scale-up-4:hover {\n    transform: scale(2.22222)\n}\n\n.scale-up-hover-4:hover .scale {\n    transform: scale(2.22222)\n}\n\n.scale-down-4:hover {\n    transform: scale(1.6)\n}\n\n.animate-hover:hover .animate-up-4,\n.animate-up-4:hover {\n    transform: translate(0, -4px)\n}\n\n.animate-hover:hover .animate-right-4,\n.animate-right-4:hover {\n    transform: translate(4px, 0)\n}\n\n.animate-down-4:hover,\n.animate-hover:hover .animate-down-4 {\n    transform: translate(0, 4px)\n}\n\n.animate-hover:hover .animate-left-4,\n.animate-left-4:hover {\n    transform: translate(-4px, 0)\n}\n\n.animate-down-5,\n.animate-left-5,\n.animate-right-5,\n.animate-up-5,\n.scale-down-5,\n.scale-up-5 {\n    transition: all .2s ease\n}\n\n.scale-up-5:hover {\n    transform: scale(2.77778)\n}\n\n.scale-up-hover-5:hover .scale {\n    transform: scale(2.77778)\n}\n\n.scale-down-5:hover {\n    transform: scale(2)\n}\n\n.animate-hover:hover .animate-up-5,\n.animate-up-5:hover {\n    transform: translate(0, -5px)\n}\n\n.animate-hover:hover .animate-right-5,\n.animate-right-5:hover {\n    transform: translate(5px, 0)\n}\n\n.animate-down-5:hover,\n.animate-hover:hover .animate-down-5 {\n    transform: translate(0, 5px)\n}\n\n.animate-hover:hover .animate-left-5,\n.animate-left-5:hover {\n    transform: translate(-5px, 0)\n}\n\n.animate-down-6,\n.animate-left-6,\n.animate-right-6,\n.animate-up-6,\n.scale-down-6,\n.scale-up-6 {\n    transition: all .2s ease\n}\n\n.scale-up-6:hover {\n    transform: scale(3.33333)\n}\n\n.scale-up-hover-6:hover .scale {\n    transform: scale(3.33333)\n}\n\n.scale-down-6:hover {\n    transform: scale(2.4)\n}\n\n.animate-hover:hover .animate-up-6,\n.animate-up-6:hover {\n    transform: translate(0, -6px)\n}\n\n.animate-hover:hover .animate-right-6,\n.animate-right-6:hover {\n    transform: translate(6px, 0)\n}\n\n.animate-down-6:hover,\n.animate-hover:hover .animate-down-6 {\n    transform: translate(0, 6px)\n}\n\n.animate-hover:hover .animate-left-6,\n.animate-left-6:hover {\n    transform: translate(-6px, 0)\n}\n\n.animate-down-7,\n.animate-left-7,\n.animate-right-7,\n.animate-up-7,\n.scale-down-7,\n.scale-up-7 {\n    transition: all .2s ease\n}\n\n.scale-up-7:hover {\n    transform: scale(3.88889)\n}\n\n.scale-up-hover-7:hover .scale {\n    transform: scale(3.88889)\n}\n\n.scale-down-7:hover {\n    transform: scale(2.8)\n}\n\n.animate-hover:hover .animate-up-7,\n.animate-up-7:hover {\n    transform: translate(0, -7px)\n}\n\n.animate-hover:hover .animate-right-7,\n.animate-right-7:hover {\n    transform: translate(7px, 0)\n}\n\n.animate-down-7:hover,\n.animate-hover:hover .animate-down-7 {\n    transform: translate(0, 7px)\n}\n\n.animate-hover:hover .animate-left-7,\n.animate-left-7:hover {\n    transform: translate(-7px, 0)\n}\n\n.animate-down-8,\n.animate-left-8,\n.animate-right-8,\n.animate-up-8,\n.scale-down-8,\n.scale-up-8 {\n    transition: all .2s ease\n}\n\n.scale-up-8:hover {\n    transform: scale(4.44444)\n}\n\n.scale-up-hover-8:hover .scale {\n    transform: scale(4.44444)\n}\n\n.scale-down-8:hover {\n    transform: scale(3.2)\n}\n\n.animate-hover:hover .animate-up-8,\n.animate-up-8:hover {\n    transform: translate(0, -8px)\n}\n\n.animate-hover:hover .animate-right-8,\n.animate-right-8:hover {\n    transform: translate(8px, 0)\n}\n\n.animate-down-8:hover,\n.animate-hover:hover .animate-down-8 {\n    transform: translate(0, 8px)\n}\n\n.animate-hover:hover .animate-left-8,\n.animate-left-8:hover {\n    transform: translate(-8px, 0)\n}\n\n.animate-down-9,\n.animate-left-9,\n.animate-right-9,\n.animate-up-9,\n.scale-down-9,\n.scale-up-9 {\n    transition: all .2s ease\n}\n\n.scale-up-9:hover {\n    transform: scale(5)\n}\n\n.scale-up-hover-9:hover .scale {\n    transform: scale(5)\n}\n\n.scale-down-9:hover {\n    transform: scale(3.6)\n}\n\n.animate-hover:hover .animate-up-9,\n.animate-up-9:hover {\n    transform: translate(0, -9px)\n}\n\n.animate-hover:hover .animate-right-9,\n.animate-right-9:hover {\n    transform: translate(9px, 0)\n}\n\n.animate-down-9:hover,\n.animate-hover:hover .animate-down-9 {\n    transform: translate(0, 9px)\n}\n\n.animate-hover:hover .animate-left-9,\n.animate-left-9:hover {\n    transform: translate(-9px, 0)\n}\n\n@keyframes show-navbar-collapse {\n    0% {\n        opacity: 0;\n        transform: scale(.95);\n        transform-origin: 100% 0\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1)\n    }\n}\n\n@keyframes hide-navbar-collapse {\n    from {\n        opacity: 1;\n        transform: scale(1);\n        transform-origin: 100% 0\n    }\n\n    to {\n        opacity: 0;\n        transform: scale(.95)\n    }\n}\n\n@keyframes show-navbar-dropdown {\n    0% {\n        opacity: 0;\n        transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n        transition: visibility .45s, opacity .45s, transform .45s\n    }\n\n    100% {\n        transform: translate(0, 0);\n        opacity: 1\n    }\n}\n\n@keyframes hide-navbar-dropdown {\n    from {\n        opacity: 1\n    }\n\n    to {\n        opacity: 0;\n        transform: translate(0, 10px)\n    }\n}\n\n@keyframes show-dropdown {\n    0% {\n        opacity: 0;\n        transform-origin: perspective(200px) rotateX(-2deg);\n        transition: visibility .45s, opacity .5s\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n@keyframes hide-dropdown {\n    from {\n        opacity: 1\n    }\n\n    to {\n        opacity: 0;\n        transform: translate(0, 10px)\n    }\n}\n\n.bell-shake.shaking {\n    animation: bellshake .5s cubic-bezier(.36, .07, .19, .97) both;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    transform-origin: top right\n}\n\n:root {\n    --animate-duration: 1s;\n    --animate-delay: 1s;\n    --animate-repeat: 1\n}\n\n.animate__animated {\n    animation-duration: 1s;\n    animation-duration: var(--animate-duration);\n    animation-fill-mode: both\n}\n\n.animate__jackInTheBox {\n    animation-name: jackInTheBox\n}\n\n@keyframes bellshake {\n    0% {\n        transform: rotate(0)\n    }\n\n    15% {\n        transform: rotate(5deg)\n    }\n\n    30% {\n        transform: rotate(-5deg)\n    }\n\n    45% {\n        transform: rotate(4deg)\n    }\n\n    60% {\n        transform: rotate(-4deg)\n    }\n\n    75% {\n        transform: rotate(2deg)\n    }\n\n    85% {\n        transform: rotate(-2deg)\n    }\n\n    92% {\n        transform: rotate(1deg)\n    }\n\n    100% {\n        transform: rotate(0)\n    }\n}\n\n@keyframes jackInTheBox {\n    from {\n        opacity: 0;\n        transform: scale(.1) rotate(30deg);\n        transform-origin: center bottom\n    }\n\n    50% {\n        transform: rotate(-10deg)\n    }\n\n    70% {\n        transform: rotate(3deg)\n    }\n\n    to {\n        opacity: 1;\n        transform: scale(1)\n    }\n}\n\n.animate__jackInTheBox {\n    animation-name: jackInTheBox\n}\n\n[class*=shadow] {\n    transition: all .2s ease\n}\n\n.badge {\n    font-size: .75em;\n    font-weight: 600\n}\n\n.badge a {\n    color: #fff\n}\n\n.badge.super-badge {\n    vertical-align: super\n}\n\n.badge-pill {\n    padding-right: .875em;\n    padding-left: .875em\n}\n\n.badge-inline {\n    margin-right: .625rem\n}\n\n.badge-inline + span {\n    top: 2px;\n    position: relative\n}\n\n.badge-inline + span > a {\n    text-decoration: underline\n}\n\n.badge-sm {\n    padding: .2rem .6rem\n}\n\n.badge-lg {\n    font-size: 1.25rem;\n    padding: .35rem .85rem\n}\n\n.btn .badge-corner {\n    position: absolute;\n    top: -50%;\n    right: .5rem;\n    transform: translate(50%, 50%);\n    margin: 0;\n    border: 3px solid;\n    padding-left: .5rem;\n    padding-right: .5rem\n}\n\n.wi-tags a {\n    display: inline-block;\n    padding: .125rem .875rem;\n    margin: .25rem;\n    line-height: 2;\n    font-size: .875rem;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    background-color: #fff\n}\n\n.pixel-pro-badge {\n    position: relative;\n    font-size: .875rem;\n    text-transform: uppercase;\n    font-weight: 500;\n    right: -11px;\n    padding: 4px 12px;\n    top: -30px;\n    background: #fff;\n    border-radius: .35rem;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)\n}\n\n@media (max-width: 575.98px) {\n    .pixel-pro-badge {\n        font-size: 1rem;\n        right: -13px;\n        padding: 5px 10px;\n        top: -23px\n    }\n}\n\n.subscription-badge {\n    top: -19px;\n    right: -12px;\n    font-size: .75rem\n}\n\n.btn.btn-circle {\n    border-radius: 50%\n}\n\n.btn.btn-md {\n    padding: .65rem 1.25rem\n}\n\n.btn.btn-xs {\n    padding: .2rem .35rem;\n    font-size: .55rem;\n    box-shadow: none\n}\n\n.btn.large-form-btn {\n    padding: 1.2rem 1rem\n}\n\n.btn.dashed-outline {\n    border-style: dashed\n}\n\n.btn-icon-only {\n    width: 2.575rem;\n    height: 2.575rem;\n    padding: 0;\n    display: flex;\n    -moz-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    -ms-flex-pack: center;\n    -moz-align-items: center;\n    -ms-align-items: center;\n    align-items: center\n}\n\n.btn-icon-only.btn-xs {\n    width: 1.7rem;\n    height: 1.7rem\n}\n\n.btn-group-sm > .btn-icon-only.btn,\n.btn-icon-only.btn-sm {\n    width: 2rem;\n    height: 2rem\n}\n\n.btn-primary:hover {\n    background-color: #161d27;\n    border-color: #161d27\n}\n\n.btn-secondary:hover {\n    background-color: #eeb15d;\n    border-color: #eeb15d\n}\n\n.btn-tertiary:hover {\n    background-color: #292959;\n    border-color: #292959\n}\n\n.btn-success:hover {\n    background-color: #0ea271;\n    border-color: #0ea271\n}\n\n.btn-info:hover {\n    background-color: #1f57b8;\n    border-color: #1f57b8\n}\n\n.btn-warning:hover {\n    background-color: #f59e04;\n    border-color: #f59e04\n}\n\n.btn-danger:hover {\n    background-color: #ca1a41;\n    border-color: #ca1a41\n}\n\n.btn-white:hover {\n    background-color: #f2f2f2;\n    border-color: #f2f2f2\n}\n\n.btn-indigo:hover {\n    background-color: #3a30e2;\n    border-color: #3a30e2\n}\n\n.btn-purple:hover {\n    background-color: #6c23eb;\n    border-color: #6c23eb\n}\n\n.btn-yellow-100:hover {\n    background-color: #ffe3bd;\n    border-color: #ffe3bd\n}\n\n.btn-yellow-200:hover {\n    background-color: #f2d0a2;\n    border-color: #f2d0a2\n}\n\n.btn-gray-50:hover {\n    background-color: #eaedf1;\n    border-color: #eaedf1\n}\n\n.btn-gray-100:hover {\n    background-color: #e3e7ec;\n    border-color: #e3e7ec\n}\n\n.btn-gray-200:hover {\n    background-color: #d7dae0;\n    border-color: #d7dae0\n}\n\n.btn-gray-300:hover {\n    background-color: #c3c8d0;\n    border-color: #c3c8d0\n}\n\n.btn-gray-400:hover {\n    background-color: #8e96a4;\n    border-color: #8e96a4\n}\n\n.btn-gray-500:hover {\n    background-color: #5f6672;\n    border-color: #5f6672\n}\n\n.btn-gray-600:hover {\n    background-color: #404954;\n    border-color: #404954\n}\n\n.btn-gray-700:hover {\n    background-color: #2d3542;\n    border-color: #2d3542\n}\n\n.btn-gray-800:hover {\n    background-color: #161d27;\n    border-color: #161d27\n}\n\n.btn-gray-900:hover {\n    background-color: #090d15;\n    border-color: #090d15\n}\n\n.btn-facebook {\n    color: #fff;\n    background-color: #3b5999;\n    border-color: #3b5999;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-facebook:hover {\n    color: #fff;\n    background-color: #324c82;\n    border-color: #2f477a\n}\n\n.btn-check:focus + .btn-facebook,\n.btn-facebook:focus {\n    color: #fff;\n    background-color: #324c82;\n    border-color: #2f477a;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(88, 114, 168, .5)\n}\n\n.btn-check:active + .btn-facebook,\n.btn-check:checked + .btn-facebook,\n.btn-facebook.active,\n.btn-facebook:active,\n.show > .btn-facebook.dropdown-toggle {\n    color: #fff;\n    background-color: #2f477a;\n    border-color: #2c4373\n}\n\n.btn-check:active + .btn-facebook:focus,\n.btn-check:checked + .btn-facebook:focus,\n.btn-facebook.active:focus,\n.btn-facebook:active:focus,\n.show > .btn-facebook.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(88, 114, 168, .5)\n}\n\n.btn-facebook.disabled,\n.btn-facebook:disabled {\n    color: #fff;\n    background-color: #3b5999;\n    border-color: #3b5999\n}\n\n.btn-facebook.btn-link {\n    color: #3b5999;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-facebook.btn-link.active,\n.btn-facebook.btn-link:focus,\n.btn-facebook.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #3b5999\n}\n\n.btn-twitter {\n    color: #1f2937;\n    background-color: #1da1f2;\n    border-color: #1da1f2;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-twitter:hover {\n    color: #1f2937;\n    background-color: #3faff4;\n    border-color: #34aaf3\n}\n\n.btn-check:focus + .btn-twitter,\n.btn-twitter:focus {\n    color: #1f2937;\n    background-color: #3faff4;\n    border-color: #34aaf3;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(29, 143, 214, .5)\n}\n\n.btn-check:active + .btn-twitter,\n.btn-check:checked + .btn-twitter,\n.btn-twitter.active,\n.btn-twitter:active,\n.show > .btn-twitter.dropdown-toggle {\n    color: #1f2937;\n    background-color: #4ab4f5;\n    border-color: #34aaf3\n}\n\n.btn-check:active + .btn-twitter:focus,\n.btn-check:checked + .btn-twitter:focus,\n.btn-twitter.active:focus,\n.btn-twitter:active:focus,\n.show > .btn-twitter.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(29, 143, 214, .5)\n}\n\n.btn-twitter.disabled,\n.btn-twitter:disabled {\n    color: #1f2937;\n    background-color: #1da1f2;\n    border-color: #1da1f2\n}\n\n.btn-twitter.btn-link {\n    color: #1da1f2;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-twitter.btn-link.active,\n.btn-twitter.btn-link:focus,\n.btn-twitter.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #1da1f2\n}\n\n.btn-google {\n    color: #fff;\n    background-color: #db4337;\n    border-color: #db4337;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-google:hover {\n    color: #fff;\n    background-color: #ba392f;\n    border-color: #af362c\n}\n\n.btn-check:focus + .btn-google,\n.btn-google:focus {\n    color: #fff;\n    background-color: #ba392f;\n    border-color: #af362c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(224, 95, 85, .5)\n}\n\n.btn-check:active + .btn-google,\n.btn-check:checked + .btn-google,\n.btn-google.active,\n.btn-google:active,\n.show > .btn-google.dropdown-toggle {\n    color: #fff;\n    background-color: #af362c;\n    border-color: #a43229\n}\n\n.btn-check:active + .btn-google:focus,\n.btn-check:checked + .btn-google:focus,\n.btn-google.active:focus,\n.btn-google:active:focus,\n.show > .btn-google.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(224, 95, 85, .5)\n}\n\n.btn-google.disabled,\n.btn-google:disabled {\n    color: #fff;\n    background-color: #db4337;\n    border-color: #db4337\n}\n\n.btn-google.btn-link {\n    color: #db4337;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-google.btn-link.active,\n.btn-google.btn-link:focus,\n.btn-google.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #db4337\n}\n\n.btn-instagram {\n    color: #fff;\n    background-color: #e4405f;\n    border-color: #e4405f;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-instagram:hover {\n    color: #fff;\n    background-color: #c23651;\n    border-color: #b6334c\n}\n\n.btn-check:focus + .btn-instagram,\n.btn-instagram:focus {\n    color: #fff;\n    background-color: #c23651;\n    border-color: #b6334c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(232, 93, 119, .5)\n}\n\n.btn-check:active + .btn-instagram,\n.btn-check:checked + .btn-instagram,\n.btn-instagram.active,\n.btn-instagram:active,\n.show > .btn-instagram.dropdown-toggle {\n    color: #fff;\n    background-color: #b6334c;\n    border-color: #ab3047\n}\n\n.btn-check:active + .btn-instagram:focus,\n.btn-check:checked + .btn-instagram:focus,\n.btn-instagram.active:focus,\n.btn-instagram:active:focus,\n.show > .btn-instagram.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(232, 93, 119, .5)\n}\n\n.btn-instagram.disabled,\n.btn-instagram:disabled {\n    color: #fff;\n    background-color: #e4405f;\n    border-color: #e4405f\n}\n\n.btn-instagram.btn-link {\n    color: #e4405f;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-instagram.btn-link.active,\n.btn-instagram.btn-link:focus,\n.btn-instagram.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #e4405f\n}\n\n.btn-pinterest {\n    color: #fff;\n    background-color: #bd081c;\n    border-color: #bd081c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-pinterest:hover {\n    color: #fff;\n    background-color: #a10718;\n    border-color: #970616\n}\n\n.btn-check:focus + .btn-pinterest,\n.btn-pinterest:focus {\n    color: #fff;\n    background-color: #a10718;\n    border-color: #970616;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(199, 45, 62, .5)\n}\n\n.btn-check:active + .btn-pinterest,\n.btn-check:checked + .btn-pinterest,\n.btn-pinterest.active,\n.btn-pinterest:active,\n.show > .btn-pinterest.dropdown-toggle {\n    color: #fff;\n    background-color: #970616;\n    border-color: #8e0615\n}\n\n.btn-check:active + .btn-pinterest:focus,\n.btn-check:checked + .btn-pinterest:focus,\n.btn-pinterest.active:focus,\n.btn-pinterest:active:focus,\n.show > .btn-pinterest.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(199, 45, 62, .5)\n}\n\n.btn-pinterest.disabled,\n.btn-pinterest:disabled {\n    color: #fff;\n    background-color: #bd081c;\n    border-color: #bd081c\n}\n\n.btn-pinterest.btn-link {\n    color: #bd081c;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-pinterest.btn-link.active,\n.btn-pinterest.btn-link:focus,\n.btn-pinterest.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #bd081c\n}\n\n.btn-youtube {\n    color: #fff;\n    background-color: #cd201f;\n    border-color: #cd201f;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-youtube:hover {\n    color: #fff;\n    background-color: #ae1b1a;\n    border-color: #a41a19\n}\n\n.btn-check:focus + .btn-youtube,\n.btn-youtube:focus {\n    color: #fff;\n    background-color: #ae1b1a;\n    border-color: #a41a19;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(213, 65, 65, .5)\n}\n\n.btn-check:active + .btn-youtube,\n.btn-check:checked + .btn-youtube,\n.btn-youtube.active,\n.btn-youtube:active,\n.show > .btn-youtube.dropdown-toggle {\n    color: #fff;\n    background-color: #a41a19;\n    border-color: #9a1817\n}\n\n.btn-check:active + .btn-youtube:focus,\n.btn-check:checked + .btn-youtube:focus,\n.btn-youtube.active:focus,\n.btn-youtube:active:focus,\n.show > .btn-youtube.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(213, 65, 65, .5)\n}\n\n.btn-youtube.disabled,\n.btn-youtube:disabled {\n    color: #fff;\n    background-color: #cd201f;\n    border-color: #cd201f\n}\n\n.btn-youtube.btn-link {\n    color: #cd201f;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-youtube.btn-link.active,\n.btn-youtube.btn-link:focus,\n.btn-youtube.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #cd201f\n}\n\n.btn-slack {\n    color: #1f2937;\n    background-color: #3aaf85;\n    border-color: #3aaf85;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-slack:hover {\n    color: #1f2937;\n    background-color: #58bb97;\n    border-color: #4eb791\n}\n\n.btn-check:focus + .btn-slack,\n.btn-slack:focus {\n    color: #1f2937;\n    background-color: #58bb97;\n    border-color: #4eb791;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(54, 155, 121, .5)\n}\n\n.btn-check:active + .btn-slack,\n.btn-check:checked + .btn-slack,\n.btn-slack.active,\n.btn-slack:active,\n.show > .btn-slack.dropdown-toggle {\n    color: #1f2937;\n    background-color: #61bf9d;\n    border-color: #4eb791\n}\n\n.btn-check:active + .btn-slack:focus,\n.btn-check:checked + .btn-slack:focus,\n.btn-slack.active:focus,\n.btn-slack:active:focus,\n.show > .btn-slack.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(54, 155, 121, .5)\n}\n\n.btn-slack.disabled,\n.btn-slack:disabled {\n    color: #1f2937;\n    background-color: #3aaf85;\n    border-color: #3aaf85\n}\n\n.btn-slack.btn-link {\n    color: #3aaf85;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-slack.btn-link.active,\n.btn-slack.btn-link:focus,\n.btn-slack.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #3aaf85\n}\n\n.btn-dribbble {\n    color: #fff;\n    background-color: #ea4c89;\n    border-color: #ea4c89;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-dribbble:hover {\n    color: #fff;\n    background-color: #c74174;\n    border-color: #bb3d6e\n}\n\n.btn-check:focus + .btn-dribbble,\n.btn-dribbble:focus {\n    color: #fff;\n    background-color: #c74174;\n    border-color: #bb3d6e;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(237, 103, 155, .5)\n}\n\n.btn-check:active + .btn-dribbble,\n.btn-check:checked + .btn-dribbble,\n.btn-dribbble.active,\n.btn-dribbble:active,\n.show > .btn-dribbble.dropdown-toggle {\n    color: #fff;\n    background-color: #bb3d6e;\n    border-color: #b03967\n}\n\n.btn-check:active + .btn-dribbble:focus,\n.btn-check:checked + .btn-dribbble:focus,\n.btn-dribbble.active:focus,\n.btn-dribbble:active:focus,\n.show > .btn-dribbble.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(237, 103, 155, .5)\n}\n\n.btn-dribbble.disabled,\n.btn-dribbble:disabled {\n    color: #fff;\n    background-color: #ea4c89;\n    border-color: #ea4c89\n}\n\n.btn-dribbble.btn-link {\n    color: #ea4c89;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-dribbble.btn-link.active,\n.btn-dribbble.btn-link:focus,\n.btn-dribbble.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #ea4c89\n}\n\n.btn-dropbox {\n    color: #fff;\n    background-color: #1e90ff;\n    border-color: #1e90ff;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-dropbox:hover {\n    color: #fff;\n    background-color: #1a7ad9;\n    border-color: #1873cc\n}\n\n.btn-check:focus + .btn-dropbox,\n.btn-dropbox:focus {\n    color: #fff;\n    background-color: #1a7ad9;\n    border-color: #1873cc;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(64, 161, 255, .5)\n}\n\n.btn-check:active + .btn-dropbox,\n.btn-check:checked + .btn-dropbox,\n.btn-dropbox.active,\n.btn-dropbox:active,\n.show > .btn-dropbox.dropdown-toggle {\n    color: #fff;\n    background-color: #1873cc;\n    border-color: #176cbf\n}\n\n.btn-check:active + .btn-dropbox:focus,\n.btn-check:checked + .btn-dropbox:focus,\n.btn-dropbox.active:focus,\n.btn-dropbox:active:focus,\n.show > .btn-dropbox.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(64, 161, 255, .5)\n}\n\n.btn-dropbox.disabled,\n.btn-dropbox:disabled {\n    color: #fff;\n    background-color: #1e90ff;\n    border-color: #1e90ff\n}\n\n.btn-dropbox.btn-link {\n    color: #1e90ff;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-dropbox.btn-link.active,\n.btn-dropbox.btn-link:focus,\n.btn-dropbox.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #1e90ff\n}\n\n.btn-twitch {\n    color: #fff;\n    background-color: #4b367c;\n    border-color: #4b367c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-twitch:hover {\n    color: #fff;\n    background-color: #402e69;\n    border-color: #3c2b63\n}\n\n.btn-check:focus + .btn-twitch,\n.btn-twitch:focus {\n    color: #fff;\n    background-color: #402e69;\n    border-color: #3c2b63;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(102, 84, 144, .5)\n}\n\n.btn-check:active + .btn-twitch,\n.btn-check:checked + .btn-twitch,\n.btn-twitch.active,\n.btn-twitch:active,\n.show > .btn-twitch.dropdown-toggle {\n    color: #fff;\n    background-color: #3c2b63;\n    border-color: #38295d\n}\n\n.btn-check:active + .btn-twitch:focus,\n.btn-check:checked + .btn-twitch:focus,\n.btn-twitch.active:focus,\n.btn-twitch:active:focus,\n.show > .btn-twitch.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(102, 84, 144, .5)\n}\n\n.btn-twitch.disabled,\n.btn-twitch:disabled {\n    color: #fff;\n    background-color: #4b367c;\n    border-color: #4b367c\n}\n\n.btn-twitch.btn-link {\n    color: #4b367c;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-twitch.btn-link.active,\n.btn-twitch.btn-link:focus,\n.btn-twitch.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #4b367c\n}\n\n.btn-paypal {\n    color: #1f2937;\n    background-color: #ecb32c;\n    border-color: #ecb32c;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-paypal:hover {\n    color: #1f2937;\n    background-color: #efbe4c;\n    border-color: #eebb41\n}\n\n.btn-check:focus + .btn-paypal,\n.btn-paypal:focus {\n    color: #1f2937;\n    background-color: #efbe4c;\n    border-color: #eebb41;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(205, 158, 46, .5)\n}\n\n.btn-check:active + .btn-paypal,\n.btn-check:checked + .btn-paypal,\n.btn-paypal.active,\n.btn-paypal:active,\n.show > .btn-paypal.dropdown-toggle {\n    color: #1f2937;\n    background-color: #f0c256;\n    border-color: #eebb41\n}\n\n.btn-check:active + .btn-paypal:focus,\n.btn-check:checked + .btn-paypal:focus,\n.btn-paypal.active:focus,\n.btn-paypal:active:focus,\n.show > .btn-paypal.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(205, 158, 46, .5)\n}\n\n.btn-paypal.disabled,\n.btn-paypal:disabled {\n    color: #1f2937;\n    background-color: #ecb32c;\n    border-color: #ecb32c\n}\n\n.btn-paypal.btn-link {\n    color: #ecb32c;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-paypal.btn-link.active,\n.btn-paypal.btn-link:focus,\n.btn-paypal.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #ecb32c\n}\n\n.btn-behance {\n    color: #fff;\n    background-color: #0057ff;\n    border-color: #0057ff;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-behance:hover {\n    color: #fff;\n    background-color: #004ad9;\n    border-color: #0046cc\n}\n\n.btn-behance:focus,\n.btn-check:focus + .btn-behance {\n    color: #fff;\n    background-color: #004ad9;\n    border-color: #0046cc;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(38, 112, 255, .5)\n}\n\n.btn-behance.active,\n.btn-behance:active,\n.btn-check:active + .btn-behance,\n.btn-check:checked + .btn-behance,\n.show > .btn-behance.dropdown-toggle {\n    color: #fff;\n    background-color: #0046cc;\n    border-color: #0041bf\n}\n\n.btn-behance.active:focus,\n.btn-behance:active:focus,\n.btn-check:active + .btn-behance:focus,\n.btn-check:checked + .btn-behance:focus,\n.show > .btn-behance.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(38, 112, 255, .5)\n}\n\n.btn-behance.disabled,\n.btn-behance:disabled {\n    color: #fff;\n    background-color: #0057ff;\n    border-color: #0057ff\n}\n\n.btn-behance.btn-link {\n    color: #0057ff;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-behance.btn-link.active,\n.btn-behance.btn-link:focus,\n.btn-behance.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #0057ff\n}\n\n.btn-reddit {\n    color: #fff;\n    background-color: #e84422;\n    border-color: #e84422;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-reddit:hover {\n    color: #fff;\n    background-color: #c53a1d;\n    border-color: #ba361b\n}\n\n.btn-check:focus + .btn-reddit,\n.btn-reddit:focus {\n    color: #fff;\n    background-color: #c53a1d;\n    border-color: #ba361b;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(235, 96, 67, .5)\n}\n\n.btn-check:active + .btn-reddit,\n.btn-check:checked + .btn-reddit,\n.btn-reddit.active,\n.btn-reddit:active,\n.show > .btn-reddit.dropdown-toggle {\n    color: #fff;\n    background-color: #ba361b;\n    border-color: #ae331a\n}\n\n.btn-check:active + .btn-reddit:focus,\n.btn-check:checked + .btn-reddit:focus,\n.btn-reddit.active:focus,\n.btn-reddit:active:focus,\n.show > .btn-reddit.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(235, 96, 67, .5)\n}\n\n.btn-reddit.disabled,\n.btn-reddit:disabled {\n    color: #fff;\n    background-color: #e84422;\n    border-color: #e84422\n}\n\n.btn-reddit.btn-link {\n    color: #e84422;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-reddit.btn-link.active,\n.btn-reddit.btn-link:focus,\n.btn-reddit.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #e84422\n}\n\n.btn-github {\n    color: #fff;\n    background-color: #222;\n    border-color: #222;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075)\n}\n\n.btn-github:hover {\n    color: #fff;\n    background-color: #1d1d1d;\n    border-color: #1b1b1b\n}\n\n.btn-check:focus + .btn-github,\n.btn-github:focus {\n    color: #fff;\n    background-color: #1d1d1d;\n    border-color: #1b1b1b;\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .15), 0 1px 1px rgba(17, 24, 39, .075), 0 0 0 .18rem rgba(67, 67, 67, .5)\n}\n\n.btn-check:active + .btn-github,\n.btn-check:checked + .btn-github,\n.btn-github.active,\n.btn-github:active,\n.show > .btn-github.dropdown-toggle {\n    color: #fff;\n    background-color: #1b1b1b;\n    border-color: #1a1a1a\n}\n\n.btn-check:active + .btn-github:focus,\n.btn-check:checked + .btn-github:focus,\n.btn-github.active:focus,\n.btn-github:active:focus,\n.show > .btn-github.dropdown-toggle:focus {\n    box-shadow: inset 0 3px 5px rgba(17, 24, 39, .125), 0 0 0 .18rem rgba(67, 67, 67, .5)\n}\n\n.btn-github.disabled,\n.btn-github:disabled {\n    color: #fff;\n    background-color: #222;\n    border-color: #222\n}\n\n.btn-github.btn-link {\n    color: #222;\n    background: 0 0;\n    box-shadow: none;\n    border: 0;\n    border-style: none\n}\n\n.btn-github.btn-link.active,\n.btn-github.btn-link:focus,\n.btn-github.btn-link:hover {\n    background-color: transparent !important;\n    box-shadow: none;\n    border: 0;\n    color: #222\n}\n\n.theme-settings-close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    font-size: .65rem\n}\n\n.btn-close.theme-settings-close {\n    background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n    border: 0;\n    border-radius: .5rem;\n    opacity: .5\n}\n\n.breadcrumb-item {\n    font-size: .75rem\n}\n\n.breadcrumb-item,\n.breadcrumb-item a {\n    color: #374151;\n    font-weight: 400;\n    font-size: .75rem\n}\n\n@media (min-width: 576px) {\n\n    .breadcrumb-item,\n    .breadcrumb-item a {\n        font-size: .875rem\n    }\n}\n\n.breadcrumb-transparent {\n    background: 0 0;\n    padding: 0\n}\n\n.breadcrumb-text-light .breadcrumb-item,\n.breadcrumb-text-light .breadcrumb-item a {\n    color: #fff\n}\n\n.breadcrumb-text-light .breadcrumb-item:before {\n    color: #fff\n}\n\n.card {\n    position: relative\n}\n\n.card .card-header {\n    background: 0 0\n}\n\n.card.hover-state:hover {\n    background-color: #f2f4f6\n}\n\n.card .profile-cover {\n    background-repeat: no-repeat;\n    background-position: top center;\n    background-size: cover;\n    height: 200px\n}\n\n.card.notification-card {\n    height: 633px\n}\n\n.card.notification-card .list-group-timeline {\n    height: 520px;\n    overflow: hidden;\n    overflow-y: auto\n}\n\n@media (min-width: 992px) {\n    .card.timeline-card:before {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 0;\n        margin-left: .75rem;\n        border: 8px solid #111827;\n        border-color: transparent #e0e6ec #e0e6ec transparent;\n        box-sizing: border-box;\n        transform-origin: 0 0;\n        transform: rotate(135deg);\n        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n    }\n\n    .card.left-timeline-card:after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        right: 0;\n        margin-right: -5px;\n        border: 8px solid #111827;\n        border-color: transparent #e0e6ec #e0e6ec transparent;\n        box-sizing: border-box;\n        transform-origin: 0 0;\n        transform: rotate(-45deg);\n        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n    }\n}\n\n.message-wrapper .card,\n.task-wrapper .card {\n    border: 0\n}\n\n.customer-testimonial .content-wrapper:before {\n    content: \"\";\n    position: absolute;\n    top: 25px;\n    left: -1px;\n    margin-left: .75rem;\n    border: 8px solid #111827;\n    border-color: transparent #e0e6ec #e0e6ec transparent;\n    box-sizing: border-box;\n    transform-origin: 0 0;\n    transform: rotate(135deg);\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n}\n\n.card-footer {\n    background-color: transparent\n}\n\n.card-stats {\n    padding-left: 1.785rem\n}\n\n.card .card-blockquote {\n    position: relative;\n    padding: 2rem\n}\n\n.card .card-blockquote .svg-bg {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 95px;\n    top: -94px;\n    left: 0\n}\n\n.card-lift-hover:hover {\n    transform: translateY(-20px);\n    transition: all .2s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .card-lift-hover:hover {\n        transition: none\n    }\n}\n\n.page-preview {\n    display: block;\n    position: relative\n}\n\n.page-preview .show-on-hover {\n    position: absolute;\n    bottom: -25px;\n    background: rgba(31, 41, 55, .85);\n    padding: 10px 0;\n    border-bottom-left-radius: .5rem;\n    border-bottom-right-radius: .5rem;\n    width: calc(100% + 28px);\n    left: -14px;\n    opacity: 0;\n    transition: .2s\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .page-preview .show-on-hover {\n        transition: none\n    }\n}\n\n.page-preview.page-preview-lg .show-on-hover {\n    left: -30px;\n    width: calc(100% + 60px);\n    bottom: -20px\n}\n\n.page-preview:hover .show-on-hover {\n    z-index: 99;\n    opacity: 1\n}\n\n.carousel-caption,\n.carousel-caption .h5,\n.carousel-caption h5 {\n    color: #fff\n}\n\n.carousel-indicators li {\n    height: 10px;\n    width: 10px;\n    border-radius: 50%;\n    background: 0 0;\n    border: 2px solid #fff\n}\n\n.carousel-indicators .active {\n    opacity: 1;\n    background: #fff\n}\n\n.carousel-control-next-icon,\n.carousel-control-prev-icon {\n    width: auto;\n    height: auto;\n    font-weight: 900\n}\n\n.carousel-control-prev-icon {\n    background-image: none\n}\n\n.carousel-control-prev-icon::before {\n    content: '\\f060';\n    font-family: \"Font Awesome 5 Free\";\n    font-size: 2rem\n}\n\n.carousel-control-next-icon {\n    background-image: none\n}\n\n.carousel-control-next-icon:before {\n    font-family: \"Font Awesome 5 Free\";\n    content: \"\\f061\";\n    font-size: 2rem\n}\n\n.close {\n    transition: all .2s ease\n}\n\n.close > span:not(.sr-only) {\n    display: block;\n    height: 1.25rem;\n    width: 1.25rem;\n    background-color: transparent;\n    color: rgba(0, 0, 0, .6);\n    line-height: 17px;\n    border-radius: 50%;\n    font-size: 1.25rem;\n    transition: all .2s ease\n}\n\n.close:focus,\n.close:hover {\n    background-color: transparent;\n    color: rgba(0, 0, 0, .9);\n    outline: 0\n}\n\n.close:focus span:not(.sr-only),\n.close:hover span:not(.sr-only) {\n    background-color: transparent\n}\n\n.counter-alternate::after {\n    content: '\\f067';\n    font-family: \"Font Awesome 5 Free\";\n    position: absolute;\n    font-size: 2.25rem;\n    color: #1f2937;\n    font-weight: 900\n}\n\n.custom-control-label:before {\n    box-shadow: none;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n.custom-control-label span {\n    position: relative;\n    top: 2px\n}\n\n.custom-control-label {\n    margin-bottom: 0\n}\n\n.custom-control-input:active ~ .custom-control-label::before {\n    border-color: #1f2937\n}\n\n.custom-file-label {\n    background-color: #f3f3f5\n}\n\n.custom-file-label::after {\n    background-color: #f3f3f5\n}\n\n.custom-select {\n    font-size: .875rem;\n    box-shadow: none\n}\n\n.custom-select.custom-select-shadow {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);\n    transition: box-shadow .15s ease\n}\n\n.custom-select.custom-select-shadow:focus {\n    box-shadow: .1rem .1rem 0 rgba(229, 231, 235, .5)\n}\n\n.custom-select:hover {\n    cursor: pointer\n}\n\n.apexcharts-tooltip {\n    background-color: #fff !important;\n    color: #374151 !important;\n    border: 0 !important;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important;\n    border-radius: .35rem !important\n}\n\n.apexcharts-tooltip .apexcharts-tooltip-title {\n    padding: 6px 10px !important;\n    background: #e5e7eb !important;\n    border-bottom: .0625rem solid #d1d5db !important\n}\n\n.apexcharts-xaxistooltip {\n    color: #374151 !important;\n    border: 0 !important;\n    background-color: #fff !important;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06) !important;\n    border-radius: .35rem !important\n}\n\n.apexcharts-xaxistooltip-bottom::before {\n    border-bottom-color: #fff !important\n}\n\n.apexcharts-xaxistooltip-bottom::after {\n    border-bottom-color: #fff !important\n}\n\n.apexcharts-tooltip-marker {\n    min-width: 10px !important;\n    min-height: 10px !important;\n    margin-right: 8px !important\n}\n\n.apexcharts-tooltip-y-group {\n    padding: 4px 0 5px !important\n}\n\n.ct-bar {\n    stroke-linecap: round;\n    stroke-width: 10px\n}\n\n.ct-label {\n    fill: #374151;\n    color: #374151;\n    font-size: .75rem;\n    margin-top: 6px;\n    font-weight: 500\n}\n\n.ct-slice-pie {\n    stroke: #fff;\n    stroke-width: 3px\n}\n\n.ct-chart-donut .ct-series {\n    stroke: #fff;\n    stroke-width: 3px\n}\n\n.ct-chart-donut .ct-label,\n.ct-chart-pie .ct-label {\n    font-size: .75rem;\n    font-weight: 500\n}\n\n.small-chart {\n    margin-left: -1rem\n}\n\n.ct-chart-donut .ct-label,\n.ct-chart-pie .ct-label {\n    color: #fff;\n    fill: #fff;\n    font-size: 1rem;\n    font-weight: 500\n}\n\n.ct-series-g .ct-grid {\n    stroke: #f8bd7a;\n    stroke-width: 2px;\n    stroke-dasharray: 2px\n}\n\n.ct-series-g .ct-label.ct-horizontal.ct-end {\n    margin-left: -9px;\n    margin-top: 10px;\n    color: #1f2937\n}\n\n.dropdown-menu .dropdown-header,\n.dropdown-menu .dropdown-item {\n    padding: .5rem 1rem;\n    font-size: .875rem\n}\n\n.dropdown-menu .dropdown-header .dropdown-icon,\n.dropdown-menu .dropdown-item .dropdown-icon {\n    height: 1.25rem;\n    width: 1.25rem\n}\n\n.dropdown-menu .dropdown-header {\n    color: #111827;\n    font-weight: 500\n}\n\n.dropdown-menu .dropdown-item {\n    transition: all .2s ease;\n    font-weight: 400\n}\n\n.show .dropdown-menu {\n    animation: show-dropdown .2s ease forwards\n}\n\n.dropdown-menu.dropdown-menu-xs {\n    min-width: 120px;\n    max-width: 120px;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)\n}\n\n.dropdown-menu-sm {\n    min-width: 100px;\n    border: 1rem\n}\n\n.dropdown-menu-md {\n    min-width: 180px;\n    border: 1rem\n}\n\n.dropdown-menu-lg {\n    min-width: 350px;\n    border-radius: 1rem\n}\n\n@media (max-width: 575.98px) {\n    .dropdown-menu-lg {\n        min-width: 300px\n    }\n}\n\n[data-toggle]:hover {\n    cursor: pointer\n}\n\n.dropdown-toggle:after,\n.dropend .dropdown-toggle:after,\n.dropstart .dropdown-toggle:before,\n.dropup .dropdown-toggle:after {\n    display: none\n}\n\n.dropzone {\n    min-height: 150px;\n    border: 2px dashed #4b5563;\n    background: #fff\n}\n\n.dropzone:hover {\n    background-color: #e5e7eb\n}\n\n.dropzone .dz-message .dz-button {\n    font-size: 1.25rem;\n    font-weight: 500\n}\n\n.icon {\n    height: 2rem\n}\n\n.icon.icon-xxs {\n    height: 1rem\n}\n\n.icon.icon-xs {\n    height: 1.25rem\n}\n\n.icon.icon-sm {\n    height: 1.5rem\n}\n\n.icon.icon-lg {\n    height: 3.5rem\n}\n\n.icon.icon-xl {\n    height: 4.5rem\n}\n\n.icon.icon-xxl {\n    height: 6rem\n}\n\n.icon.active-dot svg {\n    height: .7rem\n}\n\n.icon-shape {\n    width: 4rem;\n    height: 4rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center\n}\n\n.icon-shape svg {\n    height: 2rem\n}\n\n.icon-shape.icon-xxs {\n    width: 1.5rem;\n    height: 1.5rem\n}\n\n.icon-shape.icon-xxs svg {\n    height: 1rem\n}\n\n.icon-shape.icon-xs {\n    width: 2.5rem;\n    height: 2.5rem\n}\n\n.icon-shape.icon-xs svg {\n    height: 1.25rem\n}\n\n.icon-shape.icon-sm {\n    width: 3.275rem;\n    height: 3.275rem\n}\n\n.icon-shape.icon-sm svg {\n    height: 1.5rem\n}\n\n.icon-shape.icon-lg {\n    width: 5rem;\n    height: 5rem\n}\n\n.icon-shape.icon-lg svg {\n    height: 3.5rem\n}\n\n.icon-shape.icon-xl {\n    width: 6rem;\n    height: 6rem\n}\n\n.icon-shape.icon-xl svg {\n    height: 4.5rem\n}\n\n.icon-shape.icon-xxl {\n    width: 7.5rem;\n    height: 7.5rem\n}\n\n.icon-shape.icon-xxl svg {\n    height: 6rem\n}\n\n.rating-star:hover {\n    cursor: pointer;\n    color: #fba918\n}\n\n.toggle-icon {\n    height: 1.875rem\n}\n\n.w--20 {\n    width: 20px\n}\n\n.calendar {\n    width: 3.125rem;\n    line-height: 1;\n    flex-direction: column;\n    text-align: center;\n    border-radius: .5rem\n}\n\n.calendar .calendar-month {\n    background-color: #e11d48;\n    color: #fff;\n    border-radius: .5rem .5rem 0 0;\n    padding: .275rem;\n    font-weight: 500\n}\n\n.calendar .calendar-day {\n    font-size: 1.5rem;\n    padding: .25rem;\n    background-color: #f2f4f6;\n    border-top: 0;\n    border-radius: 0 0 .5rem .5rem;\n    color: #1f2937;\n    font-weight: 500\n}\n\n.dot {\n    width: 12px;\n    height: 12px\n}\n\n.bell-dot {\n    display: inline-block;\n    position: absolute;\n    top: -11px;\n    right: 6px;\n    height: 10px;\n    width: 10px;\n    border: 2px solid #f2f4f6\n}\n\n.notification-bell.unread::before {\n    position: absolute;\n    content: \"\";\n    background-color: #e11d48;\n    right: 12px;\n    top: 7px;\n    height: .75rem;\n    width: .75rem;\n    border-radius: 50%;\n    border: 2px solid #f2f4f6\n}\n\n.bootstrap-big-icon {\n    position: absolute;\n    opacity: .05;\n    transform: rotate(17deg)\n}\n\n@media (min-width: 992px) {\n    .bootstrap-big-icon {\n        right: -20%;\n        bottom: 6%\n    }\n}\n\n@media (min-width: 1200px) {\n    .bootstrap-big-icon {\n        right: -10%;\n        bottom: 6%\n    }\n}\n\n.github-big-icon {\n    position: absolute;\n    right: 80px\n}\n\n.github-big-icon svg {\n    color: #9ca3af;\n    height: 800px;\n    opacity: .2\n}\n\n.icon-shape-primary {\n    color: #1f2937;\n    background-color: rgba(31, 41, 55, .3)\n}\n\n.icon-shape-secondary {\n    color: #f0bc74;\n    background-color: rgba(240, 188, 116, .3)\n}\n\n.icon-shape-tertiary {\n    color: #31316a;\n    background-color: rgba(49, 49, 106, .3)\n}\n\n.icon-shape-success {\n    color: #10b981;\n    background-color: rgba(16, 185, 129, .3)\n}\n\n.icon-shape-info {\n    color: #2361ce;\n    background-color: rgba(35, 97, 206, .3)\n}\n\n.icon-shape-warning {\n    color: #fba918;\n    background-color: rgba(251, 169, 24, .3)\n}\n\n.icon-shape-danger {\n    color: #e11d48;\n    background-color: rgba(225, 29, 72, .3)\n}\n\n.icon-shape-white {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .3)\n}\n\n.icon-shape-indigo {\n    color: #4f46e5;\n    background-color: rgba(79, 70, 229, .3)\n}\n\n.icon-shape-purple {\n    color: #7c3aed;\n    background-color: rgba(124, 58, 237, .3)\n}\n\n.icon-shape-yellow-100 {\n    color: #ffeed6;\n    background-color: rgba(255, 238, 214, .3)\n}\n\n.icon-shape-yellow-200 {\n    color: #f5dbb8;\n    background-color: rgba(245, 219, 184, .3)\n}\n\n.icon-shape-gray-50 {\n    color: #f9fafb;\n    background-color: rgba(249, 250, 251, .3)\n}\n\n.icon-shape-gray-100 {\n    color: #f2f4f6;\n    background-color: rgba(242, 244, 246, .3)\n}\n\n.icon-shape-gray-200 {\n    color: #e5e7eb;\n    background-color: rgba(229, 231, 235, .3)\n}\n\n.icon-shape-gray-300 {\n    color: #d1d5db;\n    background-color: rgba(209, 213, 219, .3)\n}\n\n.icon-shape-gray-400 {\n    color: #9ca3af;\n    background-color: rgba(156, 163, 175, .3)\n}\n\n.icon-shape-gray-500 {\n    color: #6b7280;\n    background-color: rgba(107, 114, 128, .3)\n}\n\n.icon-shape-gray-600 {\n    color: #4b5563;\n    background-color: rgba(75, 85, 99, .3)\n}\n\n.icon-shape-gray-700 {\n    color: #374151;\n    background-color: rgba(55, 65, 81, .3)\n}\n\n.icon-shape-gray-800 {\n    color: #1f2937;\n    background-color: rgba(31, 41, 55, .3)\n}\n\n.icon-shape-gray-900 {\n    color: #111827;\n    background-color: rgba(17, 24, 39, .3)\n}\n\n.image-xl {\n    height: 20rem\n}\n\n.image-xl img {\n    height: 20rem\n}\n\n.image-lg {\n    height: 12rem\n}\n\n.image-lg img {\n    height: 12rem\n}\n\n.image-md {\n    height: 5.5rem\n}\n\n.image-md img {\n    height: 5.5rem\n}\n\n.image-sm {\n    height: 3rem\n}\n\n.image-sm img {\n    height: 3rem\n}\n\n.image-xs {\n    height: 1.5rem\n}\n\n.image-xs img {\n    height: 1.5rem\n}\n\n.image-small {\n    height: 1rem\n}\n\n.image-small img {\n    height: 1rem\n}\n\n.full-image {\n    height: 100%\n}\n\n.language-flag {\n    width: auto;\n    height: 1rem;\n    margin-right: .4rem;\n    position: relative;\n    top: -2px\n}\n\n.home-pattern {\n    fill: #f2f4f6\n}\n\n.form-bg-image {\n    background-repeat: no-repeat !important;\n    background-position: top center !important\n}\n\n.list-group-space .list-group-item {\n    margin-bottom: 1.5rem;\n    border-radius: .5rem\n}\n\n.list-group-item {\n    border: 0\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.list-group-item i {\n    width: 1rem\n}\n\n.list-group-img {\n    width: 3rem;\n    height: 3rem;\n    border-radius: 50%;\n    vertical-align: top;\n    margin: -.1rem 1.2rem 0 -.2rem\n}\n\n.list-group-content {\n    flex: 1;\n    min-width: 0\n}\n\n.list-group-content > p {\n    color: #6b7280;\n    line-height: 1.5;\n    margin: .2rem 0 0\n}\n\n.list-group-heading {\n    font-size: 1rem;\n    color: #1f2937\n}\n\n.list-group-heading > .small,\n.list-group-heading > small {\n    float: right;\n    color: #6b7280;\n    font-weight: 500\n}\n\n.list-group.simple-list .list-group-item {\n    background: 0 0;\n    border: none;\n    padding: .375rem .125rem\n}\n\n.list-group.simple-list .list-group-item i {\n    vertical-align: middle;\n    width: 35px;\n    display: inline-block\n}\n\n.list-group.kanban-list {\n    position: relative;\n    padding-bottom: 45px\n}\n\n.list-group.kanban-list .card {\n    margin-bottom: .75rem;\n    cursor: pointer\n}\n\n.list-group.kanban-list .new-card {\n    position: absolute;\n    bottom: 0\n}\n\n.news-list .row > [class*=col] {\n    padding: 0 .25rem\n}\n\n.news-list > li:not(:last-child) {\n    margin-bottom: .75rem\n}\n\n.news-list img {\n    min-height: 100%;\n    -o-object-fit: cover;\n    object-fit: cover\n}\n\n.map {\n    height: 400px;\n    width: 100%;\n    -moz-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    filter: grayscale(100%)\n}\n\n.mapouter {\n    position: relative;\n    text-align: right;\n    height: 500px;\n    width: 100%\n}\n\n.gmap_canvas {\n    overflow: hidden;\n    background: 0 0 !important;\n    height: 500px;\n    width: 100%;\n    -moz-filter: grayscale(100%);\n    -ms-filter: grayscale(100%);\n    -o-filter: grayscale(100%);\n    filter: grayscale(100%)\n}\n\n.gmap_canvas #gmap_canvas {\n    width: 100%;\n    height: 500px\n}\n\n#mapbox {\n    width: 100%;\n    height: 600px;\n    z-index: 1\n}\n\n.leaflet-popup-content-wrapper {\n    padding: 8px 8px 8px 0\n}\n\n.leaflet-popup-content-wrapper,\n.leaflet-popup-tip {\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)\n}\n\n.leaflet-container a.leaflet-popup-close-button {\n    padding: 7px 15px 0 0\n}\n\n.logo-map {\n    position: absolute;\n    right: 0;\n    z-index: 3\n}\n\n.search-map {\n    position: absolute;\n    z-index: 3;\n    bottom: 30px;\n    width: 100%\n}\n\n.svgMap-map-wrapper {\n    position: relative;\n    width: 100%;\n    padding-top: 50%;\n    overflow: hidden;\n    background: #fff;\n    color: #1f2937\n}\n\n.svgMap-map-wrapper * {\n    box-sizing: border-box;\n    outline: 0\n}\n\n.svgMap-map-wrapper .svgMap-map-image {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-wrapper {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    z-index: 1;\n    display: flex;\n    overflow: hidden;\n    border-radius: .5rem;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2)\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-move,\n.svgMap-map-wrapper .svgMap-map-controls-zoom {\n    display: flex;\n    margin-right: 5px;\n    overflow: hidden;\n    background: #fff\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-move:last-child,\n.svgMap-map-wrapper .svgMap-map-controls-zoom:last-child {\n    margin-right: 0\n}\n\n.svgMap-map-wrapper .svgMap-control-button {\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    position: relative\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #e5e7eb;\n    transition: background-color .2s\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {\n    width: 11px;\n    height: 3px\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:before {\n    background: #111\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:before {\n    background: #ccc\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button:after {\n    width: 3px;\n    height: 11px\n}\n\n.svgMap-map-wrapper .svgMap-country {\n    cursor: pointer;\n    stroke: #fff;\n    stroke-width: 1;\n    stroke-linejoin: round;\n    vector-effect: non-scaling-stroke;\n    transition: fill .2s, stroke .2s\n}\n\n.svgMap-map-wrapper .svgMap-country.svgMap-active,\n.svgMap-map-wrapper .svgMap-country:hover {\n    stroke: #e5e7eb\n}\n\n.svgMap-map-wrapper .svgMap-country.svgMap-active {\n    stroke-width: 1.5\n}\n\n.svgMap-tooltip {\n    box-shadow: 0 0 3px rgba(0, 0, 0, .2);\n    position: absolute;\n    z-index: 2;\n    border-radius: 2px;\n    background: #fff;\n    transform: translate(-50%, -100%);\n    border-bottom: 1px solid #e5e7eb;\n    display: none;\n    pointer-events: none;\n    min-width: 60px\n}\n\n.svgMap-tooltip.svgMap-tooltip-flipped {\n    transform: translate(-50%, 0);\n    border-bottom: 0;\n    border-top: 1px solid #e5e7eb\n}\n\n.svgMap-tooltip.svgMap-active {\n    display: block\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container {\n    position: relative;\n    padding: 10px 20px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container {\n    text-align: center;\n    margin: 2px 0 5px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container.svgMap-tooltip-flag-container-emoji {\n    font-size: 50px;\n    line-height: 0;\n    padding: 25px 0 15px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container .svgMap-tooltip-flag {\n    display: block;\n    margin: auto;\n    width: auto;\n    height: 32px;\n    padding: 2px;\n    background: rgba(0, 0, 0, .15);\n    border-radius: 2px\n}\n\n.svgMap-tooltip .svgMap-tooltip-title {\n    white-space: nowrap;\n    font-size: 18px;\n    line-height: 28px;\n    padding: 0 0 8px;\n    text-align: center\n}\n\n.svgMap-tooltip .svgMap-tooltip-content {\n    white-space: nowrap;\n    text-align: center;\n    font-size: 14px;\n    color: #777;\n    margin: -5px 0 0\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table {\n    padding: 0;\n    border-spacing: 0;\n    margin: auto\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td {\n    padding: 2px 0;\n    text-align: left\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td span {\n    color: #111\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td:first-child {\n    padding-right: 10px;\n    text-align: right\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td sup {\n    vertical-align: baseline;\n    position: relative;\n    top: -5px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content .svgMap-tooltip-no-data {\n    padding: 2px 0;\n    color: #777;\n    font-style: italic\n}\n\n.svgMap-tooltip .svgMap-tooltip-pointer {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    overflow: hidden;\n    height: 10px;\n    width: 30px\n}\n\n.svgMap-tooltip .svgMap-tooltip-pointer:after {\n    content: '';\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    position: absolute;\n    bottom: 6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg)\n}\n\n.svgMap-tooltip.svgMap-tooltip-flipped .svgMap-tooltip-pointer {\n    bottom: auto;\n    top: -10px;\n    transform: translateX(-50%) scaleY(-1)\n}\n\n.modal.static-example {\n    position: relative;\n    display: block\n}\n\n.modal-content {\n    border: 0;\n    border-radius: .5rem\n}\n\n.modal-fluid .modal-dialog {\n    margin-top: 0;\n    margin-bottom: 0\n}\n\n.modal-fluid .modal-content {\n    border-radius: 0\n}\n\n.modal-primary .modal-title {\n    color: color-yiq(#1f2937)\n}\n\n.modal-primary .modal-footer,\n.modal-primary .modal-header {\n    border-color: rgba(31, 41, 55, .075)\n}\n\n.modal-primary .modal-content {\n    background-color: #1f2937;\n    color: color-yiq(#1f2937)\n}\n\n.modal-primary .modal-content .heading {\n    color: color-yiq(#1f2937)\n}\n\n.modal-primary .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-secondary .modal-title {\n    color: color-yiq(#f0bc74)\n}\n\n.modal-secondary .modal-footer,\n.modal-secondary .modal-header {\n    border-color: rgba(240, 188, 116, .075)\n}\n\n.modal-secondary .modal-content {\n    background-color: #f0bc74;\n    color: color-yiq(#f0bc74)\n}\n\n.modal-secondary .modal-content .heading {\n    color: color-yiq(#f0bc74)\n}\n\n.modal-secondary .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-tertiary .modal-title {\n    color: color-yiq(#31316a)\n}\n\n.modal-tertiary .modal-footer,\n.modal-tertiary .modal-header {\n    border-color: rgba(49, 49, 106, .075)\n}\n\n.modal-tertiary .modal-content {\n    background-color: #31316a;\n    color: color-yiq(#31316a)\n}\n\n.modal-tertiary .modal-content .heading {\n    color: color-yiq(#31316a)\n}\n\n.modal-tertiary .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-success .modal-title {\n    color: color-yiq(#10b981)\n}\n\n.modal-success .modal-footer,\n.modal-success .modal-header {\n    border-color: rgba(16, 185, 129, .075)\n}\n\n.modal-success .modal-content {\n    background-color: #10b981;\n    color: color-yiq(#10b981)\n}\n\n.modal-success .modal-content .heading {\n    color: color-yiq(#10b981)\n}\n\n.modal-success .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-info .modal-title {\n    color: color-yiq(#2361ce)\n}\n\n.modal-info .modal-footer,\n.modal-info .modal-header {\n    border-color: rgba(35, 97, 206, .075)\n}\n\n.modal-info .modal-content {\n    background-color: #2361ce;\n    color: color-yiq(#2361ce)\n}\n\n.modal-info .modal-content .heading {\n    color: color-yiq(#2361ce)\n}\n\n.modal-info .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-warning .modal-title {\n    color: color-yiq(#fba918)\n}\n\n.modal-warning .modal-footer,\n.modal-warning .modal-header {\n    border-color: rgba(251, 169, 24, .075)\n}\n\n.modal-warning .modal-content {\n    background-color: #fba918;\n    color: color-yiq(#fba918)\n}\n\n.modal-warning .modal-content .heading {\n    color: color-yiq(#fba918)\n}\n\n.modal-warning .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-danger .modal-title {\n    color: color-yiq(#e11d48)\n}\n\n.modal-danger .modal-footer,\n.modal-danger .modal-header {\n    border-color: rgba(225, 29, 72, .075)\n}\n\n.modal-danger .modal-content {\n    background-color: #e11d48;\n    color: color-yiq(#e11d48)\n}\n\n.modal-danger .modal-content .heading {\n    color: color-yiq(#e11d48)\n}\n\n.modal-danger .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-white .modal-title {\n    color: color-yiq(#fff)\n}\n\n.modal-white .modal-footer,\n.modal-white .modal-header {\n    border-color: rgba(255, 255, 255, .075)\n}\n\n.modal-white .modal-content {\n    background-color: #fff;\n    color: color-yiq(#fff)\n}\n\n.modal-white .modal-content .heading {\n    color: color-yiq(#fff)\n}\n\n.modal-white .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-indigo .modal-title {\n    color: color-yiq(#4f46e5)\n}\n\n.modal-indigo .modal-footer,\n.modal-indigo .modal-header {\n    border-color: rgba(79, 70, 229, .075)\n}\n\n.modal-indigo .modal-content {\n    background-color: #4f46e5;\n    color: color-yiq(#4f46e5)\n}\n\n.modal-indigo .modal-content .heading {\n    color: color-yiq(#4f46e5)\n}\n\n.modal-indigo .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-purple .modal-title {\n    color: color-yiq(#7c3aed)\n}\n\n.modal-purple .modal-footer,\n.modal-purple .modal-header {\n    border-color: rgba(124, 58, 237, .075)\n}\n\n.modal-purple .modal-content {\n    background-color: #7c3aed;\n    color: color-yiq(#7c3aed)\n}\n\n.modal-purple .modal-content .heading {\n    color: color-yiq(#7c3aed)\n}\n\n.modal-purple .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-yellow-100 .modal-title {\n    color: color-yiq(#ffeed6)\n}\n\n.modal-yellow-100 .modal-footer,\n.modal-yellow-100 .modal-header {\n    border-color: rgba(255, 238, 214, .075)\n}\n\n.modal-yellow-100 .modal-content {\n    background-color: #ffeed6;\n    color: color-yiq(#ffeed6)\n}\n\n.modal-yellow-100 .modal-content .heading {\n    color: color-yiq(#ffeed6)\n}\n\n.modal-yellow-100 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-yellow-200 .modal-title {\n    color: color-yiq(#f5dbb8)\n}\n\n.modal-yellow-200 .modal-footer,\n.modal-yellow-200 .modal-header {\n    border-color: rgba(245, 219, 184, .075)\n}\n\n.modal-yellow-200 .modal-content {\n    background-color: #f5dbb8;\n    color: color-yiq(#f5dbb8)\n}\n\n.modal-yellow-200 .modal-content .heading {\n    color: color-yiq(#f5dbb8)\n}\n\n.modal-yellow-200 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-50 .modal-title {\n    color: color-yiq(#f9fafb)\n}\n\n.modal-gray-50 .modal-footer,\n.modal-gray-50 .modal-header {\n    border-color: rgba(249, 250, 251, .075)\n}\n\n.modal-gray-50 .modal-content {\n    background-color: #f9fafb;\n    color: color-yiq(#f9fafb)\n}\n\n.modal-gray-50 .modal-content .heading {\n    color: color-yiq(#f9fafb)\n}\n\n.modal-gray-50 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-100 .modal-title {\n    color: color-yiq(#f2f4f6)\n}\n\n.modal-gray-100 .modal-footer,\n.modal-gray-100 .modal-header {\n    border-color: rgba(242, 244, 246, .075)\n}\n\n.modal-gray-100 .modal-content {\n    background-color: #f2f4f6;\n    color: color-yiq(#f2f4f6)\n}\n\n.modal-gray-100 .modal-content .heading {\n    color: color-yiq(#f2f4f6)\n}\n\n.modal-gray-100 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-200 .modal-title {\n    color: color-yiq(#e5e7eb)\n}\n\n.modal-gray-200 .modal-footer,\n.modal-gray-200 .modal-header {\n    border-color: rgba(229, 231, 235, .075)\n}\n\n.modal-gray-200 .modal-content {\n    background-color: #e5e7eb;\n    color: color-yiq(#e5e7eb)\n}\n\n.modal-gray-200 .modal-content .heading {\n    color: color-yiq(#e5e7eb)\n}\n\n.modal-gray-200 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-300 .modal-title {\n    color: color-yiq(#d1d5db)\n}\n\n.modal-gray-300 .modal-footer,\n.modal-gray-300 .modal-header {\n    border-color: rgba(209, 213, 219, .075)\n}\n\n.modal-gray-300 .modal-content {\n    background-color: #d1d5db;\n    color: color-yiq(#d1d5db)\n}\n\n.modal-gray-300 .modal-content .heading {\n    color: color-yiq(#d1d5db)\n}\n\n.modal-gray-300 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-400 .modal-title {\n    color: color-yiq(#9ca3af)\n}\n\n.modal-gray-400 .modal-footer,\n.modal-gray-400 .modal-header {\n    border-color: rgba(156, 163, 175, .075)\n}\n\n.modal-gray-400 .modal-content {\n    background-color: #9ca3af;\n    color: color-yiq(#9ca3af)\n}\n\n.modal-gray-400 .modal-content .heading {\n    color: color-yiq(#9ca3af)\n}\n\n.modal-gray-400 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-500 .modal-title {\n    color: color-yiq(#6b7280)\n}\n\n.modal-gray-500 .modal-footer,\n.modal-gray-500 .modal-header {\n    border-color: rgba(107, 114, 128, .075)\n}\n\n.modal-gray-500 .modal-content {\n    background-color: #6b7280;\n    color: color-yiq(#6b7280)\n}\n\n.modal-gray-500 .modal-content .heading {\n    color: color-yiq(#6b7280)\n}\n\n.modal-gray-500 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-600 .modal-title {\n    color: color-yiq(#4b5563)\n}\n\n.modal-gray-600 .modal-footer,\n.modal-gray-600 .modal-header {\n    border-color: rgba(75, 85, 99, .075)\n}\n\n.modal-gray-600 .modal-content {\n    background-color: #4b5563;\n    color: color-yiq(#4b5563)\n}\n\n.modal-gray-600 .modal-content .heading {\n    color: color-yiq(#4b5563)\n}\n\n.modal-gray-600 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-700 .modal-title {\n    color: color-yiq(#374151)\n}\n\n.modal-gray-700 .modal-footer,\n.modal-gray-700 .modal-header {\n    border-color: rgba(55, 65, 81, .075)\n}\n\n.modal-gray-700 .modal-content {\n    background-color: #374151;\n    color: color-yiq(#374151)\n}\n\n.modal-gray-700 .modal-content .heading {\n    color: color-yiq(#374151)\n}\n\n.modal-gray-700 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-800 .modal-title {\n    color: color-yiq(#1f2937)\n}\n\n.modal-gray-800 .modal-footer,\n.modal-gray-800 .modal-header {\n    border-color: rgba(31, 41, 55, .075)\n}\n\n.modal-gray-800 .modal-content {\n    background-color: #1f2937;\n    color: color-yiq(#1f2937)\n}\n\n.modal-gray-800 .modal-content .heading {\n    color: color-yiq(#1f2937)\n}\n\n.modal-gray-800 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.modal-gray-900 .modal-title {\n    color: color-yiq(#111827)\n}\n\n.modal-gray-900 .modal-footer,\n.modal-gray-900 .modal-header {\n    border-color: rgba(17, 24, 39, .075)\n}\n\n.modal-gray-900 .modal-content {\n    background-color: #111827;\n    color: color-yiq(#111827)\n}\n\n.modal-gray-900 .modal-content .heading {\n    color: color-yiq(#111827)\n}\n\n.modal-gray-900 .close > span:not(.sr-only) {\n    color: #fff\n}\n\n.nav-link {\n    color: #1f2937\n}\n\n.nav-link.active,\n.nav-link:hover {\n    color: #1f2937\n}\n\n.nav-link.active img,\n.nav-link:hover img {\n    opacity: inherit;\n    transition: all .2s ease\n}\n\n.nav-link span {\n    position: relative\n}\n\n.nav-tabs .nav-item {\n    margin-bottom: 0\n}\n\n.nav-tabs .nav-link {\n    border: 0;\n    padding: 1rem 1rem;\n    background-color: #fff\n}\n\n.nav-tabs .nav-link.active {\n    color: #fff;\n    background-color: #1f2937\n}\n\n.nav-tabs.nav-dark .nav-link.active {\n    color: #fff;\n    background-color: #12358a\n}\n\n.nav-tabs.nav-light .nav-link.active {\n    color: #111827;\n    background-color: #9ca3af\n}\n\n.nav-tabs.nav-light .nav-link:hover {\n    color: #111827\n}\n\n.nav-pills .nav-item:not(:last-child) {\n    padding-right: 1rem\n}\n\n.nav-pills .nav-link {\n    padding: .75rem .85rem;\n    transition: all .2s ease;\n    box-shadow: none;\n    border: 1px solid #9ca3af\n}\n\n.nav-pills .nav-link.avatar-link {\n    border: 0\n}\n\n.nav-pills .nav-link:hover {\n    color: #1f2937\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n    color: #1f2937;\n    background-color: #f8f8f8;\n    border-color: #1f2937\n}\n\n.nav-pills.rounded .nav-link {\n    border-radius: 30px\n}\n\n.nav-pills.rounded.vertical-tab .nav-link {\n    margin-bottom: .625rem;\n    min-width: 100px\n}\n\n.nav-pills.rounded.vertical-tab .nav-item:not(:last-child) {\n    padding-right: 0\n}\n\n.nav-pills.bordered-pill-md .nav-link {\n    border: .125rem solid #e5e7eb;\n    font-weight: 500\n}\n\n.nav-pills.vertical-tab .nav-link {\n    margin-bottom: .625rem\n}\n\n.nav-pills.vertical-tab .nav-item:not(:last-child) {\n    padding-right: 0\n}\n\n.nav-pills .nav-item {\n    margin-bottom: 1rem\n}\n\n@media (max-width: 575.98px) {\n    .nav-pills:not(.nav-pills-circle) .nav-item {\n        padding-right: 0\n    }\n}\n\n.nav-pill-circle .nav-link {\n    display: flex;\n    text-align: center;\n    height: 80px;\n    width: 80px;\n    padding: 0;\n    box-shadow: none;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center\n}\n\n.nav-pill-circle .nav-link.avatar-link {\n    box-shadow: none\n}\n\n.nav-pill-circle.vertical-tab .nav-link-icon i,\n.nav-pill-circle.vertical-tab .nav-link-icon svg {\n    font-size: 1.5rem\n}\n\n.nav-pill-circle.vertical-tab .nav-item:not(:last-child) {\n    padding-right: 0\n}\n\n.nav-pill-circle .nav-link-icon i,\n.nav-pill-circle .nav-link-icon svg {\n    font-size: 1.25rem;\n    margin: 0;\n    display: block\n}\n\n.nav-pill-square .nav-link {\n    text-align: center;\n    min-width: 80px;\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n    justify-content: center\n}\n\n.nav-pill-square.vertical-tab .nav-link {\n    margin-bottom: .625rem;\n    min-width: 100px\n}\n\n.nav-pill-square.vertical-tab .nav-item:not(:last-child) {\n    padding-right: 0\n}\n\n.nav-pill-square .nav-link-icon i,\n.nav-pill-square .nav-link-icon svg {\n    font-size: 1.25rem;\n    margin: 0;\n    display: block;\n    line-height: 50px\n}\n\n.nav-wrapper {\n    padding: 1rem 0;\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem\n}\n\n.nav-wrapper + .card {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem\n}\n\n.tab-content > .tab-pane {\n    display: none\n}\n\n.tab-content > .tab-pane pre {\n    padding: 0;\n    margin: 0\n}\n\n.tab-content > .active {\n    display: block\n}\n\n@media (min-width: 992px) {\n    .nav-pills .nav-item {\n        margin-bottom: 0\n    }\n}\n\n.circle-pagination .page-link,\n.circle-pagination span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    padding: 0;\n    border-radius: 50%\n}\n\n.dataTable-pagination-list {\n    display: flex;\n    padding-left: 0;\n    list-style: none\n}\n\n.dataTable-pagination-list li > a {\n    position: relative;\n    display: block;\n    color: #1f2937;\n    background-color: #fff;\n    border: .0625rem solid #9ca3af;\n    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .dataTable-pagination-list li > a {\n        transition: none\n    }\n}\n\n.dataTable-pagination-list li > a:hover {\n    z-index: 2;\n    color: #000;\n    background-color: #e5e7eb;\n    border-color: #d1d5db\n}\n\n.dataTable-pagination-list li > a:focus {\n    z-index: 3;\n    color: #000;\n    background-color: #e5e7eb;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.dataTable-pagination-list li:not(:first-child) a {\n    margin-left: -.0625rem\n}\n\n.dataTable-pagination-list li.active a {\n    z-index: 3;\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.dataTable-pagination-list li.disabled a {\n    color: #4b5563;\n    pointer-events: none;\n    background-color: #fff;\n    border-color: #d1d5db\n}\n\n.popover {\n    border: 0\n}\n\n.popover-header {\n    font-weight: 500\n}\n\n.popover-primary {\n    background-color: #1f2937\n}\n\n.popover-primary .popover-header {\n    background-color: #1f2937;\n    color: color-yiq(#1f2937)\n}\n\n.popover-primary .popover-body {\n    color: color-yiq(#1f2937)\n}\n\n.popover-primary .popover-header {\n    border-color: rgba(31, 41, 55, .2)\n}\n\n.popover-primary.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-primary.bs-popover-top .arrow::after {\n    border-top-color: #1f2937\n}\n\n.popover-primary.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-primary.bs-popover-end .arrow::after {\n    border-right-color: #1f2937\n}\n\n.popover-primary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-primary.bs-popover-bottom .arrow::after {\n    border-bottom-color: #1f2937\n}\n\n.popover-primary.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-primary.bs-popover-start .arrow::after {\n    border-left-color: #1f2937\n}\n\n.popover-secondary {\n    background-color: #f0bc74\n}\n\n.popover-secondary .popover-header {\n    background-color: #f0bc74;\n    color: color-yiq(#f0bc74)\n}\n\n.popover-secondary .popover-body {\n    color: color-yiq(#f0bc74)\n}\n\n.popover-secondary .popover-header {\n    border-color: rgba(240, 188, 116, .2)\n}\n\n.popover-secondary.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-secondary.bs-popover-top .arrow::after {\n    border-top-color: #f0bc74\n}\n\n.popover-secondary.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-secondary.bs-popover-end .arrow::after {\n    border-right-color: #f0bc74\n}\n\n.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-secondary.bs-popover-bottom .arrow::after {\n    border-bottom-color: #f0bc74\n}\n\n.popover-secondary.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-secondary.bs-popover-start .arrow::after {\n    border-left-color: #f0bc74\n}\n\n.popover-tertiary {\n    background-color: #31316a\n}\n\n.popover-tertiary .popover-header {\n    background-color: #31316a;\n    color: color-yiq(#31316a)\n}\n\n.popover-tertiary .popover-body {\n    color: color-yiq(#31316a)\n}\n\n.popover-tertiary .popover-header {\n    border-color: rgba(49, 49, 106, .2)\n}\n\n.popover-tertiary.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-tertiary.bs-popover-top .arrow::after {\n    border-top-color: #31316a\n}\n\n.popover-tertiary.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-tertiary.bs-popover-end .arrow::after {\n    border-right-color: #31316a\n}\n\n.popover-tertiary.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-tertiary.bs-popover-bottom .arrow::after {\n    border-bottom-color: #31316a\n}\n\n.popover-tertiary.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-tertiary.bs-popover-start .arrow::after {\n    border-left-color: #31316a\n}\n\n.popover-success {\n    background-color: #10b981\n}\n\n.popover-success .popover-header {\n    background-color: #10b981;\n    color: color-yiq(#10b981)\n}\n\n.popover-success .popover-body {\n    color: color-yiq(#10b981)\n}\n\n.popover-success .popover-header {\n    border-color: rgba(16, 185, 129, .2)\n}\n\n.popover-success.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-success.bs-popover-top .arrow::after {\n    border-top-color: #10b981\n}\n\n.popover-success.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-success.bs-popover-end .arrow::after {\n    border-right-color: #10b981\n}\n\n.popover-success.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-success.bs-popover-bottom .arrow::after {\n    border-bottom-color: #10b981\n}\n\n.popover-success.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-success.bs-popover-start .arrow::after {\n    border-left-color: #10b981\n}\n\n.popover-info {\n    background-color: #2361ce\n}\n\n.popover-info .popover-header {\n    background-color: #2361ce;\n    color: color-yiq(#2361ce)\n}\n\n.popover-info .popover-body {\n    color: color-yiq(#2361ce)\n}\n\n.popover-info .popover-header {\n    border-color: rgba(35, 97, 206, .2)\n}\n\n.popover-info.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-info.bs-popover-top .arrow::after {\n    border-top-color: #2361ce\n}\n\n.popover-info.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-info.bs-popover-end .arrow::after {\n    border-right-color: #2361ce\n}\n\n.popover-info.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-info.bs-popover-bottom .arrow::after {\n    border-bottom-color: #2361ce\n}\n\n.popover-info.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-info.bs-popover-start .arrow::after {\n    border-left-color: #2361ce\n}\n\n.popover-warning {\n    background-color: #fba918\n}\n\n.popover-warning .popover-header {\n    background-color: #fba918;\n    color: color-yiq(#fba918)\n}\n\n.popover-warning .popover-body {\n    color: color-yiq(#fba918)\n}\n\n.popover-warning .popover-header {\n    border-color: rgba(251, 169, 24, .2)\n}\n\n.popover-warning.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-warning.bs-popover-top .arrow::after {\n    border-top-color: #fba918\n}\n\n.popover-warning.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-warning.bs-popover-end .arrow::after {\n    border-right-color: #fba918\n}\n\n.popover-warning.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-warning.bs-popover-bottom .arrow::after {\n    border-bottom-color: #fba918\n}\n\n.popover-warning.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-warning.bs-popover-start .arrow::after {\n    border-left-color: #fba918\n}\n\n.popover-danger {\n    background-color: #e11d48\n}\n\n.popover-danger .popover-header {\n    background-color: #e11d48;\n    color: color-yiq(#e11d48)\n}\n\n.popover-danger .popover-body {\n    color: color-yiq(#e11d48)\n}\n\n.popover-danger .popover-header {\n    border-color: rgba(225, 29, 72, .2)\n}\n\n.popover-danger.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-danger.bs-popover-top .arrow::after {\n    border-top-color: #e11d48\n}\n\n.popover-danger.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-danger.bs-popover-end .arrow::after {\n    border-right-color: #e11d48\n}\n\n.popover-danger.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-danger.bs-popover-bottom .arrow::after {\n    border-bottom-color: #e11d48\n}\n\n.popover-danger.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-danger.bs-popover-start .arrow::after {\n    border-left-color: #e11d48\n}\n\n.popover-white {\n    background-color: #fff\n}\n\n.popover-white .popover-header {\n    background-color: #fff;\n    color: color-yiq(#fff)\n}\n\n.popover-white .popover-body {\n    color: color-yiq(#fff)\n}\n\n.popover-white .popover-header {\n    border-color: rgba(255, 255, 255, .2)\n}\n\n.popover-white.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-white.bs-popover-top .arrow::after {\n    border-top-color: #fff\n}\n\n.popover-white.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-white.bs-popover-end .arrow::after {\n    border-right-color: #fff\n}\n\n.popover-white.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-white.bs-popover-bottom .arrow::after {\n    border-bottom-color: #fff\n}\n\n.popover-white.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-white.bs-popover-start .arrow::after {\n    border-left-color: #fff\n}\n\n.popover-indigo {\n    background-color: #4f46e5\n}\n\n.popover-indigo .popover-header {\n    background-color: #4f46e5;\n    color: color-yiq(#4f46e5)\n}\n\n.popover-indigo .popover-body {\n    color: color-yiq(#4f46e5)\n}\n\n.popover-indigo .popover-header {\n    border-color: rgba(79, 70, 229, .2)\n}\n\n.popover-indigo.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-indigo.bs-popover-top .arrow::after {\n    border-top-color: #4f46e5\n}\n\n.popover-indigo.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-indigo.bs-popover-end .arrow::after {\n    border-right-color: #4f46e5\n}\n\n.popover-indigo.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-indigo.bs-popover-bottom .arrow::after {\n    border-bottom-color: #4f46e5\n}\n\n.popover-indigo.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-indigo.bs-popover-start .arrow::after {\n    border-left-color: #4f46e5\n}\n\n.popover-purple {\n    background-color: #7c3aed\n}\n\n.popover-purple .popover-header {\n    background-color: #7c3aed;\n    color: color-yiq(#7c3aed)\n}\n\n.popover-purple .popover-body {\n    color: color-yiq(#7c3aed)\n}\n\n.popover-purple .popover-header {\n    border-color: rgba(124, 58, 237, .2)\n}\n\n.popover-purple.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-purple.bs-popover-top .arrow::after {\n    border-top-color: #7c3aed\n}\n\n.popover-purple.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-purple.bs-popover-end .arrow::after {\n    border-right-color: #7c3aed\n}\n\n.popover-purple.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-purple.bs-popover-bottom .arrow::after {\n    border-bottom-color: #7c3aed\n}\n\n.popover-purple.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-purple.bs-popover-start .arrow::after {\n    border-left-color: #7c3aed\n}\n\n.popover-yellow-100 {\n    background-color: #ffeed6\n}\n\n.popover-yellow-100 .popover-header {\n    background-color: #ffeed6;\n    color: color-yiq(#ffeed6)\n}\n\n.popover-yellow-100 .popover-body {\n    color: color-yiq(#ffeed6)\n}\n\n.popover-yellow-100 .popover-header {\n    border-color: rgba(255, 238, 214, .2)\n}\n\n.popover-yellow-100.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-yellow-100.bs-popover-top .arrow::after {\n    border-top-color: #ffeed6\n}\n\n.popover-yellow-100.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-yellow-100.bs-popover-end .arrow::after {\n    border-right-color: #ffeed6\n}\n\n.popover-yellow-100.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-yellow-100.bs-popover-bottom .arrow::after {\n    border-bottom-color: #ffeed6\n}\n\n.popover-yellow-100.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-yellow-100.bs-popover-start .arrow::after {\n    border-left-color: #ffeed6\n}\n\n.popover-yellow-200 {\n    background-color: #f5dbb8\n}\n\n.popover-yellow-200 .popover-header {\n    background-color: #f5dbb8;\n    color: color-yiq(#f5dbb8)\n}\n\n.popover-yellow-200 .popover-body {\n    color: color-yiq(#f5dbb8)\n}\n\n.popover-yellow-200 .popover-header {\n    border-color: rgba(245, 219, 184, .2)\n}\n\n.popover-yellow-200.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-yellow-200.bs-popover-top .arrow::after {\n    border-top-color: #f5dbb8\n}\n\n.popover-yellow-200.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-yellow-200.bs-popover-end .arrow::after {\n    border-right-color: #f5dbb8\n}\n\n.popover-yellow-200.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-yellow-200.bs-popover-bottom .arrow::after {\n    border-bottom-color: #f5dbb8\n}\n\n.popover-yellow-200.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-yellow-200.bs-popover-start .arrow::after {\n    border-left-color: #f5dbb8\n}\n\n.popover-gray-50 {\n    background-color: #f9fafb\n}\n\n.popover-gray-50 .popover-header {\n    background-color: #f9fafb;\n    color: color-yiq(#f9fafb)\n}\n\n.popover-gray-50 .popover-body {\n    color: color-yiq(#f9fafb)\n}\n\n.popover-gray-50 .popover-header {\n    border-color: rgba(249, 250, 251, .2)\n}\n\n.popover-gray-50.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-50.bs-popover-top .arrow::after {\n    border-top-color: #f9fafb\n}\n\n.popover-gray-50.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-50.bs-popover-end .arrow::after {\n    border-right-color: #f9fafb\n}\n\n.popover-gray-50.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-50.bs-popover-bottom .arrow::after {\n    border-bottom-color: #f9fafb\n}\n\n.popover-gray-50.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-50.bs-popover-start .arrow::after {\n    border-left-color: #f9fafb\n}\n\n.popover-gray-100 {\n    background-color: #f2f4f6\n}\n\n.popover-gray-100 .popover-header {\n    background-color: #f2f4f6;\n    color: color-yiq(#f2f4f6)\n}\n\n.popover-gray-100 .popover-body {\n    color: color-yiq(#f2f4f6)\n}\n\n.popover-gray-100 .popover-header {\n    border-color: rgba(242, 244, 246, .2)\n}\n\n.popover-gray-100.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-100.bs-popover-top .arrow::after {\n    border-top-color: #f2f4f6\n}\n\n.popover-gray-100.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-100.bs-popover-end .arrow::after {\n    border-right-color: #f2f4f6\n}\n\n.popover-gray-100.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-100.bs-popover-bottom .arrow::after {\n    border-bottom-color: #f2f4f6\n}\n\n.popover-gray-100.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-100.bs-popover-start .arrow::after {\n    border-left-color: #f2f4f6\n}\n\n.popover-gray-200 {\n    background-color: #e5e7eb\n}\n\n.popover-gray-200 .popover-header {\n    background-color: #e5e7eb;\n    color: color-yiq(#e5e7eb)\n}\n\n.popover-gray-200 .popover-body {\n    color: color-yiq(#e5e7eb)\n}\n\n.popover-gray-200 .popover-header {\n    border-color: rgba(229, 231, 235, .2)\n}\n\n.popover-gray-200.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-200.bs-popover-top .arrow::after {\n    border-top-color: #e5e7eb\n}\n\n.popover-gray-200.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-200.bs-popover-end .arrow::after {\n    border-right-color: #e5e7eb\n}\n\n.popover-gray-200.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-200.bs-popover-bottom .arrow::after {\n    border-bottom-color: #e5e7eb\n}\n\n.popover-gray-200.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-200.bs-popover-start .arrow::after {\n    border-left-color: #e5e7eb\n}\n\n.popover-gray-300 {\n    background-color: #d1d5db\n}\n\n.popover-gray-300 .popover-header {\n    background-color: #d1d5db;\n    color: color-yiq(#d1d5db)\n}\n\n.popover-gray-300 .popover-body {\n    color: color-yiq(#d1d5db)\n}\n\n.popover-gray-300 .popover-header {\n    border-color: rgba(209, 213, 219, .2)\n}\n\n.popover-gray-300.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-300.bs-popover-top .arrow::after {\n    border-top-color: #d1d5db\n}\n\n.popover-gray-300.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-300.bs-popover-end .arrow::after {\n    border-right-color: #d1d5db\n}\n\n.popover-gray-300.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-300.bs-popover-bottom .arrow::after {\n    border-bottom-color: #d1d5db\n}\n\n.popover-gray-300.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-300.bs-popover-start .arrow::after {\n    border-left-color: #d1d5db\n}\n\n.popover-gray-400 {\n    background-color: #9ca3af\n}\n\n.popover-gray-400 .popover-header {\n    background-color: #9ca3af;\n    color: color-yiq(#9ca3af)\n}\n\n.popover-gray-400 .popover-body {\n    color: color-yiq(#9ca3af)\n}\n\n.popover-gray-400 .popover-header {\n    border-color: rgba(156, 163, 175, .2)\n}\n\n.popover-gray-400.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-400.bs-popover-top .arrow::after {\n    border-top-color: #9ca3af\n}\n\n.popover-gray-400.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-400.bs-popover-end .arrow::after {\n    border-right-color: #9ca3af\n}\n\n.popover-gray-400.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-400.bs-popover-bottom .arrow::after {\n    border-bottom-color: #9ca3af\n}\n\n.popover-gray-400.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-400.bs-popover-start .arrow::after {\n    border-left-color: #9ca3af\n}\n\n.popover-gray-500 {\n    background-color: #6b7280\n}\n\n.popover-gray-500 .popover-header {\n    background-color: #6b7280;\n    color: color-yiq(#6b7280)\n}\n\n.popover-gray-500 .popover-body {\n    color: color-yiq(#6b7280)\n}\n\n.popover-gray-500 .popover-header {\n    border-color: rgba(107, 114, 128, .2)\n}\n\n.popover-gray-500.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-500.bs-popover-top .arrow::after {\n    border-top-color: #6b7280\n}\n\n.popover-gray-500.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-500.bs-popover-end .arrow::after {\n    border-right-color: #6b7280\n}\n\n.popover-gray-500.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-500.bs-popover-bottom .arrow::after {\n    border-bottom-color: #6b7280\n}\n\n.popover-gray-500.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-500.bs-popover-start .arrow::after {\n    border-left-color: #6b7280\n}\n\n.popover-gray-600 {\n    background-color: #4b5563\n}\n\n.popover-gray-600 .popover-header {\n    background-color: #4b5563;\n    color: color-yiq(#4b5563)\n}\n\n.popover-gray-600 .popover-body {\n    color: color-yiq(#4b5563)\n}\n\n.popover-gray-600 .popover-header {\n    border-color: rgba(75, 85, 99, .2)\n}\n\n.popover-gray-600.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-600.bs-popover-top .arrow::after {\n    border-top-color: #4b5563\n}\n\n.popover-gray-600.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-600.bs-popover-end .arrow::after {\n    border-right-color: #4b5563\n}\n\n.popover-gray-600.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-600.bs-popover-bottom .arrow::after {\n    border-bottom-color: #4b5563\n}\n\n.popover-gray-600.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-600.bs-popover-start .arrow::after {\n    border-left-color: #4b5563\n}\n\n.popover-gray-700 {\n    background-color: #374151\n}\n\n.popover-gray-700 .popover-header {\n    background-color: #374151;\n    color: color-yiq(#374151)\n}\n\n.popover-gray-700 .popover-body {\n    color: color-yiq(#374151)\n}\n\n.popover-gray-700 .popover-header {\n    border-color: rgba(55, 65, 81, .2)\n}\n\n.popover-gray-700.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-700.bs-popover-top .arrow::after {\n    border-top-color: #374151\n}\n\n.popover-gray-700.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-700.bs-popover-end .arrow::after {\n    border-right-color: #374151\n}\n\n.popover-gray-700.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-700.bs-popover-bottom .arrow::after {\n    border-bottom-color: #374151\n}\n\n.popover-gray-700.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-700.bs-popover-start .arrow::after {\n    border-left-color: #374151\n}\n\n.popover-gray-800 {\n    background-color: #1f2937\n}\n\n.popover-gray-800 .popover-header {\n    background-color: #1f2937;\n    color: color-yiq(#1f2937)\n}\n\n.popover-gray-800 .popover-body {\n    color: color-yiq(#1f2937)\n}\n\n.popover-gray-800 .popover-header {\n    border-color: rgba(31, 41, 55, .2)\n}\n\n.popover-gray-800.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-800.bs-popover-top .arrow::after {\n    border-top-color: #1f2937\n}\n\n.popover-gray-800.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-800.bs-popover-end .arrow::after {\n    border-right-color: #1f2937\n}\n\n.popover-gray-800.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-800.bs-popover-bottom .arrow::after {\n    border-bottom-color: #1f2937\n}\n\n.popover-gray-800.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-800.bs-popover-start .arrow::after {\n    border-left-color: #1f2937\n}\n\n.popover-gray-900 {\n    background-color: #111827\n}\n\n.popover-gray-900 .popover-header {\n    background-color: #111827;\n    color: color-yiq(#111827)\n}\n\n.popover-gray-900 .popover-body {\n    color: color-yiq(#111827)\n}\n\n.popover-gray-900 .popover-header {\n    border-color: rgba(17, 24, 39, .2)\n}\n\n.popover-gray-900.bs-popover-auto[data-popper-placement^=top] .arrow::after,\n.popover-gray-900.bs-popover-top .arrow::after {\n    border-top-color: #111827\n}\n\n.popover-gray-900.bs-popover-auto[data-popper-placement^=right] .arrow::after,\n.popover-gray-900.bs-popover-end .arrow::after {\n    border-right-color: #111827\n}\n\n.popover-gray-900.bs-popover-auto[data-popper-placement^=bottom] .arrow::after,\n.popover-gray-900.bs-popover-bottom .arrow::after {\n    border-bottom-color: #111827\n}\n\n.popover-gray-900.bs-popover-auto[data-popper-placement^=left] .arrow::after,\n.popover-gray-900.bs-popover-start .arrow::after {\n    border-left-color: #111827\n}\n\n.progress-wrapper {\n    position: relative\n}\n\n.progress-bar {\n    box-shadow: none;\n    border-radius: 0;\n    height: auto\n}\n\n.progress {\n    height: 6px;\n    margin-bottom: 1rem;\n    overflow: hidden;\n    background-color: #e5e7eb;\n    font-size: .75rem;\n    font-weight: 500;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1)\n}\n\n.progress-xl {\n    height: .8rem\n}\n\n.progress-lg {\n    height: .6rem\n}\n\n.progress-sm {\n    height: .2rem\n}\n\n.progress-info {\n    display: flex;\n    -moz-align-items: center;\n    -ms-align-items: center;\n    align-items: center;\n    -moz-justify-content: space-between;\n    -ms-justify-content: space-between;\n    justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: .5rem\n}\n\n.progress-info .progress-label span {\n    display: inline-block;\n    color: #1f2937;\n    font-size: .875rem;\n    font-weight: 500\n}\n\n.progress-info .progress-percentage {\n    text-align: right\n}\n\n.progress-info .progress-percentage span {\n    display: inline-block;\n    color: #6b7280;\n    font-size: .75rem;\n    font-weight: 500\n}\n\n.info-xl .progress-label span,\n.info-xl .progress-percentage span {\n    font-size: .875rem\n}\n\n.info-xl .progress-percentage {\n    text-align: right\n}\n\n.progress-tooltip {\n    background: #1f2937;\n    color: #fff;\n    font-weight: 500;\n    padding: .25rem .375rem;\n    line-height: 1;\n    font-size: .75rem;\n    position: relative;\n    border-radius: .35rem\n}\n\n.progress-tooltip:after {\n    content: \" \";\n    position: absolute;\n    top: 100%;\n    left: 10px;\n    border: solid transparent;\n    height: 0;\n    width: 0;\n    pointer-events: none;\n    border-top-color: #111827;\n    border-width: 6px\n}\n\n@keyframes animate-positive {\n    0% {\n        width: 0%\n    }\n}\n\n.progress-info .bg-primary::after {\n    border-top-color: #1f2937\n}\n\n.progress-info .bg-secondary::after {\n    border-top-color: #f0bc74\n}\n\n.progress-info .bg-tertiary::after {\n    border-top-color: #31316a\n}\n\n.progress-info .bg-success::after {\n    border-top-color: #10b981\n}\n\n.progress-info .bg-info::after {\n    border-top-color: #2361ce\n}\n\n.progress-info .bg-warning::after {\n    border-top-color: #fba918\n}\n\n.progress-info .bg-danger::after {\n    border-top-color: #e11d48\n}\n\n.progress-info .bg-white::after {\n    border-top-color: #fff\n}\n\n.progress-info .bg-indigo::after {\n    border-top-color: #4f46e5\n}\n\n.progress-info .bg-purple::after {\n    border-top-color: #7c3aed\n}\n\n.progress-info .bg-yellow-100::after {\n    border-top-color: #ffeed6\n}\n\n.progress-info .bg-yellow-200::after {\n    border-top-color: #f5dbb8\n}\n\n.progress-info .bg-gray-50::after {\n    border-top-color: #f9fafb\n}\n\n.progress-info .bg-gray-100::after {\n    border-top-color: #f2f4f6\n}\n\n.progress-info .bg-gray-200::after {\n    border-top-color: #e5e7eb\n}\n\n.progress-info .bg-gray-300::after {\n    border-top-color: #d1d5db\n}\n\n.progress-info .bg-gray-400::after {\n    border-top-color: #9ca3af\n}\n\n.progress-info .bg-gray-500::after {\n    border-top-color: #6b7280\n}\n\n.progress-info .bg-gray-600::after {\n    border-top-color: #4b5563\n}\n\n.progress-info .bg-gray-700::after {\n    border-top-color: #374151\n}\n\n.progress-info .bg-gray-800::after {\n    border-top-color: #1f2937\n}\n\n.progress-info .bg-gray-900::after {\n    border-top-color: #111827\n}\n\n.choices__inner {\n    background-color: #fff;\n    border-color: #d1d5db;\n    border-radius: .5rem\n}\n\n.choices__list.choices__list--dropdown {\n    border-color: #d1d5db;\n    margin-top: .5rem;\n    border-radius: .5rem;\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n}\n\n.choices .is-open .choices__inner,\n.choices.is-focused .choices__inner {\n    background-color: #fff;\n    border-color: #d1d5db;\n    border-radius: .5rem\n}\n\n.choices__list--multiple .choices__item.is-highlighted {\n    background-color: #e5e7eb;\n    border-color: #d1d5db\n}\n\n.is-disabled .choices__list--multiple .choices__item {\n    background-color: #9ca3af;\n    border-color: #d1d5db\n}\n\n.choices__list--dropdown .choices__item--selectable.is-highlighted {\n    background-color: #e5e7eb\n}\n\n.choices__input {\n    background-color: transparent\n}\n\n.choices__list--multiple .choices__item {\n    background-color: #1f2937;\n    border: 0;\n    border-radius: .5rem\n}\n\n.avatar-sm {\n    width: 1.5rem;\n    height: 1.5rem\n}\n\n.avatar-md {\n    width: 3rem;\n    height: 3rem\n}\n\n.avatar-lg {\n    width: 4.5rem;\n    height: 4.5rem\n}\n\n.step {\n    position: relative;\n    margin-bottom: 4rem;\n    border-radius: 6px\n}\n\n.step .step-shape {\n    display: inline-flex;\n    width: 7rem;\n    height: 7rem;\n    text-align: center;\n    -moz-align-items: center;\n    -ms-align-items: center;\n    align-items: center;\n    -moz-justify-content: center;\n    -ms-justify-content: center;\n    justify-content: center;\n    -ms-flex-pack: center\n}\n\n.step .step-shape i,\n.step .step-shape svg {\n    font-size: 2rem\n}\n\n.step .step-shape .step-number {\n    position: absolute;\n    font-weight: 500;\n    top: -10px;\n    width: 32px;\n    height: 32px;\n    border-width: .125rem;\n    border-style: solid;\n    line-height: 1.7\n}\n\n.step .step-shape.bordered {\n    border-width: .125rem;\n    border-style: solid\n}\n\n.step .step-shape.bordered .step-number {\n    background-color: #fff;\n    top: -12px\n}\n\n.step .step-shape.rounded-circle .step-number {\n    margin-right: 1.275rem\n}\n\n.step .icon-lg {\n    font-size: 4.5rem\n}\n\n.step .back-layer {\n    display: flex;\n    position: absolute;\n    font-size: 12rem;\n    z-index: 0;\n    top: 0\n}\n\n.table thead th {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n    font-size: .75rem;\n    text-transform: uppercase;\n    font-weight: 600;\n    border-top: 0\n}\n\n.table th {\n    font-weight: 500;\n    padding: 1rem\n}\n\n.table td .progress {\n    height: 3px;\n    width: 120px;\n    margin: 0\n}\n\n.table td,\n.table th {\n    font-size: .875rem;\n    /* ceyhun white-space: nowrap */\n}\n\n.table.user-table thead th {\n    border-top: 0\n}\n\n.table.align-items-center td,\n.table.align-items-center th {\n    vertical-align: middle\n}\n\n.table .thead-dark th {\n    background-color: #1f2937;\n    color: #fff\n}\n\n.table .thead-dark th a {\n    color: #1f2937\n}\n\n.table .thead-light th {\n    background-color: #f2f4f6;\n    color: #1f2937\n}\n\n.table .thead-light th a {\n    color: #1f2937\n}\n\n.table-hover tr {\n    transition: all .2s ease\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .table-hover tr {\n        transition: none\n    }\n}\n\n.table-flush td,\n.table-flush th {\n    border-left: 0;\n    border-right: 0\n}\n\n.table-flush tbody tr:first-child td,\n.table-flush tbody tr:first-child th {\n    border-top: 0\n}\n\n.table-flush tbody tr:last-child td,\n.table-flush tbody tr:last-child th {\n    border-bottom: 0\n}\n\n.card .table {\n    margin-bottom: 0\n}\n\n.card .table td,\n.card .table th {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem\n}\n\n.table [data-sort] {\n    cursor: pointer\n}\n\n.table .custom-toggle {\n    display: block\n}\n\n.table .thead-dark [data-sort]::after {\n    content: url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='%231F2937'/></svg>\");\n    margin-left: .25rem\n}\n\n.table .thead-light [data-sort]::after {\n    content: url(\"data:image/svg+xml;utf8,<svg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M3 0L6 4H0L3 0ZM3 10L0 6H6L3 10Z' fill='%231F2937'/></svg>\");\n    margin-left: .25rem\n}\n\n.dataTables_wrapper .dataTables_info {\n    padding-left: 1.5rem\n}\n\n.dataTables_wrapper .dataTables_paginate {\n    padding-right: 1.5rem\n}\n\n.dataTables_wrapper .dataTables_length label {\n    padding-left: 1.5rem\n}\n\n.dataTables_wrapper .dataTables_filter {\n    padding-right: 1.5rem\n}\n\n.dataTable-bottom,\n.dataTable-top {\n    display: flex;\n    width: 100%;\n    justify-content: space-between\n}\n\n@media (max-width: 767.98px) {\n\n    .dataTable-bottom,\n    .dataTable-top {\n        flex-direction: column\n    }\n\n    .dataTable-bottom .dataTable-info,\n    .dataTable-top .dataTable-info {\n        margin-bottom: 1rem\n    }\n}\n\n.dataTable-top {\n    padding: 0 1rem 1rem 1rem\n}\n\n.dataTable-bottom {\n    padding: 1.5rem 1rem 0 1rem\n}\n\n.dataTable-pagination {\n    display: flex;\n    padding-left: 0;\n    list-style: none\n}\n\n.dataTable-pagination a {\n    padding: .375rem .75rem\n}\n\n.dataTable-pagination li:first-child a {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem\n}\n\n.dataTable-pagination li:last-child a {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem\n}\n\n.dataTable-pagination > li:not(:first-child) a {\n    margin-left: -.0625rem\n}\n\n.dataTable-pagination > li.active a {\n    z-index: 3;\n    color: #fff;\n    background-color: #1f2937;\n    border-color: #1f2937\n}\n\n.dataTable-pagination > li.disabled a {\n    color: #4b5563;\n    pointer-events: none;\n    background-color: #fff;\n    border-color: #d1d5db\n}\n\n.dataTable-pagination > li a {\n    position: relative;\n    display: block;\n    color: #1f2937;\n    background-color: #fff;\n    border: .0625rem solid #9ca3af\n}\n\n.dataTable-pagination > li a:hover {\n    z-index: 2;\n    color: #000;\n    background-color: #e5e7eb;\n    border-color: #d1d5db\n}\n\n.dataTable-pagination > li a:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.dataTable-selector {\n    display: inline-block;\n    width: auto;\n    height: calc(1.5em + 1.125rem);\n    padding: .5rem 2rem .5rem 1rem;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6b7280;\n    vertical-align: middle;\n    background-color: #fff;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%231F2937' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n    background-repeat: no-repeat;\n    background-position: right 1rem center;\n    background-size: 16px 12px;\n    border: .0625rem solid #d1d5db;\n    border-radius: .5rem;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125);\n    -webkit-appearance: none;\n    appearance: none\n}\n\n.dataTable-selector:focus {\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: inset 0 1px 2px rgba(17, 24, 39, .0125), 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.dataTable-selector:focus::-ms-value {\n    color: #6b7280;\n    background-color: #fff\n}\n\n.dataTable-selector[multiple],\n.dataTable-selector[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: 1rem;\n    background-image: none\n}\n\n.dataTable-selector:disabled {\n    color: #4b5563;\n    background-color: #e5e7eb\n}\n\n.dataTable-selector:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #6b7280\n}\n\n.dataTable-input {\n    display: block;\n    width: 100%;\n    min-height: calc(1.5em + 1.125rem);\n    padding: .5rem 1rem;\n    font-size: .875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #6b7280;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: .0625rem solid #d1d5db;\n    -webkit-appearance: none;\n    appearance: none;\n    border-radius: .5rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .dataTable-input {\n        transition: none\n    }\n}\n\n.dataTable-input:focus {\n    color: #6b7280;\n    background-color: #fff;\n    border-color: #4d6689;\n    outline: 0;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07), 0 0 0 .18rem rgba(31, 41, 55, .25)\n}\n\n.dataTable-input::placeholder {\n    color: #4b5563;\n    opacity: 1\n}\n\n.dataTable-input:disabled,\n.dataTable-input[readonly] {\n    background-color: #e5e7eb;\n    opacity: 1\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    font-family: Inter, sans-serif;\n    font-weight: 500\n}\n\n.p,\nol li,\np,\nul li {\n    font-family: var(--bs-font-sans-serif);\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.6\n}\n\n.text-action,\na {\n    color: #1f2937;\n    transition: all .2s ease\n}\n\n.text-action:hover,\na:hover {\n    color: #000;\n    cursor: pointer\n}\n\n.lead + .btn-wrapper {\n    margin-top: 3rem\n}\n\n@media (max-width: 767.98px) {\n    .lead {\n        font-size: 1rem\n    }\n}\n\n.line-through {\n    -webkit-text-decoration: line-through;\n    text-decoration: line-through\n}\n\n.text-italic {\n    font-style: italic !important\n}\n\n.description {\n    font-size: .875rem\n}\n\n.hover\\:underline:hover {\n    text-decoration: underline\n}\n\n.heading {\n    font-size: 2rem;\n    font-weight: 500\n}\n\n@media (max-width: 767.98px) {\n    .display-2 {\n        font-size: 1.875rem\n    }\n}\n\n@media (max-width: 991.98px) {\n    .display-3 {\n        font-size: 1.875rem\n    }\n}\n\n@media (max-width: 575.98px) {\n    .display-4 {\n        font-size: 1.5rem\n    }\n}\n\n.blockquote {\n    font-style: italic\n}\n\n@media (max-width: 767.98px) {\n    .blockquote.blockquote-large {\n        font-size: 1.25rem\n    }\n}\n\n.blockquote .blockquote-footer {\n    font-size: .875rem;\n    font-weight: 600\n}\n\n@media (max-width: 767.98px) {\n    .blockquote .blockquote-footer {\n        font-size: 1.25rem\n    }\n}\n\n.font-small {\n    font-size: .875rem;\n    font-weight: 300\n}\n\n.font-base {\n    font-size: 1rem;\n    font-weight: 300\n}\n\n.font-medium {\n    font-size: 1.25rem;\n    font-weight: 300\n}\n\ncode[class*=language-],\npre[class*=language-] {\n    text-shadow: none;\n    font-family: var(--bs-font-sans-serif);\n    font-weight: 500\n}\n\n.text-primary,\n.text-primary:hover {\n    color: #1f2937 !important\n}\n\n.text-primary .display-1,\n.text-primary .display-2,\n.text-primary .display-3,\n.text-primary .display-4,\n.text-primary .h1,\n.text-primary .h2,\n.text-primary .h3,\n.text-primary .h4,\n.text-primary .h5,\n.text-primary .h6,\n.text-primary a:not(.btn),\n.text-primary h1,\n.text-primary h2,\n.text-primary h3,\n.text-primary h4,\n.text-primary h5,\n.text-primary h6 {\n    color: #1f2937\n}\n\n.text-primary .text-muted {\n    color: rgba(31, 41, 55, .7) !important\n}\n\n.text-secondary,\n.text-secondary:hover {\n    color: #f0bc74 !important\n}\n\n.text-secondary .display-1,\n.text-secondary .display-2,\n.text-secondary .display-3,\n.text-secondary .display-4,\n.text-secondary .h1,\n.text-secondary .h2,\n.text-secondary .h3,\n.text-secondary .h4,\n.text-secondary .h5,\n.text-secondary .h6,\n.text-secondary a:not(.btn),\n.text-secondary h1,\n.text-secondary h2,\n.text-secondary h3,\n.text-secondary h4,\n.text-secondary h5,\n.text-secondary h6 {\n    color: #f0bc74\n}\n\n.text-secondary .text-muted {\n    color: rgba(240, 188, 116, .7) !important\n}\n\n.text-tertiary,\n.text-tertiary:hover {\n    color: #31316a !important\n}\n\n.text-tertiary .display-1,\n.text-tertiary .display-2,\n.text-tertiary .display-3,\n.text-tertiary .display-4,\n.text-tertiary .h1,\n.text-tertiary .h2,\n.text-tertiary .h3,\n.text-tertiary .h4,\n.text-tertiary .h5,\n.text-tertiary .h6,\n.text-tertiary a:not(.btn),\n.text-tertiary h1,\n.text-tertiary h2,\n.text-tertiary h3,\n.text-tertiary h4,\n.text-tertiary h5,\n.text-tertiary h6 {\n    color: #31316a\n}\n\n.text-tertiary .text-muted {\n    color: rgba(49, 49, 106, .7) !important\n}\n\n.text-success,\n.text-success:hover {\n    color: #10b981 !important\n}\n\n.text-success .display-1,\n.text-success .display-2,\n.text-success .display-3,\n.text-success .display-4,\n.text-success .h1,\n.text-success .h2,\n.text-success .h3,\n.text-success .h4,\n.text-success .h5,\n.text-success .h6,\n.text-success a:not(.btn),\n.text-success h1,\n.text-success h2,\n.text-success h3,\n.text-success h4,\n.text-success h5,\n.text-success h6 {\n    color: #10b981\n}\n\n.text-success .text-muted {\n    color: rgba(16, 185, 129, .7) !important\n}\n\n.text-info,\n.text-info:hover {\n    color: #2361ce !important\n}\n\n.text-info .display-1,\n.text-info .display-2,\n.text-info .display-3,\n.text-info .display-4,\n.text-info .h1,\n.text-info .h2,\n.text-info .h3,\n.text-info .h4,\n.text-info .h5,\n.text-info .h6,\n.text-info a:not(.btn),\n.text-info h1,\n.text-info h2,\n.text-info h3,\n.text-info h4,\n.text-info h5,\n.text-info h6 {\n    color: #2361ce\n}\n\n.text-info .text-muted {\n    color: rgba(35, 97, 206, .7) !important\n}\n\n.text-warning,\n.text-warning:hover {\n    color: #fba918 !important\n}\n\n.text-warning .display-1,\n.text-warning .display-2,\n.text-warning .display-3,\n.text-warning .display-4,\n.text-warning .h1,\n.text-warning .h2,\n.text-warning .h3,\n.text-warning .h4,\n.text-warning .h5,\n.text-warning .h6,\n.text-warning a:not(.btn),\n.text-warning h1,\n.text-warning h2,\n.text-warning h3,\n.text-warning h4,\n.text-warning h5,\n.text-warning h6 {\n    color: #fba918\n}\n\n.text-warning .text-muted {\n    color: rgba(251, 169, 24, .7) !important\n}\n\n.text-danger,\n.text-danger:hover {\n    color: #e11d48 !important\n}\n\n.text-danger .display-1,\n.text-danger .display-2,\n.text-danger .display-3,\n.text-danger .display-4,\n.text-danger .h1,\n.text-danger .h2,\n.text-danger .h3,\n.text-danger .h4,\n.text-danger .h5,\n.text-danger .h6,\n.text-danger a:not(.btn),\n.text-danger h1,\n.text-danger h2,\n.text-danger h3,\n.text-danger h4,\n.text-danger h5,\n.text-danger h6 {\n    color: #e11d48\n}\n\n.text-danger .text-muted {\n    color: rgba(225, 29, 72, .7) !important\n}\n\n.text-white,\n.text-white:hover {\n    color: #fff !important\n}\n\n.text-white .display-1,\n.text-white .display-2,\n.text-white .display-3,\n.text-white .display-4,\n.text-white .h1,\n.text-white .h2,\n.text-white .h3,\n.text-white .h4,\n.text-white .h5,\n.text-white .h6,\n.text-white a:not(.btn),\n.text-white h1,\n.text-white h2,\n.text-white h3,\n.text-white h4,\n.text-white h5,\n.text-white h6 {\n    color: #fff\n}\n\n.text-white .text-muted {\n    color: rgba(255, 255, 255, .7) !important\n}\n\n.text-indigo,\n.text-indigo:hover {\n    color: #4f46e5 !important\n}\n\n.text-indigo .display-1,\n.text-indigo .display-2,\n.text-indigo .display-3,\n.text-indigo .display-4,\n.text-indigo .h1,\n.text-indigo .h2,\n.text-indigo .h3,\n.text-indigo .h4,\n.text-indigo .h5,\n.text-indigo .h6,\n.text-indigo a:not(.btn),\n.text-indigo h1,\n.text-indigo h2,\n.text-indigo h3,\n.text-indigo h4,\n.text-indigo h5,\n.text-indigo h6 {\n    color: #4f46e5\n}\n\n.text-indigo .text-muted {\n    color: rgba(79, 70, 229, .7) !important\n}\n\n.text-purple,\n.text-purple:hover {\n    color: #7c3aed !important\n}\n\n.text-purple .display-1,\n.text-purple .display-2,\n.text-purple .display-3,\n.text-purple .display-4,\n.text-purple .h1,\n.text-purple .h2,\n.text-purple .h3,\n.text-purple .h4,\n.text-purple .h5,\n.text-purple .h6,\n.text-purple a:not(.btn),\n.text-purple h1,\n.text-purple h2,\n.text-purple h3,\n.text-purple h4,\n.text-purple h5,\n.text-purple h6 {\n    color: #7c3aed\n}\n\n.text-purple .text-muted {\n    color: rgba(124, 58, 237, .7) !important\n}\n\n.text-yellow-100,\n.text-yellow-100:hover {\n    color: #ffeed6 !important\n}\n\n.text-yellow-100 .display-1,\n.text-yellow-100 .display-2,\n.text-yellow-100 .display-3,\n.text-yellow-100 .display-4,\n.text-yellow-100 .h1,\n.text-yellow-100 .h2,\n.text-yellow-100 .h3,\n.text-yellow-100 .h4,\n.text-yellow-100 .h5,\n.text-yellow-100 .h6,\n.text-yellow-100 a:not(.btn),\n.text-yellow-100 h1,\n.text-yellow-100 h2,\n.text-yellow-100 h3,\n.text-yellow-100 h4,\n.text-yellow-100 h5,\n.text-yellow-100 h6 {\n    color: #ffeed6\n}\n\n.text-yellow-100 .text-muted {\n    color: rgba(255, 238, 214, .7) !important\n}\n\n.text-yellow-200,\n.text-yellow-200:hover {\n    color: #f5dbb8 !important\n}\n\n.text-yellow-200 .display-1,\n.text-yellow-200 .display-2,\n.text-yellow-200 .display-3,\n.text-yellow-200 .display-4,\n.text-yellow-200 .h1,\n.text-yellow-200 .h2,\n.text-yellow-200 .h3,\n.text-yellow-200 .h4,\n.text-yellow-200 .h5,\n.text-yellow-200 .h6,\n.text-yellow-200 a:not(.btn),\n.text-yellow-200 h1,\n.text-yellow-200 h2,\n.text-yellow-200 h3,\n.text-yellow-200 h4,\n.text-yellow-200 h5,\n.text-yellow-200 h6 {\n    color: #f5dbb8\n}\n\n.text-yellow-200 .text-muted {\n    color: rgba(245, 219, 184, .7) !important\n}\n\n.text-gray-50,\n.text-gray-50:hover {\n    color: #f9fafb !important\n}\n\n.text-gray-50 .display-1,\n.text-gray-50 .display-2,\n.text-gray-50 .display-3,\n.text-gray-50 .display-4,\n.text-gray-50 .h1,\n.text-gray-50 .h2,\n.text-gray-50 .h3,\n.text-gray-50 .h4,\n.text-gray-50 .h5,\n.text-gray-50 .h6,\n.text-gray-50 a:not(.btn),\n.text-gray-50 h1,\n.text-gray-50 h2,\n.text-gray-50 h3,\n.text-gray-50 h4,\n.text-gray-50 h5,\n.text-gray-50 h6 {\n    color: #f9fafb\n}\n\n.text-gray-50 .text-muted {\n    color: rgba(249, 250, 251, .7) !important\n}\n\n.text-gray-100,\n.text-gray-100:hover {\n    color: #f2f4f6 !important\n}\n\n.text-gray-100 .display-1,\n.text-gray-100 .display-2,\n.text-gray-100 .display-3,\n.text-gray-100 .display-4,\n.text-gray-100 .h1,\n.text-gray-100 .h2,\n.text-gray-100 .h3,\n.text-gray-100 .h4,\n.text-gray-100 .h5,\n.text-gray-100 .h6,\n.text-gray-100 a:not(.btn),\n.text-gray-100 h1,\n.text-gray-100 h2,\n.text-gray-100 h3,\n.text-gray-100 h4,\n.text-gray-100 h5,\n.text-gray-100 h6 {\n    color: #f2f4f6\n}\n\n.text-gray-100 .text-muted {\n    color: rgba(242, 244, 246, .7) !important\n}\n\n.text-gray-200,\n.text-gray-200:hover {\n    color: #e5e7eb !important\n}\n\n.text-gray-200 .display-1,\n.text-gray-200 .display-2,\n.text-gray-200 .display-3,\n.text-gray-200 .display-4,\n.text-gray-200 .h1,\n.text-gray-200 .h2,\n.text-gray-200 .h3,\n.text-gray-200 .h4,\n.text-gray-200 .h5,\n.text-gray-200 .h6,\n.text-gray-200 a:not(.btn),\n.text-gray-200 h1,\n.text-gray-200 h2,\n.text-gray-200 h3,\n.text-gray-200 h4,\n.text-gray-200 h5,\n.text-gray-200 h6 {\n    color: #e5e7eb\n}\n\n.text-gray-200 .text-muted {\n    color: rgba(229, 231, 235, .7) !important\n}\n\n.text-gray-300,\n.text-gray-300:hover {\n    color: #d1d5db !important\n}\n\n.text-gray-300 .display-1,\n.text-gray-300 .display-2,\n.text-gray-300 .display-3,\n.text-gray-300 .display-4,\n.text-gray-300 .h1,\n.text-gray-300 .h2,\n.text-gray-300 .h3,\n.text-gray-300 .h4,\n.text-gray-300 .h5,\n.text-gray-300 .h6,\n.text-gray-300 a:not(.btn),\n.text-gray-300 h1,\n.text-gray-300 h2,\n.text-gray-300 h3,\n.text-gray-300 h4,\n.text-gray-300 h5,\n.text-gray-300 h6 {\n    color: #d1d5db\n}\n\n.text-gray-300 .text-muted {\n    color: rgba(209, 213, 219, .7) !important\n}\n\n.text-gray-400,\n.text-gray-400:hover {\n    color: #9ca3af !important\n}\n\n.text-gray-400 .display-1,\n.text-gray-400 .display-2,\n.text-gray-400 .display-3,\n.text-gray-400 .display-4,\n.text-gray-400 .h1,\n.text-gray-400 .h2,\n.text-gray-400 .h3,\n.text-gray-400 .h4,\n.text-gray-400 .h5,\n.text-gray-400 .h6,\n.text-gray-400 a:not(.btn),\n.text-gray-400 h1,\n.text-gray-400 h2,\n.text-gray-400 h3,\n.text-gray-400 h4,\n.text-gray-400 h5,\n.text-gray-400 h6 {\n    color: #9ca3af\n}\n\n.text-gray-400 .text-muted {\n    color: rgba(156, 163, 175, .7) !important\n}\n\n.text-gray-500,\n.text-gray-500:hover {\n    color: #6b7280 !important\n}\n\n.text-gray-500 .display-1,\n.text-gray-500 .display-2,\n.text-gray-500 .display-3,\n.text-gray-500 .display-4,\n.text-gray-500 .h1,\n.text-gray-500 .h2,\n.text-gray-500 .h3,\n.text-gray-500 .h4,\n.text-gray-500 .h5,\n.text-gray-500 .h6,\n.text-gray-500 a:not(.btn),\n.text-gray-500 h1,\n.text-gray-500 h2,\n.text-gray-500 h3,\n.text-gray-500 h4,\n.text-gray-500 h5,\n.text-gray-500 h6 {\n    color: #6b7280\n}\n\n.text-gray-500 .text-muted {\n    color: rgba(107, 114, 128, .7) !important\n}\n\n.text-gray-600,\n.text-gray-600:hover {\n    color: #4b5563 !important\n}\n\n.text-gray-600 .display-1,\n.text-gray-600 .display-2,\n.text-gray-600 .display-3,\n.text-gray-600 .display-4,\n.text-gray-600 .h1,\n.text-gray-600 .h2,\n.text-gray-600 .h3,\n.text-gray-600 .h4,\n.text-gray-600 .h5,\n.text-gray-600 .h6,\n.text-gray-600 a:not(.btn),\n.text-gray-600 h1,\n.text-gray-600 h2,\n.text-gray-600 h3,\n.text-gray-600 h4,\n.text-gray-600 h5,\n.text-gray-600 h6 {\n    color: #4b5563\n}\n\n.text-gray-600 .text-muted {\n    color: rgba(75, 85, 99, .7) !important\n}\n\n.text-gray-700,\n.text-gray-700:hover {\n    color: #374151 !important\n}\n\n.text-gray-700 .display-1,\n.text-gray-700 .display-2,\n.text-gray-700 .display-3,\n.text-gray-700 .display-4,\n.text-gray-700 .h1,\n.text-gray-700 .h2,\n.text-gray-700 .h3,\n.text-gray-700 .h4,\n.text-gray-700 .h5,\n.text-gray-700 .h6,\n.text-gray-700 a:not(.btn),\n.text-gray-700 h1,\n.text-gray-700 h2,\n.text-gray-700 h3,\n.text-gray-700 h4,\n.text-gray-700 h5,\n.text-gray-700 h6 {\n    color: #374151\n}\n\n.text-gray-700 .text-muted {\n    color: rgba(55, 65, 81, .7) !important\n}\n\n.text-gray-800,\n.text-gray-800:hover {\n    color: #1f2937 !important\n}\n\n.text-gray-800 .display-1,\n.text-gray-800 .display-2,\n.text-gray-800 .display-3,\n.text-gray-800 .display-4,\n.text-gray-800 .h1,\n.text-gray-800 .h2,\n.text-gray-800 .h3,\n.text-gray-800 .h4,\n.text-gray-800 .h5,\n.text-gray-800 .h6,\n.text-gray-800 a:not(.btn),\n.text-gray-800 h1,\n.text-gray-800 h2,\n.text-gray-800 h3,\n.text-gray-800 h4,\n.text-gray-800 h5,\n.text-gray-800 h6 {\n    color: #1f2937\n}\n\n.text-gray-800 .text-muted {\n    color: rgba(31, 41, 55, .7) !important\n}\n\n.text-gray-900,\n.text-gray-900:hover {\n    color: #111827 !important\n}\n\n.text-gray-900 .display-1,\n.text-gray-900 .display-2,\n.text-gray-900 .display-3,\n.text-gray-900 .display-4,\n.text-gray-900 .h1,\n.text-gray-900 .h2,\n.text-gray-900 .h3,\n.text-gray-900 .h4,\n.text-gray-900 .h5,\n.text-gray-900 .h6,\n.text-gray-900 a:not(.btn),\n.text-gray-900 h1,\n.text-gray-900 h2,\n.text-gray-900 h3,\n.text-gray-900 h4,\n.text-gray-900 h5,\n.text-gray-900 h6 {\n    color: #111827\n}\n\n.text-gray-900 .text-muted {\n    color: rgba(17, 24, 39, .7) !important\n}\n\narticle img {\n    margin: 40px 0\n}\n\narticle blockquote,\narticle ol,\narticle p,\narticle ul {\n    margin-bottom: 20px\n}\n\narticle ol li,\narticle p,\narticle ul li {\n    font-size: 1.2rem\n}\n\narticle .h1,\narticle .h2,\narticle .h3,\narticle .h4,\narticle .h5,\narticle .h6,\narticle h1,\narticle h2,\narticle h3,\narticle h4,\narticle h5,\narticle h6 {\n    margin-bottom: 30px\n}\n\n.folder-structure li {\n    font-size: 1.2rem\n}\n\n.truncate-text {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis\n}\n\n.list-group-timeline .list-group-item {\n    position: relative\n}\n\n.list-group-timeline .list-group-item .col-auto {\n    z-index: 999\n}\n\n.list-group-timeline .list-group-item::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 4px;\n    height: 100%;\n    border-left: 2px solid #e5e7eb\n}\n\n.list-group-timeline .list-group-item::after {\n    content: \"\";\n    position: absolute;\n    top: 15px;\n    left: 8px;\n    width: 10px;\n    height: 10px;\n    margin-top: .425rem;\n    margin-left: -.5rem;\n    border: 2px solid #e5e7eb;\n    background: #fff;\n    border-radius: .5rem\n}\n\n.tooltip-inner {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06)\n}\n\n.chartist-tooltip {\n    position: absolute;\n    display: inline-block;\n    opacity: 0;\n    min-width: 5em;\n    padding: .5em;\n    background: #e5e7eb;\n    border: 1px solid #9ca3af;\n    border-radius: .5rem;\n    color: #1f2937;\n    font-weight: 500;\n    text-align: center;\n    pointer-events: none;\n    z-index: 1;\n    transition: all .2s ease\n}\n\n.chartist-tooltip:before {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    width: 0;\n    height: 0;\n    margin-left: -15px;\n    border: 15px solid transparent;\n    border-top-color: #e5e7eb\n}\n\n.chartist-tooltip.tooltip-show {\n    opacity: 1\n}\n\n.ct-area,\n.ct-line {\n    pointer-events: none\n}\n\n.fc-h-event {\n    border: 0;\n    padding: 3px;\n    display: block\n}\n\n.fc-daygrid-day-frame {\n    padding: 5px;\n    border: .0625rem solid #e5e7eb\n}\n\n.fc-daygrid-day {\n    transition: all .2s ease\n}\n\n.fc .fc-scrollgrid,\n.fc .fc-scrollgrid table {\n    border-color: #fff\n}\n\n.fc .fc-scrollgrid {\n    border-collapse: collapse !important\n}\n\n.fc-daygrid-day:hover {\n    cursor: pointer;\n    background: rgba(240, 188, 116, .2)\n}\n\n.fc .fc-highlight {\n    background-color: rgba(240, 188, 116, .2)\n}\n\n@media (min-width: 768px) {\n    .fc .fc-col-header-cell-cushion::before {\n        margin-right: 10px\n    }\n}\n\n.fc .fc-daygrid-day-frame {\n    padding: 5px;\n    border: .0625rem solid #e5e7eb;\n    width: 100%;\n    height: 190px\n}\n\n@media (max-width: 575.98px) {\n    .fc .fc-daygrid-day-frame {\n        height: 100%\n    }\n}\n\n.fc .fc-col-header-cell-cushion {\n    padding: 6px 8px\n}\n\n@media (max-width: 575.98px) {\n    .fc .fc-toolbar .btn {\n        padding: .25rem .45rem\n    }\n\n    .fc .fc-toolbar .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {\n        margin-left: .35em\n    }\n}\n\n.fc-daygrid-event {\n    font-weight: 500;\n    border-radius: .35rem\n}\n\n.fc-direction-ltr .fc-daygrid-event {\n    padding-right: 10px;\n    padding-left: 10px\n}\n\n.fc-daygrid-day-number {\n    font-weight: 500\n}\n\n@media (max-width: 767.98px) {\n    .fc .fc-toolbar-title {\n        font-size: 1rem\n    }\n}\n\n.datepicker .datepicker-cell.selected,\n.datepicker .datepicker-cell.selected:hover {\n    background: #1f2937\n}\n\n[data-simplebar] {\n    position: fixed;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: flex-start\n}\n\n.simplebar-wrapper {\n    overflow: hidden;\n    width: inherit;\n    height: inherit;\n    max-width: inherit;\n    max-height: inherit\n}\n\n.simplebar-mask {\n    direction: inherit;\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: auto !important;\n    height: auto !important;\n    z-index: 0\n}\n\n.simplebar-offset {\n    direction: inherit !important;\n    box-sizing: inherit !important;\n    resize: none !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    padding: 0;\n    margin: 0;\n    -webkit-overflow-scrolling: touch\n}\n\n.simplebar-content-wrapper {\n    direction: inherit;\n    box-sizing: border-box !important;\n    position: relative;\n    display: block;\n    height: 100%;\n    width: auto;\n    max-width: 100%;\n    max-height: 100%;\n    scrollbar-width: none;\n    -ms-overflow-style: none\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n    width: 0;\n    height: 0\n}\n\n.simplebar-content:after,\n.simplebar-content:before {\n    content: ' ';\n    display: table\n}\n\n.simplebar-placeholder {\n    max-height: 100%;\n    max-width: 100%;\n    width: 100%;\n    pointer-events: none\n}\n\n.simplebar-height-auto-observer-wrapper {\n    box-sizing: inherit !important;\n    height: 100%;\n    width: 100%;\n    max-width: 1px;\n    position: relative;\n    float: left;\n    max-height: 1px;\n    overflow: hidden;\n    z-index: -1;\n    padding: 0;\n    margin: 0;\n    pointer-events: none;\n    flex-grow: inherit;\n    flex-shrink: 0;\n    flex-basis: 0\n}\n\n.simplebar-height-auto-observer {\n    box-sizing: inherit;\n    display: block;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1000%;\n    width: 1000%;\n    min-height: 1px;\n    min-width: 1px;\n    overflow: hidden;\n    pointer-events: none;\n    z-index: -1\n}\n\n.simplebar-track {\n    z-index: 1;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    overflow: hidden\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n    pointer-events: none;\n    user-select: none;\n    -webkit-user-select: none\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n    pointer-events: all\n}\n\n.simplebar-scrollbar {\n    position: absolute;\n    left: 0;\n    right: 0;\n    min-height: 10px\n}\n\n.simplebar-scrollbar:before {\n    position: absolute;\n    content: '';\n    background: #000;\n    border-radius: 7px;\n    left: 2px;\n    right: 2px;\n    opacity: 0;\n    transition: opacity .2s .5s linear\n}\n\n.simplebar-hover .simplebar-scrollbar:before,\n.simplebar-mouse-entered .simplebar-scrollbar:before,\n.simplebar-scrolling .simplebar-scrollbar:before {\n    opacity: .5;\n    transition-delay: 0s;\n    transition-duration: 0s\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n    opacity: .5;\n    transition-delay: 0s;\n    transition-duration: 0s\n}\n\n.simplebar-track.simplebar-vertical {\n    top: 0;\n    width: 11px\n}\n\n.simplebar-scrollbar:before {\n    top: 2px;\n    bottom: 2px;\n    left: 2px;\n    right: 2px\n}\n\n.simplebar-track.simplebar-horizontal {\n    left: 0;\n    height: 11px\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n    right: auto;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    min-height: 0;\n    min-width: 10px;\n    width: auto\n}\n\n[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {\n    right: auto;\n    left: 0\n}\n\n.simplebar-dummy-scrollbar-size {\n    direction: rtl;\n    position: fixed;\n    opacity: 0;\n    visibility: hidden;\n    height: 500px;\n    width: 500px;\n    overflow-y: hidden;\n    overflow-x: scroll;\n    -ms-overflow-style: scrollbar !important\n}\n\n.simplebar-dummy-scrollbar-size > div {\n    width: 200%;\n    height: 200%;\n    margin: 10px 0\n}\n\n.simplebar-hide-scrollbar {\n    position: fixed;\n    left: 0;\n    visibility: hidden;\n    overflow-y: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none\n}\n\n.simplebar-scrollbar::before {\n    background-color: #0d1116\n}\n\n.svgMap-map-wrapper {\n    position: relative;\n    width: 100%;\n    height: 300px;\n    padding-top: 0;\n    overflow: hidden;\n    background: #fff;\n    color: #fff\n}\n\n.svgMap-map-wrapper * {\n    box-sizing: border-box\n}\n\n.svgMap-map-wrapper :focus:not(:focus-visible) {\n    outline: 0\n}\n\n.svgMap-map-wrapper .svgMap-map-image {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-wrapper {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    z-index: 1;\n    display: flex;\n    overflow: hidden;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    border-radius: .5rem\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-move,\n.svgMap-map-wrapper .svgMap-map-controls-zoom {\n    display: flex;\n    margin-right: 5px;\n    overflow: hidden;\n    background: #111827\n}\n\n.svgMap-map-wrapper .svgMap-map-controls-move:last-child,\n.svgMap-map-wrapper .svgMap-map-controls-zoom:last-child {\n    margin-right: 0\n}\n\n.svgMap-map-wrapper .svgMap-control-button {\n    background-color: transparent;\n    border: none;\n    border-radius: 0;\n    color: inherit;\n    font: inherit;\n    line-height: inherit;\n    margin: 0;\n    padding: 0;\n    overflow: visible;\n    text-transform: none;\n    -webkit-appearance: none;\n    appearance: none;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n    position: relative\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #d1d5db;\n    transition: background-color .2s\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:before {\n    width: 11px;\n    height: 3px\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button:hover:before {\n    background: #fff\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:after,\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-button.svgMap-disabled:before {\n    background: #9ca3af\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button {\n    margin: 1px 0 1px 1px\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-in-button:after {\n    width: 3px;\n    height: 11px\n}\n\n.svgMap-map-wrapper .svgMap-control-button.svgMap-zoom-out-button {\n    margin: 1px 1px 1px 0\n}\n\n.svgMap-map-wrapper .svgMap-country {\n    cursor: pointer;\n    stroke: #fff;\n    stroke-width: 1;\n    stroke-linejoin: round;\n    vector-effect: non-scaling-stroke;\n    transition: fill .2s, stroke .2s\n}\n\n.svgMap-map-wrapper .svgMap-country.svgMap-active,\n.svgMap-map-wrapper .svgMap-country:hover {\n    stroke: #e11d48\n}\n\n.svgMap-map-wrapper .svgMap-country.svgMap-active {\n    stroke-width: #e11d48\n}\n\n.svgMap-tooltip {\n    position: absolute;\n    z-index: 2;\n    background: #fff;\n    transform: translate(-50%, -100%);\n    display: none;\n    pointer-events: none;\n    min-width: 60px;\n    border: .0625rem solid #e5e7eb;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    border-radius: .5rem\n}\n\n.svgMap-tooltip.svgMap-tooltip-flipped {\n    transform: translate(-50%, 0);\n    border-bottom: 0;\n    border-top: 1px solid #000\n}\n\n.svgMap-tooltip.svgMap-active {\n    display: block\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container {\n    position: relative;\n    padding: 10px 20px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container {\n    text-align: left;\n    margin: 2px 0 5px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container.svgMap-tooltip-flag-container-emoji {\n    font-size: 40px;\n    line-height: 0;\n    padding: 25px 0 15px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content-container .svgMap-tooltip-flag-container .svgMap-tooltip-flag {\n    display: block;\n    width: auto;\n    height: 35px;\n    border: 2px solid #fff;\n    border-radius: .5rem\n}\n\n.svgMap-tooltip .svgMap-tooltip-title {\n    font-size: 1.25rem;\n    font-weight: 500;\n    white-space: nowrap;\n    padding: 0 0 8px;\n    text-align: left\n}\n\n.svgMap-tooltip .svgMap-tooltip-content {\n    white-space: nowrap;\n    font-size: .875rem;\n    font-weight: 400;\n    color: #d1d5db\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table {\n    padding: 0;\n    border-spacing: 0\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td {\n    padding: 2px 0;\n    text-align: left;\n    font-weight: 400\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td span {\n    color: #10b981;\n    font-weight: 500\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td:first-child {\n    padding-right: 15px;\n    text-align: left;\n    color: #374151\n}\n\n.svgMap-tooltip .svgMap-tooltip-content table td sup {\n    vertical-align: baseline;\n    position: relative;\n    top: -5px\n}\n\n.svgMap-tooltip .svgMap-tooltip-content .svgMap-tooltip-no-data {\n    padding: 2px 0;\n    color: #d1d5db;\n    font-style: italic\n}\n\n.svgMap-tooltip .svgMap-tooltip-pointer {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    overflow: hidden;\n    height: 10px;\n    width: 30px\n}\n\n.svgMap-tooltip .svgMap-tooltip-pointer:after {\n    content: \"\";\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: .0625rem solid #e5e7eb;\n    position: absolute;\n    bottom: 6px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg)\n}\n\n.svgMap-tooltip.svgMap-tooltip-flipped .svgMap-tooltip-pointer {\n    bottom: auto;\n    top: -10px;\n    transform: translateX(-50%) scaleY(-1)\n}\n\n.swal2-container.swal2-backdrop-show,\n.swal2-container.swal2-noanimation {\n    background: rgba(31, 41, 55, .8) !important\n}\n\n.swal2-popup {\n    color: #374151 !important;\n    border: 0 !important\n}\n\n.swal2-title {\n    color: #1f2937 !important;\n    font-weight: 700 !important\n}\n\n.swal2-content {\n    color: #4b5563 !important\n}\n\n.swal2-styled {\n    padding: .5rem 1rem\n}\n\n.swal2-styled.swal2-confirm {\n    background-color: #2361ce !important;\n    border-radius: .5rem !important\n}\n\n.swal2-icon .swal2-icon-content {\n    font-size: 2.5em !important\n}\n\n.swal2-icon.swal2-success [class^=swal2-success-circular-line] {\n    opacity: 0\n}\n\n.swal2-icon.swal2-success .swal2-success-fix {\n    opacity: 0\n}\n\n.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {\n    animation: swal2-animate-success-line-tip .55s\n}\n\n.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {\n    animation: swal2-animate-success-line-long .55s\n}\n\n.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {\n    animation: swal2-rotate-success-circular-line 3.25s ease-in\n}\n\n.noUi-target,\n.noUi-target * {\n    -webkit-touch-callout: none;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-user-select: none;\n    touch-action: none;\n    user-select: none;\n    box-sizing: border-box\n}\n\n.noUi-target {\n    position: relative;\n    direction: ltr\n}\n\n.noUi-base,\n.noUi-connects {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 1\n}\n\n.noUi-connects {\n    overflow: hidden;\n    z-index: 0\n}\n\n.noUi-connect,\n.noUi-origin {\n    will-change: transform;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    transform-origin: 0 0\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-origin {\n    left: auto;\n    right: 0\n}\n\n.noUi-vertical .noUi-origin {\n    width: 0\n}\n\n.noUi-horizontal .noUi-origin {\n    height: 0\n}\n\n.noUi-handle {\n    position: absolute\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n    transition: transform .3s\n}\n\n.noUi-state-drag * {\n    cursor: inherit !important\n}\n\n.noUi-horizontal {\n    height: 5px\n}\n\n.noUi-horizontal .noUi-handle {\n    left: -17px;\n    top: -10px\n}\n\n.noUi-vertical {\n    width: 5px;\n    height: 340px\n}\n\n.noUi-vertical .noUi-handle {\n    width: 18px;\n    height: 34px;\n    left: -6px;\n    top: -17px\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n    right: -17px;\n    left: auto\n}\n\n.noUi-connects {\n    border-radius: 3px\n}\n\n.noUi-connect {\n    background: #1f2937\n}\n\n.noUi-draggable {\n    cursor: ew-resize\n}\n\n.noUi-vertical .noUi-draggable {\n    cursor: ns-resize\n}\n\n.noUi-handle {\n    border: 1px solid #f2f4f6;\n    border-radius: 3px;\n    background: #fff;\n    cursor: default;\n    outline: 0\n}\n\n.noUi-handle:hover {\n    cursor: grab;\n    cursor: -moz-grab;\n    background-color: #9ca3af\n}\n\n.noUi-handle:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    background-color: #9ca3af;\n    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5)\n}\n\n.noUi-handle:focus {\n    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5);\n    background-color: #9ca3af\n}\n\n.noUi-active {\n    outline: 0\n}\n\n[disabled] .noUi-connect {\n    background: #9ca3af\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-handle,\n[disabled].noUi-target {\n    cursor: not-allowed\n}\n\n.noUi-pips,\n.noUi-pips * {\n    box-sizing: border-box\n}\n\n.noUi-pips {\n    position: absolute;\n    color: #1f2937;\n    font-size: .75rem\n}\n\n.noUi-value {\n    margin-top: 5px;\n    position: absolute;\n    white-space: nowrap;\n    text-align: center\n}\n\n.noUi-value-sub {\n    color: #9ca3af;\n    font-size: .75rem\n}\n\n.noUi-marker {\n    position: absolute;\n    background: #1f2937\n}\n\n.noUi-marker-sub {\n    background: #1f2937\n}\n\n.noUi-marker-large {\n    background: #1f2937\n}\n\n.noUi-pips-horizontal {\n    padding: 12px 0;\n    height: auto;\n    top: 100%;\n    left: 0;\n    width: 100%\n}\n\n.noUi-value-horizontal {\n    transform: translate(-50%, 50%)\n}\n\n.noUi-rtl .noUi-value-horizontal {\n    transform: translate(50%, 50%)\n}\n\n.noUi-marker-horizontal.noUi-marker {\n    margin-left: -1px;\n    width: 2px;\n    height: 5px\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n    height: 10px\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n    height: 12px\n}\n\n.noUi-pips-vertical {\n    padding: 0 10px;\n    height: 100%;\n    top: 0;\n    left: 100%\n}\n\n.noUi-value-vertical {\n    transform: translate(0, -50%, 0);\n    padding-left: 25px\n}\n\n.noUi-rtl .noUi-value-vertical {\n    transform: translate(0, 50%)\n}\n\n.noUi-marker-vertical.noUi-marker {\n    width: 5px;\n    height: 2px;\n    margin-top: -1px\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n    width: 10px\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n    width: 15px\n}\n\n.noUi-tooltip {\n    background: #fff;\n    color: #1f2937;\n    font-size: .75rem;\n    font-weight: 400;\n    display: block;\n    position: absolute;\n    padding: 5px 10px;\n    text-align: center;\n    white-space: nowrap;\n    border-radius: .5rem;\n    border: .0625rem solid #9ca3af\n}\n\n.noUi-horizontal .noUi-tooltip {\n    transform: translate(-50%, 0);\n    left: 50%;\n    bottom: 30px\n}\n\n.noUi-vertical .noUi-tooltip {\n    transform: translate(0, -50%);\n    top: 50%;\n    right: 120%\n}\n\n.noUi-target {\n    background: #9ca3af;\n    border-radius: 5px;\n    border: 0;\n    box-shadow: inset 0 2px 5px rgba(140, 152, 164, .2);\n    margin: 15px 0;\n    cursor: pointer\n}\n\n.noUi-horizontal {\n    height: 5px\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n    right: -10px\n}\n\n.noUi-vertical {\n    width: 5px\n}\n\n.noUi-connect {\n    background: #1f2937;\n    box-shadow: none\n}\n\n.noUi-handle {\n    position: absolute;\n    border: 1px solid #1f2937;\n    border-radius: 50%;\n    width: 23px;\n    height: 23px;\n    box-shadow: 0 2px 5px rgba(140, 152, 164, .2);\n    background: #fff;\n    transition: all 150ms cubic-bezier(.17, .01, .28, 1.06)\n}\n\n.noUi-vertical .noUi-handle {\n    border: 1px solid #374151;\n    border-radius: 3px;\n    background: #fff;\n    cursor: default;\n    box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #f2f4f6, 0 3px 6px -3px #e5e7eb;\n    outline: 0\n}\n\n.noUi-vertical .noUi-handle:hover {\n    cursor: grab;\n    cursor: -moz-grab;\n    background-color: #9ca3af\n}\n\n.noUi-vertical .noUi-handle:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    background-color: #9ca3af;\n    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5)\n}\n\n.noUi-vertical .noUi-handle:focus {\n    box-shadow: 0 0 0 .2rem rgba(69, 77, 103, .5);\n    background-color: #9ca3af\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n    transform: scale(1.2)\n}\n\n.input-slider--cyan .noUi-connect {\n    background: #63b1bd\n}\n\n.input-slider--cyan.noUi-horizontal .noUi-handle,\n.input-slider--cyan.noUi-vertical .noUi-handle {\n    background-color: #63b1bd\n}\n\n.input-slider--red .noUi-connect {\n    background: #e11d48\n}\n\n.input-slider--red.noUi-horizontal .noUi-handle,\n.input-slider--red.noUi-vertical .noUi-handle {\n    background-color: #e11d48\n}\n\n.input-slider--green .noUi-connect {\n    background: #10b981\n}\n\n.input-slider--green.noUi-horizontal .noUi-handle,\n.input-slider--green.noUi-vertical .noUi-handle {\n    background-color: #10b981\n}\n\n.input-slider--yellow .noUi-connect {\n    background: #f3c78e\n}\n\n.input-slider--yellow.noUi-horizontal .noUi-handle,\n.input-slider--yellow.noUi-vertical .noUi-handle {\n    background-color: #f3c78e\n}\n\n.input-slider--pink .noUi-connect {\n    background: #ef4683\n}\n\n.input-slider--pink.noUi-horizontal .noUi-handle,\n.input-slider--pink.noUi-vertical .noUi-handle {\n    background-color: #ef4683\n}\n\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n    background: #e5e7eb\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n    cursor: not-allowed\n}\n\n.range-slider-value {\n    font-size: .75rem;\n    font-weight: 500;\n    background-color: rgba(31, 41, 55, .7);\n    color: color-yiq(#1f2937);\n    border-radius: 10px;\n    padding: .4em .8em .3em .85em\n}\n\n.range-slider-wrapper .upper-info {\n    font-weight: 400;\n    margin-bottom: 5px\n}\n\n.input-slider-value-output {\n    background: #1f2937;\n    color: #fff;\n    padding: 4px 8px;\n    position: relative;\n    top: 12px;\n    font-size: 11px;\n    border-radius: 2px\n}\n\n.input-slider-value-output:after {\n    bottom: 100%;\n    left: 10px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: #1f2937;\n    border-bottom-color: #333;\n    border-width: 4px;\n    margin-left: -4px\n}\n\n.input-slider-value-output.left:after {\n    left: 10px;\n    right: auto\n}\n\n.input-slider-value-output.right:after {\n    right: 10px;\n    left: auto\n}\n\n@media (min-width: 992px) {\n    .form-control.form-control-lg {\n        padding: 1rem 1rem\n    }\n}\n\n.search-bar .form-control {\n    width: 280px;\n    transition: width .2s ease-in-out\n}\n\n@media (max-width: 575.98px) {\n    .search-bar .form-control {\n        width: 120px\n    }\n\n    .search-bar .form-control:focus {\n        width: 150px\n    }\n}\n\n.form-check-input.round-check[type=checkbox] {\n    border-radius: 50%\n}\n\n.form-switch {\n    padding-left: 2.75em\n}\n\n.form-switch .form-check-input {\n    height: 1.275em\n}\n\n.input-group .form-control:focus {\n    border-color: #d1d5db\n}\n\n.input-group .form-control:focus + .input-group-text {\n    border-color: #d1d5db\n}\n\n.input-group-text {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .07)\n}\n\n.form-select .form-select-lg {\n    padding: .5rem 2rem .5rem 1rem\n}\n\n.file-field input[type=file] {\n    max-width: 230px;\n    position: absolute;\n    cursor: pointer;\n    opacity: 0;\n    padding-bottom: 30px\n}\n\n.file-field svg {\n    cursor: pointer\n}\n\n.datepicker-dropdown {\n    z-index: 9999\n}\n\n.card {\n\n    border-radius: 10px\n}\n\n.c-details span {\n    font-weight: 300;\n    font-size: 13px\n}\n\n.icon {\n    width: 50px;\n    height: 50px;\n    background-color: #eee;\n    border-radius: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 39px\n}\n\n.badge span {\n    background-color: #fffbec;\n    width: 60px;\n    height: 25px;\n    padding-bottom: 3px;\n    border-radius: 5px;\n    display: flex;\n    color: #fed85d;\n    justify-content: center;\n    align-items: center\n}\n\n.progress {\n    height: 10px;\n    border-radius: 10px\n}\n\n.progress div {\n    background-color: red\n}\n\n.text1 {\n    font-size: 14px;\n    font-weight: 600\n}\n\n.text2 {\n    color: #a5aec0\n}\n\n\n.clock {\n\n    position: relative;\n    background-size: contain; /* Resmi dive sığdırır */\n    background-position: center; /* Resmi ortalar */\n    background-repeat: no-repeat; /* Tekrar etmesini engeller */\n}\n\n.clock-text-box {\n\n    position: absolute;\n    top: 55%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: black;\n    font-size: 40px;\n    font-weight: bold;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
